import { makeStyles, mergeClasses, Input, tokens, makeStaticStyles, Toolbar, ToolbarButton, ToolbarDivider, Menu, MenuTrigger, MenuPopover, MenuList, MenuItemRadio, Button, interactionTagPrimaryClassNames, createLightTheme, createDarkTheme, MessageBar, MessageBarBody, Tooltip, Dropdown, Option, Spinner, Field, Textarea, MessageBarActions, TabList, Tab, Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, DialogActions, OverlayDrawer, DrawerHeader, DrawerHeaderTitle, DrawerBody, DrawerFooter, Badge, MenuItem, OptionGroup, SearchBox, Switch, Checkbox, Label, RadioGroup, Radio, Text, Combobox, TagPicker, TagPickerControl, TagPickerGroup, Tag, TagPickerInput, TagPickerList, TagPickerOption, Avatar, useId as useId$1, Overflow, OverflowItem, CounterBadge, Popover, PopoverTrigger, PopoverSurface, TagGroup, InteractionTag, InteractionTagPrimary, InteractionTagSecondary, MessageBarTitle, Subtitle2, Caption1, Body1Strong, MenuDivider, Skeleton, SkeletonItem, webDarkTheme, webLightTheme, teamsDarkTheme, teamsLightTheme, FluentProvider, Divider, useOverflowMenu, useIsOverflowItemVisible, Title3, Table as Table$1, TableHeader as TableHeader$1, TableRow, TableHeaderCell, TableBody, TableCell as TableCell$1, createTableColumn, DataGrid, DataGridHeader, DataGridRow, DataGridHeaderCell, DataGridBody, DataGridCell, SplitButton, Card, ProgressBar, MenuGroupHeader, MenuItemCheckbox, ToolbarToggleButton, ToolbarRadioButton, MenuGroup, ToggleButton, MenuButton, DialogTrigger, Link } from '@fluentui/react-components';
import { MaskMode, useMaskedTextField, useT, useLocale, useAuthOptions, usePowerPortalsPro, highlightMatches, useRecordContext, useColumnMetadata, useMainContext, useValidationContext, useDialogService, useRunWithOverlay, useOverlayServiceState, OverlayServiceProvider, useOverlayForTarget, useIsDialogOpen, useAuth, AuthStatus, usePrefixedT, useUserTimeZone, useTableMetadata, useViewsForTable, QueryStatus, useRecordPages, useOrganizationSettings, useRecordContextOptional, MainContext, useWarnAboutUnsavedChanges, useViewMetadata, useQueryData, RecordContext, useLocalization, useOverlayService, KEEP_OPEN, useTablePermissions, useColumnValue, DialogServiceProvider, DialogOpenProvider, DialogHandleProvider, useUrlCultureStrategy, useDefaultLocale, useSupportedLocales, setAspNetCultureCookie, buildLocalePath, useLocalizationLoaded, useRecordPage, useDataverseUnavailable, useQueryParam, useUnsavedChangesGuard, useRecord, useFetchRecords, replaceQueryParam, useColumnValidationErrors, isKeyModeEnabled, useOperationAccess } from '@powerportalspro/react';
import { forwardRef, useRef, useImperativeHandle, createContext, useState, useEffect, useCallback, memo, useMemo, useContext, useLayoutEffect, useId, Fragment as Fragment$1, useTransition, Children, isValidElement } from 'react';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { ArrowRotateCounterclockwise20Regular, ArrowRotateClockwise20Regular, FlipHorizontal20Regular, FlipVertical20Regular, ZoomIn20Regular, ZoomOut20Regular, ArrowReset20Regular, ChevronDown16Regular, Grid20Regular, Crop20Regular, FullScreenMinimize20Regular, FullScreenMaximize20Regular, ArrowDownload20Regular, Prohibited20Regular, Checkmark20Filled, BoxDismiss24Regular, BoxCheckmark24Regular, DocumentDismiss24Regular, Trophy24Regular, CheckmarkCircle24Regular, DismissCircle24Regular, ArrowDownload24Regular, ArrowClockwise24Regular, Dismiss20Regular, Save24Regular, DocumentArrowLeft24Regular, ChevronDown20Regular, ChevronRight20Regular, Folder20Regular, Document20Regular, ErrorCircle20Regular, Eye20Regular, Search20Regular, Dismiss24Regular, MoreHorizontal20Regular, StarOff20Regular, Star20Regular, EyeOff20Regular, Copy20Regular, Rename20Regular, TextEditStyle20Regular, Delete20Regular, Print20Regular, Filter24Filled, Filter24Regular, Filter20Filled, Filter20Regular, Add16Regular, Edit20Regular, ChevronUp12Regular, ChevronDown12Regular, ArrowUp20Regular, ArrowDown20Regular, Add20Regular, Edit16Regular, LinkAdd16Regular, LinkDismiss16Regular, Delete16Regular, MathFormula24Regular, MathFormula20Regular, ArrowClockwise20Regular, ArrowSortDown16Regular, ArrowSortUp16Regular, Filter16Regular, LinkAdd20Regular, Link16Regular, DocumentTable20Regular, Link20Regular, Play20Regular, ComposeRegular, EditRegular, DeleteRegular, AttachRegular, EyeRegular, Settings24Regular, TableAdd20Regular, ArrowSort20Regular, Warning16Regular, MoreHorizontal16Regular, ChevronDoubleLeft16Regular, ReOrderDotsVertical16Regular, LocationRegular, QuestionCircle24Regular, Info24Regular, Warning24Regular, Person20Regular, Warning20Regular, EyeTracking20Regular, ArrowExit20Regular, PersonEdit20Regular, ArrowSwap20Regular, SignOut20Regular, Settings20Regular, MoreVerticalRegular, ArrowSyncRegular, ArrowDownloadRegular, SearchRegular, DismissRegular, Delete24Regular, LinkDismiss20Regular, ArrowUpload32Regular, ArrowUpload24Regular, ArrowSync24Regular, DrawerArrowDownload24Regular, NavigationRegular, PersonPasskeyRegular, Send20Regular, DismissCircle20Regular, ArrowRepeatAll20Regular, Print24Regular, Money20Regular, History16Regular, Search16Regular, ErrorCircle12Filled, ArrowUndo20Regular, ArrowRedo20Regular, PaintBrush20Regular, TextFont20Regular, TextFontSize20Regular, TextBold20Regular, TextItalic20Regular, TextUnderline20Regular, TextStrikethrough20Regular, Highlight20Regular, TextColor20Regular, TextBulletListLtr20Regular, TextNumberListLtr20Regular, TextIndentDecreaseLtr20Regular, TextIndentIncreaseLtr20Regular, TextQuote20Regular, TextAlignLeft20Regular, TextAlignCenter20Regular, TextAlignRight20Regular, TextSubscript20Regular, TextSuperscript20Regular, Image20Regular, TextParagraphDirectionRight20Regular, TextParagraphDirectionLeft20Regular, ClearFormatting20Regular, ChevronUp20Regular, DocumentText20Regular, FolderZip20Regular, MusicNote220Regular, Video20Regular, SlideText20Regular, DocumentPdf20Regular, Save20Regular, SaveCopy20Regular, GroupList20Regular, ChevronDoubleLeft20Regular, ChevronLeft20Regular, ChevronDoubleRight20Regular, ArrowSplit20Regular, AddCircle20Regular, Table20Regular, ChevronRight12Regular, Mail20Regular, Call20Regular, TaskListSquareLtr20Regular, CalendarLtr20Regular, Chat20Regular, Note20Regular, Info12Regular, ArrowCounterclockwise24Regular, Prohibited24Regular, DocumentCheckmark24Regular, Send24Regular, DocumentCsv20Regular, TableSettings20Regular, TableInsertRow20Regular, TableInsertColumn20Regular, TableDeleteRow20Regular, TableDeleteColumn20Regular, TableCellsMerge20Regular, TableCellsSplit20Regular, TableDismiss20Regular, Checkmark16Regular, Dismiss16Regular, ArrowSortUp20Regular, ArrowSortDown20Regular, DismissCircle20Filled, FilterDismiss20Regular, TextBulletListTree20Regular, NumberSymbol20Regular, TableMoveLeft20Regular, TableMoveRight20Regular, Pin20Regular, PinOff20Regular, ChevronRight16Regular, ArrowDown16Regular, ArrowUp16Regular } from '@fluentui/react-icons';
import { ColumnType, ConditionOperator, TableSecurityPermission, QueryAggregate, DateGrouping, JoinOperator, AggregateType, CloseRecordAction, KanbanDateLane, KanbanDatePeriod, GridExportFormat, CaptchaProvider, isCaptchaRequired, captchaAction, readRangeSize, MultiTablePageOrder, LogicalOperator, RequiredLevel, PortalUserType, controlToJson, savedViewsQuery, userViewSettingsQuery, UserViewSettingSchema, controlKeysOf, SavedViewSchema, viewSettingsQuery, setDefaultView, setViewHidden, savedGridViewLayoutToJson, parseSavedGridViewLayout, parseControl, parseXml, multiTableViewsQuery, multiTableViewTablesQuery, MultiTableViewTableSchema, toViewTable, MultiTableViewSchema, toViewTableRow, joinTypeReturnsColumns, getAllLinkEntities, createFetchXmlQuery, toFetchXml, updateEntity, getLinkAliases, createCondition, createFilter, getConditionOperatorInfo, resolveColumnDisplayValue, canReadColumn, readColumnRawValue, createAttribute, getRecordReferenceId, parseFetchXml, DateTimeBehavior, toZonedWallClock, hasSavedId, findRecordPage, recordPageUrl, canWriteColumn, readPartyList, MemoFormat, GridLayout, savedViewControl, SavedViewControlKind, defaultViewId, extractGridCriteria, applyGridCriteria, gridFilteredColumns, PagingCookies, QueryGroupingStatus, keepingGroupability, savedGridViewLayoutsArrangeAlike, GridColumnPin, createLinkEntity, uniqueAlias, hasNoDataFilter, setNoDataFilter, clearNoDataFilter, setLinkJoinType, renameLinkAlias, removeNode, invertFilterConditions, addFilter, addCondition, updateCondition, updateFilter, addLinkEntity, getAllEntities, updateAttribute, updateQuery, findColumnsFilter, hasUnionFilterHint, transformQuery, UNION_FILTER_HINT, findColumns, setFindColumns, aggregateTypesForColumn, createOrder, updateOrder, moveOrder, addOrder, hasBlockingProblem, MultiTableViewType, sameGridCriteria, MultiTableUses, isViewHidden, closeRecordDefinition, closeReasonsFor, fromZonedWallClock, UnauthorizedAccessError, PowerPortalsProError, kanbanLaneKind, KanbanDateLaneOrder, firstDayOfWeek, validateKanbanDateLanes, todayIn, resolveKanbanDateLanes, savedKanbanLayoutToJson, kanbanLookupLanes, kanbanLanes, arrangeKanbanLanes, kanbanLayoutOf, KanbanDateLaneDrop, SAVED_KANBAN_LAYOUT_VERSION, RelationshipFilterMode, ImpersonateResult, SwitchIdentityResult, stateReasonsOf, stateChangeOf, StateChangeKind, recordPageNewUrl, isPasskeySupported, parseSavedSearchLayout, MultiTablePageMerger, searchColumnLabelOf, savedSearchLayoutToJson, parseSavedKanbanLayout, KANBAN_NO_VALUE_KEY, ColumnSecurityPermission, isGovernedTable, kanbanMoveOf, kanbanDateDayOf, kanbanDateValueFor, kanbanDateLaneKeyOf, kanbanMoveUpdate, kanbanRanksForDrop, shownViewTables, rootRecordPageUrl, LoginResult, isPasskeyCancellation, validateFetchXml, stripLikeWildcards, SearchKind, isDateOnly, readRelatedRecords, setGridColumnFilter, totalsToAggregates, FORMATTED_AGGREGATES, isValidAggregateFormat, aggregatesToTotals, serializeXml, gridAggregateNamed, SortDirection, MAX_AGGREGATE_FORMAT_LENGTH, Routes, canInvertFilter, operationGrantsAllow, kanbanDateLaneFilter, kanbanLaneFilter, inferLikeOperator, TextFormat, gridAggregateName, relatedRecordName, findGridColumnFilter, relatedRecordsKey, QUERY_DATE_GROUPINGS, dateStepsOf, getConditionOperatorsForColumnType, supportsColumnComparison, aggregateTypeToFetchXml, splitGridColumn, gridColumnViewJoin, defaultGridColumnFilterOperator, isDateStep, areColumnTypesComparable, formatLikeValue, AddPasskeyResult } from '@powerportalspro/core';
export { GridColumnPin, GridLayout, resolveColumnDisplayValue } from '@powerportalspro/core';
import { useEditor, useEditorState, EditorContent } from '@tiptap/react';
import { Extension, getSchema, getMarkRange } from '@tiptap/core';
import Image from '@tiptap/extension-image';
import { Table, TableCell, TableHeader, TableRow as TableRow$1 } from '@tiptap/extension-table';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import Italic from '@tiptap/extension-italic';
import TextAlign from '@tiptap/extension-text-align';
import { Placeholder } from '@tiptap/extensions';
import { TextStyleKit } from '@tiptap/extension-text-style';
import StarterKit from '@tiptap/starter-kit';
import { PluginKey, Plugin } from '@tiptap/pm/state';
import { TableMap, CellSelection } from '@tiptap/pm/tables';
import { DecorationSet, Decoration } from '@tiptap/pm/view';
import { DOMParser as DOMParser$1, DOMSerializer } from '@tiptap/pm/model';
import { unzipSync } from 'fflate';
import Markdown from 'react-markdown';
import hljs from 'highlight.js/lib/core';
import csharp from 'highlight.js/lib/languages/csharp';
import css from 'highlight.js/lib/languages/css';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import markdown from 'highlight.js/lib/languages/markdown';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import yaml from 'highlight.js/lib/languages/yaml';
import { DatePicker } from '@fluentui/react-datepicker-compat';
import { TimePicker } from '@fluentui/react-timepicker-compat';
import { createColumnHelper, useReactTable, getCoreRowModel } from '@tanstack/react-table';
import { flushSync } from 'react-dom';
import { useSensors, useSensor, TouchSensor, KeyboardSensor, DndContext, DragOverlay, useDroppable, PointerSensor } from '@dnd-kit/core';
import { sortableKeyboardCoordinates, SortableContext, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS as CSS$1 } from '@dnd-kit/utilities';
import { Nav, NavCategory, NavCategoryItem, NavSubItemGroup, NavSubItem } from '@fluentui/react-nav';
import { useLocation, useNavigate, useBlocker } from 'react-router-dom';
import { useWizard, Wizard } from 'react-use-wizard';
import { ChartType, AggregateDataverseChartDataSource, ViewDataverseChartDataSource, Chart, DataverseChartDataSource, toIndexAxis } from '@powerportalspro/react-charts';

// src/edits/base/masked-text-field.tsx
var useMaskedTextFieldStyles = makeStyles({
  alignLeft: { "& input": { textAlign: "left" } },
  alignRight: { "& input": { textAlign: "right" } },
  alignCenter: { "& input": { textAlign: "center" } }
});
function defined(obj) {
  const result = {};
  for (const k of Object.keys(obj)) {
    const v = obj[k];
    if (v !== void 0) result[k] = v;
  }
  return result;
}
var MaskedTextField = forwardRef(
  function MaskedTextField2(props, ref) {
    const {
      value: value2,
      onValueChange,
      onFocus,
      onBlur,
      mode = MaskMode.None,
      pattern = null,
      allowedPattern = null,
      numeric = null,
      valueIncludesMask = false,
      immediate = false,
      id,
      size,
      appearance,
      type = "text",
      placeholder,
      disabled,
      readOnly,
      maxLength,
      autoComplete,
      inputMode,
      ariaLabel,
      textAlign,
      contentBefore,
      contentAfter,
      className,
      style
    } = props;
    const useHookPath = mode !== MaskMode.None || immediate;
    const alignStyles = useMaskedTextFieldStyles();
    const inputAlignClass = textAlign === "right" ? alignStyles.alignRight : textAlign === "center" ? alignStyles.alignCenter : textAlign === "left" ? alignStyles.alignLeft : void 0;
    const elementRef = useRef(null);
    const {
      displayValue,
      onChange: hookOnChange,
      inputRef: hookInputRef,
      forceValue: hookForceValue
    } = useMaskedTextField({
      value: value2,
      onValueChange,
      mode,
      pattern,
      allowedPattern,
      numeric,
      valueIncludesMask
    });
    const fastForceValue = (next) => {
      onValueChange(next);
    };
    useImperativeHandle(
      ref,
      () => ({
        forceValue: useHookPath ? hookForceValue : fastForceValue,
        focus: () => elementRef.current?.focus(),
        blur: () => elementRef.current?.blur()
      }),
      [useHookPath, hookForceValue, onValueChange]
    );
    const composedInputRef = (el) => {
      elementRef.current = el;
      if (useHookPath) {
        hookInputRef(el);
      }
    };
    const rootClassName = mergeClasses(className, inputAlignClass);
    const commonInputProps = defined({
      id,
      className: rootClassName === "" ? void 0 : rootClassName,
      style,
      size,
      appearance,
      type,
      placeholder,
      maxLength,
      readOnly,
      disabled,
      autoComplete,
      inputMode
    });
    if (!useHookPath) {
      return /* @__PURE__ */ jsx(
        Input,
        {
          ...commonInputProps,
          value: value2 ?? "",
          contentBefore: contentBefore ?? null,
          contentAfter: contentAfter ?? null,
          input: {
            "aria-label": ariaLabel,
            ref: composedInputRef
          },
          onChange: (_, data) => onValueChange(data.value === "" ? null : data.value),
          ...onFocus && { onFocus: () => onFocus() },
          ...onBlur && { onBlur: () => onBlur(value2 ?? null) }
        }
      );
    }
    return /* @__PURE__ */ jsx(
      Input,
      {
        ...commonInputProps,
        value: displayValue,
        onChange: hookOnChange,
        contentBefore: contentBefore ?? null,
        contentAfter: contentAfter ?? null,
        input: { "aria-label": ariaLabel, ref: composedInputRef },
        ...onFocus && { onFocus: () => onFocus() },
        ...onBlur && { onBlur: () => onBlur(value2 ?? null) }
      }
    );
  }
);

// src/edits/base/column-edit-types.ts
var DescriptionLocation = {
  None: "none",
  Tooltip: "tooltip",
  BelowControl: "belowControl"
};
var EditorLabelPosition = {
  Auto: "auto",
  Above: "above",
  Side: "side"
};
var HOVER_OPEN_DELAY_MS = 500;
var HOVER_CLOSE_DELAY_MS = 200;
var useStyles = makeStyles({
  // Plain <button> rather than Fluent's `Button` — Fluent's size variants
  // impose a 24px+ min-height frame that overwhelms a small inline icon.
  // A naked button gives us a tight bounding box around just the SVG.
  trigger: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "12px",
    height: "12px",
    padding: 0,
    marginLeft: tokens.spacingHorizontalXS,
    verticalAlign: "middle",
    border: "none",
    background: "transparent",
    color: tokens.colorBrandForeground1,
    cursor: "pointer",
    borderRadius: tokens.borderRadiusSmall,
    lineHeight: 0,
    fontSize: 0,
    ":hover": {
      color: tokens.colorBrandForeground2Hover
    },
    ":focus-visible": {
      outlineStyle: "solid",
      outlineWidth: "1px",
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: "1px"
    }
  },
  // Pin font-size on the icon — Fluent's react-icons render at `1em`, so
  // without this they pick up the surrounding label's text size.
  icon: {
    fontSize: "12px",
    width: "12px",
    height: "12px",
    display: "block"
  },
  surface: {
    maxWidth: "320px",
    whiteSpace: "pre-wrap"
  }
});
function DescriptionIcon({ description, ariaLabel }) {
  const styles = useStyles();
  const [open, setOpen] = useState(false);
  const openTimerRef = useRef(void 0);
  const lastInteractionRef = useRef("hover");
  const clearOpenTimer = useCallback(() => {
    if (openTimerRef.current !== void 0) {
      window.clearTimeout(openTimerRef.current);
      openTimerRef.current = void 0;
    }
  }, []);
  useEffect(() => () => clearOpenTimer(), [clearOpenTimer]);
  return /* @__PURE__ */ jsx(
    "span",
    {
      onClick: (e) => e.stopPropagation(),
      onMouseDown: (e) => {
        lastInteractionRef.current = "click";
        e.stopPropagation();
      },
      onPointerEnter: () => {
        lastInteractionRef.current = "hover";
      },
      children: /* @__PURE__ */ jsxs(
        Popover,
        {
          withArrow: true,
          openOnHover: true,
          mouseLeaveDelay: HOVER_CLOSE_DELAY_MS,
          open,
          onOpenChange: (_, data) => {
            if (data.open === false) {
              clearOpenTimer();
              setOpen(false);
              return;
            }
            if (lastInteractionRef.current === "click") {
              clearOpenTimer();
              setOpen(true);
              return;
            }
            if (openTimerRef.current !== void 0) return;
            openTimerRef.current = window.setTimeout(() => {
              openTimerRef.current = void 0;
              setOpen(true);
            }, HOVER_OPEN_DELAY_MS);
          },
          children: [
            /* @__PURE__ */ jsx(PopoverTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                tabIndex: -1,
                className: styles.trigger,
                "aria-label": ariaLabel ? `Show description for ${ariaLabel}` : "Show description",
                children: /* @__PURE__ */ jsx(Info12Regular, { className: styles.icon })
              }
            ) }),
            /* @__PURE__ */ jsx(PopoverSurface, { className: styles.surface, children: description })
          ]
        }
      )
    }
  );
}
var EditorLabelPositionContext = createContext(
  void 0
);
function EditorLabelPositionProvider({
  position,
  children
}) {
  const inherited = useContext(EditorLabelPositionContext);
  return /* @__PURE__ */ jsx(EditorLabelPositionContext.Provider, { value: position ?? inherited, children });
}
function useEditorLabelPosition(own) {
  const inherited = useContext(EditorLabelPositionContext);
  return own ?? inherited ?? EditorLabelPosition.Auto;
}
var useEditorLabelLayoutStyles = makeStaticStyles(`
.ppp-label-side, .ppp-label-auto { display: grid; grid-template-columns: var(--ppp-editor-label-width, 33%) minmax(0, 1fr); column-gap: var(--spacingHorizontalM, 12px); row-gap: 0; }
.ppp-label-auto { container: ppp-editor-label / inline-size; width: 100%; }
.ppp-label-side > * { grid-column: 2; }
.ppp-label-auto > * { grid-column: 1 / -1; }
.ppp-label-side > label.ppp-editor-label { grid-column: 1; grid-row: 1; align-self: start; padding-block: var(--spacingVerticalSNudge, 6px); margin-bottom: 0; }
.ppp-label-text.ppp-label-side > label.ppp-editor-label { padding-block: 0; }
@container ppp-editor-label (min-width: 400px) {
  .ppp-label-auto > * { grid-column: 2; }
  .ppp-label-auto > label.ppp-editor-label { grid-column: 1; grid-row: 1; align-self: start; padding-block: var(--spacingVerticalSNudge, 6px); margin-bottom: 0; }
  .ppp-label-text.ppp-label-auto > label.ppp-editor-label { padding-block: 0; }
}
`);
function useEditorLabelLayoutClass(own, hasLabel) {
  useEditorLabelLayoutStyles();
  const position = useEditorLabelPosition(own);
  return hasLabel ? `ppp-label-${position}` : void 0;
}
var editorLabelClassName = "ppp-editor-label";
var useEditorStateStyles = makeStaticStyles(`
.ppp-readonly-value {
  box-sizing: border-box;
  min-height: 32px;
  padding: calc(var(--spacingVerticalSNudge, 6px) - var(--strokeWidthThin, 1px)) var(--spacingHorizontalM, 12px);
  border: var(--strokeWidthThin, 1px) solid var(--colorNeutralStrokeDisabled, #e0e0e0);
  border-radius: var(--borderRadiusMedium, 4px);
  background-color: var(--colorTransparentBackground, transparent);
  color: var(--colorNeutralForeground1, #242424);
  font-family: var(--fontFamilyBase);
  font-size: var(--fontSizeBase300, 14px);
  font-weight: var(--fontWeightRegular, 400);
  line-height: var(--lineHeightBase300, 20px);
  overflow-wrap: anywhere;
}
.ppp-readonly-value:focus-visible {
  outline: var(--strokeWidthThick, 2px) solid var(--colorStrokeFocus2, #000000);
  outline-offset: var(--strokeWidthThin, 1px);
}
.ppp-editor-disabled label.ppp-editor-label { color: var(--colorNeutralForegroundDisabled, #bdbdbd); }
.ppp-editor-disabled .ppp-money-edit-symbol { color: var(--colorNeutralForegroundDisabled, #bdbdbd); }
`);
var useFluentStateStyles = makeStaticStyles(`
.ppp-editor-readonly .fui-Input.fui-Input,
.ppp-editor-readonly .fui-Textarea.fui-Textarea {
  background-color: var(--colorTransparentBackground, transparent);
  border-color: var(--colorNeutralStrokeDisabled, #e0e0e0);
}
.ppp-editor-readonly .fui-Input::after,
.ppp-editor-readonly .fui-Textarea::after { display: none; }
.ppp-editor-readonly .fui-Textarea__textarea { resize: none; }
.ppp-editor-readonly .fui-Checkbox,
.ppp-editor-readonly .fui-Radio,
.ppp-editor-readonly .fui-Switch { pointer-events: none; }
.ppp-editor-disabled .ppp-editor-label .fui-Label__required { color: var(--colorNeutralForegroundDisabled, #bdbdbd); }
`);
function useEditorStateClass(readOnly, disabled) {
  useEditorStateStyles();
  useFluentStateStyles();
  return disabled ? "ppp-editor-disabled" : readOnly ? "ppp-editor-readonly" : void 0;
}
function ReadOnlyValue({ id, children, "aria-label": ariaLabel }) {
  useEditorStateStyles();
  return /* @__PURE__ */ jsx(
    "div",
    {
      id,
      className: "ppp-readonly-value",
      role: "textbox",
      "aria-readonly": "true",
      "aria-label": ariaLabel,
      tabIndex: 0,
      children
    }
  );
}
var toNumber = (value2) => value2 === void 0 || value2 === null ? value2 : Number(value2);
function getStateColumn(tableMetadata, kind) {
  const column = tableMetadata?.columns.find(
    (x) => kind === "state" ? x.$type === 12 : x.$type === 13
  );
  if (!column) return void 0;
  return {
    ...column,
    choices: column.choices.map((choice2) => ({
      ...choice2,
      value: Number(choice2.value),
      state: toNumber(choice2.state),
      defaultStatus: toNumber(choice2.defaultStatus)
    }))
  };
}
function heldChoiceValue(record, columnName) {
  const raw = record?.properties?.[columnName]?.value;
  return raw === void 0 || raw === null ? void 0 : Number(raw);
}
function isRecordClosed(record, tableMetadata, dirtyColumns) {
  if (!record || isNewRecord(record)) return false;
  const states = getStateColumn(tableMetadata, "state");
  if (!states || dirtyColumns?.has(states.columnName)) return false;
  const state = heldChoiceValue(record, states.columnName);
  return states.choices.some((x) => x.value === state && x.isClosed === true);
}
function getActiveAndInactive(states) {
  if (!states || states.choices.length !== 2) return void 0;
  const active = states.choices.find((x) => x.invariantName === "Active");
  const inactive = states.choices.find((x) => x.invariantName === "Inactive");
  return active && inactive ? { active, inactive } : void 0;
}
function isMetadataRequired(metadata) {
  if (!metadata) return false;
  return metadata.requiredLevel === RequiredLevel.SystemRequired || metadata.requiredLevel === RequiredLevel.ApplicationRequired;
}
function isMetadataReadOnly(metadata, isNewRecord2) {
  if (!metadata) return false;
  const typeCode = metadata.$type;
  if (typeCode === 41 || typeCode === 42) return false;
  return isNewRecord2 ? !metadata.isValidForCreate : !metadata.isValidForUpdate;
}
function isNewRecord(record) {
  if (!record) return true;
  if (!record.id || record.id === "00000000-0000-0000-0000-000000000000") return true;
  return record.permissions === void 0;
}
function isRecordWriteDenied(record) {
  if (!record) return false;
  if (isNewRecord(record)) return false;
  const perms = record.permissions ?? 0;
  return (perms & TableSecurityPermission.Write) === 0;
}
function isColumnWriteDenied(record, columnName) {
  if (!record || !columnName) return false;
  return !canWriteColumn(record, columnName);
}
function resolveEditState(metadata, record, explicitReadOnly, explicitDisabled, columnName, recordLocked) {
  if (isRecordWriteDenied(record) || isColumnWriteDenied(record, columnName) || recordLocked === true) {
    return { readOnly: true, disabled: explicitDisabled ?? false };
  }
  return {
    readOnly: explicitReadOnly ?? isMetadataReadOnly(metadata, isNewRecord(record)),
    disabled: explicitDisabled ?? false
  };
}
function getDisplayLabel(metadata, columnName, tableName, t) {
  if (tableName) {
    return t(`tables.${tableName}.columns.${columnName}.label`);
  }
  return metadata?.displayName || columnName;
}
function getDisplayDescription(metadata, columnName, tableName, t) {
  if (tableName) {
    const key3 = `tables.${tableName}.columns.${columnName}.description`;
    const resolved = t(key3);
    return resolved !== key3 ? nonBlankDescription(resolved) : void 0;
  }
  return nonBlankDescription(metadata?.description);
}
function nonBlankDescription(value2) {
  return value2 !== void 0 && value2 !== null && value2.trim().length > 0 ? value2 : void 0;
}
function resolveDescription(description, metadata, columnName, tableName, t) {
  return nonBlankDescription(description) ?? getDisplayDescription(metadata, columnName, tableName, t);
}
function getStringMaxLength(metadata) {
  if (!metadata) return void 0;
  const m = metadata;
  if (m.maxLength === void 0 || m.maxLength === null) return void 0;
  return Number(m.maxLength);
}
function getChoiceMetadata(metadata) {
  if (!metadata) return void 0;
  const m = metadata;
  if (m.$type !== 11 && m.$type !== 12 && m.$type !== 13 && m.$type !== 40) return void 0;
  if (m.choiceLogicalName === void 0 || m.choices === void 0) return void 0;
  return {
    choiceLogicalName: m.choiceLogicalName,
    isGlobal: m.isGlobal ?? false,
    choices: m.choices.map((c) => ({
      value: Number(c.value),
      displayName: c.displayName,
      ...c.color ? { color: c.color } : {},
      ...c.isHidden ? { isHidden: true } : {}
    }))
  };
}
function getLookupMetadata(metadata) {
  if (!metadata) return void 0;
  const m = metadata;
  if (m.$type !== 6) return void 0;
  if (!m.targetTables || m.targetTables.length === 0) return void 0;
  return { targetTables: m.targetTables };
}
function getNumberLimits(metadata) {
  if (!metadata) return {};
  const m = metadata;
  const result = {};
  if (m.min !== void 0) result.min = Number(m.min);
  if (m.max !== void 0) result.max = Number(m.max);
  if (m.precision !== void 0) result.precision = Number(m.precision);
  return result;
}
function resolveNumberValueType(metadata) {
  const t = metadata?.$type;
  switch (t) {
    case 3:
      return "decimal";
    case 4:
      return "double";
    case 5:
      return "int";
    case 18:
      return "bigint";
    default:
      return void 0;
  }
}
function buildFieldValidationProps(errors, displayValidationErrorMessage) {
  const firstError = displayValidationErrorMessage && errors && errors.length > 0 ? errors[0] : void 0;
  if (!firstError) return {};
  return {
    validationState: "error",
    validationMessage: firstError,
    validationMessageIcon: /* @__PURE__ */ jsx(ErrorCircle12Filled, {})
  };
}
function defaultBuiltInErrors(state, localizer) {
  const errors = [];
  const labelText = state.label ?? "";
  if (state.required) {
    const v = state.value;
    const isEmpty = v === null || v === void 0 || typeof v === "string" && v.trim() === "" || Array.isArray(v) && v.length === 0;
    if (isEmpty) {
      errors.push(localizer.t("app.messages.column-required", [labelText]));
      return errors;
    }
  }
  switch (state.kind) {
    case "string": {
      const v = state.value;
      if (typeof v !== "string") break;
      if (state.maxLength !== void 0 && v.length > state.maxLength) {
        errors.push(localizer.t("app.messages.column-max-length", [state.maxLength]));
      }
      if (state.minLength !== void 0 && v.length < state.minLength) {
        errors.push(localizer.t("app.messages.column-min-length", [state.minLength]));
      }
      break;
    }
    case "number": {
      const v = state.value;
      if (typeof v !== "number" || !Number.isFinite(v)) break;
      if (state.max !== void 0 && v > state.max) {
        errors.push(localizer.t("app.messages.column-max-value", [state.max]));
      }
      if (state.min !== void 0 && v < state.min) {
        errors.push(localizer.t("app.messages.column-min-value", [state.min]));
      }
      break;
    }
    case "array": {
      const v = state.value;
      if (!Array.isArray(v)) break;
      if (state.maxCount !== void 0 && v.length > state.maxCount) {
        errors.push(localizer.t("app.errors.value-max-count", [state.maxCount]));
      }
      if (state.minCount !== void 0 && v.length < state.minCount) {
        errors.push(localizer.t("app.errors.value-min-count", [state.minCount]));
      }
      break;
    }
  }
  return errors;
}
function useColumnValidation(columnName, state, customValidator) {
  const validation = useValidationContext();
  const errors = useColumnValidationErrors(columnName);
  const t = useT();
  const stateRef = useRef(state);
  stateRef.current = state;
  const customValidatorRef = useRef(customValidator);
  customValidatorRef.current = customValidator;
  const localizerRef = useRef({ t });
  localizerRef.current = { t };
  const validationRef = useRef(validation);
  validationRef.current = validation;
  useEffect(() => {
    const v = validationRef.current;
    if (!v) return;
    const validator = async () => {
      const current = stateRef.current;
      const errs = defaultBuiltInErrors(current, localizerRef.current);
      if (customValidatorRef.current) {
        const custom = await customValidatorRef.current();
        return [...errs, ...custom];
      }
      return errs;
    };
    return v.register(columnName, validator);
  }, [columnName]);
  const touchedRef = useRef(false);
  const lastValueJsonRef = useRef(JSON.stringify(state.value));
  useEffect(() => {
    const v = validationRef.current;
    if (!v) return;
    const currentValueJson = JSON.stringify(state.value);
    if (currentValueJson !== lastValueJsonRef.current) {
      lastValueJsonRef.current = currentValueJson;
      touchedRef.current = true;
    }
    if (!touchedRef.current) return;
    void v.validateColumn(columnName);
  }, [columnName, JSON.stringify(state)]);
  return errors;
}
function useGuardedSetValue(rawSetValue, readOnly, disabled) {
  return useCallback(
    (next) => {
      if (readOnly || disabled) return;
      rawSetValue(next);
    },
    [rawSetValue, readOnly, disabled]
  );
}
function useStringColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const value2 = raw?.value ?? void 0;
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, { $type: 14, value: next });
      }
    },
    [columnName, ctx]
  );
  return { value: value2, setValue };
}
function useBoolColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const value2 = raw?.value ?? void 0;
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, { $type: 0, value: next });
      }
    },
    [columnName, ctx]
  );
  return { value: value2, setValue };
}
function useNumberColumn(columnName, valueType = "int") {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const rawValue = raw?.value;
  const value2 = rawValue === void 0 || rawValue === null ? void 0 : Number(rawValue);
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
        return;
      }
      const wireValue = valueType === "int" ? { $type: 5, value: next } : valueType === "decimal" ? { $type: 3, value: next } : valueType === "double" ? { $type: 4, value: next } : { $type: 18, value: next };
      ctx.setColumnValue(columnName, wireValue);
    },
    [columnName, ctx, valueType]
  );
  return { value: value2, setValue };
}
function useChoiceColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const rawValue = raw?.value;
  const value2 = rawValue === void 0 || rawValue === null ? void 0 : Number(rawValue);
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, { $type: 11, value: next });
      }
    },
    [columnName, ctx]
  );
  return { value: value2, setValue };
}
function useMultiSelectChoiceColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const value2 = (raw?.value ?? []).map((c) => Number(c.value));
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0 || next.length === 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, {
          $type: 40,
          value: next.map((v) => ({ value: v }))
        });
      }
    },
    [columnName, ctx]
  );
  return { value: value2, setValue };
}
function useLookupColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  let value2;
  if (raw?.value && raw.value !== "00000000-0000-0000-0000-000000000000") {
    value2 = {
      id: raw.value,
      name: raw.name ?? null,
      tableName: raw.tableName
    };
  }
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, {
          $type: 6,
          value: next.id,
          name: next.name,
          tableName: next.tableName
        });
      }
    },
    [columnName, ctx]
  );
  return { value: value2, setValue };
}
function useMoneyColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const rawValue = raw?.value;
  const value2 = rawValue === void 0 || rawValue === null ? void 0 : Number(rawValue);
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, { $type: 8, value: next });
      }
    },
    [columnName, ctx]
  );
  return { value: value2, setValue };
}
function useDateColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const value2 = raw?.value ?? void 0;
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, { $type: 2, value: next });
      }
    },
    [columnName, ctx]
  );
  return { value: value2, setValue };
}
function useFileColumn(columnName) {
  const ctx = useRecordContext();
  const properties = ctx.record?.properties;
  const dataColumn = properties?.[columnName];
  const dataColumnType = dataColumn?.$type;
  let value2;
  let fileId;
  if (dataColumnType === "FileValue") {
    const fv = dataColumn;
    value2 = fv;
    if (fv.id && fv.id !== "00000000-0000-0000-0000-000000000000") {
      fileId = fv.id;
    }
  } else if (dataColumnType === 15) {
    const guidValue = dataColumn;
    if (guidValue.value && guidValue.value !== "00000000-0000-0000-0000-000000000000") {
      const nameColumn = properties?.[`${columnName}_name`];
      value2 = {
        fileName: nameColumn?.value ?? "",
        id: guidValue.value,
        value: null
      };
      fileId = guidValue.value;
    }
  } else {
    const idColumn = properties?.[`${columnName}id`];
    if (idColumn?.value && idColumn.value !== "00000000-0000-0000-0000-000000000000") {
      fileId = idColumn.value;
    }
  }
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, {
          $type: "FileValue",
          fileName: next.fileName,
          id: next.id,
          value: next.value ?? null
        });
      }
    },
    [columnName, ctx]
  );
  const hydrateValue = useCallback(
    (next) => {
      if (next === null) {
        ctx.hydrateColumnValue(columnName, null);
      } else {
        ctx.hydrateColumnValue(columnName, {
          $type: "FileValue",
          fileName: next.fileName,
          id: next.id,
          value: next.value ?? null
        });
      }
    },
    [columnName, ctx]
  );
  return { value: value2, setValue, fileId, hydrateValue };
}
function useRecordLocked() {
  const { record, tableMetadata, dirtyColumns, createDenied } = useRecordContext();
  return createDenied === true || isRecordClosed(record, tableMetadata, dirtyColumns);
}
function TextEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  type = "text",
  minLength,
  maxLength,
  autoComplete,
  placeholder,
  mask = MaskMode.None,
  pattern,
  allowedPattern,
  numeric,
  storeMaskedValue = false,
  immediate = false,
  validate
}) {
  const { value: value2, setValue: rawSetValue } = useStringColumn(columnName);
  const { record } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedMaxLength = maxLength ?? getStringMaxLength(metadata);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "string",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value2 ?? "",
      ...minLength !== void 0 && { minLength },
      ...resolvedMaxLength !== void 0 && { maxLength: resolvedMaxLength }
    },
    validate
  );
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-text-edit", layoutClassName, stateClassName),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: /* @__PURE__ */ jsx(
        MaskedTextField,
        {
          id,
          className,
          style,
          type,
          value: value2,
          onValueChange: (next) => setValue(next),
          ...maxLength !== void 0 && { maxLength: resolvedMaxLength },
          readOnly: resolvedReadOnly,
          disabled: resolvedDisabled,
          placeholder,
          autoComplete: autoComplete ? "on" : "off",
          mode: mask,
          pattern,
          allowedPattern,
          numeric,
          valueIncludesMask: storeMaskedValue,
          immediate
        }
      )
    }
  );
}
function MemoEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  minLength,
  maxLength,
  rows = 3,
  placeholder,
  resize = "vertical",
  validate
}) {
  const { value: value2, setValue: rawSetValue } = useStringColumn(columnName);
  const { record } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedMaxLength = maxLength ?? getStringMaxLength(metadata);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "string",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value2 ?? "",
      ...minLength !== void 0 && { minLength },
      ...resolvedMaxLength !== void 0 && { maxLength: resolvedMaxLength }
    },
    validate
  );
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-memo-edit", layoutClassName, stateClassName),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: /* @__PURE__ */ jsx(
        Textarea,
        {
          id,
          className,
          style,
          value: value2 ?? "",
          rows,
          minLength,
          maxLength: resolvedMaxLength,
          readOnly: resolvedReadOnly,
          disabled: resolvedDisabled,
          placeholder,
          resize,
          onChange: (_, data) => {
            setValue(data.value === "" ? null : data.value);
          }
        }
      )
    }
  );
}
var key = new PluginKey("pppFormatPainter");
var isFormatting = (mark) => mark.type.name !== "link";
var FormatPainter = Extension.create({
  name: "pppFormatPainter",
  addStorage() {
    return { marks: null };
  },
  addCommands() {
    return {
      toggleFormatPainter: () => ({ state, tr, dispatch }) => {
        if (dispatch) {
          this.storage.marks = this.storage.marks ? null : (state.storedMarks ?? state.selection.$from.marks()).filter(isFormatting);
          tr.setMeta(key, true);
        }
        return true;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Escape: () => {
        if (!this.storage.marks) return false;
        return this.editor.commands.toggleFormatPainter();
      }
    };
  },
  addProseMirrorPlugins() {
    const storage = this.storage;
    const editor = this.editor;
    return [
      new Plugin({
        key,
        props: {
          attributes: () => storage.marks ? { class: "ppp-rich-edit-format-painter" } : {},
          handleDOMEvents: {
            mouseup: () => {
              if (!storage.marks) return false;
              setTimeout(() => {
                const marks = storage.marks;
                const { from, to, empty } = editor.state.selection;
                if (!marks || empty) return;
                storage.marks = null;
                const tr = editor.state.tr;
                editor.state.doc.nodesBetween(from, to, (node, pos) => {
                  if (!node.isText) return true;
                  const start = Math.max(from, pos);
                  const end = Math.min(to, pos + node.nodeSize);
                  node.marks.filter(isFormatting).forEach((mark) => tr.removeMark(start, end, mark.type));
                  return false;
                });
                marks.forEach((mark) => tr.addMark(from, to, mark));
                tr.setMeta(key, true);
                editor.view.dispatch(tr);
              });
              return false;
            }
          }
        }
      })
    ];
  }
});
var RICH_TEXT_IMAGE_TYPES = ["image/png", "image/jpeg", "image/gif", "image/webp", "image/bmp"];
var MAX_RICH_TEXT_IMAGE_BYTES = 10 * 1024 * 1024;
var ImageInsert = Extension.create({
  name: "pppImageInsert",
  addOptions() {
    return { upload: void 0, onError: void 0, maxLength: void 0 };
  },
  addCommands() {
    return {
      insertImageFiles: (files) => ({ editor }) => {
        void insertImages(editor, files, this.options);
        return files.length > 0;
      }
    };
  },
  addProseMirrorPlugins() {
    const editor = this.editor;
    const options = this.options;
    return [
      new Plugin({
        key: new PluginKey("pppImageInsert"),
        props: {
          handlePaste: (_view, event) => {
            const files = imageFiles(event.clipboardData?.files);
            if (files.length === 0 || !editor.isEditable) return false;
            void insertImages(editor, files, options);
            return true;
          },
          handleDrop: (view, event) => {
            const files = imageFiles(event.dataTransfer?.files);
            if (files.length === 0 || !editor.isEditable) return false;
            const at = view.posAtCoords({ left: event.clientX, top: event.clientY });
            if (at) editor.commands.setTextSelection(at.pos);
            void insertImages(editor, files, options);
            return true;
          }
        }
      })
    ];
  }
});
function imageFiles(list) {
  return Array.from(list ?? []).filter((file) => file.type.startsWith("image/"));
}
async function insertImages(editor, files, options) {
  for (const file of files) {
    if (!RICH_TEXT_IMAGE_TYPES.includes(file.type)) {
      options.onError?.(file, "not-an-image");
      continue;
    }
    if (file.size > MAX_RICH_TEXT_IMAGE_BYTES) {
      options.onError?.(file, "too-large");
      continue;
    }
    let src;
    try {
      src = await options.upload?.(file) ?? null;
      if (src === null) {
        src = await readAsDataUrl(file);
        const maxLength = options.maxLength?.();
        if (maxLength !== void 0 && editor.getHTML().length + src.length > maxLength) {
          options.onError?.(file, "too-large-to-embed");
          continue;
        }
      }
    } catch {
      options.onError?.(file, "failed");
      continue;
    }
    if (editor.isDestroyed) return;
    editor.chain().focus().setImage({ src, alt: "" }).run();
  }
}
function readAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

// src/rich-edit/core/style.ts
var ALLOWED_PROPERTIES = /* @__PURE__ */ new Set([
  "aspect-ratio",
  "background-color",
  "border",
  "border-bottom",
  "border-bottom-color",
  "border-bottom-style",
  "border-bottom-width",
  "border-collapse",
  "border-color",
  "border-left",
  "border-left-color",
  "border-left-style",
  "border-left-width",
  "border-radius",
  "border-right",
  "border-right-color",
  "border-right-style",
  "border-right-width",
  "border-spacing",
  "border-style",
  "border-top",
  "border-top-color",
  "border-top-style",
  "border-top-width",
  "border-width",
  "caption-side",
  "clear",
  "color",
  "direction",
  "display",
  "float",
  "font-family",
  "font-size",
  "font-style",
  "font-variant",
  "font-weight",
  "height",
  "letter-spacing",
  "line-height",
  "list-style",
  "list-style-position",
  "list-style-type",
  "margin",
  "margin-bottom",
  "margin-left",
  "margin-right",
  "margin-top",
  "max-height",
  "max-width",
  "min-height",
  "min-width",
  "object-fit",
  "overflow",
  "overflow-wrap",
  "padding",
  "padding-bottom",
  "padding-left",
  "padding-right",
  "padding-top",
  "table-layout",
  "text-align",
  "text-decoration",
  "text-decoration-color",
  "text-decoration-line",
  "text-decoration-style",
  "text-indent",
  "text-transform",
  "unicode-bidi",
  "vertical-align",
  "white-space",
  "width",
  "word-break",
  "word-spacing",
  "word-wrap"
]);
var UNSAFE_VALUE = /url\s*\(|image-set\s*\(|expression\s*\(|javascript:|@import|\\|[\r\n\f]/i;
function isAllowedStyle(property, value2) {
  return ALLOWED_PROPERTIES.has(property) && value2.length > 0 && !UNSAFE_VALUE.test(value2);
}
function parseStyle(style) {
  if (!style) return [];
  const declarations = [];
  let depth = 0;
  let quote = null;
  let start = 0;
  const push = (end) => {
    const text2 = style.slice(start, end);
    const colon = text2.indexOf(":");
    if (colon > 0) {
      const property = text2.slice(0, colon).trim().toLowerCase();
      const value2 = text2.slice(colon + 1).trim();
      if (property && value2) declarations.push({ property, value: value2 });
    }
    start = end + 1;
  };
  for (let i = 0; i < style.length; i++) {
    const c = style[i];
    if (quote) {
      if (c === quote) quote = null;
    } else if (c === '"' || c === "'") {
      quote = c;
    } else if (c === "(") {
      depth++;
    } else if (c === ")") {
      depth = Math.max(0, depth - 1);
    } else if (c === ";" && depth === 0) {
      push(i);
    }
  }
  push(style.length);
  return declarations;
}
function formatStyle(declarations) {
  if (declarations.length === 0) return null;
  return declarations.map((d) => `${d.property}: ${d.value}`).join("; ") + ";";
}
function getStyleValue(style, property) {
  const declarations = parseStyle(style);
  for (let i = declarations.length - 1; i >= 0; i--) {
    if (declarations[i].property === property) return declarations[i].value;
  }
  return void 0;
}
function getMarginLeftPixels(style) {
  let marginLeft;
  for (const { property, value: value2 } of parseStyle(style)) {
    if (property === "margin-left") marginLeft = value2;
    else if (property === "margin") marginLeft = expandBox(value2)[3];
  }
  const match = marginLeft?.match(/^(-?\d+(?:\.\d+)?)px$/i);
  return match ? Math.max(0, Math.round(Number(match[1]))) : 0;
}
function expandBox(value2) {
  const parts = value2.trim().split(/\s+/);
  const [top, right = top, bottom = top, left = right] = parts;
  return [top, right, bottom, left];
}
function residualStyle(style, owned, omitMarginLeft = false) {
  const kept = [];
  for (const declaration of parseStyle(style)) {
    const { property, value: value2 } = declaration;
    if (omitMarginLeft && property === "margin") {
      const [top, right, bottom] = expandBox(value2);
      kept.push(
        { property: "margin-top", value: top },
        { property: "margin-right", value: right },
        { property: "margin-bottom", value: bottom }
      );
      continue;
    }
    if (omitMarginLeft && property === "margin-left") continue;
    if (owned.includes(property)) continue;
    if (isAllowedStyle(property, value2)) kept.push(declaration);
  }
  return formatStyle(kept);
}
var HANDLE_PIXELS = 5;
var MIN_COLUMN_PIXELS = 24;
function resizeColumns(widths, column, delta, available) {
  const next = [...widths];
  if (column < widths.length - 1) {
    const pair = widths[column] + widths[column + 1];
    next[column] = clamp(widths[column] + delta, MIN_COLUMN_PIXELS, pair - MIN_COLUMN_PIXELS);
    next[column + 1] = pair - next[column];
  } else {
    const others = widths.reduce((sum, width, i) => i === column ? sum : sum + width, 0);
    next[column] = clamp(widths[column] + delta, MIN_COLUMN_PIXELS, Math.max(MIN_COLUMN_PIXELS, available - others));
  }
  return next;
}
function percentage(part, whole) {
  return `${Math.round(part / whole * 1e4) / 100}%`;
}
function clamp(value2, min, max) {
  return Math.min(Math.max(value2, min), max);
}
var key2 = new PluginKey("pppTableColumnResize");
function tableColumnResizing() {
  let dragging = false;
  return new Plugin({
    key: key2,
    // The cell whose border is under the pointer, to mark it.
    state: {
      init: () => null,
      apply: (tr, hovered) => {
        const meta = tr.getMeta(key2);
        if (meta !== void 0) return meta;
        return tr.docChanged ? null : hovered;
      }
    },
    props: {
      attributes: (state) => key2.getState(state) != null ? { class: "resize-cursor" } : {},
      decorations: (state) => hoverDecoration(state),
      handleDOMEvents: {
        mousemove: (view, event) => {
          if (dragging) return false;
          const border = view.editable ? borderAt(view, event) : null;
          setHovered(view, border?.cellPos ?? null);
          return false;
        },
        mouseleave: (view) => {
          if (!dragging) setHovered(view, null);
          return false;
        },
        mousedown: (view, event) => {
          if (!view.editable || event.button !== 0) return false;
          const border = borderAt(view, event);
          if (!border) return false;
          event.preventDefault();
          dragging = true;
          drag(view, event, border, () => {
            dragging = false;
          });
          return true;
        }
      }
    }
  });
}
function setHovered(view, cellPos) {
  if (key2.getState(view.state) === cellPos) return;
  view.dispatch(view.state.tr.setMeta(key2, cellPos));
}
function hoverDecoration(state) {
  const cellPos = key2.getState(state);
  if (cellPos == null) return null;
  const cell = state.doc.nodeAt(cellPos);
  if (!cell) return null;
  return DecorationSet.create(state.doc, [
    Decoration.node(cellPos, cellPos + cell.nodeSize, { class: "ppp-column-resize-hover" })
  ]);
}
function borderAt(view, event) {
  const target = event.target;
  let cellDom = target?.closest?.("td, th");
  if (!cellDom || !view.dom.contains(cellDom)) return null;
  const rtl = getComputedStyle(cellDom).direction === "rtl";
  const rect = cellDom.getBoundingClientRect();
  const trailing = rtl ? rect.left : rect.right;
  const leading = rtl ? rect.right : rect.left;
  if (Math.abs(event.clientX - trailing) > HANDLE_PIXELS) {
    const previous = cellDom.previousElementSibling;
    if (!previous || Math.abs(event.clientX - leading) > HANDLE_PIXELS) return null;
    cellDom = previous;
  }
  const $pos = view.state.doc.resolve(view.posAtDOM(cellDom, 0));
  let cellPos = null;
  for (let depth = $pos.depth; depth > 0; depth--) {
    const role = $pos.node(depth).type.spec.tableRole;
    if (cellPos === null && (role === "cell" || role === "header_cell")) cellPos = $pos.before(depth);
    if (role === "table" && cellPos !== null) {
      const tablePos = $pos.before(depth);
      const table = $pos.node(depth);
      const column = TableMap.get(table).findCell(cellPos - tablePos - 1).right - 1;
      return { cellPos, tablePos, table, column, rtl };
    }
  }
  return null;
}
function drag(view, start, border, done) {
  const wrapper = view.nodeDOM(border.tablePos);
  const table = wrapper?.querySelector("table");
  const cols = table ? Array.from(table.querySelectorAll(":scope > colgroup > col")) : [];
  if (!wrapper || !table || cols.length === 0) {
    done();
    return;
  }
  const tableWidth = table.getBoundingClientRect().width;
  let widths = cols.map((col) => col.getBoundingClientRect().width);
  if (widths.some((width) => width <= 0)) widths = cols.map(() => tableWidth / cols.length);
  const available = wrapper.clientWidth || tableWidth;
  let current = widths;
  const show = (next) => {
    const total = next.reduce((sum, width) => sum + width, 0);
    next.forEach((width, i) => {
      cols[i].style.width = percentage(width, total);
      cols[i].style.minWidth = "";
    });
    table.style.width = percentage(total, available);
  };
  const move = (event) => {
    const delta = (event.clientX - start.clientX) * (border.rtl ? -1 : 1);
    current = resizeColumns(widths, border.column, delta, available);
    show(current);
  };
  const end = (event) => {
    window.removeEventListener("mousemove", move);
    window.removeEventListener("mouseup", end);
    move(event);
    done();
    const total = current.reduce((sum, width) => sum + width, 0);
    const node = view.state.doc.nodeAt(border.tablePos);
    if (!node || node.type !== border.table.type || total <= 0) return;
    view.dispatch(
      view.state.tr.setNodeMarkup(border.tablePos, void 0, {
        ...node.attrs,
        columnWidths: current.map((width) => percentage(width, total)),
        style: withWidth(node.attrs.style, percentage(total, available))
      }).setMeta(key2, null)
    );
  };
  window.addEventListener("mousemove", move);
  window.addEventListener("mouseup", end);
}
function withWidth(style, width) {
  return formatStyle([...parseStyle(style).filter((d) => d.property !== "width"), { property: "width", value: width }]);
}

// src/rich-edit/core/table-view.ts
var RichTextTableView = class {
  constructor(node, cellMinWidth) {
    this.node = node;
    this.cellMinWidth = cellMinWidth;
    this.dom = document.createElement("div");
    this.dom.className = "tableWrapper";
    this.table = this.dom.appendChild(document.createElement("table"));
    this.colgroup = this.table.appendChild(document.createElement("colgroup"));
    this.contentDOM = this.table.appendChild(document.createElement("tbody"));
    this.render();
  }
  node;
  cellMinWidth;
  dom;
  contentDOM;
  table;
  colgroup;
  update(node) {
    if (node.type !== this.node.type) return false;
    this.node = node;
    this.render();
    return true;
  }
  ignoreMutation(mutation) {
    const target = mutation.target;
    return mutation.type === "selection" ? false : this.dom.contains(target) && !this.contentDOM.contains(target);
  }
  render() {
    const { style, dir } = this.node.attrs;
    this.table.style.cssText = style ?? "";
    setOrRemove(this.table, "class", this.node.attrs.class);
    setOrRemove(this.table, "dir", dir);
    const widths = columnWidths(this.node);
    while (this.colgroup.children.length > widths.length) this.colgroup.lastElementChild.remove();
    while (this.colgroup.children.length < widths.length) this.colgroup.appendChild(document.createElement("col"));
    widths.forEach((width, i) => {
      const col = this.colgroup.children[i];
      col.style.width = width ?? "";
      col.style.minWidth = width ? "" : `${this.cellMinWidth}px`;
    });
  }
};
function setOrRemove(element, name, value2) {
  if (value2) element.setAttribute(name, value2);
  else element.removeAttribute(name);
}
function columnWidths(table) {
  const percentages = table.attrs.columnWidths;
  const widths = [];
  const row = table.firstChild;
  row?.forEach((cell) => {
    const colwidth = cell.attrs.colwidth;
    for (let i = 0; i < cell.attrs.colspan; i++) {
      const pixels = colwidth?.[i];
      widths.push(pixels ? `${pixels}px` : percentages?.[widths.length] ?? null);
    }
  });
  return widths;
}

// src/rich-edit/core/extensions.ts
var INDENT_STEP_PIXELS = 40;
var TEXT_ALIGNMENTS = ["left", "center", "right", "justify"];
var STYLED_NODES = [
  "heading",
  "blockquote",
  "bulletList",
  "orderedList",
  "listItem",
  "table",
  "tableRow",
  "tableCell",
  "tableHeader",
  "horizontalRule",
  "codeBlock"
];
var NEW_PARAGRAPH_STYLE = "margin: 0;";
var DIRECTED_NODES = [
  "paragraph",
  "heading",
  "blockquote",
  "bulletList",
  "orderedList",
  "listItem",
  "table",
  "tableCell",
  "tableHeader"
];
var INDENTED_NODES = ["paragraph", "heading"];
var TEXT_STYLE_PROPERTIES = ["color", "background-color", "font-family", "font-size", "line-height"];
function renderResidualStyle(attributes) {
  const owned = [];
  if (attributes.textAlign) owned.push("text-align");
  if (attributes.align) owned.push("text-align");
  const kept = attributes.style;
  const omitMarginLeft = "indent" in attributes && (attributes.indent > 0 || getMarginLeftPixels(kept) > 0);
  const style = residualStyle(kept, owned, omitMarginLeft);
  return style ? { style } : {};
}
var PreservedAttributes = Extension.create({
  name: "pppPreservedAttributes",
  addGlobalAttributes() {
    return [
      {
        types: STYLED_NODES,
        attributes: {
          style: {
            default: null,
            parseHTML: (element) => residualStyle(element.getAttribute("style"), []),
            renderHTML: renderResidualStyle
          }
        }
      },
      {
        // A paragraph made here gets Dynamics' own spacing, which it writes on every paragraph:
        // none, so Enter starts the next line rather than a spaced block. One read from a document
        // keeps the style it had, or none.
        types: ["paragraph"],
        attributes: {
          style: {
            default: NEW_PARAGRAPH_STYLE,
            parseHTML: (element) => residualStyle(element.getAttribute("style"), []) ?? "",
            renderHTML: renderResidualStyle
          }
        }
      },
      {
        types: ["textStyle"],
        attributes: {
          style: {
            default: null,
            parseHTML: (element) => residualStyle(element.getAttribute("style"), TEXT_STYLE_PROPERTIES),
            renderHTML: (attributes) => {
              const style = residualStyle(attributes.style, TEXT_STYLE_PROPERTIES);
              return style ? { style } : {};
            }
          }
        }
      },
      {
        types: DIRECTED_NODES,
        attributes: {
          dir: {
            default: null,
            parseHTML: (element) => {
              const dir = element.getAttribute("dir")?.toLowerCase();
              return dir === "ltr" || dir === "rtl" || dir === "auto" ? dir : null;
            },
            renderHTML: (attributes) => attributes.dir ? { dir: attributes.dir } : {}
          }
        }
      }
    ];
  }
});
var Indent = Extension.create({
  name: "pppIndent",
  addGlobalAttributes() {
    return [
      {
        types: INDENTED_NODES,
        attributes: {
          indent: {
            default: 0,
            parseHTML: (element) => getMarginLeftPixels(element.getAttribute("style")),
            renderHTML: (attributes) => attributes.indent > 0 ? { style: `margin-left: ${attributes.indent}px` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    const shift = (step) => ({ tr, state, dispatch }) => {
      let changed = false;
      state.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos) => {
        if (!INDENTED_NODES.includes(node.type.name)) return true;
        const current = node.attrs.indent ?? 0;
        const next = Math.max(0, current + step);
        if (next !== current) {
          tr.setNodeMarkup(pos, void 0, { ...node.attrs, indent: next });
          changed = true;
        }
        return false;
      });
      if (changed && dispatch) return true;
      return changed;
    };
    return {
      indent: () => ({ editor, commands, ...props }) => editor.isActive("listItem") ? commands.sinkListItem("listItem") : shift(INDENT_STEP_PIXELS)(props),
      outdent: () => ({ editor, commands, ...props }) => editor.isActive("listItem") ? commands.liftListItem("listItem") : shift(-INDENT_STEP_PIXELS)(props)
    };
  }
});
var TextDirection = Extension.create({
  name: "pppTextDirection",
  addCommands() {
    return {
      setTextDirection: (direction) => ({ tr, state, dispatch }) => {
        let changed = false;
        state.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos) => {
          if (!INDENTED_NODES.includes(node.type.name)) return true;
          if (node.attrs.dir !== direction) {
            tr.setNodeMarkup(pos, void 0, { ...node.attrs, dir: direction });
            changed = true;
          }
          return false;
        });
        if (changed && dispatch) return true;
        return changed;
      }
    };
  }
});
var RichTextTable = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      columnWidths: {
        default: null,
        rendered: false,
        parseHTML: (element) => {
          const cols = Array.from(element.querySelectorAll(":scope > colgroup > col"));
          if (cols.length === 0) return null;
          const widths = cols.map((col) => getStyleValue(col.getAttribute("style"), "width") ?? col.getAttribute("width") ?? "");
          return widths.every((width) => /^\d+(\.\d+)?%$/.test(width)) ? widths : null;
        }
      },
      class: {
        default: null,
        parseHTML: (element) => keptClasses(element.getAttribute("class"))
      }
    };
  },
  renderHTML({ node, HTMLAttributes }) {
    const widths = node.attrs.columnWidths ?? pixelWidthsAsPercentages(node);
    const colgroup = widths ? ["colgroup", {}, ...widths.map((width) => ["col", { style: `width: ${width};` }])] : ["colgroup", {}];
    return ["table", HTMLAttributes, colgroup, ["tbody", 0]];
  },
  addProseMirrorPlugins() {
    return [...this.parent?.() ?? [], tableColumnResizing()];
  }
}).configure({
  // Not Tiptap's own resizing, which works in pixels and lets go of the table's width mid-drag.
  resizable: false,
  View: RichTextTableView
});
function pixelWidthsAsPercentages(node) {
  const row = node.firstChild;
  if (!row) return null;
  const widths = [];
  row.forEach((cell) => {
    const colwidth = cell.attrs.colwidth;
    for (let i = 0; i < cell.attrs.colspan; i++) widths.push(colwidth?.[i] ?? 0);
  });
  if (widths.some((width) => width <= 0)) return null;
  const total = widths.reduce((sum, width) => sum + width, 0);
  return widths.map((width) => `${Math.round(width / total * 1e4) / 100}%`);
}
var cellAttributes = {
  colwidth: { default: null, rendered: false }
};
var RichTextTableCell = TableCell.extend({
  addAttributes() {
    return { ...this.parent?.(), ...cellAttributes };
  }
});
var RichTextTableHeader = TableHeader.extend({
  addAttributes() {
    return { ...this.parent?.(), ...cellAttributes };
  }
});
function keptClasses(value2) {
  const kept = (value2 ?? "").split(/\s+/).filter((name) => /^(ck-[\w-]+|table|image[\w-]*)$/.test(name));
  return kept.length > 0 ? kept.join(" ") : null;
}
var RichTextItalic = Italic.extend({
  renderHTML({ HTMLAttributes }) {
    return ["i", HTMLAttributes, 0];
  }
});
var RichTextImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: (element) => readPixels(element.getAttribute("width") ?? getStyleValue(element.getAttribute("style"), "max-width"))
      },
      height: {
        default: null,
        parseHTML: (element) => readPixels(element.getAttribute("height"))
      },
      aspectRatio: {
        default: null,
        rendered: false,
        parseHTML: (element) => getStyleValue(element.getAttribute("style"), "aspect-ratio") ?? null
      },
      style: {
        default: null,
        rendered: false,
        parseHTML: (element) => residualStyle(element.getAttribute("style"), ["width", "height", "max-width", "aspect-ratio"])
      },
      class: {
        default: null,
        rendered: false,
        parseHTML: (element) => keptClasses(element.getAttribute("class"))
      }
    };
  },
  renderHTML({ node, HTMLAttributes }) {
    const { width, height, aspectRatio, style } = node.attrs;
    const attributes = { ...HTMLAttributes };
    const declarations = [];
    let classes = node.attrs.class;
    if (width) {
      const ratio = aspectRatio ?? (height ? `${width}/${height}` : null);
      if (ratio) declarations.push(`aspect-ratio:${ratio}`);
      declarations.push("height:auto", `max-width:${width}px`);
      if (!classes?.split(" ").includes("image_resized")) classes = classes ? `${classes} image_resized` : "image_resized";
    }
    if (style) declarations.push(style.replace(/;\s*$/, ""));
    if (declarations.length > 0) attributes.style = declarations.join(";") + ";";
    if (classes) attributes.class = classes;
    return ["img", attributes];
  }
}).configure({
  inline: true,
  allowBase64: true,
  resize: { enabled: true, alwaysPreserveAspectRatio: true, minWidth: 16, minHeight: 16 }
});
function readPixels(value2) {
  const match = value2?.trim().match(/^(\d+(?:\.\d+)?)(px)?$/i);
  return match ? Math.round(Number(match[1])) : null;
}
function createRichTextExtensions(options = {}) {
  return [
    StarterKit.configure({
      // Dynamics writes no trailing paragraph, and adding one would change every document opened.
      trailingNode: false,
      italic: false,
      link: {
        openOnClick: false,
        autolink: true,
        defaultProtocol: "https",
        protocols: ["http", "https", "mailto", "tel"],
        HTMLAttributes: { rel: "noopener noreferrer", target: null, class: null }
      }
    }),
    RichTextItalic,
    TextStyleKit,
    TextAlign.configure({ types: ["heading", "paragraph"], alignments: [...TEXT_ALIGNMENTS] }),
    Subscript,
    Superscript,
    RichTextTable,
    TableRow$1,
    RichTextTableHeader,
    RichTextTableCell,
    RichTextImage,
    PreservedAttributes,
    Indent,
    TextDirection,
    FormatPainter,
    ImageInsert.configure({ upload: options.uploadImage, onError: options.onImageError, maxLength: options.maxLength }),
    ...options.placeholder ? [Placeholder.configure({ placeholder: options.placeholder })] : []
  ];
}
function isRichTextEmpty(editor) {
  let hasContent = false;
  editor.state.doc.descendants((node) => {
    if (hasContent) return false;
    if (node.isText ? node.text.trim().length > 0 : node.type.name === "image" || node.type.name === "table" || node.type.name === "horizontalRule") {
      hasContent = true;
    }
    return !hasContent;
  });
  return !hasContent;
}

// src/rich-edit/core/stored-html.ts
function defaultRichTextWrapper(direction = "ltr") {
  return { class: "ck-content", "data-wrapper": "true", dir: direction };
}
var WRAPPER_ATTRIBUTES = ["class", "data-wrapper", "dir", "lang", "style"];
var GUID = "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";
var DATAVERSE_IMAGE = new RegExp(
  `^(?:https://[^/]+)?/api/data/v[\\d.]+/msdyn_richtextfiles\\((${GUID})\\)/msdyn_imageblob/\\$value(?:\\?.*)?$`,
  "i"
);
var PORTAL_IMAGE = new RegExp(`/files/msdyn_richtextfile/(${GUID})/msdyn_imageblob/image(?:\\?.*)?$`, "i");
function dataverseImageAddress(id) {
  return `/api/data/v9.0/msdyn_richtextfiles(${id})/msdyn_imageblob/$value?size=full`;
}
function openStoredHtml(value2, images, direction = "ltr") {
  if (!value2 || value2.trim() === "") return { wrapper: defaultRichTextWrapper(direction), body: "" };
  if (!looksLikeHtml(value2)) return { wrapper: defaultRichTextWrapper(direction), body: plainTextToHtml(value2) };
  const container = parse(value2);
  let wrapper = defaultRichTextWrapper(direction);
  const root = singleWrapper(container);
  let body = container;
  if (root) {
    wrapper = Object.fromEntries(
      Array.from(root.attributes).filter((a) => WRAPPER_ATTRIBUTES.includes(a.name)).map((a) => [a.name, a.value])
    );
    body = root;
  }
  if (images) {
    body.querySelectorAll("img[src]").forEach((img) => {
      const id = img.getAttribute("src").match(DATAVERSE_IMAGE)?.[1];
      if (id) img.setAttribute("src", images.display(id));
    });
  }
  return { wrapper, body: body.innerHTML };
}
function storeEditorHtml(editorHtml, wrapper, isEmpty) {
  if (isEmpty) return null;
  const container = parse(editorHtml);
  container.querySelectorAll("img[src]").forEach((img) => {
    const id = img.getAttribute("src").match(PORTAL_IMAGE)?.[1];
    if (id) img.setAttribute("src", dataverseImageAddress(id));
  });
  container.querySelectorAll("td, th, li").forEach((cell) => {
    const only = cell.children.length === 1 ? cell.firstElementChild : null;
    if (only?.tagName === "P" && isPlainParagraph(only) && cell.childNodes.length === 1) {
      only.replaceWith(...Array.from(only.childNodes));
    }
  });
  const attributes = Object.entries(wrapper).map(([name, value2]) => `${name}="${escapeAttribute(value2)}"`).join(" ");
  return `<div ${attributes}>${container.innerHTML}</div>`;
}
function isPlainParagraph(paragraph) {
  return Array.from(paragraph.attributes).every(
    (attribute) => attribute.name === "style" && parseStyle(attribute.value).every((d) => /^margin(-\w+)?$/.test(d.property) && /^0(px)?(\s+0(px)?)*$/.test(d.value))
  );
}
function richTextToPlainText(value2) {
  if (!value2) return "";
  if (!looksLikeHtml(value2)) return value2;
  const container = parse(value2);
  container.querySelectorAll("script, style, template").forEach((hidden) => hidden.remove());
  container.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));
  container.querySelectorAll("p, div, li, h1, h2, h3, h4, h5, h6, blockquote, tr, pre").forEach((block) => {
    block.append("\n");
  });
  container.querySelectorAll("td, th").forEach((cell) => cell.append("	"));
  return (container.textContent ?? "").replace(/\u00a0/g, " ").split("\n").map((line) => line.replace(/[ \t]+$/g, "").replace(/^[ \t]+/g, "")).join("\n").replace(/\n{2,}/g, "\n").trim();
}
function isRichTextValue(value2, metadata) {
  if (metadata?.$type === 14) return false;
  if (metadata?.$type === 7 && metadata.format === RICH_TEXT_FORMAT) return true;
  return looksLikeHtml(value2);
}
var RICH_TEXT_FORMAT = 2;
function looksLikeHtml(value2) {
  return /^\s*<\/?[a-z][\s\S]*?>/i.test(value2);
}
function plainTextToHtml(text2) {
  return text2.replace(/\r\n?/g, "\n").split("\n").map((line) => `<p>${escapeText(line)}</p>`).join("");
}
function parse(html) {
  const inert = document.implementation.createHTMLDocument("");
  const container = inert.createElement("div");
  container.innerHTML = html;
  return container;
}
function singleWrapper(container) {
  const elements = Array.from(container.childNodes).filter(
    (node) => !(node.nodeType === 3 && node.textContent.trim() === "")
  );
  const only = elements.length === 1 ? elements[0] : null;
  return only?.nodeType === 1 && only.tagName === "DIV" && only.getAttribute("data-wrapper") === "true" ? only : null;
}
function escapeText(value2) {
  return value2.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function escapeAttribute(value2) {
  return escapeText(value2).replace(/"/g, "&quot;");
}
var schema;
function renderRichText(value2, images, direction = "ltr") {
  const opened = openStoredHtml(value2, images, direction);
  if (opened.body === "") return { html: "", wrapper: opened.wrapper };
  const inert = document.implementation.createHTMLDocument("");
  const source = inert.createElement("div");
  source.innerHTML = opened.body;
  schema ??= getSchema(createRichTextExtensions());
  const content = DOMParser$1.fromSchema(schema).parse(source).content;
  const target = inert.createElement("div");
  target.appendChild(DOMSerializer.fromSchema(schema).serializeFragment(content, { document: inert }));
  return { html: target.innerHTML, wrapper: opened.wrapper };
}

// src/rich-edit/core/styles.ts
var CSS = `
.ppp-rich-edit {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
  background-color: var(--colorNeutralBackground1);
  border: var(--strokeWidthThin) solid var(--colorNeutralStroke1);
  border-bottom-color: var(--colorNeutralStrokeAccessible);
  border-radius: var(--borderRadiusMedium);
}
.ppp-rich-edit:hover {
  border-color: var(--colorNeutralStroke1Hover);
  border-bottom-color: var(--colorNeutralStrokeAccessibleHover);
}
.ppp-rich-edit::after {
  content: '';
  position: absolute;
  left: calc(var(--strokeWidthThin) * -1);
  right: calc(var(--strokeWidthThin) * -1);
  bottom: calc(var(--strokeWidthThin) * -1);
  height: max(var(--strokeWidthThick), var(--borderRadiusMedium));
  border-bottom-left-radius: var(--borderRadiusMedium);
  border-bottom-right-radius: var(--borderRadiusMedium);
  border-bottom: var(--strokeWidthThick) solid var(--colorCompoundBrandStroke);
  clip-path: inset(calc(100% - var(--strokeWidthThick)) 0 0 0);
  transform: scaleX(0);
  transition: transform var(--durationUltraFast) var(--curveAccelerateMid);
  pointer-events: none;
  box-sizing: border-box;
}
.ppp-rich-edit:focus-within::after {
  transform: scaleX(1);
  transition: transform var(--durationNormal) var(--curveDecelerateMid);
}
.ppp-rich-edit:focus-within:active::after {
  border-bottom-color: var(--colorCompoundBrandStrokePressed);
}
.ppp-rich-edit[data-invalid='true'],
.ppp-rich-edit[data-invalid='true']:hover {
  border-color: var(--colorPaletteRedBorder2);
}
.ppp-rich-edit[data-readonly='true']::after,
.ppp-rich-edit[data-disabled='true']::after {
  display: none;
}
/* Read-only, as the read-only value box: no background, a faint border, text as readable as ever. */
.ppp-rich-edit[data-readonly='true'],
.ppp-rich-edit[data-readonly='true']:hover {
  background-color: var(--colorTransparentBackground);
  border-color: var(--colorNeutralStrokeDisabled);
}
.ppp-rich-edit[data-disabled='true'],
.ppp-rich-edit[data-disabled='true']:hover {
  background-color: var(--colorTransparentBackground);
  border-color: var(--colorNeutralStrokeDisabled);
  color: var(--colorNeutralForegroundDisabled);
  cursor: not-allowed;
}
.ppp-rich-edit-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacingHorizontalXXS);
  padding: var(--spacingVerticalXXS) var(--spacingHorizontalXS);
  border-bottom: var(--strokeWidthThin) solid var(--colorNeutralStroke2);
}
/* A condensed toolbar's button that shows the rest, at its end. */
.ppp-rich-edit-toolbar-expand {
  margin-inline-start: auto;
}
.ppp-rich-edit-divider {
  align-self: stretch;
  flex: none;
  width: var(--strokeWidthThin);
  margin: var(--spacingVerticalXS) var(--spacingHorizontalXS);
  background-color: var(--colorNeutralStroke2);
}
.ppp-rich-edit-content {
  /* Exactly --ppp-rich-edit-rows lines of the document's default text (lh: this element's line
     height), the padding round them whatever the page's own sizing rule is. Never squeezed by the
     field's flex column: a shorter area would scroll a document that should fit. */
  box-sizing: content-box;
  flex: none;
  height: calc(var(--ppp-rich-edit-rows, 10) * 1lh);
  overflow: auto;
  padding: var(--spacingVerticalS) var(--spacingHorizontalM);
  color: var(--colorNeutralForeground1);
  font-family: var(--fontFamilyBase);
  font-size: var(--fontSizeBase300);
  /* Fluent's body ratio (lineHeightBase300 / fontSizeBase300, 20px / 14px), as a ratio so a
     document's default font \u2014 and any larger text in it \u2014 keeps its lines apart. */
  line-height: 1.4286;
  cursor: text;
}
/* AutoFitHeight: as tall as its content, from one line up to the rows, then scrolling. */
.ppp-rich-edit[data-auto-fit='true'] .ppp-rich-edit-content {
  height: auto;
  min-height: 1lh;
  max-height: calc(var(--ppp-rich-edit-rows, 10) * 1lh);
}
.ppp-rich-edit[data-disabled='true'] .ppp-rich-edit-content {
  color: var(--colorNeutralForegroundDisabled);
  cursor: not-allowed;
}
.ppp-rich-edit-content .ProseMirror {
  outline: none;
  /* Fills the editing area, so a click anywhere in it reaches the document \u2014 and no more than
     fills it: the space inside, not the area's whole height, and its children's margins kept
     within it (flow-root), so a document that fits brings up no scroll bar. With AutoFitHeight
     the area has no height of its own, and this is its content's. */
  min-height: 100%;
  display: flow-root;
}
.ppp-rich-edit-content .ProseMirror p.is-editor-empty:first-child {
  position: relative;
}
/* Over the empty first line, cut to fit it: one that wrapped would overflow an editor fitting a
   single empty line. */
.ppp-rich-edit-content .ProseMirror p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  position: absolute;
  top: 0;
  inset-inline: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  color: var(--colorNeutralForeground4);
}
/* A highlight is a fixed color, as in Dynamics: text on it with no color of its own reads in the
   fixed dark text Fluent puts on static surfaces, rather than in the theme's (light, in dark mode).
   Text that has a color keeps it \u2014 an inline style wins over this. */
.ppp-rich-edit-content [style*='background-color'],
.ppp-rich-text-view [style*='background-color'] {
  color: var(--colorNeutralForeground1Static, #242424);
}
.ppp-rich-edit-content a,
.ppp-rich-text-view a {
  color: var(--colorBrandForegroundLink);
}
.ppp-rich-edit-content blockquote,
.ppp-rich-text-view blockquote {
  margin-left: 0;
  margin-right: 0;
  padding-left: var(--spacingHorizontalL);
  padding-right: var(--spacingHorizontalL);
  border-left: var(--strokeWidthThickest) solid var(--colorNeutralStroke1);
  font-style: italic;
  overflow: hidden;
}
.ppp-rich-edit-content img,
.ppp-rich-text-view img {
  max-width: 100%;
  height: auto;
}
.ppp-rich-edit-content img.ProseMirror-selectednode,
.ppp-rich-edit-content [data-resize-container].ProseMirror-selectednode img {
  outline: var(--strokeWidthThick) solid var(--colorBrandStroke1);
}
.ppp-rich-edit-content [data-resize-container] {
  display: inline-flex;
  max-width: 100%;
}
.ppp-rich-edit-content [data-resize-handle] {
  z-index: 1;
  width: var(--spacingHorizontalS);
  height: var(--spacingVerticalS);
  background-color: var(--colorBrandBackground);
  border: var(--strokeWidthThin) solid var(--colorNeutralBackground1);
  border-radius: var(--borderRadiusSmall);
  box-sizing: border-box;
  opacity: 0;
}
.ppp-rich-edit-content [data-resize-container]:hover [data-resize-handle],
.ppp-rich-edit-content [data-resize-container].ProseMirror-selectednode [data-resize-handle],
.ppp-rich-edit-content [data-resize-state='true'] [data-resize-handle] {
  opacity: 1;
}
.ppp-rich-edit-content [data-resize-handle='top-left'],
.ppp-rich-edit-content [data-resize-handle='bottom-right'] {
  cursor: nwse-resize;
}
.ppp-rich-edit-content [data-resize-handle='top-right'],
.ppp-rich-edit-content [data-resize-handle='bottom-left'] {
  cursor: nesw-resize;
}
.ppp-rich-edit-content .tableWrapper,
.ppp-rich-text-view .tableWrapper {
  overflow-x: auto;
}
.ppp-rich-edit-content table,
.ppp-rich-text-view table {
  border-collapse: collapse;
  table-layout: fixed;
}
.ppp-rich-edit-content td,
.ppp-rich-edit-content th,
.ppp-rich-text-view td,
.ppp-rich-text-view th {
  position: relative;
  vertical-align: top;
  box-sizing: border-box;
}
.ppp-rich-edit-content .selectedCell::after {
  content: '';
  position: absolute;
  inset: 0;
  background-color: var(--colorBrandBackground2);
  opacity: 0.6;
  pointer-events: none;
}
.ppp-rich-edit-content .ppp-column-resize-hover::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline-end: calc(var(--spacingHorizontalXXS) * -1);
  width: var(--spacingHorizontalXS);
  background-color: var(--colorBrandStroke1);
  pointer-events: none;
  z-index: 1;
}
.ppp-rich-edit-content .resize-cursor {
  cursor: col-resize;
}
/* A document shown read-only (RichTextView): the editor's text, without its box. */
.ppp-rich-text-view {
  color: var(--colorNeutralForeground1);
  font-family: var(--fontFamilyBase);
  font-size: var(--fontSizeBase300);
  line-height: 1.4286;
  overflow-wrap: anywhere;
}
.ppp-rich-text-view > :first-child {
  margin-top: 0;
}
.ppp-rich-text-view > :last-child {
  margin-bottom: 0;
}
.ppp-rich-edit-message {
  margin-top: var(--spacingVerticalXS);
}
.ppp-rich-edit-format-painter {
  cursor: copy;
}
.ppp-rich-edit-swatches {
  display: grid;
  grid-template-columns: repeat(10, var(--spacingHorizontalXL));
  gap: var(--spacingHorizontalXXS);
}
.ppp-rich-edit-swatch {
  width: var(--spacingHorizontalXL);
  height: var(--spacingVerticalXL);
  padding: 0;
  border: var(--strokeWidthThin) solid var(--colorNeutralStroke1);
  border-radius: var(--borderRadiusSmall);
  cursor: pointer;
}
.ppp-rich-edit-swatch:hover,
.ppp-rich-edit-swatch:focus-visible {
  outline: var(--strokeWidthThick) solid var(--colorBrandStroke1);
  outline-offset: var(--strokeWidthThin);
}
.ppp-rich-edit-link {
  display: flex;
  flex-direction: column;
  gap: var(--spacingVerticalS);
  min-width: min(280px, calc(100vw - var(--spacingHorizontalXXXL)));
}
.ppp-rich-edit-link-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacingHorizontalS);
}
.ppp-rich-edit-table-grid {
  display: grid;
  grid-template-columns: repeat(10, var(--spacingHorizontalL));
  gap: var(--spacingHorizontalXXS);
}
.ppp-rich-edit-table-grid-cell {
  width: var(--spacingHorizontalL);
  height: var(--spacingVerticalL);
  padding: 0;
  border: var(--strokeWidthThin) solid var(--colorNeutralStroke1);
  background-color: var(--colorNeutralBackground1);
  cursor: pointer;
}
.ppp-rich-edit-table-grid-cell[data-selected='true'] {
  background-color: var(--colorBrandBackground2);
  border-color: var(--colorBrandStroke1);
}
`;
var STYLE_ID = "ppp-rich-edit-styles";
function ensureRichTextStyles(doc = document) {
  if (doc.getElementById(STYLE_ID)) return;
  const style = doc.createElement("style");
  style.id = STYLE_ID;
  style.textContent = CSS;
  doc.head.appendChild(style);
}
function wrapperFontStyle(wrapperStyle) {
  const font = {};
  for (const part of (wrapperStyle ?? "").split(";")) {
    const colon = part.indexOf(":");
    if (colon < 0) continue;
    const property = part.slice(0, colon).trim().toLowerCase();
    const value2 = part.slice(colon + 1).trim();
    if (!value2 || /url\s*\(|expression\s*\(|\\/i.test(value2)) continue;
    if (property === "font-family") font.fontFamily = value2;
    else if (property === "font-size") font.fontSize = value2;
  }
  return font;
}
var RICH_TEXT_FONTS = [
  "Arial",
  "Arial Black",
  "Calibri",
  "Calibri Light",
  "Cambria",
  "Candara",
  "Comic Sans MS",
  "Consolas",
  "Constantia",
  "Corbel",
  "Courier New",
  "Franklin Gothic Book",
  "Garamond",
  "Georgia",
  "Impact",
  "Lucida Console",
  "Lucida Sans Unicode",
  "Palatino Linotype",
  "Segoe UI",
  "Tahoma",
  "Times New Roman",
  "Trebuchet MS",
  "Verdana"
];
var RICH_TEXT_FONT_SIZES = [
  "8pt",
  "9pt",
  "10pt",
  "10.5pt",
  "11pt",
  "12pt",
  "14pt",
  "16pt",
  "18pt",
  "20pt",
  "22pt",
  "24pt",
  "26pt",
  "28pt",
  "36pt",
  "48pt",
  "72pt"
];
var RICH_TEXT_COLORS = [
  "#ffffff",
  "#000000",
  "#e7e6e6",
  "#44546a",
  "#4472c4",
  "#ed7d31",
  "#a5a5a5",
  "#ffc000",
  "#5b9bd5",
  "#70ad47",
  "#c00000",
  "#ff0000",
  "#ffc000",
  "#ffff00",
  "#92d050",
  "#00b050",
  "#00b0f0",
  "#0070c0",
  "#002060",
  "#7030a0"
];
function getRichTextState(editor) {
  const textStyle = editor.getAttributes("textStyle");
  const link = editor.getAttributes("link");
  const block = editor.getAttributes(editor.isActive("heading") ? "heading" : "paragraph");
  const can = editor.can();
  return {
    bold: editor.isActive("bold"),
    italic: editor.isActive("italic"),
    underline: editor.isActive("underline"),
    strike: editor.isActive("strike"),
    subscript: editor.isActive("subscript"),
    superscript: editor.isActive("superscript"),
    bulletList: editor.isActive("bulletList"),
    orderedList: editor.isActive("orderedList"),
    blockquote: editor.isActive("blockquote"),
    textAlign: TEXT_ALIGNMENTS.includes(block.textAlign ?? "") ? block.textAlign : null,
    direction: block.dir === "ltr" || block.dir === "rtl" ? block.dir : null,
    fontFamily: textStyle.fontFamily ?? null,
    fontSize: textStyle.fontSize ?? null,
    color: textStyle.color ?? null,
    backgroundColor: textStyle.backgroundColor ?? null,
    link: link.href ? { href: link.href, newWindow: link.target === "_blank" } : null,
    linkText: (() => {
      const { from, to } = linkRange(editor);
      return editor.state.doc.textBetween(from, to, " ");
    })(),
    formatPainter: editor.storage.pppFormatPainter?.marks != null,
    inTable: editor.isActive("table"),
    canMergeCells: editor.state.selection instanceof CellSelection && can.mergeCells(),
    canSplitCell: can.splitCell(),
    canUndo: can.undo(),
    canRedo: can.redo(),
    canIndent: editor.isActive("listItem") ? can.sinkListItem("listItem") : true,
    canOutdent: editor.isActive("listItem") ? true : can.outdent(),
    hasSelection: !editor.state.selection.empty
  };
}
function runRichTextCommand(editor, command) {
  const chain = editor.chain().focus();
  switch (command.name) {
    case "bold":
      chain.toggleBold().run();
      return;
    case "italic":
      chain.toggleItalic().run();
      return;
    case "underline":
      chain.toggleUnderline().run();
      return;
    case "strike":
      chain.toggleStrike().run();
      return;
    case "subscript":
      chain.unsetSuperscript().toggleSubscript().run();
      return;
    case "superscript":
      chain.unsetSubscript().toggleSuperscript().run();
      return;
    case "bulletList":
      chain.toggleBulletList().run();
      return;
    case "orderedList":
      chain.toggleOrderedList().run();
      return;
    case "blockquote":
      chain.toggleBlockquote().run();
      return;
    case "indent":
      chain.indent().run();
      return;
    case "outdent":
      chain.outdent().run();
      return;
    case "undo":
      chain.undo().run();
      return;
    case "redo":
      chain.redo().run();
      return;
    case "removeFormat":
      chain.command(({ tr, state }) => {
        const { from, to } = state.selection;
        Object.values(state.schema.marks).filter((type) => type.name !== "link").forEach((type) => tr.removeMark(from, to, type));
        return true;
      }).run();
      return;
    case "formatPainter":
      chain.toggleFormatPainter().run();
      return;
    case "textAlign":
      chain.setTextAlign(command.value).run();
      return;
    case "direction":
      chain.setTextDirection(command.value).run();
      return;
    case "fontFamily":
      (command.value ? chain.setFontFamily(command.value) : chain.unsetFontFamily()).removeEmptyTextStyle().run();
      return;
    case "fontSize":
      (command.value ? chain.setFontSize(command.value) : chain.unsetFontSize()).removeEmptyTextStyle().run();
      return;
    case "color":
      (command.value ? chain.setColor(command.value) : chain.unsetColor()).removeEmptyTextStyle().run();
      return;
    case "backgroundColor":
      (command.value ? chain.setBackgroundColor(command.value) : chain.unsetBackgroundColor()).removeEmptyTextStyle().run();
      return;
    case "setLink": {
      const href = command.href.trim();
      if (!href) {
        chain.extendMarkRange("link").unsetLink().run();
        return;
      }
      const attributes = { href, target: command.newWindow ? "_blank" : null };
      const { from, to } = linkRange(editor);
      const current = editor.state.doc.textBetween(from, to, " ");
      const text2 = command.text?.trim() ? command.text : current || href;
      if (from < to && text2 === current) {
        chain.setTextSelection({ from, to }).setLink(attributes).run();
      } else {
        const kept = from < to ? editor.state.doc.nodeAt(from)?.marks ?? [] : editor.state.selection.$from.marks();
        const marks = [
          ...kept.filter((mark) => mark.type.name !== "link").map((mark) => mark.toJSON()),
          { type: "link", attrs: attributes }
        ];
        chain.insertContentAt({ from, to }, { type: "text", text: text2, marks }).run();
      }
      return;
    }
    case "unsetLink":
      chain.extendMarkRange("link").unsetLink().run();
      return;
    case "pickImage":
      pickImageFiles(editor);
      return;
    case "insertTable":
      chain.insertTable({ rows: command.rows, cols: command.columns, withHeaderRow: false }).run();
      applyNewTableStyle(editor);
      return;
    case "addRowBefore":
      chain.addRowBefore().run();
      return;
    case "addRowAfter":
      chain.addRowAfter().run();
      return;
    case "addColumnBefore":
      chain.addColumnBefore().run();
      return;
    case "addColumnAfter":
      chain.addColumnAfter().run();
      return;
    case "deleteRow":
      chain.deleteRow().run();
      return;
    case "deleteColumn":
      chain.deleteColumn().run();
      return;
    case "deleteTable":
      chain.deleteTable().run();
      return;
    case "mergeCells":
      chain.mergeCells().run();
      return;
    case "splitCell":
      chain.splitCell().run();
      return;
    case "toggleHeaderRow":
      chain.toggleHeaderRow().run();
      return;
  }
}
function linkRange(editor) {
  const { state } = editor;
  const { from, to, $from } = state.selection;
  const linkType = state.schema.marks.link;
  if (linkType && editor.isActive("link")) {
    const range = getMarkRange($from, linkType) ?? getMarkRange(state.doc.resolve(Math.max(0, from - 1)), linkType);
    if (range) return range;
  }
  return { from, to };
}
var NEW_TABLE_STYLE = "border-collapse: collapse; border: 1px double #b3b3b3; width: 100%;";
var NEW_CELL_STYLE = "border: 1px solid #bfbfbf; padding: .4em; min-width: 2em; vertical-align: middle;";
function applyNewTableStyle(editor) {
  const { state } = editor;
  const { $from } = state.selection;
  for (let depth = $from.depth; depth > 0; depth--) {
    const node = $from.node(depth);
    if (node.type.name !== "table") continue;
    if (node.attrs.style) return;
    const tablePos = $from.before(depth);
    const tr = state.tr.setNodeMarkup(tablePos, void 0, { ...node.attrs, style: NEW_TABLE_STYLE });
    node.descendants((cell, pos) => {
      if (cell.type.name === "tableCell" || cell.type.name === "tableHeader") {
        tr.setNodeMarkup(tablePos + 1 + pos, void 0, { ...cell.attrs, style: NEW_CELL_STYLE });
        return false;
      }
      return true;
    });
    editor.view.dispatch(tr);
    return;
  }
}
function pickImageFiles(editor) {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = RICH_TEXT_IMAGE_TYPES.join(",");
  input.multiple = true;
  input.addEventListener("change", () => {
    const files = Array.from(input.files ?? []);
    if (files.length > 0) editor.commands.insertImageFiles(files);
  });
  input.click();
}

// src/rich-edit/core/index.ts
var RICH_TEXT_IMAGE_TABLE = "msdyn_richtextfile";
var RICH_TEXT_IMAGE_COLUMN = "msdyn_imageblob";
var RichEditToolbarMode = {
  Full: "full",
  Condensed: "condensed"
};
var RichEditToolbarButton = {
  Undo: "undo",
  Redo: "redo",
  FormatPainter: "formatPainter",
  Font: "font",
  FontSize: "fontSize",
  Bold: "bold",
  Italic: "italic",
  Underline: "underline",
  Strikethrough: "strikethrough",
  HighlightColor: "highlightColor",
  TextColor: "textColor",
  BulletedList: "bulletedList",
  NumberedList: "numberedList",
  DecreaseIndent: "decreaseIndent",
  IncreaseIndent: "increaseIndent",
  Blockquote: "blockquote",
  AlignLeft: "alignLeft",
  AlignCenter: "alignCenter",
  AlignRight: "alignRight",
  Link: "link",
  RemoveLink: "removeLink",
  Subscript: "subscript",
  Superscript: "superscript",
  Image: "image",
  LeftToRight: "leftToRight",
  RightToLeft: "rightToLeft",
  RemoveFormatting: "removeFormatting",
  Table: "table"
};
var B = RichEditToolbarButton;
var TOOLBAR_GROUPS = [
  [B.Undo, B.Redo],
  [B.FormatPainter, B.Font, B.FontSize],
  [B.Bold, B.Italic, B.Underline, B.Strikethrough, B.HighlightColor, B.TextColor],
  [B.BulletedList, B.NumberedList, B.DecreaseIndent, B.IncreaseIndent, B.Blockquote],
  [B.AlignLeft, B.AlignCenter, B.AlignRight],
  [B.Link, B.RemoveLink, B.Subscript, B.Superscript, B.Image, B.LeftToRight, B.RightToLeft, B.RemoveFormatting, B.Table]
];
var DEFAULT_CONDENSED_TOOLBAR_BUTTONS = [
  B.Undo,
  B.Redo,
  B.Bold,
  B.Italic,
  B.Underline,
  B.Strikethrough,
  B.HighlightColor,
  B.TextColor,
  B.BulletedList,
  B.NumberedList,
  B.Link,
  B.RemoveLink
];
function Tip({ label, children }) {
  return /* @__PURE__ */ jsx(Tooltip, { content: label, relationship: "label", withArrow: true, children });
}
function RichEditToolbar({
  state,
  run,
  allowImages,
  defaultFont,
  defaultFontSize,
  mode,
  condensedButtons: chosenCondensedButtons,
  buttons
}) {
  const condensedButtons = chosenCondensedButtons?.length ? chosenCondensedButtons : DEFAULT_CONDENSED_TOOLBAR_BUTTONS;
  const t = usePrefixedT("app.components.rich-edit");
  const [expanded, setExpanded] = useState(false);
  const condensed = mode === RichEditToolbarMode.Condensed && !expanded;
  const offers = (button) => (button !== B.Image || allowImages) && (!buttons?.length || buttons.includes(button));
  const shows = (button) => offers(button) && (!condensed || condensedButtons.includes(button));
  const hasMoreButtons = TOOLBAR_GROUPS.some(
    (group) => group.some((button) => offers(button) && !condensedButtons.includes(button))
  );
  useEffect(() => {
    if (mode !== RichEditToolbarMode.Condensed || !hasMoreButtons) setExpanded(false);
  }, [mode, hasMoreButtons]);
  const showsDividerBefore = (group) => TOOLBAR_GROUPS[group].some(shows) && TOOLBAR_GROUPS.slice(0, group).some((earlier) => earlier.some(shows));
  const painterShown = shows(B.FormatPainter);
  const turningPainterOff = useRef(false);
  useEffect(() => {
    if (!state.formatPainter) turningPainterOff.current = false;
    else if (!painterShown && !turningPainterOff.current) {
      turningPainterOff.current = true;
      run({ name: "formatPainter" });
    }
  }, [painterShown, state.formatPainter, run]);
  const checkedValues = {
    format: [
      state.bold && "bold",
      state.italic && "italic",
      state.underline && "underline",
      state.strike && "strike",
      state.subscript && "subscript",
      state.superscript && "superscript"
    ].filter((name) => !!name),
    block: [
      state.bulletList && "bulletList",
      state.orderedList && "orderedList",
      state.blockquote && "blockquote"
    ].filter((name) => !!name),
    painter: state.formatPainter ? ["formatPainter"] : [],
    align: state.textAlign ? [state.textAlign] : [],
    direction: state.direction ? [state.direction] : []
  };
  const onCheckedValueChange = (_, { name, checkedItems }) => {
    if (name === "align") {
      const value2 = checkedItems[0];
      if (value2 === "left" || value2 === "center" || value2 === "right" || value2 === "justify") {
        run({ name: "textAlign", value: value2 });
      }
      return;
    }
    if (name === "direction") {
      const value2 = checkedItems[0];
      if (value2 === "ltr" || value2 === "rtl") run({ name: "direction", value: value2 });
      return;
    }
    const before = new Set(checkedValues[name] ?? []);
    const after = new Set(checkedItems);
    const pressed = [...before].find((v) => !after.has(v)) ?? [...after].find((v) => !before.has(v));
    if (pressed) run({ name: pressed });
  };
  return /* @__PURE__ */ jsxs(
    Toolbar,
    {
      "aria-label": t("toolbar"),
      size: "small",
      className: "ppp-rich-edit-toolbar",
      checkedValues,
      onCheckedValueChange,
      children: [
        shows(RichEditToolbarButton.Undo) && /* @__PURE__ */ jsx(Tip, { label: t("undo"), children: /* @__PURE__ */ jsx(ToolbarButton, { icon: /* @__PURE__ */ jsx(ArrowUndo20Regular, {}), disabled: !state.canUndo, onClick: () => run({ name: "undo" }) }) }),
        shows(RichEditToolbarButton.Redo) && /* @__PURE__ */ jsx(Tip, { label: t("redo"), children: /* @__PURE__ */ jsx(ToolbarButton, { icon: /* @__PURE__ */ jsx(ArrowRedo20Regular, {}), disabled: !state.canRedo, onClick: () => run({ name: "redo" }) }) }),
        showsDividerBefore(1) && /* @__PURE__ */ jsx(ToolbarDivider, {}),
        shows(RichEditToolbarButton.FormatPainter) && /* @__PURE__ */ jsx(Tip, { label: t("format-painter"), children: /* @__PURE__ */ jsx(ToolbarToggleButton, { icon: /* @__PURE__ */ jsx(PaintBrush20Regular, {}), name: "painter", value: "formatPainter" }) }),
        shows(RichEditToolbarButton.Font) && /* @__PURE__ */ jsx(
          ValueMenu,
          {
            label: t("font"),
            icon: /* @__PURE__ */ jsx(TextFont20Regular, {}),
            current: state.fontFamily ?? defaultFont,
            values: RICH_TEXT_FONTS,
            defaultLabel: t("default-font"),
            onSelect: (value2) => run({ name: "fontFamily", value: value2 }),
            renderValue: (value2) => /* @__PURE__ */ jsx("span", { style: { fontFamily: value2 }, children: value2 })
          }
        ),
        shows(RichEditToolbarButton.FontSize) && /* @__PURE__ */ jsx(
          ValueMenu,
          {
            label: t("font-size"),
            icon: /* @__PURE__ */ jsx(TextFontSize20Regular, {}),
            current: state.fontSize ?? defaultFontSize,
            values: RICH_TEXT_FONT_SIZES,
            defaultLabel: t("default-font-size"),
            onSelect: (value2) => run({ name: "fontSize", value: value2 }),
            renderValue: (value2) => value2.replace(/pt$/, "")
          }
        ),
        showsDividerBefore(2) && /* @__PURE__ */ jsx(ToolbarDivider, {}),
        shows(RichEditToolbarButton.Bold) && /* @__PURE__ */ jsx(Tip, { label: t("bold"), children: /* @__PURE__ */ jsx(ToolbarToggleButton, { icon: /* @__PURE__ */ jsx(TextBold20Regular, {}), name: "format", value: "bold" }) }),
        shows(RichEditToolbarButton.Italic) && /* @__PURE__ */ jsx(Tip, { label: t("italic"), children: /* @__PURE__ */ jsx(ToolbarToggleButton, { icon: /* @__PURE__ */ jsx(TextItalic20Regular, {}), name: "format", value: "italic" }) }),
        shows(RichEditToolbarButton.Underline) && /* @__PURE__ */ jsx(Tip, { label: t("underline"), children: /* @__PURE__ */ jsx(ToolbarToggleButton, { icon: /* @__PURE__ */ jsx(TextUnderline20Regular, {}), name: "format", value: "underline" }) }),
        shows(RichEditToolbarButton.Strikethrough) && /* @__PURE__ */ jsx(Tip, { label: t("strikethrough"), children: /* @__PURE__ */ jsx(ToolbarToggleButton, { icon: /* @__PURE__ */ jsx(TextStrikethrough20Regular, {}), name: "format", value: "strike" }) }),
        shows(RichEditToolbarButton.HighlightColor) && /* @__PURE__ */ jsx(
          ColorPicker,
          {
            label: t("highlight-color"),
            icon: /* @__PURE__ */ jsx(Highlight20Regular, {}),
            clearLabel: t("no-color"),
            current: state.backgroundColor,
            onSelect: (value2) => run({ name: "backgroundColor", value: value2 })
          }
        ),
        shows(RichEditToolbarButton.TextColor) && /* @__PURE__ */ jsx(
          ColorPicker,
          {
            label: t("text-color"),
            icon: /* @__PURE__ */ jsx(TextColor20Regular, {}),
            clearLabel: t("automatic-color"),
            current: state.color,
            onSelect: (value2) => run({ name: "color", value: value2 })
          }
        ),
        showsDividerBefore(3) && /* @__PURE__ */ jsx(ToolbarDivider, {}),
        shows(RichEditToolbarButton.BulletedList) && /* @__PURE__ */ jsx(Tip, { label: t("bullet-list"), children: /* @__PURE__ */ jsx(ToolbarToggleButton, { icon: /* @__PURE__ */ jsx(TextBulletListLtr20Regular, {}), name: "block", value: "bulletList" }) }),
        shows(RichEditToolbarButton.NumberedList) && /* @__PURE__ */ jsx(Tip, { label: t("numbered-list"), children: /* @__PURE__ */ jsx(ToolbarToggleButton, { icon: /* @__PURE__ */ jsx(TextNumberListLtr20Regular, {}), name: "block", value: "orderedList" }) }),
        shows(RichEditToolbarButton.DecreaseIndent) && /* @__PURE__ */ jsx(Tip, { label: t("decrease-indent"), children: /* @__PURE__ */ jsx(
          ToolbarButton,
          {
            icon: /* @__PURE__ */ jsx(TextIndentDecreaseLtr20Regular, {}),
            disabled: !state.canOutdent,
            onClick: () => run({ name: "outdent" })
          }
        ) }),
        shows(RichEditToolbarButton.IncreaseIndent) && /* @__PURE__ */ jsx(Tip, { label: t("increase-indent"), children: /* @__PURE__ */ jsx(
          ToolbarButton,
          {
            icon: /* @__PURE__ */ jsx(TextIndentIncreaseLtr20Regular, {}),
            disabled: !state.canIndent,
            onClick: () => run({ name: "indent" })
          }
        ) }),
        shows(RichEditToolbarButton.Blockquote) && /* @__PURE__ */ jsx(Tip, { label: t("blockquote"), children: /* @__PURE__ */ jsx(ToolbarToggleButton, { icon: /* @__PURE__ */ jsx(TextQuote20Regular, {}), name: "block", value: "blockquote" }) }),
        showsDividerBefore(4) && /* @__PURE__ */ jsx(ToolbarDivider, {}),
        shows(RichEditToolbarButton.AlignLeft) && /* @__PURE__ */ jsx(Tip, { label: t("align-left"), children: /* @__PURE__ */ jsx(ToolbarRadioButton, { icon: /* @__PURE__ */ jsx(TextAlignLeft20Regular, {}), name: "align", value: "left" }) }),
        shows(RichEditToolbarButton.AlignCenter) && /* @__PURE__ */ jsx(Tip, { label: t("align-center"), children: /* @__PURE__ */ jsx(ToolbarRadioButton, { icon: /* @__PURE__ */ jsx(TextAlignCenter20Regular, {}), name: "align", value: "center" }) }),
        shows(RichEditToolbarButton.AlignRight) && /* @__PURE__ */ jsx(Tip, { label: t("align-right"), children: /* @__PURE__ */ jsx(ToolbarRadioButton, { icon: /* @__PURE__ */ jsx(TextAlignRight20Regular, {}), name: "align", value: "right" }) }),
        showsDividerBefore(5) && /* @__PURE__ */ jsx(ToolbarDivider, {}),
        shows(RichEditToolbarButton.Link) && /* @__PURE__ */ jsx(LinkEditor, { state, run }),
        shows(RichEditToolbarButton.RemoveLink) && /* @__PURE__ */ jsx(Tip, { label: t("remove-link"), children: /* @__PURE__ */ jsx(ToolbarButton, { icon: /* @__PURE__ */ jsx(LinkDismiss20Regular, {}), disabled: !state.link, onClick: () => run({ name: "unsetLink" }) }) }),
        shows(RichEditToolbarButton.Subscript) && /* @__PURE__ */ jsx(Tip, { label: t("subscript"), children: /* @__PURE__ */ jsx(ToolbarToggleButton, { icon: /* @__PURE__ */ jsx(TextSubscript20Regular, {}), name: "format", value: "subscript" }) }),
        shows(RichEditToolbarButton.Superscript) && /* @__PURE__ */ jsx(Tip, { label: t("superscript"), children: /* @__PURE__ */ jsx(ToolbarToggleButton, { icon: /* @__PURE__ */ jsx(TextSuperscript20Regular, {}), name: "format", value: "superscript" }) }),
        shows(RichEditToolbarButton.Image) && /* @__PURE__ */ jsx(Tip, { label: t("image"), children: /* @__PURE__ */ jsx(ToolbarButton, { icon: /* @__PURE__ */ jsx(Image20Regular, {}), onClick: () => run({ name: "pickImage" }) }) }),
        shows(RichEditToolbarButton.LeftToRight) && /* @__PURE__ */ jsx(Tip, { label: t("left-to-right"), children: /* @__PURE__ */ jsx(ToolbarRadioButton, { icon: /* @__PURE__ */ jsx(TextParagraphDirectionRight20Regular, {}), name: "direction", value: "ltr" }) }),
        shows(RichEditToolbarButton.RightToLeft) && /* @__PURE__ */ jsx(Tip, { label: t("right-to-left"), children: /* @__PURE__ */ jsx(ToolbarRadioButton, { icon: /* @__PURE__ */ jsx(TextParagraphDirectionLeft20Regular, {}), name: "direction", value: "rtl" }) }),
        shows(RichEditToolbarButton.RemoveFormatting) && /* @__PURE__ */ jsx(Tip, { label: t("remove-format"), children: /* @__PURE__ */ jsx(ToolbarButton, { icon: /* @__PURE__ */ jsx(ClearFormatting20Regular, {}), onClick: () => run({ name: "removeFormat" }) }) }),
        shows(RichEditToolbarButton.Table) && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(TableInserter, { run }),
          state.inTable && /* @__PURE__ */ jsx(TableOptions, { state, run })
        ] }),
        mode === RichEditToolbarMode.Condensed && hasMoreButtons && /* @__PURE__ */ jsx(Tip, { label: t(expanded ? "less-formatting" : "more-formatting"), children: /* @__PURE__ */ jsx(
          ToolbarButton,
          {
            className: "ppp-rich-edit-toolbar-expand",
            icon: expanded ? /* @__PURE__ */ jsx(ChevronUp20Regular, {}) : /* @__PURE__ */ jsx(ChevronDown20Regular, {}),
            "aria-expanded": expanded,
            onClick: () => setExpanded(!expanded)
          }
        ) })
      ]
    }
  );
}
function ValueMenu({ label, icon, current, values, defaultLabel, onSelect, renderValue }) {
  return /* @__PURE__ */ jsxs(
    Menu,
    {
      checkedValues: { value: current ? [current] : [] },
      onCheckedValueChange: (_, { checkedItems }) => onSelect(checkedItems[0] === "" ? null : checkedItems[0] ?? null),
      children: [
        /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: label, relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(ToolbarButton, { icon, children: current ? renderValue(current) : defaultLabel }) }) }),
        /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs(MenuList, { children: [
          /* @__PURE__ */ jsx(MenuItemRadio, { name: "value", value: "", children: defaultLabel }),
          values.map((value2) => /* @__PURE__ */ jsx(MenuItemRadio, { name: "value", value: value2, children: renderValue(value2) }, value2))
        ] }) })
      ]
    }
  );
}
function ColorPicker({ label, icon, clearLabel, current, onSelect }) {
  const [open, setOpen] = useState(false);
  const choose2 = (value2) => {
    setOpen(false);
    onSelect(value2);
  };
  return /* @__PURE__ */ jsxs(Popover, { open, onOpenChange: (_, data) => setOpen(data.open), trapFocus: true, withArrow: true, children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: label, relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(ToolbarButton, { icon }) }) }),
    /* @__PURE__ */ jsxs(PopoverSurface, { "aria-label": label, children: [
      /* @__PURE__ */ jsx("div", { className: "ppp-rich-edit-swatches", role: "group", "aria-label": label, children: RICH_TEXT_COLORS.map((color, i) => /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: "ppp-rich-edit-swatch",
          style: { backgroundColor: color },
          "aria-label": color,
          "aria-pressed": current?.toLowerCase() === color,
          onClick: () => choose2(color)
        },
        `${color}-${i}`
      )) }),
      /* @__PURE__ */ jsx(Button, { appearance: "subtle", size: "small", onClick: () => choose2(null), children: clearLabel })
    ] })
  ] });
}
function LinkEditor({ state, run }) {
  const t = usePrefixedT("app.components.rich-edit");
  const [open, setOpen] = useState(false);
  const [href, setHref] = useState("");
  const [text2, setText] = useState("");
  const [newWindow, setNewWindow] = useState(false);
  const apply = () => {
    setOpen(false);
    run({ name: "setLink", href, text: text2, newWindow });
  };
  return /* @__PURE__ */ jsxs(
    Popover,
    {
      open,
      onOpenChange: (_, data) => {
        if (data.open) {
          setHref(state.link?.href ?? "");
          setText(state.linkText);
          setNewWindow(state.link?.newWindow ?? true);
        }
        setOpen(data.open);
      },
      trapFocus: true,
      withArrow: true,
      children: [
        /* @__PURE__ */ jsx(PopoverTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: t("link"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(ToolbarButton, { icon: /* @__PURE__ */ jsx(Link20Regular, {}) }) }) }),
        /* @__PURE__ */ jsx(PopoverSurface, { "aria-label": t("link"), children: /* @__PURE__ */ jsxs(
          "form",
          {
            className: "ppp-rich-edit-link",
            onSubmit: (e) => {
              e.preventDefault();
              apply();
            },
            children: [
              /* @__PURE__ */ jsx(Field, { label: t("link-address"), children: /* @__PURE__ */ jsx(Input, { type: "url", value: href, onChange: (_, data) => setHref(data.value) }) }),
              /* @__PURE__ */ jsx(Field, { label: t("link-text"), children: /* @__PURE__ */ jsx(Input, { value: text2, onChange: (_, data) => setText(data.value) }) }),
              /* @__PURE__ */ jsx(
                Checkbox,
                {
                  label: t("link-new-window"),
                  checked: newWindow,
                  onChange: (_, data) => setNewWindow(data.checked === true)
                }
              ),
              /* @__PURE__ */ jsx("div", { className: "ppp-rich-edit-link-actions", children: /* @__PURE__ */ jsx(Button, { appearance: "primary", type: "submit", children: t("link-apply") }) })
            ]
          }
        ) })
      ]
    }
  );
}
var TABLE_GRID_SIZE = 10;
function TableInserter({ run }) {
  const t = usePrefixedT("app.components.rich-edit");
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState({ rows: 1, columns: 1 });
  const insert = (rows, columns) => {
    setOpen(false);
    run({ name: "insertTable", rows, columns });
  };
  return /* @__PURE__ */ jsxs(Popover, { open, onOpenChange: (_, data) => setOpen(data.open), trapFocus: true, withArrow: true, children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: t("insert-table"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(ToolbarButton, { icon: /* @__PURE__ */ jsx(Table20Regular, {}) }) }) }),
    /* @__PURE__ */ jsxs(PopoverSurface, { "aria-label": t("insert-table"), children: [
      /* @__PURE__ */ jsx("div", { className: "ppp-rich-edit-table-grid", role: "grid", "aria-label": t("insert-table"), children: Array.from({ length: TABLE_GRID_SIZE * TABLE_GRID_SIZE }, (_, i) => {
        const rows = Math.floor(i / TABLE_GRID_SIZE) + 1;
        const columns = i % TABLE_GRID_SIZE + 1;
        const label = t("table-size", [String(rows), String(columns)]);
        return /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: "ppp-rich-edit-table-grid-cell",
            "data-selected": rows <= size.rows && columns <= size.columns,
            "aria-label": label,
            onMouseEnter: () => setSize({ rows, columns }),
            onFocus: () => setSize({ rows, columns }),
            onClick: () => insert(rows, columns)
          },
          i
        );
      }) }),
      /* @__PURE__ */ jsx("div", { "aria-live": "polite", children: t("table-size", [String(size.rows), String(size.columns)]) })
    ] })
  ] });
}
function TableOptions({ state, run }) {
  const t = usePrefixedT("app.components.rich-edit");
  return /* @__PURE__ */ jsxs(Menu, { children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: t("table-options"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(ToolbarButton, { icon: /* @__PURE__ */ jsx(TableSettings20Regular, {}) }) }) }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs(MenuList, { children: [
      /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TableInsertRow20Regular, {}), onClick: () => run({ name: "addRowBefore" }), children: t("add-row-above") }),
      /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TableInsertRow20Regular, {}), onClick: () => run({ name: "addRowAfter" }), children: t("add-row-below") }),
      /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TableInsertColumn20Regular, {}), onClick: () => run({ name: "addColumnBefore" }), children: t("add-column-left") }),
      /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TableInsertColumn20Regular, {}), onClick: () => run({ name: "addColumnAfter" }), children: t("add-column-right") }),
      /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TableDeleteRow20Regular, {}), onClick: () => run({ name: "deleteRow" }), children: t("delete-row") }),
      /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TableDeleteColumn20Regular, {}), onClick: () => run({ name: "deleteColumn" }), children: t("delete-column") }),
      /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TableCellsMerge20Regular, {}), disabled: !state.canMergeCells, onClick: () => run({ name: "mergeCells" }), children: t("merge-cells") }),
      /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TableCellsSplit20Regular, {}), disabled: !state.canSplitCell, onClick: () => run({ name: "splitCell" }), children: t("split-cell") }),
      /* @__PURE__ */ jsx(MenuItem, { onClick: () => run({ name: "toggleHeaderRow" }), children: t("header-row") }),
      /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TableDismiss20Regular, {}), onClick: () => run({ name: "deleteTable" }), children: t("delete-table") })
    ] }) })
  ] });
}

// src/edits/base/file-helpers.ts
var EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== "string") {
        reject(new Error("FileReader returned non-string result."));
        return;
      }
      const commaIndex = result.indexOf(",");
      resolve(commaIndex >= 0 ? result.substring(commaIndex + 1) : result);
    };
    reader.onerror = () => reject(reader.error ?? new Error("FileReader error"));
    reader.readAsDataURL(file);
  });
}
function base64ToBytes(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}
async function fetchFileBytes(ppp, tableName, recordId, columnName) {
  if (!tableName || !recordId) return null;
  const info = await ppp.getFileInfoAsync(tableName, recordId, columnName, true);
  if (!info.fileData) return null;
  return base64ToBytes(info.fileData);
}
function triggerBlobDownload(bytes, fileName) {
  const blob = new Blob([bytes.buffer]);
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
function guessImageMimeType(fileName) {
  const ext = fileName.toLowerCase().split(".").pop() ?? "";
  switch (ext) {
    case "png":
      return "image/png";
    case "gif":
      return "image/gif";
    case "webp":
      return "image/webp";
    case "svg":
      return "image/svg+xml";
    case "bmp":
      return "image/bmp";
    case "jpg":
    case "jpeg":
    default:
      return "image/jpeg";
  }
}
function bytesToText(bytes) {
  return new TextDecoder("utf-8").decode(bytes);
}
function base64ToText(base64) {
  return bytesToText(base64ToBytes(base64));
}
function getFileExtension(fileName) {
  if (!fileName) return "";
  const lastDot = fileName.lastIndexOf(".");
  if (lastDot < 0 || lastDot === fileName.length - 1) return "";
  return fileName.slice(lastDot + 1).toLowerCase();
}
function getMimeFromFileName(fileName) {
  const ext = getFileExtension(fileName);
  switch (ext) {
    case "png":
      return "image/png";
    case "gif":
      return "image/gif";
    case "webp":
      return "image/webp";
    case "svg":
      return "image/svg+xml";
    case "bmp":
      return "image/bmp";
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "pdf":
      return "application/pdf";
    case "html":
    case "htm":
      return "text/html";
    case "md":
    case "markdown":
      return "text/markdown";
    case "json":
      return "application/json";
    case "xml":
      return "application/xml";
    case "csv":
      return "text/csv";
    case "txt":
    case "log":
      return "text/plain";
    case "zip":
      return "application/zip";
    default:
      return "application/octet-stream";
  }
}
function categorizeFile({
  mimeType,
  fileName
}) {
  const mime = (mimeType ?? "").toLowerCase();
  if (mime.startsWith("image/")) return "image";
  if (mime === "text/markdown" || mime === "text/x-markdown") return "markdown";
  if (mime === "application/pdf") return "embedded";
  if (mime === "application/zip" || mime === "application/x-zip-compressed") return "zip";
  const ext = getFileExtension(fileName);
  if (IMAGE_EXTS.has(ext)) return "image";
  if (MARKDOWN_EXTS.has(ext)) return "markdown";
  if (ext === "pdf") return "embedded";
  if (ext === "zip") return "zip";
  if (TEXT_EXTS.has(ext)) return "text";
  if (mime.startsWith("text/") || mime === "application/json" || mime === "application/xml") {
    return "text";
  }
  return "download";
}
var IMAGE_EXTS = /* @__PURE__ */ new Set(["png", "gif", "webp", "svg", "bmp", "jpg", "jpeg", "ico", "avif"]);
var MARKDOWN_EXTS = /* @__PURE__ */ new Set(["md", "markdown"]);
var TEXT_EXTS = /* @__PURE__ */ new Set([
  "txt",
  "log",
  "csv",
  "tsv",
  "json",
  "xml",
  "yaml",
  "yml",
  "toml",
  "ini",
  "js",
  "jsx",
  "mjs",
  "cjs",
  "ts",
  "tsx",
  "html",
  "htm",
  "css",
  "scss",
  "less",
  "cs",
  "vb",
  "fs",
  "razor",
  "cshtml",
  "vbhtml",
  "csproj",
  "vbproj",
  "fsproj",
  "sln",
  "py",
  "rb",
  "go",
  "rs",
  "java",
  "kt",
  "swift",
  "php",
  "pl",
  "lua",
  "sql",
  "sh",
  "bash",
  "ps1",
  "cmd",
  "bat",
  "config",
  "props",
  "targets"
]);
function getHighlightLanguage(fileName) {
  const ext = getFileExtension(fileName);
  switch (ext) {
    case "js":
    case "mjs":
    case "cjs":
    case "jsx":
      return "javascript";
    case "ts":
    case "tsx":
      return "typescript";
    case "json":
      return "json";
    case "html":
    case "htm":
    case "xml":
    case "csproj":
    case "vbproj":
    case "fsproj":
    case "config":
    case "props":
    case "targets":
    case "razor":
    case "cshtml":
    case "vbhtml":
      return "xml";
    case "css":
    case "scss":
    case "less":
      return "css";
    case "yaml":
    case "yml":
      return "yaml";
    case "cs":
      return "csharp";
    case "md":
    case "markdown":
      return "markdown";
    case "csv":
    case "tsv":
    case "log":
    case "txt":
    default:
      return "plaintext";
  }
}

// src/rich-edit/use-rich-text-images.ts
var richTextImageAddresses = {
  display: (id) => Routes.api.getRetrieveFullImageRoute(RICH_TEXT_IMAGE_TABLE, id, RICH_TEXT_IMAGE_COLUMN)
};
function useRichTextImageUpload() {
  const { ppp } = usePowerPortalsPro();
  return useMemo(
    () => async (file) => {
      const permissions = await ppp.retrieveTablePermissionsAsync(RICH_TEXT_IMAGE_TABLE);
      const needed = TableSecurityPermission.Create | TableSecurityPermission.Read;
      if ((permissions & needed) !== needed) return null;
      const { id } = await ppp.createRecordAsync({
        tableName: RICH_TEXT_IMAGE_TABLE,
        properties: {
          msdyn_name: { $type: 14, value: file.name },
          [RICH_TEXT_IMAGE_COLUMN]: {
            $type: "FileValue",
            fileName: file.name,
            id: EMPTY_GUID,
            value: await readFileAsBase64(file)
          }
        }
      });
      return richTextImageAddresses.display(id);
    },
    [ppp]
  );
}
var VALUE_DELAY_MS = 250;
function RichEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  minLength,
  maxLength,
  rows = 10,
  autoFitHeight = false,
  placeholder,
  displayToolbar = true,
  toolbarMode = RichEditToolbarMode.Full,
  condensedToolbarButtons,
  toolbarButtons,
  allowImages = true,
  validate
}) {
  ensureRichTextStyles();
  const { value: value2, setValue: rawSetValue } = useStringColumn(columnName);
  const { record, registerPendingEdit, notifyPendingEditChanged } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const t = useT();
  const [imageError, setImageError] = useState(null);
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedMaxLength = maxLength ?? getStringMaxLength(metadata);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const editable = !resolvedReadOnly && !resolvedDisabled;
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const minLengthValidator = useCallback(() => {
    if (minLength === void 0 || !value2) return [];
    return richTextToPlainText(value2).length < minLength ? [t("app.messages.column-min-length", [minLength])] : [];
  }, [minLength, value2, t]);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "string",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value2 ?? "",
      ...resolvedMaxLength !== void 0 && { maxLength: resolvedMaxLength }
    },
    useCallback(async () => [...minLengthValidator(), ...await validate?.() ?? []], [minLengthValidator, validate])
  );
  const upload = useRichTextImageUpload();
  const onImageError = useCallback(
    (file, reason) => {
      setImageError(t(`app.components.rich-edit.image-${reason}`, [file.name]));
    },
    [t]
  );
  const callbacks = useRef({
    setValue,
    upload,
    onImageError,
    maxLength: resolvedMaxLength,
    notifyPendingEditChanged,
    flush: () => {
    }
  });
  Object.assign(callbacks.current, {
    setValue,
    upload,
    onImageError,
    maxLength: resolvedMaxLength,
    notifyPendingEditChanged
  });
  const opened = useMemo(() => openStoredHtml(value2, richTextImageAddresses), []);
  const wrapper = useRef(opened.wrapper);
  const stored = useRef(value2);
  const editor = useEditor({
    extensions: createRichTextExtensions({
      ...placeholder !== void 0 && { placeholder },
      uploadImage: allowImages ? (file) => callbacks.current.upload(file) : void 0,
      onImageError: (file, reason) => callbacks.current.onImageError(file, reason),
      maxLength: () => callbacks.current.maxLength
    }),
    content: opened.body,
    editable,
    onUpdate: () => {
      const wasPending = pending.current !== void 0;
      window.clearTimeout(pending.current);
      pending.current = window.setTimeout(() => callbacks.current.flush(), VALUE_DELAY_MS);
      if (!wasPending) callbacks.current.notifyPendingEditChanged?.();
    },
    onBlur: () => callbacks.current.flush()
  });
  const pending = useRef(void 0);
  const flush = useCallback(() => {
    if (pending.current === void 0) return;
    window.clearTimeout(pending.current);
    pending.current = void 0;
    if (!editor.isDestroyed) {
      const next = storeEditorHtml(editor.getHTML(), wrapper.current, isRichTextEmpty(editor));
      if (next !== stored.current) {
        stored.current = next;
        callbacks.current.setValue(next);
      }
    }
    callbacks.current.notifyPendingEditChanged?.();
  }, [editor]);
  callbacks.current.flush = flush;
  useEffect(
    () => registerPendingEdit?.({
      isPending: () => pending.current !== void 0,
      apply: async () => flush()
    }),
    [registerPendingEdit, flush]
  );
  useEffect(() => () => flush(), [flush]);
  useEffect(() => {
    if (value2 === stored.current) return;
    window.clearTimeout(pending.current);
    pending.current = void 0;
    const reopened = openStoredHtml(value2, richTextImageAddresses);
    wrapper.current = reopened.wrapper;
    stored.current = value2;
    editor.commands.setContent(reopened.body, { emitUpdate: false });
  }, [editor, value2]);
  useEffect(() => {
    editor.setEditable(editable, false);
  }, [editor, editable]);
  const state = useEditorState({ editor, selector: ({ editor: current }) => getRichTextState(current) });
  const run = useCallback((command) => runRichTextCommand(editor, command), [editor]);
  const toolbarShown = displayToolbar && editable;
  const painterOn = !!state?.formatPainter;
  const turningPainterOff = useRef(false);
  useEffect(() => {
    if (!painterOn) turningPainterOff.current = false;
    else if (!toolbarShown && !turningPainterOff.current) {
      turningPainterOff.current = true;
      run({ name: "formatPainter" });
    }
  }, [toolbarShown, painterOn, run]);
  const fieldValidationProps = buildFieldValidationProps(validationErrors, displayValidationErrorMessage);
  const invalid = "validationState" in fieldValidationProps;
  const font = wrapperFontStyle(wrapper.current.style);
  useLayoutEffect(() => {
    const dom = editor.view.dom;
    dom.setAttribute("role", "textbox");
    dom.setAttribute("aria-multiline", "true");
    dom.setAttribute("aria-label", resolvedLabel);
    toggleAttribute(dom, "aria-required", resolvedRequired);
    toggleAttribute(dom, "aria-invalid", invalid);
    toggleAttribute(dom, "aria-readonly", resolvedReadOnly);
    toggleAttribute(dom, "aria-disabled", resolvedDisabled);
    if (id) dom.id = id;
  }, [editor, resolvedLabel, resolvedRequired, invalid, resolvedReadOnly, resolvedDisabled, id]);
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] }),
    onClick: () => editor.commands.focus()
  } : null;
  const contentStyle = {
    ...font,
    ...font.fontFamily && { fontFamily: `${font.fontFamily}, var(--fontFamilyBase)` },
    "--ppp-rich-edit-rows": rows
  };
  return /* @__PURE__ */ jsxs("div", { className: "ppp-rich-edit-field", children: [
    /* @__PURE__ */ jsx(
      Field,
      {
        className: mergeClasses(layoutClassName, stateClassName),
        label: labelSlot,
        hint: fieldHint,
        required: resolvedRequired,
        ...fieldValidationProps,
        children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: mergeClasses("ppp-rich-edit", className),
            style,
            "data-invalid": invalid,
            "data-readonly": resolvedReadOnly,
            "data-disabled": resolvedDisabled,
            "data-auto-fit": autoFitHeight,
            dir: wrapper.current.dir === "rtl" ? "rtl" : void 0,
            children: [
              displayToolbar && editable && state && /* @__PURE__ */ jsx(
                RichEditToolbar,
                {
                  state,
                  run,
                  allowImages,
                  defaultFont: font.fontFamily,
                  defaultFontSize: font.fontSize,
                  mode: toolbarMode,
                  condensedButtons: condensedToolbarButtons,
                  buttons: toolbarButtons
                }
              ),
              /* @__PURE__ */ jsx(
                EditorContent,
                {
                  editor,
                  className: "ppp-rich-edit-content",
                  style: contentStyle,
                  onClick: (e) => {
                    if (e.target === e.currentTarget) editor.commands.focus("end");
                  }
                }
              )
            ]
          }
        )
      }
    ),
    imageError && /* @__PURE__ */ jsxs(MessageBar, { intent: "error", className: "ppp-rich-edit-message", children: [
      /* @__PURE__ */ jsx(MessageBarBody, { children: imageError }),
      /* @__PURE__ */ jsx(
        MessageBarActions,
        {
          containerAction: /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "transparent",
              "aria-label": t("app.buttons.close.label"),
              icon: /* @__PURE__ */ jsx(Dismiss20Regular, {}),
              onClick: () => setImageError(null)
            }
          )
        }
      )
    ] })
  ] });
}
function toggleAttribute(element, name, on) {
  if (on) element.setAttribute(name, "true");
  else element.removeAttribute(name);
}
function RichTextView({ value: value2, className, style }) {
  ensureRichTextStyles();
  const rendered = useMemo(() => renderRichText(value2, richTextImageAddresses), [value2]);
  const font = wrapperFontStyle(rendered.wrapper["style"]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: mergeClasses("ppp-rich-text-view", className),
      dir: rendered.wrapper["dir"] === "rtl" ? "rtl" : void 0,
      style: {
        ...font,
        ...font.fontFamily && { fontFamily: `${font.fontFamily}, var(--fontFamilyBase)` },
        ...style
      },
      dangerouslySetInnerHTML: { __html: rendered.html }
    }
  );
}

// src/buttons/progress-overlay.ts
function createProgressOverlay(service, targetId) {
  let current = null;
  return {
    show(description) {
      if (!service) return;
      const next = service.show({ targetId, description });
      if (current) service.hide(current);
      current = next;
    },
    close() {
      if (service && current) service.hide(current);
      current = null;
    }
  };
}
function SaveContextButton({
  disabled,
  onBeforeSave,
  onSaved,
  onError,
  label,
  appearance = "subtle"
}) {
  const ctx = useMainContext();
  const validation = useValidationContext();
  const dialog = useDialogService();
  const runWithOverlay = useRunWithOverlay();
  const t = useT();
  const [saving, setSaving] = useState(false);
  const resolvedLabel = label ?? t("app.buttons.save.label");
  const handleClick = useCallback(async () => {
    if (!ctx) return;
    setSaving(true);
    try {
      await ctx.applyPendingEdits?.();
      if (onBeforeSave) await onBeforeSave();
      if (ctx.forceSuccessfulValidationBeforeSave && validation && !await validation.validateAll()) {
        return;
      }
      await runWithOverlay({ description: t("app.messages.record-save") }, () => ctx.saveAll());
      if (onSaved) await onSaved();
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
          title: t("app.errors.record-save")
        });
      }
    } finally {
      setSaving(false);
    }
  }, [ctx, validation, dialog, runWithOverlay, t, onBeforeSave, onSaved, onError]);
  const isDisabled = !ctx || !ctx.isDirty || saving || disabled === true;
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      className: "ppp-save-context-button",
      appearance,
      icon: /* @__PURE__ */ jsx(Save24Regular, {}),
      disabled: isDisabled,
      onClick: handleClick,
      children: resolvedLabel
    }
  );
}
var useStyles2 = makeStyles({
  link: {
    color: tokens.colorBrandForegroundLink,
    textDecorationLine: "none",
    ":hover": {
      color: tokens.colorBrandForegroundLinkHover,
      textDecorationLine: "underline"
    },
    ":focus-visible": {
      color: tokens.colorBrandForegroundLinkHover,
      textDecorationLine: "underline"
    }
  }
});
function followRecordLink(event, url, onNavigate) {
  if (!onNavigate || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  onNavigate(url);
}
function RecordLink({ href, onNavigate, className, children }) {
  const styles = useStyles2();
  return /* @__PURE__ */ jsx(
    "a",
    {
      className: mergeClasses("ppp-record-link", styles.link, className),
      href,
      onClick: (event) => followRecordLink(event, href, onNavigate),
      children
    }
  );
}
function useFileUpload(options) {
  const { setValue, maxFileSizeBytes, enabled, warnPrefix, onUploaded } = options;
  const dialog = useDialogService();
  const t = useT();
  const inputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const handleFileSelected = useCallback(
    async (file) => {
      if (maxFileSizeBytes !== void 0 && file.size > maxFileSizeBytes) {
        console.warn(
          `${warnPrefix}: rejected ${file.name} (${file.size} bytes) \u2014 exceeds maxFileSizeBytes (${maxFileSizeBytes}).`
        );
        await dialog.showErrorAsync(
          t("app.messages.file-upload-max-file-size-error", [maxFileSizeBytes, file.size]),
          { title: t("app.messages.file-upload-max-file-size-error-title") }
        );
        return;
      }
      const base64 = await readFileAsBase64(file);
      setValue({
        fileName: file.name,
        id: EMPTY_GUID,
        value: base64
      });
      onUploaded?.();
    },
    [dialog, maxFileSizeBytes, onUploaded, setValue, t, warnPrefix]
  );
  const onInputChange = useCallback(
    (ev) => {
      const file = ev.target.files?.[0];
      if (file) void handleFileSelected(file);
      ev.target.value = "";
    },
    [handleFileSelected]
  );
  const dropZoneHandlers = useMemo(
    () => ({
      role: "button",
      tabIndex: enabled ? 0 : -1,
      "aria-disabled": !enabled,
      onClick: () => {
        if (enabled) inputRef.current?.click();
      },
      onKeyDown: (ev) => {
        if (!enabled) return;
        if (ev.key === "Enter" || ev.key === " ") {
          ev.preventDefault();
          inputRef.current?.click();
        }
      },
      onDragOver: (ev) => {
        if (!enabled) return;
        ev.preventDefault();
        setIsDragOver(true);
      },
      onDragLeave: () => setIsDragOver(false),
      onDrop: (ev) => {
        if (!enabled) return;
        ev.preventDefault();
        setIsDragOver(false);
        const file = ev.dataTransfer.files?.[0];
        if (file) void handleFileSelected(file);
      }
    }),
    [enabled, handleFileSelected]
  );
  return { inputRef, isDragOver, onInputChange, dropZoneHandlers };
}
var ZOOM_MIN = 0.25;
var ZOOM_MAX = 8;
var ZOOM_STEP = 1.25;
var ImageViewer = forwardRef(function ImageViewer2({
  source,
  alt,
  className,
  style,
  id,
  framed = false,
  toolbar = false,
  downloadable = false,
  fileName,
  onClick,
  fallback,
  croppable = false,
  onCropApplied,
  onDirtyChanged,
  onSave,
  onCancel,
  outputFormat = "auto",
  outputQuality = 0.9
}, ref) {
  const styles = useImageViewerStyles();
  const t = useT();
  const [croppedSource, setCroppedSource] = useState(null);
  const displaySource = croppedSource ?? source;
  const resolvedFileName = fileName ?? extractFileName(displaySource) ?? "image";
  const resolvedAlt = alt ?? resolvedFileName;
  const src = useImageSrc(displaySource);
  const cropEnabled = toolbar && croppable;
  const [angle, setAngle] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const [flipH, setFlipH] = useState(false);
  const [flipV, setFlipV] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showThirds, setShowThirds] = useState(false);
  const [imageLayout, setImageLayout] = useState(null);
  const [baseline, setBaseline] = useState({ angle: 0, flipH: false, flipV: false, croppedSource: null });
  const isDirty = angle !== baseline.angle || flipH !== baseline.flipH || flipV !== baseline.flipV || croppedSource !== baseline.croppedSource;
  const wrapperRef = useRef(null);
  const imageContainerRef = useRef(null);
  const imgRef = useRef(null);
  const [aspectRatio, setAspectRatio] = useState("free");
  const [selection, setSelection] = useState(null);
  const selectionRef = useRef(selection);
  selectionRef.current = selection;
  const prevTransformRef = useRef({ angle, zoom, pan, flipH, flipV });
  const resizingRef = useRef(false);
  const dragRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const zoomRef = useRef(zoom);
  const panRef = useRef(pan);
  const angleRef = useRef(angle);
  const flipHRef = useRef(flipH);
  const flipVRef = useRef(flipV);
  zoomRef.current = zoom;
  panRef.current = pan;
  angleRef.current = angle;
  flipHRef.current = flipH;
  flipVRef.current = flipV;
  useEffect(() => {
    setAngle(0);
    setZoom(1);
    setPan({ x: 0, y: 0 });
    setFlipH(false);
    setFlipV(false);
    setSelection(null);
    setBaseline({ angle: 0, flipH: false, flipV: false, croppedSource: null });
  }, [src]);
  useEffect(() => {
    setCroppedSource(null);
  }, [source]);
  useEffect(() => {
    const prev = prevTransformRef.current;
    const cur = { angle, zoom, pan, flipH, flipV };
    const transformChanged = prev.angle !== cur.angle || prev.zoom !== cur.zoom || prev.pan.x !== cur.pan.x || prev.pan.y !== cur.pan.y || prev.flipH !== cur.flipH || prev.flipV !== cur.flipV;
    if (transformChanged) {
      resizingRef.current = false;
      const sel = selectionRef.current;
      const imgEl = imgRef.current;
      if (sel && imgEl) {
        const natural = containerRectToImageNatural(
          sel,
          imgEl,
          prev.angle,
          prev.zoom,
          prev.pan,
          prev.flipH,
          prev.flipV
        );
        if (natural) {
          const reprojected = imageNaturalRectToContainer(
            natural,
            imgEl,
            cur.angle,
            cur.zoom,
            cur.pan,
            cur.flipH,
            cur.flipV
          );
          if (reprojected) {
            setSelection(reprojected);
          }
        }
      }
    }
    prevTransformRef.current = cur;
  }, [angle, zoom, pan, flipH, flipV]);
  useEffect(() => {
    if (showThirds && imgRef.current) setImageLayout(readImageLayoutMetrics(imgRef.current));
  }, [showThirds]);
  useEffect(() => {
    if (!toolbar) return;
    const container = imageContainerRef.current;
    if (!container) return;
    let prevMetrics = imgRef.current ? readImageLayoutMetrics(imgRef.current) : null;
    const observer = new ResizeObserver(() => {
      const imgEl = imgRef.current;
      if (!imgEl) return;
      const newMetrics = readImageLayoutMetrics(imgEl);
      if (!newMetrics) return;
      const sel = selectionRef.current;
      const layoutChanged = !prevMetrics || prevMetrics.layoutW !== newMetrics.layoutW || prevMetrics.layoutH !== newMetrics.layoutH || prevMetrics.offsetLeft !== newMetrics.offsetLeft || prevMetrics.offsetTop !== newMetrics.offsetTop;
      if (layoutChanged) setImageLayout(newMetrics);
      if (sel && prevMetrics && layoutChanged) {
        const natural = containerRectToImageNatural(
          sel,
          imgEl,
          angleRef.current,
          zoomRef.current,
          panRef.current,
          flipHRef.current,
          flipVRef.current,
          prevMetrics
        );
        if (natural) {
          const reprojected = imageNaturalRectToContainer(
            natural,
            imgEl,
            angleRef.current,
            zoomRef.current,
            panRef.current,
            flipHRef.current,
            flipVRef.current,
            newMetrics
          );
          if (reprojected) {
            resizingRef.current = true;
            setSelection(reprojected);
          }
        }
      }
      prevMetrics = newMetrics;
    });
    observer.observe(container);
    return () => observer.disconnect();
  }, [toolbar]);
  const onDirtyChangedRef = useRef(onDirtyChanged);
  onDirtyChangedRef.current = onDirtyChanged;
  useEffect(() => {
    onDirtyChangedRef.current?.(isDirty);
  }, [isDirty]);
  useEffect(() => {
    if (!toolbar) return;
    const handler = () => {
      setIsFullscreen(document.fullscreenElement === wrapperRef.current);
    };
    document.addEventListener("fullscreenchange", handler);
    return () => document.removeEventListener("fullscreenchange", handler);
  }, [toolbar]);
  useEffect(() => {
    if (!toolbar) return;
    const node = imageContainerRef.current;
    if (!node) return;
    const handler = (e) => {
      e.preventDefault();
      const factor = Math.exp(-e.deltaY * 223e-5);
      const prevZoom = zoomRef.current;
      const nextZoom = Math.min(Math.max(prevZoom * factor, ZOOM_MIN), ZOOM_MAX);
      if (nextZoom === prevZoom) return;
      setZoom(nextZoom);
      if (nextZoom <= 1) {
        setPan({ x: 0, y: 0 });
        return;
      }
      const rect = node.getBoundingClientRect();
      const cursorRelCenterX = e.clientX - (rect.left + rect.width / 2);
      const cursorRelCenterY = e.clientY - (rect.top + rect.height / 2);
      const r = nextZoom / prevZoom;
      const prevPan = panRef.current;
      setPan({
        x: (1 - r) * cursorRelCenterX + r * prevPan.x,
        y: (1 - r) * cursorRelCenterY + r * prevPan.y
      });
    };
    node.addEventListener("wheel", handler, { passive: false });
    return () => node.removeEventListener("wheel", handler);
  }, [toolbar]);
  useEffect(() => {
    if (!toolbar) return;
    wrapperRef.current?.focus();
  }, [toolbar, isFullscreen]);
  useEffect(() => {
    if (!toolbar || !cropEnabled) return;
    const wrapper = wrapperRef.current;
    if (!wrapper) return;
    const handler = (e) => {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      const key3 = e.key;
      if (key3 !== "ArrowUp" && key3 !== "ArrowDown" && key3 !== "ArrowLeft" && key3 !== "ArrowRight") {
        return;
      }
      const sel = selectionRef.current;
      if (!sel) return;
      e.preventDefault();
      e.stopPropagation();
      const step = e.shiftKey ? 10 : 1;
      const dx = key3 === "ArrowLeft" ? -step : key3 === "ArrowRight" ? step : 0;
      const dy = key3 === "ArrowUp" ? -step : key3 === "ArrowDown" ? step : 0;
      const bounds = imgRef.current ? getDisplayedImageBounds(
        imgRef.current,
        angleRef.current,
        zoomRef.current,
        panRef.current,
        flipHRef.current,
        flipVRef.current
      ) : null;
      const rect = imageContainerRef.current?.getBoundingClientRect();
      const cw = rect?.width ?? Number.POSITIVE_INFINITY;
      const ch = rect?.height ?? Number.POSITIVE_INFINITY;
      const minX = Math.max(0, bounds ? bounds.x : 0);
      const minY = Math.max(0, bounds ? bounds.y : 0);
      const maxX = Math.min(cw, bounds ? bounds.x + bounds.w : cw);
      const maxY = Math.min(ch, bounds ? bounds.y + bounds.h : ch);
      setSelection({
        x: Math.max(minX, Math.min(sel.x + dx, maxX - sel.w)),
        y: Math.max(minY, Math.min(sel.y + dy, maxY - sel.h)),
        w: sel.w,
        h: sel.h
      });
    };
    wrapper.addEventListener("keydown", handler, true);
    return () => wrapper.removeEventListener("keydown", handler, true);
  }, [toolbar, cropEnabled]);
  const handleDownload = useCallback(() => {
    if (!displaySource) return;
    void downloadSource(displaySource, resolvedFileName);
  }, [displaySource, resolvedFileName]);
  const handleRotateCw = useCallback(() => setAngle((a) => a + 90), []);
  const handleRotateCcw = useCallback(() => setAngle((a) => a - 90), []);
  const handleZoomIn = useCallback(() => setZoom((z) => Math.min(z * ZOOM_STEP, ZOOM_MAX)), []);
  const handleZoomOut = useCallback(() => {
    setZoom((z) => {
      const next = Math.max(z / ZOOM_STEP, ZOOM_MIN);
      if (next <= 1) setPan({ x: 0, y: 0 });
      return next;
    });
  }, []);
  const handleReset = useCallback(() => {
    const snappedAngle = Math.round(angle / 360) * 360;
    setAngle(snappedAngle);
    setZoom(1);
    setPan({ x: 0, y: 0 });
    setFlipH(false);
    setFlipV(false);
    setSelection(null);
    setCroppedSource(null);
    setBaseline({ angle: snappedAngle, flipH: false, flipV: false, croppedSource: null });
  }, [angle]);
  const handleFlipH = useCallback(() => setFlipH((f) => !f), []);
  const handleFlipV = useCallback(() => setFlipV((f) => !f), []);
  const handleToggleFullscreen = useCallback(() => {
    if (document.fullscreenElement) {
      void document.exitFullscreen();
    } else {
      void wrapperRef.current?.requestFullscreen();
    }
  }, []);
  const aspectValue = aspectRatioToNumber(aspectRatio);
  const onContainerPointerDown = useCallback(
    (e) => {
      if (!toolbar) return;
      if (e.button !== 0) return;
      if (dragRef.current) return;
      if (cropEnabled) {
        e.preventDefault();
        const rect = e.currentTarget.getBoundingClientRect();
        const localX = e.clientX - rect.left;
        const localY = e.clientY - rect.top;
        const sel = selectionRef.current;
        if (sel && localX >= sel.x && localX <= sel.x + sel.w && localY >= sel.y && localY <= sel.y + sel.h) {
          e.currentTarget.setPointerCapture(e.pointerId);
          dragRef.current = {
            kind: "move",
            pointerId: e.pointerId,
            originX: localX,
            originY: localY,
            startSelection: sel,
            imageBounds: imgRef.current ? getDisplayedImageBounds(imgRef.current, angle, zoom, pan, flipH, flipV) : null
          };
          return;
        }
        e.currentTarget.setPointerCapture(e.pointerId);
        dragRef.current = {
          kind: "select",
          pointerId: e.pointerId,
          originX: localX,
          originY: localY,
          moved: false,
          imageBounds: imgRef.current ? getDisplayedImageBounds(imgRef.current, angle, zoom, pan, flipH, flipV) : null
        };
        setSelection({ x: localX, y: localY, w: 0, h: 0 });
        return;
      }
      if (zoom > 1) {
        e.currentTarget.setPointerCapture(e.pointerId);
        dragRef.current = {
          kind: "pan",
          pointerId: e.pointerId,
          startX: e.clientX,
          startY: e.clientY,
          startPan: pan
        };
        setIsDragging(true);
      }
    },
    [toolbar, cropEnabled, zoom, pan, angle, flipH, flipV]
  );
  const onHandlePointerDown = useCallback(
    (e) => {
      if (e.button !== 0) return;
      if (dragRef.current) return;
      const handle = e.currentTarget.dataset.handle;
      if (!handle) return;
      const containerEl = imageContainerRef.current;
      const sel = selectionRef.current;
      if (!containerEl || !sel) return;
      e.stopPropagation();
      e.preventDefault();
      containerEl.setPointerCapture(e.pointerId);
      dragRef.current = {
        kind: "resize",
        pointerId: e.pointerId,
        handle,
        startSelection: sel,
        imageBounds: imgRef.current ? getDisplayedImageBounds(imgRef.current, angle, zoom, pan, flipH, flipV) : null,
        aspectValue
      };
    },
    [angle, zoom, pan, flipH, flipV, aspectValue]
  );
  const onContainerPointerMove = useCallback(
    (e) => {
      const drag2 = dragRef.current;
      if (!drag2 || drag2.pointerId !== e.pointerId) return;
      if (drag2.kind === "pan") {
        setPan({
          x: drag2.startPan.x + (e.clientX - drag2.startX),
          y: drag2.startPan.y + (e.clientY - drag2.startY)
        });
        return;
      }
      if (drag2.kind === "move") {
        const rect2 = e.currentTarget.getBoundingClientRect();
        const localX2 = e.clientX - rect2.left;
        const localY2 = e.clientY - rect2.top;
        const dx2 = localX2 - drag2.originX;
        const dy2 = localY2 - drag2.originY;
        const { x: x2, y: y2, w: w2, h: h2 } = drag2.startSelection;
        const ib2 = drag2.imageBounds;
        const minX2 = Math.max(0, ib2 ? ib2.x : 0);
        const minY2 = Math.max(0, ib2 ? ib2.y : 0);
        const maxX2 = Math.min(rect2.width, ib2 ? ib2.x + ib2.w : rect2.width);
        const maxY2 = Math.min(rect2.height, ib2 ? ib2.y + ib2.h : rect2.height);
        const newX = Math.max(minX2, Math.min(x2 + dx2, maxX2 - w2));
        const newY = Math.max(minY2, Math.min(y2 + dy2, maxY2 - h2));
        setSelection({ x: newX, y: newY, w: w2, h: h2 });
        return;
      }
      if (drag2.kind === "resize") {
        const rect2 = e.currentTarget.getBoundingClientRect();
        const localX2 = e.clientX - rect2.left;
        const localY2 = e.clientY - rect2.top;
        const ib2 = drag2.imageBounds;
        const minX2 = Math.max(0, ib2 ? ib2.x : 0);
        const minY2 = Math.max(0, ib2 ? ib2.y : 0);
        const maxX2 = Math.min(rect2.width, ib2 ? ib2.x + ib2.w : rect2.width);
        const maxY2 = Math.min(rect2.height, ib2 ? ib2.y + ib2.h : rect2.height);
        const start = drag2.startSelection;
        const startRight = start.x + start.w;
        const startBottom = start.y + start.h;
        const startCenterX = (start.x + startRight) / 2;
        const startCenterY = (start.y + startBottom) / 2;
        const movesLeft = drag2.handle === "w" || drag2.handle === "nw" || drag2.handle === "sw";
        const movesRight = drag2.handle === "e" || drag2.handle === "ne" || drag2.handle === "se";
        const movesTop = drag2.handle === "n" || drag2.handle === "nw" || drag2.handle === "ne";
        const movesBottom = drag2.handle === "s" || drag2.handle === "sw" || drag2.handle === "se";
        let newLeft = movesLeft ? Math.max(minX2, Math.min(localX2, startRight - 1)) : start.x;
        let newRight = movesRight ? Math.min(maxX2, Math.max(localX2, start.x + 1)) : startRight;
        let newTop = movesTop ? Math.max(minY2, Math.min(localY2, startBottom - 1)) : start.y;
        let newBottom = movesBottom ? Math.min(maxY2, Math.max(localY2, start.y + 1)) : startBottom;
        let newW = newRight - newLeft;
        let newH = newBottom - newTop;
        const isCornerDrag = (movesLeft || movesRight) && (movesTop || movesBottom);
        const isEdgeDrag = !isCornerDrag && (movesLeft || movesRight || movesTop || movesBottom);
        if (drag2.aspectValue !== null && isCornerDrag) {
          const anchorX = movesLeft ? startRight : start.x;
          const anchorY = movesTop ? startBottom : start.y;
          const aspect = drag2.aspectValue;
          if (newW / aspect > newH) {
            newH = newW / aspect;
          } else {
            newW = newH * aspect;
          }
          const maxAllowedW = movesLeft ? anchorX - minX2 : maxX2 - anchorX;
          const maxAllowedH = movesTop ? anchorY - minY2 : maxY2 - anchorY;
          if (newW > maxAllowedW) {
            const scale = maxAllowedW / newW;
            newW *= scale;
            newH *= scale;
          }
          if (newH > maxAllowedH) {
            const scale = maxAllowedH / newH;
            newW *= scale;
            newH *= scale;
          }
          newLeft = movesLeft ? anchorX - newW : anchorX;
          newTop = movesTop ? anchorY - newH : anchorY;
        } else if (drag2.aspectValue !== null && isEdgeDrag) {
          const aspect = drag2.aspectValue;
          if (movesTop || movesBottom) {
            const maxHalfW = Math.min(startCenterX - minX2, maxX2 - startCenterX);
            let h2 = newH;
            let w2 = h2 * aspect;
            if (w2 / 2 > maxHalfW) {
              w2 = maxHalfW * 2;
              h2 = w2 / aspect;
              if (movesTop) newTop = newBottom - h2;
              else newBottom = newTop + h2;
            }
            newLeft = startCenterX - w2 / 2;
            newRight = startCenterX + w2 / 2;
            newW = w2;
            newH = h2;
          } else {
            const maxHalfH = Math.min(startCenterY - minY2, maxY2 - startCenterY);
            let w2 = newW;
            let h2 = w2 / aspect;
            if (h2 / 2 > maxHalfH) {
              h2 = maxHalfH * 2;
              w2 = h2 * aspect;
              if (movesLeft) newLeft = newRight - w2;
              else newRight = newLeft + w2;
            }
            newTop = startCenterY - h2 / 2;
            newBottom = startCenterY + h2 / 2;
            newW = w2;
            newH = h2;
          }
        }
        setSelection({ x: newLeft, y: newTop, w: newW, h: newH });
        return;
      }
      const rect = e.currentTarget.getBoundingClientRect();
      const localX = e.clientX - rect.left;
      const localY = e.clientY - rect.top;
      let dx = localX - drag2.originX;
      let dy = localY - drag2.originY;
      if (!drag2.moved && Math.abs(dx) + Math.abs(dy) > 3) {
        drag2.moved = true;
      }
      if (aspectValue !== null) {
        const absX = Math.abs(dx);
        const absY = Math.abs(dy);
        if (absX / aspectValue > absY) {
          const newAbsY = absX / aspectValue;
          dy = dy === 0 ? newAbsY : Math.sign(dy) * newAbsY;
        } else {
          const newAbsX = absY * aspectValue;
          dx = dx === 0 ? newAbsX : Math.sign(dx) * newAbsX;
        }
      }
      let x = drag2.originX;
      let y = drag2.originY;
      let w = dx;
      let h = dy;
      if (w < 0) {
        x += w;
        w = -w;
      }
      if (h < 0) {
        y += h;
        h = -h;
      }
      const ib = drag2.imageBounds;
      const minX = Math.max(0, ib ? ib.x : 0);
      const minY = Math.max(0, ib ? ib.y : 0);
      const maxX = Math.min(rect.width, ib ? ib.x + ib.w : rect.width);
      const maxY = Math.min(rect.height, ib ? ib.y + ib.h : rect.height);
      if (x < minX) {
        w -= minX - x;
        x = minX;
      }
      if (y < minY) {
        h -= minY - y;
        y = minY;
      }
      w = Math.min(w, maxX - x);
      h = Math.min(h, maxY - y);
      if (w < 0) w = 0;
      if (h < 0) h = 0;
      setSelection({ x, y, w, h });
    },
    [aspectValue]
  );
  const onContainerPointerUp = useCallback((e) => {
    const drag2 = dragRef.current;
    if (!drag2 || drag2.pointerId !== e.pointerId) return;
    e.currentTarget.releasePointerCapture(e.pointerId);
    if (drag2.kind === "pan") {
      setIsDragging(false);
    } else if (drag2.kind === "move") ; else if (drag2.kind === "resize") ; else {
      if (!drag2.moved) {
        setSelection(null);
      } else {
        setSelection((prev) => {
          if (!prev || prev.w < 5 || prev.h < 5) return null;
          return prev;
        });
      }
    }
    dragRef.current = null;
  }, []);
  const handleAspectChange = useCallback((next) => {
    setAspectRatio(next);
    setSelection(null);
  }, []);
  const handleCrop = useCallback(async () => {
    if (!selection || !imgRef.current || !displaySource) return;
    if (selection.w < 1 || selection.h < 1) return;
    const result = await renderCrop({
      imageEl: imgRef.current,
      selection,
      angle,
      zoom,
      pan,
      flipH,
      flipV,
      sourceFileName: extractFileName(displaySource) ?? "image",
      outputFormat,
      outputQuality
    });
    if (!result) return;
    setCroppedSource({
      kind: "bytes",
      value: result.bytes,
      mimeType: result.mimeType,
      fileName: result.fileName
    });
    setSelection(null);
    onCropApplied?.(result);
  }, [selection, angle, zoom, pan, flipH, flipV, displaySource, onCropApplied, outputFormat, outputQuality]);
  const onWrapperKeyDown = useCallback(
    (e) => {
      if (!toolbar) return;
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      const sel = selectionRef.current;
      switch (e.key) {
        case "Escape":
          if (onCancel) {
            e.preventDefault();
            onCancel();
          }
          return;
        case "Enter":
          if (sel && sel.w >= 5 && sel.h >= 5) {
            e.preventDefault();
            void handleCrop();
          } else if (onSave && isDirty) {
            e.preventDefault();
            void onSave();
          }
          return;
        case "+":
        case "=":
          e.preventDefault();
          handleZoomIn();
          return;
        case "-":
        case "_":
          e.preventDefault();
          handleZoomOut();
          return;
        case "0":
          e.preventDefault();
          setZoom(1);
          setPan({ x: 0, y: 0 });
          return;
        case "Delete":
        case "Backspace":
          if (sel) {
            e.preventDefault();
            setSelection(null);
          }
          return;
      }
    },
    [toolbar, onCancel, onSave, isDirty, handleCrop, handleZoomIn, handleZoomOut]
  );
  useImperativeHandle(
    ref,
    () => ({
      isDirty,
      resetDirty: () => {
        setBaseline({ angle, flipH, flipV, croppedSource });
      },
      commit: async () => {
        if (!isDirty) return null;
        if (!imgRef.current) return null;
        return await renderBakedImage({
          imageEl: imgRef.current,
          angle,
          flipH,
          flipV,
          sourceFileName: extractFileName(displaySource) ?? "image",
          outputFormat,
          outputQuality
        });
      },
      revertCrop: () => {
        setCroppedSource(null);
      }
    }),
    [isDirty, angle, flipH, flipV, croppedSource, displaySource, outputFormat, outputQuality]
  );
  if (!source || !src) {
    return /* @__PURE__ */ jsx(Fragment, { children: fallback ?? null });
  }
  const wrapped = framed || toolbar;
  const wantsClickDownload = downloadable && !wrapped && !onClick;
  const imgClickHandler = onClick ?? (wantsClickDownload ? () => handleDownload() : void 0);
  const scaleX = zoom * (flipH ? -1 : 1);
  const scaleY = zoom * (flipV ? -1 : 1);
  const transform = toolbar ? `translate(${pan.x}px, ${pan.y}px) rotate(${angle}deg) scale(${scaleX}, ${scaleY})` : void 0;
  const imgStyle = (() => {
    if (!toolbar && !wrapped) return style;
    if (!toolbar) return void 0;
    return {
      transform,
      // Drop the easing while the user is mid-drag; otherwise pan would lag
      // a frame behind the pointer.
      transition: isDragging ? "none" : "transform 120ms ease-out",
      // Pointer events pass through the image to the container so the
      // container's pan/select handlers see the pointer. Cursor styling
      // lives on the container too.
      pointerEvents: "none"
    };
  })();
  const thirdsLines = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: styles.thirdsLineV1 }),
    /* @__PURE__ */ jsx("div", { className: styles.thirdsLineV2 }),
    /* @__PURE__ */ jsx("div", { className: styles.thirdsLineH1 }),
    /* @__PURE__ */ jsx("div", { className: styles.thirdsLineH2 })
  ] });
  const img = /* @__PURE__ */ jsx(
    "img",
    {
      ref: imgRef,
      id: !wrapped ? id : void 0,
      src,
      onLoad: (e) => setImageLayout(readImageLayoutMetrics(e.currentTarget)),
      alt: resolvedAlt,
      crossOrigin: croppable ? "anonymous" : void 0,
      className: mergeClasses(
        wrapped ? styles.framedImage : styles.bareImage,
        isFullscreen && styles.framedImageFullscreen,
        wantsClickDownload && styles.clickable,
        !wrapped && className
      ),
      style: imgStyle,
      onClick: imgClickHandler,
      draggable: false
    }
  );
  if (!wrapped) return img;
  const isResettable = angle % 360 !== 0 || zoom !== 1 || pan.x !== 0 || pan.y !== 0 || flipH || flipV || croppedSource !== null || selection !== null;
  const selectionNaturalDims = (() => {
    if (!selection || !imgRef.current) return null;
    const nat = containerRectToImageNatural(
      selection,
      imgRef.current,
      angle,
      zoom,
      pan,
      flipH,
      flipV
    );
    if (!nat) return null;
    return { w: Math.max(0, Math.round(nat.w)), h: Math.max(0, Math.round(nat.h)) };
  })();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: wrapperRef,
      id,
      className: mergeClasses(
        styles.wrapper,
        isFullscreen && styles.wrapperFullscreen,
        className
      ),
      style,
      tabIndex: toolbar ? 0 : void 0,
      onKeyDown: toolbar ? onWrapperKeyDown : void 0,
      children: [
        toolbar && /* @__PURE__ */ jsxs(
          Toolbar,
          {
            size: "small",
            "aria-label": t("app.components.image-viewer.toolbar", [resolvedFileName]),
            className: styles.toolbar,
            children: [
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.components.image-viewer.rotate-ccw"),
                  icon: /* @__PURE__ */ jsx(ArrowRotateCounterclockwise20Regular, {}),
                  onClick: handleRotateCcw
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.components.image-viewer.rotate-cw"),
                  icon: /* @__PURE__ */ jsx(ArrowRotateClockwise20Regular, {}),
                  onClick: handleRotateCw
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t(
                    flipH ? "app.components.image-viewer.unflip-horizontal" : "app.components.image-viewer.flip-horizontal"
                  ),
                  icon: /* @__PURE__ */ jsx(FlipHorizontal20Regular, {}),
                  ...flipH ? { appearance: "primary" } : {},
                  onClick: handleFlipH
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t(
                    flipV ? "app.components.image-viewer.unflip-vertical" : "app.components.image-viewer.flip-vertical"
                  ),
                  icon: /* @__PURE__ */ jsx(FlipVertical20Regular, {}),
                  ...flipV ? { appearance: "primary" } : {},
                  onClick: handleFlipV
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.components.image-viewer.zoom-in"),
                  icon: /* @__PURE__ */ jsx(ZoomIn20Regular, {}),
                  disabled: zoom >= ZOOM_MAX,
                  onClick: handleZoomIn
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.components.image-viewer.zoom-out"),
                  icon: /* @__PURE__ */ jsx(ZoomOut20Regular, {}),
                  disabled: zoom <= ZOOM_MIN,
                  onClick: handleZoomOut
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.components.image-viewer.reset-view"),
                  icon: /* @__PURE__ */ jsx(ArrowReset20Regular, {}),
                  disabled: !isResettable,
                  onClick: handleReset
                }
              ),
              cropEnabled && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(ToolbarDivider, {}),
                /* @__PURE__ */ jsxs(
                  Menu,
                  {
                    checkedValues: { aspect: [aspectRatio] },
                    onCheckedValueChange: (_e, data) => {
                      const next = data.checkedItems[0];
                      if (next) handleAspectChange(next);
                    },
                    ...isFullscreen && wrapperRef.current ? { mountNode: wrapperRef.current } : {},
                    children: [
                      /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
                        ToolbarButton,
                        {
                          "aria-label": t("app.components.image-viewer.crop-aspect-ratio", [aspectRatio]),
                          icon: /* @__PURE__ */ jsx(ChevronDown16Regular, {}),
                          children: aspectRatioLabel(aspectRatio)
                        }
                      ) }),
                      /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs(MenuList, { children: [
                        /* @__PURE__ */ jsx(MenuItemRadio, { name: "aspect", value: "free", children: "Free" }),
                        /* @__PURE__ */ jsx(MenuItemRadio, { name: "aspect", value: "1:1", children: "Square (1:1)" }),
                        /* @__PURE__ */ jsx(MenuItemRadio, { name: "aspect", value: "4:3", children: "4:3" }),
                        /* @__PURE__ */ jsx(MenuItemRadio, { name: "aspect", value: "16:9", children: "16:9" })
                      ] }) })
                    ]
                  }
                ),
                /* @__PURE__ */ jsx(
                  ToolbarButton,
                  {
                    "aria-label": t(
                      showThirds ? "app.components.image-viewer.hide-thirds" : "app.components.image-viewer.show-thirds"
                    ),
                    icon: /* @__PURE__ */ jsx(Grid20Regular, {}),
                    ...showThirds ? { appearance: "primary" } : {},
                    onClick: () => setShowThirds((s) => !s)
                  }
                ),
                /* @__PURE__ */ jsx(
                  ToolbarButton,
                  {
                    "aria-label": t("app.components.image-viewer.crop-to-selection"),
                    icon: /* @__PURE__ */ jsx(Crop20Regular, {}),
                    disabled: selection === null,
                    onClick: () => void handleCrop()
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(ToolbarDivider, {}),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t(
                    isFullscreen ? "app.components.image-viewer.exit-fullscreen" : "app.components.image-viewer.enter-fullscreen"
                  ),
                  icon: isFullscreen ? /* @__PURE__ */ jsx(FullScreenMinimize20Regular, {}) : /* @__PURE__ */ jsx(FullScreenMaximize20Regular, {}),
                  onClick: handleToggleFullscreen
                }
              ),
              downloadable && /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.buttons.download-item", [resolvedFileName]),
                  icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
                  onClick: handleDownload
                }
              ),
              (onSave || onCancel) && /* @__PURE__ */ jsx(ToolbarDivider, {}),
              onCancel && // Red prohibited-circle = "discard / exit". Color comes from a
              // palette token so it stays semantically red across light/dark
              // theme switches and consumer accent customizations.
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.buttons.cancel.label"),
                  icon: /* @__PURE__ */ jsx(Prohibited20Regular, { className: styles.cancelIcon }),
                  onClick: onCancel
                }
              ),
              onSave && // Filled green checkmark = "commit changes". Disabled while the
              // viewer is clean so the consumer doesn't fire a no-op commit
              // (matches the `commit() returns null when !isDirty` contract).
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.buttons.save.label"),
                  icon: /* @__PURE__ */ jsx(Checkmark20Filled, { className: styles.saveIcon }),
                  disabled: !isDirty,
                  onClick: () => void onSave()
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            ref: imageContainerRef,
            className: mergeClasses(
              styles.imageContainer,
              isFullscreen && styles.imageContainerFullscreen
            ),
            onPointerDown: toolbar ? onContainerPointerDown : void 0,
            onPointerMove: toolbar ? onContainerPointerMove : void 0,
            onPointerUp: toolbar ? onContainerPointerUp : void 0,
            onPointerCancel: toolbar ? onContainerPointerUp : void 0,
            style: cropEnabled ? { cursor: "crosshair" } : toolbar && zoom > 1 ? { cursor: isDragging ? "grabbing" : "grab" } : void 0,
            children: [
              img,
              showThirds && !selection && imageLayout && // Rule-of-thirds guide over the whole image while nothing is
              // selected: on the image's own layout box, with its transform, so it
              // turns and zooms with it.
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: styles.thirdsGuide,
                  "aria-hidden": "true",
                  style: pictureThirdsGuideStyle(imageLayout, zoom, pan, angle, isDragging),
                  children: thirdsLines
                }
              ),
              selection && // Dashed selection rectangle over the image. The huge spread
              // box-shadow dims everything outside the rectangle inside the
              // container — clipped by the container's overflow:hidden.
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: styles.selectionOverlay,
                  style: {
                    left: `${selection.x}px`,
                    top: `${selection.y}px`,
                    width: `${selection.w}px`,
                    height: `${selection.h}px`,
                    // Match the image's 120ms ease-out (see `imgStyle.transition`)
                    // so a transform-driven re-projection animates in lockstep
                    // with the image. Disabled while a drag is active so user
                    // drags track the cursor 1:1 instead of trailing 120ms
                    // behind. dragRef is a ref rather than state, but every
                    // pointermove (which is what changes the selection during
                    // a drag) calls setSelection — that triggers a re-render
                    // which reads the current dragRef value.
                    transition: dragRef.current || resizingRef.current ? "none" : "left 120ms ease-out, top 120ms ease-out, width 120ms ease-out, height 120ms ease-out"
                  },
                  children: [
                    showThirds && /* @__PURE__ */ jsx("div", { className: styles.thirdsGuide, "aria-hidden": "true", children: thirdsLines }),
                    selectionNaturalDims && /* @__PURE__ */ jsxs("div", { className: styles.dimensionBadge, "aria-hidden": "true", children: [
                      selectionNaturalDims.w,
                      " \xD7 ",
                      selectionNaturalDims.h,
                      " px"
                    ] }),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleNW),
                        "data-handle": "nw",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-top-left")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleNE),
                        "data-handle": "ne",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-top-right")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleSE),
                        "data-handle": "se",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-bottom-right")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleSW),
                        "data-handle": "sw",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-bottom-left")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleN),
                        "data-handle": "n",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-top")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleS),
                        "data-handle": "s",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-bottom")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleE),
                        "data-handle": "e",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-right")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleW),
                        "data-handle": "w",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-left")
                      }
                    )
                  ]
                }
              ),
              downloadable && !toolbar && /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  size: "small",
                  icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
                  "aria-label": t("app.buttons.download-item", [resolvedFileName]),
                  className: styles.downloadButton,
                  onClick: (ev) => {
                    ev.stopPropagation();
                    handleDownload();
                  }
                }
              )
            ]
          }
        )
      ]
    }
  );
});
function extractFileName(source) {
  if (!source) return void 0;
  if (source.kind === "url") {
    try {
      const url = new URL(source.value, "http://_resolve");
      const last = url.pathname.split("/").filter(Boolean).pop();
      return last ? decodeURIComponent(last) : void 0;
    } catch {
      return void 0;
    }
  }
  return source.fileName;
}
function resolveMimeType(source) {
  if (source.kind === "url") return "image/*";
  if (source.mimeType) return source.mimeType;
  if (source.fileName) return guessImageMimeType(source.fileName);
  return "image/jpeg";
}
function useImageSrc(source) {
  const lastSourceRef = useRef(void 0);
  const bytesUrlRef = useRef(null);
  const isBytes = source != null && source.kind === "bytes";
  if (source !== lastSourceRef.current || isBytes && bytesUrlRef.current === null) {
    if (bytesUrlRef.current !== null) {
      URL.revokeObjectURL(bytesUrlRef.current);
      bytesUrlRef.current = null;
    }
    if (isBytes && source) {
      const blob = new Blob([source.value.buffer], {
        type: resolveMimeType(source)
      });
      bytesUrlRef.current = URL.createObjectURL(blob);
    }
    lastSourceRef.current = source;
  }
  useEffect(() => {
    return () => {
      if (bytesUrlRef.current !== null) {
        URL.revokeObjectURL(bytesUrlRef.current);
        bytesUrlRef.current = null;
      }
    };
  }, []);
  if (!source) return null;
  if (source.kind === "url") return source.value || null;
  if (source.kind === "base64")
    return source.value ? `data:${resolveMimeType(source)};base64,${source.value}` : null;
  return bytesUrlRef.current;
}
function pictureThirdsGuideStyle(layout, zoom, pan, angle, isDragging) {
  const fit = Math.min(layout.layoutW / layout.naturalW, layout.layoutH / layout.naturalH);
  const width = layout.naturalW * fit * zoom;
  const height = layout.naturalH * fit * zoom;
  return {
    right: "auto",
    bottom: "auto",
    left: `${layout.offsetLeft + (layout.layoutW - width) / 2}px`,
    top: `${layout.offsetTop + (layout.layoutH - height) / 2}px`,
    width: `${width}px`,
    height: `${height}px`,
    transform: `translate(${pan.x}px, ${pan.y}px) rotate(${angle}deg)`,
    transition: isDragging ? "none" : "transform 120ms ease-out, left 120ms ease-out, top 120ms ease-out, width 120ms ease-out, height 120ms ease-out"
  };
}
function readImageLayoutMetrics(imageEl) {
  const layoutW = imageEl.offsetWidth;
  const layoutH = imageEl.offsetHeight;
  const naturalW = imageEl.naturalWidth;
  const naturalH = imageEl.naturalHeight;
  if (layoutW === 0 || layoutH === 0 || naturalW === 0 || naturalH === 0) return null;
  return {
    layoutW,
    layoutH,
    offsetLeft: imageEl.offsetLeft,
    offsetTop: imageEl.offsetTop,
    naturalW,
    naturalH
  };
}
function getDisplayedImageBounds(imageEl, angle, zoom, pan, flipH, flipV) {
  const layoutW = imageEl.offsetWidth;
  const layoutH = imageEl.offsetHeight;
  const naturalW = imageEl.naturalWidth;
  const naturalH = imageEl.naturalHeight;
  if (layoutW === 0 || layoutH === 0 || naturalW === 0 || naturalH === 0) return null;
  const containScale = Math.min(layoutW / naturalW, layoutH / naturalH);
  const displayW = naturalW * containScale;
  const displayH = naturalH * containScale;
  const imgCenterX = imageEl.offsetLeft + layoutW / 2;
  const imgCenterY = imageEl.offsetTop + layoutH / 2;
  const halfW = displayW / 2;
  const halfH = displayH / 2;
  const sx = zoom * (flipH ? -1 : 1);
  const sy = zoom * (flipV ? -1 : 1);
  const rad = angle * Math.PI / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const corners = [
    [-halfW, -halfH],
    [halfW, -halfH],
    [halfW, halfH],
    [-halfW, halfH]
  ];
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const [cx, cy] of corners) {
    const x1 = cx * sx;
    const y1 = cy * sy;
    const x2 = x1 * cos - y1 * sin;
    const y2 = x1 * sin + y1 * cos;
    const x3 = x2 + pan.x + imgCenterX;
    const y3 = y2 + pan.y + imgCenterY;
    if (x3 < minX) minX = x3;
    if (x3 > maxX) maxX = x3;
    if (y3 < minY) minY = y3;
    if (y3 > maxY) maxY = y3;
  }
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}
function containerRectToImageNatural(rect, imageEl, angle, zoom, pan, flipH, flipV, metricsOverride) {
  const m = metricsOverride ?? readImageLayoutMetrics(imageEl);
  if (!m) return null;
  const { layoutW, layoutH, naturalW, naturalH } = m;
  const containScale = Math.min(layoutW / naturalW, layoutH / naturalH);
  const imgCenterX = m.offsetLeft + layoutW / 2;
  const imgCenterY = m.offsetTop + layoutH / 2;
  const sx = zoom * (flipH ? -1 : 1);
  const sy = zoom * (flipV ? -1 : 1);
  if (sx === 0 || sy === 0) return null;
  const rad = angle * Math.PI / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const corners = [
    [rect.x, rect.y],
    [rect.x + rect.w, rect.y],
    [rect.x + rect.w, rect.y + rect.h],
    [rect.x, rect.y + rect.h]
  ];
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const [cx, cy] of corners) {
    const px = cx - imgCenterX - pan.x;
    const py = cy - imgCenterY - pan.y;
    const rx = px * cos + py * sin;
    const ry = -px * sin + py * cos;
    const tx = rx / sx;
    const ty = ry / sy;
    const nx = tx / containScale + naturalW / 2;
    const ny = ty / containScale + naturalH / 2;
    if (nx < minX) minX = nx;
    if (nx > maxX) maxX = nx;
    if (ny < minY) minY = ny;
    if (ny > maxY) maxY = ny;
  }
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}
function imageNaturalRectToContainer(rect, imageEl, angle, zoom, pan, flipH, flipV, metricsOverride) {
  const m = metricsOverride ?? readImageLayoutMetrics(imageEl);
  if (!m) return null;
  const { layoutW, layoutH, naturalW, naturalH } = m;
  const containScale = Math.min(layoutW / naturalW, layoutH / naturalH);
  const imgCenterX = m.offsetLeft + layoutW / 2;
  const imgCenterY = m.offsetTop + layoutH / 2;
  const sx = zoom * (flipH ? -1 : 1);
  const sy = zoom * (flipV ? -1 : 1);
  const rad = angle * Math.PI / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const corners = [
    [rect.x, rect.y],
    [rect.x + rect.w, rect.y],
    [rect.x + rect.w, rect.y + rect.h],
    [rect.x, rect.y + rect.h]
  ];
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const [nx, ny] of corners) {
    const cx = (nx - naturalW / 2) * containScale;
    const cy = (ny - naturalH / 2) * containScale;
    const sxv = cx * sx;
    const syv = cy * sy;
    const rx = sxv * cos - syv * sin;
    const ry = sxv * sin + syv * cos;
    const tx = rx + pan.x + imgCenterX;
    const ty = ry + pan.y + imgCenterY;
    if (tx < minX) minX = tx;
    if (tx > maxX) maxX = tx;
    if (ty < minY) minY = ty;
    if (ty > maxY) maxY = ty;
  }
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}
async function downloadSource(source, fileName) {
  if (source.kind === "url") {
    const anchor = document.createElement("a");
    anchor.href = source.value;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    return;
  }
  const bytes = source.kind === "base64" ? base64ToBytes(source.value) : source.value;
  triggerBlobDownload(bytes, fileName);
}
function resolveAutoOutputFormat(sourceFileName) {
  const dot = sourceFileName.lastIndexOf(".");
  if (dot < 0) return "png";
  const ext = sourceFileName.slice(dot + 1).toLowerCase();
  return ext === "jpg" || ext === "jpeg" || ext === "jpe" ? "jpeg" : "png";
}
function aspectRatioToNumber(aspect) {
  switch (aspect) {
    case "1:1":
      return 1;
    case "4:3":
      return 4 / 3;
    case "16:9":
      return 16 / 9;
    case "free":
    default:
      return null;
  }
}
function aspectRatioLabel(aspect) {
  return aspect === "free" ? "Free" : aspect;
}
async function renderCrop(args) {
  const { imageEl, selection, angle, zoom, pan, flipH, flipV, sourceFileName, outputQuality } = args;
  const outputFormat = args.outputFormat === "auto" ? resolveAutoOutputFormat(sourceFileName) : args.outputFormat;
  const layoutW = imageEl.offsetWidth;
  const layoutH = imageEl.offsetHeight;
  const naturalW = imageEl.naturalWidth;
  const naturalH = imageEl.naturalHeight;
  if (layoutW === 0 || layoutH === 0 || naturalW === 0 || naturalH === 0) return null;
  const containScale = Math.min(layoutW / naturalW, layoutH / naturalH);
  const imgCenterX = imageEl.offsetLeft + layoutW / 2;
  const imgCenterY = imageEl.offsetTop + layoutH / 2;
  const angleNorm = (angle % 360 + 360) % 360;
  const isQuarterTurn = angleNorm === 90 || angleNorm === 270;
  const rotatedW = isQuarterTurn ? naturalH : naturalW;
  const rotatedH = isQuarterTurn ? naturalW : naturalH;
  const scale = containScale * zoom;
  const corners = [
    [selection.x, selection.y],
    [selection.x + selection.w, selection.y],
    [selection.x + selection.w, selection.y + selection.h],
    [selection.x, selection.y + selection.h]
  ];
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const [cx, cy] of corners) {
    const qx = rotatedW / 2 + (cx - imgCenterX - pan.x) / scale;
    const qy = rotatedH / 2 + (cy - imgCenterY - pan.y) / scale;
    if (qx < minX) minX = qx;
    if (qx > maxX) maxX = qx;
    if (qy < minY) minY = qy;
    if (qy > maxY) maxY = qy;
  }
  const cropLeft = Math.max(0, minX);
  const cropTop = Math.max(0, minY);
  const cropRight = Math.min(rotatedW, maxX);
  const cropBottom = Math.min(rotatedH, maxY);
  const cropSrcW = cropRight - cropLeft;
  const cropSrcH = cropBottom - cropTop;
  if (cropSrcW < 1 || cropSrcH < 1) return null;
  const naturalCanvas = document.createElement("canvas");
  naturalCanvas.width = rotatedW;
  naturalCanvas.height = rotatedH;
  const nCtx = naturalCanvas.getContext("2d");
  if (!nCtx) return null;
  nCtx.translate(rotatedW / 2, rotatedH / 2);
  nCtx.rotate(angleNorm * Math.PI / 180);
  nCtx.scale(flipH ? -1 : 1, flipV ? -1 : 1);
  nCtx.drawImage(imageEl, -naturalW / 2, -naturalH / 2, naturalW, naturalH);
  const out = document.createElement("canvas");
  out.width = Math.max(1, Math.round(cropSrcW));
  out.height = Math.max(1, Math.round(cropSrcH));
  const oCtx = out.getContext("2d");
  if (!oCtx) return null;
  oCtx.drawImage(
    naturalCanvas,
    cropLeft,
    cropTop,
    cropSrcW,
    cropSrcH,
    0,
    0,
    out.width,
    out.height
  );
  const mimeType = outputFormat === "jpeg" ? "image/jpeg" : "image/png";
  const ext = outputFormat === "jpeg" ? "jpg" : "png";
  const blob = await new Promise(
    (resolve) => out.toBlob((b) => resolve(b), mimeType, outputQuality)
  );
  if (!blob) return null;
  const arrayBuffer = await blob.arrayBuffer();
  const bytes = new Uint8Array(arrayBuffer);
  const base64 = bytesToBase64(bytes);
  const dot = sourceFileName.lastIndexOf(".");
  const stem = dot >= 0 ? sourceFileName.slice(0, dot) : sourceFileName;
  const fileName = `${stem}-cropped.${ext}`;
  return {
    bytes,
    base64,
    mimeType,
    fileName,
    width: out.width,
    height: out.height
  };
}
async function renderBakedImage(args) {
  const { imageEl, angle, flipH, flipV, sourceFileName, outputQuality } = args;
  const outputFormat = args.outputFormat === "auto" ? resolveAutoOutputFormat(sourceFileName) : args.outputFormat;
  const naturalW = imageEl.naturalWidth;
  const naturalH = imageEl.naturalHeight;
  if (naturalW === 0 || naturalH === 0) return null;
  const angleNorm = (angle % 360 + 360) % 360;
  const isQuarterTurn = angleNorm === 90 || angleNorm === 270;
  const outputW = isQuarterTurn ? naturalH : naturalW;
  const outputH = isQuarterTurn ? naturalW : naturalH;
  const canvas = document.createElement("canvas");
  canvas.width = outputW;
  canvas.height = outputH;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;
  ctx.translate(outputW / 2, outputH / 2);
  ctx.rotate(angleNorm * Math.PI / 180);
  ctx.scale(flipH ? -1 : 1, flipV ? -1 : 1);
  ctx.drawImage(imageEl, -naturalW / 2, -naturalH / 2, naturalW, naturalH);
  const mimeType = outputFormat === "jpeg" ? "image/jpeg" : "image/png";
  const ext = outputFormat === "jpeg" ? "jpg" : "png";
  const blob = await new Promise(
    (resolve) => canvas.toBlob((b) => resolve(b), mimeType, outputQuality)
  );
  if (!blob) return null;
  const arrayBuffer = await blob.arrayBuffer();
  const bytes = new Uint8Array(arrayBuffer);
  const base64 = bytesToBase64(bytes);
  const dot = sourceFileName.lastIndexOf(".");
  const stem = dot >= 0 ? sourceFileName.slice(0, dot) : sourceFileName;
  const fileName = `${stem}-edited.${ext}`;
  return {
    bytes,
    base64,
    mimeType,
    fileName,
    width: outputW,
    height: outputH
  };
}
function bytesToBase64(bytes) {
  const chunkSize = 32768;
  let binary = "";
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }
  return btoa(binary);
}
var useImageViewerStyles = makeStyles({
  bareImage: {
    maxWidth: "100%",
    height: "auto",
    display: "block"
  },
  clickable: {
    cursor: "pointer"
  },
  wrapper: {
    display: "inline-flex",
    flexDirection: "column",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2,
    overflow: "hidden"
  },
  wrapperFullscreen: {
    width: "100vw",
    height: "100vh",
    border: "none",
    borderRadius: 0,
    backgroundColor: tokens.colorNeutralBackground1
  },
  // Wraps onto another row when the viewer is too narrow for every button,
  // rather than cutting the last ones off.
  toolbar: {
    flex: "0 0 auto",
    flexWrap: "wrap",
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1
  },
  imageContainer: {
    position: "relative",
    flex: "1 1 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: tokens.spacingHorizontalM,
    minHeight: "120px",
    overflow: "hidden"
  },
  imageContainerFullscreen: {
    padding: 0
  },
  framedImage: {
    maxWidth: "100%",
    maxHeight: "320px",
    objectFit: "contain",
    display: "block",
    userSelect: "none",
    WebkitUserSelect: "none"
  },
  framedImageFullscreen: {
    maxHeight: "100%",
    maxWidth: "100%"
  },
  selectionOverlay: {
    position: "absolute",
    border: `${tokens.strokeWidthThicker} dashed ${tokens.colorNeutralStrokeOnBrand}`,
    // Spread shadow dims everything outside the rectangle. The container's
    // `overflow: hidden` clips the shadow to the visible viewer area.
    boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.45)",
    // `auto` (not `none`) so the overlay can show a `move` cursor while
    // the pointer is inside the selection — the pointerdown still bubbles
    // up to the container's handler (currentTarget is the container), so
    // hit-testing and pointer capture continue to work the same way.
    pointerEvents: "auto",
    cursor: "move",
    boxSizing: "border-box",
    // Drag-handle hardening: stop the browser from interpreting the
    // press-and-drag as a text-selection or touch gesture. Without
    // these, the browser intermittently steals pointer capture mid-
    // move (the move drag freezes; the user has to click to "reset"
    // before they can drag again).
    userSelect: "none",
    WebkitUserSelect: "none",
    touchAction: "none"
  },
  // Rule-of-thirds guide. A pointer-transparent container that fills the
  // selection rectangle and holds four thin lines (two vertical, two
  // horizontal) at the 1/3 and 2/3 marks. Lines are translucent white so
  // they read against any image content without overpowering it.
  thirdsGuide: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: "none"
  },
  thirdsLineV1: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: "33.3333%",
    width: "1px",
    backgroundColor: "rgba(255, 255, 255, 0.55)"
  },
  thirdsLineV2: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: "66.6667%",
    width: "1px",
    backgroundColor: "rgba(255, 255, 255, 0.55)"
  },
  thirdsLineH1: {
    position: "absolute",
    left: 0,
    right: 0,
    top: "33.3333%",
    height: "1px",
    backgroundColor: "rgba(255, 255, 255, 0.55)"
  },
  thirdsLineH2: {
    position: "absolute",
    left: 0,
    right: 0,
    top: "66.6667%",
    height: "1px",
    backgroundColor: "rgba(255, 255, 255, 0.55)"
  },
  // Live dimension readout. Anchored to the top-left of the selection,
  // sitting just outside the dashed border. Opaque background so it
  // shows clearly over the dimmed surrounding area. `pointer-events:
  // none` so the badge can't accidentally start a move-drag (the
  // overlay-level `cursor: move` and pointer handlers would otherwise
  // see it as a hit target).
  dimensionBadge: {
    position: "absolute",
    top: 0,
    left: 0,
    transform: "translateY(calc(-100% - 4px))",
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    borderTopLeftRadius: tokens.borderRadiusSmall,
    borderTopRightRadius: tokens.borderRadiusSmall,
    borderBottomLeftRadius: tokens.borderRadiusSmall,
    borderBottomRightRadius: tokens.borderRadiusSmall,
    fontSize: tokens.fontSizeBase200,
    fontFamily: tokens.fontFamilyMonospace,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    pointerEvents: "none",
    userSelect: "none",
    WebkitUserSelect: "none",
    boxShadow: tokens.shadow4,
    zIndex: 2
  },
  // Resize handles. Small filled squares on each corner (always) and edge
  // midpoint (free aspect only). Positioned on the overlay's border with
  // a half-size translate so the visible square straddles the edge — gives
  // a wide hit target without the handle "moving" the visual edge of the
  // selection.
  resizeHandle: {
    position: "absolute",
    width: "12px",
    height: "12px",
    backgroundColor: tokens.colorNeutralBackground1,
    borderTopWidth: tokens.strokeWidthThin,
    borderRightWidth: tokens.strokeWidthThin,
    borderBottomWidth: tokens.strokeWidthThin,
    borderLeftWidth: tokens.strokeWidthThin,
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftStyle: "solid",
    borderTopColor: tokens.colorNeutralStrokeAccessible,
    borderRightColor: tokens.colorNeutralStrokeAccessible,
    borderBottomColor: tokens.colorNeutralStrokeAccessible,
    borderLeftColor: tokens.colorNeutralStrokeAccessible,
    borderTopLeftRadius: tokens.borderRadiusSmall,
    borderTopRightRadius: tokens.borderRadiusSmall,
    borderBottomLeftRadius: tokens.borderRadiusSmall,
    borderBottomRightRadius: tokens.borderRadiusSmall,
    pointerEvents: "auto",
    userSelect: "none",
    WebkitUserSelect: "none",
    touchAction: "none",
    // Sit above the dashed border so the user can grab them.
    zIndex: 1,
    boxSizing: "border-box"
  },
  handleNW: {
    top: 0,
    left: 0,
    transform: "translate(-50%, -50%)",
    cursor: "nwse-resize"
  },
  handleNE: {
    top: 0,
    right: 0,
    transform: "translate(50%, -50%)",
    cursor: "nesw-resize"
  },
  handleSE: {
    bottom: 0,
    right: 0,
    transform: "translate(50%, 50%)",
    cursor: "nwse-resize"
  },
  handleSW: {
    bottom: 0,
    left: 0,
    transform: "translate(-50%, 50%)",
    cursor: "nesw-resize"
  },
  handleN: {
    top: 0,
    left: "50%",
    transform: "translate(-50%, -50%)",
    cursor: "ns-resize"
  },
  handleS: {
    bottom: 0,
    left: "50%",
    transform: "translate(-50%, 50%)",
    cursor: "ns-resize"
  },
  handleE: {
    top: "50%",
    right: 0,
    transform: "translate(50%, -50%)",
    cursor: "ew-resize"
  },
  handleW: {
    top: "50%",
    left: 0,
    transform: "translate(-50%, -50%)",
    cursor: "ew-resize"
  },
  downloadButton: {
    position: "absolute",
    top: tokens.spacingVerticalXS,
    right: tokens.spacingHorizontalXS,
    backgroundColor: tokens.colorNeutralBackground1
  },
  // Palette tokens (not bare hex) so the colors track the theme — Fluent's
  // light/dark switch picks the right contrast, and the disabled state
  // overlay still applies cleanly on top.
  saveIcon: {
    color: tokens.colorPaletteGreenForeground1
  },
  cancelIcon: {
    color: tokens.colorPaletteRedForeground1
  }
});
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("json", json);
hljs.registerLanguage("yaml", yaml);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("typescript", typescript);
hljs.registerLanguage("csharp", csharp);
hljs.registerLanguage("css", css);
hljs.registerLanguage("markdown", markdown);
function highlightToHtml(code, language) {
  if (language && language !== "plaintext" && hljs.getLanguage(language)) {
    return hljs.highlight(code, { language, ignoreIllegals: true }).value;
  }
  return escapeHtml(code);
}
function escapeHtml(value2) {
  return value2.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function FileViewer({
  source,
  fileName,
  className,
  style,
  id,
  fallback,
  maxHeight = "60vh",
  downloadable = true
}) {
  const styles = useFileViewerStyles();
  if (!source) return /* @__PURE__ */ jsx(Fragment, { children: fallback ?? null });
  const resolvedFileName = fileName ?? (source.kind === "url" ? source.fileName ?? extractFileNameFromUrl(source.value) : source.fileName) ?? "file";
  const resolvedMime = source.mimeType ?? getMimeFromFileName(resolvedFileName);
  const category = categorizeFile({
    mimeType: resolvedMime,
    fileName: resolvedFileName
  });
  const wrapperClass = mergeClasses(styles.wrapper, className);
  const wrapperStyle = { ...style };
  switch (category) {
    case "image":
      return /* @__PURE__ */ jsx("div", { className: styles.imageCenter, children: /* @__PURE__ */ jsx(
        ImageViewer,
        {
          source: toImageSource(source),
          fileName: resolvedFileName,
          framed: true,
          downloadable,
          ...className !== void 0 && { className },
          ...style !== void 0 && { style },
          ...id !== void 0 && { id }
        }
      ) });
    case "markdown":
      return /* @__PURE__ */ jsx(
        MarkdownRenderer,
        {
          source,
          fileName: resolvedFileName,
          className: wrapperClass,
          style: wrapperStyle,
          id,
          maxHeight,
          downloadable
        }
      );
    case "text":
      return /* @__PURE__ */ jsx(
        TextRenderer,
        {
          source,
          fileName: resolvedFileName,
          className: wrapperClass,
          style: wrapperStyle,
          id,
          maxHeight,
          downloadable
        }
      );
    case "embedded":
      return /* @__PURE__ */ jsx(
        EmbeddedRenderer,
        {
          source,
          fileName: resolvedFileName,
          mimeType: resolvedMime,
          className: wrapperClass,
          style: wrapperStyle,
          id,
          maxHeight,
          downloadable
        }
      );
    case "zip":
      return /* @__PURE__ */ jsx(
        ZipViewer,
        {
          source,
          fileName: resolvedFileName,
          className: wrapperClass,
          style: wrapperStyle,
          id,
          maxHeight,
          downloadable
        }
      );
    case "download":
    default:
      return /* @__PURE__ */ jsx(
        DownloadCard,
        {
          source,
          fileName: resolvedFileName,
          mimeType: resolvedMime,
          className: wrapperClass,
          style: wrapperStyle,
          id
        }
      );
  }
}
function toImageSource(source) {
  if (source.kind === "url") return { kind: "url", value: source.value };
  const base = { kind: source.kind, value: source.value };
  return {
    ...base,
    ...source.mimeType !== void 0 && { mimeType: source.mimeType },
    ...source.fileName !== void 0 && { fileName: source.fileName }
  };
}
function extractFileNameFromUrl(url) {
  try {
    const parsed = new URL(url, "http://_resolve");
    const last = parsed.pathname.split("/").filter(Boolean).pop();
    return last ? decodeURIComponent(last) : void 0;
  } catch {
    return void 0;
  }
}
function DownloadOverlayButton({ source, fileName }) {
  const styles = useFileViewerStyles();
  const t = useT();
  return /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.file-viewer.download"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
    Button,
    {
      appearance: "subtle",
      icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
      "aria-label": t("app.components.file-viewer.download"),
      onClick: () => void downloadFileSource(source, fileName),
      className: styles.downloadOverlay
    }
  ) });
}
function TextRenderer({
  source,
  fileName,
  className,
  style,
  id,
  maxHeight,
  downloadable
}) {
  const styles = useFileViewerStyles();
  const { text: text2, error, isLoading } = useFileText(source);
  const language = getHighlightLanguage(fileName);
  const html = useHighlightedHtml(text2, language);
  if (isLoading) return /* @__PURE__ */ jsx(LoadingShell, { className, style, id });
  if (error) return /* @__PURE__ */ jsx(ErrorShell, { className, style, id, message: error });
  if (text2 === null) return null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id,
      className: mergeClasses(styles.codeFrame, className),
      style: { height: "100%", maxHeight, ...style },
      children: [
        html !== null ? /* @__PURE__ */ jsx(HighlightedCodeBlock, { html }) : /* @__PURE__ */ jsx("pre", { className: styles.fallbackPre, children: text2 }),
        downloadable && /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
      ]
    }
  );
}
function MarkdownRenderer({
  source,
  fileName,
  className,
  style,
  id,
  maxHeight,
  downloadable
}) {
  const styles = useFileViewerStyles();
  const t = useT();
  const { text: text2, error, isLoading } = useFileText(source);
  const [tab, setTab] = useState("preview");
  const sourceHtml = useHighlightedHtml(tab === "source" ? text2 : null, "markdown");
  if (isLoading) return /* @__PURE__ */ jsx(LoadingShell, { className, style, id });
  if (error) return /* @__PURE__ */ jsx(ErrorShell, { className, style, id, message: error });
  if (text2 === null) return null;
  return /* @__PURE__ */ jsxs("div", { id, className: mergeClasses(styles.markdownFrame, className), style, children: [
    /* @__PURE__ */ jsxs(
      TabList,
      {
        selectedValue: tab,
        onTabSelect: (_, data) => setTab(data.value),
        size: "small",
        children: [
          /* @__PURE__ */ jsx(Tab, { value: "preview", children: t("app.components.file-viewer.preview-tab") }),
          /* @__PURE__ */ jsx(Tab, { value: "source", children: t("app.components.file-viewer.source-tab") })
        ]
      }
    ),
    /* @__PURE__ */ jsx("div", { className: styles.markdownBody, style: { maxHeight }, children: tab === "preview" ? /* @__PURE__ */ jsx("div", { className: styles.markdownPreview, children: /* @__PURE__ */ jsx(Markdown, { children: text2 }) }) : sourceHtml !== null ? /* @__PURE__ */ jsx(HighlightedCodeBlock, { html: sourceHtml }) : /* @__PURE__ */ jsx("pre", { className: styles.fallbackPre, children: text2 }) }),
    downloadable && /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
  ] });
}
function EmbeddedRenderer({
  source,
  fileName,
  mimeType,
  className,
  style,
  id,
  maxHeight,
  downloadable
}) {
  const styles = useFileViewerStyles();
  const objectUrl = useObjectUrl(source, mimeType);
  if (source.kind === "url") {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        id,
        className: mergeClasses(styles.embeddedWrapper, className),
        style: { ...style, height: maxHeight },
        children: [
          /* @__PURE__ */ jsx("iframe", { title: fileName, src: source.value, className: styles.iframe }),
          downloadable && /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
        ]
      }
    );
  }
  if (!objectUrl) return /* @__PURE__ */ jsx(LoadingShell, { className, style, id });
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id,
      className: mergeClasses(styles.embeddedWrapper, className),
      style: { ...style, height: maxHeight },
      children: [
        /* @__PURE__ */ jsx("iframe", { title: fileName, src: objectUrl, className: styles.iframe }),
        downloadable && /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
      ]
    }
  );
}
var ZIP_TREE_MIN_WIDTH = 180;
var ZIP_TREE_MIN_PREVIEW = 280;
var ZIP_TREE_INITIAL_WIDTH = 280;
var ZIP_SPLITTER_KEY_STEP = 16;
var ZIP_TREE_WIDTH_STORAGE_KEY = "powerportalspro:zipViewer:treeWidth";
var ZIP_TREE_WIDTH_PERSIST_DEBOUNCE_MS = 250;
function ZipViewer({
  source,
  fileName,
  className,
  style,
  id,
  maxHeight,
  downloadable
}) {
  const styles = useFileViewerStyles();
  const t = useT();
  const { bytes, error, isLoading } = useFileBytes(source);
  const [entries, treeError] = useMemo(() => {
    if (!bytes) return [null, null];
    try {
      return [unzipSync(bytes), null];
    } catch (err) {
      return [null, err instanceof Error ? err.message : "Failed to read archive."];
    }
  }, [bytes]);
  const tree = useMemo(() => entries ? buildZipTree(entries) : [], [entries]);
  const [selected, setSelected] = useState(null);
  const [expanded, setExpanded] = useState(() => /* @__PURE__ */ new Set());
  useEffect(() => {
    setSelected(null);
    setExpanded(/* @__PURE__ */ new Set());
  }, [entries]);
  const frameRef = useRef(null);
  const [treeWidth, setTreeWidth] = useState(() => {
    if (typeof window === "undefined") return ZIP_TREE_INITIAL_WIDTH;
    try {
      const stored = window.localStorage.getItem(ZIP_TREE_WIDTH_STORAGE_KEY);
      if (stored !== null) {
        const parsed = Number.parseInt(stored, 10);
        if (Number.isFinite(parsed) && parsed >= ZIP_TREE_MIN_WIDTH) return parsed;
      }
    } catch {
    }
    return ZIP_TREE_INITIAL_WIDTH;
  });
  const dragStateRef = useRef(
    null
  );
  useEffect(() => {
    if (typeof window === "undefined") return;
    const handle = window.setTimeout(() => {
      try {
        window.localStorage.setItem(
          ZIP_TREE_WIDTH_STORAGE_KEY,
          String(Math.round(treeWidth))
        );
      } catch {
      }
    }, ZIP_TREE_WIDTH_PERSIST_DEBOUNCE_MS);
    return () => window.clearTimeout(handle);
  }, [treeWidth]);
  const computeMaxTreeWidth = () => {
    const totalWidth = frameRef.current?.getBoundingClientRect().width ?? 0;
    return Math.max(ZIP_TREE_MIN_WIDTH, totalWidth - ZIP_TREE_MIN_PREVIEW);
  };
  const onSplitterPointerDown = (ev) => {
    ev.preventDefault();
    ev.currentTarget.setPointerCapture(ev.pointerId);
    dragStateRef.current = {
      startX: ev.clientX,
      startWidth: treeWidth,
      maxWidth: computeMaxTreeWidth()
    };
  };
  const onSplitterPointerMove = (ev) => {
    const drag2 = dragStateRef.current;
    if (!drag2) return;
    if (!ev.currentTarget.hasPointerCapture(ev.pointerId)) return;
    const delta = ev.clientX - drag2.startX;
    const next = Math.min(Math.max(drag2.startWidth + delta, ZIP_TREE_MIN_WIDTH), drag2.maxWidth);
    setTreeWidth(next);
  };
  const onSplitterPointerUp = (ev) => {
    if (ev.currentTarget.hasPointerCapture(ev.pointerId)) {
      ev.currentTarget.releasePointerCapture(ev.pointerId);
    }
    dragStateRef.current = null;
  };
  const onSplitterKeyDown = (ev) => {
    if (ev.key !== "ArrowLeft" && ev.key !== "ArrowRight") return;
    ev.preventDefault();
    const max = computeMaxTreeWidth();
    setTreeWidth((current) => {
      const step = ev.key === "ArrowLeft" ? -ZIP_SPLITTER_KEY_STEP : ZIP_SPLITTER_KEY_STEP;
      return Math.min(Math.max(current + step, ZIP_TREE_MIN_WIDTH), max);
    });
  };
  const onSplitterDoubleClick = () => {
    setTreeWidth(ZIP_TREE_INITIAL_WIDTH);
  };
  if (isLoading) return /* @__PURE__ */ jsx(LoadingShell, { className, style, id });
  if (error) return /* @__PURE__ */ jsx(ErrorShell, { className, style, id, message: error });
  if (treeError)
    return /* @__PURE__ */ jsx(ErrorShell, { className, style, id, message: treeError });
  if (!entries) return null;
  const toggleFolder = (path) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(path)) next.delete(path);
      else next.add(path);
      return next;
    });
  };
  const selectedBytes = selected !== null ? entries[selected] ?? null : null;
  const selectedLeafName = selected !== null ? leafName(selected) : "";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: frameRef,
      id,
      className: mergeClasses(styles.zipFrame, className),
      style: { ...style, height: maxHeight },
      children: [
        /* @__PURE__ */ jsx("div", { className: styles.zipTree, style: { width: `${treeWidth}px` }, children: tree.length === 0 ? /* @__PURE__ */ jsx("div", { className: styles.zipEmpty, children: /* @__PURE__ */ jsx("span", { children: "Archive is empty." }) }) : tree.map((node) => /* @__PURE__ */ jsx(
          ZipTreeNode,
          {
            node,
            depth: 0,
            expanded,
            selected,
            onToggle: toggleFolder,
            onSelect: setSelected
          },
          node.fullPath
        )) }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: styles.zipSplitter,
            role: "separator",
            "aria-orientation": "vertical",
            "aria-label": t("app.components.file-viewer.resize-tree"),
            "aria-valuenow": Math.round(treeWidth),
            "aria-valuemin": ZIP_TREE_MIN_WIDTH,
            tabIndex: 0,
            onPointerDown: onSplitterPointerDown,
            onPointerMove: onSplitterPointerMove,
            onPointerUp: onSplitterPointerUp,
            onPointerCancel: onSplitterPointerUp,
            onKeyDown: onSplitterKeyDown,
            onDoubleClick: onSplitterDoubleClick,
            children: /* @__PURE__ */ jsx("span", { className: styles.zipSplitterGrip, "aria-hidden": true })
          }
        ),
        /* @__PURE__ */ jsx("div", { className: styles.zipPreview, children: selectedBytes ? /* @__PURE__ */ jsx(
          FileViewer,
          {
            source: { kind: "bytes", value: selectedBytes, fileName: selectedLeafName },
            fileName: selectedLeafName,
            maxHeight: "100%"
          },
          selected
        ) : /* @__PURE__ */ jsxs("div", { className: styles.zipEmpty, children: [
          /* @__PURE__ */ jsx(DocumentArrowLeft24Regular, {}),
          /* @__PURE__ */ jsx("span", { children: "Select a file to preview." })
        ] }) }),
        downloadable && /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
      ]
    }
  );
}
function ZipEntryIcon({ fileName, className }) {
  switch (getFileExtension(fileName)) {
    case "pdf":
      return /* @__PURE__ */ jsx(DocumentPdf20Regular, { className });
    case "xls":
    case "xlsx":
    case "csv":
    case "ods":
      return /* @__PURE__ */ jsx(DocumentTable20Regular, { className });
    case "ppt":
    case "pptx":
    case "odp":
      return /* @__PURE__ */ jsx(SlideText20Regular, { className });
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "bmp":
    case "webp":
    case "svg":
    case "ico":
    case "tif":
    case "tiff":
      return /* @__PURE__ */ jsx(Image20Regular, { className });
    case "mp4":
    case "mov":
    case "avi":
    case "mkv":
    case "webm":
    case "m4v":
      return /* @__PURE__ */ jsx(Video20Regular, { className });
    case "mp3":
    case "wav":
    case "ogg":
    case "flac":
    case "m4a":
    case "aac":
      return /* @__PURE__ */ jsx(MusicNote220Regular, { className });
    case "zip":
    case "7z":
    case "rar":
    case "tar":
    case "gz":
      return /* @__PURE__ */ jsx(FolderZip20Regular, { className });
    case "txt":
    case "md":
    case "markdown":
    case "log":
    case "json":
    case "xml":
    case "yaml":
    case "yml":
    case "html":
    case "htm":
    case "js":
    case "ts":
    case "cs":
    case "css":
      return /* @__PURE__ */ jsx(DocumentText20Regular, { className });
    default:
      return /* @__PURE__ */ jsx(Document20Regular, { className });
  }
}
function ZipTreeNode({ node, depth, expanded, selected, onToggle, onSelect }) {
  const styles = useFileViewerStyles();
  const isExpanded = expanded.has(node.fullPath);
  const isSelected = !node.isFolder && node.fullPath === selected;
  const indent = { paddingLeft: `${depth * 20}px` };
  if (node.isFolder) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: styles.zipRow,
          role: "button",
          tabIndex: 0,
          onClick: () => onToggle(node.fullPath),
          onKeyDown: (ev) => {
            if (ev.key === "Enter" || ev.key === " ") {
              ev.preventDefault();
              onToggle(node.fullPath);
            }
          },
          style: indent,
          children: [
            /* @__PURE__ */ jsx("span", { className: styles.zipChevron, children: isExpanded ? /* @__PURE__ */ jsx(ChevronDown20Regular, {}) : /* @__PURE__ */ jsx(ChevronRight20Regular, {}) }),
            /* @__PURE__ */ jsx(Folder20Regular, { className: styles.zipIconAccent }),
            /* @__PURE__ */ jsx("span", { className: styles.zipName, children: node.name })
          ]
        }
      ),
      isExpanded && node.children.map((child) => /* @__PURE__ */ jsx(
        ZipTreeNode,
        {
          node: child,
          depth: depth + 1,
          expanded,
          selected,
          onToggle,
          onSelect
        },
        child.fullPath
      ))
    ] });
  }
  return /* @__PURE__ */ jsx(Tooltip, { relationship: "description", content: `Size: ${formatSize(node.size)}`, children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses(styles.zipRow, isSelected && styles.zipRowSelected),
      role: "button",
      tabIndex: 0,
      onClick: () => onSelect(node.fullPath),
      onKeyDown: (ev) => {
        if (ev.key === "Enter" || ev.key === " ") {
          ev.preventDefault();
          onSelect(node.fullPath);
        }
      },
      style: indent,
      children: [
        /* @__PURE__ */ jsx("span", { className: styles.zipChevronSpacer }),
        /* @__PURE__ */ jsx(ZipEntryIcon, { fileName: node.name, className: styles.zipIcon }),
        /* @__PURE__ */ jsx("span", { className: styles.zipName, children: node.name })
      ]
    }
  ) });
}
function buildZipTree(entries) {
  const root = [];
  for (const [path, bytes] of Object.entries(entries)) {
    const normalized = path.replace(/\\/g, "/");
    const isExplicitFolder = normalized.endsWith("/");
    const segments = normalized.split("/").filter(Boolean);
    if (segments.length === 0) continue;
    let current = root;
    let runningPath = "";
    for (let i = 0; i < segments.length - 1; i++) {
      const folderName = segments[i];
      runningPath = runningPath.length === 0 ? folderName : `${runningPath}/${folderName}`;
      let folder = current.find((n) => n.isFolder && n.name === folderName);
      if (!folder) {
        folder = { name: folderName, fullPath: runningPath, isFolder: true, size: 0, children: [] };
        current.push(folder);
      }
      current = folder.children;
    }
    const leaf = segments[segments.length - 1];
    if (isExplicitFolder) {
      if (!current.some((n) => n.isFolder && n.name === leaf)) {
        const folderPath = segments.join("/");
        current.push({ name: leaf, fullPath: folderPath, isFolder: true, size: 0, children: [] });
      }
    } else {
      current.push({
        name: leaf,
        fullPath: path,
        isFolder: false,
        size: bytes.length,
        children: []
      });
    }
  }
  sortZipNodes(root);
  return root;
}
function sortZipNodes(nodes) {
  nodes.sort((a, b) => {
    if (a.isFolder !== b.isFolder) return a.isFolder ? -1 : 1;
    return a.name.localeCompare(b.name, void 0, { sensitivity: "base" });
  });
  for (const node of nodes) {
    if (node.isFolder) sortZipNodes(node.children);
  }
}
function leafName(fullPath) {
  const trimmed = fullPath.endsWith("/") ? fullPath.slice(0, -1) : fullPath;
  const idx = trimmed.lastIndexOf("/");
  return idx < 0 ? trimmed : trimmed.slice(idx + 1);
}
function formatSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  let value2 = bytes;
  for (const unit of ["KB", "MB", "GB", "TB"]) {
    value2 /= 1024;
    if (value2 < 1024 || unit === "TB") return `${value2.toFixed(1)} ${unit}`;
  }
  return `${bytes} B`;
}
function DownloadCard({
  source,
  fileName,
  mimeType,
  className,
  style,
  id
}) {
  const styles = useFileViewerStyles();
  return /* @__PURE__ */ jsxs("div", { id, className: mergeClasses(styles.card, className), style, children: [
    /* @__PURE__ */ jsx(Document20Regular, { className: styles.cardIcon }),
    /* @__PURE__ */ jsxs("div", { className: styles.cardBody, children: [
      /* @__PURE__ */ jsx("div", { className: styles.cardName, children: fileName }),
      /* @__PURE__ */ jsx("div", { className: styles.cardMime, children: mimeType })
    ] }),
    /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
  ] });
}
function LoadingShell({
  className,
  style,
  id
}) {
  const styles = useFileViewerStyles();
  return /* @__PURE__ */ jsx("div", { id, className: mergeClasses(styles.statusShell, className), style, children: /* @__PURE__ */ jsx(Spinner, { size: "small" }) });
}
function ErrorShell({
  className,
  style,
  id,
  message
}) {
  const styles = useFileViewerStyles();
  return /* @__PURE__ */ jsxs("div", { id, className: mergeClasses(styles.statusShell, styles.errorShell, className), style, children: [
    /* @__PURE__ */ jsx(ErrorCircle20Regular, {}),
    /* @__PURE__ */ jsx("span", { children: message })
  ] });
}
function HighlightedCodeBlock({ html }) {
  const styles = useFileViewerStyles();
  const { probeRef, isDark } = useFluentColorScheme();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses(styles.codeHost, isDark ? styles.codeHostDark : styles.codeHostLight),
      children: [
        /* @__PURE__ */ jsx("span", { ref: probeRef, className: styles.themeProbe, "aria-hidden": true }),
        /* @__PURE__ */ jsx("pre", { children: /* @__PURE__ */ jsx("code", { className: "hljs", dangerouslySetInnerHTML: { __html: html } }) })
      ]
    }
  );
}
function useFluentColorScheme() {
  const probeRef = useRef(null);
  const [isDark, setIsDark] = useState(false);
  useLayoutEffect(() => {
    const probe = probeRef.current;
    if (!probe) return;
    const measure = () => {
      const bg = window.getComputedStyle(probe).backgroundColor;
      const match = /^rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(bg);
      if (!match) return;
      const r = Number(match[1]);
      const g = Number(match[2]);
      const b = Number(match[3]);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      setIsDark(luminance < 0.5);
    };
    measure();
    const observer = new MutationObserver(measure);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true
    });
    return () => observer.disconnect();
  }, []);
  return { probeRef, isDark };
}
function useFileText(source) {
  const fetchUrl = source.kind === "url" ? source.value : null;
  const [urlState, setUrlState] = useState({
    text: null,
    error: null,
    isLoading: fetchUrl !== null
  });
  useEffect(() => {
    if (fetchUrl === null) {
      setUrlState({ text: null, error: null, isLoading: false });
      return;
    }
    let canceled = false;
    setUrlState({ text: null, error: null, isLoading: true });
    (async () => {
      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        const text2 = await response.text();
        if (canceled) return;
        setUrlState({ text: text2, error: null, isLoading: false });
      } catch (err) {
        if (canceled) return;
        setUrlState({
          text: null,
          error: err instanceof Error ? err.message : "Failed to load file.",
          isLoading: false
        });
      }
    })();
    return () => {
      canceled = true;
    };
  }, [fetchUrl]);
  const inlineValue = source.kind === "url" ? null : source.value;
  const inlineKind = source.kind;
  return useMemo(() => {
    if (inlineKind === "url") return urlState;
    try {
      const text2 = inlineKind === "base64" ? base64ToText(inlineValue) : bytesToText(inlineValue);
      return { text: text2, error: null, isLoading: false };
    } catch (err) {
      return {
        text: null,
        error: err instanceof Error ? err.message : "Failed to decode file.",
        isLoading: false
      };
    }
  }, [inlineKind, inlineValue, urlState]);
}
function useFileBytes(source) {
  const fetchUrl = source.kind === "url" ? source.value : null;
  const [urlState, setUrlState] = useState({
    bytes: null,
    error: null,
    isLoading: fetchUrl !== null
  });
  useEffect(() => {
    if (fetchUrl === null) {
      setUrlState({ bytes: null, error: null, isLoading: false });
      return;
    }
    let canceled = false;
    setUrlState({ bytes: null, error: null, isLoading: true });
    (async () => {
      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const buffer = await response.arrayBuffer();
        if (canceled) return;
        setUrlState({ bytes: new Uint8Array(buffer), error: null, isLoading: false });
      } catch (err) {
        if (canceled) return;
        setUrlState({
          bytes: null,
          error: err instanceof Error ? err.message : "Failed to load file.",
          isLoading: false
        });
      }
    })();
    return () => {
      canceled = true;
    };
  }, [fetchUrl]);
  const inlineValue = source.kind === "url" ? null : source.value;
  const inlineKind = source.kind;
  return useMemo(() => {
    if (inlineKind === "url") return urlState;
    try {
      const bytes = inlineKind === "base64" ? base64ToBytes(inlineValue) : inlineValue;
      return { bytes, error: null, isLoading: false };
    } catch (err) {
      return {
        bytes: null,
        error: err instanceof Error ? err.message : "Failed to decode file.",
        isLoading: false
      };
    }
  }, [inlineKind, inlineValue, urlState]);
}
function useObjectUrl(source, mimeType) {
  const inlineValue = source.kind === "url" ? null : source.value;
  const inlineKind = source.kind;
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (inlineKind === "url" || inlineValue === null) {
      setUrl(null);
      return;
    }
    const bytes = inlineKind === "base64" ? base64ToBytes(inlineValue) : inlineValue;
    const blob = new Blob([bytes.buffer], { type: mimeType });
    const next = URL.createObjectURL(blob);
    setUrl(next);
    return () => {
      URL.revokeObjectURL(next);
    };
  }, [inlineKind, inlineValue, mimeType]);
  return url;
}
function useHighlightedHtml(text2, language) {
  return useMemo(
    () => text2 === null ? null : highlightToHtml(text2, language),
    [text2, language]
  );
}
async function downloadFileSource(source, fileName) {
  if (source.kind === "url") {
    const anchor = document.createElement("a");
    anchor.href = source.value;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    return;
  }
  const bytes = source.kind === "base64" ? base64ToBytes(source.value) : source.value;
  triggerBlobDownload(bytes, fileName);
}
var useFileViewerStyles = makeStyles({
  wrapper: {
    width: "100%"
  },
  imageCenter: {
    // Left-align the framed `ImageViewer` (which is `inline-flex` and
    // shrink-to-content) inside its parent. Previously this wrapper centered
    // the image horizontally for the zip-preview case where the parent
    // provided a fixed height — but the zip viewer now renders image entries
    // through a different code path (see ZipViewer), so the centering only
    // affected the standalone image arm, where the parent always collapses
    // to content height. `flex-start` keeps the image hugging the left edge
    // of its column under the Section's column-flex layout. The class
    // name stays `imageCenter` for continuity with the surrounding code;
    // the styling no longer centers.
    display: "flex",
    justifyContent: "flex-start",
    width: "100%"
  },
  codeFrame: {
    position: "relative",
    overflow: "auto",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2
  },
  codeHost: {
    // Position relative so the absolutely-placed theme probe sits inside our
    // box. Column-flex chain so the inner <pre> (the actual scrollable content
    // surface) can stretch to fill the host. `height: 100%` resolves to
    // `auto` when the parent has no defined height — keeps non-zip usage
    // sized to content. minHeight: 0 lets `overflow:auto` on the pre take
    // effect instead of pushing the host taller than the parent.
    position: "relative",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 0,
    "& pre": {
      margin: 0,
      padding: tokens.spacingHorizontalM,
      fontFamily: tokens.fontFamilyMonospace,
      fontSize: tokens.fontSizeBase200,
      lineHeight: tokens.lineHeightBase200,
      // Claim the remaining height in the column-flex chain and own the
      // scroll. Without `flex: 1` the pre would shrink to its content height
      // and leave the host's background visible below it.
      flex: "1 1 auto",
      minHeight: 0,
      overflow: "auto",
      // The code surface sits on the neutral-1 layer; the surrounding
      // `codeFrame` uses neutral-2 so the two read as nested panes. Token
      // colors come from the palette below; the base text color is the
      // theme's foreground.
      backgroundColor: tokens.colorNeutralBackground1,
      color: tokens.colorNeutralForeground1
    },
    "& code.hljs": {
      background: "transparent",
      padding: 0
    }
  },
  // github.css-inspired light palette. Syntax tokens are a semantic
  // palette (not expressible as neutral design tokens), so hex literals
  // are appropriate here — same exception the FluentMessageBar intent
  // colors take.
  codeHostLight: {
    "& .hljs-comment, & .hljs-quote": { color: "#6a737d", fontStyle: "italic" },
    "& .hljs-keyword, & .hljs-selector-tag, & .hljs-literal, & .hljs-section, & .hljs-doctag": {
      color: "#d73a49"
    },
    "& .hljs-string, & .hljs-attr, & .hljs-attribute, & .hljs-addition, & .hljs-template-tag": {
      color: "#032f62"
    },
    "& .hljs-number, & .hljs-symbol, & .hljs-bullet, & .hljs-meta, & .hljs-link": {
      color: "#005cc5"
    },
    "& .hljs-title, & .hljs-type, & .hljs-built_in": { color: "#6f42c1" },
    "& .hljs-tag .hljs-name, & .hljs-variable, & .hljs-template-variable, & .hljs-params": {
      color: "#e36209"
    },
    "& .hljs-regexp, & .hljs-deletion": { color: "#b31d28" },
    "& .hljs-strong": { fontWeight: "bold" },
    "& .hljs-emphasis": { fontStyle: "italic" }
  },
  // github-dark.css-inspired dark palette.
  codeHostDark: {
    "& .hljs-comment, & .hljs-quote": { color: "#8b949e", fontStyle: "italic" },
    "& .hljs-keyword, & .hljs-selector-tag, & .hljs-literal, & .hljs-section, & .hljs-doctag": {
      color: "#ff7b72"
    },
    "& .hljs-string, & .hljs-attr, & .hljs-attribute, & .hljs-addition, & .hljs-template-tag": {
      color: "#a5d6ff"
    },
    "& .hljs-number, & .hljs-symbol, & .hljs-bullet, & .hljs-meta, & .hljs-link": {
      color: "#79c0ff"
    },
    "& .hljs-title, & .hljs-type, & .hljs-built_in": { color: "#d2a8ff" },
    "& .hljs-tag .hljs-name, & .hljs-variable, & .hljs-template-variable, & .hljs-params": {
      color: "#ffa657"
    },
    "& .hljs-regexp, & .hljs-deletion": { color: "#ffa198" },
    "& .hljs-strong": { fontWeight: "bold" },
    "& .hljs-emphasis": { fontStyle: "italic" }
  },
  themeProbe: {
    // Hidden 1×1 probe carrying `tokens.colorNeutralBackground1` so the
    // luminance check in `useFluentColorScheme` resolves the active theme.
    // Visibility-hidden (not display-none) so getComputedStyle returns the
    // resolved color in every browser.
    position: "absolute",
    visibility: "hidden",
    pointerEvents: "none",
    width: "1px",
    height: "1px",
    backgroundColor: tokens.colorNeutralBackground1
  },
  fallbackPre: {
    margin: 0,
    padding: tokens.spacingHorizontalM,
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    whiteSpace: "pre",
    overflow: "auto"
  },
  markdownFrame: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1,
    overflow: "hidden",
    // Claim full parent height when there is one. Resolves to `auto` (i.e.
    // shrink-to-content) when the parent's height is undefined, so default
    // non-zip usage still sizes to the markdown content.
    height: "100%"
  },
  markdownBody: {
    overflow: "auto",
    borderTop: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    // Fills the remaining frame height inside the column-flex parent
    // pairs with `markdownFrame: height 100%` so the Source tab's pre
    // (and the Preview tab's content) get a real container height to
    // anchor against. minHeight: 0 lets overflow:auto kick in instead of
    // being suppressed by the flex child's content-min-size default.
    flex: "1 1 auto",
    minHeight: 0,
    display: "flex",
    flexDirection: "column"
  },
  markdownPreview: {
    padding: tokens.spacingHorizontalL,
    fontFamily: tokens.fontFamilyBase,
    color: tokens.colorNeutralForeground1,
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      marginTop: tokens.spacingVerticalL,
      marginBottom: tokens.spacingVerticalS
    },
    "& p": {
      marginTop: 0,
      marginBottom: tokens.spacingVerticalM,
      lineHeight: tokens.lineHeightBase300
    },
    "& code": {
      fontFamily: tokens.fontFamilyMonospace,
      fontSize: "0.9em",
      padding: `0 ${tokens.spacingHorizontalXS}`,
      backgroundColor: tokens.colorNeutralBackground3,
      borderRadius: tokens.borderRadiusSmall
    },
    "& pre": {
      padding: tokens.spacingHorizontalM,
      backgroundColor: tokens.colorNeutralBackground3,
      borderRadius: tokens.borderRadiusMedium,
      overflow: "auto"
    },
    "& pre code": {
      padding: 0,
      backgroundColor: "transparent"
    },
    "& a": {
      color: tokens.colorBrandForegroundLink
    },
    "& blockquote": {
      margin: 0,
      paddingLeft: tokens.spacingHorizontalM,
      borderLeft: `${tokens.strokeWidthThicker} solid ${tokens.colorNeutralStroke2}`,
      color: tokens.colorNeutralForeground2
    },
    "& table": {
      borderCollapse: "collapse"
    },
    "& th, & td": {
      padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
      border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`
    }
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: tokens.borderRadiusMedium
  },
  // Anchor the download overlay against the iframe's host. The iframe itself
  // can't host the positioned button — its absolute children would target
  // its embedded document, not the page — so we wrap one layer up.
  embeddedWrapper: {
    position: "relative",
    width: "100%",
    boxSizing: "border-box"
  },
  // Corner download icon button. Mirrors the
  // metrics: top:4 right:4, layer-1 background, subtle button appearance so
  // it sits over the viewer body without competing for attention.
  downloadOverlay: {
    position: "absolute",
    top: "4px",
    right: "4px",
    zIndex: 1,
    backgroundColor: tokens.colorNeutralBackground1
  },
  card: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    padding: tokens.spacingHorizontalM,
    // Reserve right-side room for the corner download icon so the file
    // name / MIME row doesn't slide under the overlay button on narrow
    // widths.
    paddingRight: tokens.spacingHorizontalXXXL,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2,
    position: "relative"
  },
  cardIcon: {
    flexShrink: 0,
    color: tokens.colorNeutralForeground2
  },
  cardBody: {
    flex: "1 1 auto",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXXS
  },
  cardName: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  cardMime: {
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3
  },
  statusShell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.spacingHorizontalS,
    padding: tokens.spacingHorizontalL,
    minHeight: "120px",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2
  },
  errorShell: {
    color: tokens.colorPaletteRedForeground1
  },
  zipFrame: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    minHeight: "0",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1,
    overflow: "hidden"
  },
  zipTree: {
    flexShrink: 0,
    overflow: "auto",
    backgroundColor: tokens.colorNeutralBackground2
    // Width is set inline by ZipViewer (driven by the splitter); we just
    // own the scroll + background here.
  },
  zipSplitter: {
    flexShrink: 0,
    width: "6px",
    cursor: "col-resize",
    position: "relative",
    backgroundColor: tokens.colorNeutralStroke2,
    transitionProperty: "background-color",
    transitionDuration: tokens.durationFast,
    ":hover": {
      backgroundColor: tokens.colorBrandStroke2
    },
    ":focus-visible": {
      outline: `${tokens.strokeWidthThick} solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "0"
    },
    // Wider invisible hit-target so the divider grabs cleanly even on
    // trackpads where 6px is unforgiving. The visible bar stays 6px;
    // ::before extends the hover/grab area ±4px on each side.
    "::before": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      left: "-4px",
      right: "-4px"
    }
  },
  zipSplitterGrip: {
    // Subtle three-dot grip in the middle of the divider; visual only,
    // pointer-events pass through to the splitter container.
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "2px",
    height: "24px",
    borderRadius: tokens.borderRadiusCircular,
    backgroundColor: tokens.colorNeutralForeground3,
    pointerEvents: "none",
    opacity: 0.5
  },
  zipPreview: {
    flex: "1 1 auto",
    minWidth: "0",
    overflow: "auto",
    padding: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground1
  },
  zipRow: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
    cursor: "pointer",
    userSelect: "none",
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground2Hover
    },
    ":focus-visible": {
      outline: `${tokens.strokeWidthThin} solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "-1px"
    }
  },
  // Selection style ported from the Blazor zip viewer: a subtle accent tint over
  // the row (text stays its normal color), intensifying slightly on hover so the
  // neutral row-hover doesn't wash out the selection.
  zipRowSelected: {
    backgroundColor: `color-mix(in srgb, ${tokens.colorBrandBackground} 12%, transparent)`,
    ":hover": {
      backgroundColor: `color-mix(in srgb, ${tokens.colorBrandBackground} 18%, transparent)`
    }
  },
  zipChevron: {
    flexShrink: 0,
    display: "inline-flex",
    width: "20px",
    height: "20px",
    alignItems: "center",
    justifyContent: "center",
    color: tokens.colorNeutralForeground3
  },
  zipChevronSpacer: {
    flexShrink: 0,
    width: "20px",
    height: "20px"
  },
  zipIcon: {
    flexShrink: 0,
    color: tokens.colorNeutralForeground3
  },
  zipIconAccent: {
    flexShrink: 0,
    color: tokens.colorBrandForeground1
  },
  zipName: {
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  zipEmpty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingHorizontalL,
    minHeight: "160px",
    color: tokens.colorNeutralForeground3,
    textAlign: "center"
  }
});
function FileEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  accept,
  maxFileSizeBytes,
  uploadHintText,
  onUploaded,
  validate
}) {
  const { value: value2, setValue: rawSetValue, fileId, hydrateValue } = useFileColumn(columnName);
  const { record } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const { ppp } = usePowerPortalsPro();
  const styles = useFileEditStyles();
  const t = useT();
  const reactId = useId();
  const inputId = id ?? reactId;
  const [isDownloading, setIsDownloading] = useState(false);
  const [isLoadingMetadata, setIsLoadingMetadata] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [previewSource, setPreviewSource] = useState(null);
  useEffect(() => {
    if (value2) return;
    if (!fileId) return;
    if (!record?.tableName || !record.id) return;
    if (record.id === EMPTY_GUID) return;
    let canceled = false;
    setIsLoadingMetadata(true);
    (async () => {
      try {
        const info = await ppp.getFileInfoAsync(record.tableName, record.id, columnName, false);
        if (canceled) return;
        if (info.fileName) {
          hydrateValue({
            fileName: info.fileName,
            id: fileId,
            value: null
          });
        }
      } catch (err) {
        if (canceled) return;
        console.warn(`PowerPortalsPro FileEdit: metadata fetch failed for ${columnName}`, err);
      } finally {
        if (!canceled) setIsLoadingMetadata(false);
      }
    })();
    return () => {
      canceled = true;
    };
  }, [columnName, fileId, hydrateValue, ppp, record?.id, record?.tableName, value2]);
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const isInteractable = !resolvedReadOnly && !resolvedDisabled;
  const readOnlyView = resolvedReadOnly && !resolvedDisabled;
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "string",
      required: resolvedRequired,
      label: resolvedLabel,
      // The required check just needs "is there a value" semantics; the file
      // name is the natural sentinel — empty string means no file, present
      // means there is one. Using the string-kind validator avoids defining
      // a dedicated `file` kind that has the same required-only behavior.
      value: value2?.fileName ?? ""
    },
    validate
  );
  const upload = useFileUpload({
    setValue,
    enabled: isInteractable,
    warnPrefix: "PowerPortalsPro FileEdit",
    ...maxFileSizeBytes !== void 0 && { maxFileSizeBytes },
    ...onUploaded !== void 0 && { onUploaded }
  });
  const handleDownload = useCallback(async () => {
    if (!value2) return;
    setIsDownloading(true);
    try {
      const bytes = value2.value ? base64ToBytes(value2.value) : await fetchFileBytes(ppp, record?.tableName, record?.id, columnName);
      if (bytes === null) return;
      triggerBlobDownload(bytes, value2.fileName);
    } finally {
      setIsDownloading(false);
    }
  }, [columnName, ppp, record, value2]);
  const isPreviewable = useMemo(() => {
    if (!value2?.fileName) return false;
    const mime = getMimeFromFileName(value2.fileName);
    return categorizeFile({ mimeType: mime, fileName: value2.fileName }) !== "download";
  }, [value2?.fileName]);
  const handlePreview = useCallback(async () => {
    if (!value2) return;
    setIsPreviewLoading(true);
    try {
      let base64 = value2.value ?? null;
      let resolvedFileName = value2.fileName;
      if (!base64) {
        if (!record?.tableName || !record.id) return;
        const info = await ppp.getFileInfoAsync(record.tableName, record.id, columnName, true);
        if (!info.fileData) return;
        base64 = info.fileData;
        resolvedFileName = info.fileName || value2.fileName;
        hydrateValue({
          fileName: resolvedFileName,
          id: value2.id,
          value: base64
        });
      }
      const mime = getMimeFromFileName(resolvedFileName);
      setPreviewSource({
        kind: "base64",
        value: base64,
        mimeType: mime,
        fileName: resolvedFileName
      });
    } finally {
      setIsPreviewLoading(false);
    }
  }, [columnName, hydrateValue, ppp, record, value2]);
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const dropZoneClass = mergeClasses(
    styles.dropZone,
    upload.isDragOver && styles.dropZoneActive,
    !isInteractable && styles.dropZoneDisabled,
    className
  );
  return /* @__PURE__ */ jsxs(
    Field,
    {
      className: mergeClasses("ppp-file-edit", layoutClassName, stateClassName),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: [
        readOnlyView ? (
          // Read-only, the file is named in the read-only box, with its preview and download beside it.
          /* @__PURE__ */ jsxs("div", { className: mergeClasses(styles.wrapper, styles.readOnlyRow), style, children: [
            /* @__PURE__ */ jsx("div", { className: styles.readOnlyBox, children: /* @__PURE__ */ jsx(ReadOnlyValue, { id: inputId, ...resolvedLabel !== void 0 && { "aria-label": resolvedLabel }, children: value2?.fileName ?? "" }) }),
            value2 && /* @__PURE__ */ jsxs(Fragment, { children: [
              isPreviewable && /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(Eye20Regular, {}),
                  "aria-label": t("app.buttons.preview-item", [value2.fileName]),
                  disabled: isPreviewLoading,
                  onClick: () => void handlePreview()
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
                  "aria-label": t("app.buttons.download-item", [value2.fileName]),
                  disabled: isDownloading,
                  onClick: () => void handleDownload()
                }
              )
            ] })
          ] })
        ) : /* @__PURE__ */ jsxs("div", { className: styles.wrapper, style, children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              ref: upload.inputRef,
              id: inputId,
              type: "file",
              accept,
              disabled: !isInteractable,
              className: styles.hiddenInput,
              onChange: upload.onInputChange
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: dropZoneClass, ...upload.dropZoneHandlers, children: [
            /* @__PURE__ */ jsx("span", { className: mergeClasses(styles.dropZoneText, value2 && styles.fileName), children: value2 ? value2.fileName : fileId ? isLoadingMetadata ? t("app.components.file-edit.loading-metadata") : "" : uploadHintText ?? t("app.messages.file-upload-drop-zone") }),
            value2 && // Action overlay — top-right of the drop zone, sitting on top
            // of the filename text. Translucent backdrop + blur match
            // ImageEdit's overlay so the two edits look like siblings.
            // Each button stops click propagation so triggering an action
            // doesn't also fire the drop zone's "open file picker"
            // handler.
            /* @__PURE__ */ jsxs("div", { className: styles.actions, children: [
              isPreviewable && /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(Eye20Regular, {}),
                  "aria-label": t("app.buttons.preview-item", [value2.fileName]),
                  disabled: isPreviewLoading,
                  onClick: (ev) => {
                    ev.stopPropagation();
                    void handlePreview();
                  }
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
                  "aria-label": t("app.buttons.download-item", [value2.fileName]),
                  disabled: isDownloading,
                  onClick: (ev) => {
                    ev.stopPropagation();
                    void handleDownload();
                  }
                }
              ),
              isInteractable && /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(Dismiss20Regular, {}),
                  "aria-label": t("app.buttons.remove-item", [value2.fileName]),
                  onClick: (ev) => {
                    ev.stopPropagation();
                    setValue(null);
                  }
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsx(
          Dialog,
          {
            open: previewSource !== null,
            onOpenChange: (_, data) => {
              if (!data.open) setPreviewSource(null);
            },
            modalType: "modal",
            children: /* @__PURE__ */ jsx(DialogSurface, { className: styles.previewDialogSurface, children: previewSource && value2 && /* @__PURE__ */ jsxs(DialogBody, { children: [
              /* @__PURE__ */ jsx(DialogTitle, { children: value2.fileName }),
              /* @__PURE__ */ jsx(DialogContent, { className: styles.previewDialogContent, children: /* @__PURE__ */ jsx(FileViewer, { source: previewSource, fileName: value2.fileName }) }),
              /* @__PURE__ */ jsx(DialogActions, { children: /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: () => setPreviewSource(null), children: t("app.buttons.close.label") }) })
            ] }) })
          }
        )
      ]
    }
  );
}
var useFileEditStyles = makeStyles({
  wrapper: {
    width: "100%",
    // A grid item of the Field, which would otherwise widen to the drop zone's content — a long
    // file name, which doesn't wrap — and spill out of a narrow column instead of ellipsizing.
    minWidth: 0
  },
  readOnlyRow: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS
  },
  readOnlyBox: {
    flex: "1 1 auto",
    minWidth: 0
  },
  hiddenInput: {
    position: "absolute",
    width: "1px",
    height: "1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: "none"
  },
  dropZone: {
    // Position-relative so the action overlay can sit inside the drop
    // zone in the top-right corner. Mirrors ImageEdit's `previewFrame`
    // pattern so the two edits feel like siblings.
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "48px",
    paddingInline: tokens.spacingHorizontalM,
    paddingBlock: tokens.spacingVerticalM,
    cursor: "pointer",
    border: `${tokens.strokeWidthThin} dashed ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2,
    color: tokens.colorNeutralForeground1,
    transition: "background-color 0.15s ease, box-shadow 0.15s ease",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground2Hover
    },
    ":focus-visible": {
      outline: `${tokens.strokeWidthThick} solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "2px"
    }
  },
  // Active (drag-over) state. Inset box-shadow rather than overriding
  // borderColor avoids Griffel's strict-typing lockdown that bans mixing
  // `border` shorthand and `borderColor` longhand across rules in the
  // same `makeStyles` call.
  dropZoneActive: {
    backgroundColor: tokens.colorBrandBackground2,
    boxShadow: `inset 0 0 0 ${tokens.strokeWidthThick} ${tokens.colorBrandStroke1}`
  },
  dropZoneDisabled: {
    cursor: "not-allowed",
    opacity: 0.6,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground2
    }
  },
  dropZoneText: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    // The hint wraps in a narrow column, centered as the drop zone centers it.
    textAlign: "center"
  },
  fileName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    // Reserve space on the right for the action overlay so a long
    // filename ellipsizes before colliding with the buttons. ~120px
    // accommodates three buttons (Preview / Download / X) plus their
    // gaps + the overlay's own padding.
    paddingRight: "120px"
  },
  // Overlay corner toolbar — top-right of the drop zone, sitting on top
  // of the filename text. Translucent backdrop keeps the icons readable
  // against any background; rounded corners + soft shadow separate it
  // visually from the frame edge. Same look as ImageEdit's overlay.
  actions: {
    position: "absolute",
    top: tokens.spacingVerticalS,
    right: tokens.spacingHorizontalS,
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    paddingTop: "2px",
    paddingBottom: "2px",
    backgroundColor: tokens.colorNeutralBackgroundAlpha,
    backdropFilter: "blur(4px)",
    borderRadius: tokens.borderRadiusMedium,
    boxShadow: tokens.shadow4,
    // Sit above the filename text inside the frame's stacking context.
    zIndex: 1
  },
  // Preview dialog grows wider than Fluent's default surface so PDF /
  // markdown / image renderers have room to breathe. Capped at 90vw/90vh
  // so it stays inside the viewport on smaller screens.
  previewDialogSurface: {
    maxWidth: "min(1200px, 90vw)",
    width: "90vw"
  },
  previewDialogContent: {
    // Let the FileViewer's own inner scroll-area handle overflow; we just
    // need the content slot to not constrain it.
    overflow: "hidden",
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS
  }
});
var useStyles3 = makeStyles({
  // Shared scrim look. Both global (full-screen) and scoped variants reuse
  // these so the visual feel is identical — only the positioning differs.
  // Theme-aware translucent backdrop drawn via a `::before` pseudo-element
  // so the spinner + description above stay at full opacity (the same
  // pattern the grid's refetch scrim uses). `colorNeutralBackground2` matches
  // token and swaps with FluentDesignTheme's
  // light/dark state — light gray in light theme, near-black in dark
  // theme — so the overlay reads as a soft neutral tint instead of a
  // hardcoded black film over whatever's behind. `pointerEvents: 'auto'`
  // blocks accidental clicks on the dimmed content underneath.
  scrim: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    rowGap: tokens.spacingVerticalM,
    pointerEvents: "auto",
    "::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      backgroundColor: tokens.colorNeutralBackground2,
      opacity: 0.7,
      zIndex: -1
    }
  },
  // Above a Fluent v9 dialog, which renders into a portal mount node carrying `zIndex: 1000000`
  // (@fluentui/react-portal, usePortalMountNodeStyles) — so a save started from a record panel
  // covers that panel instead of leaving it lit and clickable.
  //
  // It can compete from here, rather than needing a portal of its own, because this scrim stays
  // inside the FluentProvider — which sets no z-index and so creates no stacking context — while
  // the portal's mount node is a sibling on document.body, so both land in the root stacking
  // context. Staying inside the provider is also what keeps the theme tokens resolving; a scrim
  // portalled to the body would lose them.
  global: {
    position: "fixed",
    inset: 0,
    zIndex: 1000001
  },
  // Under the dialog layer, for while a message the user has to read and answer is on screen.
  // Covering that would leave its button unreachable and the operation waiting on a click that
  // can never happen.
  globalUnderDialogs: {
    zIndex: 2e3
  },
  scoped: {
    position: "absolute",
    inset: 0,
    // Below the global overlay so a global save during a scoped load
    // visually layers on top.
    zIndex: 100
  },
  description: {
    // Foreground reads against `colorNeutralBackground2`, NOT a brand-
    // colored backdrop — so use the standard neutral foreground token
    // (was `colorNeutralForegroundOnBrand`, which is the white-on-blue
    // pairing that mismatched the new neutral scrim).
    color: tokens.colorNeutralForeground1,
    fontWeight: tokens.fontWeightSemibold
  },
  scopedHost: {
    position: "relative"
  }
});
function FluentOverlayProvider({ children }) {
  const ctxValue = useOverlayServiceState();
  return /* @__PURE__ */ jsxs(OverlayServiceProvider, { value: ctxValue, children: [
    children,
    /* @__PURE__ */ jsx(GlobalOverlayLayer, {})
  ] });
}
function GlobalOverlayLayer() {
  const styles = useStyles3();
  const overlay = useOverlayForTarget(void 0);
  const dialogOpen = useIsDialogOpen();
  if (!overlay) return null;
  return /* @__PURE__ */ jsx(
    ScrimContent,
    {
      overlay,
      className: mergeClasses(
        styles.scrim,
        styles.global,
        dialogOpen && styles.globalUnderDialogs
      )
    }
  );
}
function FluentOverlayTarget({
  targetId,
  children,
  className,
  style,
  rootRef
}) {
  const styles = useStyles3();
  const overlay = useOverlayForTarget(targetId);
  return /* @__PURE__ */ jsxs("div", { ref: rootRef, className: mergeClasses("ppp-overlay-target", styles.scopedHost, className), style, children: [
    children,
    overlay && /* @__PURE__ */ jsx(ScrimContent, { overlay, className: mergeClasses(styles.scrim, styles.scoped) })
  ] });
}
function ScrimContent({ overlay, className }) {
  const styles = useStyles3();
  const showProgress = overlay.showProgress !== false;
  return /* @__PURE__ */ jsxs("div", { className, role: "status", "aria-live": "polite", children: [
    showProgress && /* @__PURE__ */ jsx(Spinner, { size: "large" }),
    overlay.description && /* @__PURE__ */ jsx("span", { className: styles.description, children: overlay.description })
  ] });
}
var PagingMode = {
  /** Classic pager — Prev / Next / page-size selector at the bottom. */
  Paged: "paged",
  /**
   * Infinite scroll. The pager footer is hidden, rows accumulate across page
   * boundaries, and a new page is fetched automatically when the user
   * scrolls past the rendered bottom. Use for long lists where the user
   * scans rather than navigates by page.
   */
  Virtualize: "virtualize"
};
var ViewSort = {
  /** Server-returned order, plus custom views appended in declaration order. */
  Default: "default",
  /** Localized display name, ascending (the framework default). */
  NameAscending: "nameAscending",
  /** Localized display name, descending. */
  NameDescending: "nameDescending"
};
function viewLayoutOf(view) {
  const arranged = view.pageSize !== void 0 || view.layout !== void 0 || (view.groupLevels?.length ?? 0) > 0 || view.columns.some(
    (column) => column.hidden || column.pin !== void 0 || (column.aggregates?.length ?? 0) > 0 || !!column.displayLabel?.trim()
  );
  if (!arranged) return void 0;
  return {
    version: 1,
    ...view.pageSize !== void 0 && { pageSize: view.pageSize },
    ...view.layout !== void 0 && { layout: view.layout },
    groupBy: [...view.groupLevels ?? []],
    // Its own columns, without what they leave unset; each figure once, in the footer's order, with
    // the format it gives — an empty one too, for the column's own in place of the page's — and the
    // width in whole pixels, as the C# twin reads it.
    columns: view.columns.map((column) => {
      const formats = /* @__PURE__ */ new Map();
      for (const { aggregate, format } of column.aggregates ?? []) {
        if (format !== void 0 && !formats.has(aggregate)) formats.set(aggregate, format);
      }
      const aggregates = aggregatesToTotals((column.aggregates ?? []).reduce((all, x) => all | x.aggregate, 0), formats);
      const width = typeof column.width === "number" && Math.round(column.width) > 0 ? Math.round(column.width) : void 0;
      return {
        columnName: column.columnName,
        ...width !== void 0 && { width },
        ...column.hidden && { hidden: true },
        ...column.pin && { pin: column.pin },
        ...aggregates && { aggregates },
        ...column.displayLabel?.trim() && { displayLabel: column.displayLabel }
      };
    })
  };
}
function formatsOf(infos) {
  const formats = /* @__PURE__ */ new Map();
  for (const info of infos) {
    const format = info.format?.trim();
    if (format && !formats.has(info.aggregate)) formats.set(info.aggregate, format);
  }
  return formats;
}
function resolveViewLabel(view, t) {
  const key3 = `tables.${view.tableName}.views.${view.id}.label`;
  const localized = t(key3);
  if (localized !== key3) return localized;
  return view.displayName?.trim() ? view.displayName : null;
}
function viewLabelOf(view, t) {
  return resolveViewLabel(view, t) ?? (view.name?.trim() ? view.name : view.id);
}
function customToViewMetadata(custom) {
  return {
    id: custom.id,
    fetchXml: custom.fetchXml,
    tableName: custom.tableName,
    // A column given no width is drawn at the grid's own.
    columns: custom.columns.map((column) => ({ columnName: column.columnName, ...column.width !== void 0 && { width: column.width } })),
    displayName: custom.displayName ?? null,
    name: custom.displayName ?? custom.id,
    isDefault: false,
    quickFindCompatible: false,
    userDefined: true
  };
}
function isCustomViewId(viewId, customViewDefinitions) {
  if (!viewId || !customViewDefinitions) return false;
  for (const v of customViewDefinitions) {
    if (v.id === viewId) return true;
  }
  return false;
}
function sortViews(views, mode) {
  if (mode === ViewSort.Default) return [...views];
  const sorted = [...views];
  sorted.sort((a, b) => {
    const labelA = a.displayName ?? a.name ?? "";
    const labelB = b.displayName ?? b.name ?? "";
    return mode === ViewSort.NameAscending ? labelA.localeCompare(labelB) : labelB.localeCompare(labelA);
  });
  return sorted;
}
function composeViewsList(args) {
  const customs = (args.customViewDefinitions ?? []).map(customToViewMetadata);
  const all = [...args.dataverseViews, ...customs];
  const filtered = args.viewIds && args.viewIds.length > 0 ? all.filter((v) => args.viewIds.includes(v.id)) : all;
  return sortViews(filtered, args.viewSort);
}
var SAVED_VIEW_COLUMN_WIDTH = 150;
var sameId = (a, b) => a.toLowerCase() === b.toLowerCase();
var stringValue = (value2) => ({ $type: 14, value: value2 });
var boolValue = (value2) => ({ $type: 0, value: value2 });
var readString = (record, column) => {
  const value2 = record.properties?.[column]?.value;
  return typeof value2 === "string" ? value2 : void 0;
};
var readBool = (record, column) => record.properties?.[column]?.value === true;
function useSavedViews(options) {
  const { enabled, tableName, control } = options;
  const { ppp } = usePowerPortalsPro();
  const auth = useAuth();
  const signedIn = auth.status === AuthStatus.Authenticated;
  const ownedByCaller = signedIn && (auth.user.portalUserType ?? PortalUserType.Contact) !== PortalUserType.Contact;
  const active = enabled && !!tableName && signedIn;
  const needsSignIn = enabled && !!tableName && auth.status === AuthStatus.Anonymous;
  const [state, setState] = useState(null);
  const controlJson = controlToJson(control);
  const user = signedIn ? auth.user.userId ?? "" : "";
  const key3 = `${tableName ?? ""}|${controlJson}|${ownedByCaller}|${user}`;
  useEffect(() => {
    if (!active || !tableName) return;
    let canceled = false;
    (async () => {
      try {
        const [views, settings] = await Promise.all([
          ppp.retrieveRecordsAsync(savedViewsQuery(tableName, control, ownedByCaller)),
          ppp.retrieveRecordsAsync(userViewSettingsQuery(tableName, control, ownedByCaller))
        ]);
        if (canceled) return;
        setState({
          key: key3,
          available: true,
          views: views.tableRecords.flatMap((record) => toSavedView(record, tableName) ?? []),
          settings: settings.tableRecords.flatMap((record) => toSetting(record) ?? [])
        });
      } catch (error) {
        if (canceled) return;
        console.warn(
          `[SavedViews] The saved views of '${tableName}' couldn't be read, so the ${control.kind} offers the page's views only. Saved views need the Power Portals Pro Core solution's tables, and an internal user the 'Power Portals Pro Saved Views' security role.`,
          error
        );
        setState({ key: key3, available: false, views: [], settings: [] });
      }
    })();
    return () => {
      canceled = true;
    };
  }, [active, key3, ppp]);
  const current = state?.key === key3 ? state : null;
  const currentRef = useRef(current);
  currentRef.current = current;
  const reloadSettings = useCallback(async () => {
    if (!tableName) return;
    const settings = await ppp.retrieveRecordsAsync(userViewSettingsQuery(tableName, control, ownedByCaller));
    setState(
      (previous) => previous ? { ...previous, settings: settings.tableRecords.flatMap((record) => toSetting(record) ?? []) } : previous
    );
  }, [ppp, tableName, controlJson, ownedByCaller]);
  const writeSettings = useCallback(
    async (changes, viewName) => {
      if (changes.length === 0 || !tableName) return;
      for (const change of changes) {
        if (change.kind === "create") {
          await ppp.createRecordAsync({
            tableName: UserViewSettingSchema.table,
            properties: {
              [UserViewSettingSchema.name]: stringValue(viewName),
              [UserViewSettingSchema.tableName]: stringValue(tableName),
              [UserViewSettingSchema.viewId]: stringValue(change.viewId),
              [UserViewSettingSchema.isDefault]: boolValue(change.isDefault),
              [UserViewSettingSchema.isHidden]: boolValue(change.isHidden),
              [UserViewSettingSchema.controlKey]: stringValue(controlToJson(change.control))
            }
          });
        } else if (change.kind === "update") {
          await ppp.updateRecordAsync({
            id: change.id,
            tableName: UserViewSettingSchema.table,
            properties: {
              [UserViewSettingSchema.isDefault]: boolValue(change.isDefault),
              [UserViewSettingSchema.isHidden]: boolValue(change.isHidden)
            }
          });
        } else {
          await ppp.deleteRecordAsync(UserViewSettingSchema.table, change.id);
        }
      }
      await reloadSettings();
    },
    [ppp, tableName, reloadSettings]
  );
  const create = useCallback(
    async (name, fetchXml, layouts) => {
      if (!tableName) throw new Error("Saved views need the control\u2019s table.");
      const controlKeys = controlKeysOf(control);
      const created = await ppp.createRecordAsync({
        tableName: SavedViewSchema.table,
        properties: {
          [SavedViewSchema.name]: stringValue(name),
          [SavedViewSchema.tableName]: stringValue(tableName),
          [SavedViewSchema.fetchXml]: stringValue(fetchXml),
          ...controlKeys && { [SavedViewSchema.controlKeys]: stringValue(controlKeys) },
          ...layoutProperties(layouts)
        }
      });
      const view = savedView(created.id, name, tableName, fetchXml, layouts.gridLayout, layouts.calendarLayout, layouts.kanbanLayout);
      setState((previous) => previous ? { ...previous, views: [...previous.views, view] } : previous);
      return view;
    },
    // `controlJson` covers the control's content.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ppp, tableName, controlJson]
  );
  const update = useCallback(
    async (id, changes) => {
      const existing = currentRef.current?.views.find((x) => sameId(x.id, id));
      if (!existing || !tableName) throw new Error(`There is no saved view ${id}.`);
      await ppp.updateRecordAsync({
        id,
        tableName: SavedViewSchema.table,
        properties: {
          ...changes.name !== void 0 && { [SavedViewSchema.name]: stringValue(changes.name) },
          ...changes.fetchXml !== void 0 && { [SavedViewSchema.fetchXml]: stringValue(changes.fetchXml) },
          ...layoutProperties(changes)
        }
      });
      const view = savedView(
        id,
        changes.name ?? existing.name,
        tableName,
        changes.fetchXml ?? existing.definition.fetchXml,
        changes.gridLayout ?? existing.gridLayout,
        changes.calendarLayout ?? existing.calendarLayout,
        changes.kanbanLayout ?? existing.kanbanLayout
      );
      setState((previous) => previous ? { ...previous, views: previous.views.map((x) => sameId(x.id, id) ? view : x) } : previous);
      return view;
    },
    [ppp, tableName]
  );
  const remove = useCallback(
    async (id) => {
      if (!tableName) return;
      const settings = await ppp.retrieveRecordsAsync(viewSettingsQuery(tableName, id, ownedByCaller));
      for (const setting of settings.tableRecords) if (setting.id) await ppp.deleteRecordAsync(UserViewSettingSchema.table, setting.id);
      await ppp.deleteRecordAsync(SavedViewSchema.table, id);
      await reloadSettings();
      setState((previous) => previous ? { ...previous, views: previous.views.filter((x) => !sameId(x.id, id)) } : previous);
    },
    [ppp, tableName, ownedByCaller, reloadSettings]
  );
  const setDefault = useCallback(
    (viewId, isDefault, viewName) => writeSettings(setDefaultView(currentRef.current?.settings ?? [], viewId, control, isDefault), viewName),
    // `controlJson` covers the control's content.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [writeSettings, controlJson]
  );
  const setHidden = useCallback(
    (viewId, isHidden, viewName) => writeSettings(setViewHidden(currentRef.current?.settings ?? [], viewId, control, isHidden), viewName),
    // `controlJson` covers the control's content.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [writeSettings, controlJson]
  );
  return useMemo(
    () => ({
      available: active && !!current?.available,
      needsSignIn,
      loading: active && !current,
      views: active ? current?.views ?? [] : [],
      settings: active ? current?.settings ?? [] : [],
      create,
      update,
      remove,
      setDefault,
      setHidden,
      reloadSettings
    }),
    [active, needsSignIn, current, create, update, remove, setDefault, setHidden, reloadSettings]
  );
}
function layoutProperties(layouts) {
  return {
    ...layouts.gridLayout && { [SavedViewSchema.gridLayout]: stringValue(savedGridViewLayoutToJson(layouts.gridLayout)) },
    ...layouts.calendarLayout && { [SavedViewSchema.calendarLayout]: stringValue(layouts.calendarLayout) },
    ...layouts.kanbanLayout && { [SavedViewSchema.kanbanLayout]: stringValue(layouts.kanbanLayout) }
  };
}
function toSavedView(record, tableName) {
  const fetchXml = readString(record, SavedViewSchema.fetchXml);
  if (!record.id || !fetchXml?.trim()) return void 0;
  return savedView(
    record.id,
    readString(record, SavedViewSchema.name) ?? "",
    tableName,
    fetchXml,
    parseSavedGridViewLayout(readString(record, SavedViewSchema.gridLayout)),
    readString(record, SavedViewSchema.calendarLayout) || void 0,
    readString(record, SavedViewSchema.kanbanLayout) || void 0
  );
}
function savedView(id, name, tableName, fetchXml, gridLayout, calendarLayout, kanbanLayout) {
  return {
    id,
    name,
    gridLayout,
    calendarLayout,
    kanbanLayout,
    definition: { id, fetchXml, tableName, displayName: name, columns: viewColumnsOf(fetchXml, gridLayout) }
  };
}
function toSetting(record) {
  const control = parseControl(readString(record, UserViewSettingSchema.controlKey));
  return control ? {
    id: record.id ?? "",
    viewId: (readString(record, UserViewSettingSchema.viewId) ?? "").toLowerCase(),
    control,
    isDefault: readBool(record, UserViewSettingSchema.isDefault),
    isHidden: readBool(record, UserViewSettingSchema.isHidden)
  } : void 0;
}
function viewColumnsOf(fetchXml, layout) {
  const queried = queriedColumns(fetchXml);
  const lower = new Set(queried.map((x) => x.toLowerCase()));
  const widths = new Map((layout?.columns ?? []).map((x) => [x.columnName.toLowerCase(), x.width]));
  const laidOut = (layout?.columns ?? []).map((x) => x.columnName).filter((key3) => lower.has(key3.toLowerCase()));
  const ordered = laidOut.length > 0 ? laidOut : queried;
  const seen = /* @__PURE__ */ new Set();
  return ordered.filter((key3) => !seen.has(key3.toLowerCase()) && !!seen.add(key3.toLowerCase())).map((key3) => ({ columnName: key3, width: widths.get(key3.toLowerCase()) || SAVED_VIEW_COLUMN_WIDTH }));
}
function queriedColumns(fetchXml) {
  const entity = parseXml(fetchXml).children.find((x) => x.name === "entity");
  if (!entity) return [];
  const names2 = (element) => element.children.filter((x) => x.name === "attribute" && x.attributes["name"]).map((x) => x.attributes["name"]);
  const columns = names2(entity);
  const joins = (element) => {
    for (const join of element.children.filter((x) => x.name === "link-entity")) {
      const alias = join.attributes["alias"];
      if (alias) columns.push(...names2(join).map((name) => `${alias}.${name}`));
      joins(join);
    }
  };
  joins(entity);
  return columns;
}
var sameId2 = (a, b) => a.toLowerCase() === b.toLowerCase();
var stringValue2 = (value2) => ({ $type: 14, value: value2 });
var readString2 = (record, column) => {
  const value2 = record.properties?.[column]?.value;
  return typeof value2 === "string" && value2 ? value2 : void 0;
};
function savedMultiTableView(id, name, tables, calendarLayout, timelineLayout, searchLayout) {
  return { id, name, tables, calendarLayout, timelineLayout, searchLayout, definition: { id, displayName: name, tables: [...tables] } };
}
function useMultiTableViews(options) {
  const { enabled, control } = options;
  const { ppp } = usePowerPortalsPro();
  const auth = useAuth();
  const signedIn = auth.status === AuthStatus.Authenticated;
  const ownedByCaller = signedIn && (auth.user.portalUserType ?? PortalUserType.Contact) !== PortalUserType.Contact;
  const active = enabled && signedIn;
  const controlJson = controlToJson(control);
  const user = signedIn ? auth.user.userId ?? "" : "";
  const key3 = `${controlJson}|${ownedByCaller}|${user}`;
  const [state, setState] = useState(null);
  useEffect(() => {
    if (!active) return;
    let canceled = false;
    (async () => {
      try {
        const views = (await ppp.retrieveRecordsAsync(multiTableViewsQuery(control, ownedByCaller))).tableRecords;
        const ids = views.flatMap((x) => x.id ? [x.id] : []);
        const rows = ids.length > 0 ? (await ppp.retrieveRecordsAsync(multiTableViewTablesQuery(ids, ownedByCaller))).tableRecords : [];
        if (canceled) return;
        const tablesOf2 = /* @__PURE__ */ new Map();
        for (const row of rows) {
          const viewId = row.properties?.[MultiTableViewTableSchema.view]?.value;
          const table = toViewTable(row);
          if (typeof viewId !== "string" || !table) continue;
          const list = tablesOf2.get(viewId.toLowerCase()) ?? [];
          list.push(table);
          tablesOf2.set(viewId.toLowerCase(), list);
        }
        setState({
          key: key3,
          views: views.flatMap((record) => {
            const tables = record.id ? tablesOf2.get(record.id.toLowerCase()) : void 0;
            return record.id && tables ? [
              savedMultiTableView(
                record.id,
                readString2(record, MultiTableViewSchema.name) ?? "",
                tables,
                readString2(record, MultiTableViewSchema.calendarLayout),
                readString2(record, MultiTableViewSchema.timelineLayout),
                readString2(record, MultiTableViewSchema.searchLayout)
              )
            ] : [];
          })
        });
      } catch (error) {
        if (canceled) return;
        console.warn(
          `[SavedViews] The user's views of several tables couldn't be read, so the ${control.kind} offers its other views only. They need the Power Portals Pro Core solution's multi-table view tables.`,
          error
        );
        setState({ key: key3, views: [] });
      }
    })();
    return () => {
      canceled = true;
    };
  }, [active, key3, ppp]);
  const current = state?.key === key3 ? state : null;
  const currentRef = useRef(current);
  currentRef.current = current;
  const writeTables = useCallback(
    // Writes a view's tables, and says which rows it wrote — every one, or, when one fails, none: the
    // ones before it are taken back out.
    async (viewId, tables) => {
      const written = [];
      try {
        for (let i = 0; i < tables.length; i++) {
          const created = await ppp.createRecordAsync({
            tableName: MultiTableViewTableSchema.table,
            properties: {
              ...toViewTableRow(tables[i], i),
              [MultiTableViewTableSchema.view]: { $type: 6, value: viewId, tableName: MultiTableViewSchema.table }
            }
          });
          written.push(created.id);
        }
      } catch (error) {
        for (const row of written) await ppp.deleteRecordAsync(MultiTableViewTableSchema.table, row);
        throw error;
      }
      return written;
    },
    [ppp]
  );
  const create = useCallback(
    async (name, tables, layouts) => {
      const controlKeys = controlKeysOf(control);
      const created = await ppp.createRecordAsync({
        tableName: MultiTableViewSchema.table,
        properties: {
          [MultiTableViewSchema.name]: stringValue2(name),
          ...controlKeys && { [MultiTableViewSchema.controlKeys]: stringValue2(controlKeys) },
          ...layouts.calendarLayout && { [MultiTableViewSchema.calendarLayout]: stringValue2(layouts.calendarLayout) },
          ...layouts.timelineLayout && { [MultiTableViewSchema.timelineLayout]: stringValue2(layouts.timelineLayout) },
          ...layouts.searchLayout && { [MultiTableViewSchema.searchLayout]: stringValue2(layouts.searchLayout) }
        }
      });
      try {
        await writeTables(created.id, tables);
      } catch (error) {
        await ppp.deleteRecordAsync(MultiTableViewSchema.table, created.id);
        throw error;
      }
      const view = savedMultiTableView(created.id, name, tables, layouts.calendarLayout, layouts.timelineLayout, layouts.searchLayout);
      setState((previous) => previous ? { ...previous, views: [...previous.views, view] } : previous);
      return view;
    },
    // `controlJson` covers the control's content.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ppp, controlJson, writeTables]
  );
  const update = useCallback(
    async (id, changes) => {
      const existing = currentRef.current?.views.find((x) => sameId2(x.id, id));
      if (!existing) throw new Error(`There is no view of several tables ${id}.`);
      const properties = {
        ...changes.name !== void 0 && { [MultiTableViewSchema.name]: stringValue2(changes.name) },
        ...changes.calendarLayout && { [MultiTableViewSchema.calendarLayout]: stringValue2(changes.calendarLayout) },
        ...changes.timelineLayout && { [MultiTableViewSchema.timelineLayout]: stringValue2(changes.timelineLayout) },
        ...changes.searchLayout && { [MultiTableViewSchema.searchLayout]: stringValue2(changes.searchLayout) }
      };
      if (Object.keys(properties).length > 0)
        await ppp.updateRecordAsync({ id, tableName: MultiTableViewSchema.table, properties });
      if (changes.tables) {
        const old = (await ppp.retrieveRecordsAsync(multiTableViewTablesQuery([id], false))).tableRecords;
        const written = await writeTables(id, changes.tables);
        try {
          for (const row of old) if (row.id) await ppp.deleteRecordAsync(MultiTableViewTableSchema.table, row.id);
        } catch (error) {
          for (const row of written) await ppp.deleteRecordAsync(MultiTableViewTableSchema.table, row);
          throw error;
        }
      }
      const view = savedMultiTableView(
        id,
        changes.name ?? existing.name,
        changes.tables ?? existing.tables,
        changes.calendarLayout ?? existing.calendarLayout,
        changes.timelineLayout ?? existing.timelineLayout,
        changes.searchLayout ?? existing.searchLayout
      );
      setState((previous) => previous ? { ...previous, views: previous.views.map((x) => sameId2(x.id, id) ? view : x) } : previous);
      return view;
    },
    [ppp, writeTables]
  );
  const remove = useCallback(
    async (id) => {
      const settings = await ppp.retrieveRecordsAsync(viewSettingsQuery(null, id, ownedByCaller));
      for (const setting of settings.tableRecords) if (setting.id) await ppp.deleteRecordAsync(UserViewSettingSchema.table, setting.id);
      await ppp.deleteRecordAsync(MultiTableViewSchema.table, id);
      setState((previous) => previous ? { ...previous, views: previous.views.filter((x) => !sameId2(x.id, id)) } : previous);
    },
    [ppp, ownedByCaller]
  );
  return useMemo(
    () => ({
      loading: active && !current,
      views: active ? current?.views ?? [] : [],
      create,
      update,
      remove
    }),
    [active, current, create, update, remove]
  );
}
var IDLE = { data: void 0, loading: false, error: void 0 };
var LOADING = { data: void 0, loading: true, error: void 0 };
function useMetadata(load, key3) {
  const [state, setState] = useState({ key: "", ...IDLE });
  const requestToken = useRef(0);
  const loadRef = useRef(load);
  loadRef.current = load;
  useEffect(() => {
    const token = requestToken.current += 1;
    const run = loadRef.current;
    if (!run || key3 === "") {
      setState({ key: key3, ...IDLE });
      return;
    }
    setState({ key: key3, data: void 0, loading: true, error: void 0 });
    run().then(
      (data) => {
        if (requestToken.current !== token) return;
        setState({ key: key3, data, loading: false, error: void 0 });
      },
      (error) => {
        if (requestToken.current !== token) return;
        setState({ key: key3, data: void 0, loading: false, error });
      }
    );
  }, [key3]);
  if (state.key !== key3) {
    return key3 === "" ? IDLE : LOADING;
  }
  return state;
}
function useFetchXmlTables(provider) {
  return useMetadata(() => provider.getTables(), "tables");
}
function isSelectableColumn(column) {
  if (column.validForAdvancedFind === false) return false;
  const label = column.displayName;
  if (label === void 0 || label.trim() === "") return false;
  if (column.logicalName.toLowerCase().endsWith("_base")) return false;
  if (column.type === ColumnType.Uniqueidentifier) return false;
  return true;
}
function useFetchXmlTableDetail(provider, tableLogicalName) {
  const table = tableLogicalName ?? "";
  return useMetadata(
    table === "" ? void 0 : async () => {
      const detail = await provider.getTable(table);
      if (detail === void 0) return void 0;
      return { ...detail, columns: detail.columns.filter(isSelectableColumn) };
    },
    table
  );
}
function useFetchXmlTableDetails(provider, tableLogicalNames) {
  const key3 = tableLogicalNames.join(",");
  return useMetadata(
    key3 === "" ? void 0 : async () => {
      const loaded = await Promise.all(
        tableLogicalNames.map(async (tableLogicalName) => {
          try {
            const detail = await provider.getTable(tableLogicalName);
            return detail === void 0 ? void 0 : {
              ...detail,
              columns: detail.columns.filter(isSelectableColumn)
            };
          } catch {
            return void 0;
          }
        })
      );
      const map = /* @__PURE__ */ new Map();
      for (const detail of loaded) {
        if (detail !== void 0) map.set(detail.logicalName, detail);
      }
      return map;
    },
    key3
  );
}
function metadataLabel(item) {
  return item.displayName?.trim() || item.logicalName;
}
function nameWithLogicalName(item, showLogicalNames = true) {
  if (!item.displayName) return item.logicalName;
  return showLogicalNames ? `${item.displayName} (${item.logicalName})` : item.displayName;
}
function findColumn(columns, logicalName) {
  if (logicalName === void 0) return void 0;
  return columns.find((column) => column.logicalName === logicalName);
}
function searchMetadata(items, search) {
  const needle = search.trim().toLowerCase();
  if (needle === "") return items;
  const ranked = [];
  for (const item of items) {
    const logical = item.logicalName.toLowerCase();
    const label = metadataLabel(item).toLowerCase();
    const rank = logical === needle || label === needle ? 0 : logical.startsWith(needle) || label.startsWith(needle) ? 1 : logical.includes(needle) || label.includes(needle) ? 2 : -1;
    if (rank >= 0) ranked.push({ item, rank });
  }
  return ranked.sort((left, right) => left.rank - right.rank).map((entry) => entry.item);
}

// src/fetchxml/relationship-display.ts
var RELATIONSHIP_KIND_ORDER = [
  "manyToOne",
  "oneToMany",
  "manyToMany"
];
var RELATIONSHIP_KIND_KEYS = {
  manyToOne: "relationship-group-many-to-one",
  oneToMany: "relationship-group-one-to-many",
  manyToMany: "relationship-group-many-to-many"
};
function describeRelationship(relationship, tables, sourceColumns, showLogicalNames = true) {
  const table = tables.find(
    (candidate) => candidate.logicalName === relationship.relatedTable
  );
  const tableText = table ? nameWithLogicalName(table, showLogicalNames) : relationship.relatedTable;
  if (relationship.kind === "manyToMany") return { table: tableText };
  const lookupColumn = relationship.kind === "manyToOne" ? relationship.to : relationship.from;
  if (lookupColumn === "") return { table: tableText };
  if (relationship.lookupLabel !== void 0 && relationship.lookupLabel !== "")
    return { table: tableText, lookup: relationship.lookupLabel };
  const match = relationship.kind === "manyToOne" ? sourceColumns.find((column) => column.logicalName === lookupColumn) : void 0;
  return { table: tableText, lookup: match ? metadataLabel(match) : lookupColumn };
}
function relationshipLeadLabel(display) {
  return display.lookup ?? display.table;
}
function relationshipFullLabel(display) {
  return display.lookup === void 0 ? display.table : `${display.lookup} - ${display.table}`;
}
function groupRelationships(relationships, label) {
  return RELATIONSHIP_KIND_ORDER.map((kind) => ({
    kind,
    relationships: relationships.filter((relationship) => relationship.kind === kind).sort((left, right) => {
      const byLabel = label(left).localeCompare(label(right));
      return byLabel !== 0 ? byLabel : left.schemaName.localeCompare(right.schemaName);
    })
  })).filter((group) => group.relationships.length > 0);
}
function findRelationshipForLink(link, relationships) {
  return relationships.find(
    (relationship) => relationship.relatedTable === link.name && relationship.from === (link.from ?? "") && relationship.to === (link.to ?? "")
  );
}
function searchRelationships(relationships, search, describe) {
  const needle = search.trim().toLowerCase();
  if (needle === "") return relationships;
  return relationships.filter((relationship) => {
    const { table, lookup } = describe(relationship);
    return table.toLowerCase().includes(needle) || (lookup ?? "").toLowerCase().includes(needle);
  });
}

// src/fetchxml/column-sources.ts
function columnSourceKey(alias, logicalName) {
  return alias === "" ? logicalName : `${alias}.${logicalName}`;
}
function parseColumnSourceKey(key3) {
  const dot = key3.indexOf(".");
  return dot === -1 ? { alias: "", logicalName: key3 } : { alias: key3.slice(0, dot), logicalName: key3.slice(dot + 1) };
}
function isColumnSource(link) {
  if (!joinTypeReturnsColumns(link.linkType ?? JoinOperator.Inner)) return false;
  return (link.alias ?? "").trim() !== "";
}
function getColumnSources(query, tables, details, showLogicalNames = true) {
  const label = (tableName) => {
    const table = tables.find((candidate) => candidate.logicalName === tableName);
    return table ? nameWithLogicalName(table, showLogicalNames) : tableName;
  };
  const columnsOf = (tableName) => details.get(tableName)?.columns ?? [];
  const linkLabel = (link, parentTable) => {
    const parent = details.get(parentTable);
    const relationship = findRelationshipForLink(link, parent?.relationships ?? []);
    if (relationship === void 0) {
      const alias = (link.alias ?? "").trim();
      return alias === "" || !showLogicalNames ? label(link.name) : `${label(link.name)} \u2014 ${alias}`;
    }
    return relationshipFullLabel(describeRelationship(relationship, tables, parent?.columns ?? [], showLogicalNames));
  };
  const sources = [];
  const root = query.entity;
  if (root.name === "") return sources;
  sources.push({
    entityId: root.id,
    alias: "",
    tableName: root.name,
    label: label(root.name),
    columns: columnsOf(root.name)
  });
  const visit = (entity) => {
    for (const link of entity.linkEntities) {
      if (isColumnSource(link) && link.name !== "") {
        sources.push({
          entityId: link.id,
          alias: (link.alias ?? "").trim(),
          label: linkLabel(link, entity.name),
          tableName: link.name,
          columns: columnsOf(link.name)
        });
      }
      visit(link);
    }
    for (const filter of entity.filters) visitFilter(filter);
  };
  const visitFilter = (filter, owner) => {
    for (const link of filter.linkEntities ?? []) {
      visit(link);
    }
    for (const nested of filter.filters) visitFilter(nested);
  };
  visit(root);
  const counts = /* @__PURE__ */ new Map();
  for (const source of sources) counts.set(source.label, (counts.get(source.label) ?? 0) + 1);
  const seen = /* @__PURE__ */ new Map();
  return sources.map((source) => {
    if ((counts.get(source.label) ?? 0) < 2 || source.alias === "") return source;
    if (showLogicalNames) return { ...source, label: `${source.label} \u2014 ${source.alias}` };
    const count = (seen.get(source.label) ?? 0) + 1;
    seen.set(source.label, count);
    return count === 1 ? source : { ...source, label: `${source.label} (${count})` };
  });
}
function getColumnSourceTables(query) {
  const names2 = /* @__PURE__ */ new Set();
  if (query.entity.name !== "") names2.add(query.entity.name);
  for (const link of getAllLinkEntities(query)) {
    if (isColumnSource(link) && link.name !== "") names2.add(link.name);
  }
  return [...names2].sort();
}
function findColumnSource(sources, alias) {
  const wanted = (alias ?? "").trim();
  return sources.find((source) => source.alias === wanted);
}
var EMPTY_COLUMNS = [];
var EMPTY_TABLES = [];
var EMPTY_RELATIONSHIPS = [];
var EMPTY_DETAILS = /* @__PURE__ */ new Map();
var NO_PROBLEMS = [];
var FetchXmlBuilderContext = createContext(null);
FetchXmlBuilderContext.displayName = "FetchXmlBuilder";
function useFetchXmlBuilderContext() {
  const context = useContext(FetchXmlBuilderContext);
  if (!context) {
    throw new Error(
      "FetchXML builder sections must be rendered inside a <FetchXmlBuilderProvider>. <FetchXmlBuilder> mounts one for you."
    );
  }
  return context;
}
function useShowLogicalNames() {
  return useContext(FetchXmlBuilderContext)?.showLogicalNames ?? true;
}
function readFetchXml(fetchXml, table) {
  if (fetchXml === void 0 || fetchXml.trim() === "") {
    return { query: createFetchXmlQuery(table ?? ""), parseError: void 0, problems: NO_PROBLEMS };
  }
  let parsed;
  try {
    parsed = parseFetchXml(fetchXml);
  } catch (error) {
    return {
      query: void 0,
      parseError: error instanceof Error ? error.message : String(error),
      problems: NO_PROBLEMS
    };
  }
  const problems = validateFetchXml(parsed);
  return {
    query: hasBlockingProblem(problems) ? void 0 : parsed,
    parseError: void 0,
    problems: problems.length === 0 ? NO_PROBLEMS : problems
  };
}
function useLookupNameStore(metadata) {
  const names2 = useRef(/* @__PURE__ */ new Map());
  const asked = useRef(/* @__PURE__ */ new Set());
  const [, setVersion] = useState(0);
  const key3 = (table, id) => `${table}:${id}`;
  const get = useCallback(
    (table, id) => names2.current.get(key3(table, id)),
    []
  );
  const request = useCallback(
    (table, ids) => {
      if (metadata.getRecordNames === void 0 || table === "") return;
      const wanted = ids.filter((id) => id !== "" && !asked.current.has(key3(table, id)));
      if (wanted.length === 0) return;
      for (const id of wanted) asked.current.add(key3(table, id));
      void metadata.getRecordNames(table, wanted).then((resolved) => {
        if (resolved.size === 0) return;
        for (const [id, name] of resolved) names2.current.set(key3(table, id), name);
        setVersion((version) => version + 1);
      }).catch(() => {
      });
    },
    [metadata]
  );
  return useMemo(() => ({ get, request }), [get, request]);
}
function FetchXmlBuilderProvider({
  value: value2,
  defaultValue,
  onChange,
  metadata,
  table,
  readOnly,
  allowedTables,
  allowAggregate,
  showLogicalNames,
  children
}) {
  const [state, setState] = useState(() => {
    const result = readFetchXml(value2 ?? defaultValue, table);
    return {
      // Nothing to preserve on the first render, so an unreadable initial value
      // starts from an empty query rather than from nothing at all.
      query: result.query ?? createFetchXmlQuery(table ?? ""),
      parseError: result.parseError,
      problems: result.problems
    };
  });
  const { query, parseError, problems } = state;
  const lastEmitted = useRef(void 0);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  useEffect(() => {
    if (value2 === void 0) return;
    if (value2 === lastEmitted.current) return;
    const result = readFetchXml(value2, table);
    setState((previous) => ({
      query: result.query ?? previous.query,
      parseError: result.parseError,
      problems: result.problems
    }));
  }, [value2, table]);
  const apply = useCallback((next) => {
    setState({ query: next, parseError: void 0, problems: NO_PROBLEMS });
    const xml2 = toFetchXml(next);
    lastEmitted.current = xml2;
    onChangeRef.current?.(xml2, next);
  }, []);
  useEffect(() => {
    if (table === void 0 || table === "") return;
    if (query.entity.name === table) return;
    apply(updateEntity(query, query.entity.id, { name: table }));
  }, [apply, query, table]);
  const entity = query.entity;
  const { data: tables, loading: tablesLoading } = useFetchXmlTables(metadata);
  const { data: tableDetail, loading: detailLoading } = useFetchXmlTableDetail(
    metadata,
    entity.name === "" ? void 0 : entity.name
  );
  const allowedKey = allowedTables === void 0 ? "" : allowedTables.join(",");
  const selectableTables = useMemo(() => {
    const all = tables ?? EMPTY_TABLES;
    if (allowedKey === "") return all;
    const allowed = new Set(allowedKey.split(","));
    return all.filter((candidate) => allowed.has(candidate.logicalName));
  }, [tables, allowedKey]);
  const aliases = useMemo(() => getLinkAliases(query), [query]);
  const lookupNames = useLookupNameStore(metadata);
  const sourceTables = useMemo(() => getColumnSourceTables(query), [query]);
  const { data: sourceDetails } = useFetchXmlTableDetails(metadata, sourceTables);
  const columnSources = useMemo(
    () => getColumnSources(query, tables ?? EMPTY_TABLES, sourceDetails ?? EMPTY_DETAILS, showLogicalNames !== false),
    [query, tables, sourceDetails, showLogicalNames]
  );
  const fetchXml = useMemo(() => toFetchXml(query), [query]);
  const context = useMemo(
    () => ({
      query,
      entity,
      apply,
      fetchXml,
      parseError,
      problems,
      tables: tables ?? EMPTY_TABLES,
      selectableTables,
      tablesLoading,
      columns: tableDetail?.columns ?? EMPTY_COLUMNS,
      relationships: tableDetail?.relationships ?? EMPTY_RELATIONSHIPS,
      detailLoading,
      metadata,
      aliases,
      columnSources,
      tableLocked: table !== void 0 && table !== "",
      readOnly: readOnly === true,
      // The query already having one is what keeps the controls reachable.
      allowAggregate: allowAggregate !== false || query.aggregate === true,
      showLogicalNames: showLogicalNames !== false,
      lookupNames
    }),
    [
      query,
      entity,
      apply,
      fetchXml,
      parseError,
      problems,
      tables,
      selectableTables,
      tablesLoading,
      tableDetail,
      detailLoading,
      metadata,
      aliases,
      columnSources,
      table,
      readOnly,
      allowAggregate,
      showLogicalNames,
      lookupNames
    ]
  );
  return /* @__PURE__ */ jsx(FetchXmlBuilderContext.Provider, { value: context, children });
}
var CHILD_INDENT = "15px";
var CONNECTOR_REACH = `calc(${CHILD_INDENT} + ${tokens.spacingHorizontalM} + ${tokens.strokeWidthThick})`;
var CONTROL_HEIGHT = "32px";
var CONNECTOR_OFFSET = "16px";
var HEADER_REACH = `calc(${tokens.spacingHorizontalM} + ${tokens.strokeWidthThick})`;
var CONNECTOR_RADIUS = tokens.borderRadiusMedium;
var PANEL_MIN_HEIGHT = "220px";
var FILL_PANEL = {
  flexGrow: 1,
  minHeight: PANEL_MIN_HEIGHT
};
var CONTROL_WIDTH = "--ppp-fetchxml-control-width";
var NARROW_CONTROL_WIDTH = "--ppp-fetchxml-narrow-control-width";
var DATE_PICKER_WIDTH = "--ppp-fetchxml-date-picker-width";
var DATE_EDITOR_DIRECTION = "--ppp-fetchxml-date-editor-direction";
var useFetchXmlBuilderStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalL,
    // The editor lives inside forms and split panes; `min-width: 0` stops a long
    // logical name from pushing it past its parent instead of wrapping.
    minWidth: 0,
    // Takes whatever height the host gives it, and none when the host gives none.
    // A percentage against an auto-height container resolves to auto, so this is
    // inert in the ordinary page-flow case and is what lets the FetchXML editor
    // fill a split pane or a form section that *is* sized.
    height: "100%",
    // A flex item's floor is its content unless it is told otherwise. Without
    // this the sections below refuse to shrink and a short container overflows
    // instead of letting the parts that scroll do the scrolling.
    minHeight: 0,
    fontFamily: tokens.fontFamilyBase,
    color: tokens.colorNeutralForeground1,
    // Anchors the metadata-loading scrim to the builder rather than the viewport.
    position: "relative"
  },
  /**
   * Covers the builder while a table's metadata loads.
   *
   * Mirrors the framework's own overlay — a neutral backdrop at 0.7 behind a
   * spinner — rather than inventing a second look for the same idea. It blocks
   * clicks as well as dimming: every picker underneath is about to be repopulated,
   * so a click landing on the old list would edit the query against a table that
   * is no longer selected.
   */
  loadingScrim: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "auto",
    zIndex: 100,
    "::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      backgroundColor: tokens.colorNeutralBackground2,
      opacity: 0.7,
      zIndex: -1
    }
  },
  /** Stacks the sections inside a tab panel the same way the root stacks them. */
  tabPanel: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalL,
    minWidth: 0,
    // Claims the space the tab bar and any message bar leave, so a section that
    // grows has something to grow into.
    flexGrow: 1,
    minHeight: 0
  },
  section: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    minHeight: 0,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusMedium,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalM}`,
    minWidth: 0
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    justifyContent: "space-between"
  },
  /** The clickable header of a collapsible section. Chrome-free, sized like text. */
  sectionToggle: {
    display: "flex",
    alignItems: "baseline",
    columnGap: tokens.spacingHorizontalXS,
    minWidth: 0,
    flexGrow: 1,
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
    fontFamily: "inherit",
    color: "inherit",
    textAlign: "start",
    cursor: "pointer"
  },
  sectionChevron: {
    flexShrink: 0,
    alignSelf: "center",
    color: tokens.colorNeutralForeground3
  },
  /**
   * What a collapsed section contains, beside its title. Truncates rather than
   * wrapping — a long column list must not make the collapsed header taller than
   * the expanded one it replaced.
   */
  sectionSummary: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontWeight: tokens.fontWeightRegular,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    "::before": {
      content: '"\u2014"',
      marginInlineEnd: tokens.spacingHorizontalXS
    }
  },
  sectionBody: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    minWidth: 0,
    // Inert in a section that sizes to its content — there is no free space to
    // take. It matters only in the one section that is given a height, where it
    // passes that height through to the control inside.
    flexGrow: 1,
    minHeight: 0
  },
  sectionTitle: {
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase300
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalXS
  },
  /**
   * One editable row — a column, a sort clause or a condition.
   *
   * The action buttons are in this same wrapping flow rather than pinned to the
   * right edge, so they sit immediately after the last control instead of across
   * a gap from it. When the row is too narrow they wrap along with the controls,
   * still following whatever ends up last.
   *
   * Aligned to the top, not the bottom. Every control here is the same height, so
   * the two look identical until one cell holds more than a line — a lookup naming
   * several records, say. Bottom-aligned, that cell kept its last line on the row
   * and grew *upward* over the row above it; top-aligned, the first line stays put
   * and the rest follows downward, which is the direction a list is read in.
   */
  row: {
    display: "flex",
    alignItems: "flex-start",
    columnGap: tokens.spacingHorizontalS,
    rowGap: tokens.spacingVerticalXS,
    flexWrap: "wrap",
    minWidth: 0
  },
  /**
   * A condition still missing the value its operator needs.
   *
   * An `outline`, not a `border`. An outline is painted outside the element's box
   * and takes part in no layout at all, so the marker can appear and disappear
   * without nudging the controls it surrounds — a border plus padding shifted
   * every row down and right as the user typed. `outline-offset` lifts it clear of
   * the controls, and outlines follow `border-radius`, so it still rounds.
   *
   * Outlined rather than tinted for a second reason: the row is full of Fluent
   * controls, and a colored surface behind them would force their own colors to
   * be overridden to stay readable — which is where a stock control stops behaving
   * like one.
   */
  rowIncomplete: {
    outline: `${tokens.strokeWidthThin} solid ${tokens.colorPaletteRedBorder2}`,
    outlineOffset: tokens.spacingHorizontalXXS,
    borderRadius: tokens.borderRadiusMedium,
    // Above the tree that runs behind it. A row's connectors are its own pseudo-elements, and a
    // positioned pseudo-element paints over its element's outline — so the rule crossed the marker
    // exactly where the marker was trying to say something. A stacking context here lets them be
    // pushed behind the outline without falling behind the panel as well.
    position: "relative",
    zIndex: 0,
    "::before": { zIndex: -1 },
    "::after": { zIndex: -1 }
  },
  /**
   * A row's buttons — delete, reorder. One group so they wrap together: a "move
   * down" stranded from the "move up" above it would read as a layout fault.
   */
  rowActions: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalXXS,
    flexShrink: 0
  },
  /**
   * Every editable control in a condition row.
   *
   * A fixed width rather than a flexible one so the columns line up down the
   * filter tree: with `flex-grow`, a row holding a two-part comparand sized its
   * controls differently from the row above it, and nothing read as a column.
   * The row wraps, so a narrow pane stacks these instead of squashing them.
   */
  rowControl: {
    flexGrow: 0,
    flexShrink: 0,
    // Through a variable a stacked row sets to its full width (see rowStacked).
    width: `var(${CONTROL_WIDTH}, 225px)`,
    // Fluent's Dropdown and Combobox ship `min-width: 250px`, which silently wins
    // over a narrower `width` — every control rendered at 250px and the row
    // overflowed. All three have to be pinned for the width to actually apply.
    minWidth: `var(${CONTROL_WIDTH}, 225px)`,
    maxWidth: `var(${CONTROL_WIDTH}, 225px)`
  },
  /**
   * A condition on its own — a grid column's filter — a control to a line, each the row's full
   * width: the variables the controls are sized by say so for every control in it, the value
   * editors' included.
   */
  rowStacked: {
    flexDirection: "column",
    alignItems: "stretch",
    flexWrap: "nowrap",
    rowGap: tokens.spacingVerticalS,
    [CONTROL_WIDTH]: "100%",
    [NARROW_CONTROL_WIDTH]: "100%",
    [DATE_PICKER_WIDTH]: "100%",
    [DATE_EDITOR_DIRECTION]: "column"
  },
  /**
   * A control whose values are names nobody chose for readability.
   *
   * The query hints are SQL Server's own, and the longest —
   * `ENABLE_HIST_AMENDMENT_FOR_ASC_KEYS` — runs well past the width the condition
   * rows are built around. Widened rather than truncated because a hint clipped
   * mid-name is a hint you cannot confirm you picked, and unlike a column there is
   * no display name to fall back on. All three widths pinned for the same reason
   * as above: Fluent's own `min-width` otherwise wins.
   */
  rowControlWide: {
    flexGrow: 0,
    flexShrink: 0,
    width: "394px",
    minWidth: "394px",
    maxWidth: "394px"
  },
  /**
   * A row control that sizes to its content instead of being pinned, with the
   * standard width as its floor.
   *
   * For the two places where the content, not the grid, has to decide the width:
   *
   * - The lookup value, which is not one control but a list that grows — the
   *   chosen records plus the button that adds another. Pinned at 225px none of
   *   them fit beside each other, so every one wrapped to its own line and the
   *   list read as a stack of unrelated controls.
   * - A projected column's name, which is read rather than typed into, and which
   *   carries its join's alias when the column is not the root table's.
   *
   * Everything else stays pinned, so rows still line up where lining up is what
   * makes them scannable.
   *
   * `maxWidth: 100%` keeps it inside the row, so a long list wraps within the
   * cell rather than pushing the row wider than its container.
   */
  rowControlFlexible: {
    flexGrow: 0,
    flexShrink: 1,
    minWidth: `var(${CONTROL_WIDTH}, 225px)`,
    maxWidth: "100%"
  },
  /**
   * A filter group's and/or switch.
   *
   * Its own width rather than the narrow one beside it: "Match all (AND)" does not
   * fit 125px and truncated to "Match all (A…", which loses exactly the part that
   * was added to make the meaning unambiguous. Not widened globally, because the
   * narrow control is also the value/column switch, which is deliberately small.
   */
  groupMatchControl: {
    flexGrow: 0,
    flexShrink: 0,
    width: "175px",
    // Fluent's Dropdown ships `min-width: 250px`, which silently wins over a
    // narrower `width` — all three have to be pinned for the width to apply.
    minWidth: "175px",
    maxWidth: "175px"
  },
  /**
   * The value/column comparison switch. Narrower because its two choices are short
   * and giving it the full width would push the comparand off the first line.
   */
  /**
   * A column a host fixed, named where its picker would be, on the line of the controls beside it:
   * as wide as its name, up to a picker's width.
   */
  fixedColumn: {
    width: "auto",
    minWidth: 0,
    display: "block",
    lineHeight: "32px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    fontWeight: tokens.fontWeightSemibold
  },
  rowControlNarrow: {
    flexGrow: 0,
    flexShrink: 0,
    width: `var(${NARROW_CONTROL_WIDTH}, 125px)`,
    minWidth: `var(${NARROW_CONTROL_WIDTH}, 125px)`,
    maxWidth: `var(${NARROW_CONTROL_WIDTH}, 125px)`
  },
  /**
   * What a column contributes to an aggregate query.
   *
   * Fifty pixels past the narrow control it otherwise matches: its labels say what
   * each function does rather than naming it — "Count with a value" rather than
   * `countcolumn` — and those do not fit a control sized for two short words.
   */
  aggregateFunctionControl: {
    flexGrow: 0,
    flexShrink: 0,
    width: "175px",
    minWidth: "175px",
    maxWidth: "175px"
  },
  /**
   * The date part a grouped date column is bucketed into.
   *
   * Twenty pixels past the narrow control it otherwise matches: "Fiscal period"
   * is the longest of its choices and did not fit alongside the chevron, and a
   * date part clipped to "Fiscal peri…" is one you cannot confirm you picked.
   */
  dateGroupingControl: {
    flexGrow: 0,
    flexShrink: 0,
    width: "145px",
    minWidth: "145px",
    maxWidth: "145px"
  },
  /** A nested filter group, offset from its parent by a rule down the left. */
  group: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    minWidth: 0
  },
  /**
   * The rule turns accent-colored for an OR group, so nesting reads at a glance.
   *
   * Applied to the children rather than the group, because the children are what
   * draw the rule now — each one owns the segment beside it.
   */
  groupOr: {
    // Not `borderColor`: griffel types the shorthand as `never`, so the longhands
    // are the only form that compiles.
    "& > *::before": {
      borderLeftColor: tokens.colorBrandStroke1,
      borderBottomColor: tokens.colorBrandStroke1
    },
    "& > *::after": {
      borderLeftColor: tokens.colorBrandStroke1
    }
  },
  /**
   * Everything under a group's AND/OR header.
   *
   * Indented so the rows visibly hang off the operator rather than starting at the
   * same x as it. Without the offset the header reads as another row in the list
   * instead of as the thing the list belongs to.
   */
  groupChildren: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    paddingLeft: CHILD_INDENT,
    minWidth: 0,
    // The whole tree is drawn by the children: each one owns the elbow that joins
    // it to the group, and the segment of rule that carries on to the next.
    //
    // Built this way rather than as one border down the group so the rule can stop
    // where it should. A group's line runs from the center of its header down to
    // the branch of its last child and no further — past that it would point at
    // nothing, which is the difference between a diagram and a margin decoration.
    //
    // Pseudo-elements rather than real markup: the children are condition rows,
    // nested groups and joined tables, rendered by three different components, and
    // none of them should have to know it sits in a tree to be drawn in one.
    "& > *": {
      position: "relative"
    },
    // The elbow: down through the gap above this child, then across to it.
    "& > *::before": {
      content: '""',
      position: "absolute",
      // Stated rather than inherited: these rules place a border where the box ends, so a page
      // that doesn't set a border-box reset would paint every branch a stroke below the stub it
      // meets — a visible step at each junction.
      boxSizing: "border-box",
      left: `calc(0px - ${CONNECTOR_REACH})`,
      width: CONNECTOR_REACH,
      top: `calc(0px - ${tokens.spacingVerticalS})`,
      height: `calc(${tokens.spacingVerticalS} + ${CONNECTOR_OFFSET})`,
      borderLeft: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralStroke2}`,
      // The same weight as the rule it turns out of: a thinner branch read as a
      // different kind of line rather than the same one changing direction.
      borderBottom: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralStroke2}`
    },
    // The first child reaches further up, to the center of the group's own header
    // row, so the rule begins level with the control it belongs to.
    "& > *:first-child::before": {
      // Offset by the radius: the header's stub has already drawn the turn and the
      // first few pixels of the drop, so starting level with the header again would
      // lay a straight edge over the curve.
      top: `calc(0px - ${tokens.spacingVerticalS} - ${CONNECTOR_OFFSET} + ${CONNECTOR_RADIUS})`,
      height: `calc(${tokens.spacingVerticalS} + ${CONNECTOR_OFFSET} + ${CONNECTOR_OFFSET} - ${CONNECTOR_RADIUS})`
    },
    // The rule continuing past this child to the next one.
    "& > *::after": {
      content: '""',
      position: "absolute",
      boxSizing: "border-box",
      left: `calc(0px - ${CONNECTOR_REACH})`,
      top: CONNECTOR_OFFSET,
      bottom: 0,
      borderLeft: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralStroke2}`
    },
    // Nothing carries on below the last child: its branch is where the rule ends.
    "& > *:last-child::after": {
      content: "none"
    },
    // And only there is the turn rounded. Everywhere else the rule carries on down
    // past the branch, so the junction is a T and has no corner to round — curving
    // it peeled the trunk away to the right while the line below resumed straight,
    // which read as a nick in the rule rather than as a corner.
    "& > *:last-child::before": {
      borderBottomLeftRadius: CONNECTOR_RADIUS
    }
  },
  /**
   * A join's contents: its filter, and anything hanging off that filter.
   *
   * Level with the join's own header rather than indented under it. A join's
   * filter is not its child the way a condition is a group's child — it is the
   * join's own condition, the part that says which related rows count. There is
   * never more than one, and nothing else can sit beside it, so indenting it drew
   * a level of nesting that isn't there.
   *
   * The negative margin cancels the padding {@link group} applies around it,
   * expressed with the same token so the two cannot drift apart. What lands here
   * is a `FilterGroup`, which re-applies that padding itself — which is exactly
   * what puts its header on the same x as the join's.
   *
   * No connectors either: a branch spans the gap between a rule and a child, and
   * with no gap there is nothing for one to span.
   */
  linkEntityChildren: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    minWidth: 0,
    marginLeft: `calc(0px - ${tokens.spacingHorizontalM})`,
    position: "relative",
    /**
     * The join's line, from the foot of its header down to where its filter picks
     * it up.
     *
     * Drawn in two parts because neither box knows the other's height: the header
     * covers its own lower half, and this covers the gap between them plus the
     * drop to the filter's connector point. They meet at the header's bottom edge
     * and read as one line.
     *
     * The filter's own header stub turns this into the row, so nothing here has to
     * draw the elbow.
     */
    "::before": {
      content: '""',
      position: "absolute",
      boxSizing: "border-box",
      // The same x as the header's stub above and the filter's stub below: one
      // stroke outside this block's left edge.
      left: `calc(0px - ${tokens.strokeWidthThick})`,
      top: `calc(0px - ${tokens.spacingVerticalS})`,
      height: `calc(${tokens.spacingVerticalS} + ${CONNECTOR_OFFSET})`,
      borderLeft: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralStroke2}`
    }
  },
  /**
   * The row holding a group's "Add" menu, at the foot of its children.
   *
   * A sibling of the children rather than one of them, carrying their indent so it
   * lines up beneath them. It is still the group's last branch, so it is plain where
   * what it adds will go: the rule carries on past the last child (see
   * {@link groupChildrenContinues}) and turns into the menu, as it turns into each
   * child. The row sits inside the group's padding and the rule a stroke outside it,
   * the same span a child's branch has. Met at half the row's height, which is the
   * menu button's middle whatever height the button is.
   */
  groupAdd: {
    display: "flex",
    alignItems: "center",
    paddingLeft: CHILD_INDENT,
    position: "relative",
    "::before": {
      content: '""',
      position: "absolute",
      boxSizing: "border-box",
      left: `calc(0px - ${HEADER_REACH})`,
      width: CONNECTOR_REACH,
      top: `calc(0px - ${tokens.spacingVerticalS})`,
      height: `calc(${tokens.spacingVerticalS} + 50%)`,
      borderLeft: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralStroke2}`,
      borderBottom: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralStroke2}`,
      borderBottomLeftRadius: CONNECTOR_RADIUS
    }
  },
  /** An OR group's menu branch takes the rule's accent, as its children's do. */
  groupAddOr: {
    "::before": {
      borderLeftColor: tokens.colorBrandStroke1,
      borderBottomColor: tokens.colorBrandStroke1
    }
  },
  /**
   * A join's "Add filter" row with the join's related tables hanging below it: its
   * turn is a T, and the line carries on down to them.
   */
  groupAddContinues: {
    "::before": {
      borderBottomLeftRadius: 0
    },
    "::after": {
      content: '""',
      position: "absolute",
      boxSizing: "border-box",
      left: `calc(0px - ${HEADER_REACH})`,
      top: "50%",
      bottom: 0,
      borderLeft: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralStroke2}`
    }
  },
  /**
   * On a group's children when its "Add" menu follows them: the last child is no
   * longer where the rule ends, so its segment carries on down to the menu and its
   * turn is a T rather than the corner.
   */
  groupChildrenContinues: {
    "& > *:last-child::after": {
      content: '""'
    },
    "& > *:last-child::before": {
      borderBottomLeftRadius: 0
    }
  },
  /**
   * On a join's "no filter" hint when "Add filter" follows it: the join's line runs
   * down past the hint to the menu's branch.
   */
  emptyHintContinues: {
    position: "relative",
    "::before": {
      content: '""',
      position: "absolute",
      boxSizing: "border-box",
      left: `calc(0px - ${HEADER_REACH})`,
      top: `calc(0px - ${tokens.spacingVerticalS})`,
      bottom: 0,
      borderLeft: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralStroke2}`
    }
  },
  groupHeader: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    flexWrap: "wrap",
    position: "relative",
    // The group's own stub, joining its rule to the control that governs it. The
    // rule already begins level with this row; without the stub it begins level
    // with something it is not visibly attached to.
    //
    // It carries the top corner too — a short drop below the turn, rounded, so the
    // rule curves out of the header the same way its branches curve into their
    // children. The trunk beneath starts where this leaves off, so the two read as
    // one line rather than as a stub meeting a rule.
    "::before": {
      content: '""',
      position: "absolute",
      boxSizing: "border-box",
      left: `calc(0px - ${HEADER_REACH})`,
      width: HEADER_REACH,
      // Lifted by the stroke width so the stub lands on the same line as the
      // branch arriving from the group above.
      //
      // A branch draws its horizontal on the *bottom* border of its box, which
      // puts the line just above the 16px mark; a stub drawn on the *top* border
      // puts it just below. Left alone the two sit a stroke apart, which is the
      // step visible wherever a child is itself a parent — and nowhere else,
      // because a plain condition row has no stub of its own to disagree with.
      top: `calc(${CONNECTOR_OFFSET} - ${tokens.strokeWidthThick})`,
      // Deep enough to meet the trunk the first child starts below the turn.
      height: `calc(${CONNECTOR_RADIUS} + ${tokens.strokeWidthThick})`,
      borderTop: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralStroke2}`,
      borderLeft: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralStroke2}`,
      borderTopLeftRadius: CONNECTOR_RADIUS
    }
  },
  /**
   * A group that hangs off another one squares its turn off.
   *
   * Rounding belongs to the top of a tree, where the rule begins. Inside one, the
   * branch arriving from above and the rule leaving downward are two parts of the
   * same corner, and curving only the lower half leaves a kink in it.
   */
  groupHeaderNested: {
    "::before": {
      borderTopLeftRadius: 0
    }
  },
  /**
   * A join's header.
   *
   * Keeps the horizontal that carries the branch from the group above into the
   * row, and drops the short vertical under it. That vertical is the top of a
   * group's own rule, and a join no longer has one: its filter sits level with it
   * rather than hanging under it, so the drop would point at nothing and resume,
   * as a gap in a line, below the filter's header.
   */
  linkEntityHeader: {
    "::before": {
      // Down to the foot of the row, rather than the few pixels a group's stub
      // drops. A group's rule starts immediately under its header; a join's filter
      // is a row further down, so the line has further to travel before anything
      // else carries it.
      height: `calc(100% - ${CONNECTOR_OFFSET} + ${tokens.strokeWidthThick})`
    }
  },
  /** The header stub follows the rule's accent, the same as the branches below it. */
  groupHeaderOr: {
    "::before": {
      borderTopColor: tokens.colorBrandStroke1,
      borderLeftColor: tokens.colorBrandStroke1
    }
  },
  /**
   * A projected column, shown as a label rather than an editable name: one line of
   * "Display Name (logicalname)".
   */
  columnLabel: {
    display: "flex",
    alignItems: "baseline",
    columnGap: tokens.spacingHorizontalXXS,
    minWidth: 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    // Sits on the text baseline of the input beside it rather than the box edge.
    paddingBottom: tokens.spacingVerticalSNudge
  },
  /** Yields first when the pair doesn't fit — the logical name is the load-bearing half. */
  columnLabelName: {
    flexGrow: 0,
    flexShrink: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1
  },
  /** The name that actually goes into the FetchXML, so it holds its width. */
  columnLabelLogical: {
    flexShrink: 0,
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3
  },
  /**
   * What a join leads with, standing where a group's AND/OR dropdown would.
   *
   * The lookup that forms the join, where there is one. It is what tells two joins
   * apart — a table can be reached by several lookups and they all read as the
   * same table — so it goes first and carries the emphasis. Only a many-to-many,
   * which has no lookup on either side, leads with the table itself.
   */
  /**
   * The join's name, led by an icon.
   *
   * A row of its own rather than two children of the header, so the icon sits
   * against its text at the tighter gap a glyph and its label want — the header's
   * own gap is sized for the controls beside it.
   */
  linkEntityTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalXS,
    minWidth: 0,
    // A control's height, so the branch arriving from the group above lands on the
    // middle of this line. {@link CONNECTOR_OFFSET} is half a control, which is what
    // the header's first line measures while a control still fits beside the title;
    // once the header wraps far enough for the title to sit alone, the line is only
    // as tall as the text and the branch meets it below its center.
    minHeight: CONTROL_HEIGHT
  },
  /**
   * Marks the row as a join at a glance, before any of its text is read.
   *
   * Held at its natural size: it is the one part of the title that must not
   * shrink, or a long relationship name squeezes the marker away and takes the
   * recognition with it.
   */
  linkEntityIcon: {
    flexShrink: 0,
    color: tokens.colorNeutralForeground3,
    fontSize: "16px"
  },
  /** The text itself, which is what truncates when the row runs out of room. */
  linkEntityName: {
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0
  },
  /** What follows it — the table at the other end, once the lookup has named it. */
  linkEntityDetail: {
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground3
  },
  emptyHint: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
    fontStyle: "italic"
  },
  /**
   * The same hint standing in for a group's rows: a row's height, with the text in its
   * middle, where the branch arriving from the rule meets it. A bare line of text is
   * shorter than the control a branch is placed for, and the line would land below it.
   */
  emptyRow: {
    display: "flex",
    alignItems: "center",
    minHeight: CONTROL_HEIGHT
  },
  /**
   * The query options, stacked one per line.
   *
   * Laid out in a wrapping row they packed together by width rather than by
   * meaning, and each one's hint ran into the control beside it. They are
   * unrelated switches, not a set to compare, so reading them downward is both
   * clearer and stable as options are added.
   */
  optionsGrid: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    rowGap: tokens.spacingVerticalM
  },
  preview: {
    display: "block",
    margin: 0,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalM}`,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusMedium,
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    color: tokens.colorNeutralForeground1,
    overflowX: "auto",
    whiteSpace: "pre",
    ...FILL_PANEL,
    overflowY: "auto"
  },
  /**
   * The same panel, editable.
   *
   * Styled to match the read-only `<pre>` it replaces so switching between them —
   * which is what `readOnly` does — doesn't move the page around. Fluent's own
   * `Textarea` wrapper carries the border and the focus ring, and its inner
   * `<textarea>` is already `height: 100%`, so sizing this wrapper is enough to
   * size the field.
   */
  editor: FILL_PANEL,
  /**
   * The FetchXML section, which is the one that takes the slack.
   *
   * Every other section is as tall as what it holds; this one holds a text box
   * that should be as tall as it is allowed to be. Inert where the builder has no
   * height of its own — there is no free space to grow into — so it costs nothing
   * in ordinary page flow.
   */
  previewSection: {
    flexGrow: 1,
    minHeight: 0
  },
  editorText: {
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    // A query indents deeply; wrapping it would hide the structure that the
    // indentation is carrying.
    whiteSpace: "pre",
    overflowX: "auto",
    /**
     * Fills its wrapper — by stretching, not by a percentage.
     *
     * Fluent ships the field as `height: 100%`, which is the one thing that does
     * *not* work here: the wrapper's own `height` is `auto` and its size comes
     * from `flex-grow`, so the percentage has nothing definite to resolve against
     * and falls back to the field's intrinsic two rows. That left a small box
     * scrolling at the top of a tall empty wrapper.
     *
     * `height: auto` hands the job back to the flex container, whose default
     * `align-items: stretch` sizes the item to the wrapper's content box with no
     * percentage involved. `stretch` is spelled out rather than left to the
     * default because it only applies while the cross size is `auto`, which is
     * exactly the pairing being relied on.
     */
    height: "auto",
    alignSelf: "stretch",
    // The same floor the wrapper has. `resize` honors `min-height`, so this is
    // what stops the grip dragging the field out from under its own border.
    minHeight: PANEL_MIN_HEIGHT
  },
  /** The list of faults found in what was typed. */
  problems: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXS,
    margin: 0,
    paddingInlineStart: 0,
    listStyleType: "none"
  },
  /**
   * Where a problem was found, as `fetch > entity(account) > filter`.
   *
   * Monospace and muted: it is a position in the document beside it, not part of
   * the sentence explaining what is wrong.
   */
  problemPath: {
    display: "block",
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3
  }
});

// src/fetchxml/localization-keys.ts
var FETCH_XML_BUILDER_STRINGS_PREFIX = "app.components.fetch-xml-builder";
function createFilterWithRow(type = LogicalOperator.And) {
  return { ...createFilter(type), conditions: [createCondition()] };
}
var COLUMN_TYPE_NAMES = Object.freeze(
  Object.fromEntries(Object.entries(ColumnType).map(([name, value2]) => [value2, name]))
);
function useColumnTypeLabel() {
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  return useCallback(
    (type) => {
      if (type === void 0) return t("column-type-unknown");
      const name = COLUMN_TYPE_NAMES[type];
      return name === void 0 ? t("column-type-unknown") : t(`column-types.${name}`);
    },
    [t]
  );
}

// src/fetchxml/column-sort.ts
var DEFAULT_COLUMN_SORT = { key: "display", ascending: true };
function nextColumnSort(current, key3) {
  return { key: key3, ascending: current.key === key3 ? !current.ascending : true };
}
function sortColumns(columns, sort, typeLabel) {
  const direction = sort.ascending ? 1 : -1;
  const keyOf3 = (column) => {
    switch (sort.key) {
      case "logical":
        return column.logicalName;
      case "type":
        return typeLabel(column.type);
      default:
        return metadataLabel(column);
    }
  };
  return [...columns].sort((left, right) => {
    const compared = keyOf3(left).localeCompare(keyOf3(right));
    if (compared !== 0) return compared * direction;
    return left.logicalName.localeCompare(right.logicalName) * direction;
  });
}
var GRID_COLUMNS = "20px minmax(0, 1fr) minmax(0, 1fr) 140px";
var GRID_COLUMNS_NO_LOGICAL = "20px minmax(0, 1fr) 140px";
var useStyles4 = makeStyles({
  surface: {
    // Tall enough to show a useful slice of a wide table's column list without
    // the dialog resizing as the search narrows it.
    maxWidth: "760px"
  },
  body: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
    minHeight: 0
  },
  list: {
    display: "flex",
    flexDirection: "column",
    height: "360px",
    overflowY: "auto",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusMedium
  },
  row: {
    display: "grid",
    gridTemplateColumns: GRID_COLUMNS,
    alignItems: "center",
    columnGap: tokens.spacingHorizontalM,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalM}`,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke3}`,
    cursor: "pointer",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover
    }
  },
  noLogical: {
    gridTemplateColumns: GRID_COLUMNS_NO_LOGICAL
  },
  headerRow: {
    display: "grid",
    gridTemplateColumns: GRID_COLUMNS,
    alignItems: "center",
    columnGap: tokens.spacingHorizontalM,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalM}`,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground2,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground2,
    position: "sticky",
    top: 0,
    zIndex: 1
  },
  sortButton: {
    // A header cell that happens to be a button: no chrome, aligned with the
    // plain cells beside it, clickable across the whole column width.
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalXXS,
    justifyContent: "flex-start",
    minWidth: 0,
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    color: "inherit",
    cursor: "pointer",
    ":hover": {
      color: tokens.colorNeutralForeground1
    }
  },
  sortLabel: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  sortIcon: {
    flexShrink: 0
  },
  logical: {
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  label: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  type: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  status: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    color: tokens.colorNeutralForeground3
  },
  summary: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground2
  }
});
function ColumnSelectDialog({
  open,
  sources,
  loading,
  selected,
  onCommit,
  onCancel,
  title,
  sourceActions,
  shownSource,
  showLogicalNames: showLogicalNamesProp
}) {
  const styles = useStyles4();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const typeLabel = useColumnTypeLabel();
  const builderShowsLogicalNames = useShowLogicalNames();
  const showLogicalNames = showLogicalNamesProp ?? builderShowsLogicalNames;
  const [checked, setChecked] = useState(() => new Set(selected));
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState(DEFAULT_COLUMN_SORT);
  useEffect(() => {
    if (!open) return;
    setChecked(new Set(selected));
    setSearch("");
    setSort(DEFAULT_COLUMN_SORT);
    setActiveSource(sources[0]?.entityId ?? "");
  }, [open]);
  const [activeSource, setActiveSource] = useState("");
  useEffect(() => {
    if (shownSource) setActiveSource(shownSource);
  }, [shownSource]);
  const current = sources.find((source) => source.entityId === activeSource) ?? sources[0];
  const visible = useMemo(
    () => current === void 0 ? [] : sortColumns(searchMetadata(current.columns, search), sort, typeLabel),
    [current, search, sort, typeLabel]
  );
  const chosenPerSource = useMemo(() => {
    const counts = /* @__PURE__ */ new Map();
    for (const source of sources) {
      counts.set(
        source.entityId,
        source.columns.filter(
          (column) => checked.has(columnSourceKey(source.alias, column.logicalName))
        ).length
      );
    }
    return counts;
  }, [sources, checked]);
  const showTabs = sources.length > 1;
  const toggle = (key3, isChecked) => {
    setChecked((current2) => {
      const next = new Set(current2);
      if (isChecked) next.add(key3);
      else next.delete(key3);
      return next;
    });
  };
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      open,
      onOpenChange: (_, data) => {
        if (!data.open) onCancel();
      },
      children: /* @__PURE__ */ jsx(DialogSurface, { className: styles.surface, children: /* @__PURE__ */ jsxs(DialogBody, { children: [
        /* @__PURE__ */ jsx(DialogTitle, { children: title ?? t("select-columns-title") }),
        /* @__PURE__ */ jsxs(DialogContent, { className: styles.body, children: [
          /* @__PURE__ */ jsx(
            Input,
            {
              value: search,
              onChange: (_, data) => setSearch(data.value),
              placeholder: t("search-columns"),
              "aria-label": t("search-columns"),
              contentBefore: /* @__PURE__ */ jsx(Search20Regular, {})
            }
          ),
          showTabs ? /* @__PURE__ */ jsx(
            TabList,
            {
              selectedValue: current?.entityId ?? "",
              onTabSelect: (_, data) => setActiveSource(String(data.value)),
              children: sources.map((source) => {
                const count = chosenPerSource.get(source.entityId) ?? 0;
                return /* @__PURE__ */ jsx(Tab, { value: source.entityId, children: count === 0 ? source.label : `${source.label} (${count})` }, source.entityId);
              })
            }
          ) : null,
          sourceActions?.(current),
          /* @__PURE__ */ jsxs("div", { className: styles.list, role: "grid", children: [
            /* @__PURE__ */ jsxs("div", { className: mergeClasses(styles.headerRow, !showLogicalNames && styles.noLogical), role: "row", children: [
              /* @__PURE__ */ jsx("span", { "aria-hidden": "true" }),
              /* @__PURE__ */ jsx(
                SortHeader,
                {
                  sortKey: "display",
                  sort,
                  onSort: setSort,
                  label: t("column-display-name")
                }
              ),
              showLogicalNames && /* @__PURE__ */ jsx(
                SortHeader,
                {
                  sortKey: "logical",
                  sort,
                  onSort: setSort,
                  label: t("column-logical-name")
                }
              ),
              /* @__PURE__ */ jsx(
                SortHeader,
                {
                  sortKey: "type",
                  sort,
                  onSort: setSort,
                  label: t("column-type")
                }
              )
            ] }),
            loading === true ? /* @__PURE__ */ jsx("div", { className: styles.status, children: /* @__PURE__ */ jsx(Spinner, { size: "small", label: t("loading-columns") }) }) : visible.length === 0 || current === void 0 ? /* @__PURE__ */ jsx("div", { className: styles.status, children: t("no-columns-match") }) : visible.map((column) => {
              const key3 = columnSourceKey(current.alias, column.logicalName);
              return /* @__PURE__ */ jsxs("label", { className: mergeClasses(styles.row, !showLogicalNames && styles.noLogical), role: "row", children: [
                /* @__PURE__ */ jsx(
                  Checkbox,
                  {
                    checked: checked.has(key3),
                    onChange: (_, data) => toggle(key3, data.checked === true),
                    "aria-label": metadataLabel(column)
                  }
                ),
                /* @__PURE__ */ jsx("span", { className: styles.label, children: metadataLabel(column) }),
                showLogicalNames && /* @__PURE__ */ jsx("span", { className: styles.logical, children: column.logicalName }),
                /* @__PURE__ */ jsx("span", { className: styles.type, children: typeLabel(column.type) })
              ] }, key3);
            })
          ] }),
          /* @__PURE__ */ jsx("span", { className: styles.summary, children: t("columns-selected", [checked.size]) })
        ] }),
        /* @__PURE__ */ jsxs(DialogActions, { children: [
          /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: onCancel, children: t("cancel") }),
          /* @__PURE__ */ jsx(Button, { appearance: "primary", onClick: () => onCommit([...checked]), children: t("ok") })
        ] })
      ] }) })
    }
  );
}
function SortHeader({ sortKey, sort, onSort, label }) {
  const styles = useStyles4();
  const active = sort.key === sortKey;
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      className: mergeClasses("ppp-fetch-xml-sort-header", styles.sortButton),
      "aria-sort": active ? sort.ascending ? "ascending" : "descending" : "none",
      onClick: () => onSort(nextColumnSort(sort, sortKey)),
      children: [
        /* @__PURE__ */ jsx("span", { className: styles.sortLabel, children: label }),
        active ? sort.ascending ? /* @__PURE__ */ jsx(ChevronUp12Regular, { className: styles.sortIcon }) : /* @__PURE__ */ jsx(ChevronDown12Regular, { className: styles.sortIcon }) : null
      ]
    }
  );
}
var useStyles5 = makeStyles({
  surface: {
    maxWidth: "680px"
  },
  body: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
    minHeight: 0
  },
  list: {
    display: "flex",
    flexDirection: "column",
    height: "340px",
    overflowY: "auto",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusMedium
  },
  row: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    boxSizing: "border-box",
    rowGap: tokens.spacingVerticalXXS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke3}`,
    cursor: "pointer",
    textAlign: "start",
    backgroundColor: "transparent",
    border: "none",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover
    }
  },
  selected: {
    backgroundColor: tokens.colorNeutralBackground1Selected
  },
  name: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1
  },
  /** Which view it is — the table's default, or one of its others. */
  detail: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3
  },
  empty: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    color: tokens.colorNeutralForeground3
  }
});
function ViewPickerDialog({
  open,
  views,
  loading,
  onCommit,
  onCancel
}) {
  const styles = useStyles5();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(void 0);
  useEffect(() => {
    if (!open) return;
    setSearch("");
    setSelected(void 0);
  }, [open]);
  const listed = useMemo(() => {
    const needle = search.trim().toLowerCase();
    const matching = needle === "" ? views : views.filter((view) => view.name.toLowerCase().includes(needle));
    return [...matching].sort((left, right) => left.name.localeCompare(right.name));
  }, [views, search]);
  const chosen = listed.find((view) => view.id === selected);
  return /* @__PURE__ */ jsx(Dialog, { open, onOpenChange: (_, data) => data.open ? void 0 : onCancel(), children: /* @__PURE__ */ jsx(DialogSurface, { className: styles.surface, children: /* @__PURE__ */ jsxs(DialogBody, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: t("select-view-title") }),
    /* @__PURE__ */ jsxs(DialogContent, { className: styles.body, children: [
      /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "warning", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("select-view-warning") }) }),
      /* @__PURE__ */ jsx(
        Input,
        {
          value: search,
          onChange: (_, data) => setSearch(data.value),
          placeholder: t("search-views"),
          "aria-label": t("search-views"),
          contentBefore: /* @__PURE__ */ jsx(Search20Regular, {})
        }
      ),
      /* @__PURE__ */ jsx("div", { className: styles.list, role: "listbox", "aria-label": t("select-view-title"), children: loading === true ? /* @__PURE__ */ jsx("div", { className: styles.empty, children: /* @__PURE__ */ jsx(Spinner, { size: "tiny", label: t("loading-views") }) }) : listed.length === 0 ? /* @__PURE__ */ jsx("div", { className: styles.empty, children: t("no-views") }) : listed.map((view) => /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          role: "option",
          "aria-selected": view.id === selected,
          className: mergeClasses(
            styles.row,
            view.id === selected ? styles.selected : void 0
          ),
          onClick: () => setSelected(view.id),
          onDoubleClick: () => onCommit(view),
          children: [
            /* @__PURE__ */ jsx("span", { className: styles.name, children: view.name }),
            /* @__PURE__ */ jsx("span", { className: styles.detail, children: view.isDefault === true ? t("view-default") : t("view-system") })
          ]
        },
        view.id
      )) })
    ] }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: onCancel, children: t("cancel") }),
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "primary",
          disabled: chosen === void 0,
          onClick: () => {
            if (chosen !== void 0) onCommit(chosen);
          },
          children: t("ok")
        }
      )
    ] })
  ] }) }) });
}
var DELAY = 250;
var taken = /* @__PURE__ */ new WeakSet();
function SharedTooltip({ containerRef }) {
  const [shown, setShown] = useState(void 0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    let showTimer;
    let hideTimer;
    let pressed = false;
    const tooltipFor = (event) => {
      if (taken.has(event) || !(event.target instanceof Element)) return null;
      const anchor = event.target.closest("[data-ppp-tooltip]");
      if (!anchor || !container.contains(anchor)) return null;
      taken.add(event);
      return anchor;
    };
    const show = (anchor, delay) => {
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
      showTimer = setTimeout(() => {
        const text3 = anchor.dataset.pppTooltip;
        if (!text3 || !anchor.isConnected) return;
        setShown({ anchor, text: text3 });
        setVisible(true);
      }, delay);
    };
    const hide = (delay) => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      if (delay === 0) setVisible(false);
      else hideTimer = setTimeout(() => setVisible(false), delay);
    };
    const pointerOver = (event) => {
      const anchor = tooltipFor(event);
      if (anchor && event.pointerType !== "touch" && event.buttons === 0 && !pressed) show(anchor, DELAY);
    };
    const pointerOut = (event) => {
      const anchor = tooltipFor(event);
      const within = !!anchor && event.relatedTarget instanceof Node && anchor.contains(event.relatedTarget);
      if (event.buttons === 0 && !within) pressed = false;
      if (anchor && !within) hide(DELAY);
    };
    const pointerDown = () => {
      pressed = true;
      hide(0);
    };
    const click = () => hide(0);
    const keyDown = () => {
      pressed = false;
    };
    const focusIn = (event) => {
      const anchor = tooltipFor(event);
      if (anchor && !pressed) show(anchor, 0);
    };
    const focusOut = (event) => {
      if (tooltipFor(event)) hide(0);
    };
    container.addEventListener("pointerover", pointerOver);
    container.addEventListener("pointerout", pointerOut);
    container.addEventListener("pointerdown", pointerDown, true);
    container.addEventListener("click", click, true);
    container.ownerDocument.addEventListener("keydown", keyDown, true);
    container.addEventListener("focusin", focusIn);
    container.addEventListener("focusout", focusOut);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      container.removeEventListener("pointerover", pointerOver);
      container.removeEventListener("pointerout", pointerOut);
      container.removeEventListener("pointerdown", pointerDown, true);
      container.removeEventListener("click", click, true);
      container.ownerDocument.removeEventListener("keydown", keyDown, true);
      container.removeEventListener("focusin", focusIn);
      container.removeEventListener("focusout", focusOut);
    };
  }, [containerRef]);
  useEffect(() => {
    const container = containerRef.current;
    if (!visible || !shown || !container) return;
    const observer = new MutationObserver(() => {
      if (!shown.anchor.isConnected) setVisible(false);
    });
    observer.observe(container, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [visible, shown, containerRef]);
  if (!shown) return null;
  const text2 = shown.anchor.dataset.pppTooltip ?? shown.text;
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      content: /* @__PURE__ */ jsx("span", { style: { whiteSpace: "pre-line" }, children: text2 }),
      relationship: "inaccessible",
      visible: visible && shown.anchor.isConnected,
      positioning: { target: shown.anchor },
      onVisibleChange: (_, data) => {
        if (!data.visible) setVisible(false);
      },
      children: /* @__PURE__ */ jsx("span", { hidden: true })
    }
  );
}
function FetchXmlSectionShell({
  title,
  summary,
  actions,
  markerClass,
  className,
  hideTitle,
  defaultCollapsed,
  collapsible,
  children
}) {
  const styles = useFetchXmlBuilderStyles();
  const bodyId = useId();
  const [collapsed, setCollapsed] = useState(defaultCollapsed === true);
  const sectionRef = useRef(null);
  const canCollapse = collapsible !== false && hideTitle !== true;
  const isCollapsed = canCollapse && collapsed;
  return /* @__PURE__ */ jsxs("section", { ref: sectionRef, className: mergeClasses(markerClass, styles.section, className), children: [
    /* @__PURE__ */ jsx(SharedTooltip, { containerRef: sectionRef }),
    /* @__PURE__ */ jsxs("div", { className: styles.sectionHeader, children: [
      hideTitle === true ? null : canCollapse ? /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          className: styles.sectionToggle,
          "aria-expanded": !isCollapsed,
          "aria-controls": bodyId,
          onClick: () => setCollapsed((current) => !current),
          children: [
            isCollapsed ? /* @__PURE__ */ jsx(ChevronRight12Regular, { className: styles.sectionChevron }) : /* @__PURE__ */ jsx(ChevronDown12Regular, { className: styles.sectionChevron }),
            /* @__PURE__ */ jsx("span", { className: styles.sectionTitle, children: title }),
            isCollapsed && summary !== void 0 && summary !== "" ? /* @__PURE__ */ jsx("span", { className: styles.sectionSummary, children: summary }) : null
          ]
        }
      ) : /* @__PURE__ */ jsx("span", { className: styles.sectionTitle, children: title }),
      isCollapsed ? null : actions
    ] }),
    isCollapsed ? null : /* @__PURE__ */ jsx("div", { id: bodyId, className: styles.sectionBody, children })
  ] });
}
var LIKE_FAMILY = [
  ConditionOperator.Like,
  ConditionOperator.NotLike,
  ConditionOperator.BeginsWith,
  ConditionOperator.DoesNotBeginWith,
  ConditionOperator.EndsWith,
  ConditionOperator.DoesNotEndWith,
  ConditionOperator.Contains,
  ConditionOperator.DoesNotContain
];
function isLikeOperator(operator) {
  return LIKE_FAMILY.includes(operator);
}
function getDisplayOperator(condition) {
  return inferLikeOperator(condition.operator, condition.value);
}
function getConditionValues(condition) {
  return getConditionValueEntries(condition).map((entry) => entry.value);
}
function getConditionValueEntries(condition) {
  if (condition.values !== void 0 && condition.values.length > 0) {
    return condition.values.map((entry) => ({ ...entry }));
  }
  if (condition.value !== void 0) {
    return [
      { value: condition.value, uiName: condition.uiName, uiType: condition.uiType }
    ];
  }
  return [];
}
function toValueEntries(values) {
  return values.map((entry) => typeof entry === "string" ? { value: entry } : { ...entry });
}
function getConditionText(condition) {
  const [first = ""] = getConditionValues(condition);
  return isLikeOperator(getDisplayOperator(condition)) ? stripLikeWildcards(first) : first;
}
var CLEARED = {
  value: void 0,
  values: void 0
};
function changeConditionOperator(condition, next) {
  const { arity } = getConditionOperatorInfo(next);
  const existing = getConditionValues(condition);
  const firstValue = existing[0] ?? "";
  const comparingColumns = condition.valueOfColumn !== void 0;
  if (comparingColumns && supportsColumnComparison(next)) {
    return { operator: next };
  }
  const clearValueOf = comparingColumns ? { valueOfColumn: void 0 } : {};
  if (arity === "none") {
    return { ...CLEARED, ...clearValueOf, operator: next };
  }
  if (arity === "many" || arity === "two") {
    const entries = getConditionValueEntries(condition);
    const values = arity === "two" ? [entries[0] ?? { value: "" }, entries[1] ?? { value: "" }] : entries;
    return { operator: next, ...clearValueOf, value: void 0, values };
  }
  if (isLikeOperator(next)) {
    return {
      operator: next,
      ...clearValueOf,
      values: void 0,
      value: formatLikeValue(next, firstValue)
    };
  }
  return {
    operator: next,
    ...clearValueOf,
    values: void 0,
    // A `like` value carries wildcards that mean nothing to `eq`; drop them on the
    // way out so switching operators doesn't leave `%acme%` behind.
    value: isLikeOperator(getDisplayOperator(condition)) ? stripLikeWildcards(firstValue) : firstValue
  };
}
function setConditionText(condition, text2) {
  const displayOperator = getDisplayOperator(condition);
  return {
    values: void 0,
    value: isLikeOperator(displayOperator) ? formatLikeValue(displayOperator, text2) : text2
  };
}
function setConditionValueAt(condition, index, text2) {
  const values = getConditionValueEntries(condition);
  while (values.length <= index) values.push({ value: "" });
  const existing = values[index];
  values[index] = existing === void 0 ? { value: text2 } : { ...existing, value: text2 };
  return { value: void 0, values };
}
function setConditionValues(values) {
  return { value: void 0, values: toValueEntries(values) };
}
function parseValueList(text2) {
  return text2.split(",").map((part) => part.trim()).filter((part) => part !== "");
}
function formatValueList(values) {
  return (values ?? []).map((entry) => typeof entry === "string" ? entry : entry.value).join(", ");
}
function changeConditionColumn(condition, attribute, column) {
  if (attribute === condition.attribute) return {};
  const allowed = getConditionOperatorsForColumnType(column?.type);
  const stillValid = allowed.some((info) => info.operator === condition.operator);
  const operator = stillValid ? condition.operator : allowed[0]?.operator ?? ConditionOperator.Equal;
  return {
    attribute,
    operator,
    value: void 0,
    values: void 0,
    valueOfColumn: void 0,
    uiName: void 0,
    uiType: void 0
  };
}
function getComparisonMode(condition) {
  if (!supportsColumnComparison(condition.operator)) return "value";
  return heldComparisonMode(condition);
}
function heldComparisonMode(condition) {
  return condition.valueOfColumn === void 0 ? "value" : "column";
}
function setComparisonMode(condition, mode) {
  if (heldComparisonMode(condition) === mode) return {};
  return mode === "column" ? { value: void 0, values: void 0, valueOfColumn: "" } : { valueOfColumn: void 0 };
}
function setValueOfColumn(attribute) {
  return { value: void 0, values: void 0, valueOfColumn: attribute };
}
function haveSameChoices(source, target) {
  if (source.optionSetName !== void 0 && target.optionSetName !== void 0) {
    return source.optionSetName === target.optionSetName;
  }
  const sourceValues = [...source.options ?? []].map((option) => option.value).sort(byNumber);
  const targetValues = [...target.options ?? []].map((option) => option.value).sort(byNumber);
  return sourceValues.length > 0 && sourceValues.length === targetValues.length && sourceValues.every((value2, index) => value2 === targetValues[index]);
}
var byNumber = (left, right) => left - right;
function isComparableColumn(source, candidate, sameTable) {
  if (sameTable && candidate.logicalName === source?.logicalName) return false;
  if (!areColumnTypesComparable(source?.type, candidate.type)) return false;
  if ((source?.options?.length ?? 0) > 0 && source !== void 0) {
    return haveSameChoices(source, candidate);
  }
  return true;
}
function getComparableColumns(columns, source) {
  return columns.filter((candidate) => isComparableColumn(source, candidate, true));
}
function isConditionIncomplete(condition) {
  let info;
  try {
    info = getConditionOperatorInfo(condition.operator);
  } catch {
    return false;
  }
  if (info.arity === "none") return false;
  if (condition.valueOfColumn !== void 0) {
    return condition.valueOfColumn === "";
  }
  if (info.arity === "one") {
    return getConditionText(condition).trim() === "";
  }
  const values = getConditionValues(condition).filter((value2) => value2.trim() !== "");
  return info.arity === "two" ? values.length < 2 : values.length < 1;
}
var INTEGER_TYPES = [ColumnType.Integer, ColumnType.BigInt];
var DECIMAL_TYPES = [
  ColumnType.Decimal,
  ColumnType.Double,
  ColumnType.Money
];
function numericInputKind(column, info) {
  if (info === void 0) return "none";
  if (info.valueKind === "number" || info.valueKind === "fiscalYear" || info.valueKind === "fiscalPeriod" || info.valueKind === "fiscalPeriodAndYear") {
    return "integer";
  }
  if (info.valueKind !== "column" || column?.type === void 0) return "none";
  if (INTEGER_TYPES.includes(column.type)) return "integer";
  if (DECIMAL_TYPES.includes(column.type)) return "decimal";
  return "none";
}
function isAllowedNumericInput(text2, kind) {
  if (kind === "none" || text2 === "") return true;
  return kind === "integer" ? /^-?\d*$/.test(text2) : /^-?\d*\.?\d*$/.test(text2);
}
function isAllowedNumericList(text2, kind) {
  if (kind === "none" || text2 === "") return true;
  return text2.split(",").every((entry) => isAllowedNumericInput(entry.trim(), kind));
}
function hasIncompleteCondition(scope) {
  const inFilter = (filter) => filter.conditions.some((condition) => !condition.attribute || isConditionIncomplete(condition)) || filter.filters.some(inFilter) || (filter.linkEntities ?? []).some(hasIncompleteCondition);
  return scope.filters.some(inFilter) || scope.linkEntities.some(hasIncompleteCondition);
}

// src/fetchxml/field-checks.ts
function isConditionUnfinished(condition) {
  return (condition.attribute ?? "").trim() === "" || isConditionIncomplete(condition);
}
function getDuplicateColumnAliases(attributes) {
  const counts = /* @__PURE__ */ new Map();
  for (const attribute of attributes) {
    const alias = (attribute.alias ?? "").trim();
    if (alias !== "") counts.set(alias, (counts.get(alias) ?? 0) + 1);
  }
  return new Set([...counts].filter(([, count]) => count > 1).map(([alias]) => alias));
}
function hasBadColumnAlias(attribute, aggregating, duplicates) {
  const alias = (attribute.alias ?? "").trim();
  return aggregating && alias === "" || duplicates.has(alias);
}
function getProjectedAttributes(query, columnSources) {
  const entities = getAllEntities(query);
  return columnSources.flatMap(
    (source) => entities.find((candidate) => candidate.id === source.entityId)?.attributes ?? []
  );
}
function hasUnresolvedFields(query, columnSources) {
  const aliases = getLinkAliases(query);
  const badJoin = getAllLinkEntities(query).some(
    (link) => isLinkAliasMissing(link) || joinTypeReturnsColumns(link.linkType ?? JoinOperator.Inner) && isLinkAliasDuplicate(link, aliases)
  );
  if (badJoin) return true;
  const conditions = (filter) => [
    ...filter.conditions,
    ...filter.filters.flatMap(conditions)
  ];
  const unfinished = getAllEntities(query).flatMap((entity) => entity.filters.flatMap(conditions)).some(isConditionUnfinished);
  if (unfinished) return true;
  const projected = getProjectedAttributes(query, columnSources);
  const duplicates = getDuplicateColumnAliases(projected);
  return projected.some(
    (attribute) => hasBadColumnAlias(attribute, query.aggregate === true, duplicates)
  );
}
function MetadataPicker({
  value: value2,
  onChange,
  items,
  placeholder,
  ariaLabel,
  loading,
  disabled,
  className
}) {
  const [query, setQuery] = useState(void 0);
  const [open, setOpen] = useState(false);
  const showLogicalNames = useShowLogicalNames();
  const selected = useMemo(
    () => items.find((item) => item.logicalName === value2),
    [items, value2]
  );
  const missing = value2 !== "" && selected === void 0;
  const options = useMemo(() => {
    if (open) return searchMetadata(items, query ?? "");
    return selected === void 0 ? [] : [selected];
  }, [items, query, open, selected]);
  const committedText = selected ? nameWithLogicalName(selected, showLogicalNames) : value2;
  const optional = {
    ...placeholder === void 0 ? {} : { placeholder },
    ...ariaLabel === void 0 ? {} : { "aria-label": ariaLabel }
  };
  return /* @__PURE__ */ jsxs(
    Combobox,
    {
      className: mergeClasses("ppp-metadata-picker", className),
      value: query ?? committedText,
      selectedOptions: value2 === "" ? [] : [value2],
      disabled: disabled === true || loading === true,
      ...optional,
      open,
      onChange: (event) => {
        setQuery(event.target.value);
        setOpen(true);
      },
      onOptionSelect: (_, data) => {
        setQuery(void 0);
        setOpen(false);
        onChange(data.optionValue ?? "");
      },
      onBlur: () => {
        setQuery(void 0);
        setOpen(false);
      },
      onOpenChange: (_, data) => {
        setOpen(data.open);
        if (!data.open) setQuery(void 0);
      },
      children: [
        missing ? (
          // Keeps `selectedOptions` matched so Fluent renders the value as chosen,
          // while marking it as something the metadata no longer knows about.
          /* @__PURE__ */ jsx(Option, { value: value2, text: value2, disabled: true, children: value2 }, value2)
        ) : null,
        groupEntries(options).map((run) => {
          const entries = run.items.map((item) => /* @__PURE__ */ jsx(
            Option,
            {
              value: item.logicalName,
              text: nameWithLogicalName(item, showLogicalNames),
              children: nameWithLogicalName(item, showLogicalNames)
            },
            item.logicalName
          ));
          return run.group === void 0 ? /* @__PURE__ */ jsx(Fragment$1, { children: entries }, "ungrouped") : /* @__PURE__ */ jsx(OptionGroup, { label: run.group, children: entries }, run.group);
        })
      ]
    }
  );
}
function groupEntries(items) {
  const order = [];
  const byGroup = /* @__PURE__ */ new Map();
  for (const item of items) {
    const existing = byGroup.get(item.group);
    if (existing === void 0) {
      order.push(item.group);
      byGroup.set(item.group, [item]);
    } else {
      existing.push(item);
    }
  }
  return order.map((group) => ({ group, items: byGroup.get(group) ?? [] }));
}
function ChoiceValueEditor({
  values,
  onChange,
  options,
  multiple,
  ariaLabel,
  className
}) {
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const labels = useMemo(
    () => new Map(options.map((option) => [String(option.value), option.label])),
    [options]
  );
  const selected = values.filter((value2) => value2 !== "");
  const displayText = selected.map((value2) => labels.get(value2) ?? t("unknown-choice-value", [value2])).join(", ");
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      className,
      "aria-label": ariaLabel,
      multiselect: multiple,
      placeholder: t("value"),
      value: displayText,
      selectedOptions: selected,
      onOptionSelect: (_, data) => {
        onChange(multiple ? [...data.selectedOptions] : [data.optionValue ?? ""]);
      },
      children: options.map((option) => /* @__PURE__ */ jsx(Option, { value: String(option.value), text: option.label, children: option.label }, option.value))
    }
  );
}
var PICKER_WIDTH = "125px";
var TIME_WIDTH = "109px";
var useStyles6 = makeStyles({
  /**
   * Date and time side by side. Sized by its contents rather than by a width
   * handed in from the row: two 125px pickers and the gap between them come to
   * more than one standard slot, and clamping to it would squeeze them.
   */
  // A stacked row puts the date over the time, each its full width (see the builder's rowStacked).
  root: {
    display: "flex",
    flexDirection: `var(${DATE_EDITOR_DIRECTION}, row)`,
    flexShrink: 0,
    columnGap: tokens.spacingHorizontalXS,
    rowGap: tokens.spacingVerticalS,
    width: `var(${CONTROL_WIDTH}, auto)`,
    minWidth: 0
  },
  date: {
    flexGrow: 0,
    flexShrink: 0,
    width: `var(${DATE_PICKER_WIDTH}, ${PICKER_WIDTH})`,
    minWidth: `var(${DATE_PICKER_WIDTH}, ${PICKER_WIDTH})`,
    maxWidth: `var(${DATE_PICKER_WIDTH}, ${PICKER_WIDTH})`
  },
  time: {
    flexGrow: 0,
    flexShrink: 0,
    width: `var(${DATE_PICKER_WIDTH}, ${TIME_WIDTH})`,
    minWidth: `var(${DATE_PICKER_WIDTH}, ${TIME_WIDTH})`,
    maxWidth: `var(${DATE_PICKER_WIDTH}, ${TIME_WIDTH})`,
    // Fluent's TimePicker is an `inline-grid` of input plus chevron, and the
    // input's `1fr` track carries an implicit min-content floor from the bare
    // `<input>`'s default `size="20"` — around 150px. Narrower than that, the
    // track refuses to shrink and the chevron is pushed outside the field, which
    // is why it appeared stranded to the right of the control at this width.
    // `minmax(0, 1fr)` defeats the floor; the inner `min-width` lets the browser
    // ignore the size-derived minimum.
    gridTemplateColumns: "minmax(0, 1fr) auto",
    "& .fui-TimePicker__input": {
      minWidth: 0
    }
  }
});
function pad(value2) {
  return String(value2).padStart(2, "0");
}
function formatConditionDate(date, dateOnly) {
  const day = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  if (dateOnly) return day;
  return `${day}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
function parseConditionDate(text2) {
  const trimmed = text2.trim();
  if (trimmed === "") return void 0;
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed);
  if (dateOnly) {
    return new Date(
      Number(dateOnly[1]),
      Number(dateOnly[2]) - 1,
      Number(dateOnly[3])
    );
  }
  const parsed = new Date(trimmed);
  return Number.isNaN(parsed.getTime()) ? void 0 : parsed;
}
function mergeConditionDate(day, previous, dateOnly) {
  if (dateOnly || previous === void 0) return day;
  const merged = new Date(day);
  merged.setHours(previous.getHours(), previous.getMinutes(), previous.getSeconds(), 0);
  return merged;
}
function toPickerHour(hour) {
  return Math.min(Math.max(Math.trunc(hour), 0), 24);
}
function isSameDay(left, right) {
  return left.getFullYear() === right.getFullYear() && left.getMonth() === right.getMonth() && left.getDate() === right.getDate();
}
function clampConditionDate(value2, min, max) {
  if (min !== void 0 && value2.getTime() < min.getTime()) return new Date(min);
  if (max !== void 0 && value2.getTime() > max.getTime()) return new Date(max);
  return value2;
}
function DateValueEditor({
  value: value2,
  onChange,
  dateOnly,
  label,
  min,
  max,
  disabled,
  className
}) {
  const styles = useStyles6();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const selected = useMemo(() => parseConditionDate(value2), [value2]);
  const timeDisplay = selected === void 0 ? "" : selected.toLocaleTimeString(void 0, { hour: "numeric", minute: "2-digit" });
  const [timeText, setTimeText] = useState(timeDisplay);
  useEffect(() => {
    setTimeText(timeDisplay);
  }, [timeDisplay]);
  if (value2.trim() !== "" && selected === void 0) {
    return /* @__PURE__ */ jsx(Tooltip, { content: t("date-unrecognized"), relationship: "description", children: /* @__PURE__ */ jsx(
      Input,
      {
        className,
        "aria-label": label,
        disabled,
        value: value2,
        onChange: (_, data) => onChange(data.value)
      }
    ) });
  }
  const commit = (next) => {
    if (!next) {
      onChange("");
      return;
    }
    const merged = mergeConditionDate(next, selected, dateOnly);
    onChange(formatConditionDate(clampConditionDate(merged, min, max), dateOnly));
  };
  const commitTime = (_, data) => {
    if (!data.selectedTime) {
      if (data.errorType === "invalid-input" || data.errorType === "out-of-bounds") return;
      onChange("");
      return;
    }
    const merged = selected === void 0 ? new Date(data.selectedTime) : new Date(selected);
    merged.setHours(
      data.selectedTime.getHours(),
      data.selectedTime.getMinutes(),
      data.selectedTime.getSeconds(),
      0
    );
    onChange(formatConditionDate(clampConditionDate(merged, min, max), false));
  };
  const onTimeText = (event) => {
    setTimeText(event.currentTarget.value);
  };
  const startHour = min !== void 0 && selected !== void 0 && isSameDay(selected, min) ? min.getHours() : void 0;
  const endHour = max !== void 0 && selected !== void 0 && isSameDay(selected, max) ? max.getHours() : void 0;
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses(styles.root, className), children: [
    /* @__PURE__ */ jsx(
      DatePicker,
      {
        className: styles.date,
        "aria-label": label,
        placeholder: label,
        allowTextInput: true,
        ...disabled === void 0 ? {} : { disabled },
        formatDate: (date) => date ? date.toLocaleDateString() : "",
        ...min === void 0 ? {} : { minDate: min },
        ...max === void 0 ? {} : { maxDate: max },
        value: selected ?? null,
        onSelectDate: commit
      }
    ),
    dateOnly ? null : /* @__PURE__ */ jsx(
      TimePicker,
      {
        className: styles.time,
        "aria-label": t("value-time"),
        freeform: true,
        ...disabled === void 0 ? {} : { disabled },
        ...selected === void 0 ? {} : { dateAnchor: selected },
        ...startHour === void 0 ? {} : { startHour: toPickerHour(startHour) },
        ...endHour === void 0 ? {} : { endHour: toPickerHour(endHour) },
        selectedTime: selected ?? null,
        onTimeChange: commitTime,
        value: timeText,
        onChange: onTimeText
      }
    )
  ] });
}
function resolveColumnDisplayText(record, columnName, metadata) {
  const display = resolveColumnDisplayValue(record, columnName, metadata);
  if (display == null || display === "") return display ?? null;
  return holdsText(record, columnName) && isRichTextValue(display, metadata) ? richTextToPlainText(display).replace(/\s*\n\s*/g, " ") : display;
}
function holdsText(record, columnName) {
  let property = record.properties?.[columnName];
  if (property?.$type === "RelatedRecordValue") property = property.value;
  return property?.$type === 14;
}
function readColumnWireValue(property) {
  if (property == null) return void 0;
  if (typeof property !== "object") return property;
  const wrapped = property;
  if (wrapped.$type === "RelatedRecordValue") {
    return readColumnWireValue(wrapped.value);
  }
  return wrapped.value;
}
function composeAddressLines(parts, homeCountry) {
  const lines = [parts.line1, parts.line2, parts.line3].map(clean).filter(isPresent);
  const city = clean(parts.city);
  const region = [parts.stateOrProvince, parts.postalCode].map(clean).filter(isPresent).join(" ");
  const locality = city && region ? `${city}, ${region}` : city || region;
  if (locality) lines.push(locality);
  const country = clean(parts.country);
  if (country && !sameCountry(country, homeCountry)) lines.push(country);
  return lines;
}
function splitCompositeAddress(composite) {
  return (composite ?? "").split(/\r?\n/).map(clean).filter(isPresent);
}
function clean(value2) {
  return value2?.trim() ?? "";
}
function isPresent(value2) {
  return value2.length > 0;
}
function sameCountry(country, homeCountry) {
  const home = clean(homeCountry);
  return home.length > 0 && country.localeCompare(home, void 0, { sensitivity: "base" }) === 0;
}
var ADDRESS_PARTS = ["line1", "line2", "line3", "city", "stateorprovince", "postalcode", "country"];
function resolveAddressLines(record, prefix, homeCountry, dirtyColumns) {
  const part = (suffix) => resolveColumnDisplayValue(record, `${prefix}_${suffix}`);
  const compositeColumn = `${prefix}_composite`;
  const partMaskedOrEdited = ADDRESS_PARTS.some((suffix) => {
    const column = `${prefix}_${suffix}`;
    return !canReadColumn(record, column) || (dirtyColumns?.has(column) ?? false);
  });
  if (canReadColumn(record, compositeColumn) && !partMaskedOrEdited) {
    const composite = splitCompositeAddress(resolveColumnDisplayValue(record, compositeColumn));
    if (composite.length > 0) return composite;
  }
  return composeAddressLines(readParts(part), homeCountry);
}
function readParts(part) {
  return {
    line1: part("line1"),
    line2: part("line2"),
    line3: part("line3"),
    city: part("city"),
    stateOrProvince: part("stateorprovince"),
    postalCode: part("postalcode"),
    country: part("country")
  };
}
function resolveAddressQuery(record, prefix, dirtyColumns) {
  const readable = ADDRESS_PARTS.every((suffix) => canReadColumn(record, `${prefix}_${suffix}`));
  if (readable) return resolveAddressLines(record, prefix, void 0, dirtyColumns).join(", ");
  const part = (suffix) => {
    const column = `${prefix}_${suffix}`;
    return canReadColumn(record, column) ? resolveColumnDisplayValue(record, column) : null;
  };
  return composeAddressLines(readParts(part)).join(", ");
}
function resolveAddressPosition(record, prefix, latitudeColumn, longitudeColumn, dirtyColumns) {
  const position = resolvePosition(record, latitudeColumn, longitudeColumn);
  if (!position) return null;
  const edited = (column) => dirtyColumns?.has(column) ?? false;
  const addressEdited = ADDRESS_PARTS.some((suffix) => edited(`${prefix}_${suffix}`));
  if (addressEdited && !edited(latitudeColumn) && !edited(longitudeColumn)) return null;
  return position;
}
function resolvePosition(record, latitudeColumn, longitudeColumn) {
  const latitude = toCoordinate(readColumnRawValue(record, latitudeColumn));
  const longitude = toCoordinate(readColumnRawValue(record, longitudeColumn));
  if (latitude === null || longitude === null || Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null;
  return { latitude, longitude };
}
function toCoordinate(value2) {
  const number = typeof value2 === "string" && value2.trim() ? Number(value2) : value2;
  return typeof number === "number" && Number.isFinite(number) ? number : null;
}
var NARROW_VIEWPORT_BREAKPOINT_PX = 767.97;
var NARROW_VIEWPORT_QUERY = `(max-width: ${NARROW_VIEWPORT_BREAKPOINT_PX}px)`;
var NARROW_VIEWPORT_MEDIA = `@media ${NARROW_VIEWPORT_QUERY}`;
function useIsNarrowViewport() {
  const [isNarrow, setIsNarrow] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(NARROW_VIEWPORT_QUERY).matches;
  });
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia(NARROW_VIEWPORT_QUERY);
    const handler = (ev) => setIsNarrow(ev.matches);
    setIsNarrow(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  return isNarrow;
}
var clamp2 = (n, min, max) => Math.min(Math.max(n, min), max);
var KEYBOARD_STEP = 16;
function useResizablePane({
  defaultWidth,
  minWidth,
  maxWidth,
  storageKey,
  handleEdge = "end"
}) {
  const [width, setWidth] = useState(() => {
    if (storageKey && typeof window !== "undefined") {
      try {
        const raw = window.localStorage.getItem(storageKey);
        if (raw !== null) {
          const n = Number.parseFloat(raw);
          if (Number.isFinite(n)) return clamp2(n, minWidth, maxWidth);
        }
      } catch {
      }
    }
    return clamp2(defaultWidth, minWidth, maxWidth);
  });
  const [isResizing, setIsResizing] = useState(false);
  const dragRef = useRef(null);
  const widthRef = useRef(width);
  widthRef.current = width;
  const persist = useCallback(
    (w) => {
      if (storageKey && typeof window !== "undefined") {
        try {
          window.localStorage.setItem(storageKey, String(Math.round(w)));
        } catch {
        }
      }
    },
    [storageKey]
  );
  const onPointerDown = useCallback(
    (e) => {
      if (e.button !== 0) return;
      const el = e.currentTarget;
      el.setPointerCapture(e.pointerId);
      const rtl = getComputedStyle(el).direction === "rtl";
      dragRef.current = {
        startX: e.clientX,
        startWidth: widthRef.current,
        sign: handleEdge === "end" !== rtl ? 1 : -1
      };
      setIsResizing(true);
      e.preventDefault();
    },
    [handleEdge]
  );
  const onPointerMove = useCallback(
    (e) => {
      const drag2 = dragRef.current;
      if (!drag2) return;
      const delta = e.clientX - drag2.startX;
      setWidth(clamp2(drag2.startWidth + drag2.sign * delta, minWidth, maxWidth));
    },
    [minWidth, maxWidth]
  );
  const endDrag = useCallback(
    (e) => {
      if (!dragRef.current) return;
      if (e.currentTarget.hasPointerCapture(e.pointerId)) {
        e.currentTarget.releasePointerCapture(e.pointerId);
      }
      dragRef.current = null;
      setIsResizing(false);
      persist(widthRef.current);
    },
    [persist]
  );
  const onDoubleClick = useCallback(() => {
    const next = clamp2(defaultWidth, minWidth, maxWidth);
    setWidth(next);
    persist(next);
  }, [defaultWidth, minWidth, maxWidth, persist]);
  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
        const rtl = getComputedStyle(e.currentTarget).direction === "rtl";
        const sign = handleEdge === "end" !== rtl ? 1 : -1;
        const delta = e.key === "ArrowRight" ? KEYBOARD_STEP : -KEYBOARD_STEP;
        const next = clamp2(widthRef.current + sign * delta, minWidth, maxWidth);
        setWidth(next);
        persist(next);
        e.preventDefault();
      } else if (e.key === "Enter") {
        onDoubleClick();
        e.preventDefault();
      }
    },
    [handleEdge, minWidth, maxWidth, persist, onDoubleClick]
  );
  return {
    width,
    isResizing,
    handleProps: { onPointerDown, onPointerMove, onPointerUp: endDrag, onDoubleClick, onKeyDown }
  };
}
var useStyles7 = makeStyles({
  // Width comes from the custom property the panel sets; on a phone the panel takes the
  // whole width and the handle goes, as the navigation's does. Never wider than the viewport.
  panel: {
    width: "var(--ppp-side-panel-width)",
    maxWidth: "100vw",
    [NARROW_VIEWPORT_MEDIA]: {
      width: "100vw"
    }
  },
  // Locks the resize cursor and stops text selection inside the panel for the whole drag,
  // so neither flickers as the pointer leaves the thin handle.
  resizing: {
    cursor: "col-resize",
    userSelect: "none"
  },
  // The handle straddles the edge facing the page. Transparent until hovered or dragged,
  // like the navigation's. Above the body: Fluent's DrawerBody is `position: relative` with
  // `z-index: 1`, and at an equal z-index it would cover the handle and take its pointer.
  handle: {
    position: "absolute",
    top: 0,
    bottom: 0,
    width: "6px",
    zIndex: 2,
    cursor: "col-resize",
    backgroundColor: "transparent",
    // Stop touch drags from scrolling the panel while resizing.
    touchAction: "none",
    transitionProperty: "background-color",
    transitionDuration: tokens.durationFaster,
    ":hover": {
      backgroundColor: tokens.colorNeutralStroke1Hover
    },
    [NARROW_VIEWPORT_MEDIA]: {
      display: "none"
    }
  },
  // Griffel flips left/right under right-to-left, so these follow the reading direction.
  handleAtStart: {
    left: 0
  },
  handleAtEnd: {
    right: 0
  },
  handleActive: {
    backgroundColor: tokens.colorBrandStroke1
  },
  // Focusable, so it can be resized from the keyboard: the arrow keys move the edge, Enter resets.
  handleFocusable: {
    ":focus-visible": {
      backgroundColor: tokens.colorBrandStroke1,
      outlineWidth: tokens.strokeWidthThick,
      outlineStyle: "solid",
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: "-2px"
    }
  }
});
var SidePanelContext = createContext(null);
function SidePanel({
  open,
  onOpenChange,
  title,
  footer,
  children,
  position = "end",
  enableResizing = true,
  defaultWidth = 400,
  minWidth = 320,
  maxWidth = 1200,
  widthStorageKey,
  className
}) {
  const t = useT();
  const styles = useStyles7();
  const { width, isResizing, handleProps } = useResizablePane({
    defaultWidth,
    minWidth,
    maxWidth,
    // A panel docked at the end has its handle on its start edge, and the reverse.
    handleEdge: position === "end" ? "start" : "end",
    ...widthStorageKey !== void 0 && { storageKey: widthStorageKey }
  });
  const context = useMemo(
    () => ({ close: () => onOpenChange?.(false) }),
    [onOpenChange]
  );
  const panelWidth = enableResizing ? width : defaultWidth;
  const composed = title !== void 0 || footer !== void 0;
  return /* @__PURE__ */ jsx(SidePanelContext.Provider, { value: context, children: /* @__PURE__ */ jsxs(
    OverlayDrawer,
    {
      position,
      open,
      onOpenChange: (_, data) => onOpenChange?.(data.open),
      className: mergeClasses(
        "ppp-side-panel",
        styles.panel,
        isResizing && styles.resizing,
        className
      ),
      style: { "--ppp-side-panel-width": `${panelWidth}px` },
      children: [
        composed ? /* @__PURE__ */ jsxs(Fragment, { children: [
          title !== void 0 && /* @__PURE__ */ jsx(SidePanelHeader, { children: title }),
          /* @__PURE__ */ jsx(SidePanelBody, { children }),
          footer !== void 0 && /* @__PURE__ */ jsx(SidePanelFooter, { children: footer })
        ] }) : children,
        enableResizing && /* @__PURE__ */ jsx(
          "div",
          {
            role: "separator",
            tabIndex: 0,
            "aria-orientation": "vertical",
            "aria-label": t("app.components.side-panel.resize-handle"),
            "aria-valuenow": Math.round(width),
            "aria-valuemin": minWidth,
            "aria-valuemax": maxWidth,
            className: mergeClasses(
              styles.handle,
              styles.handleFocusable,
              position === "end" ? styles.handleAtStart : styles.handleAtEnd,
              isResizing && styles.handleActive
            ),
            ...handleProps
          }
        )
      ]
    }
  ) });
}
function SidePanelHeader({ children, showDismiss = true, dismissLabel }) {
  const t = useT();
  const panel = useContext(SidePanelContext);
  return /* @__PURE__ */ jsx(DrawerHeader, { children: /* @__PURE__ */ jsx(
    DrawerHeaderTitle,
    {
      ...showDismiss && panel && {
        action: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            "aria-label": dismissLabel ?? t("app.buttons.cancel.label"),
            icon: /* @__PURE__ */ jsx(Dismiss24Regular, {}),
            onClick: panel.close
          }
        )
      },
      children
    }
  ) });
}
function SidePanelBody({ children, className }) {
  return /* @__PURE__ */ jsx(DrawerBody, { ...className !== void 0 && { className }, children });
}
function SidePanelFooter({ children }) {
  return /* @__PURE__ */ jsx(DrawerFooter, { children });
}
var VIEW_NAME_LENGTH = 200;
function GridSaveViewDialog({ open, title, name, onSave, onCancel }) {
  const t = useT();
  const [value2, setValue] = useState(name);
  useEffect(() => {
    if (open) setValue(name);
  }, [open, name]);
  const canSave = value2.trim().length > 0;
  const save = () => {
    if (canSave) onSave(value2.trim());
  };
  return /* @__PURE__ */ jsx(Dialog, { open, onOpenChange: (_, data) => !data.open && onCancel(), children: /* @__PURE__ */ jsx(DialogSurface, { style: { width: "min(440px, 94vw)" }, children: /* @__PURE__ */ jsxs(DialogBody, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: title }),
    /* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsx(Field, { label: t("app.components.grid.saved-views-name"), children: /* @__PURE__ */ jsx(
      Input,
      {
        className: "ppp-grid-save-view-name",
        value: value2,
        maxLength: VIEW_NAME_LENGTH,
        autoFocus: true,
        onChange: (_, data) => setValue(data.value),
        onKeyDown: (event) => {
          if (event.key === "Enter") save();
        }
      }
    ) }) }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(Button, { onClick: onCancel, children: t("app.buttons.cancel.label") }),
      /* @__PURE__ */ jsx(Button, { appearance: "primary", disabled: !canSave, onClick: save, children: t("app.components.grid.saved-views-save") })
    ] })
  ] }) }) });
}
function GridColumnLabelsDialog({ open, columns, onSave, onCancel }) {
  const t = useT();
  const [labels, setLabels] = useState(/* @__PURE__ */ new Map());
  useEffect(() => {
    if (open) setLabels(new Map(columns.map((column) => [column.key, column.label ?? ""])));
  }, [open]);
  return /* @__PURE__ */ jsx(Dialog, { open, onOpenChange: (_, data) => !data.open && onCancel(), children: /* @__PURE__ */ jsx(DialogSurface, { style: { width: "min(520px, 94vw)" }, children: /* @__PURE__ */ jsxs(DialogBody, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: t("app.components.grid.saved-views-labels-title") }),
    /* @__PURE__ */ jsxs(DialogContent, { children: [
      /* @__PURE__ */ jsx("p", { children: t("app.components.grid.saved-views-labels-description") }),
      /* @__PURE__ */ jsx("div", { style: { display: "flex", flexDirection: "column", rowGap: tokens.spacingVerticalM }, children: columns.map((column) => /* @__PURE__ */ jsx(Field, { label: column.ownTitle, children: /* @__PURE__ */ jsx(
        Input,
        {
          value: labels.get(column.key) ?? "",
          placeholder: column.ownTitle,
          maxLength: VIEW_NAME_LENGTH,
          onChange: (_, data) => setLabels((current) => new Map(current).set(column.key, data.value))
        }
      ) }, column.key)) })
    ] }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(Button, { onClick: onCancel, children: t("app.buttons.cancel.label") }),
      /* @__PURE__ */ jsx(Button, { appearance: "primary", onClick: () => onSave(labels), children: t("app.components.grid.saved-views-save") })
    ] })
  ] }) }) });
}
var useStyles8 = makeStyles({
  list: {
    listStyleType: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column"
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`
  },
  name: {
    flex: "1 1 auto",
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: tokens.spacingHorizontalXS
  },
  hidden: {
    color: tokens.colorNeutralForeground3
  }
});
function GridManageViewsPanel(props) {
  const t = useT();
  const styles = useStyles8();
  return /* @__PURE__ */ jsx(
    SidePanel,
    {
      open: props.open,
      onOpenChange: props.onOpenChange,
      title: t("app.components.grid.saved-views-manage-title"),
      widthStorageKey: "ppp-grid-manage-views-width",
      children: /* @__PURE__ */ jsx("ul", { className: `ppp-grid-managed-views ${styles.list}`, "aria-busy": props.busy, children: props.views.map((view) => /* @__PURE__ */ jsxs("li", { className: `ppp-grid-managed-view ${styles.row}`, children: [
        /* @__PURE__ */ jsxs("div", { className: `${styles.name} ${view.isHidden ? styles.hidden : ""}`, children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "transparent",
              disabled: props.busy,
              "aria-current": view.isShown ? "true" : void 0,
              onClick: () => props.onOpenView(view.id),
              children: view.isShown ? /* @__PURE__ */ jsx("strong", { children: view.name }) : view.name
            }
          ),
          view.isDefault && /* @__PURE__ */ jsx(Badge, { appearance: "tint", color: "brand", size: "small", children: t("app.components.grid.saved-views-default") }),
          view.isHidden && /* @__PURE__ */ jsx(Badge, { appearance: "tint", color: "informative", size: "small", children: t("app.components.grid.saved-views-hidden") }),
          view.isSaved && /* @__PURE__ */ jsx(Badge, { appearance: "outline", color: "informative", size: "small", children: t("app.components.grid.saved-views-mine") })
        ] }),
        /* @__PURE__ */ jsxs(Menu, { children: [
          /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "subtle",
              disabled: props.busy,
              "aria-label": t("app.components.grid.saved-views-actions", [view.name]),
              icon: /* @__PURE__ */ jsx(MoreHorizontal20Regular, {})
            }
          ) }),
          /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs(MenuList, { children: [
            view.isDefault ? /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(StarOff20Regular, {}), onClick: () => props.onSetDefault(view.id, false), children: t("app.components.grid.saved-views-clear-default") }) : /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Star20Regular, {}), onClick: () => props.onSetDefault(view.id, true), children: t("app.components.grid.saved-views-set-default") }),
            view.isHidden ? /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Eye20Regular, {}), onClick: () => props.onSetHidden(view.id, false), children: t("app.components.grid.saved-views-show") }) : !view.isShown && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(EyeOff20Regular, {}), onClick: () => props.onSetHidden(view.id, true), children: t("app.components.grid.saved-views-hide") }),
            /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Copy20Regular, {}), onClick: () => props.onClone(view.id), children: t("app.components.grid.saved-views-clone") }),
            view.isSaved && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Rename20Regular, {}), onClick: () => props.onRename(view.id), children: t("app.components.grid.saved-views-rename") }),
              props.onEditLabels && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TextEditStyle20Regular, {}), onClick: () => props.onEditLabels?.(view.id), children: t("app.components.grid.saved-views-labels") }),
              /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Delete20Regular, {}), onClick: () => props.onDelete(view.id), children: t("app.components.grid.saved-views-delete") })
            ] })
          ] }) })
        ] })
      ] }, view.id)) })
    }
  );
}
function useSignInPrompt(needsSignIn, signInUrl) {
  const dialog = useDialogService();
  const t = useT();
  return useCallback(
    async (action) => {
      if (!needsSignIn) {
        await action();
        return;
      }
      const result = await dialog.showConfirmationAsync(t("app.components.grid.saved-views-sign-in-message"), {
        title: t("app.components.grid.saved-views-sign-in-title"),
        primaryText: t("app.buttons.login.label"),
        secondaryText: t("app.buttons.cancel.label")
      });
      if (result.canceled) return;
      const returnUrl = window.location.pathname + window.location.search + window.location.hash;
      window.location.assign(`${signInUrl}${signInUrl.includes("?") ? "&" : "?"}ReturnUrl=${encodeURIComponent(returnUrl)}`);
    },
    [needsSignIn, signInUrl, dialog, t]
  );
}
function useSavedViewSession({ saved, operations, signInUrl, deletingText }) {
  const t = useT();
  const dialogService = useDialogService();
  const runWithOverlay = useRunWithOverlay();
  const signedIn = useSignInPrompt(saved.needsSignIn, signInUrl);
  const operationsRef = useRef(operations);
  operationsRef.current = operations;
  const [saving, setSaving] = useState(false);
  const savingRef = useRef(false);
  const [dialog, setDialog] = useState(null);
  const [manageOpen, setManageOpen] = useState(false);
  const run = async (change, progress) => {
    if (savingRef.current) return;
    savingRef.current = true;
    setSaving(true);
    try {
      await (progress === void 0 ? change() : runWithOverlay({ description: progress }, change));
    } catch (error) {
      console.warn("[SavedViews] A change to the user\u2019s saved views failed.", error);
      await dialogService.showErrorAsync(t("app.components.grid.saved-views-error"));
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };
  const viewName = (viewId) => operationsRef.current.managedViewName(viewId) || viewId;
  const confirmDelete = async (viewId) => {
    const result = await dialogService.showConfirmationAsync(
      t("app.components.grid.saved-views-delete-message", [operationsRef.current.savedViewName(viewId) ?? ""]),
      {
        title: t("app.components.grid.saved-views-delete-title"),
        primaryText: t("app.components.grid.saved-views-delete"),
        secondaryText: t("app.buttons.cancel.label")
      }
    );
    if (result.canceled) return;
    await run(() => operationsRef.current.remove(viewId), deletingText);
  };
  const setDefault = (viewId, isDefault) => run(() => saved.setDefault(viewId, isDefault, viewName(viewId)));
  const setHidden = (viewId, isHidden) => run(() => saved.setHidden(viewId, isHidden, viewName(viewId)));
  const openSaveAs = () => setDialog({ kind: "saveAs", viewId: operationsRef.current.shownViewId ?? "", name: "" });
  const openRename = (viewId) => setDialog({ kind: "rename", viewId, name: operationsRef.current.savedViewName(viewId) ?? "" });
  const openClone = (viewId) => setDialog({ kind: "clone", viewId, name: t("app.components.grid.saved-views-copy-of", [operationsRef.current.managedViewName(viewId)]) });
  const openManage = () => setManageOpen(true);
  const saveDialog = (name) => {
    const asked = dialog;
    setDialog(null);
    if (!asked) return;
    const operations2 = operationsRef.current;
    void run(
      () => asked.kind === "rename" ? operations2.rename(asked.viewId, name) : asked.kind === "clone" ? operations2.clone(asked.viewId, name) : operations2.saveAs(name)
    );
  };
  const openViewFromPanel = (viewId) => {
    setManageOpen(false);
    operationsRef.current.openView(viewId);
  };
  const offered = saved.available;
  const showsMenu = saved.available || saved.needsSignIn;
  return {
    offered,
    showsMenu,
    saving,
    run,
    signedIn,
    confirmDelete,
    setDefault,
    setHidden,
    openSaveAs,
    openRename,
    openClone,
    openManage,
    dialog,
    dialogTitle: t(
      dialog?.kind === "rename" ? "app.components.grid.saved-views-rename-title" : dialog?.kind === "clone" ? "app.components.grid.saved-views-clone-title" : "app.components.grid.saved-views-save-as-title"
    ),
    saveDialog,
    closeDialog: () => setDialog(null),
    manageOpen,
    setManageOpen,
    openViewFromPanel,
    managedViews: () => operationsRef.current.managedViews(),
    editColumnLabels: operations.editColumnLabels ? (viewId) => {
      setManageOpen(false);
      operationsRef.current.editColumnLabels?.(viewId);
    } : void 0,
    menu: ({ canSave, canSaveAs, canSetDefault }) => showsMenu ? {
      canSave,
      canSaveAs,
      canSetDefault,
      busy: saving,
      onSave: () => void signedIn(() => run(() => operationsRef.current.save())),
      onSaveAs: () => void signedIn(openSaveAs),
      onSetDefault: () => void signedIn(() => {
        const shown = operationsRef.current.shownViewId;
        return shown ? setDefault(shown, true) : void 0;
      }),
      onManage: () => void signedIn(openManage)
    } : void 0
  };
}
function SavedViewDialogs({ session }) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      GridSaveViewDialog,
      {
        open: session.dialog !== null,
        title: session.dialogTitle,
        name: session.dialog?.name ?? "",
        onSave: session.saveDialog,
        onCancel: session.closeDialog
      }
    ),
    session.offered && /* @__PURE__ */ jsx(
      GridManageViewsPanel,
      {
        open: session.manageOpen,
        onOpenChange: session.setManageOpen,
        views: session.manageOpen ? session.managedViews() : [],
        busy: session.saving,
        onOpenView: session.openViewFromPanel,
        onSetDefault: (id, isDefault) => void session.setDefault(id, isDefault),
        onSetHidden: (id, isHidden) => void session.setHidden(id, isHidden),
        onRename: session.openRename,
        ...session.editColumnLabels && { onEditLabels: session.editColumnLabels },
        onClone: session.openClone,
        onDelete: (id) => void session.confirmDelete(id)
      }
    )
  ] });
}
var useStyles9 = makeStyles({
  // As wide as a grid's view picker.
  root: {
    minWidth: "220px"
  }
});
function ViewPicker({ options, value: value2, onChange, isUserView, sort = ViewSort.Default, disabled, className }) {
  const styles = useStyles9();
  const t = useT();
  const { locale } = useLocale();
  const listed = useMemo(() => {
    if (sort === ViewSort.Default) return options;
    const direction = sort === ViewSort.NameDescending ? -1 : 1;
    return [...options].sort((a, b) => direction * a.label.localeCompare(b.label, locale));
  }, [options, sort, locale]);
  const option = (view) => /* @__PURE__ */ jsx(Option, { value: view.id, text: view.label, children: view.label }, view.id);
  const own = isUserView ? listed.filter((view) => isUserView(view.id)) : [];
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      className: mergeClasses("ppp-view-picker", styles.root, className),
      "aria-label": t("app.components.view-selector.view-name"),
      value: listed.find((view) => view.id === value2)?.label ?? "",
      selectedOptions: value2 ? [value2] : [],
      disabled: disabled ?? false,
      onOptionSelect: (_, data) => {
        if (data.optionValue && data.optionValue !== value2) onChange(data.optionValue);
      },
      children: own.length === 0 ? listed.map(option) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(OptionGroup, { label: t("app.components.grid.views-system"), children: listed.filter((view) => !isUserView(view.id)).map(option) }),
        /* @__PURE__ */ jsx(OptionGroup, { label: t("app.components.grid.views-mine"), children: own.map(option) })
      ] })
    }
  );
}
function ViewRefreshButton({ onClick, disabled, className }) {
  const t = useT();
  return /* @__PURE__ */ jsx(Tooltip, { content: t("app.buttons.refresh.label"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
    Button,
    {
      className: mergeClasses("ppp-view-refresh", className),
      appearance: "subtle",
      icon: /* @__PURE__ */ jsx(ArrowClockwise24Regular, {}),
      disabled: disabled ?? false,
      onClick
    }
  ) });
}
function MapPrintButton({ onPrint, onSaveImage, canSaveImage, disabled, inToolbar, className }) {
  const t = useT();
  const button = (onClick) => /* @__PURE__ */ jsx(
    Button,
    {
      className: mergeClasses("ppp-map-print-button", className),
      appearance: inToolbar ? "subtle" : "secondary",
      icon: inToolbar ? /* @__PURE__ */ jsx(Print24Regular, {}) : /* @__PURE__ */ jsx(Print20Regular, {}),
      disabled: disabled ?? false,
      ...onClick && { onClick }
    }
  );
  if (!canSaveImage) {
    return /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.map.print"), relationship: "label", withArrow: true, children: button(onPrint) });
  }
  return /* @__PURE__ */ jsxs(Menu, { positioning: "below-end", children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.map.print-menu"), relationship: "label", withArrow: true, children: button() }) }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: /* @__PURE__ */ jsx(MapPrintMenuItems, { onPrint, onSaveImage, canSaveImage: true, disabled }) }) })
  ] });
}
function MapPrintMenuItems({ onPrint, onSaveImage, canSaveImage, disabled }) {
  const t = useT();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(MenuItem, { className: "ppp-map-print-item", icon: /* @__PURE__ */ jsx(Print20Regular, {}), disabled: disabled ?? false, onClick: onPrint, children: t("app.components.map.print") }),
    canSaveImage && /* @__PURE__ */ jsx(MenuItem, { className: "ppp-map-save-image-item", icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}), disabled: disabled ?? false, onClick: onSaveImage, children: t("app.components.map.save-image") })
  ] });
}
function ViewSearchBox({
  value: value2,
  onChange,
  onTextChange,
  placeholder,
  delay = 300,
  tooltip,
  tooltipPositioning = "below",
  contentBefore,
  className
}) {
  const [text2, setText] = useState(value2);
  const textRef = useRef(text2);
  textRef.current = text2;
  const handed = useRef(value2);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  useEffect(() => {
    if (value2 === textRef.current) {
      handed.current = value2;
      return;
    }
    if (value2 === handed.current) return;
    handed.current = value2;
    setText(value2);
  }, [value2]);
  useEffect(() => {
    if (!onChangeRef.current || text2 === handed.current) return;
    const timer = setTimeout(() => {
      handed.current = text2;
      onChangeRef.current?.(text2);
    }, delay);
    return () => clearTimeout(timer);
  }, [text2, delay]);
  const box = /* @__PURE__ */ jsx(
    SearchBox,
    {
      className: mergeClasses("ppp-view-search", className),
      placeholder,
      "aria-label": placeholder,
      value: text2,
      ...contentBefore !== void 0 && { contentBefore },
      onChange: (_, data) => {
        setText(data.value);
        onTextChange?.(data.value);
      }
    }
  );
  return tooltip === void 0 ? box : /* @__PURE__ */ jsx(Tooltip, { relationship: "description", withArrow: true, positioning: tooltipPositioning, content: tooltip, children: box });
}
var GridMapPrintList = {
  /** The records selected on the cards; every card's, with none selected. */
  Selected: "selected",
  /** The records whose pins are in view on the map as it is printed. */
  InView: "inView",
  /** Every card beside the map. */
  All: "all",
  /** None: the map alone. */
  None: "none"
};
function boundsHold(bounds, latitude, longitude) {
  if (latitude < bounds.south || latitude > bounds.north) return false;
  if (bounds.east - bounds.west >= 360) return true;
  const wrap = (value2) => ((value2 + 180) % 360 + 360) % 360 - 180;
  const [west, east, at] = [wrap(bounds.west), wrap(bounds.east), wrap(longitude)];
  return west <= east ? at >= west && at <= east : at >= west || at <= east;
}
var GridNearSearchContext = createContext(null);
function useGridNearSearch() {
  return useContext(GridNearSearchContext);
}
var GridMapRendererContext = createContext(null);
function useGridMapRenderer() {
  return useContext(GridMapRendererContext);
}
var MAP_PRINT_LISTS = [
  { list: GridMapPrintList.Selected, key: "map-print-list-selected" },
  { list: GridMapPrintList.InView, key: "map-print-list-in-view" },
  { list: GridMapPrintList.All, key: "map-print-list-all" },
  { list: GridMapPrintList.None, key: "map-print-list-none" }
];
var MAP_PRINT_LIST = "mapPrintList";
function offersGridSettings(props) {
  return !!(props.onColumns || props.onSort || props.pageSize || props.editable || props.mapSelectedOnly || props.mapPrintList);
}
var EDITABLE = "editable";
var MAP_SELECTED_ONLY = "mapSelectedOnly";
var PAGE_SIZE = "pageSize";
function SettingsMenuList(props) {
  const t = useT();
  const sections = [];
  if (props.onColumns || props.onSort) {
    sections.push(
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        props.onColumns && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TableAdd20Regular, {}), onClick: props.onColumns, children: t("app.components.grid.columns") }),
        props.onSort && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(ArrowSort20Regular, {}), onClick: props.onSort, children: t("app.components.grid.sort") })
      ] }, "layout")
    );
  }
  if (props.pageSize || props.editable) {
    const pageSize = props.pageSize;
    const editable = props.editable;
    sections.push(
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        pageSize && /* @__PURE__ */ jsxs(
          Menu,
          {
            checkedValues: { [PAGE_SIZE]: [String(pageSize.value)] },
            onCheckedValueChange: (_, data) => {
              const next = Number(data.checkedItems[0]);
              if (Number.isFinite(next) && next > 0) pageSize.onChange(next);
            },
            children: [
              /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { children: `${t("app.components.grid.page-size")}: ${pageSize.value}` }) }),
              /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: pageSize.options.map((size) => /* @__PURE__ */ jsx(MenuItemRadio, { name: PAGE_SIZE, value: String(size), children: String(size) }, size)) }) })
            ]
          }
        ),
        editable && (editable.disabledReason ? /* @__PURE__ */ jsx(Tooltip, { relationship: "description", withArrow: true, content: editable.disabledReason, children: /* @__PURE__ */ jsx(MenuItemCheckbox, { name: EDITABLE, value: EDITABLE, disabled: true, children: t("app.components.grid.editable") }) }) : /* @__PURE__ */ jsx(MenuItemCheckbox, { name: EDITABLE, value: EDITABLE, children: t("app.components.grid.editable") }))
      ] }, "grid")
    );
  }
  if (props.mapSelectedOnly || props.mapPrintList) {
    const printList = props.mapPrintList;
    sections.push(
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        props.mapSelectedOnly && /* @__PURE__ */ jsx(MenuItemCheckbox, { name: MAP_SELECTED_ONLY, value: MAP_SELECTED_ONLY, className: "ppp-grid-map-selected-only", children: t("app.components.grid.map-selected-only") }),
        printList && /* @__PURE__ */ jsxs(
          Menu,
          {
            checkedValues: { [MAP_PRINT_LIST]: [printList.value] },
            onCheckedValueChange: (_, data) => {
              const next = MAP_PRINT_LISTS.find((x) => x.list === data.checkedItems[0]);
              if (next) printList.onChange(next.list);
            },
            children: [
              /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { className: "ppp-grid-map-print-list", children: t("app.components.grid.map-print-list") }) }),
              /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: MAP_PRINT_LISTS.map(({ list, key: key3 }) => /* @__PURE__ */ jsx(MenuItemRadio, { name: MAP_PRINT_LIST, value: list, className: "ppp-grid-map-print-list-option", children: t(`app.components.grid.${key3}`) }, list)) }) })
            ]
          }
        )
      ] }, "map")
    );
  }
  return /* @__PURE__ */ jsx(MenuList, { children: sections.flatMap((section, index) => index === 0 ? [section] : [/* @__PURE__ */ jsx(MenuDivider, {}, `divider-${index}`), section]) });
}
function menuChecks(props) {
  return {
    checkedValues: {
      [EDITABLE]: props.editable?.checked ? [EDITABLE] : [],
      [MAP_SELECTED_ONLY]: props.mapSelectedOnly?.checked ? [MAP_SELECTED_ONLY] : []
    },
    onCheckedValueChange: (_, data) => {
      if (data.name === EDITABLE) props.editable?.onChange(data.checkedItems.includes(EDITABLE));
      if (data.name === MAP_SELECTED_ONLY) props.mapSelectedOnly?.onChange(data.checkedItems.includes(MAP_SELECTED_ONLY));
    }
  };
}
function GridSettingsButton(props) {
  const t = useT();
  return /* @__PURE__ */ jsxs(Menu, { hasIcons: true, hasCheckmarks: !!(props.editable || props.mapSelectedOnly), ...menuChecks(props), children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: t("app.buttons.settings.label"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "subtle",
        className: "ppp-grid-settings",
        icon: /* @__PURE__ */ jsx(Settings24Regular, {})
      }
    ) }) }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(SettingsMenuList, { ...props }) })
  ] });
}
function GridSettingsOverflowItem(props) {
  const t = useT();
  return /* @__PURE__ */ jsxs(Menu, { hasIcons: true, hasCheckmarks: !!(props.editable || props.mapSelectedOnly), ...menuChecks(props), children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Settings20Regular, {}), children: t("app.buttons.settings.label") }) }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(SettingsMenuList, { ...props }) })
  ] });
}
var TABLES = "tables";
var showsTables = (props) => (props.tables?.length ?? 0) > 1;
function offersViewFilterMenu(props) {
  return !!props.onEditFilters || !!props.refinements || showsTables(props) || !!props.savedViews;
}
var offersOnlyFilters = (props) => !!props.onEditFilters && !props.refinements && !showsTables(props) && !props.savedViews;
var checks = (props) => showsTables(props) || !!props.refinements;
function menuChecks2(props) {
  return {
    checkedValues: { ...props.refinements?.checkedValues, [TABLES]: (props.tables ?? []).filter((x) => x.shown).map((x) => x.table) },
    onCheckedValueChange: (_, data) => {
      if (data.name !== TABLES) {
        props.refinements?.onCheckedValueChange(data.name, data.checkedItems);
        return;
      }
      for (const table of props.tables ?? []) {
        const shown = data.checkedItems.includes(table.table);
        if (shown !== table.shown) props.onTableShownChange?.(table.table, shown);
      }
    }
  };
}
function ViewFilterMenuList(props) {
  const t = useT();
  const sections = [];
  if (props.onEditFilters) {
    sections.push(
      /* @__PURE__ */ jsx(MenuGroup, { children: /* @__PURE__ */ jsx(MenuItem, { className: "ppp-view-menu-edit-filters", icon: /* @__PURE__ */ jsx(Filter20Regular, {}), onClick: props.onEditFilters, children: t("app.components.view-filter-menu.edit-filters") }) }, "filters")
    );
  }
  if (props.refinements) {
    sections.push(/* @__PURE__ */ jsx(MenuGroup, { children: props.refinements.items }, "refinements"));
  }
  if (showsTables(props)) {
    sections.push(
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        /* @__PURE__ */ jsx(MenuGroupHeader, { children: t("app.components.view-filter-menu.show") }),
        props.tables.map((table) => /* @__PURE__ */ jsx(MenuItemCheckbox, { className: "ppp-view-menu-table", name: TABLES, value: table.table, children: table.label }, table.table))
      ] }, "tables")
    );
  }
  const views = props.savedViews;
  if (views) {
    sections.push(
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        /* @__PURE__ */ jsx(MenuGroupHeader, { children: t("app.components.grid.saved-views") }),
        views.canSave && /* @__PURE__ */ jsx(MenuItem, { className: "ppp-view-menu-save", icon: /* @__PURE__ */ jsx(Save20Regular, {}), disabled: views.busy, onClick: views.onSave, children: t("app.components.grid.saved-views-save") }),
        views.canSaveAs && /* @__PURE__ */ jsx(MenuItem, { className: "ppp-view-menu-save-as", icon: /* @__PURE__ */ jsx(SaveCopy20Regular, {}), disabled: views.busy, onClick: views.onSaveAs, children: t("app.components.grid.saved-views-save-as") }),
        views.canSetDefault && /* @__PURE__ */ jsx(MenuItem, { className: "ppp-view-menu-set-default", icon: /* @__PURE__ */ jsx(Star20Regular, {}), disabled: views.busy, onClick: views.onSetDefault, children: t("app.components.grid.saved-views-set-default") }),
        /* @__PURE__ */ jsx(MenuItem, { className: "ppp-view-menu-manage", icon: /* @__PURE__ */ jsx(Settings20Regular, {}), disabled: views.busy, onClick: views.onManage, children: t("app.components.grid.saved-views-manage") })
      ] }, "views")
    );
  }
  return /* @__PURE__ */ jsx(MenuList, { children: sections.flatMap((section, index) => index === 0 ? [section] : [/* @__PURE__ */ jsx(MenuDivider, {}, `divider-${index}`), section]) });
}
function ViewFilterMenu(props) {
  const t = useT();
  if (!offersViewFilterMenu(props)) return null;
  const icon = props.changed ? /* @__PURE__ */ jsx(Filter24Filled, { primaryFill: tokens.colorBrandForeground1 }) : /* @__PURE__ */ jsx(Filter24Regular, {});
  const label = t("app.components.grid.filter");
  if (offersOnlyFilters(props)) {
    return /* @__PURE__ */ jsx(Tooltip, { content: label, relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "subtle",
        className: "ppp-view-filter-menu",
        icon,
        disabled: !!props.disabled,
        onClick: props.onEditFilters
      }
    ) });
  }
  return /* @__PURE__ */ jsxs(Menu, { hasIcons: true, hasCheckmarks: checks(props), ...menuChecks2(props), children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: label, relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(Button, { appearance: "subtle", className: "ppp-view-filter-menu", icon, disabled: !!props.disabled }) }) }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(ViewFilterMenuList, { ...props }) })
  ] });
}
function ViewFilterMenuOverflowItem(props) {
  const t = useT();
  if (!offersViewFilterMenu(props)) return null;
  const icon = props.changed ? /* @__PURE__ */ jsx(Filter20Filled, { primaryFill: tokens.colorBrandForeground1 }) : /* @__PURE__ */ jsx(Filter20Regular, {});
  const label = t("app.components.grid.filter");
  if (offersOnlyFilters(props)) {
    return /* @__PURE__ */ jsx(MenuItem, { icon, disabled: !!props.disabled, onClick: props.onEditFilters, children: label });
  }
  return /* @__PURE__ */ jsxs(Menu, { hasIcons: true, hasCheckmarks: checks(props), ...menuChecks2(props), children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { icon, disabled: !!props.disabled, children: label }) }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(ViewFilterMenuList, { ...props }) })
  ] });
}
var useStyles10 = makeStyles({
  surface: {
    maxWidth: "680px"
  },
  body: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
    minHeight: 0
  },
  list: {
    display: "flex",
    flexDirection: "column",
    height: "340px",
    overflowY: "auto",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusMedium
  },
  /**
   * Each kind's block. A flex column, so the rows inside it stretch the way they
   * did before the groups existed — a `<button>` in a plain block context sizes to
   * its content and leaves the rest of the row unclickable.
   */
  group: {
    display: "flex",
    flexDirection: "column"
  },
  row: {
    display: "flex",
    flexDirection: "column",
    // Belt and braces with the flex stretch above: the row spans the list however
    // it is laid out, so the whole width is a hit target.
    width: "100%",
    boxSizing: "border-box",
    rowGap: tokens.spacingVerticalXXS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke3}`,
    cursor: "pointer",
    textAlign: "start",
    backgroundColor: "transparent",
    border: "none",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover
    }
  },
  selected: {
    backgroundColor: tokens.colorNeutralBackground1Selected
  },
  /**
   * What a row leads with: the lookup that forms the relationship, which is the
   * part that tells two apart. A table reached by several lookups reads as the
   * same table on every row, so the lookup carries the emphasis and goes first.
   */
  leading: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1
  },
  /** What follows it — the table at the other end. */
  trailing: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground3
  },
  groupHeading: {
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalM}`,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground2,
    backgroundColor: tokens.colorNeutralBackground2,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    position: "sticky",
    top: 0,
    zIndex: 1
  },
  detail: {
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3
  },
  empty: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    color: tokens.colorNeutralForeground3
  }
});
function RelationshipPickerDialog({
  open,
  relationships,
  tables,
  sourceColumns,
  onCommit,
  onCancel,
  showLogicalNames: showLogicalNamesProp
}) {
  const styles = useStyles10();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(void 0);
  useEffect(() => {
    if (!open) return;
    setSearch("");
    setSelected(void 0);
  }, [open]);
  const builderShowsLogicalNames = useShowLogicalNames();
  const showLogicalNames = showLogicalNamesProp ?? builderShowsLogicalNames;
  const describe = useMemo(
    () => (relationship) => describeRelationship(relationship, tables, sourceColumns, showLogicalNames),
    [tables, sourceColumns, showLogicalNames]
  );
  const groups = useMemo(
    () => groupRelationships(
      searchRelationships(relationships, search, describe),
      // Ordered by the lookup the row leads with, not by the table it reaches:
      // several lookups to one table would otherwise sort as one indistinct run.
      (relationship) => relationshipLeadLabel(describe(relationship))
    ),
    [relationships, search, describe]
  );
  const chosen = groups.flatMap((group) => group.relationships).find((relationship) => relationship.schemaName === selected);
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      open,
      onOpenChange: (_, data) => {
        if (!data.open) onCancel();
      },
      children: /* @__PURE__ */ jsx(DialogSurface, { className: styles.surface, children: /* @__PURE__ */ jsxs(DialogBody, { children: [
        /* @__PURE__ */ jsx(DialogTitle, { children: t("select-relationship-title") }),
        /* @__PURE__ */ jsxs(DialogContent, { className: styles.body, children: [
          /* @__PURE__ */ jsx(
            Input,
            {
              value: search,
              onChange: (_, data) => setSearch(data.value),
              placeholder: t("search-relationships"),
              "aria-label": t("search-relationships"),
              contentBefore: /* @__PURE__ */ jsx(Search20Regular, {})
            }
          ),
          /* @__PURE__ */ jsx("div", { className: styles.list, role: "listbox", "aria-label": t("select-relationship-title"), children: groups.length === 0 ? /* @__PURE__ */ jsx("div", { className: styles.empty, children: t("no-relationships") }) : groups.map((group) => /* @__PURE__ */ jsxs(
            "div",
            {
              role: "group",
              className: styles.group,
              "aria-label": t(RELATIONSHIP_KIND_KEYS[group.kind]),
              children: [
                /* @__PURE__ */ jsx("div", { className: styles.groupHeading, children: t(RELATIONSHIP_KIND_KEYS[group.kind]) }),
                group.relationships.map((relationship) => {
                  const { table, lookup } = describe(relationship);
                  return /* @__PURE__ */ jsxs(
                    "button",
                    {
                      type: "button",
                      role: "option",
                      "aria-selected": relationship.schemaName === selected,
                      className: mergeClasses(
                        styles.row,
                        relationship.schemaName === selected ? styles.selected : void 0
                      ),
                      onClick: () => setSelected(relationship.schemaName),
                      onDoubleClick: () => onCommit(relationship),
                      children: [
                        /* @__PURE__ */ jsxs("span", { children: [
                          /* @__PURE__ */ jsx("span", { className: styles.leading, children: relationshipLeadLabel({ table, lookup }) }),
                          lookup === void 0 ? null : /* @__PURE__ */ jsx("span", { className: styles.trailing, children: ` - ${table}` })
                        ] }),
                        showLogicalNames && /* @__PURE__ */ jsx("span", { className: styles.detail, children: relationship.schemaName })
                      ]
                    },
                    relationship.schemaName
                  );
                })
              ]
            },
            group.kind
          )) })
        ] }),
        /* @__PURE__ */ jsxs(DialogActions, { children: [
          /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: onCancel, children: t("cancel") }),
          /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "primary",
              disabled: chosen === void 0,
              onClick: () => {
                if (chosen !== void 0) onCommit(chosen);
              },
              children: t("ok")
            }
          )
        ] })
      ] }) })
    }
  );
}
var DATE_ONLY_BEHAVIOR = 1;
function usePowerPortalsProFetchXmlMetadata() {
  const { tableMetadataCache, viewsForTableCache, ppp } = usePowerPortalsPro();
  return useMemo(
    () => ({
      async getTables() {
        const headers = await tableMetadataCache.getAllHeadersAsync();
        return headers.map(toTableInfo);
      },
      async getTable(tableLogicalName) {
        const metadata = await tableMetadataCache.getAsync(tableLogicalName);
        if (!metadata) return void 0;
        const detail = toTableDetail(tableLogicalName, metadata);
        return {
          ...detail,
          relationships: await withRelatedTableDetails(detail.relationships, tableMetadataCache)
        };
      },
      async getViews(tableLogicalName) {
        const views = await viewsForTableCache.getAsync(tableLogicalName);
        return views.filter((view) => (view.fetchXml ?? "") !== "").map((view) => ({
          id: view.id,
          // The same label the grids' view picker shows: `displayName` is the
          // consumer's override for it, and falling back to `name` is what makes
          // the two lists read as the same views.
          name: view.displayName ?? view.name,
          fetchXml: view.fetchXml ?? "",
          isDefault: view.isDefault
        }));
      },
      getRecordNames(tableLogicalName, ids) {
        return retrieveRecordNames(ppp, tableMetadataCache, tableLogicalName, ids);
      }
    }),
    [tableMetadataCache, viewsForTableCache, ppp]
  );
}
async function retrieveRecordNames(ppp, cache, tableLogicalName, ids) {
  const names2 = /* @__PURE__ */ new Map();
  if (ids.length === 0) return names2;
  try {
    const metadata = await cache.getAsync(tableLogicalName);
    const nameColumn = metadata?.primaryNameColumn;
    const idColumn = metadata?.primaryIdColumn;
    if (!metadata || !nameColumn || !idColumn) return names2;
    const base = createFetchXmlQuery(tableLogicalName);
    const query = {
      ...base,
      entity: {
        ...base.entity,
        attributes: [createAttribute(nameColumn)],
        filters: [
          {
            ...createFilter(LogicalOperator.And),
            conditions: [
              createCondition({
                attribute: idColumn,
                operator: ConditionOperator.In,
                values: ids.map((id) => ({ value: id }))
              })
            ]
          }
        ]
      }
    };
    const response = await ppp.retrieveRecordsAsync(toFetchXml(query));
    for (const record of response.tableRecords ?? []) {
      const id = getRecordReferenceId(record);
      const name = resolveColumnDisplayValue(record, nameColumn) ?? void 0;
      if (id !== void 0 && name !== void 0 && name !== "") names2.set(id, name);
    }
  } catch {
  }
  return names2;
}
function toTableInfo(header) {
  return {
    logicalName: header.logicalName,
    displayName: header.displayName,
    schemaName: header.schemaName,
    isValidForAdvancedFind: header.isValidForAdvancedFind,
    isIntersect: header.isIntersect
  };
}
function toTableDetail(logicalName, metadata) {
  return {
    logicalName,
    primaryIdColumn: metadata.primaryIdColumn,
    primaryNameColumn: metadata.primaryNameColumn,
    columns: toColumns(metadata),
    relationships: toRelationships(logicalName, metadata)
  };
}
function toColumns(metadata) {
  const columns = metadata.columns ?? [];
  return columns.filter(
    (column) => typeof column.columnName === "string" && column.columnName !== ""
  ).map((column) => ({
    logicalName: column.columnName,
    displayName: column.displayName,
    validForAdvancedFind: column.isValidForAdvancedFind,
    // `columnType` is the typed slot; `$type` is the polymorphic discriminator
    // carrying the same integer. Reading both means a payload shaped by either
    // serializer settles on the same answer.
    type: column.columnType ?? column.$type,
    targets: column.targetTables,
    options: column.choices?.map((choice2) => ({
      value: Number(choice2.value),
      label: choice2.displayName
    })),
    optionSetName: column.choiceLogicalName,
    dateOnly: column.dateTimeBehavior === DATE_ONLY_BEHAVIOR
  })).sort(
    (left, right) => metadataLabel(left).localeCompare(metadataLabel(right))
  );
}
function toRelationships(logicalName, metadata) {
  const result = [];
  for (const relationship of metadata.oneToMany ?? []) {
    result.push({
      schemaName: relationship.relationshipName,
      kind: "oneToMany",
      relatedTable: relationship.referencingTable,
      from: relationship.referencingTableColumn,
      to: relationship.referencedTableColumn
    });
  }
  for (const relationship of metadata.manyToOne ?? []) {
    result.push({
      schemaName: relationship.relationshipName,
      kind: "manyToOne",
      relatedTable: relationship.referencedTable,
      from: relationship.referencedTableColumn,
      to: relationship.referencingTableColumn
    });
  }
  for (const relationship of metadata.manyToMany ?? []) {
    const isTable1 = equalsIgnoreCase(relationship.table1, logicalName);
    const related = isTable1 ? relationship.table2 : relationship.table1;
    const { own, other } = intersectColumnsFor(relationship, logicalName, metadata.primaryIdColumn);
    result.push({
      schemaName: relationship.relationshipName,
      kind: "manyToMany",
      relatedTable: related,
      from: own,
      to: metadata.primaryIdColumn,
      intersectTable: relationship.intersectTableName,
      // The second hop, on to the related table by its primary id. This table's
      // metadata doesn't carry that: a self-referencing relationship's is this
      // table's own, and anything else is guessed from the intersect column —
      // usually named after it — until `withRelatedTableDetails` reads the real one.
      relatedKey: equalsIgnoreCase(related, logicalName) ? metadata.primaryIdColumn : other,
      relatedIntersectColumn: other
    });
  }
  return result.sort((left, right) => left.schemaName.localeCompare(right.schemaName));
}
async function withRelatedTableDetails(relationships, cache) {
  const wanted = /* @__PURE__ */ new Map();
  for (const relationship of relationships) {
    if (relationship.kind === "manyToMany") {
      if (relationship.relatedKey !== void 0 && relationship.relatedKey === relationship.to) continue;
      if (!wanted.has(relationship.relatedTable)) wanted.set(relationship.relatedTable, /* @__PURE__ */ new Set());
      continue;
    }
    if (relationship.kind !== "oneToMany" || relationship.from === "") continue;
    const columns = wanted.get(relationship.relatedTable) ?? /* @__PURE__ */ new Set();
    columns.add(relationship.from);
    wanted.set(relationship.relatedTable, columns);
  }
  if (wanted.size === 0) return relationships;
  const requests = [...wanted].map(([tableName, columns]) => ({
    tableName,
    columns: [...columns]
  }));
  let tables;
  try {
    tables = await cache.getManyAsync(requests);
  } catch {
    return relationships;
  }
  const labels = /* @__PURE__ */ new Map();
  const primaryIds = /* @__PURE__ */ new Map();
  for (const table of tables) {
    if (table.primaryIdColumn) primaryIds.set(table.tableName.toLowerCase(), table.primaryIdColumn);
    for (const column of table.columns ?? []) {
      if (column.columnName && column.displayName)
        labels.set(lookupKey(table.tableName, column.columnName), column.displayName);
    }
  }
  return relationships.map((relationship) => {
    if (relationship.kind === "manyToMany") {
      const relatedKey = primaryIds.get(relationship.relatedTable.toLowerCase());
      return relatedKey === void 0 ? relationship : { ...relationship, relatedKey };
    }
    if (relationship.kind !== "oneToMany") return relationship;
    const label = labels.get(lookupKey(relationship.relatedTable, relationship.from));
    return label === void 0 ? relationship : { ...relationship, lookupLabel: label };
  });
}
function lookupKey(tableName, columnName) {
  return `${tableName.toLowerCase()}.${columnName.toLowerCase()}`;
}
function intersectColumnsFor(relationship, tableName, primaryIdColumn, otherPrimaryIdColumn) {
  const first = relationship.table1IntersectColumn ?? "";
  const second = relationship.table2IntersectColumn ?? "";
  const inOrder = { own: first, other: second };
  const swapped = { own: second, other: first };
  const isTable1 = equalsIgnoreCase(relationship.table1, tableName);
  if (isTable1 && equalsIgnoreCase(relationship.table2, tableName)) return inOrder;
  const firstNamesIt = equalsIgnoreCase(first, primaryIdColumn ?? "");
  const secondNamesIt = equalsIgnoreCase(second, primaryIdColumn ?? "");
  if (firstNamesIt !== secondNamesIt) return firstNamesIt ? inOrder : swapped;
  if (otherPrimaryIdColumn) {
    const firstIsOther = equalsIgnoreCase(first, otherPrimaryIdColumn);
    const secondIsOther = equalsIgnoreCase(second, otherPrimaryIdColumn);
    if (firstIsOther !== secondIsOther) return firstIsOther ? swapped : inOrder;
  }
  return isTable1 ? inOrder : swapped;
}
function equalsIgnoreCase(left, right) {
  return (left ?? "").toLowerCase() === right.toLowerCase();
}
function useShowsLogicalNames() {
  const auth = useAuth();
  return auth.status === AuthStatus.Authenticated && auth.user.portalUserType === PortalUserType.SystemUser;
}
var useStyles11 = makeStyles({
  surface: {
    // Room for a condition's column, operator, comparison and value on one line, with its
    // buttons beside them rather than wrapped under — in a related table's filter too.
    width: "min(1200px, 94vw)",
    maxWidth: "min(1200px, 94vw)"
  },
  // The builder takes the whole height of its parent, here the dialog's content: a filter taller
  // than the window caps it there, and its section shrinks with it, leaving the last rows below
  // the section's border. Sized to its rows, it lets the content scroll them instead.
  builder: {
    height: "auto"
  }
});
function GridFilterDialog(props) {
  const { open, onCancel } = props;
  return open ? /* @__PURE__ */ jsx(Dialog, { open: true, onOpenChange: (_, data) => !data.open && onCancel(), children: /* @__PURE__ */ jsx(GridFilterDialogSurface, { ...props }) }) : null;
}
function GridFilterDialogSurface({ table, criteria, viewCriteria, onApply, onCancel }) {
  const t = useT();
  const showsLogicalNames = useShowsLogicalNames();
  const styles = useStyles11();
  const metadata = useReadableFetchXmlMetadata();
  const [draft, setDraft] = useState(criteria);
  const [restoring, setRestoring] = useState(false);
  const canApply = useMemo(() => {
    try {
      return !hasIncompleteCondition(parseFetchXml(draft).entity);
    } catch {
      return false;
    }
  }, [draft]);
  return /* @__PURE__ */ jsx(DialogSurface, { className: styles.surface, "aria-label": t("app.components.grid.filter-title"), children: /* @__PURE__ */ jsxs(DialogBody, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: t("app.components.grid.filter-title") }),
    /* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsx(
      FetchXmlBuilder,
      {
        className: styles.builder,
        value: draft,
        onChange: setDraft,
        metadata,
        table,
        allowAggregate: false,
        showLogicalNames: showsLogicalNames,
        sections: { table: false, columns: false, sorts: false, options: false, preview: false }
      }
    ) }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          onClick: () => {
            setDraft(viewCriteria);
            setRestoring(true);
          },
          children: t("app.components.grid.filter-reset")
        }
      ),
      /* @__PURE__ */ jsx(Button, { onClick: onCancel, children: t("app.components.grid.filter-cancel") }),
      /* @__PURE__ */ jsx(Button, { appearance: "primary", disabled: !canApply, onClick: () => onApply(draft, restoring), children: t("app.components.grid.filter-apply") })
    ] })
  ] }) });
}
function useReadableFetchXmlMetadata() {
  const base = usePowerPortalsProFetchXmlMetadata();
  const { ppp } = usePowerPortalsPro();
  return useMemo(() => {
    const canRead = async (tableName) => (((await tablePermissions(ppp, tableName))?.operations ?? 0) & TableSecurityPermission.Read) === TableSecurityPermission.Read;
    return {
      getTables: base.getTables,
      ...base.getRecordNames && { getRecordNames: base.getRecordNames },
      async getTable(tableName) {
        const [detail, permissions] = await Promise.all([base.getTable(tableName), tablePermissions(ppp, tableName)]);
        if (!detail) return detail;
        const related = [...new Set(detail.relationships.map((x) => x.relatedTable))];
        const answers = await Promise.all(related.map(canRead));
        const readableTables = new Set(related.filter((_, i) => answers[i]));
        const withheld = new Set((permissions?.withheldColumns ?? []).map((x) => x.toLowerCase()));
        return {
          ...detail,
          columns: withheld.size ? detail.columns.filter((x) => !withheld.has(x.logicalName.toLowerCase())) : detail.columns,
          relationships: detail.relationships.filter((x) => readableTables.has(x.relatedTable))
        };
      }
    };
  }, [base, ppp]);
}
var PERMISSION_LIFETIME_MS = 2 * 60 * 1e3;
var permissionsByClient = /* @__PURE__ */ new WeakMap();
function tablePermissions(ppp, tableName) {
  let answers = permissionsByClient.get(ppp);
  if (!answers) permissionsByClient.set(ppp, answers = /* @__PURE__ */ new Map());
  const key3 = tableName.toLowerCase();
  const kept = answers.get(key3);
  if (kept && Date.now() - kept.askedAt < PERMISSION_LIFETIME_MS) return kept.answer;
  const answer = ppp.retrieveUserTablePermissionsAsync(tableName).catch(() => {
    answers.delete(key3);
    return void 0;
  });
  answers.set(key3, { answer, askedAt: Date.now() });
  return answer;
}
var MAXIMUM_ADDED_COLUMN_DEPTH = 5;
var MAXIMUM_JOINS = 15;
function GridColumnsDialog({
  open,
  fetchXml,
  ownColumns,
  ownJoins,
  keptColumns,
  extraJoins,
  shown,
  onApply,
  onCancel
}) {
  const t = useT();
  const metadata = useReadableFetchXmlMetadata();
  const showsLogicalNames = useShowsLogicalNames();
  const [query, setQuery] = useState(void 0);
  const [tables, setTables] = useState([]);
  const [details, setDetails] = useState(/* @__PURE__ */ new Map());
  const [asked, setAsked] = useState(/* @__PURE__ */ new Set());
  const [joiningFrom, setJoiningFrom] = useState(void 0);
  const [shownSource, setShownSource] = useState(void 0);
  useEffect(() => {
    if (!open) return;
    try {
      setQuery(parseFetchXml(fetchXml));
    } catch {
      setQuery(void 0);
    }
    setShownSource(void 0);
    setJoiningFrom(void 0);
  }, [open]);
  useEffect(() => {
    if (!open) return;
    let canceled = false;
    void metadata.getTables().then((list) => {
      if (!canceled) setTables(list);
    });
    return () => {
      canceled = true;
    };
  }, [open, metadata]);
  const neededTables = useMemo(() => query ? getColumnSourceTables(query) : [], [query]);
  useEffect(() => {
    const missing = neededTables.filter((table) => !asked.has(table));
    if (missing.length === 0) return;
    setAsked((current) => /* @__PURE__ */ new Set([...current, ...missing]));
    void Promise.all(
      missing.map(async (table) => [table, await metadata.getTable(table).catch(() => void 0)])
    ).then((loaded) => {
      setDetails((current) => {
        const next = new Map(current);
        for (const [table, detail] of loaded) if (detail) next.set(table, { ...detail, columns: detail.columns.filter(isSelectableColumn) });
        return next;
      });
      setAnswered((current) => /* @__PURE__ */ new Set([...current, ...loaded.map(([table]) => table)]));
    });
  }, [neededTables, asked, metadata]);
  const [answered, setAnswered] = useState(/* @__PURE__ */ new Set());
  const sources = useMemo(
    () => query ? getColumnSources(query, tables, details, showsLogicalNames) : [],
    [query, tables, details, showsLogicalNames]
  );
  const joinCount2 = (query ? countJoins(query.entity) : 0) + extraJoins;
  const canJoinFrom = (source) => !!source && !!query && depthOf(query.entity, source.entityId) < MAXIMUM_ADDED_COLUMN_DEPTH && joinCount2 < MAXIMUM_JOINS;
  const join = (relationship) => {
    const from = joiningFrom;
    setJoiningFrom(void 0);
    if (!from || !query) return;
    const link = createLinkEntity({
      name: relationship.relatedTable,
      from: relationship.from,
      to: relationship.to,
      alias: uniqueAlias(relationship.relatedTable, getLinkAliases(query)),
      // Outer, so a record whose lookup is empty stays.
      linkType: JoinOperator.LeftOuter
    });
    setQuery(addLinkEntity(query, from.entityId, link));
    setShownSource(link.id);
  };
  const apply = (keys) => {
    if (!query) return;
    onApply(choose(toFetchXml(query), keys, ownColumns, ownJoins, keptColumns));
  };
  const fromDetail = joiningFrom ? details.get(joiningFrom.tableName) : void 0;
  return /* @__PURE__ */ jsx(
    ColumnSelectDialog,
    {
      open,
      sources,
      loading: sources.length === 0 || neededTables.some((table) => !answered.has(table)),
      selected: shown,
      title: t("app.components.grid.columns-title"),
      shownSource,
      showLogicalNames: showsLogicalNames,
      onCommit: apply,
      onCancel,
      sourceActions: (source) => /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(Add16Regular, {}),
            disabled: !canJoinFrom(source),
            onClick: () => {
              if (canJoinFrom(source)) setJoiningFrom(source);
            },
            children: t("app.components.grid.columns-add-related", [source?.label ?? ""])
          }
        ),
        /* @__PURE__ */ jsx(
          RelationshipPickerDialog,
          {
            open: !!joiningFrom,
            relationships: (fromDetail?.relationships ?? []).filter((relationship) => relationship.kind === "manyToOne"),
            tables,
            sourceColumns: fromDetail?.columns ?? [],
            onCommit: join,
            onCancel: () => setJoiningFrom(void 0),
            showLogicalNames: showsLogicalNames
          }
        )
      ] })
    }
  );
}
function countJoins(entity) {
  return entity.linkEntities.reduce((count, link) => count + 1 + countJoins(link), 0);
}
function depthOf(entity, id, depth = 0) {
  if (entity.id === id) return depth;
  for (const link of entity.linkEntities) {
    const found = depthOf(link, id, link.intersect ? depth : depth + 1);
    if (found >= 0) return found;
  }
  return -1;
}
function choose(fetchXml, keys, ownColumns, ownJoins, keptColumns = []) {
  const lower = (value2) => value2.toLowerCase();
  const chosen = new Set(keys.map(lower));
  const own = new Set(ownColumns.map(lower));
  const stays = new Set([...ownColumns, ...keptColumns].map(lower));
  const ownJoin = new Set(ownJoins.map(lower));
  const fetch2 = parseXml(fetchXml);
  const entity = fetch2.children.find((x) => x.name === "entity");
  const added = [];
  if (!entity) return { fetchXml, added, hiddenOwn: [] };
  const project = (table, prefix) => {
    table.children = table.children.filter(
      (x) => x.name !== "attribute" || stays.has(lower(prefix + (x.attributes["name"] ?? ""))) || chosen.has(lower(prefix + (x.attributes["name"] ?? "")))
    );
    for (const key3 of keys) {
      const dot = key3.lastIndexOf(".");
      if ((dot < 0 ? "" : `${key3.slice(0, dot)}.`).toLowerCase() !== prefix.toLowerCase()) continue;
      const name = key3.slice(prefix.length);
      if (!table.children.some((x) => x.name === "attribute" && lower(x.attributes["name"] ?? "") === lower(name))) {
        const lastAttribute = table.children.map((x) => x.name).lastIndexOf("attribute");
        table.children.splice(lastAttribute + 1, 0, { name: "attribute", attributes: { name }, children: [], text: "" });
      }
      if (!own.has(lower(key3))) added.push(key3);
    }
  };
  const joins = [];
  const walk = (element) => {
    for (const child of element.children) {
      if (child.name === "link-entity") {
        joins.push(child);
        walk(child);
      }
    }
  };
  project(entity, "");
  walk(entity);
  for (const join of joins) {
    const alias = join.attributes["alias"];
    if (alias) project(join, `${alias}.`);
  }
  const drop = (element) => {
    for (const child of element.children) if (child.name === "link-entity") drop(child);
    element.children = element.children.filter((child) => {
      if (child.name !== "link-entity") return true;
      const alias = child.attributes["alias"];
      const isOwn = !!alias && ownJoin.has(lower(alias));
      const intersect = child.attributes["intersect"] === "true";
      return isOwn || child.children.length > 0 || !intersect && !alias;
    });
  };
  drop(entity);
  return {
    fetchXml: serializeXml(fetch2),
    added,
    hiddenOwn: ownColumns.filter((key3) => !chosen.has(lower(key3)))
  };
}
function BoolCell({ value: value2, record, columnName }) {
  const t = useT();
  const v = value2;
  const formatted = record.formattedValues?.[columnName];
  if (formatted) return /* @__PURE__ */ jsx("span", { className: "ppp-grid-cell-bool", children: formatted });
  if (!v) return null;
  if (v.value === true) {
    return /* @__PURE__ */ jsx(
      Checkmark16Regular,
      {
        "aria-label": t("app.components.grid.bool-true"),
        className: "ppp-grid-cell-bool"
      }
    );
  }
  if (v.value === false) {
    return /* @__PURE__ */ jsx(
      Dismiss16Regular,
      {
        "aria-label": t("app.components.grid.bool-false"),
        className: "ppp-grid-cell-bool"
      }
    );
  }
  return null;
}
var useHighlighterStyles = makeStyles({
  // Inline marker around matched substrings. `colorPaletteYellowBackground3`
  // is the brightest of Fluent's three yellow-background tokens — the lower
  // tints (1, 2) read as "barely tinted" against typical light-theme
  // surfaces; tint 3 stays solidly yellow so matches pop without forcing
  // hardcoded hex. Bold weight reinforces the hit visually while keeping
  // the glyph anatomy unchanged (no shifts).
  // Foreground uses `colorNeutralForeground1Static` rather than the
  // paired `colorPaletteYellowForeground2` because the latter's polarity
  // INVERTS between themes — in dark mode it resolves to a near-white
  // yellow tint that washes out against the bright yellow background.
  // The `Static` variant resolves to a dark gray in both light AND dark
  // themes, which gives consistent contrast against the always-bright
  // yellow background.
  mark: {
    backgroundColor: tokens.colorPaletteYellowBackground3,
    color: tokens.colorNeutralForeground1Static,
    fontWeight: tokens.fontWeightBold,
    padding: 0,
    borderRadius: tokens.borderRadiusSmall
  }
});
function foldString(s, caseSensitive) {
  let folded = "";
  const starts = [];
  const ends = [];
  const combiningMarks = /[̀-ͯ]/g;
  for (let i = 0; i < s.length; i++) {
    const decomposed = s.charAt(i).normalize("NFD").replace(combiningMarks, "");
    const f = caseSensitive ? decomposed : decomposed.toLowerCase();
    if (f.length === 0) {
      if (ends.length > 0) ends[ends.length - 1] = i + 1;
      continue;
    }
    for (let j = 0; j < f.length; j++) {
      folded += f[j];
      starts.push(i);
      ends.push(i + 1);
    }
  }
  return { folded, starts, ends };
}
function tokenizeSearch(search, delimiters) {
  if (!delimiters) return [search];
  const delim = new Set(Array.from(delimiters));
  const tokens80 = [];
  let current = "";
  for (const ch of search) {
    if (delim.has(ch)) {
      if (current.length > 0) {
        tokens80.push(current);
        current = "";
      }
    } else {
      current += ch;
    }
  }
  if (current.length > 0) tokens80.push(current);
  return tokens80;
}
function splitHighlightSegments(text2, search, options) {
  if (!text2 || !search) return [];
  const caseSensitive = options?.caseSensitive ?? false;
  const delimiters = options?.delimiters ?? "";
  const tokens80 = tokenizeSearch(search, delimiters);
  if (tokens80.length === 0) return [{ text: text2, isMatch: false }];
  const folded = foldString(text2, caseSensitive);
  const ranges = [];
  for (const token of tokens80) {
    const tokenFolded = foldString(token, caseSensitive).folded;
    if (tokenFolded.length === 0) continue;
    let cursor2 = 0;
    while (cursor2 <= folded.folded.length - tokenFolded.length) {
      const foundAt = folded.folded.indexOf(tokenFolded, cursor2);
      if (foundAt === -1) break;
      ranges.push({
        start: folded.starts[foundAt],
        end: folded.ends[foundAt + tokenFolded.length - 1]
      });
      cursor2 = foundAt + tokenFolded.length;
    }
  }
  if (ranges.length === 0) return [{ text: text2, isMatch: false }];
  ranges.sort((a, b) => a.start - b.start);
  const merged = [];
  for (const r of ranges) {
    const last = merged[merged.length - 1];
    if (last && r.start <= last.end) {
      if (r.end > last.end) last.end = r.end;
    } else {
      merged.push({ start: r.start, end: r.end });
    }
  }
  const segments = [];
  let cursor = 0;
  for (const r of merged) {
    if (r.start > cursor) {
      segments.push({ text: text2.slice(cursor, r.start), isMatch: false });
    }
    segments.push({ text: text2.slice(r.start, r.end), isMatch: true });
    cursor = r.end;
  }
  if (cursor < text2.length) {
    segments.push({ text: text2.slice(cursor), isMatch: false });
  }
  return segments;
}
function Highlighter({
  text: text2,
  searchText,
  delimiters,
  caseSensitive,
  className
}) {
  const styles = useHighlighterStyles();
  const cleanSearch = (() => {
    const stripped = (searchText ?? "").replace(/\*/g, "");
    return delimiters?.includes(" ") ? stripped : stripped.trim();
  })();
  const segments = useMemo(
    () => splitHighlightSegments(text2 ?? "", cleanSearch, {
      ...delimiters !== void 0 && { delimiters },
      ...caseSensitive !== void 0 && { caseSensitive }
    }),
    [text2, cleanSearch, delimiters, caseSensitive]
  );
  if (segments.length === 0) {
    return /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-highlighter", className), children: text2 ?? "" });
  }
  return /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-highlighter", className), children: segments.map(
    (seg, idx) => seg.isMatch ? /* @__PURE__ */ jsx("mark", { className: styles.mark, children: seg.text }, idx) : /* @__PURE__ */ jsx("span", { children: seg.text }, idx)
  ) });
}
function HighlightFull({ text: text2, className }) {
  const styles = useHighlighterStyles();
  return /* @__PURE__ */ jsx("mark", { className: `${styles.mark}${className ? ` ${className}` : ""}`, children: text2 });
}

// src/grids/cells/numeric-search-match.ts
function splitSearchComparison(searchText) {
  const value2 = searchText.replace(/\s+/g, "");
  for (const op of [">=", "<=", "<", ">", "="]) {
    if (value2.includes(op)) return { op, value: value2.split(op).join("") };
  }
  return { op: "=", value: value2 };
}
function parseNumericSearch(searchText) {
  if (!searchText) return null;
  const { op, value: value2 } = splitSearchComparison(searchText);
  if (!value2) return null;
  const n = Number(value2);
  if (!Number.isFinite(n)) return null;
  return { op, value: n };
}
function matchesNumericSearch(rawCellValue, parsed) {
  if (rawCellValue == null) return false;
  const n = typeof rawCellValue === "number" ? rawCellValue : Number(rawCellValue);
  if (!Number.isFinite(n)) return false;
  switch (parsed.op) {
    case "=":
      return n === parsed.value;
    case "<":
      return n < parsed.value;
    case ">":
      return n > parsed.value;
    case "<=":
      return n <= parsed.value;
    case ">=":
      return n >= parsed.value;
  }
}

// src/grids/cells/date-search-match.ts
var DAY_MS = 864e5;
var EARLIEST = dayNumber(1753, 1, 1);
var LATEST = dayNumber(9999, 12, 31);
var lastParse;
function parseDateSearch(searchText, locale) {
  if (!searchText) return null;
  if (lastParse?.searchText === searchText && lastParse.locale === locale) return lastParse.result;
  const result = parse2(searchText, locale);
  lastParse = { searchText, locale, result };
  return result;
}
function parse2(searchText, locale) {
  const { op, value: value2 } = splitSearchComparison(searchText);
  const days = parseDays(value2, locale);
  if (!days) return null;
  const [first, last] = days;
  switch (op) {
    case ">":
      return last >= LATEST ? null : { from: last + 1 };
    case ">=":
      return { from: first };
    case "<":
      return first <= EARLIEST ? null : { to: first - 1 };
    case "<=":
      return { to: last };
    default:
      return { from: first, to: last };
  }
}
function matchesDateSearch(display, parsed, locale) {
  if (!display) return false;
  const shape = cultureShape(locale);
  if (!shape) return false;
  const text2 = display.replace(/\s+/g, "");
  const match = shape.atStart.exec(text2);
  const iso = match ? null : /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(text2);
  const day = match ? dayFromGroups(match, shape) : iso ? validDay(Number(iso[1]), Number(iso[2]), Number(iso[3])) : void 0;
  if (day === void 0) return false;
  return (parsed.from === void 0 || day >= parsed.from) && (parsed.to === void 0 || day <= parsed.to);
}
function parseDays(text2, locale) {
  if (/^\d{4}$/.test(text2)) {
    const year = Number(text2);
    if (year < 1753 || year > 9999) return void 0;
    return [dayNumber(year, 1, 1), dayNumber(year, 12, 31)];
  }
  const iso = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(text2);
  let day;
  if (iso) {
    day = validDay(Number(iso[1]), Number(iso[2]), Number(iso[3]));
  } else {
    const shape = cultureShape(locale);
    const match = shape?.whole.exec(text2.replace(/[./-]+$/, ""));
    day = match && shape ? dayFromGroups(match, shape) : void 0;
  }
  if (day === void 0 || day < EARLIEST) return void 0;
  return [day, day];
}
var shapes = /* @__PURE__ */ new Map();
function cultureShape(locale) {
  if (shapes.has(locale)) return shapes.get(locale);
  let format;
  try {
    format = new Intl.DateTimeFormat(locale, { year: "numeric", month: "numeric", day: "numeric", timeZone: "UTC" });
  } catch {
    format = new Intl.DateTimeFormat("en", { year: "numeric", month: "numeric", day: "numeric", timeZone: "UTC" });
  }
  let shape = null;
  if (format.resolvedOptions().calendar === "gregory") {
    const parts = format.formatToParts(new Date(Date.UTC(2026, 2, 15)));
    const order = parts.map((p) => p.type).filter((t) => t === "day" || t === "month" || t === "year");
    const separator = (parts.find((p) => p.type === "literal")?.value ?? "/").replace(/\s+/g, "") || "/";
    const sep = separator.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const pattern = order.map((part) => part === "year" ? "(\\d{4})" : "(\\d{1,2})").join(sep);
    shape = { order, atStart: new RegExp(`^${pattern}`), whole: new RegExp(`^${pattern}$`) };
  }
  shapes.set(locale, shape);
  return shape;
}
function dayFromGroups(match, shape) {
  const value2 = (part) => Number(match[shape.order.indexOf(part) + 1]);
  return validDay(value2("year"), value2("month"), value2("day"));
}
function validDay(year, month, day) {
  if (month < 1 || month > 12 || day < 1) return void 0;
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
    return void 0;
  }
  return Math.round(date.getTime() / DAY_MS);
}
function dayNumber(year, month, day) {
  return Math.round(Date.UTC(year, month - 1, day) / DAY_MS);
}

// src/grids/cells/search-highlight.ts
var WHOLE = { kind: "whole" };
function searchKindOf(type) {
  switch (type) {
    case ColumnType.String:
    case ColumnType.Memo:
    case ColumnType.Lookup:
    case ColumnType.Customer:
    case ColumnType.Owner:
    case ColumnType.Choice:
    case ColumnType.State:
    case ColumnType.Status:
    case ColumnType.MultiSelectChoice:
      return "text";
    case ColumnType.Decimal:
    case ColumnType.Double:
    case ColumnType.Integer:
    case ColumnType.BigInt:
    case ColumnType.Money:
      return "number";
    case ColumnType.DateTime:
      return "date";
    default:
      return void 0;
  }
}
function numberOf(value2) {
  if (value2 === null || typeof value2 !== "object") return value2;
  const own = value2;
  const inner = own.$type === "RelatedRecordValue" ? own.value : own;
  return inner?.value;
}
function searchHighlightFor(type, value2, shown, search, locale) {
  if (!search?.trim() || !shown?.trim()) return null;
  switch (searchKindOf(type)) {
    case "text": {
      const term = search.replace(/\*/g, "");
      return term.trim() ? { kind: "text", term } : null;
    }
    case "number": {
      const parsed = parseNumericSearch(search);
      return parsed && matchesNumericSearch(numberOf(value2), parsed) ? WHOLE : null;
    }
    case "date": {
      const parsed = parseDateSearch(search, locale);
      return parsed && matchesDateSearch(shown, parsed, locale) ? WHOLE : null;
    }
    default:
      return null;
  }
}
function ChoiceCell({ value: value2, record, columnName, metadata, searchText }) {
  const display = resolveColumnDisplayValue(record, columnName, metadata);
  if (display == null || display === "") return null;
  const highlight = searchHighlightFor(ColumnType.Choice, value2, display, searchText, "");
  return /* @__PURE__ */ jsx(Highlighter, { text: display, searchText: highlight?.kind === "text" ? highlight.term : null, className: "ppp-grid-cell-choice" });
}
function DateCell({ value: value2, record, columnName, metadata, searchText }) {
  const { locale } = useLocale();
  const display = resolveColumnDisplayValue(record, columnName, metadata);
  if (display == null || display === "") return null;
  if (searchHighlightFor(ColumnType.DateTime, value2, display, searchText, locale)?.kind === "whole") {
    return /* @__PURE__ */ jsx(HighlightFull, { text: display, className: "ppp-grid-cell-date" });
  }
  return /* @__PURE__ */ jsx("span", { className: "ppp-grid-cell-date", children: display });
}
function FallbackCell({
  value: _value,
  record,
  columnName,
  metadata,
  searchText
}) {
  const display = resolveColumnDisplayValue(record, columnName, metadata);
  if (display == null || display === "") return null;
  return /* @__PURE__ */ jsx(Highlighter, { text: display, searchText: searchText ?? null, className: "ppp-grid-cell-fallback" });
}
var CDN_BASE = "https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/item-types";
function isThumbnailSupported(fileName) {
  return ["png", "jpg", "jpeg", "gif", "bmp", "webp"].includes(getFileExtension(fileName));
}
var CDN_ICON_NAMES = {
  // Adobe / PDF.
  pdf: "pdf",
  // Microsoft 365 — Word.
  doc: "docx",
  docx: "docx",
  docm: "docx",
  dot: "dotx",
  dotx: "dotx",
  rtf: "rtf",
  // Microsoft 365 — Excel.
  xls: "xlsx",
  xlsx: "xlsx",
  xlsm: "xlsx",
  xlsb: "xlsx",
  csv: "csv",
  // Microsoft 365 — PowerPoint.
  ppt: "pptx",
  pptx: "pptx",
  pptm: "pptx",
  ppsx: "ppsx",
  potx: "potx",
  // Microsoft 365 — OneNote / Visio / Project / Publisher / Access.
  one: "one",
  onetoc: "one",
  onetoc2: "one",
  vsdx: "vsdx",
  vssx: "vssx",
  vstx: "vstx",
  mpp: "mpp",
  mpt: "mpt",
  pub: "pub",
  accdb: "accdb",
  mdb: "mdb",
  // Outlook / email.
  msg: "email",
  eml: "email",
  // Archives.
  zip: "zip",
  "7z": "zip",
  rar: "zip",
  tar: "zip",
  gz: "zip",
  // Images.
  png: "photo",
  jpg: "photo",
  jpeg: "photo",
  gif: "photo",
  bmp: "photo",
  webp: "photo",
  tif: "photo",
  tiff: "photo",
  ico: "photo",
  svg: "photo",
  heic: "photo",
  heif: "photo",
  // Video.
  mp4: "video",
  mov: "video",
  avi: "video",
  mkv: "video",
  webm: "video",
  m4v: "video",
  wmv: "video",
  // Audio.
  mp3: "audio",
  wav: "audio",
  ogg: "audio",
  flac: "audio",
  m4a: "audio",
  aac: "audio",
  wma: "audio",
  // Text / web / data.
  txt: "txt",
  log: "txt",
  md: "txt",
  markdown: "txt",
  html: "html",
  htm: "html",
  xml: "xml",
  yaml: "yaml",
  yml: "yaml",
  css: "css",
  // Source code — CDN has a single 'code' glyph rather than per-language.
  js: "code",
  jsx: "code",
  ts: "code",
  tsx: "code",
  mjs: "code",
  cjs: "code",
  cs: "code",
  vb: "code",
  fs: "code",
  py: "code",
  rb: "code",
  go: "code",
  rs: "code",
  java: "code",
  kt: "code",
  swift: "code",
  php: "code",
  sh: "code",
  bash: "code",
  ps1: "code",
  json: "code",
  sql: "code",
  // Executables / installers.
  exe: "exe",
  msi: "exe"
};
var useStyles12 = makeStyles({
  // Sized via inline width/height attrs on the <img>; height-100% in the
  // class keeps the icon vertically centered inside the cell's flex row.
  cdnIcon: {
    flexShrink: 0,
    display: "block",
    objectFit: "contain"
  }
});
function renderFileTypeIcon(fileName, className, size = 20) {
  const ext = getFileExtension(fileName);
  const brandedName = CDN_ICON_NAMES[ext];
  if (brandedName) {
    return /* @__PURE__ */ jsx(
      CdnFileTypeIcon,
      {
        name: brandedName,
        alt: ext,
        size,
        ...className !== void 0 && { className }
      }
    );
  }
  return /* @__PURE__ */ jsx(FallbackIcon, { ext, size, ...className !== void 0 && { className } });
}
function FallbackIcon({ ext, size, className }) {
  const Icon = pickFallbackIcon(ext);
  return /* @__PURE__ */ jsx(
    Icon,
    {
      ...className !== void 0 && { className },
      ...size !== 20 && { style: { width: size, height: size } },
      "aria-hidden": true
    }
  );
}
function CdnFileTypeIcon({
  name,
  alt,
  size,
  className
}) {
  const styles = useStyles12();
  const [failed, setFailed] = useState(false);
  if (failed) {
    return /* @__PURE__ */ jsx(FallbackIcon, { ext: alt, size, ...className !== void 0 && { className } });
  }
  return /* @__PURE__ */ jsx(
    "img",
    {
      src: `${CDN_BASE}/${size}/${name}.svg`,
      alt,
      width: size,
      height: size,
      className: className ? `${styles.cdnIcon} ${className}` : styles.cdnIcon,
      onError: () => setFailed(true),
      decoding: "async"
    }
  );
}
function pickFallbackIcon(ext) {
  switch (ext) {
    case "pdf":
      return DocumentPdf20Regular;
    case "doc":
    case "docx":
    case "rtf":
    case "odt":
      return Document20Regular;
    case "xls":
    case "xlsx":
    case "csv":
    case "ods":
      return DocumentTable20Regular;
    case "ppt":
    case "pptx":
    case "odp":
      return SlideText20Regular;
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "bmp":
    case "webp":
    case "svg":
    case "ico":
    case "tif":
    case "tiff":
      return Image20Regular;
    case "mp4":
    case "mov":
    case "avi":
    case "mkv":
    case "webm":
    case "m4v":
      return Video20Regular;
    case "mp3":
    case "wav":
    case "ogg":
    case "flac":
    case "m4a":
    case "aac":
      return MusicNote220Regular;
    case "zip":
    case "7z":
    case "rar":
    case "tar":
    case "gz":
      return FolderZip20Regular;
    case "txt":
    case "md":
    case "markdown":
    case "log":
    case "json":
    case "xml":
    case "yaml":
    case "yml":
    case "html":
    case "htm":
    case "js":
    case "ts":
    case "cs":
    case "css":
      return DocumentText20Regular;
    default:
      return Document20Regular;
  }
}
var GridContext = createContext(null);
var GridContextProvider = GridContext.Provider;
function useGridContext() {
  const ctx = useContext(GridContext);
  if (!ctx) {
    throw new Error(
      "useGridContext() was called outside of <MainGrid>. Grid buttons (NewRecordGridButton, DeleteRecordGridButton, RefreshGridButton, etc.) must be rendered as children of <MainGrid>."
    );
  }
  return ctx;
}
var EMPTY_GUID2 = "00000000-0000-0000-0000-000000000000";
function FileCell({ record, columnName, metadata }) {
  const styles = useFileCellStyles();
  const actions = useFileActions(record, columnName, metadata);
  if (!actions.fileName) {
    return canReadColumn(record, columnName) ? null : /* @__PURE__ */ jsx(Fragment, { children: record.formattedValues?.[columnName] ?? null });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-grid-cell-file", styles.cell), children: [
      renderFileTypeIcon(actions.fileName, styles.leadingIcon),
      /* @__PURE__ */ jsx("span", { className: styles.name, children: actions.fileName }),
      /* @__PURE__ */ jsx(FileActionButtons, { actions })
    ] }),
    actions.dialog
  ] });
}
function FileActionButtons({ actions }) {
  const t = useT();
  const previewLabel = t("app.components.grid.file-cell-preview-tooltip");
  const downloadLabel = t("app.components.grid.file-cell-download-tooltip");
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    actions.showPreview && /* @__PURE__ */ jsx(Tooltip, { content: previewLabel, relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "subtle",
        size: "small",
        icon: /* @__PURE__ */ jsx(Eye20Regular, {}),
        "aria-label": previewLabel,
        disabled: actions.isBusy,
        onClick: (ev) => {
          ev.stopPropagation();
          void actions.preview();
        },
        onDoubleClick: (ev) => ev.stopPropagation()
      }
    ) }),
    actions.showDownload && /* @__PURE__ */ jsx(Tooltip, { content: downloadLabel, relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "subtle",
        size: "small",
        icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
        "aria-label": downloadLabel,
        disabled: actions.isBusy,
        onClick: (ev) => {
          ev.stopPropagation();
          void actions.download();
        },
        onDoubleClick: (ev) => ev.stopPropagation()
      }
    ) })
  ] });
}
function useFileActions(record, columnName, metadata) {
  const styles = useFileCellStyles();
  const t = useT();
  const { ppp } = usePowerPortalsPro();
  const { allowPreviewForFileColumns, allowDownloadForFileColumns } = useGridContext();
  const [isBusy, setIsBusy] = useState(false);
  const [previewSource, setPreviewSource] = useState(null);
  const presence = useDialogPresence(previewSource !== null, PREVIEW_EXIT_MS);
  const lastSourceRef = useRef(null);
  if (previewSource) lastSourceRef.current = previewSource;
  const renderedSource = previewSource ?? lastSourceRef.current;
  const isVisible = presence.surfaceState === "open";
  const isClosing = presence.surfaceState === "closing";
  const transitionDuration = isClosing ? `${PREVIEW_EXIT_MS}ms` : `${PREVIEW_ENTER_MS}ms`;
  const transitionTimingFunction = isClosing ? "cubic-bezier(0.7, 0, 1, 0.5)" : "cubic-bezier(0.1, 0.9, 0.2, 1)";
  const surfaceStyle = useMemo(() => ({
    backgroundColor: "transparent",
    boxShadow: "none",
    border: "none",
    padding: 0
  }), []);
  const animationStyle = useMemo(() => ({
    width: "100%",
    transformOrigin: "50% 50%",
    transitionProperty: "opacity, transform",
    transitionDuration,
    transitionTimingFunction,
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "scale(1)" : "scale(0.96)",
    // Chrome that used to live on DialogSurface — now on the
    // animating wrapper so it fades together with the content.
    backgroundColor: "var(--colorNeutralBackground1)",
    color: "var(--colorNeutralForeground1)",
    border: "1px solid var(--colorTransparentStroke)",
    borderRadius: "var(--borderRadiusXLarge)",
    boxShadow: "var(--shadow64)",
    padding: "24px",
    boxSizing: "border-box"
  }), [isVisible, transitionDuration]);
  const fileName = canReadColumn(record, columnName) ? resolveColumnDisplayValue(record, columnName, metadata) || void 0 : void 0;
  const tableName = record.tableName;
  const recordId = record.id;
  const isPersisted = !!recordId && recordId !== EMPTY_GUID2 && !recordId.startsWith("__pending-create-");
  const handleDownload = useCallback(async () => {
    if (!isPersisted || !tableName || !recordId || !fileName) return;
    setIsBusy(true);
    try {
      const info = await ppp.getFileInfoAsync(tableName, recordId, columnName, true);
      if (!info.fileData) return;
      const bytes = base64ToBytes(info.fileData);
      triggerBlobDownload(bytes, info.fileName || fileName);
    } finally {
      setIsBusy(false);
    }
  }, [columnName, fileName, isPersisted, ppp, recordId, tableName]);
  const handlePreview = useCallback(async () => {
    if (!isPersisted || !tableName || !recordId || !fileName) return;
    setIsBusy(true);
    try {
      const info = await ppp.getFileInfoAsync(tableName, recordId, columnName, true);
      if (!info.fileData) return;
      const resolvedName = info.fileName || fileName;
      setPreviewSource({
        kind: "base64",
        value: info.fileData,
        mimeType: getMimeFromFileName(resolvedName),
        fileName: resolvedName
      });
    } finally {
      setIsBusy(false);
    }
  }, [columnName, fileName, isPersisted, ppp, recordId, tableName]);
  const dialog = /* @__PURE__ */ jsx(
    Dialog,
    {
      open: presence.mounted,
      onOpenChange: (_, data) => {
        if (!data.open) setPreviewSource(null);
      },
      modalType: "modal",
      children: /* @__PURE__ */ jsx(DialogSurface, { className: styles.previewSurface, style: surfaceStyle, children: /* @__PURE__ */ jsx("div", { style: animationStyle, children: renderedSource && /* @__PURE__ */ jsxs(DialogBody, { children: [
        /* @__PURE__ */ jsx(DialogTitle, { children: renderedSource.fileName }),
        /* @__PURE__ */ jsx(DialogContent, { className: styles.previewContent, children: /* @__PURE__ */ jsx(
          FileViewer,
          {
            source: renderedSource,
            ...(renderedSource.fileName ?? fileName) && { fileName: renderedSource.fileName ?? fileName }
          }
        ) }),
        /* @__PURE__ */ jsx(DialogActions, { children: /* @__PURE__ */ jsx(DialogTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Button, { appearance: "primary", children: t("app.buttons.close.label") }) }) })
      ] }) }) })
    }
  );
  return {
    fileName,
    isPersisted,
    showPreview: allowPreviewForFileColumns && isPersisted,
    showDownload: allowDownloadForFileColumns && isPersisted,
    isBusy,
    preview: handlePreview,
    download: handleDownload,
    dialog
  };
}
var PREVIEW_ENTER_MS = 160;
var PREVIEW_EXIT_MS = 120;
function useDialogPresence(open, exitMs) {
  const [mounted, setMounted] = useState(open);
  const [surfaceState, setSurfaceState] = useState(
    open ? "open" : "hidden"
  );
  const timerRef = useRef(null);
  useEffect(() => {
    if (open) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      setMounted(true);
      return;
    }
    if (!mounted) return;
    setSurfaceState("closing");
    timerRef.current = setTimeout(() => {
      setMounted(false);
      setSurfaceState("hidden");
      timerRef.current = null;
    }, exitMs);
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [open, mounted, exitMs]);
  useLayoutEffect(() => {
    if (!mounted) return;
    if (surfaceState !== "hidden") return;
    const id = requestAnimationFrame(() => setSurfaceState("open"));
    return () => cancelAnimationFrame(id);
  }, [mounted, surfaceState]);
  useEffect(() => {
    if (open && mounted && surfaceState === "closing") {
      setSurfaceState("hidden");
    }
  }, [open, mounted, surfaceState]);
  return { mounted, surfaceState };
}
var useFileCellStyles = makeStyles({
  cell: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    minWidth: 0
  },
  leadingIcon: {
    flexShrink: 0,
    color: tokens.colorNeutralForeground2
  },
  name: {
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  // Preview dialog mirrors FileEdit's surface so the two share a layout
  // wider than Fluent's default so PDF / markdown / image renderers have
  // room to breathe, capped at the viewport for small screens.
  previewSurface: {
    maxWidth: "min(1200px, 90vw)",
    width: "90vw"
  },
  // Animation wrapper styles live inline on the wrapper div (see
  // `animationStyle` in FileCell) — earlier Griffel-driven attempts
  // had the from/to values applied but the transition itself didn't
  // run, so inline `style` is the bulletproof path.
  previewContent: {
    overflow: "hidden",
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS
  }
});
function LookupCell({ value: value2, record, columnName, metadata, searchText }) {
  const display = resolveColumnDisplayValue(record, columnName, metadata);
  if (display == null || display === "") return null;
  const highlight = searchHighlightFor(ColumnType.Lookup, value2, display, searchText, "");
  return /* @__PURE__ */ jsx(Highlighter, { text: display, searchText: highlight?.kind === "text" ? highlight.term : null, className: "ppp-grid-cell-lookup" });
}
function MoneyCell({
  value: value2,
  record,
  columnName,
  metadata,
  searchText
}) {
  const display = resolveColumnDisplayValue(record, columnName, metadata);
  if (display == null || display === "") return null;
  if (searchHighlightFor(ColumnType.Money, value2, display, searchText, "")?.kind === "whole") {
    return /* @__PURE__ */ jsx(HighlightFull, { text: display, className: "ppp-grid-cell-money" });
  }
  return /* @__PURE__ */ jsx("span", { className: "ppp-grid-cell-money", children: display });
}
function MultiSelectChoiceCell({
  value: value2,
  record,
  columnName,
  metadata,
  searchText
}) {
  const display = resolveColumnDisplayValue(record, columnName, metadata);
  if (display == null || display === "") return null;
  const highlight = searchHighlightFor(ColumnType.MultiSelectChoice, value2, display, searchText, "");
  return /* @__PURE__ */ jsx(
    Highlighter,
    {
      text: display,
      searchText: highlight?.kind === "text" ? highlight.term : null,
      className: "ppp-grid-cell-multi-select-choice"
    }
  );
}
function NumberCell({
  value: value2,
  record,
  columnName,
  metadata,
  searchText
}) {
  const display = resolveColumnDisplayValue(record, columnName, metadata);
  if (display == null || display === "") return null;
  if (searchHighlightFor(ColumnType.Decimal, value2, display, searchText, "")?.kind === "whole") {
    return /* @__PURE__ */ jsx(HighlightFull, { text: display, className: "ppp-grid-cell-number" });
  }
  return /* @__PURE__ */ jsx("span", { className: "ppp-grid-cell-number", children: display });
}
var useStyles13 = makeStyles({
  items: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    minWidth: 0
  }
});
function RelatedRecordsList({
  row,
  value: value2,
  separator = ", ",
  urlFor,
  onRecordClick,
  itemRenderer,
  searchText = null
}) {
  const styles = useStyles13();
  if (!value2) return null;
  const records = value2.value ?? [];
  if (itemRenderer) {
    return /* @__PURE__ */ jsxs("span", { className: mergeClasses("ppp-grid-cell-related-records", styles.items), children: [
      records.map((record, index) => /* @__PURE__ */ jsx(Fragment$1, { children: itemRenderer({ record, value: value2, row }) }, record.id ?? index)),
      value2.isTruncated && /* @__PURE__ */ jsx("span", { children: "\u2026" })
    ] });
  }
  return /* @__PURE__ */ jsxs("span", { className: "ppp-grid-cell-related-records", children: [
    records.map((record, index) => {
      const name = relatedRecordName(value2, record);
      return /* @__PURE__ */ jsxs(Fragment$1, { children: [
        index > 0 && separator,
        renderName(record, /* @__PURE__ */ jsx(Highlighter, { text: name, searchText }), urlFor, onRecordClick)
      ] }, record.id ?? index);
    }),
    value2.isTruncated && `${records.length > 0 ? separator : ""}\u2026`
  ] });
}
function renderName(record, name, urlFor, onRecordClick) {
  if (!record.id || !urlFor && !onRecordClick) return name;
  const href = urlFor?.(record);
  const handleClick = (event) => {
    event.stopPropagation();
    if (!onRecordClick) return;
    if (href && (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0)) return;
    event.preventDefault();
    onRecordClick(record);
  };
  return /* @__PURE__ */ jsx(Link, { inline: true, href: href ?? "#", onClick: handleClick, children: name });
}
function RelatedRecordsCell({ record, columnName }) {
  return /* @__PURE__ */ jsx(RelatedRecordsList, { row: record, value: readRelatedRecords(record, columnName) });
}
function TextCell({ value: value2, record, columnName, metadata, searchText }) {
  const display = resolveColumnDisplayText(record, columnName, metadata);
  if (display == null || display === "") return null;
  const highlight = searchHighlightFor(ColumnType.String, value2, display, searchText, "");
  return /* @__PURE__ */ jsx(Highlighter, { text: display, searchText: highlight?.kind === "text" ? highlight.term : null, className: "ppp-grid-cell-text" });
}

// src/grids/cells/cell-dispatcher.tsx
function getRendererTypeForMetadata(metadata) {
  const typeCode = metadata?.$type;
  switch (typeCode) {
    case 0:
      return "bool";
    case 2:
      return "date";
    case 3:
    case 4:
    case 5:
    case 18:
      return "number";
    case 6:
      return "lookup";
    case 7:
    case 14:
      return "string";
    case 8:
      return "money";
    case 11:
    case 12:
    case 13:
      return "choice";
    case 40:
      return "multiSelectChoice";
    case 41:
      return "file";
    case 42:
      return "image";
    case 43:
      return "relatedRecords";
    default:
      return "fallback";
  }
}
function getCellRendererByType(typeCode) {
  switch (typeCode) {
    case 0:
      return BoolCell;
    case 2:
      return DateCell;
    case 3:
    case 4:
    case 5:
    case 18:
      return NumberCell;
    case 6:
      return LookupCell;
    case 7:
    case 14:
      return TextCell;
    case 8:
      return MoneyCell;
    case 11:
    case 12:
    case 13:
      return ChoiceCell;
    case 40:
      return MultiSelectChoiceCell;
    case 41:
    case 42:
      return FileCell;
    case 43:
      return RelatedRecordsCell;
    default:
      return FallbackCell;
  }
}
function getCellRenderer(metadata) {
  const typeCode = metadata?.$type;
  return getCellRendererByType(typeCode);
}
function isColumnSortable(metadata) {
  const typeCode = metadata?.$type;
  return typeCode !== 41 && typeCode !== 42;
}
function getRendererTypeForCode(typeCode) {
  switch (typeCode) {
    case 0:
      return "bool";
    case 2:
      return "date";
    case 3:
    case 4:
    case 5:
    case 18:
      return "number";
    case 6:
      return "lookup";
    case 7:
    case 14:
      return "string";
    case 8:
      return "money";
    case 11:
    case 12:
    case 13:
      return "choice";
    case 40:
      return "multiSelectChoice";
    case 41:
      return "file";
    case 42:
      return "image";
    case 43:
      return "relatedRecords";
    default:
      return "fallback";
  }
}
var BoolEditorType = {
  Checkbox: "checkbox",
  Switch: "switch"
};
var useStyles14 = makeStyles({
  // Inline-label layout (`inlineLabel`): Checkbox/Switch indicator and the
  // external label sit side-by-side.
  // `ppp-bool-edit-inline` div pattern. Gap matches FluentUI's own internal
  // checkbox-to-label spacing so a swap to / from inline-label mode doesn't
  // visibly shift positions.
  inlineWrapper: {
    display: "inline-flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS
  },
  // Pointer cursor on the label — signals to the user that the label is
  // clickable (matching the native browser behavior of clicking a
  // `<label htmlFor=...>` to toggle its associated input). Applied to
  // both the inline label AND the Field's label slot so the cursor hint is
  // consistent whichever one shows.
  clickableLabel: {
    cursor: "pointer"
  }
});
function BoolEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  editorType = BoolEditorType.Checkbox,
  inlineLabel = true,
  validate
}) {
  const { value: value2, setValue: rawSetValue } = useBoolColumn(columnName);
  const { record } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const t = useT();
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const styles = useStyles14();
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const showLabel = displayLabelWhenAvailable && !!resolvedLabel;
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "bool",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value2 ?? null
    },
    validate
  );
  const layoutClassName = useEditorLabelLayoutClass(labelPosition, showLabel);
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelChildren = /* @__PURE__ */ jsxs(Fragment, { children: [
    resolvedLabel,
    showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
  ] });
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const hasError = "validationState" in fieldValidationProps;
  const needsFieldWrapper = showLabel || descriptionLocation === DescriptionLocation.BelowControl || hasError;
  const showInlineLabel = showLabel && inlineLabel;
  const controlClassName = needsFieldWrapper ? className : mergeClasses("ppp-bool-edit", className);
  const control = editorType === BoolEditorType.Switch ? /* @__PURE__ */ jsx(
    Switch,
    {
      id: inputId,
      className: controlClassName,
      style,
      checked: value2 ?? false,
      disabled: resolvedDisabled,
      required: resolvedRequired,
      onChange: (_, data) => setValue(data.checked === true)
    }
  ) : /* @__PURE__ */ jsx(
    Checkbox,
    {
      id: inputId,
      className: controlClassName,
      style,
      checked: value2 == null ? "mixed" : value2,
      disabled: resolvedDisabled,
      required: resolvedRequired,
      onChange: () => {
        if (value2 === null || value2 === void 0) {
          setValue(false);
        } else if (value2 === false) {
          setValue(true);
        } else {
          setValue(null);
        }
      }
    }
  );
  const inlineLabelEl = /* @__PURE__ */ jsx(
    Label,
    {
      htmlFor: inputId,
      disabled: resolvedDisabled,
      required: resolvedRequired,
      className: styles.clickableLabel,
      children: labelChildren
    }
  );
  if (needsFieldWrapper) {
    const fieldLabelSlot = showLabel && !inlineLabel ? {
      children: labelChildren,
      htmlFor: inputId,
      className: mergeClasses(editorLabelClassName, styles.clickableLabel)
    } : null;
    const fieldBody = showInlineLabel ? /* @__PURE__ */ jsxs("div", { className: styles.inlineWrapper, children: [
      control,
      inlineLabelEl
    ] }) : control;
    return /* @__PURE__ */ jsx(
      Field,
      {
        className: mergeClasses("ppp-bool-edit", layoutClassName, stateClassName),
        label: fieldLabelSlot,
        hint: fieldHint,
        required: resolvedRequired,
        ...fieldValidationProps,
        children: fieldBody
      }
    );
  }
  return control;
}
var ChoiceValueSort = {
  /** Server order — whatever Dataverse returned. */
  Default: "default",
  /** Alphabetical by localized display label. */
  DisplayName: "displayName",
  /** Alphabetical descending by localized display label. */
  DisplayNameDescending: "displayNameDescending",
  /** Ascending by integer option value. */
  Value: "value",
  /** Descending by integer option value. */
  ValueDescending: "valueDescending"
};
var ChoiceInvalidValueBehavior = {
  /** Hide the option entirely. */
  Remove: "remove",
  /** Keep the option visible but disabled (un-selectable). */
  Disable: "disable"
};
var ChoiceOrientation = {
  Vertical: "vertical",
  Horizontal: "horizontal"
};
function resolveChoiceLabel(t, tableName, columnName, choiceLogicalName, value2, fallback) {
  const keys = [];
  if (tableName) {
    keys.push(`tables.${tableName}.columns.${columnName}.values.${value2}.label`);
    keys.push(`tables.${tableName}.choices.${choiceLogicalName}.values.${value2}.label`);
  }
  keys.push(`choices.${choiceLogicalName}.values.${value2}.label`);
  for (const k of keys) {
    const resolved = t(k);
    if (resolved !== k) return resolved;
  }
  return fallback;
}
function resolveSelectedChoices(t, record, columnName, choiceMetadata) {
  if (!canReadColumn(record, columnName)) return void 0;
  const raw = readColumnWireValue(record.properties?.[columnName]);
  if (raw === void 0 || raw === null) return void 0;
  const selected = (Array.isArray(raw) ? raw.map((entry) => entry.value) : [raw]).filter((v) => v !== void 0 && v !== null).map(Number).filter((v) => !Number.isNaN(v));
  if (selected.length === 0) return void 0;
  const leafColumnName = columnName.split(".").pop() ?? columnName;
  return selected.map((value2) => {
    const choice2 = choiceMetadata.choices.find((c) => c.value === value2);
    return {
      text: resolveChoiceLabel(
        t,
        record.tableName,
        leafColumnName,
        choiceMetadata.choiceLogicalName,
        value2,
        choice2?.displayName ?? String(value2)
      ),
      color: choice2?.color
    };
  });
}
function unofferedChoiceValues(meta, validChoiceValues, invalidChoiceValues) {
  const isInvalid = (value2) => validChoiceValues !== void 0 ? !validChoiceValues.includes(value2) : invalidChoiceValues?.includes(value2) ?? false;
  const notOffered = /* @__PURE__ */ new Set();
  for (const c of meta.choices) {
    const hidden = c.isHidden === true && !(validChoiceValues?.includes(c.value) ?? false);
    if (hidden || isInvalid(c.value)) notOffered.add(c.value);
  }
  return { notOffered };
}
var noValues = /* @__PURE__ */ new Set();
function useHeldChoices(notOffered, selectedValues, record, columnName) {
  const key3 = `${getRecordReferenceId(record) ?? ""}|${columnName}`;
  const [held, setHeld] = useState(() => ({ key: key3, values: noValues }));
  let next = held.key === key3 ? held : { key: key3, values: noValues };
  const newlyHeld = selectedValues.filter((value2) => notOffered?.has(value2) === true && !next.values.has(value2));
  if (newlyHeld.length > 0) next = { key: key3, values: /* @__PURE__ */ new Set([...next.values, ...newlyHeld]) };
  if (next !== held) setHeld(next);
  return next.values;
}
function groupChoices(choices, groupOf) {
  const ungrouped = [];
  const groups = /* @__PURE__ */ new Map();
  for (const choice2 of choices) {
    const heading = groupOf(choice2.value);
    if (heading === null || heading === void 0 || heading === "") {
      ungrouped.push(choice2);
      continue;
    }
    const group = groups.get(heading);
    if (group) group.push(choice2);
    else groups.set(heading, [choice2]);
  }
  return [
    ...ungrouped.length > 0 ? [{ heading: void 0, choices: ungrouped }] : [],
    ...[...groups].map(([heading, grouped]) => ({ heading, choices: grouped }))
  ];
}
function buildRenderableChoices(meta, tableName, columnName, options) {
  const { notOffered } = unofferedChoiceValues(meta, options.validChoiceValues, options.invalidChoiceValues);
  const removed = options.invalidValueBehavior === ChoiceInvalidValueBehavior.Remove ? notOffered : noValues;
  const held = options.heldValues ?? noValues;
  const result = meta.choices.filter((c) => !removed.has(c.value) || held.has(c.value)).map((c) => ({
    value: c.value,
    text: resolveChoiceLabel(
      options.t,
      tableName,
      columnName,
      meta.choiceLogicalName,
      c.value,
      c.displayName
    ),
    disabled: notOffered.has(c.value),
    ...c.color ? { color: c.color } : {},
    ...notOffered.has(c.value) && held.has(c.value) ? { held: true } : {}
  }));
  switch (options.sort) {
    case ChoiceValueSort.DisplayName:
      result.sort((a, b) => a.text.localeCompare(b.text));
      break;
    case ChoiceValueSort.DisplayNameDescending:
      result.sort((a, b) => b.text.localeCompare(a.text));
      break;
    case ChoiceValueSort.Value:
      result.sort((a, b) => a.value - b.value);
      break;
    case ChoiceValueSort.ValueDescending:
      result.sort((a, b) => b.value - a.value);
      break;
    case ChoiceValueSort.Default:
  }
  return result;
}
var useStyles15 = makeStyles({
  // One element, so that a container laying its children out in a grid — a
  // closed dropdown's button does — keeps the swatch and the text together.
  label: {
    display: "inline-flex",
    alignItems: "center"
  },
  // The border keeps a white or very dark color visible on either theme.
  swatch: {
    display: "inline-block",
    flexShrink: 0,
    width: "12px",
    height: "12px",
    boxSizing: "border-box",
    borderRadius: tokens.borderRadiusCircular,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    marginInlineEnd: tokens.spacingHorizontalS
  },
  // A selected option in a ColumnDisplayValue. The swatch sits on the baseline,
  // which centers it on the line; inline-block keeps it on the same line as its
  // label unless the label alone is too long for one.
  value: {
    display: "inline-block"
  },
  // An option with no color keeps the space, so labels with and without one line up.
  none: {
    borderTopColor: tokens.colorTransparentStroke,
    borderRightColor: tokens.colorTransparentStroke,
    borderBottomColor: tokens.colorTransparentStroke,
    borderLeftColor: tokens.colorTransparentStroke
  }
});
function ChoiceColorSwatch({ color }) {
  const styles = useStyles15();
  return /* @__PURE__ */ jsx(
    "span",
    {
      "aria-hidden": true,
      className: mergeClasses("ppp-choice-color", styles.swatch, color === void 0 && styles.none),
      style: color === void 0 ? void 0 : { backgroundColor: color }
    }
  );
}
function ChoiceColorLabel({ text: text2, color }) {
  const styles = useStyles15();
  return /* @__PURE__ */ jsxs("span", { className: mergeClasses("ppp-choice-option", styles.label), children: [
    /* @__PURE__ */ jsx(ChoiceColorSwatch, { color }),
    text2
  ] });
}
function ChoiceColorValue({ text: text2, color }) {
  const styles = useStyles15();
  return /* @__PURE__ */ jsxs("span", { className: mergeClasses("ppp-choice-value", styles.value), children: [
    color !== void 0 && /* @__PURE__ */ jsx(ChoiceColorSwatch, { color }),
    text2
  ] });
}

// src/edits/base/format-value.ts
function formatValue(value2, format, locale, timeZone) {
  if (value2 === null || value2 === void 0 || value2 === "") return "";
  const trimmed = format.trim();
  if (trimmed === "") return String(value2);
  if (typeof value2 === "number" || typeof value2 === "string" && value2.length <= 24) {
    const n = typeof value2 === "number" ? value2 : Number(value2);
    if (Number.isFinite(n)) {
      const numeric = tryFormatNumber(n, trimmed, locale);
      if (numeric !== void 0) return numeric;
    }
  }
  if (isStandardDateCode(trimmed)) {
    const date = value2 instanceof Date ? value2 : new Date(String(value2));
    if (!Number.isNaN(date.getTime())) {
      return formatDate(date, trimmed, locale, timeZone);
    }
  }
  return String(value2);
}
var NUMERIC_STD_RE = /^([NnFfDdCcPpEeXx])(\d+)?$/;
var NUMERIC_CUSTOM_RE = /^([#0,]+)(?:\.([0#]+))?$/;
function tryFormatNumber(n, format, locale) {
  const std = format.match(NUMERIC_STD_RE);
  if (std) {
    const letter = std[1];
    const code = letter.toUpperCase();
    const digits = std[2] !== void 0 ? Number(std[2]) : void 0;
    switch (code) {
      case "N": {
        const opts = { useGrouping: true };
        applyDigits(opts, digits ?? 2);
        return new Intl.NumberFormat(locale, opts).format(n);
      }
      case "F": {
        const opts = { useGrouping: false };
        applyDigits(opts, digits ?? 2);
        return new Intl.NumberFormat(locale, opts).format(n);
      }
      case "D": {
        const int = Math.trunc(n);
        const absStr = String(Math.abs(int));
        const padded = digits !== void 0 ? absStr.padStart(digits, "0") : absStr;
        return int < 0 ? "-" + padded : padded;
      }
      case "C": {
        const opts = {
          style: "currency",
          currency: currencyForLocale(locale)
        };
        applyDigits(opts, digits ?? 2);
        return new Intl.NumberFormat(locale, opts).format(n);
      }
      case "P": {
        const opts = { style: "percent" };
        applyDigits(opts, digits ?? 2);
        return new Intl.NumberFormat(locale, opts).format(n);
      }
      case "E": {
        const opts = { notation: "scientific" };
        applyDigits(opts, digits ?? 6);
        return new Intl.NumberFormat(locale, opts).format(n);
      }
      case "X": {
        let hex = Math.trunc(n).toString(16);
        if (letter === "X") hex = hex.toUpperCase();
        if (digits !== void 0) hex = hex.padStart(digits, "0");
        return hex;
      }
    }
  }
  const custom = format.match(NUMERIC_CUSTOM_RE);
  if (custom) {
    const useGrouping = custom[1].includes(",");
    const decimals = custom[2] !== void 0 ? custom[2].length : 0;
    return new Intl.NumberFormat(locale, {
      useGrouping,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(n);
  }
  return void 0;
}
function applyDigits(opts, digits) {
  opts.minimumFractionDigits = digits;
  opts.maximumFractionDigits = digits;
}
function currencyForLocale(locale) {
  if (!locale) return "USD";
  const region = locale.split("-")[1]?.toUpperCase();
  switch (region) {
    case "GB":
      return "GBP";
    case "EU":
    case "DE":
    case "FR":
    case "IT":
    case "ES":
    case "NL":
      return "EUR";
    case "JP":
      return "JPY";
    case "CA":
      return "CAD";
    case "AU":
      return "AUD";
    case "IN":
      return "INR";
    default:
      return "USD";
  }
}
function isStandardDateCode(format) {
  if (format.length !== 1) return false;
  return "dDfFgGtTMmYysoOuR".includes(format);
}
function formatDate(date, code, locale, timeZone) {
  const zone = timeZone ? { timeZone } : {};
  switch (code) {
    case "d":
      return new Intl.DateTimeFormat(locale, { ...zone, dateStyle: "short" }).format(date);
    case "D":
      return new Intl.DateTimeFormat(locale, { ...zone, dateStyle: "long" }).format(date);
    case "f":
      return new Intl.DateTimeFormat(locale, { ...zone, dateStyle: "long", timeStyle: "short" }).format(date);
    case "F":
      return new Intl.DateTimeFormat(locale, { ...zone, dateStyle: "full", timeStyle: "long" }).format(date);
    case "g":
      return new Intl.DateTimeFormat(locale, { ...zone, dateStyle: "short", timeStyle: "short" }).format(date);
    case "G":
      return new Intl.DateTimeFormat(locale, { ...zone, dateStyle: "short", timeStyle: "medium" }).format(date);
    case "t":
      return new Intl.DateTimeFormat(locale, { ...zone, timeStyle: "short" }).format(date);
    case "T":
      return new Intl.DateTimeFormat(locale, { ...zone, timeStyle: "medium" }).format(date);
    case "M":
    case "m":
      return new Intl.DateTimeFormat(locale, { ...zone, month: "long", day: "numeric" }).format(date);
    case "Y":
    case "y":
      return new Intl.DateTimeFormat(locale, { ...zone, year: "numeric", month: "long" }).format(date);
    case "s":
      return date.toISOString().slice(0, 19);
    case "o":
    case "O":
      return date.toISOString();
    case "u":
      return date.toISOString().slice(0, 19).replace("T", " ") + "Z";
    case "R":
      return date.toUTCString();
    default:
      return date.toLocaleString(locale, zone);
  }
}
var useColumnDisplayValueStyles = makeStyles({
  value: {
    // Match the vertical rhythm of a Fluent `<Input>` so a read-only
    // display sits on the same baseline as adjacent edit fields. Tokens
    // (not literal pixel values) so the layout follows theme density
    // changes the consumer might dial in.
    minHeight: tokens.lineHeightBase300,
    padding: `${tokens.spacingVerticalXS} 0`,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    // Long lookups / multi-select labels can exceed the field width;
    // wrap rather than overflow so the form layout stays predictable.
    whiteSpace: "normal",
    wordBreak: "break-word"
  },
  empty: {
    color: tokens.colorNeutralForeground3
  }
});
function ColumnDisplayValue({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  isVisible = true,
  emptyPlaceholder = "\u2014",
  format,
  displayChoiceColors = false,
  className,
  style,
  id
}) {
  const { record } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const { locale } = useLocale();
  const userTimeZone = useUserTimeZone();
  const styles = useColumnDisplayValueStyles();
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  if (!isVisible) return null;
  const behavior = metadata?.dateTimeBehavior;
  const dateTimeZone = behavior === DateTimeBehavior.DateOnly || behavior === DateTimeBehavior.TimeZoneIndependent ? "UTC" : userTimeZone;
  let display;
  if (record && format) {
    const raw = readColumnWireValue(record.properties?.[columnName]);
    if (raw === void 0 || raw === null) {
      display = canReadColumn(record, columnName) ? null : record.formattedValues?.[columnName] ?? null;
    } else if (Array.isArray(raw)) {
      display = raw.map((entry) => formatValue(entry.value, format, locale, dateTimeZone)).filter((s) => s.length > 0).join(", ");
      if (display.length === 0) display = null;
    } else {
      display = formatValue(raw, format, locale, dateTimeZone);
    }
  } else {
    display = record ? resolveColumnDisplayValue(record, columnName, metadata) : null;
  }
  const isEmpty = display === null || display === "";
  const displayText = isEmpty ? emptyPlaceholder : display;
  const choiceMetadata = displayChoiceColors && !format ? getChoiceMetadata(metadata) : void 0;
  const coloredChoices = choiceMetadata && record ? resolveSelectedChoices(t, record, columnName, choiceMetadata) : void 0;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const valueClass = `${styles.value}${isEmpty && !coloredChoices ? ` ${styles.empty}` : ""}${className ? ` ${className}` : ""}`;
  return /* @__PURE__ */ jsx(Field, { className: mergeClasses("ppp-column-display-value", layoutClassName, layoutClassName && "ppp-label-text"), label: labelSlot, hint: fieldHint, children: /* @__PURE__ */ jsx("div", { id, className: valueClass, style, children: coloredChoices ? coloredChoices.map((c, i) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
    i > 0 && "; ",
    /* @__PURE__ */ jsx(ChoiceColorValue, { text: c.text, color: c.color })
  ] }, i)) : displayText }) });
}
var useStyles16 = makeStyles({
  // Fluent lays a horizontal group out on one line and lets every radio shrink to fit it, so a
  // label with spaces in it breaks onto several lines while single words run past the end. Each
  // radio keeps its label on one line instead.
  horizontal: {
    "& .fui-Radio": {
      flexShrink: 0
    },
    "& .fui-Radio__label": {
      whiteSpace: "nowrap"
    }
  },
  // The radios that don't fit move to the next row...
  horizontalWrap: {
    flexWrap: "wrap"
  },
  // ...or the row scrolls. The padding keeps a focused radio's ring, which Fluent draws just
  // outside the radio, inside the scrolling box rather than clipped by it.
  horizontalScroll: {
    flexWrap: "nowrap",
    overflowX: "auto",
    padding: tokens.spacingHorizontalXS
  }
});
function useRadioGroupClassName(horizontal, wrap, className) {
  const styles = useStyles16();
  return mergeClasses(
    horizontal && styles.horizontal,
    horizontal && (wrap ? styles.horizontalWrap : styles.horizontalScroll),
    className
  );
}
var ChoiceEditorType = {
  Dropdown: "dropdown",
  RadioButtons: "radioButtons"
};
function ChoiceEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  editorType = ChoiceEditorType.Dropdown,
  validChoiceValues,
  invalidChoiceValues,
  sort = ChoiceValueSort.Default,
  invalidValueBehavior = ChoiceInvalidValueBehavior.Remove,
  radioButtonOrientation = ChoiceOrientation.Vertical,
  wrapRadioButtons = true,
  displayNullChoice,
  displayChoiceColors = false,
  onValueChange,
  groupOf,
  validate
}) {
  const { value: value2, setValue: rawSetValue } = useChoiceColumn(columnName);
  const { record, tableMetadata } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const resolvedDisplayNullChoice = displayNullChoice ?? !resolvedRequired;
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setAndTell = useCallback(
    (next) => {
      rawSetValue(next);
      onValueChange?.(next ?? null);
    },
    [rawSetValue, onValueChange]
  );
  const setValue = useGuardedSetValue(setAndTell, resolvedReadOnly, resolvedDisabled);
  const choiceMeta = useMemo(() => getChoiceMetadata(metadata), [metadata]);
  const tableName = tableMetadata?.tableName;
  const validKey = validChoiceValues ? JSON.stringify(validChoiceValues) : "";
  const invalidKey = invalidChoiceValues ? JSON.stringify(invalidChoiceValues) : "";
  const unoffered = useMemo(
    () => choiceMeta ? unofferedChoiceValues(choiceMeta, validChoiceValues, invalidChoiceValues) : void 0,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [choiceMeta, validKey, invalidKey]
  );
  const heldValues = useHeldChoices(
    unoffered?.notOffered,
    value2 === void 0 ? [] : [value2],
    record,
    columnName
  );
  const choices = useMemo(
    () => choiceMeta ? buildRenderableChoices(choiceMeta, tableName, columnName, {
      validChoiceValues,
      invalidChoiceValues,
      invalidValueBehavior,
      sort,
      t,
      heldValues
    }) : [],
    // `t` is stable across renders within a single localizer cache state, so
    // including it in the dep correctly re-computes labels when localization
    // strings finish loading.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [choiceMeta, tableName, columnName, validKey, invalidKey, invalidValueBehavior, sort, t, heldValues]
  );
  const radioGroupClassName = useRadioGroupClassName(
    radioButtonOrientation === ChoiceOrientation.Horizontal,
    wrapRadioButtons,
    className
  );
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "number",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value2 ?? null
    },
    validate
  );
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const nullChoiceLabel = t("app.null-choice-label");
  const selectedKey = value2 === void 0 ? "" : String(value2);
  const selectedOption = choices.find((c) => c.value === value2);
  const groups = groupOf ? groupChoices(choices, groupOf) : void 0;
  const closedText = (text2, heading) => heading ? `${heading}: ${text2}` : text2;
  const selectedHeading = selectedOption && groupOf ? groupOf(selectedOption.value) || void 0 : void 0;
  const dropdownDisplayText = value2 === void 0 ? (
    // Unset: show the "(none)" label only when the null choice is offered,
    // otherwise leave the dropdown blank so a required column reads as empty.
    resolvedDisplayNullChoice ? nullChoiceLabel : ""
  ) : selectedOption ? closedText(selectedOption.text, selectedHeading) : String(value2);
  const readOnlyView = resolvedReadOnly && !resolvedDisabled;
  const optionLabel = (text2, color) => displayChoiceColors ? /* @__PURE__ */ jsx(ChoiceColorLabel, { text: text2, color }) : text2;
  let control;
  if (readOnlyView && editorType !== ChoiceEditorType.RadioButtons) {
    control = /* @__PURE__ */ jsx(ReadOnlyValue, { ...id !== void 0 && { id }, "aria-label": resolvedLabel, children: selectedOption === void 0 ? value2 === void 0 ? "" : String(value2) : displayChoiceColors && selectedOption.color !== void 0 ? /* @__PURE__ */ jsx(ChoiceColorValue, { text: selectedOption.text, color: selectedOption.color }) : selectedOption.text });
  } else if (editorType === ChoiceEditorType.RadioButtons) {
    control = /* @__PURE__ */ jsxs(
      RadioGroup,
      {
        id,
        className: radioGroupClassName,
        style,
        value: selectedKey,
        layout: radioButtonOrientation === ChoiceOrientation.Horizontal ? "horizontal" : "vertical",
        disabled: resolvedDisabled,
        required: resolvedRequired,
        ...readOnlyView && { "aria-readonly": true },
        onChange: (_, data) => {
          if (!data.value) {
            setValue(null);
            return;
          }
          setValue(Number(data.value));
        },
        children: [
          resolvedDisplayNullChoice && /* @__PURE__ */ jsx(Radio, { value: "", label: optionLabel(nullChoiceLabel, void 0) }, "__null__"),
          (groups ?? [{ heading: void 0, choices }]).flatMap((group) => [
            ...group.heading !== void 0 ? [
              // A row of its own, so it heads its radios laid out horizontally too.
              /* @__PURE__ */ jsx(
                Text,
                {
                  block: true,
                  weight: "semibold",
                  className: "ppp-choice-group-heading",
                  style: { width: "100%" },
                  children: group.heading
                },
                `heading:${group.heading}`
              )
            ] : [],
            ...group.choices.map((c) => /* @__PURE__ */ jsx(
              Radio,
              {
                value: String(c.value),
                label: optionLabel(c.text, c.color),
                disabled: resolvedDisabled || c.disabled
              },
              c.value
            ))
          ])
        ]
      }
    );
  } else {
    control = /* @__PURE__ */ jsxs(
      Dropdown,
      {
        id,
        className,
        style,
        selectedOptions: value2 === void 0 ? resolvedDisplayNullChoice ? [""] : [] : [selectedKey],
        value: dropdownDisplayText,
        ...displayChoiceColors && selectedOption?.color !== void 0 ? {
          button: {
            children: /* @__PURE__ */ jsx(ChoiceColorLabel, { text: dropdownDisplayText, color: selectedOption.color })
          }
        } : {},
        disabled: resolvedDisabled,
        onOptionSelect: (_, data) => {
          if (!data.optionValue) {
            setValue(null);
            return;
          }
          setValue(Number(data.optionValue));
        },
        children: [
          resolvedDisplayNullChoice && /* @__PURE__ */ jsx(Option, { value: "", text: nullChoiceLabel, children: optionLabel(nullChoiceLabel, void 0) }, "__null__"),
          (groups ?? [{ heading: void 0, choices }]).map((group) => {
            const options = group.choices.map((c) => (
              // The option's own text, which typing to select matches; `value` above is what the
              // closed dropdown shows.
              /* @__PURE__ */ jsx(Option, { value: String(c.value), text: c.text, disabled: c.disabled, children: optionLabel(c.text, c.color) }, c.value)
            ));
            return group.heading === void 0 ? options : /* @__PURE__ */ jsx(OptionGroup, { label: group.heading, children: options }, group.heading);
          })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-choice-edit", layoutClassName, stateClassName),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: control
    }
  );
}
var DateTimeEditorType = {
  DateTime: "dateTime",
  DateOnly: "dateOnly",
  TimeOnly: "timeOnly"
};
var useDateTimeStyles = makeStyles({
  // Side-by-side date + time pickers when editorType is `dateTime`. Stack
  // vertically on narrow screens — each picker's input is ~120px wide so
  // they fit comfortably in the typical form column at desktop widths.
  row: {
    display: "flex",
    flexWrap: "wrap",
    gap: tokens.spacingHorizontalS,
    alignItems: "center"
  },
  // Applied only when BOTH pickers render: date gets 2 shares, time gets 1
  // share (≈67/33 split). The date picker's content — full month-name + day
  // + four-digit year — needs more room than the time picker's hh:mm, so a
  // straight 50/50 left the date side cramped while the time side had slack.
  // `flex-basis: 100px` (NOT 0) is what triggers flex-wrap when the row can't
  // fit both side-by-side — wrap checks the items' hypothetical main size
  // (= basis), so with basis:0 it would never trigger and `min-width` would
  // instead force overflow. `min-width: 0` lets each picker shrink freely
  // down to its flex share, overriding the wrapper's intrinsic min-width.
  // The TimePicker overrides are critical: Fluent's Combobox-based TimePicker
  // uses `display: inline-grid` with `grid-template-columns: '1fr auto'` (input
  // + chevron). The `1fr` track has an implicit `min-content` floor equal to
  // the bare `<input>`'s default `size="20"` — about 150px — so the picker
  // refuses to shrink past ~180px even with `min-width: 0` on the wrapper, and
  // the chevron protrudes out of the field in narrow layouts. Switching the
  // track to `minmax(0, 1fr) auto` defeats that floor, and `min-width: 0` on
  // the inner `<input>` lets the browser ignore the `size`-derived min-content.
  // Together: the picker actually shrinks to whatever flex allocates.
  bothPickers: {
    // First child is the DatePicker (rendered before the TimePicker in the
    // JSX), second is the TimePicker. `nth-child` rather than `first-child` /
    // `last-child` so future siblings (e.g. an inline validation icon) don't
    // silently inherit the time-side share.
    "& > *:nth-child(1)": {
      flex: "2 1 100px",
      minWidth: 0
    },
    "& > *:nth-child(2)": {
      flex: "1 1 100px",
      minWidth: 0
    },
    "& .fui-TimePicker": {
      minWidth: 0,
      gridTemplateColumns: "minmax(0, 1fr) auto"
    },
    "& .fui-TimePicker__input": {
      minWidth: 0
    }
  }
});
function DateTimeEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  editorType,
  placeholder,
  disabledDateFunc,
  validate
}) {
  const { value: value2, setValue: rawSetValue } = useDateColumn(columnName);
  const { record } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const styles = useDateTimeStyles();
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const resolvedEditorType = editorType ?? resolveEditorTypeFromMetadata(metadata);
  const timeZone = useUserTimeZone();
  const authLoading = usePowerPortalsPro().authState.status === "loading";
  const clock = clockOf(metadata, resolvedEditorType, timeZone);
  const awaitsTimeZone = clock === "browser" && isUserLocal(metadata) && authLoading;
  const restrictedDates = useMemo(() => {
    if (!disabledDateFunc) return void 0;
    const out = [];
    const cursor = /* @__PURE__ */ new Date();
    cursor.setFullYear(cursor.getFullYear() - 2);
    cursor.setHours(0, 0, 0, 0);
    const end = /* @__PURE__ */ new Date();
    end.setFullYear(end.getFullYear() + 2);
    while (cursor <= end) {
      if (disabledDateFunc(new Date(cursor))) {
        out.push(new Date(cursor));
      }
      cursor.setDate(cursor.getDate() + 1);
    }
    return out.length > 0 ? out : void 0;
  }, [disabledDateFunc]);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "datetime",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value2 ?? null
    },
    validate
  );
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const currentDate = value2 && !awaitsTimeZone ? fromWire(value2, clock, timeZone) : null;
  const handleDateSelected = (selected) => {
    if (!selected) {
      setValue(null);
      return;
    }
    if (resolvedEditorType === DateTimeEditorType.DateOnly) {
      setValue(toWire(new Date(selected.getFullYear(), selected.getMonth(), selected.getDate()), clock, timeZone));
      return;
    }
    const merged = new Date(selected);
    if (currentDate) {
      merged.setHours(
        currentDate.getHours(),
        currentDate.getMinutes(),
        currentDate.getSeconds(),
        currentDate.getMilliseconds()
      );
    } else {
      merged.setHours(0, 0, 0, 0);
    }
    setValue(toWire(merged, clock, timeZone));
  };
  const handleTimeSelected = (_ev, data) => {
    if (!data.selectedTime) {
      if (data.errorType === "invalid-input" || data.errorType === "out-of-bounds") return;
      setValue(null);
      return;
    }
    const baseDate = currentDate ?? (clock === "zone" && timeZone ? toZonedWallClock(/* @__PURE__ */ new Date(), timeZone) : /* @__PURE__ */ new Date());
    const merged = new Date(baseDate);
    merged.setHours(
      data.selectedTime.getHours(),
      data.selectedTime.getMinutes(),
      data.selectedTime.getSeconds(),
      data.selectedTime.getMilliseconds()
    );
    setValue(toWire(merged, clock, timeZone));
  };
  const dateAnchor = currentDate ?? /* @__PURE__ */ new Date();
  const showDate = resolvedEditorType === DateTimeEditorType.DateOnly || resolvedEditorType === DateTimeEditorType.DateTime;
  const showTime = resolvedEditorType === DateTimeEditorType.TimeOnly || resolvedEditorType === DateTimeEditorType.DateTime;
  const readOnlyView = resolvedReadOnly && !resolvedDisabled;
  const readOnlyText = currentDate ? [
    showDate ? currentDate.toLocaleDateString(void 0) : void 0,
    showTime ? currentDate.toLocaleTimeString(void 0, { hour: "numeric", minute: "2-digit" }) : void 0
  ].filter((x) => x !== void 0).join(" ") : "";
  const timeDisplayValue = currentDate ? currentDate.toLocaleTimeString(void 0, { hour: "numeric", minute: "2-digit" }) : "";
  const [timeInputText, setTimeInputText] = useState(timeDisplayValue);
  useEffect(() => {
    setTimeInputText(timeDisplayValue);
  }, [timeDisplayValue]);
  const handleTimeInputChange = (ev) => {
    setTimeInputText(ev.currentTarget.value);
  };
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-date-time-edit", layoutClassName, stateClassName),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: readOnlyView ? /* @__PURE__ */ jsx(ReadOnlyValue, { ...id !== void 0 && { id }, "aria-label": resolvedLabel, children: readOnlyText }) : /* @__PURE__ */ jsxs(
        "div",
        {
          className: mergeClasses(styles.row, showDate && showTime && styles.bothPickers, className),
          style,
          children: [
            showDate && /* @__PURE__ */ jsx(
              DatePicker,
              {
                value: currentDate,
                onSelectDate: handleDateSelected,
                disabled: resolvedDisabled || awaitsTimeZone,
                allowTextInput: true,
                ...restrictedDates !== void 0 && {
                  calendar: { restrictedDates }
                },
                ...id !== void 0 && { id },
                ...placeholder !== void 0 && { placeholder }
              }
            ),
            showTime && /* @__PURE__ */ jsx(
              TimePicker,
              {
                freeform: true,
                selectedTime: currentDate,
                onTimeChange: handleTimeSelected,
                disabled: resolvedDisabled || awaitsTimeZone,
                dateAnchor,
                value: timeInputText,
                onChange: handleTimeInputChange,
                ...!showDate && id !== void 0 && { id },
                ...placeholder !== void 0 && { placeholder }
              }
            )
          ]
        }
      )
    }
  );
}
function resolveEditorTypeFromMetadata(metadata) {
  const m = metadata;
  if (m?.dateTimeBehavior === DateTimeBehavior.DateOnly) {
    return DateTimeEditorType.DateOnly;
  }
  return DateTimeEditorType.DateTime;
}
function behaviorOf(metadata) {
  return metadata?.dateTimeBehavior;
}
function isUserLocal(metadata) {
  const behavior = behaviorOf(metadata);
  return behavior === void 0 || behavior === DateTimeBehavior.UserLocal;
}
function clockOf(metadata, editorType, timeZone) {
  const behavior = behaviorOf(metadata);
  if (behavior === DateTimeBehavior.DateOnly || behavior === DateTimeBehavior.TimeZoneIndependent) return "literal";
  if (behavior === void 0 && editorType === DateTimeEditorType.DateOnly) return "literal";
  return timeZone ? "zone" : "browser";
}
function fromWire(wireValue, clock, timeZone) {
  const instant = new Date(wireValue);
  if (Number.isNaN(instant.getTime())) return null;
  switch (clock) {
    case "literal":
      return new Date(
        instant.getUTCFullYear(),
        instant.getUTCMonth(),
        instant.getUTCDate(),
        instant.getUTCHours(),
        instant.getUTCMinutes(),
        instant.getUTCSeconds()
      );
    case "zone":
      return toZonedWallClock(instant, timeZone);
    default:
      return instant;
  }
}
function toWire(shown, clock, timeZone) {
  switch (clock) {
    case "literal":
      return new Date(
        Date.UTC(shown.getFullYear(), shown.getMonth(), shown.getDate(), shown.getHours(), shown.getMinutes(), shown.getSeconds())
      ).toISOString();
    case "zone":
      return fromZonedWallClock(shown, timeZone).toISOString();
    default:
      return shown.toISOString();
  }
}
function ImageEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  accept = "image/*",
  displayImage = true,
  maxFileSizeBytes,
  uploadHintText,
  outputFormat = "auto",
  outputQuality = 0.9,
  editAfterUpload = false,
  validate
}) {
  const { value: value2, setValue: rawSetValue, fileId, hydrateValue } = useFileColumn(columnName);
  const { record, registerPendingEdit, notifyPendingEditChanged } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const { ppp } = usePowerPortalsPro();
  const styles = useImageEditStyles();
  const t = useT();
  const reactId = useId();
  const inputId = id ?? reactId;
  const [isDownloading, setIsDownloading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const viewerRef = useRef(null);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const isInteractable = !resolvedReadOnly && !resolvedDisabled;
  const handleUploaded = useCallback(() => {
    if (editAfterUpload && displayImage && isInteractable) setIsEditing(true);
  }, [displayImage, editAfterUpload, isInteractable]);
  const upload = useFileUpload({
    setValue,
    enabled: isInteractable,
    onUploaded: handleUploaded,
    warnPrefix: "PowerPortalsPro ImageEdit",
    ...maxFileSizeBytes !== void 0 && { maxFileSizeBytes }
  });
  useEffect(() => {
    if (!displayImage) return;
    if (value2?.value) return;
    if (!fileId) return;
    if (!record?.tableName || !record.id) return;
    if (record.id === EMPTY_GUID) return;
    let canceled = false;
    (async () => {
      try {
        const info = await ppp.getFileInfoAsync(record.tableName, record.id, columnName, true);
        if (canceled) return;
        if (info.fileData) {
          hydrateValue({
            fileName: info.fileName ?? value2?.fileName ?? "",
            id: fileId,
            value: info.fileData
          });
        }
      } catch (err) {
        if (canceled) return;
        console.warn(`PowerPortalsPro ImageEdit: preview fetch failed for ${columnName}`, err);
      }
    })();
    return () => {
      canceled = true;
    };
  }, [columnName, displayImage, fileId, hydrateValue, ppp, record?.id, record?.tableName, value2?.fileName, value2?.value]);
  const handleDownload = useCallback(async () => {
    if (!value2) return;
    setIsDownloading(true);
    try {
      const bytes = value2.value ? base64ToBytes(value2.value) : await fetchFileBytes(ppp, record?.tableName, record?.id, columnName);
      if (bytes === null) return;
      triggerBlobDownload(bytes, value2.fileName);
    } finally {
      setIsDownloading(false);
    }
  }, [columnName, ppp, record, value2]);
  const handleEnterEdit = useCallback(() => {
    setIsEditing(true);
  }, []);
  const handleCancelEdit = useCallback(() => {
    setIsEditing(false);
  }, []);
  const applyEdit = useCallback(async (now) => {
    const run = (update) => now ? flushSync(update) : update();
    const handle = viewerRef.current;
    if (!handle) {
      run(() => setIsEditing(false));
      return;
    }
    const result = await handle.commit();
    if (!result) {
      run(() => setIsEditing(false));
      return;
    }
    const origName = value2?.fileName ?? "image";
    const dot = origName.lastIndexOf(".");
    const stem = dot >= 0 ? origName.slice(0, dot) : origName;
    const ext = result.mimeType === "image/jpeg" ? "jpg" : "png";
    run(() => {
      setValue({
        fileName: `${stem}.${ext}`,
        id: EMPTY_GUID,
        value: result.base64
      });
      setIsEditing(false);
    });
  }, [setValue, value2?.fileName]);
  const handleSaveEdit = useCallback(() => applyEdit(false), [applyEdit]);
  const pendingEditRef = useRef({ isEditing, applyEdit });
  pendingEditRef.current = { isEditing, applyEdit };
  useEffect(
    () => registerPendingEdit?.({
      isPending: () => pendingEditRef.current.isEditing,
      apply: () => pendingEditRef.current.applyEdit(true)
    }),
    [registerPendingEdit]
  );
  useEffect(() => {
    notifyPendingEditChanged?.();
  }, [isEditing, notifyPendingEditChanged]);
  const hasImagePreview = displayImage && value2?.value != null;
  const isLoadingImagePreview = displayImage && !value2?.value && !!fileId && !!record?.id && record.id !== EMPTY_GUID;
  const imageSource = useMemo(() => {
    if (value2?.value == null) return null;
    return {
      kind: "base64",
      value: value2.value,
      fileName: value2.fileName
    };
  }, [value2?.value, value2?.fileName]);
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  if (!hasImagePreview && !isLoadingImagePreview) {
    const fileEditProps = {
      columnName,
      accept,
      displayLabelWhenAvailable,
      descriptionLocation,
      displayValidationErrorMessage,
      isVisible,
      uploadHintText: uploadHintText ?? t("app.messages.image-upload-drop-zone"),
      ...label !== void 0 && { label },
      ...labelPosition !== void 0 && { labelPosition },
      ...description !== void 0 && { description },
      ...required !== void 0 && { required },
      ...readOnly !== void 0 && { readOnly },
      ...disabled !== void 0 && { disabled },
      // Fold `ppp-image-edit` into the className forwarded to FileEdit so
      // the marker survives the delegation. FileEdit lands `className` on
      // its inner drop-zone div (not its Field), so the marker won't sit
      // on the outermost element in the delegate branch — but it's still
      // present in the rendered DOM for consumer CSS to target.
      className: mergeClasses("ppp-image-edit", className),
      ...style !== void 0 && { style },
      ...id !== void 0 && { id },
      ...maxFileSizeBytes !== void 0 && { maxFileSizeBytes },
      ...validate !== void 0 && { validate },
      onUploaded: handleUploaded
    };
    return /* @__PURE__ */ jsx(FileEdit, { ...fileEditProps });
  }
  if (!isVisible) return null;
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  if (isLoadingImagePreview) {
    return /* @__PURE__ */ jsx(
      Field,
      {
        className: mergeClasses("ppp-image-edit", layoutClassName, stateClassName),
        label: labelSlot,
        hint: fieldHint,
        required: resolvedRequired,
        children: /* @__PURE__ */ jsx(
          "div",
          {
            className: mergeClasses(styles.loadingFrame, className),
            ...style !== void 0 && { style },
            children: /* @__PURE__ */ jsx(Spinner, { size: "small", label: t("app.components.image-edit.loading-preview") })
          }
        )
      }
    );
  }
  const source = imageSource;
  if (resolvedReadOnly && !resolvedDisabled) {
    return /* @__PURE__ */ jsx(
      Field,
      {
        className: mergeClasses("ppp-image-edit", layoutClassName, stateClassName),
        label: labelSlot,
        hint: fieldHint,
        required: resolvedRequired,
        children: /* @__PURE__ */ jsx(
          ImageViewer,
          {
            source,
            framed: true,
            downloadable: true,
            className: mergeClasses(styles.viewer, className),
            ...style !== void 0 && { style }
          }
        )
      }
    );
  }
  const viewerWrapperClass = mergeClasses(
    styles.viewerWrapper,
    isInteractable && !isEditing && styles.viewerWrapperInteractable,
    upload.isDragOver && !isEditing && styles.viewerWrapperActive
  );
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-image-edit", layoutClassName, stateClassName),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      children: /* @__PURE__ */ jsxs("div", { className: mergeClasses(styles.wrapper, className), style, children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: upload.inputRef,
            id: inputId,
            type: "file",
            accept,
            disabled: !isInteractable,
            className: styles.hiddenInput,
            onChange: upload.onInputChange
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: viewerWrapperClass,
            ...isInteractable && !isEditing ? upload.dropZoneHandlers : {},
            children: [
              /* @__PURE__ */ jsx(
                ImageViewer,
                {
                  ref: viewerRef,
                  source,
                  framed: true,
                  toolbar: isEditing,
                  croppable: isEditing,
                  outputFormat,
                  outputQuality,
                  className: styles.viewer,
                  ...isEditing && {
                    onSave: handleSaveEdit,
                    onCancel: handleCancelEdit
                  }
                },
                isEditing ? "edit" : "view"
              ),
              isInteractable && !isEditing && // View-mode overlay: Edit (enters edit mode), Download, Clear.
              // Translucent backdrop keeps icons readable against arbitrary
              // image content; `stopPropagation` on each button stops the
              // click from also firing the wrapper's open-file-picker
              // handler.
              /* @__PURE__ */ jsxs("div", { className: styles.actions, children: [
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    appearance: "subtle",
                    icon: /* @__PURE__ */ jsx(Edit20Regular, {}),
                    "aria-label": t("app.buttons.edit-item", [value2.fileName]),
                    onClick: (ev) => {
                      ev.stopPropagation();
                      handleEnterEdit();
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    appearance: "subtle",
                    icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
                    "aria-label": t("app.buttons.download-item", [value2.fileName]),
                    disabled: isDownloading,
                    onClick: (ev) => {
                      ev.stopPropagation();
                      void handleDownload();
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    appearance: "subtle",
                    icon: /* @__PURE__ */ jsx(Dismiss20Regular, {}),
                    "aria-label": t("app.buttons.remove-item", [value2.fileName]),
                    onClick: (ev) => {
                      ev.stopPropagation();
                      setValue(null);
                    }
                  }
                )
              ] })
            ]
          }
        )
      ] })
    }
  );
}
var useImageEditStyles = makeStyles({
  wrapper: {
    width: "100%"
  },
  // Placeholder frame shown while the lazy-load is in flight. Same
  // chrome (border, background, rounded corners) as ImageViewer's
  // framed mode so the layout doesn't jump when the bytes arrive and
  // we swap to the real viewer. Min-height matches a reasonable image
  // size so the spinner sits in the middle of a visible area rather
  // than against a 0-height box.
  loadingFrame: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "180px",
    borderTopWidth: tokens.strokeWidthThin,
    borderRightWidth: tokens.strokeWidthThin,
    borderBottomWidth: tokens.strokeWidthThin,
    borderLeftWidth: tokens.strokeWidthThin,
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftStyle: "solid",
    borderTopColor: tokens.colorNeutralStroke1,
    borderRightColor: tokens.colorNeutralStroke1,
    borderBottomColor: tokens.colorNeutralStroke1,
    borderLeftColor: tokens.colorNeutralStroke1,
    borderTopLeftRadius: tokens.borderRadiusMedium,
    borderTopRightRadius: tokens.borderRadiusMedium,
    borderBottomLeftRadius: tokens.borderRadiusMedium,
    borderBottomRightRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2
  },
  hiddenInput: {
    position: "absolute",
    width: "1px",
    height: "1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: "none"
  },
  // Positioning context for the absolute-positioned action overlay. Sits
  // outside ImageViewer's own framed wrapper so the overlay can anchor
  // to the field-width edge, not to ImageViewer's intrinsic content
  // width.
  viewerWrapper: {
    position: "relative",
    display: "block"
  },
  // View-mode hover affordance: cursor hints that clicking opens the
  // file picker. Edit mode skips this since the viewer's pan/crop
  // gestures own the cursor in that state.
  viewerWrapperInteractable: {
    cursor: "pointer"
  },
  // Drag-over highlight. Inset box-shadow (instead of overriding
  // borderColor on a `border` shorthand) sidesteps Griffel's strict
  // mixing rules — same trick used in `FileEdit` and the original
  // `previewFrameActive`.
  viewerWrapperActive: {
    boxShadow: `inset 0 0 0 ${tokens.strokeWidthThick} ${tokens.colorBrandStroke1}`,
    borderRadius: tokens.borderRadiusMedium
  },
  // ImageViewer defaults to `display: inline-flex` (sized to content). For
  // a form field we want it to fill the field width so the action overlay
  // anchors to the visible image's right edge.
  viewer: {
    display: "flex",
    width: "100%",
    maxWidth: "100%"
  },
  // Overlay corner toolbar — top-right of the viewer, sitting on top of
  // the image. Translucent backdrop keeps the icons readable against any
  // image content (a near-white photo would wash out a transparent
  // button); rounded corners + a soft shadow separate it visually from
  // the viewer's frame.
  actions: {
    position: "absolute",
    top: tokens.spacingVerticalS,
    right: tokens.spacingHorizontalS,
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    paddingTop: "2px",
    paddingBottom: "2px",
    backgroundColor: tokens.colorNeutralBackgroundAlpha,
    backdropFilter: "blur(4px)",
    borderRadius: tokens.borderRadiusMedium,
    boxShadow: tokens.shadow4,
    // Sit above the image inside the viewer's stacking context.
    zIndex: 1
  }
});
var LINKABLE = TableSecurityPermission.Read | TableSecurityPermission.AppendTo;

// src/edits/base/lookup-filters.ts
function lookupFiltersFor(filter, provider, record, tableName) {
  const filters = [];
  if (filter?.trim()) filters.push({ $type: "FetchXmlFilter", filterXml: filter });
  const provided = provider && record ? provider({ record, tableName }) : void 0;
  if (provided?.trim()) filters.push({ $type: "FetchXmlFilter", filterXml: provided });
  return filters;
}
function lookupFiltersKey(filters) {
  return filters.map((x) => "filterXml" in x ? x.filterXml : JSON.stringify(x)).join("\n");
}
var SEARCH_DEBOUNCE_MS = 300;
var NULL_CHOICE_VALUE = "__null__";
var LookupEditorType = {
  /**
   * Default. Debounced server-side typeahead via Fluent {@link Combobox}.
   * Use this whenever the target table has more records than would
   * comfortably fit in a flat list.
   */
  AutoComplete: "autoComplete",
  /**
   * Pre-fetched top-N records rendered as a Fluent {@link Dropdown}. No
   * typing — the consumer just picks from the visible list. Best for
   * small / bounded target tables (configuration lookups, status owners,
   * etc.). Cap controlled by {@link LookupEditProps.maxRecordsReturned}.
   */
  Dropdown: "dropdown",
  /**
   * Pre-fetched top-N records rendered as a Fluent {@link RadioGroup}. Same
   * data shape as `Dropdown`; a "(none)" radio can be added on the front via
   * {@link LookupEditProps.displayNullChoice}.
   */
  RadioButtons: "radioButtons"
};
var useLookupStyles = makeStyles({
  // Listbox sizing — min/max-height are dynamic (driven by the
  // `popupMinHeight` / `popupMaxHeight` props) and applied via inline
  // style on the slot, so only the always-on bits live here. Inline
  // style is used for size because Fluent's own Listbox class can carry
  // sizing rules with similar specificity to our Griffel class — inline
  // style beats both. The explicit `padding-top: 0` eliminates the gap
  // above the sticky polymorphic header where scrolling options would
  // otherwise briefly bleed through before disappearing behind the
  // header. (Fluent's Listbox applies a small top inset by default;
  // zeroing it lets the sticky header touch the listbox's top edge
  // exactly.)
  listbox: {
    overflowY: "auto",
    paddingTop: "0"
  },
  // Polymorphic target-table picker rendered inside the Combobox's listbox
  // (above the options). The inner
  // Dropdown uses `inlinePopup` so its option list renders as a DOM
  // descendant of the trigger rather than being portaled to body — that
  // keeps the inner popup INSIDE the outer Combobox's tree, so clicking an
  // inner option isn't treated as an "outside click" that would dismiss
  // the outer Combobox.
  // The wrapper's `onMouseDown` preventDefault is the second half of the
  // trick: mousedown on the inner Dropdown trigger (or its options) would
  // otherwise pull focus out of the outer Combobox's input and the outer
  // popup would blur-close before the click registered. preventDefault on
  // mousedown blocks the focus shift without blocking the subsequent click
  // event, so the inner Dropdown still opens and selects as usual.
  // `position: sticky; top: 0` pins the header at the top of the scrolling
  // listbox so it stays visible while the user scrolls through options.
  // The background fill is required because sticky elements still allow
  // content to scroll BEHIND them — without an opaque fill, options would
  // bleed through.
  // Its z-index is above the Advanced Search footer's: the inner
  // Dropdown's option list belongs to this header's stacking layer, and
  // with no results it reaches down over the footer, which would
  // otherwise be drawn on top of it.
  targetPickerHeader: {
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    marginBottom: tokens.spacingVerticalXXS,
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    position: "sticky",
    top: 0,
    backgroundColor: tokens.colorNeutralBackground1,
    zIndex: 2
  },
  targetPickerLabel: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
    whiteSpace: "nowrap",
    flex: "0 0 auto"
  },
  targetPickerControl: {
    flex: "1 1 auto",
    minWidth: "0"
  },
  statusOption: {
    color: tokens.colorNeutralForeground3,
    fontStyle: "italic"
  },
  loadingOption: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS
  },
  // Multi-column option template — one row per result, view columns
  // stacked vertically. The first column is bold (the "primary" line);
  // subsequent columns are normal weight + dimmer.
  // option template (`FluentStack Orientation="Vertical"` with
  // bold-first-column styling).
  optionStack: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "2px",
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS
  },
  optionRowPrimary: {
    fontWeight: tokens.fontWeightSemibold
  },
  optionRowSecondary: {
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase200
  },
  optionNull: {
    color: tokens.colorNeutralForeground4,
    fontStyle: "italic"
  },
  // Sticky footer hosting the Advanced Search button. Mirrors the
  // sticky-top behavior of `targetPickerHeader` but pinned at the bottom
  // of the listbox so the button stays visible while scrolling through
  // results. Same `onMouseDown` preventDefault trick applies in the JSX
  // (block focus shift that would dismiss the outer Combobox before the
  // click registers).
  advancedSearchFooter: {
    display: "flex",
    justifyContent: "flex-end",
    padding: tokens.spacingHorizontalS,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
    position: "sticky",
    bottom: 0,
    zIndex: 1
  }
});
function resolveLookupView(views, defaultViewId) {
  const lookupViews = views.filter((v) => typeof v.type === "number" && (v.type & 64) === 64);
  return views.find((v) => v.id === defaultViewId) ?? lookupViews.find((v) => v.isDefault) ?? lookupViews[0];
}
function LookupEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  editorType = LookupEditorType.AutoComplete,
  maxRecordsReturned = 20,
  placeholder,
  defaultTable,
  targetTables: namedTargetTables,
  showRecordLinks = true,
  onNavigate,
  displayNullChoice = true,
  radioButtonOrientation = ChoiceOrientation.Vertical,
  wrapRadioButtons = true,
  popupMaxHeight = "250px",
  popupMinHeight = "150px",
  defaultViewId,
  viewIds,
  filter,
  filterProvider,
  clearValueOutsideFilter = true,
  validate
}) {
  const { value: lookupValue, setValue: rawSetLookupValue } = useLookupColumn(columnName);
  const { record, dirtyColumns } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const styles = useLookupStyles();
  const { ppp, tableMetadataCache, viewsForTableCache } = usePowerPortalsPro();
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setLookupValue = useGuardedSetValue(
    rawSetLookupValue,
    resolvedReadOnly,
    resolvedDisabled
  );
  const lookupMeta = getLookupMetadata(metadata);
  const columnTargets = lookupMeta?.targetTables;
  const targetsKey = useMemo(() => {
    const columns = columnTargets ?? [];
    if (!namedTargetTables) return columns.join(",");
    const named = namedTargetTables.map((name) => columns.find((column) => column.toLowerCase() === name.toLowerCase())).filter((name) => name !== void 0);
    return [...new Set(named)].join(",");
  }, [columnTargets, namedTargetTables]);
  const needed = resolvedReadOnly || resolvedDisabled ? TableSecurityPermission.Read : LINKABLE;
  const offeredKey = targetsKey ? `${needed}:${targetsKey}` : "";
  const [offered, setOffered] = useState({ key: "", tables: [] });
  useEffect(() => {
    if (!offeredKey) return;
    let current = true;
    const names2 = targetsKey.split(",");
    ppp.retrieveTablesPermissionsAsync(names2).then(
      (permissions) => {
        if (!current) return;
        setOffered({
          key: offeredKey,
          tables: names2.filter((name) => ((permissions[name] ?? 0) & needed) === needed)
        });
      },
      // Unanswered, no table is offered, rather than the editor failing.
      () => {
        if (current) setOffered({ key: offeredKey, tables: [] });
      }
    );
    return () => {
      current = false;
    };
  }, [ppp, offeredKey]);
  const targetTables = useMemo(
    () => offeredKey && offered.key === offeredKey ? offered.tables : [],
    [offeredKey, offered]
  );
  const isPolymorphic = targetTables.length > 1;
  const offeredTable = (name) => name && targetTables.includes(name) ? name : void 0;
  const [selectedTargetTable, setSelectedTargetTable] = useState(void 0);
  const effectiveTargetTable = offeredTable(selectedTargetTable) ?? offeredTable(defaultTable) ?? offeredTable(lookupValue?.tableName) ?? targetTables[0];
  const targetMetaQuery = useTableMetadata(effectiveTargetTable ?? "", {
    enabled: Boolean(effectiveTargetTable)
  });
  const primaryNameColumn = targetMetaQuery.data?.primaryNameColumn;
  const viewsQuery = useViewsForTable(effectiveTargetTable ?? "", {
    enabled: Boolean(effectiveTargetTable)
  });
  const lookupView = useMemo(() => {
    const views = viewsQuery.data;
    return views && views.length > 0 ? resolveLookupView(views, defaultViewId) : void 0;
  }, [viewsQuery.data, defaultViewId]);
  const viewColumnNames = useMemo(() => {
    if (lookupView?.columns && lookupView.columns.length > 0) {
      return lookupView.columns.map((c) => c.columnName);
    }
    return primaryNameColumn ? [primaryNameColumn] : [];
  }, [lookupView, primaryNameColumn]);
  const viewColumnMetadata = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    const cols = targetMetaQuery.data?.columns ?? [];
    for (const c of cols) m.set(c.columnName, c);
    return m;
  }, [targetMetaQuery.data]);
  const filtersFor = (tableName) => lookupFiltersFor(filter, filterProvider, record, tableName);
  const searchFiltersNow = effectiveTargetTable ? filtersFor(effectiveTargetTable) : [];
  const searchFiltersKey = lookupFiltersKey(searchFiltersNow);
  const searchFilters = useMemo(() => searchFiltersNow, [searchFiltersKey]);
  const [query, setQuery] = useState(
    editorType === LookupEditorType.AutoComplete ? null : ""
  );
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [comboboxOpen, setComboboxOpen] = useState(false);
  useEffect(() => {
    if (editorType !== LookupEditorType.AutoComplete && query === null) {
      setQuery("");
    }
  }, [editorType, query]);
  const viewsLoading = viewsQuery.status === QueryStatus.Loading;
  const abortRef = useRef(null);
  useEffect(() => {
    if (query === null) return;
    if (!effectiveTargetTable || !primaryNameColumn || viewsLoading) return;
    const timer = setTimeout(() => {
      abortRef.current?.abort();
      const controller = new AbortController();
      abortRef.current = controller;
      setLoading(true);
      setError(null);
      const searchRequest = {
        tableName: effectiveTargetTable,
        ...lookupView && { viewId: lookupView.id },
        ...query && { searchText: query },
        maxRecords: maxRecordsReturned,
        ...searchFilters.length > 0 && { filters: searchFilters }
      };
      ppp.searchLookupAsync(searchRequest, controller.signal).then((resp) => {
        if (controller.signal.aborted) return;
        const mapped = resp.tableRecords.map((r) => {
          const nameCol = r.properties?.[primaryNameColumn];
          return {
            id: r.id ?? "",
            name: nameCol?.value ?? "",
            tableName: r.tableName,
            record: r
          };
        });
        setResults(mapped);
      }).catch((e) => {
        if (controller.signal.aborted) return;
        setError(e instanceof Error ? e.message : "Search failed");
        setResults([]);
      }).finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    }, SEARCH_DEBOUNCE_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [
    query,
    effectiveTargetTable,
    primaryNameColumn,
    viewsLoading,
    maxRecordsReturned,
    ppp,
    lookupView,
    searchFilters
  ]);
  useEffect(() => () => abortRef.current?.abort(), []);
  const listedFiltersKeyRef = useRef(searchFiltersKey);
  useEffect(() => {
    if (listedFiltersKeyRef.current === searchFiltersKey) return;
    listedFiltersKeyRef.current = searchFiltersKey;
    if (editorType !== LookupEditorType.AutoComplete) return;
    abortRef.current?.abort();
    setLoading(false);
    setError(null);
    setResults([]);
  }, [searchFiltersKey, editorType]);
  const valueFilters = lookupValue ? filtersFor(lookupValue.tableName) : void 0;
  const valueFiltersKey = valueFilters ? lookupFiltersKey(valueFilters) : void 0;
  const recordKey = record ? `${record.tableName}:${getRecordReferenceId(record) ?? ""}` : void 0;
  const filterReadRef = useRef(null);
  const latestRef = useRef({ hasChanges: false, valueId: lookupValue?.id, setLookupValue });
  latestRef.current = { hasChanges: dirtyColumns.size > 0, valueId: lookupValue?.id, setLookupValue };
  useEffect(() => {
    const previous = filterReadRef.current;
    const valueId = lookupValue?.id;
    filterReadRef.current = { recordKey, valueId, key: valueFiltersKey };
    if (!previous || previous.recordKey !== recordKey || previous.valueId !== valueId || previous.key === valueFiltersKey) {
      return;
    }
    if (!lookupValue || !valueFilters?.length || !clearValueOutsideFilter || resolvedReadOnly || resolvedDisabled || !targetTables.includes(lookupValue.tableName)) {
      return;
    }
    const controller = new AbortController();
    const value2 = lookupValue;
    void (async () => {
      try {
        const [meta, views] = await Promise.all([
          tableMetadataCache.getAsync(value2.tableName),
          viewsForTableCache.getAsync(value2.tableName)
        ]);
        if (!meta || controller.signal.aborted) return;
        const view = resolveLookupView(views, defaultViewId);
        const response = await ppp.searchLookupAsync(
          {
            tableName: value2.tableName,
            ...view && { viewId: view.id },
            maxRecords: 1,
            filters: [
              ...valueFilters,
              {
                $type: "FetchXmlFilter",
                filterXml: `<filter><condition attribute="${meta.primaryIdColumn}" operator="eq" value="${value2.id}" /></filter>`
              }
            ]
          },
          controller.signal
        );
        const latest = latestRef.current;
        if (!controller.signal.aborted && !response.tableRecords.some((x) => x.id === value2.id) && latest.hasChanges && latest.valueId === value2.id) {
          latest.setLookupValue(null);
        }
      } catch {
      }
    })();
    return () => controller.abort();
  }, [recordKey, lookupValue?.id, valueFiltersKey]);
  const radioGroupClassName = useRadioGroupClassName(
    radioButtonOrientation === ChoiceOrientation.Horizontal,
    wrapRadioButtons
  );
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "string",
      required: resolvedRequired,
      label: resolvedLabel,
      value: lookupValue?.id ?? null
    },
    validate
  );
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  const recordPages = useRecordPages({ enabled: resolvedReadOnly && !resolvedDisabled && showRecordLinks });
  const recordPage = showRecordLinks && lookupValue?.id && hasSavedId({ id: lookupValue.id }) ? findRecordPage(recordPages, lookupValue.tableName) : void 0;
  const recordPageHref = recordPage && lookupValue?.id ? recordPageUrl(recordPage, lookupValue.id) : void 0;
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const readOnlyView = resolvedReadOnly && !resolvedDisabled;
  const onPickRecord = (pickedId) => {
    if (!pickedId) {
      setLookupValue(null);
      return;
    }
    const picked = results.find((r) => r.id === pickedId);
    if (picked) {
      setLookupValue({
        id: picked.id,
        name: picked.name,
        tableName: picked.tableName
      });
    }
  };
  const [dialogHidden, setDialogHidden] = useState(true);
  const [dialogSearchText, setDialogSearchText] = useState("");
  const [dialogTableFilters, setDialogTableFilters] = useState({});
  const dialogTitle = useMemo(
    () => t("app.messages.select-lookup-value", [resolvedLabel]),
    [t, resolvedLabel]
  );
  const onAdvancedSearchClicked = () => {
    setDialogSearchText(query?.trim() ?? "");
    setDialogTableFilters(Object.fromEntries(targetTables.map((table) => [table, filtersFor(table)])));
    setComboboxOpen(false);
    setQuery(null);
    setDialogHidden(false);
  };
  const onDialogActionClicked = async (records) => {
    if (records.length !== 1) {
      setDialogHidden(true);
      return;
    }
    const record2 = records[0];
    if (!record2.id || !targetTables.includes(record2.tableName)) {
      setDialogHidden(true);
      return;
    }
    let nameColumn = record2.tableName === effectiveTargetTable ? primaryNameColumn : void 0;
    if (!nameColumn) {
      try {
        const meta = await tableMetadataCache.getAsync(record2.tableName);
        nameColumn = meta?.primaryNameColumn;
      } catch {
      }
    }
    const name = nameColumn ? resolveColumnDisplayValue(record2, nameColumn) : null;
    setLookupValue({
      id: record2.id,
      name: name ?? "",
      tableName: record2.tableName
    });
    if (record2.tableName !== effectiveTargetTable && targetTables.includes(record2.tableName)) {
      setSelectedTargetTable(record2.tableName);
    }
    setDialogHidden(true);
  };
  const onTargetTableChange = (next) => {
    if (next === effectiveTargetTable) return;
    setSelectedTargetTable(next);
    setResults([]);
    setError(null);
    setQuery(query ?? "");
    setComboboxOpen(true);
  };
  let control;
  if (readOnlyView && editorType !== LookupEditorType.RadioButtons) {
    control = /* @__PURE__ */ jsx(ReadOnlyValue, { ...id !== void 0 && { id }, "aria-label": resolvedLabel, children: recordPageHref !== void 0 ? /* @__PURE__ */ jsx(RecordLink, { href: recordPageHref, onNavigate, children: lookupValue?.name ?? "" }) : lookupValue?.name ?? "" });
  } else if (editorType === LookupEditorType.RadioButtons) {
    control = renderRadioGroup({
      id,
      className,
      style,
      lookupValue,
      results,
      loading,
      error,
      displayNullChoice,
      radioButtonOrientation,
      disabled: resolvedDisabled,
      readOnly: readOnlyView,
      resolvedRequired,
      onPick: onPickRecord,
      t,
      styles,
      radioGroupClassName
    });
  } else if (editorType === LookupEditorType.Dropdown) {
    control = renderDropdown({
      id,
      className,
      style,
      lookupValue,
      results,
      loading,
      error,
      disabled: resolvedDisabled,
      placeholder,
      popupMaxHeight,
      popupMinHeight,
      viewColumnNames,
      viewColumnMetadata,
      onPick: onPickRecord,
      styles,
      t
    });
  } else {
    control = renderAutoComplete({
      id,
      className,
      style,
      lookupValue,
      results,
      loading,
      error,
      disabled: resolvedDisabled,
      placeholder,
      popupMaxHeight,
      popupMinHeight,
      query,
      setQuery,
      open: comboboxOpen,
      setOpen: setComboboxOpen,
      onPick: onPickRecord,
      // Target picker is part of the AutoComplete row — pass everything it
      // needs to render and route changes back.
      isPolymorphic,
      targetTables,
      effectiveTargetTable,
      onTargetTableChange,
      // Multi-column option template inputs — view-loaded column list +
      // type-metadata map for display-value resolution.
      viewColumnNames,
      viewColumnMetadata,
      onAdvancedSearchClicked,
      t,
      styles
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Field,
      {
        className: mergeClasses("ppp-lookup-edit", layoutClassName, stateClassName),
        label: labelSlot,
        hint: fieldHint,
        required: resolvedRequired,
        ...fieldValidationProps,
        children: control
      }
    ),
    editorType === LookupEditorType.AutoComplete && targetTables.length > 0 && /* @__PURE__ */ jsx(
      LookupDialog,
      {
        hidden: dialogHidden,
        onHiddenChange: setDialogHidden,
        title: dialogTitle,
        tableNames: targetTables,
        ...effectiveTargetTable !== void 0 && { defaultTable: effectiveTargetTable },
        selectionMode: "single",
        ...viewIds !== void 0 && { viewIds },
        tableFilters: dialogTableFilters,
        ...dialogSearchText && { initialSearchText: dialogSearchText },
        actionLabel: t("app.buttons.select.label"),
        onActionClicked: onDialogActionClicked
      }
    )
  ] });
}
function renderAutoComplete(input) {
  const {
    id,
    className,
    style,
    lookupValue,
    results,
    loading,
    error,
    disabled,
    placeholder,
    popupMaxHeight,
    popupMinHeight,
    query,
    setQuery,
    open,
    setOpen,
    onPick,
    isPolymorphic,
    targetTables,
    effectiveTargetTable,
    onTargetTableChange,
    viewColumnNames,
    viewColumnMetadata,
    onAdvancedSearchClicked,
    t,
    styles
  } = input;
  const displayValue = query !== null ? query : lookupValue?.name ?? "";
  const selectedOptions = lookupValue?.id ? [lookupValue.id] : [];
  return /* @__PURE__ */ jsxs(
    Combobox,
    {
      id,
      className,
      style,
      clearable: true,
      ...placeholder !== void 0 && { placeholder },
      value: displayValue,
      selectedOptions,
      disabled,
      open,
      expandIcon: /* @__PURE__ */ jsx(Search20Regular, {}),
      positioning: {
        position: "below",
        align: "start",
        useTransform: !isPolymorphic
      },
      listbox: {
        className: styles.listbox,
        style: { maxHeight: popupMaxHeight, minHeight: popupMinHeight }
      },
      onChange: (e) => {
        setQuery(e.target.value);
      },
      onOpenChange: (_, data) => {
        setOpen(data.open);
        if (data.open && query === null) {
          if (lookupValue === void 0) {
            setQuery("");
          }
        } else if (!data.open) {
          setQuery(null);
        }
      },
      onOptionSelect: (_, data) => {
        if (data.optionValue && targetTables.includes(data.optionValue)) {
          return;
        }
        onPick(data.optionValue ?? null);
        setQuery(null);
      },
      children: [
        isPolymorphic && effectiveTargetTable && /* @__PURE__ */ jsxs(
          "div",
          {
            className: styles.targetPickerHeader,
            onMouseDown: (e) => e.preventDefault(),
            children: [
              /* @__PURE__ */ jsx("span", { className: styles.targetPickerLabel, children: tTargetPickerLabel(t) }),
              /* @__PURE__ */ jsx(
                Dropdown,
                {
                  size: "small",
                  inlinePopup: true,
                  positioning: { strategy: "fixed" },
                  className: styles.targetPickerControl,
                  selectedOptions: [effectiveTargetTable],
                  value: tableLabel(t, effectiveTargetTable),
                  onOptionSelect: (event, data) => {
                    event.stopPropagation();
                    if (data.optionValue) onTargetTableChange(data.optionValue);
                  },
                  onOpenChange: (event) => {
                    event.stopPropagation();
                  },
                  children: targetTables.map((name) => /* @__PURE__ */ jsx(Option, { value: name, text: tableLabel(t, name), children: tableLabel(t, name) }, name))
                }
              )
            ]
          }
        ),
        renderListboxContents({
          loading,
          error,
          results,
          lookupValue,
          viewColumnNames,
          viewColumnMetadata,
          // Highlight what the user typed. `query` is null when the popup
          // just opened with no query — the highlighter treats null as "no
          // highlight" so the initial top-N list renders plain.
          searchText: query,
          styles,
          t
        }),
        targetTables.length > 0 && /* @__PURE__ */ jsx(
          "div",
          {
            className: styles.advancedSearchFooter,
            onMouseDown: (e) => e.preventDefault(),
            children: /* @__PURE__ */ jsx(
              Button,
              {
                size: "small",
                icon: /* @__PURE__ */ jsx(Search20Regular, {}),
                onClick: onAdvancedSearchClicked,
                children: t("app.buttons.advanced-search.label")
              }
            )
          }
        )
      ]
    }
  );
}
function renderDropdown(input) {
  const {
    id,
    className,
    style,
    lookupValue,
    results,
    loading,
    error,
    disabled,
    placeholder,
    popupMaxHeight,
    popupMinHeight,
    viewColumnNames,
    viewColumnMetadata,
    onPick,
    styles,
    t
  } = input;
  const selectedOptions = lookupValue?.id ? [lookupValue.id] : [];
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      id,
      className,
      style,
      clearable: true,
      ...placeholder !== void 0 && { placeholder },
      value: lookupValue?.name ?? "",
      selectedOptions,
      disabled,
      expandIcon: /* @__PURE__ */ jsx(Search20Regular, {}),
      positioning: {
        position: "below",
        align: "start"
      },
      listbox: {
        className: styles.listbox,
        style: { maxHeight: popupMaxHeight, minHeight: popupMinHeight }
      },
      onOptionSelect: (_, data) => {
        onPick(data.optionValue ?? null);
      },
      children: renderListboxContents({
        loading,
        error,
        results,
        lookupValue,
        viewColumnNames,
        viewColumnMetadata,
        // Dropdown mode has no typed query, so nothing to highlight.
        searchText: null,
        styles,
        t
      })
    }
  );
}
function renderRadioGroup(input) {
  const {
    id,
    className,
    style,
    lookupValue,
    results,
    loading,
    error,
    displayNullChoice,
    radioButtonOrientation,
    disabled,
    readOnly,
    resolvedRequired,
    onPick,
    t,
    styles,
    radioGroupClassName
  } = input;
  const groupValue = lookupValue?.id ?? (displayNullChoice ? NULL_CHOICE_VALUE : "");
  return /* @__PURE__ */ jsxs("div", { className, style, children: [
    loading && /* @__PURE__ */ jsxs("div", { className: styles.loadingOption, children: [
      /* @__PURE__ */ jsx(Spinner, { size: "extra-tiny" }),
      /* @__PURE__ */ jsx("span", { className: styles.statusOption, children: t("app.components.lookup-edit.searching") })
    ] }),
    error && !loading && /* @__PURE__ */ jsx("div", { className: styles.statusOption, children: error }),
    /* @__PURE__ */ jsxs(
      RadioGroup,
      {
        id,
        className: radioGroupClassName,
        value: groupValue,
        layout: radioButtonOrientation === ChoiceOrientation.Horizontal ? "horizontal" : "vertical",
        disabled,
        required: resolvedRequired,
        ...readOnly && { "aria-readonly": true },
        onChange: (_, data) => {
          if (data.value === NULL_CHOICE_VALUE) {
            onPick(null);
            return;
          }
          onPick(data.value);
        },
        children: [
          displayNullChoice && /* @__PURE__ */ jsx(
            Radio,
            {
              value: NULL_CHOICE_VALUE,
              label: tNullChoice(t)
            },
            NULL_CHOICE_VALUE
          ),
          results.map((r) => /* @__PURE__ */ jsx(
            Radio,
            {
              value: r.id,
              label: r.name || t("app.components.lookup-edit.unnamed-record")
            },
            r.id
          ))
        ]
      }
    )
  ] });
}
function renderListboxContents(input) {
  const {
    loading,
    error,
    results,
    lookupValue,
    viewColumnNames,
    viewColumnMetadata,
    searchText,
    styles,
    t
  } = input;
  const showCommittedAsFallback = lookupValue !== void 0 && !results.some((r) => r.id === lookupValue.id);
  const isMultiColumn = viewColumnNames.length > 1;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    loading && /* @__PURE__ */ jsx(
      Option,
      {
        value: "__loading__",
        text: t("app.components.lookup-edit.searching"),
        disabled: true,
        className: styles.statusOption,
        children: /* @__PURE__ */ jsxs("div", { className: styles.loadingOption, children: [
          /* @__PURE__ */ jsx(Spinner, { size: "extra-tiny" }),
          /* @__PURE__ */ jsx("span", { children: t("app.components.lookup-edit.searching") })
        ] })
      },
      "__loading__"
    ),
    error && !loading && /* @__PURE__ */ jsx(
      Option,
      {
        value: "__error__",
        text: error,
        disabled: true,
        className: styles.statusOption,
        children: error
      },
      "__error__"
    ),
    !loading && !error && results.length === 0 && // Two empty states: "Type to search…" when the popup is open
    // but the user hasn't typed anything yet (no search has run);
    // "No matches" when a search ran and returned zero rows. The
    // searchText prop is `null` only in the AutoComplete case where
    // the popup just opened over a committed value — we deliberately
    // skip the auto-browse search there so the existing entry stays
    // visible. See `onOpenChange` in `renderAutoComplete`.
    /* @__PURE__ */ jsx(
      Option,
      {
        value: "__empty__",
        text: searchText === null ? "Type to search\u2026" : "No matches",
        disabled: true,
        className: styles.statusOption,
        children: searchText === null ? "Type to search\u2026" : "No matches"
      },
      "__empty__"
    ),
    results.map(
      (r) => isMultiColumn ? /* @__PURE__ */ jsx(Option, { value: r.id, text: r.name, children: /* @__PURE__ */ jsx("div", { className: styles.optionStack, children: viewColumnNames.map((colName, i) => {
        const value2 = resolveColumnDisplayValue(
          r.record,
          colName,
          viewColumnMetadata.get(colName)
        );
        if (value2 === null || value2 === "") {
          if (i === 0) {
            return /* @__PURE__ */ jsx(
              "span",
              {
                className: `${styles.optionRowPrimary} ${styles.optionNull}`,
                children: "(no name)"
              },
              colName
            );
          }
          return null;
        }
        const rowClass = i === 0 ? styles.optionRowPrimary : styles.optionRowSecondary;
        return /* @__PURE__ */ jsx("span", { className: rowClass, children: /* @__PURE__ */ jsx(Highlighter, { text: value2, searchText }) }, colName);
      }) }) }, r.id) : (
        // Single-column path: keep the v0 layout (one line per option)
        // so the popup stays compact when there's no view to expand to.
        /* @__PURE__ */ jsx(Option, { value: r.id, text: r.name, children: r.name ? /* @__PURE__ */ jsx(Highlighter, { text: r.name, searchText }) : /* @__PURE__ */ jsx("span", { className: styles.statusOption, children: "(no name)" }) }, r.id)
      )
    ),
    showCommittedAsFallback && /* @__PURE__ */ jsx(
      Option,
      {
        value: lookupValue.id,
        text: lookupValue.name ?? "",
        style: { display: "none" },
        children: lookupValue.name ?? ""
      },
      lookupValue.id
    )
  ] });
}
function tableLabel(t, tableName) {
  const key3 = `tables.${tableName}.label`;
  const resolved = t(key3);
  return resolved === key3 ? tableName : resolved;
}
function tNullChoice(t) {
  return t("app.null-choice-label");
}
function tTargetPickerLabel(t) {
  const key3 = "app.messages.lookup-target-label";
  const resolved = t(key3);
  return resolved === key3 ? "Search:" : resolved;
}
function StatusReasonEdit({ allowStateChange = false, ...props }) {
  const { record, tableMetadata, setColumnValue } = useRecordContext();
  const t = useT();
  const states = useMemo(() => getStateColumn(tableMetadata, "state"), [tableMetadata]);
  const reasons = useMemo(() => getStateColumn(tableMetadata, "status")?.choices ?? [], [tableMetadata]);
  const heldState = states ? heldChoiceValue(record, states.columnName) : void 0;
  const heldReason = heldChoiceValue(record, props.columnName);
  const currentState = heldState ?? reasons.find((x) => x.value === heldReason)?.state ?? states?.choices[0]?.value ?? void 0;
  const mayChangeState = allowStateChange && (!states || !record || canWriteColumn(record, states.columnName));
  const offered = useMemo(
    () => mayChangeState || currentState === void 0 || currentState === null ? void 0 : reasons.filter((x) => x.state === currentState).map((x) => x.value),
    [mayChangeState, currentState, reasons]
  );
  const stateLabelOf = (reason) => {
    const state = reasons.find((x) => x.value === reason)?.state;
    const choice2 = states?.choices.find((x) => x.value === state);
    if (!states || !choice2) return void 0;
    return resolveChoiceLabel(
      t,
      tableMetadata?.tableName,
      states.columnName,
      states.choiceLogicalName,
      choice2.value,
      choice2.displayName
    );
  };
  const onReasonChange = (reason) => {
    if (!mayChangeState || reason === null || !states) return;
    const state = reasons.find((x) => x.value === reason)?.state;
    if (state !== void 0 && state !== null && state !== heldState) {
      setColumnValue(states.columnName, { $type: 11, value: state });
    }
  };
  return /* @__PURE__ */ jsx(
    ChoiceEdit,
    {
      ...props,
      ...offered !== void 0 && { validChoiceValues: offered },
      ...mayChangeState && { groupOf: stateLabelOf },
      onValueChange: onReasonChange
    }
  );
}
function StatusEdit(props) {
  const { tableMetadata, setColumnValue } = useRecordContext();
  const states = getStateColumn(tableMetadata, "state");
  const reasons = getStateColumn(tableMetadata, "status");
  const onStateChange = (state) => {
    if (state === null || !reasons) return;
    const reason = states?.choices.find((x) => x.value === state)?.defaultStatus;
    if (reason !== void 0 && reason !== null) setColumnValue(reasons.columnName, { $type: 11, value: reason });
  };
  return /* @__PURE__ */ jsx(ChoiceEdit, { ...props, onValueChange: onStateChange });
}

// src/edits/base/locked-number.ts
var ignoreLockedChange = () => void 0;
function lockedNumberText(value2, {
  format,
  locale,
  whole = false,
  precision
}) {
  if (value2 === null || value2 === void 0) return null;
  const given = format?.trim();
  if (given) return formatValue(typeof value2 === "bigint" ? Number(value2) : value2, given, locale);
  if (whole) {
    return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(
      typeof value2 === "bigint" ? value2 : Math.trunc(value2)
    );
  }
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: precision ?? 0,
    maximumFractionDigits: precision ?? 20
  }).format(value2);
}
var useMoneyEditStyles = makeStyles({
  // Currency-symbol start adornment. Reserves the same 20px footprint as
  // the fallback Money icon so single-glyph "$" and multi-character "CHF"
  // rows line their input start up consistently. Left-aligns the glyph
  // inside that box — centering left a visible gap to the left of narrow
  // symbols (the 20px box minus a ~6px "$") that didn't exist with the
  // original icon. `colorNeutralForeground2` matches the visual weight
  // Fluent's Input slots already render their icons at.
  currencySymbol: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-start",
    minWidth: "20px",
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    userSelect: "none"
  },
  // Spinner buttons (`contentAfter`). Same shape as NumberEdit's spinner
  // duplicated here rather than shared because MoneyEdit's makeStyles call
  // is already this file's; cross-file Griffel style import would double-
  // generate selectors.
  spinner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "center",
    height: "100%",
    rowGap: "1px"
  },
  spinnerButton: {
    minWidth: 0,
    width: "18px",
    height: "14px",
    padding: 0,
    borderRadius: tokens.borderRadiusSmall,
    color: tokens.colorNeutralForeground2,
    ":hover": {
      color: tokens.colorNeutralForeground1
    },
    ":disabled": {
      color: tokens.colorNeutralForegroundDisabled
    }
  }
});
function MoneyEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  min,
  max,
  precision,
  hideStep = false,
  format,
  step = 0.01,
  placeholder,
  validate
}) {
  const { value: value2, setValue: rawSetValue } = useMoneyColumn(columnName);
  const { record } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const { locale } = useLocale();
  const styles = useMoneyEditStyles();
  const t = useT();
  const limits = getNumberLimits(metadata);
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedMin = min ?? limits.min;
  const resolvedMax = max ?? limits.max;
  const resolvedPrecision = precision ?? limits.precision;
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "number",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value2 ?? null,
      ...resolvedMin !== void 0 && { min: resolvedMin },
      ...resolvedMax !== void 0 && { max: resolvedMax }
    },
    validate
  );
  const numericOptions = useMemo(
    () => ({
      decimalSeparator: ".",
      groupSeparator: ",",
      allowNegative: resolvedMin === void 0 || resolvedMin < 0,
      allowDecimal: true,
      maxDecimals: resolvedPrecision ?? 2
    }),
    [resolvedMin, resolvedPrecision]
  );
  const [isFocused, setIsFocused] = useState(false);
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  if (!isVisible) return null;
  const displayValue = value2 === void 0 || value2 === null ? null : !isFocused && resolvedPrecision !== void 0 ? value2.toFixed(resolvedPrecision) : String(value2);
  const isReadOnlyDisplay = resolvedReadOnly || resolvedDisabled;
  const handleValueChange = (raw) => {
    if (raw === null || raw === "" || raw === "-") {
      setValue(null);
      return;
    }
    const parsed = Number.parseFloat(raw);
    if (Number.isNaN(parsed)) return;
    const rounded = resolvedPrecision !== void 0 ? Number(parsed.toFixed(resolvedPrecision)) : parsed;
    setValue(rounded);
  };
  const readOnlyDisplayText = isReadOnlyDisplay ? lockedNumberText(value2, { format, locale, precision: resolvedPrecision ?? 2 }) : null;
  const textIncludesSymbol = /^c/i.test(format?.trim() ?? "");
  if (isReadOnlyDisplay && isFocused) setIsFocused(false);
  const currencySymbol = record?.currency?.symbol;
  const renderCurrencyAdornment = () => currencySymbol ? /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-money-edit-symbol", styles.currencySymbol), "aria-hidden": "true", children: currencySymbol }) : /* @__PURE__ */ jsx(Money20Regular, { "aria-hidden": "true" });
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const currentNumber = value2 === null || value2 === void 0 ? 0 : value2;
  const canIncrement = !resolvedReadOnly && !resolvedDisabled && (resolvedMax === void 0 || currentNumber < resolvedMax);
  const canDecrement = !resolvedReadOnly && !resolvedDisabled && (resolvedMin === void 0 || currentNumber > resolvedMin);
  const stepBy = useCallback(
    (direction) => {
      const base = value2 === null || value2 === void 0 ? 0 : value2;
      let next = base + step * direction;
      if (resolvedMin !== void 0) next = Math.max(next, resolvedMin);
      if (resolvedMax !== void 0) next = Math.min(next, resolvedMax);
      if (resolvedPrecision !== void 0) next = Number(next.toFixed(resolvedPrecision));
      setValue(next);
    },
    [value2, step, resolvedMin, resolvedMax, resolvedPrecision, setValue]
  );
  const repeatTimerRef = useRef(null);
  const repeatIntervalRef = useRef(null);
  const stopRepeat = useCallback(() => {
    if (repeatTimerRef.current !== null) {
      clearTimeout(repeatTimerRef.current);
      repeatTimerRef.current = null;
    }
    if (repeatIntervalRef.current !== null) {
      clearInterval(repeatIntervalRef.current);
      repeatIntervalRef.current = null;
    }
  }, []);
  const startRepeat = useCallback(
    (direction) => {
      stepBy(direction);
      stopRepeat();
      repeatTimerRef.current = setTimeout(() => {
        repeatIntervalRef.current = setInterval(() => stepBy(direction), 60);
      }, 400);
    },
    [stepBy, stopRepeat]
  );
  useEffect(() => stopRepeat, [stopRepeat]);
  const spinnerButtons = !hideStep ? /* @__PURE__ */ jsxs("div", { className: styles.spinner, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "transparent",
        className: styles.spinnerButton,
        icon: /* @__PURE__ */ jsx(ChevronUp12Regular, {}),
        "aria-hidden": true,
        tabIndex: -1,
        disabled: !canIncrement,
        onMouseDown: (e) => {
          e.preventDefault();
          startRepeat(1);
        },
        onMouseUp: stopRepeat,
        onMouseLeave: stopRepeat,
        onTouchStart: (e) => {
          e.preventDefault();
          startRepeat(1);
        },
        onTouchEnd: stopRepeat
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "transparent",
        className: styles.spinnerButton,
        icon: /* @__PURE__ */ jsx(ChevronDown12Regular, {}),
        "aria-hidden": true,
        tabIndex: -1,
        disabled: !canDecrement,
        onMouseDown: (e) => {
          e.preventDefault();
          startRepeat(-1);
        },
        onMouseUp: stopRepeat,
        onMouseLeave: stopRepeat,
        onTouchStart: (e) => {
          e.preventDefault();
          startRepeat(-1);
        },
        onTouchEnd: stopRepeat
      }
    )
  ] }) : null;
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-money-edit", layoutClassName, stateClassName),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: isReadOnlyDisplay ? (
        // Locked: the field the user would type in, read-only or disabled, as the other editors
        // show theirs — unmasked, holding the value formatted for display.
        /* @__PURE__ */ jsx(
          MaskedTextField,
          {
            id,
            className,
            style,
            ...!textIncludesSymbol && { contentBefore: renderCurrencyAdornment() },
            type: "text",
            value: readOnlyDisplayText,
            onValueChange: ignoreLockedChange,
            readOnly: resolvedReadOnly,
            disabled: resolvedDisabled,
            textAlign: "right"
          }
        )
      ) : /* @__PURE__ */ jsx(
        MaskedTextField,
        {
          id,
          className,
          style,
          contentBefore: renderCurrencyAdornment(),
          type: "text",
          inputMode: "decimal",
          value: displayValue,
          onValueChange: handleValueChange,
          placeholder,
          mode: MaskMode.Numeric,
          numeric: numericOptions,
          textAlign: "right",
          onFocus: () => setIsFocused(true),
          onBlur: () => setIsFocused(false),
          ...spinnerButtons !== null && { contentAfter: spinnerButtons }
        }
      )
    }
  );
}
var PRIMARY_EMAIL_COLUMNS = ["emailaddress1", "internalemailaddress", "emailaddress"];
function emailColumnOf(table) {
  const emails = (table.columns ?? []).filter((column) => {
    const meta = column;
    return meta.$type === ColumnType.String && meta.textFormat === TextFormat.Email && !!meta.columnName;
  }).map((column) => column.columnName);
  return PRIMARY_EMAIL_COLUMNS.find((name) => emails.includes(name)) ?? emails.sort()[0] ?? null;
}
var EMAIL_ADDRESS = /^[^\s@<>()[\],;:"]+@[^\s@<>()[\],;:"]+\.[^\s@<>()[\],;:"]+$/;
function isEmailAddress(text2) {
  return EMAIL_ADDRESS.test(text2.trim());
}
async function searchableTablesAsync(ppp, tableMetadata, targetTables) {
  const tables = await Promise.all(
    targetTables.map(async (tableName) => {
      try {
        const permissions = Number(await ppp.retrieveTablePermissionsAsync(tableName));
        if ((permissions & LINKABLE) !== LINKABLE) return null;
        const metadata = await tableMetadata.getAsync(tableName);
        const emailColumn = metadata ? emailColumnOf(metadata) : null;
        return metadata && emailColumn ? { tableName, primaryNameColumn: metadata.primaryNameColumn, emailColumn } : null;
      } catch {
        return null;
      }
    })
  );
  return tables.filter((table) => table !== null);
}
async function searchPartiesAsync(ppp, tables, searchText, maxRecords, signal, onRefused, filtersFor) {
  const found = await Promise.all(
    tables.map(async (table) => {
      const pageFilters = filtersFor ? filtersFor(table.tableName) : [];
      if (pageFilters === null) return [];
      const response = await ppp.searchLookupAsync(
        {
          tableName: table.tableName,
          searchText,
          maxRecords,
          filters: [
            {
              $type: "FetchXmlFilter",
              filterXml: `<filter><condition attribute="${table.emailColumn}" operator="not-null" /></filter>`
            },
            ...pageFilters
          ],
          additionalColumns: [table.emailColumn]
        },
        signal
      ).catch((error) => {
        if (error instanceof UnauthorizedAccessError) onRefused?.(table, pageFilters);
        return null;
      });
      if (!response) return [];
      return response.tableRecords.map((record) => {
        const name = record.properties?.[table.primaryNameColumn]?.value;
        const address = record.properties?.[table.emailColumn]?.value;
        return {
          party: { tableName: table.tableName, value: record.id ?? null, name: typeof name === "string" ? name : null },
          address: typeof address === "string" ? address : null
        };
      });
    })
  );
  return found.flat().sort((a, b) => (a.party?.name ?? "").localeCompare(b.party?.name ?? "")).slice(0, maxRecords);
}
function sameParty(a, b) {
  if (a.party?.value || b.party?.value)
    return !!a.party?.value && a.party.value === b.party?.value && a.party.tableName === b.party?.tableName;
  return !!a.address && a.address.toLowerCase() === b.address?.toLowerCase();
}
var useStyles17 = makeStyles({
  control: { minWidth: 0 },
  option: { display: "flex", flexDirection: "column", minWidth: 0 },
  address: { color: tokens.colorNeutralForeground3, fontSize: tokens.fontSizeBase200 },
  status: { padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`, color: tokens.colorNeutralForeground3 }
});
var SEARCH_DELAY_MS = 300;
var keyOf = (party) => party.party?.value ? `${party.party.tableName}:${party.party.value}` : `address:${(party.address ?? "").toLowerCase()}`;
var nameOf = (party) => party.party?.name || party.address || party.displayName || "";
function PartyListEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  validate,
  allowUnresolvedEmailAddresses,
  targetTables,
  maxSuggestions = 10,
  placeholder,
  filter,
  filterProvider
}) {
  const styles = useStyles17();
  const t = useT();
  const ctx = useRecordContext();
  const recordLocked = useRecordLocked();
  const { record } = ctx;
  const metadata = useColumnMetadata(columnName);
  const { ppp, tableMetadataCache } = usePowerPortalsPro();
  const organizationSettings = useOrganizationSettings();
  const allowAddresses = allowUnresolvedEmailAddresses ?? organizationSettings.data?.allowUnresolvedEmailAddresses ?? false;
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const parties = useMemo(() => readPartyList(record, columnName) ?? [], [record, columnName]);
  const rawSetValue = useCallback(
    (next) => ctx.setColumnValue(columnName, { $type: 10, value: next }),
    [ctx, columnName]
  );
  const setParties = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const columnTargets = metadata?.targetTables;
  const locked = resolvedReadOnly || resolvedDisabled;
  const tablesKey = locked ? "" : (targetTables ?? columnTargets ?? []).join(",");
  const [tables, setTables] = useState([]);
  const tablesPromise = useRef(Promise.resolve([]));
  useEffect(() => {
    let current = true;
    const names2 = tablesKey ? tablesKey.split(",") : [];
    const found = names2.length ? searchableTablesAsync(ppp, tableMetadataCache, names2) : Promise.resolve([]);
    tablesPromise.current = found;
    void found.then((searchable) => {
      if (current) setTables(searchable);
    });
    return () => {
      current = false;
    };
  }, [ppp, tableMetadataCache, tablesKey]);
  const refusedUnder = useRef(/* @__PURE__ */ new Map());
  const refuse = useCallback((refused, pageFilters) => {
    if (pageFilters.length > 0) {
      refusedUnder.current.set(refused.tableName, lookupFiltersKey(pageFilters));
      return;
    }
    tablesPromise.current = tablesPromise.current.then((all) => all.filter((x) => x !== refused));
    setTables((all) => all.filter((x) => x !== refused));
  }, []);
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [searchedFor, setSearchedFor] = useState("");
  const [searching, setSearching] = useState(false);
  const search = useRef(null);
  const filtersFor = useRef(() => []);
  filtersFor.current = (tableName) => {
    const filters = lookupFiltersFor(filter, filterProvider, record, tableName);
    return refusedUnder.current.get(tableName) === lookupFiltersKey(filters) ? null : filters;
  };
  useEffect(() => {
    search.current?.abort();
    const text2 = query.trim();
    if (!text2 || tables.length === 0) {
      setSuggestions([]);
      setSearching(false);
      return;
    }
    const controller = new AbortController();
    search.current = controller;
    setSearching(true);
    const wait = setTimeout(() => {
      searchPartiesAsync(ppp, tables, text2, maxSuggestions, controller.signal, refuse, (table) => filtersFor.current(table)).then((found) => {
        if (controller.signal.aborted) return;
        setSuggestions(found);
        setSearchedFor(text2);
      }).catch(() => {
        if (!controller.signal.aborted) setSuggestions([]);
      }).finally(() => {
        if (!controller.signal.aborted) setSearching(false);
      });
    }, SEARCH_DELAY_MS);
    return () => {
      clearTimeout(wait);
      controller.abort();
    };
  }, [query, tables, ppp, maxSuggestions, refuse]);
  const typedAddress = query.trim();
  const addressOption = allowAddresses && isEmailAddress(typedAddress) && !suggestions.some((s) => s.address?.toLowerCase() === typedAddress.toLowerCase()) && !parties.some((p) => p.address?.toLowerCase() === typedAddress.toLowerCase()) ? { party: null, address: typedAddress } : null;
  const options = [
    ...addressOption ? [addressOption] : [],
    ...suggestions.filter((s) => !parties.some((p) => sameParty(p, s)))
  ];
  const currentParties = useRef(parties);
  currentParties.current = parties;
  const rootRef = useRef(null);
  const setRoot = useCallback((element) => {
    rootRef.current = element;
  }, []);
  const add = (party) => {
    const now = currentParties.current;
    if (!now.some((p) => sameParty(p, party))) setParties([...now, party]);
    setQuery("");
  };
  const onKeyDown = (event) => {
    if (event.key !== "Enter" || !isEmailAddress(typedAddress)) return;
    const active = event.currentTarget.getAttribute("aria-activedescendant");
    if (active && event.currentTarget.ownerDocument.getElementById(active)?.textContent?.trim() !== typedAddress) return;
    event.preventDefault();
    const address = typedAddress;
    const hasAddress = (party) => party.address?.toLowerCase() === address.toLowerCase();
    void (async () => {
      const found = searchedFor === address ? suggestions.find(hasAddress) : (await searchPartiesAsync(ppp, await tablesPromise.current, address, maxSuggestions, void 0, refuse, (table) => filtersFor.current(table)).catch(() => [])).find(hasAddress);
      if (found) {
        const rest = currentParties.current.filter((p) => p.party || p.address?.toLowerCase() !== address.toLowerCase());
        setParties(rest.some((p) => sameParty(p, found)) ? rest : [...rest, found]);
        setQuery("");
      } else if (allowAddresses) add({ party: null, address });
    })();
  };
  const validationErrors = useColumnValidation(
    columnName,
    { kind: "array", required: resolvedRequired, label: resolvedLabel, value: parties },
    validate
  );
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  return /* @__PURE__ */ jsx(
    Field,
    {
      ref: setRoot,
      className: mergeClasses("ppp-party-list-edit", className),
      style,
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...buildFieldValidationProps(validationErrors, displayValidationErrorMessage),
      children: resolvedReadOnly && !resolvedDisabled ? /* @__PURE__ */ jsx(ReadOnlyValue, { ...id !== void 0 && { id }, ...resolvedLabel !== void 0 && { "aria-label": resolvedLabel }, children: parties.map(nameOf).join("; ") }) : /* @__PURE__ */ jsxs(
        TagPicker,
        {
          disabled: locked,
          open: open && query.trim() !== "",
          onOpenChange: (_, data) => setOpen(data.open),
          selectedOptions: parties.map(keyOf),
          positioning: { position: "below", align: "start" },
          onOptionSelect: (_, data) => {
            const chosen = new Set(data.selectedOptions);
            const kept = parties.filter((p) => chosen.has(keyOf(p)));
            const added = options.filter((o) => chosen.has(keyOf(o)) && !kept.some((p) => sameParty(p, o)));
            setParties([...kept, ...added]);
            setQuery("");
          },
          children: [
            /* @__PURE__ */ jsxs(TagPickerControl, { className: styles.control, children: [
              /* @__PURE__ */ jsx(TagPickerGroup, { children: parties.map((party) => /* @__PURE__ */ jsx(
                Tag,
                {
                  value: keyOf(party),
                  shape: "rounded",
                  "data-ppp-tooltip": party.address ?? void 0,
                  "aria-description": party.address ?? void 0,
                  dismissible: !locked,
                  dismissIcon: { "aria-label": t("app.buttons.remove.label") },
                  children: nameOf(party)
                },
                keyOf(party)
              )) }),
              /* @__PURE__ */ jsx(
                TagPickerInput,
                {
                  id,
                  "aria-label": resolvedLabel,
                  placeholder: parties.length === 0 ? placeholder : void 0,
                  value: query,
                  onChange: (e) => {
                    setQuery(e.target.value);
                    setOpen(true);
                  },
                  onKeyDown
                }
              ),
              /* @__PURE__ */ jsx(SharedTooltip, { containerRef: rootRef })
            ] }),
            /* @__PURE__ */ jsxs(TagPickerList, { children: [
              query.trim() !== "" && searching && options.length === 0 && /* @__PURE__ */ jsx("div", { className: styles.status, children: /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) }),
              query.trim() !== "" && !searching && options.length === 0 && /* @__PURE__ */ jsx("div", { className: styles.status, children: t("app.components.lookup-edit.no-matches") }),
              options.map((option) => /* @__PURE__ */ jsx(TagPickerOption, { value: keyOf(option), text: nameOf(option), children: /* @__PURE__ */ jsxs("div", { className: styles.option, children: [
                /* @__PURE__ */ jsx("span", { children: nameOf(option) }),
                option.party && option.address && /* @__PURE__ */ jsx("span", { className: styles.address, children: option.address })
              ] }) }, keyOf(option)))
            ] })
          ]
        }
      )
    }
  );
}
var useMultiSelectStyles = makeStyles({
  // Shared base for every orientation. `overflow: auto` (both axes, matching
  //) lets the box scroll naturally on
  // whichever axis genuinely overflows — no axis is force-`hidden`. The padding
  // is load-bearing, not cosmetic: Fluent v9's Checkbox draws its focus ring as
  // an absolutely-positioned `::after` inset by -2px (native outline disabled),
  // so a focused checkbox bleeds ~2px past its own box. The padding keeps that
  // ring inside the padding box so it never adds scrollable overflow (which
  // would otherwise flick a scrollbar / nudge content when you focus an option
  // at the edge).
  // NOTE: a column flex-wrap needs a DEFINITE height to wrap against. Give the
  // editor a fixed `height` (not `max-height`) when you want vertical wrapping
  // `max-height` lets the container collapse to its content, so it has no stable
  // height to wrap into columns against and the layout shifts as items change.
  container: {
    overflow: "auto",
    padding: tokens.spacingHorizontalXS
  },
  // Flex layout — column for vertical, row for horizontal. Gap matches Fluent's
  // standard small spacing so checkbox rows feel related without crowding.
  containerVertical: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXXS
  },
  // Vertical + wrap: stack checkboxes in a column, then flow into additional
  // columns once the (definite) height is reached.
  containerVerticalWrap: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    rowGap: tokens.spacingVerticalXXS,
    columnGap: tokens.spacingHorizontalM
  },
  containerHorizontal: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: tokens.spacingHorizontalM,
    // Keep each checkbox at its natural height. A row's default
    // `align-items: stretch` would stretch every checkbox to the container's
    // (fixed) height; the checkbox's indicator is `align-self: flex-start`
    // (top) while its label is `align-self: center`, so a stretched checkbox
    // splits them onto separate lines. `flex-start` keeps the row's items
    // their intrinsic height so indicator + label stay inline.
    alignItems: "flex-start"
  },
  containerHorizontalWrap: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    rowGap: tokens.spacingVerticalXXS,
    columnGap: tokens.spacingHorizontalM,
    // Same as the horizontal row above: don't vertically stretch the
    // checkboxes, or the indicator (top) and label (center) separate.
    alignItems: "flex-start"
  },
  // Keep each checkbox at its natural size. In the horizontal `nowrap` row,
  // Fluent's default `flex-shrink: 1` lets items compress below their content
  // width, which pushes each checkbox's absolutely-positioned hidden <input>
  // (it overlays the indicator at full row height) over the neighboring
  // option — so a click lands on the wrong checkbox. Pinning shrink to 0 keeps
  // the hit targets aligned; the container's `overflow-x: auto` handles the row
  // running wider than its box.
  checkbox: {
    flexShrink: 0
  }
});
function MultiSelectChoiceEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  validChoiceValues,
  invalidChoiceValues,
  sort = ChoiceValueSort.Default,
  invalidValueBehavior = ChoiceInvalidValueBehavior.Remove,
  checkboxOrientation = ChoiceOrientation.Vertical,
  wrapCheckboxes = true,
  minCount,
  maxCount,
  displayChoiceColors = false,
  validate
}) {
  const { value: value2, setValue: rawSetValue } = useMultiSelectChoiceColumn(columnName);
  const { record, tableMetadata } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const styles = useMultiSelectStyles();
  const t = useT();
  const generatedId = useId();
  const baseId = id ?? generatedId;
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const choiceMeta = useMemo(() => getChoiceMetadata(metadata), [metadata]);
  const tableName = tableMetadata?.tableName;
  const validKey = validChoiceValues ? JSON.stringify(validChoiceValues) : "";
  const invalidKey = invalidChoiceValues ? JSON.stringify(invalidChoiceValues) : "";
  const unoffered = useMemo(
    () => choiceMeta ? unofferedChoiceValues(choiceMeta, validChoiceValues, invalidChoiceValues) : void 0,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [choiceMeta, validKey, invalidKey]
  );
  const heldValues = useHeldChoices(unoffered?.notOffered, value2, record, columnName);
  const choices = useMemo(
    () => choiceMeta ? buildRenderableChoices(choiceMeta, tableName, columnName, {
      validChoiceValues,
      invalidChoiceValues,
      invalidValueBehavior,
      sort,
      t,
      heldValues
    }) : [],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [choiceMeta, tableName, columnName, validKey, invalidKey, invalidValueBehavior, sort, t, heldValues]
  );
  const selectedSet = useMemo(() => new Set(value2), [value2]);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "array",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value2,
      ...minCount !== void 0 && { minCount },
      ...maxCount !== void 0 && { maxCount }
    },
    validate
  );
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const containerClass = checkboxOrientation === ChoiceOrientation.Horizontal ? wrapCheckboxes ? styles.containerHorizontalWrap : styles.containerHorizontal : wrapCheckboxes ? styles.containerVerticalWrap : styles.containerVertical;
  const toggle = (optionValue, checked) => {
    if (checked && !selectedSet.has(optionValue)) {
      setValue([...value2, optionValue]);
    } else if (!checked && selectedSet.has(optionValue)) {
      setValue(value2.filter((v) => v !== optionValue));
    }
  };
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-multi-select-choice-edit", layoutClassName, stateClassName),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: /* @__PURE__ */ jsx("div", { id, className: mergeClasses(styles.container, containerClass, className), style, children: choices.map((c) => /* @__PURE__ */ jsx(
        Checkbox,
        {
          id: `${baseId}_${c.value}`,
          className: styles.checkbox,
          label: displayChoiceColors ? /* @__PURE__ */ jsx(ChoiceColorLabel, { text: c.text, color: c.color }) : c.text,
          required: false,
          checked: selectedSet.has(c.value),
          disabled: resolvedDisabled || c.disabled && !(c.held === true && selectedSet.has(c.value)),
          onChange: (_, data) => toggle(c.value, data.checked === true)
        },
        c.value
      )) })
    }
  );
}
var useNumberEditStyles = makeStyles({
  // Stack of two chevron buttons rendered in the input's `contentAfter` slot.
  // Mirrors markup — same compact dual-button
  // layout that aligns with the input's vertical center.
  spinner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "center",
    height: "100%",
    // Tighten the gap between up/down so the two buttons read as one control.
    rowGap: "1px"
  },
  spinnerButton: {
    // Compact buttons — same visual footprint as.
    // `minWidth: 0` overrides Fluent's default Button width so we can shrink
    // to the icon's natural size.
    minWidth: 0,
    width: "18px",
    height: "14px",
    padding: 0,
    borderRadius: tokens.borderRadiusSmall,
    // Lift the icon's stroke weight to match
    // default button color is too pale against the input chrome.
    color: tokens.colorNeutralForeground2,
    ":hover": {
      color: tokens.colorNeutralForeground1
    },
    ":disabled": {
      color: tokens.colorNeutralForegroundDisabled
    }
  }
});
function NumberEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  valueType,
  min,
  max,
  precision,
  hideStep = false,
  format,
  step = 1,
  placeholder,
  validate
}) {
  const { record } = useRecordContext();
  const recordLocked = useRecordLocked();
  const { locale } = useLocale();
  const metadata = useColumnMetadata(columnName);
  const resolvedValueType = valueType ?? resolveNumberValueType(metadata) ?? "int";
  const { value: value2, setValue: rawSetValue } = useNumberColumn(columnName, resolvedValueType);
  const styles = useNumberEditStyles();
  const t = useT();
  const limits = getNumberLimits(metadata);
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedMin = min ?? limits.min;
  const resolvedMax = max ?? limits.max;
  const resolvedPrecision = precision ?? limits.precision;
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "number",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value2 ?? null,
      ...resolvedMin !== void 0 && { min: resolvedMin },
      ...resolvedMax !== void 0 && { max: resolvedMax }
    },
    validate
  );
  const numericOptions = useMemo(
    () => ({
      decimalSeparator: ".",
      groupSeparator: ",",
      // Negatives are allowed unless the metadata pins min ≥ 0. When `min`
      // is undefined we err on the permissive side so int columns without
      // an explicit floor still accept e.g. `-100`.
      allowNegative: resolvedMin === void 0 || resolvedMin < 0,
      // `int` / `bigint` are whole numbers; everything else (decimal / double
      // / money) can carry a fractional portion.
      allowDecimal: resolvedValueType !== "int" && resolvedValueType !== "bigint",
      maxDecimals: resolvedPrecision ?? null
    }),
    [resolvedMin, resolvedValueType, resolvedPrecision]
  );
  const [isFocused, setIsFocused] = useState(false);
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  const stateClassName = useEditorStateClass(resolvedReadOnly, resolvedDisabled);
  if (!isVisible) return null;
  const formatForDisplay = (val) => {
    if (val === null || val === void 0) return null;
    const num = typeof val === "bigint" ? Number(val) : val;
    if (resolvedValueType === "int" || resolvedValueType === "bigint") {
      return String(Math.trunc(num));
    }
    if (!isFocused && resolvedPrecision !== void 0) {
      return num.toFixed(resolvedPrecision);
    }
    return String(num);
  };
  const displayValue = formatForDisplay(value2);
  const locked = resolvedReadOnly || resolvedDisabled;
  if (locked && isFocused) setIsFocused(false);
  const handleValueChange = (raw) => {
    if (raw === null || raw === "" || raw === "-") {
      setValue(null);
      return;
    }
    const parsed = resolvedValueType === "int" || resolvedValueType === "bigint" ? Number.parseInt(raw, 10) : Number.parseFloat(raw);
    if (Number.isNaN(parsed)) return;
    const rounded = resolvedPrecision !== void 0 ? Number(parsed.toFixed(resolvedPrecision)) : parsed;
    setValue(rounded);
  };
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const currentNumber = value2 === null || value2 === void 0 ? 0 : typeof value2 === "bigint" ? Number(value2) : value2;
  const canIncrement = !resolvedReadOnly && !resolvedDisabled && (resolvedMax === void 0 || currentNumber < resolvedMax);
  const canDecrement = !resolvedReadOnly && !resolvedDisabled && (resolvedMin === void 0 || currentNumber > resolvedMin);
  const stepBy = useCallback(
    (direction) => {
      const base = value2 === null || value2 === void 0 ? 0 : typeof value2 === "bigint" ? Number(value2) : value2;
      let next = base + step * direction;
      if (resolvedMin !== void 0) next = Math.max(next, resolvedMin);
      if (resolvedMax !== void 0) next = Math.min(next, resolvedMax);
      if (resolvedPrecision !== void 0) next = Number(next.toFixed(resolvedPrecision));
      if (resolvedValueType === "int" || resolvedValueType === "bigint") {
        next = Math.trunc(next);
      }
      setValue(next);
    },
    [value2, step, resolvedMin, resolvedMax, resolvedPrecision, resolvedValueType, setValue]
  );
  const repeatTimerRef = useRef(null);
  const repeatIntervalRef = useRef(null);
  const stopRepeat = useCallback(() => {
    if (repeatTimerRef.current !== null) {
      clearTimeout(repeatTimerRef.current);
      repeatTimerRef.current = null;
    }
    if (repeatIntervalRef.current !== null) {
      clearInterval(repeatIntervalRef.current);
      repeatIntervalRef.current = null;
    }
  }, []);
  const startRepeat = useCallback(
    (direction) => {
      stepBy(direction);
      stopRepeat();
      repeatTimerRef.current = setTimeout(() => {
        repeatIntervalRef.current = setInterval(() => stepBy(direction), 60);
      }, 400);
    },
    [stepBy, stopRepeat]
  );
  useEffect(() => stopRepeat, [stopRepeat]);
  const spinnerButtons = !hideStep ? /* @__PURE__ */ jsxs("div", { className: styles.spinner, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "transparent",
        className: styles.spinnerButton,
        icon: /* @__PURE__ */ jsx(ChevronUp12Regular, {}),
        "aria-hidden": true,
        tabIndex: -1,
        disabled: !canIncrement,
        onMouseDown: (e) => {
          e.preventDefault();
          startRepeat(1);
        },
        onMouseUp: stopRepeat,
        onMouseLeave: stopRepeat,
        onTouchStart: (e) => {
          e.preventDefault();
          startRepeat(1);
        },
        onTouchEnd: stopRepeat
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "transparent",
        className: styles.spinnerButton,
        icon: /* @__PURE__ */ jsx(ChevronDown12Regular, {}),
        "aria-hidden": true,
        tabIndex: -1,
        disabled: !canDecrement,
        onMouseDown: (e) => {
          e.preventDefault();
          startRepeat(-1);
        },
        onMouseUp: stopRepeat,
        onMouseLeave: stopRepeat,
        onTouchStart: (e) => {
          e.preventDefault();
          startRepeat(-1);
        },
        onTouchEnd: stopRepeat
      }
    )
  ] }) : null;
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-number-edit", layoutClassName, stateClassName),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: locked ? (
        // Locked: the field the user would type in, read-only or disabled, as the other editors
        // show theirs — unmasked, holding the value formatted for display.
        /* @__PURE__ */ jsx(
          MaskedTextField,
          {
            id,
            className,
            style,
            type: "text",
            value: lockedNumberText(value2, {
              format,
              locale,
              whole: resolvedValueType === "int" || resolvedValueType === "bigint",
              precision: resolvedPrecision
            }),
            onValueChange: ignoreLockedChange,
            readOnly: resolvedReadOnly,
            disabled: resolvedDisabled,
            textAlign: "right"
          }
        )
      ) : /* @__PURE__ */ jsx(
        MaskedTextField,
        {
          id,
          className,
          style,
          type: "text",
          inputMode: numericOptions.allowDecimal ? "decimal" : "numeric",
          value: displayValue,
          onValueChange: handleValueChange,
          placeholder,
          mode: MaskMode.Numeric,
          numeric: numericOptions,
          textAlign: "right",
          onFocus: () => setIsFocused(true),
          onBlur: () => setIsFocused(false),
          ...spinnerButtons !== null && { contentAfter: spinnerButtons }
        }
      )
    }
  );
}
function ColumnEdit({ targetTables, showRecordLinks, onNavigate, ...props }) {
  const metadata = useColumnMetadata(props.columnName);
  const record = useRecordContextOptional()?.record;
  const typeCode = metadata?.$type;
  if (record && !canReadColumn(record, props.columnName)) {
    return /* @__PURE__ */ jsx(ColumnDisplayValue, { ...props });
  }
  switch (typeCode) {
    case 0:
      return /* @__PURE__ */ jsx(BoolEdit, { ...props });
    case 2:
      return /* @__PURE__ */ jsx(DateTimeEdit, { ...props });
    case 3:
    case 4:
    case 5:
    case 18:
      return /* @__PURE__ */ jsx(NumberEdit, { ...props });
    case 6:
      return /* @__PURE__ */ jsx(
        LookupEdit,
        {
          ...props,
          ...targetTables && { targetTables },
          ...showRecordLinks !== void 0 && { showRecordLinks },
          ...onNavigate && { onNavigate }
        }
      );
    case 7:
      return isRichTextColumn(metadata) ? /* @__PURE__ */ jsx(RichEdit, { ...props }) : /* @__PURE__ */ jsx(MemoEdit, { ...props });
    case 8:
      return /* @__PURE__ */ jsx(MoneyEdit, { ...props });
    case 10:
      return /* @__PURE__ */ jsx(PartyListEdit, { ...props, targetTables });
    case 11:
      return /* @__PURE__ */ jsx(ChoiceEdit, { ...props });
    case 12:
      return /* @__PURE__ */ jsx(StatusEdit, { ...props });
    case 13:
      return /* @__PURE__ */ jsx(StatusReasonEdit, { ...props });
    case 14:
      return /* @__PURE__ */ jsx(TextEdit, { ...props });
    case 40:
      return /* @__PURE__ */ jsx(MultiSelectChoiceEdit, { ...props });
    case 41:
      return /* @__PURE__ */ jsx(FileEdit, { ...props });
    case 42:
      return /* @__PURE__ */ jsx(ImageEdit, { ...props });
    default:
      return null;
  }
}
function getEditComponentForType(typeCode, metadata) {
  switch (typeCode) {
    case 0:
      return BoolEdit;
    case 2:
      return DateTimeEdit;
    case 3:
    case 4:
    case 5:
    case 18:
      return NumberEdit;
    case 6:
      return LookupEdit;
    case 7:
      return isRichTextColumn(metadata) ? RichEdit : MemoEdit;
    case 8:
      return MoneyEdit;
    case 10:
      return PartyListEdit;
    case 11:
      return ChoiceEdit;
    case 12:
      return StatusEdit;
    case 13:
      return StatusReasonEdit;
    case 14:
      return TextEdit;
    case 40:
      return MultiSelectChoiceEdit;
    case 41:
      return FileEdit;
    case 42:
      return ImageEdit;
    default:
      return null;
  }
}
function getEditComponentForMetadata(metadata) {
  const typeCode = metadata?.$type;
  return getEditComponentForType(typeCode, metadata);
}
function isRichTextColumn(metadata) {
  return metadata?.format === MemoFormat.RichText;
}
var GRID_COLUMN_MARKER = /* @__PURE__ */ Symbol.for("@powerportalspro/grid-column");
var GRID_COLUMNS_MARKER = /* @__PURE__ */ Symbol.for("@powerportalspro/grid-columns");
var GRID_TEMPLATE_COLUMN_MARKER = /* @__PURE__ */ Symbol.for(
  "@powerportalspro/grid-template-column"
);
var GRID_RELATED_RECORDS_COLUMN_MARKER = /* @__PURE__ */ Symbol.for(
  "@powerportalspro/grid-related-records-column"
);
function GridTemplateColumn(_props) {
  return null;
}
GridTemplateColumn[GRID_TEMPLATE_COLUMN_MARKER] = true;
function GridRelatedRecordsColumn(_props) {
  return null;
}
GridRelatedRecordsColumn[GRID_RELATED_RECORDS_COLUMN_MARKER] = true;
function GridColumn(_props) {
  return null;
}
GridColumn[GRID_COLUMN_MARKER] = true;
function GridColumns(_props) {
  return null;
}
GridColumns[GRID_COLUMNS_MARKER] = true;
function isGridColumnElement(node) {
  if (!isValidElement(node)) return false;
  const type = node.type;
  return !!type && type[GRID_COLUMN_MARKER] === true;
}
function isGridColumnsElement(node) {
  if (!isValidElement(node)) return false;
  const type = node.type;
  return !!type && type[GRID_COLUMNS_MARKER] === true;
}
function isGridTemplateColumnElement(node) {
  if (!isValidElement(node)) return false;
  const type = node.type;
  return !!type && type[GRID_TEMPLATE_COLUMN_MARKER] === true;
}
function isGridRelatedRecordsColumnElement(node) {
  if (!isValidElement(node)) return false;
  const type = node.type;
  return !!type && type[GRID_RELATED_RECORDS_COLUMN_MARKER] === true;
}
function extractGridColumnOverrides(children) {
  const declared = [];
  const templates = [];
  const related = [];
  const ordered = [];
  const toolbarParts = [];
  let templateIndex = 0;
  function pushTemplate(props) {
    const withId = {
      ...props,
      id: props.id ?? `__template-${templateIndex}`
    };
    templates.push(withId);
    ordered.push({ kind: "template", props: withId });
    templateIndex += 1;
  }
  function pushColumn(props) {
    declared.push(props);
    ordered.push({ kind: "column", props });
  }
  function pushRelated(props) {
    const columnKey = relatedRecordsKey(props.relationshipName, props.selfReferencingRole);
    const sameKey = related.filter((r) => r.columnKey === columnKey).length;
    const withKey = {
      ...props,
      columnKey,
      columnId: sameKey === 0 ? columnKey : `${columnKey}#${sameKey + 1}`
    };
    related.push(withKey);
    ordered.push({ kind: "related", props: withKey });
  }
  Children.forEach(children, (child) => {
    if (isGridColumnElement(child)) {
      pushColumn(child.props);
      return;
    }
    if (isGridTemplateColumnElement(child)) {
      pushTemplate(child.props);
      return;
    }
    if (isGridRelatedRecordsColumnElement(child)) {
      pushRelated(child.props);
      return;
    }
    if (isGridColumnsElement(child)) {
      Children.forEach(child.props.children, (nested) => {
        if (isGridColumnElement(nested)) {
          pushColumn(nested.props);
        } else if (isGridTemplateColumnElement(nested)) {
          pushTemplate(nested.props);
        } else if (isGridRelatedRecordsColumnElement(nested)) {
          pushRelated(nested.props);
        }
      });
      return;
    }
    toolbarParts.push(child);
  });
  return {
    declaredColumns: declared,
    templateColumns: templates,
    relatedColumns: related,
    orderedDeclarations: ordered,
    toolbarChildren: toolbarParts.length === 0 ? null : toolbarParts
  };
}
var GridToolbarOverflowId = {
  Actions: "grid-actions",
  Search: "grid-search",
  Near: "grid-near",
  Layout: "grid-layout",
  Filter: "grid-filter",
  Totals: "grid-totals",
  Print: "grid-print",
  Refresh: "grid-refresh",
  Settings: "grid-settings"
};
var PINNED_PRIORITY = 1;
function GridToolbarOverflowMenu({
  children,
  ariaLabel
}) {
  const { ref, overflowCount, isOverflowing } = useOverflowMenu();
  if (!isOverflowing) return null;
  return /* @__PURE__ */ jsxs(Menu, { hasIcons: true, children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        ref,
        className: "ppp-grid-toolbar-overflow",
        appearance: "subtle",
        icon: /* @__PURE__ */ jsx(MoreHorizontal20Regular, {}),
        "aria-label": `${ariaLabel} (${overflowCount})`,
        "data-ppp-tooltip": ariaLabel
      }
    ) }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children }) })
  ] });
}
function OverflowMenuItem({
  itemId,
  children
}) {
  const isVisible = useIsOverflowItemVisible(itemId);
  if (isVisible) return null;
  return /* @__PURE__ */ jsx(Fragment, { children });
}
var PPP_FOOTER_CLASS = "ppp-footer";
var useFooterStyles = makeStyles({
  // Single source of truth for the framework's footer-band visual
  // treatment. Mirrors token-for-token
  // any change here propagates to every consumer (Section footer
  // bands, future grid footers, standalone usage).
  // Token mapping:
  // --neutral-foreground-rest → tokens.colorNeutralForeground1
  // --neutral-layer-2 → tokens.colorNeutralBackground2
  // --neutral-stroke-rest → tokens.colorNeutralStroke1
  // --control-corner-radius → tokens.borderRadiusMedium
  // 2*--design-unit (8px) → tokens.spacingVerticalS
  // 3*--design-unit (12px) → tokens.spacingHorizontalM
  root: {
    width: "100%",
    boxSizing: "border-box",
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    color: tokens.colorNeutralForeground1,
    backgroundColor: tokens.colorNeutralBackground2,
    borderTop: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderBottomLeftRadius: tokens.borderRadiusMedium,
    borderBottomRightRadius: tokens.borderRadiusMedium,
    // keeps the footer
    // flush against whatever sits above (typically a section body).
    marginTop: 0
  }
});
function Footer({ children, className, style, ...rest }) {
  const styles = useFooterStyles();
  return /* @__PURE__ */ jsx(
    "footer",
    {
      ...rest,
      className: mergeClasses(styles.root, PPP_FOOTER_CLASS, className),
      style,
      children
    }
  );
}
var LEADING_COLUMN_WIDTH = 50;
var PINNED_BODY_CELL_CLASS = "ppp-grid-pinned-cell";
var useMainGridStyles = makeStyles({
  // Top-level grid layout:
  // ┌───────────────────────────────────────┐
  // │ toolbar (flex-shrink: 0, fixed top) │
  // ├───────────────────────────────────────┤
  // │ bodyArea (flex: 1, hosts scroll + │
  // │ refetch scrim; centers status │
  // │ messages when no rows) │
  // ├───────────────────────────────────────┤
  // │ paging (flex-shrink: 0, fixed bot.) │
  // └───────────────────────────────────────┘
  // Sizing is configured via {@link MainGridProps.minHeight} /
  // {@link MainGridProps.maxHeight} / {@link MainGridProps.fullSize},
  // / `MaxHeight` / `FullSize` parameters.
  // The base `wrapper` style has no flex sizing — the grid grows to fit
  // content between the configured min/max. The {@link wrapperFullSize}
  // variant adds `flex: 1` for the "fill the parent's height" case.
  wrapper: {
    width: "100%",
    // Mirrors `.ppp-section`'s defensive sizing: in a flex/grid parent the
    // default `min-width: auto` is content-based, which lets the inner
    // table's resized pixel width push the wrapper beyond its parent's
    // bounds. `min-width: 0` clamps it so the wrapper stays at 100% of
    // the parent and the inner `tableContainer`'s `overflow: auto`
    // engages — producing a horizontal scrollbar instead of escaping.
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    // Mirrors shell: thin neutral outline +
    // rounded corners around the whole grid. `overflow: hidden` clips
    // the rounded corners against children (toolbar tint, body cells)
    // so the corner radius reads cleanly; the inner `tableContainer`
    // owns its own scroll behavior so the clip doesn't fight scrolling.
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    overflow: "hidden"
    // No `position` here: the wrapper is rendered by the grid's `FluentOverlayTarget`, whose own
    // `position: relative` anchors the overlays that cover the whole grid — its loading overlay,
    // and a toolbar button's.
  },
  // Applied when `fullSize: true`. `flex: 1 1 auto` makes the grid take
  // the parent's available height (must be inside a flex column or
  // fixed-height container), and `min-height: 0` is the critical bit
  // letting the bodyArea's `overflow: auto` actually clip — without it
  // flex children's intrinsic min content size prevents overflow from
  // ever engaging. Min/max-height inline styles are skipped in this
  // mode.
  wrapperFullSize: {
    flex: "1 1 auto",
    minHeight: 0
  },
  // Drops the outer border + rounded corners when `borderVisible: false`.
  // Useful when an embedding card / panel already supplies framing — a
  // double border looks heavier than intended. The inner table's column
  // separators and bottom rules stay; only the wrapper's outer rectangle
  // is suppressed.
  wrapperBorderless: {
    border: "none",
    borderRadius: 0
  },
  // Middle stripe — fills the space between toolbar and paging row. When the
  // grid is loading or errored, the bodyArea hosts a status surface instead of
  // the scroll container.
  bodyArea: {
    position: "relative",
    flex: "1 1 auto",
    minHeight: 0,
    // Same reasoning as wrapper.minWidth: 0 — without this, a flex item's
    // `min-width: auto` resolves to content min-content, and the inner
    // table's pixel width would expand bodyArea past the wrapper, blocking
    // the horizontal scroll trick.
    minWidth: 0,
    display: "flex",
    flexDirection: "column"
  },
  // Top toolbar — view picker on the left, search box + button slot on
  // the right. Locked at the top of the grid (`flexShrink: 0`) so it
  // doesn't compress when the body area takes the available height.
  // Subtle neutral tint + bottom divider stroke. Uses
  // `colorNeutralBackground3` (≈ #f5f5f5 in light theme) rather than
  // `colorNeutralBackground2` — Background3 reads as a clearer toolbar
  // shade against the body's Background1.
  toolbar: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    backgroundColor: tokens.colorNeutralBackground3,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`
  },
  // The grouping strip's band continues the toolbar's, so the border goes under the strip.
  toolbarAboveGroupPanel: {
    borderBottomStyle: "none"
  },
  groupPanelBand: {
    flexShrink: 0,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    paddingBottom: tokens.spacingVerticalS,
    backgroundColor: tokens.colorNeutralBackground3,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`
  },
  viewPicker: {
    minWidth: "220px"
  },
  // The layout dropdown: wide enough for "Automatic" and its chevron.
  layoutPicker: {
    minWidth: "130px"
  },
  // Static title shown in the toolbar in place of the view-picker dropdown
  // when the grid is locked to a single view (or the consumer passed `title`
  // on a single-view table). Mirrors rendering.
  title: {
    fontWeight: tokens.fontWeightSemibold,
    paddingLeft: tokens.spacingHorizontalS
  },
  // Flex container for the toolbar's overflow-aware right cluster. The
  // `<Overflow>` measures this against its own width; OverflowItems
  // inside register their widths via context and get hidden in priority
  // order when they don't all fit. `flex: 1` lets it expand to fill the
  // toolbar's available space (after the spacer); `min-width: 0` is the
  // critical bit that lets Overflow shrink the container — without it
  // flex children's intrinsic min-content prevents the measurement loop
  // from ever signaling overflow. `overflow: hidden` clips items mid-
  // hide-transition (the OverflowItem CSS toggles visibility rather
  // than display, so they occupy zero space but their bounding box can
  // briefly extend during the transition).
  toolbarOverflow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    justifyContent: "flex-end"
  },
  // Slot wrapper for the consumer's action-button cluster when it lives
  // inside an OverflowItem. Keeps the cluster's internal layout (gap +
  // alignment) intact even though the surrounding `<GridToolbarItems>` div
  // is also a flex container — the OverflowItem treats this whole slot
  // as a single unit for overflow measurement.
  toolbarSlot: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS
  },
  // Plain `<div>` wrapper around each OverflowItem's content (refresh
  // button, settings popover, etc.). Necessary because OverflowItem's
  // ref-forwarding recursively unwraps FluentTrigger components
  // (Tooltip, Popover, MenuTrigger, etc.) until it lands on a non-
  // trigger element — and the `data-overflowing` attribute it toggles
  // for the hide-CSS rule lands on whatever the deepest unwrap is.
  // A plain div is NOT a trigger, so OverflowItem stops here, measures
  // this element's offsetWidth, and toggles `data-overflowing` here.
  // Fluent's `[overflowingItems] [data-overflowing] { display: none }`
  // then collapses the whole wrapper (including its complex Fluent
  // child) cleanly. Display: contents would also work conceptually but
  // breaks ResizeObserver measurement.
  toolbarItemWrapper: {
    display: "flex",
    alignItems: "center"
  },
  // Same pattern as `toolbarItemWrapper` but specifically for the
  // SearchBox, so the OverflowItem measures the wrapper instead of
  // recursively unwrapping into the Tooltip → SearchBox tree. Inherits
  // flex display so the SearchBox's natural minWidth shapes the
  // wrapper width.
  searchBoxWrapper: {
    display: "flex",
    alignItems: "center"
  },
  // Wrapper for a non-MenuItem control rendered inside the overflow
  // menu (search box, settings switch, action buttons cluster). Gives
  // the row consistent padding so it looks at home next to plain
  // MenuItems. `width: 100%` ensures the contained input / button bar
  // fills the menu's surface width.
  menuActionRow: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    width: "100%"
  },
  // SearchBox sized to fit comfortably inside the overflow menu's
  // surface — the inline toolbar SearchBox has its own `searchBox`
  // sizing that's tuned for the toolbar's narrow strip; the menu
  // version gets a wider min-width to feel like a proper search input
  // when surfaced from the "..." menu.
  menuSearchBox: {
    minWidth: "200px",
    width: "100%"
  },
  searchBox: {
    // Narrower than the original 240px so the SearchBox can shrink with
    // the toolbar before the Overflow algorithm hides it entirely. On
    // narrow viewports where 240px wouldn't fit, the SearchBox still
    // collapses into the overflow menu (where `menuSearchBox` gives it
    // the wider styling).
    minWidth: "160px"
  },
  // Horizontal flex container for the toolbar's action-button area.
  // Children sit at the right end of the toolbar after the search box,
  //. `flexShrink: 0` keeps the cluster
  // intact when the viewport narrows (the view picker / search box flex
  // first); the small gap matches Fluent's typical button-row spacing.
  buttonsBar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexShrink: 0,
    columnGap: tokens.spacingHorizontalXS
  },
  // Table itself. `border-collapse: separate` + per-row borders gives
  // Fluent's "cards stacked into a list" feel without doubled lines at
  // every cell intersection.
  // `tableLayout: 'fixed'` is required for the resize handles to feel
  // crisp: with `auto`, the browser fights user-set column widths
  // against content width and resize drags look laggy or unstable. With
  // `fixed`, each `<th>`'s `width` style is authoritative and body cells
  // simply ellipsis-overflow within it (already wired via
  // `bodyCell.maxWidth: 0`).
  // No `width: 100%` — that combined with `table-layout: fixed` causes
  // the browser to redistribute leftover space (container width minus
  // sum of declared column widths) proportionally across all columns,
  // INCLUDING the 50px-locked select column. Even `<col width="50px">`
  // and `max-width: 50px` on the cell aren't honored in that case
  // (long-standing Chromium quirk). Setting the table's width to the
  // exact total via inline style at render time eliminates the leftover
  // entirely, so the select column stays at exactly 50px. Tradeoff: a
  // grid narrower than its container leaves visible space on the right
  // instead of stretching.
  table: {
    borderCollapse: "separate",
    borderSpacing: 0,
    tableLayout: "fixed",
    // A page's own `table { margin-bottom: 1rem }` (Bootstrap's reboot, many site stylesheets)
    // would leave a strip under the last row, and under the totals row scrolled to the bottom.
    margin: 0
  },
  headerRow: {
    backgroundColor: tokens.colorNeutralBackground2
  },
  headerCell: {
    // `position: sticky` pins the header row to the top of the scroll
    // container (`tableContainer`) as the body scrolls beneath it.
    // Sticky must be on the `<th>` cells, not the `<thead>` / `<tr>`
    // Chrome / Safari don't honor sticky on table-row-group elements.
    position: "sticky",
    top: 0,
    // Above body cells, pinned ones (zIndex: 1) included, but below the
    // loading overlay (zIndex: 4) — so the overlay covers the header too
    // while still letting the resize handle inside the th catch pointer
    // events.
    zIndex: 2,
    // Background MUST live on the th itself, not just the parent <tr>.
    // When a child is `position: sticky`, the parent row's background
    // paints at the row's natural scroll position — not at the sticky
    // offset — so the cell becomes transparent and body rows scroll
    // through visibly underneath. Painting the background on the th
    // travels with the cell to its sticky position and occludes the
    // rows beneath cleanly.
    backgroundColor: tokens.colorNeutralBackground2,
    textAlign: "left",
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground2,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    // Use `box-shadow` instead of `border-bottom` for the divider: with
    // `position: sticky`, table cell borders don't render correctly
    // (they're collapsed away in some browsers, or attached to the
    // wrong row). An inset box-shadow at -1px draws an internal hairline
    // along the bottom edge that paints reliably across all browsers
    // regardless of the sticky positioning.
    // The offset is negated by calc(): a minus sign before var() isn't valid CSS, and drops the
    // whole shadow.
    boxShadow: `inset 0 calc(-1 * ${tokens.strokeWidthThin}) 0 ${tokens.colorNeutralStroke1}`,
    // Wrapping in the header keeps narrow columns from blowing out the
    // grid width when label text is long. Body cells handle their own
    // overflow per-renderer.
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  // Sortable headers — pointer cursor + hover background to advertise
  // clickability. Non-sortable headers (File/Image columns) inherit the
  // base headerCell style only.
  headerCellSortable: {
    cursor: "pointer",
    userSelect: "none",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground2Hover
    }
  },
  // Inner flex layout for sortable headers: label on the left, sort
  // indicator on the right. Stays a single row even when the label
  // ellipsis-truncates.
  headerCellInner: {
    display: "inline-flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    maxWidth: "100%"
  },
  // The header's label and sort indicator, then the column menu's chevron at the cell's end.
  headerCellContent: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXXS,
    minWidth: 0
  },
  headerCellInnerFill: {
    flex: "1 1 auto",
    minWidth: 0
  },
  headerCellLabel: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  // A header's tooltip: the column's name, over its description.
  headerTooltipTitle: {
    fontWeight: tokens.fontWeightSemibold
  },
  // A header label the user can drag onto the grouping strip. No cursor of its own: the header's
  // shows whether a click sorts it, and dragging is the lesser use of a header.
  headerCellGroupDrag: {},
  // Where a header dragged over another goes: before or after it, beside the header's own divider.
  headerCellDropBefore: {
    boxShadow: `inset 2px 0 0 ${tokens.colorBrandStroke1}, inset 0 calc(-1 * ${tokens.strokeWidthThin}) 0 ${tokens.colorNeutralStroke1}`
  },
  headerCellDropAfter: {
    boxShadow: `inset -2px 0 0 ${tokens.colorBrandStroke1}, inset 0 calc(-1 * ${tokens.strokeWidthThin}) 0 ${tokens.colorNeutralStroke1}`
  },
  sortIcon: {
    flex: "0 0 auto",
    color: tokens.colorNeutralForeground2
  },
  // A column the rows are filtered on, in the brand color the toolbar's Filter button takes while
  // the grid is filtered.
  headerFiltered: {
    flex: "0 0 auto",
    color: tokens.colorBrandForeground1
  },
  // Small numeric badge that shows the 1-based sort precedence when
  // multiple columns are active. Mirrors the position-indicator pattern
  // most data grids use (AG Grid, Material UI, etc.) — number alone is
  // enough, no need to ape Excel's "↑1" combined glyph.
  sortPosition: {
    flex: "0 0 auto",
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    minWidth: "12px",
    textAlign: "center"
  },
  // Resize handle — a narrow vertical strip on the right edge of each
  // header cell. Invisible by default so it doesn't clutter the chrome;
  // a subtle accent line appears on hover or while actively dragging.
  // `touchAction: 'none'` is required to keep mobile-Safari from
  // scrolling the page while the user drags.
  resizeHandle: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    width: "5px",
    cursor: "col-resize",
    userSelect: "none",
    touchAction: "none",
    backgroundColor: "transparent",
    transitionProperty: "background-color",
    transitionDuration: tokens.durationFaster,
    ":hover": {
      backgroundColor: tokens.colorBrandStroke1
    }
  },
  // Drag-in-progress — keep the indicator visible even after the cursor
  // leaves the strict 5px hit-zone (the OS continues sending mousemove
  // events to the original target until mouseup).
  resizeHandleActive: {
    backgroundColor: tokens.colorBrandStroke1
  },
  // Checkbox column — the column that holds row-selection toggles. Locked
  // to 50px with `width` + `min-width` + `max-width` all three together.
  // With `table-layout: fixed` and `width: 100%` on the table, declaring
  // only `width: 50px` isn't enough: when the sum of all column widths is
  // less than the table's rendered width, the browser distributes the
  // extra space across columns proportionally — including this one — and
  // the cell ends up rendering noticeably wider than 50px. `min-width` /
  // `max-width` clamp the cell so the proportional distribution can't
  // steal width into it; the slack lands on the data columns instead.
  selectCell: {
    width: `${LEADING_COLUMN_WIDTH}px`,
    minWidth: `${LEADING_COLUMN_WIDTH}px`,
    maxWidth: `${LEADING_COLUMN_WIDTH}px`,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalXS
  },
  // Pending-operation column. Same 50px clamp as `selectCell` — matches
  // the visual rhythm of the checkbox column to its left. Same
  // `table-layout: fixed` distribution caveat applies (the width triple
  // is what keeps the column from absorbing slack from the data
  // columns). Header is empty by design; the meaning lives in the per-
  // row icons.
  pendingCell: {
    width: `${LEADING_COLUMN_WIDTH}px`,
    minWidth: `${LEADING_COLUMN_WIDTH}px`,
    maxWidth: `${LEADING_COLUMN_WIDTH}px`,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    textAlign: "center"
  },
  // Operation icons. Brand-tinted to draw the eye but kept at icon-only
  // intensity — they're status indicators, not actions. `verticalAlign:
  // middle` aligns to the row's baseline rather than sitting on the
  // text descender line (which would push the icon below cell center).
  pendingIconCreate: {
    color: tokens.colorPaletteGreenForeground1,
    verticalAlign: "middle"
  },
  pendingIconUpdate: {
    color: tokens.colorBrandForeground1,
    verticalAlign: "middle"
  },
  // Toolbar pending-operation summary indicators (Plus/Pencil/Trash + a
  // count badge). Inline-flex so the icon and its badge stay tight; small
  // gap separates them without making the chip feel airy. Each indicator
  // is its own compact unit so multiple can sit side-by-side without
  // any custom spacing logic.
  pendingIndicator: {
    display: "inline-flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalXXS,
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS
  },
  // Row that's currently selected — accent-tinted background so it
  // stands out from hover. Same treatment Fluent's DataGrid uses.
  bodyRowSelected: {
    backgroundColor: tokens.colorNeutralBackground1Selected,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Selected
    },
    [`& > .${PINNED_BODY_CELL_CLASS}`]: {
      backgroundColor: tokens.colorNeutralBackground1Selected
    },
    // Replaces `bodyRow`'s hover rule for pinned cells, which would otherwise outrank the one above.
    [`:hover > .${PINNED_BODY_CELL_CLASS}`]: {
      backgroundColor: tokens.colorNeutralBackground1Selected
    }
  },
  // A pinned column's cells are shaded apart from the columns scrolling under them, as Fluent UI
  // Blazor shades them, until the row is hovered or selected. Same selectors as the selected row's,
  // so that one wins when both classes are merged.
  bodyRow: {
    backgroundColor: tokens.colorNeutralBackground1,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover
    },
    [`& > .${PINNED_BODY_CELL_CLASS}`]: {
      backgroundColor: tokens.colorNeutralBackground2
    },
    [`:hover > .${PINNED_BODY_CELL_CLASS}`]: {
      backgroundColor: tokens.colorNeutralBackground1Hover
    }
  },
  // Click-anywhere selection cursor feedback. Applied when
  // `selectFromEntireRow` is on so the user sees the row as a click target.
  // Interactive children (links, buttons) override this via their own
  // cursor in the cascade.
  bodyRowClickable: {
    cursor: "pointer"
  },
  // Applied when a shared `ViewDataSource.highlight` is set and the
  // row's column value doesn't match — drives the "highlight + dim"
  // chart cross-filter UX. The row data, selection, and pending
  // operations are unaffected; only visual opacity changes so the
  // user can see the full context with the matching subset
  // emphasized. Cleared by `setHighlight(undefined)` on the
  // datasource.
  bodyRowMuted: {
    opacity: 0.4
  },
  // The Map layout: the cards' list, one card wide and scrolling, beside the map, which takes the
  // rest. On a phone the map sits above the cards, which the page scrolls. As Blazor's
  // .ppp-grid-map-layout.
  mapLayout: {
    display: "grid",
    gridTemplateColumns: "minmax(260px, 1fr) minmax(0, 2fr)",
    height: "var(--ppp-grid-map-height, 560px)",
    "@media (max-width: 767.98px)": {
      gridTemplateColumns: "minmax(0, 1fr)",
      gridTemplateRows: "320px auto",
      height: "auto"
    }
  },
  mapCards: {
    minHeight: 0,
    overflowY: "auto",
    // Griffel takes a border's parts, not its shorthand.
    borderInlineEndWidth: tokens.strokeWidthThin,
    borderInlineEndStyle: "solid",
    borderInlineEndColor: tokens.colorNeutralStroke2,
    "@media (max-width: 767.98px)": {
      overflowY: "visible",
      borderInlineEndStyle: "none"
    }
  },
  mapPane: {
    position: "relative",
    minWidth: 0,
    minHeight: 0,
    "@media (max-width: 767.98px)": {
      gridRow: "1"
    }
  },
  // The map alone, with a message above it when there is one.
  mapOnly: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS,
    height: "var(--ppp-grid-map-height, 560px)"
  },
  mapOnlyPane: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "auto"
  },
  // Sentinel rendered after the last body row in virtualize mode.
  // IntersectionObserver watches this against the scroll container; when
  // it enters view, the next page loads. Height + padding give the
  // observer a reasonable target box; the centered spinner indicates
  // "loading the next page" without a layout shift on the rows above.
  loadMoreSentinel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    minHeight: "32px"
  },
  // The table's sentinel: a body row spanning every column, tall enough for the spinner, so the
  // rows don't shift as it comes and goes.
  loadMoreCell: {
    boxSizing: "border-box",
    height: "44px",
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    paddingLeft: 0,
    paddingRight: 0
  },
  // Centered in the visible width, not the table's: sticky at half the scroll viewport, pulled
  // back by half its own width, so a table wider than the grid still shows it.
  loadMoreSpinner: {
    position: "sticky",
    left: "50%",
    width: "fit-content",
    transform: "translateX(-50%)",
    display: "flex"
  },
  // Primary-name cell rendered as a clickable link — fires the grid's
  // registered edit handler. Mirrors:
  // accent foreground, no underline at rest, underline on hover/focus.
  // Inherits the surrounding cell's color when there's nothing to
  // navigate to (the cell falls back to plain text in that case, so
  // there's no styled-disabled state to worry about).
  primaryNameLink: {
    color: tokens.colorBrandForegroundLink,
    textDecorationLine: "none",
    cursor: "pointer",
    // The link wraps the cell's content even when that content is empty, which
    // leaves the cell holding an empty anchor: not `:empty` itself, so the rule
    // on `bodyCell` does not reach it, and no line box either. Same remedy, one
    // level down.
    ":empty::before": {
      content: '"\\00a0"'
    },
    ":hover": {
      color: tokens.colorBrandForegroundLinkHover,
      textDecorationLine: "underline"
    },
    ":focus-visible": {
      color: tokens.colorBrandForegroundLinkHover,
      textDecorationLine: "underline",
      outlineStyle: "none"
    }
  },
  // Subtle striping. Off by default in this v1 — toggle by setting a
  // `data-striped="true"` attribute on the wrapper in a future phase.
  bodyCell: {
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    borderBottomWidth: tokens.strokeWidthThin,
    borderBottomStyle: "solid",
    borderBottomColor: tokens.colorNeutralStroke2,
    verticalAlign: "middle",
    // Single-line cells with ellipsis. Wrapping rows would be a per-
    // column opt-in (e.g. Memo) handled by the cell renderer setting
    // its own `white-space: normal` on its content.
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 0,
    // A cell with nothing in it has no line box, so it is only as tall as its
    // padding — and every cell renderer returns `null` for an empty value.
    // One such cell is harmless, because its neighbors hold the row open; a
    // row where *every* column is empty collapses to a fraction of the height
    // of the rows around it.
    //
    // A non-breaking space restores the line box, at exactly the height a line
    // of text in this cell would take, so an empty row matches a populated one
    // without a pixel value to keep in step with the typography tokens. Only
    // `:empty` cells get it: a cell holding text or an editor is untouched.
    ":empty::before": {
      content: '"\\00a0"'
    }
  },
  // Inline-edit cell wrapper. Constrains the embedded editor to the
  // column's actual width — without this, Fluent v9's <Input> /
  // <Combobox> / <Dropdown> outer slots carry a default min-width
  // (~200px on `.fui-Input`, similar on the others) that overflows
  // narrow columns and visually leaks into the neighbor cell.
  // Fluent's atomic-CSS rules can land in either order vs ours, so
  // `!important` is the reliable way to win specificity against the
  // outer-slot rule. The descendant cascade (`& *`) covers Field,
  // Input wrapper, Combobox button, Dropdown trigger, etc. without
  // having to enumerate Fluent's per-component class names — the
  // worst that happens elsewhere is that an inner intentional
  // min-width inside a dropdown listbox flattens, which is harmless
  // because the listbox is portaled out of the cell anyway.
  inlineEditCell: {
    width: "100%",
    minWidth: 0,
    // Direct children get width: 100% too so the typed edit's
    // <Field> stretches to fill the cell instead of shrink-wrapping.
    "& > *": {
      width: "100%"
    },
    "& *": {
      minWidth: "0 !important"
    }
  },
  // Scroll container for the table. Fills the bodyArea (`flex: 1`) and
  // shows scrollbars on demand — `overflow: auto` triggers vertical
  // scrolling when rows overflow the height, horizontal scrolling when
  // user-resized columns push the table wider than the container. The
  // sticky `<thead>` cells stay locked at the top of THIS box (not the
  // viewport) while the body scrolls beneath them. `min-height: 0` is
  // again the critical bit for the flex-child overflow trick to work.
  tableContainer: {
    flex: "1 1 auto",
    minHeight: 0,
    // The element that actually owns the horizontal scrollbar — for that to
    // engage, the container must be ALLOWED to be narrower than the table
    // inside it. Without `min-width: 0`, `min-width: auto` resolves to the
    // table's pixel width as content min-content, the container grows to
    // match, and `overflow: auto` never triggers — the table just escapes
    // its ancestors instead.
    minWidth: 0,
    overflow: "auto"
  },
  // The loading overlay, over the whole grid — toolbar, rows and footer — while it loads or
  // refetches, as the Blazor grid's `OverlayWithProgress`: a theme-aware neutral tint
  // (`colorNeutralBackground2`) at 0.7 opacity, drawn by a `::before` pseudo-element so the
  // spinner above it stays at full opacity. `pointerEvents: 'auto'` keeps the grid's controls from
  // being used until the rows they'd act on have arrived. A child of the wrapper, which is
  // `position: relative`, rather than of the scroll container, so it stays put as the rows scroll
  // under it; `zIndex` keeps it above the sticky header, pinned cells and the toolbar.
  loadingOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "auto",
    zIndex: 4,
    "::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      backgroundColor: tokens.colorNeutralBackground2,
      opacity: 0.7,
      zIndex: -1
    }
  },
  // Text a screen reader announces with the loading overlay, kept off screen.
  visuallyHidden: {
    position: "absolute",
    width: "1px",
    height: "1px",
    overflow: "hidden",
    clipPath: "inset(50%)",
    whiteSpace: "nowrap"
  },
  // Fills `bodyArea` during the first load, holding its height under the
  // loading overlay until there is a table to show.
  bodyFill: {
    flex: "1 1 auto",
    // Room for the overlay's spinner when nothing else gives the grid height (no minHeight, an
    // auto-height container), so the grid doesn't collapse to its toolbar and then jump.
    minHeight: "80px"
  },
  // Centered status surface that fills `bodyArea` when a load failed.
  // Replaces `tableContainer` in that state rather than rendering
  // alongside it.
  statusFill: {
    flex: "1 1 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: tokens.spacingVerticalL,
    color: tokens.colorNeutralForeground3
  },
  statusFillError: {
    color: tokens.colorPaletteRedForeground1
  },
  // "No records found" row when a successful response has zero rows.
  // Lives INSIDE `tableContainer` so the column headers above it stay
  // sticky / scroll horizontally with the empty grid. Padding gives it
  // breathing room from the header divider.
  emptyStateRow: {
    display: "flex",
    justifyContent: "center",
    padding: tokens.spacingVerticalL,
    color: tokens.colorNeutralForeground3
  },
  // Paging strip at the bottom of the grid. Renders inside the
  // `<Footer>` layout component, which paints the background tint +
  // top-border divider (
  // renders a `<Footer>` in its `grid-area: footer` slot). This style
  // only handles the inner flex layout: page-size group on the left,
  // a flex spacer, then record count + nav buttons on the right.
  // Locked at the bottom (`flexShrink: 0`) so it stays visible even
  // when the body area is tall enough to require vertical scrolling.
  // Padding is tightened from the `<Footer>` default (`spacingHorizontalM`)
  // to `spacingHorizontalS` for visual parity with the grid `toolbar`.
  pagingRow: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: tokens.spacingHorizontalM,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    color: tokens.colorNeutralForeground2
  },
  pagingPageSizeGroup: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS
  },
  pagingPageSizeLabel: {
    color: tokens.colorNeutralForeground2
  },
  // Tight dropdown — page-size options are 2-3 digits so the field
  // doesn't need the default 240px+ minWidth Fluent's Dropdown picks.
  pagingPageSizeDropdown: {
    minWidth: "80px"
  },
  pagingSpacer: {
    flex: "1 1 auto"
  },
  pagingNav: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS
  },
  pagingCount: {
    fontVariantNumeric: "tabular-nums"
  },
  // Totals row: the footer's figures under their columns. Sticky at the bottom of the scroll
  // container, as the header is at its top — on the cells, for the same reason (see
  // `headerCell`) — and painted the header's color, with a hairline above.
  totalsCell: {
    position: "sticky",
    bottom: 0,
    // Above the rows, pinned cells (zIndex: 1) included.
    zIndex: 2,
    backgroundColor: tokens.colorNeutralBackground2,
    boxShadow: `inset 0 ${tokens.strokeWidthThin} 0 ${tokens.colorNeutralStroke1}`,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    verticalAlign: "middle",
    overflow: "hidden",
    maxWidth: 0,
    fontVariantNumeric: "tabular-nums"
  },
  // A pinned column's cells, held at their edge (the offset is inline) as the other columns scroll
  // under them: a body cell painted as its row is (a record's row shades it, see `bodyRow`), and a
  // header or totals cell above the other cells of its row, as those are above the rows.
  pinnedBodyCell: {
    position: "sticky",
    zIndex: 1,
    backgroundColor: "inherit"
  },
  pinnedHeaderCell: {
    zIndex: 3
  },
  pinnedTotalsCell: {
    zIndex: 3
  },
  // The line between the columns pinned to an edge and the columns that scroll, on the innermost
  // pinned cell. Drawn rather than a border, which would widen the cell past the width its
  // neighbors are placed by.
  pinnedStartEdge: {
    "::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      insetInlineEnd: 0,
      width: tokens.strokeWidthThin,
      backgroundColor: tokens.colorNeutralStroke1,
      pointerEvents: "none"
    }
  },
  pinnedEndEdge: {
    "::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      insetInlineStart: 0,
      width: tokens.strokeWidthThin,
      backgroundColor: tokens.colorNeutralStroke1,
      pointerEvents: "none"
    }
  },
  // A group's name pinned with the columns pinned to the start, running on over the cells after them
  // as it does without pins — drawn over those, as the pinned cells are.
  groupLabelCellPinned: {
    overflow: "visible"
  },
  // A column's figures, one per line.
  totalsStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: tokens.spacingVerticalXXS
  },
  totalsStackEnd: {
    alignItems: "flex-end",
    "& > span": {
      justifyContent: "flex-end"
    }
  },
  // One figure: its label, muted, then its value — below the label when the column is too narrow
  // for both, so a long total shows whole rather than cut short.
  total: {
    display: "flex",
    flexWrap: "wrap",
    columnGap: tokens.spacingHorizontalXS,
    maxWidth: "100%",
    whiteSpace: "nowrap"
  },
  totalLabel: {
    color: tokens.colorNeutralForeground3
  },
  totalValue: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1
  },
  // A grouped grid's header rows, drawn as a hierarchical grid's parent rows: the toggle, the
  // group's name and count across the columns before the first with figures, and the group's own
  // figures under their columns — side by side, so the row keeps a record row's height. The whole
  // row toggles the group.
  groupRow: {
    backgroundColor: tokens.colorNeutralBackground1,
    cursor: "pointer",
    userSelect: "none",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover
    },
    // Pinned cells shaded as a record's row shades them (`bodyRow`), so the band runs unbroken.
    [`& > .${PINNED_BODY_CELL_CLASS}`]: {
      backgroundColor: tokens.colorNeutralBackground2
    },
    [`:hover > .${PINNED_BODY_CELL_CLASS}`]: {
      backgroundColor: tokens.colorNeutralBackground1Hover
    }
  },
  // A record's first column in a grouped grid, indented past its group's name: the toggle's width
  // and the gap after it, less the label's pull to the left, and one step more.
  // Past the innermost group's header, which is a step in for each level outside it (--ppp-group-depth).
  groupedRecordCell: {
    paddingLeft: `calc(${tokens.spacingHorizontalM} + ${tokens.spacingHorizontalXXL} + ${tokens.spacingHorizontalM} + var(--ppp-group-depth, 0) * ${tokens.spacingHorizontalXXL})`
  },
  groupCell: {
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    borderBottomWidth: tokens.strokeWidthThin,
    borderBottomStyle: "solid",
    borderBottomColor: tokens.colorNeutralStroke2,
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    overflow: "hidden",
    maxWidth: 0,
    fontVariantNumeric: "tabular-nums"
  },
  // An inner group's header sits a step in from the one outside it (--ppp-group-level).
  groupLabel: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    marginLeft: `calc(${tokens.spacingHorizontalS} * -1)`,
    paddingLeft: `calc(var(--ppp-group-level, 0) * ${tokens.spacingHorizontalXXL})`,
    minWidth: 0
  },
  groupName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: tokens.colorNeutralForeground1
  },
  groupCount: {
    flexShrink: 0,
    color: tokens.colorNeutralForeground3
  },
  groupFigures: {
    display: "flex",
    gap: tokens.spacingHorizontalS,
    minWidth: 0,
    overflow: "hidden",
    "& > span": {
      flexWrap: "nowrap",
      minWidth: 0
    }
  },
  groupFiguresEnd: {
    justifyContent: "flex-end"
  },
  // The first column's figures, after the group's name.
  groupFiguresAfterName: {
    marginLeft: tokens.spacingHorizontalM,
    fontWeight: tokens.fontWeightRegular
  },
  groupingMessage: {
    marginTop: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalS,
    marginLeft: tokens.spacingHorizontalM,
    marginRight: tokens.spacingHorizontalM,
    flexShrink: 0
  },
  // The cards' figures: each column's under its title, side by side, after the cards.
  cardsTotals: {
    flexShrink: 0,
    display: "flex",
    flexWrap: "wrap",
    rowGap: tokens.spacingVerticalS,
    columnGap: tokens.spacingHorizontalXXL,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    backgroundColor: tokens.colorNeutralBackground2,
    boxShadow: `inset 0 ${tokens.strokeWidthThin} 0 ${tokens.colorNeutralStroke1}`,
    fontVariantNumeric: "tabular-nums"
  },
  // A grouped list's header: across the whole list, above its group's cards, its figures beside
  // the group's name — a step in for each level outside its own (--ppp-group-level).
  cardsGroup: {
    gridColumn: "1 / -1",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    rowGap: tokens.spacingVerticalXS,
    columnGap: tokens.spacingHorizontalXXL,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: `calc(${tokens.spacingHorizontalS} + var(--ppp-group-level, 0) * ${tokens.spacingHorizontalXXL})`,
    borderBottomWidth: tokens.strokeWidthThin,
    borderBottomStyle: "solid",
    borderBottomColor: tokens.colorNeutralStroke2,
    fontWeight: tokens.fontWeightSemibold,
    cursor: "pointer",
    // Its label carries no level of its own, and needs no pull into a cell's padding.
    "& > div:first-child": {
      marginLeft: 0
    }
  },
  cardsGroupFigures: {
    display: "flex",
    alignItems: "baseline",
    gap: tokens.spacingHorizontalS,
    minWidth: 0,
    fontWeight: tokens.fontWeightRegular,
    fontVariantNumeric: "tabular-nums"
  },
  cardsTotal: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXXS,
    minWidth: 0
  },
  cardsTotalColumn: {
    color: tokens.colorNeutralForeground2,
    fontWeight: tokens.fontWeightSemibold
  }
});
function MainGridPaging({
  page,
  pageSize,
  totalCount,
  recordCount,
  dataLength,
  onPageChange,
  onPageSizeChange,
  pageSizes,
  showPageSize
}) {
  const styles = useMainGridStyles();
  const t = useT();
  const pageSizeLabel = t("app.components.grid.page-size");
  const totalPages = totalCount !== void 0 ? Math.max(1, Math.ceil(totalCount / pageSize)) : void 0;
  const canPrev = page > 1;
  const canNext = totalPages !== void 0 ? page < totalPages : dataLength === pageSize;
  const canFirst = canPrev;
  const canLast = totalPages !== void 0 && page < totalPages;
  return /* @__PURE__ */ jsxs(Footer, { className: mergeClasses("ppp-grid-paging", styles.pagingRow), children: [
    showPageSize && /* @__PURE__ */ jsxs("div", { className: styles.pagingPageSizeGroup, children: [
      /* @__PURE__ */ jsx("span", { className: styles.pagingPageSizeLabel, children: pageSizeLabel }),
      /* @__PURE__ */ jsx(
        Dropdown,
        {
          className: styles.pagingPageSizeDropdown,
          "aria-label": pageSizeLabel,
          value: String(pageSize),
          selectedOptions: [String(pageSize)],
          onOptionSelect: (_, data) => {
            if (data.optionValue) {
              const next = Number(data.optionValue);
              if (Number.isFinite(next) && next > 0) onPageSizeChange(next);
            }
          },
          children: pageSizes.map((size) => /* @__PURE__ */ jsx(Option, { value: String(size), text: String(size), children: String(size) }, size))
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: styles.pagingSpacer }),
    totalCount !== void 0 && // Singular/plural collapsed into a single "{0} items" form so a
    // single localization key covers all counts. Slight grammatical
    // oddity at count=1 ("1 items") is accepted in trade.
    /* @__PURE__ */ jsx("span", { className: styles.pagingCount, children: t("app.components.grid.record-count", [recordCount ?? totalCount]) }),
    /* @__PURE__ */ jsxs("div", { className: styles.pagingNav, children: [
      /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.grid.first-page"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ChevronDoubleLeft20Regular, {}),
          disabledFocusable: !canFirst,
          onClick: () => onPageChange(1)
        }
      ) }),
      /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.grid.previous-page"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ChevronLeft20Regular, {}),
          disabledFocusable: !canPrev,
          onClick: () => onPageChange(Math.max(1, page - 1))
        }
      ) }),
      /* @__PURE__ */ jsx("span", { className: styles.pagingCount, children: totalPages !== void 0 ? t("app.components.grid.paging-text", [page, totalPages]) : t("app.components.grid.paging-text-no-total", [page]) }),
      /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.grid.next-page"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ChevronRight20Regular, {}),
          disabledFocusable: !canNext,
          onClick: () => onPageChange(page + 1)
        }
      ) }),
      /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.grid.last-page"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ChevronDoubleRight20Regular, {}),
          disabledFocusable: !canLast,
          onClick: () => {
            if (totalPages !== void 0) onPageChange(totalPages);
          }
        }
      ) })
    ] })
  ] });
}
function MainGridVirtualizeFooter({
  loadedCount,
  totalCount
}) {
  const styles = useMainGridStyles();
  const t = useT();
  const text2 = totalCount !== void 0 ? t("app.components.grid.record-count-showing", [totalCount, 1, loadedCount]) : t("app.components.grid.record-count-showing-no-total", [1, loadedCount]);
  return /* @__PURE__ */ jsxs(Footer, { className: mergeClasses("ppp-grid-virtualize-footer", styles.pagingRow), children: [
    /* @__PURE__ */ jsx("div", { className: styles.pagingSpacer }),
    /* @__PURE__ */ jsx("span", { className: styles.pagingCount, children: text2 })
  ] });
}

// src/grids/virtualize-paging.ts
function hasMoreRowsToLoad(state) {
  if (state.moreRecords === false) return false;
  if (state.moreRecords === true) return true;
  if (state.lastPageEmpty) return false;
  if (state.totalCount === void 0) return true;
  return state.accumulatedCount < state.totalCount;
}

// src/grids/grid-group-layout.ts
var GridGroupLayout = class {
  // Every header drawn, outer before inner, in the order the rows come.
  entries;
  /** How many records the expanded groups hold: what the server pages. */
  recordCount;
  constructor(groups, collapsed) {
    const entries = [];
    let records = 0;
    const walk = (level, depth) => {
      for (const group of level) {
        const isCollapsed = collapsed.has(group.key);
        const holdsRecords = group.groups == null;
        const index = entries.length;
        const firstRecord = records;
        entries.push(void 0);
        if (!isCollapsed) {
          if (holdsRecords) records += Math.max(0, Number(group.count) || 0);
          else walk(group.groups, depth + 1);
        }
        entries[index] = {
          group,
          depth,
          collapsed: isCollapsed,
          holdsRecords: holdsRecords && !isCollapsed,
          firstRecord,
          count: records - firstRecord
        };
      }
    };
    walk(groups, 0);
    this.entries = entries;
    this.recordCount = records;
  }
  /**
   * How many records the groups named by `keys` hold, at whatever level: the ones a fetch left out
   * for them, which the grid still holds. A group inside one named too is counted once, with it.
   */
  static recordsIn(groups, keys) {
    if (keys.size === 0) return 0;
    const sum = (level) => {
      let records = 0;
      for (const group of level) {
        if (keys.has(group.key)) records += Math.max(0, Number(group.count) || 0);
        else if (group.groups) records += sum(group.groups);
      }
      return records;
    };
    return sum(groups);
  }
  /** Every group's key, at every level. */
  static keysOf(groups) {
    const keys = [];
    const walk = (level) => {
      for (const group of level) {
        keys.push(group.key);
        if (group.groups) walk(group.groups);
      }
    };
    walk(groups);
    return keys;
  }
  /**
   * The headers and records of one page — the records `firstRecord` onward, `recordCount` of them
   * — in the order drawn. Each expanded group with records on the page has its header before the
   * first of them, a group carried over from the page before included, and an outer group's header
   * goes before its inner ones'. A collapsed group's header goes on the page whose records it
   * stands before, or the last page when no record follows it.
   */
  pageItems(firstRecord, recordCount) {
    const end = firstRecord + recordCount;
    const isLastPage = end >= this.recordCount;
    const items = [];
    const outer = [];
    for (const entry of this.entries) {
      outer.length = Math.min(outer.length, entry.depth);
      let onPage;
      let from = 0;
      let to = 0;
      if (entry.collapsed) {
        onPage = entry.firstRecord >= firstRecord && entry.firstRecord < end || isLastPage && entry.firstRecord >= end;
      } else if (entry.holdsRecords) {
        from = Math.max(entry.firstRecord, firstRecord);
        to = Math.min(entry.firstRecord + entry.count, end);
        onPage = from < to;
      } else {
        outer.push({ entry, drawn: false });
        continue;
      }
      if (!onPage) continue;
      for (const parent of outer) {
        if (parent.drawn) continue;
        items.push({ kind: "header", group: parent.entry.group, collapsed: false, level: parent.entry.depth });
        parent.drawn = true;
      }
      items.push({ kind: "header", group: entry.group, collapsed: entry.collapsed, level: entry.depth });
      for (let record = from; record < to; record++) items.push({ kind: "record", index: record });
    }
    return items;
  }
};
function searchColumnsFor(declarations, hidden = /* @__PURE__ */ new Set()) {
  if (!declarations || declarations.length === 0) return void 0;
  const seen = /* @__PURE__ */ new Set();
  const ordered = [];
  for (const decl of declarations) {
    if (decl.props.visible === false || hidden.has(declarationId(decl))) continue;
    if (decl.kind === "related" && decl.props.searchable === false) continue;
    const names2 = decl.kind === "column" ? [decl.props.columnName] : decl.kind === "related" ? [decl.props.columnKey] : decl.props.searchBy ?? [];
    for (const name of names2) {
      if (!name) continue;
      const key3 = name.toLowerCase();
      if (seen.has(key3)) continue;
      seen.add(key3);
      ordered.push(name);
    }
  }
  return ordered;
}
function declarationId(decl) {
  return decl.kind === "column" ? decl.props.columnName : decl.kind === "related" ? decl.props.columnId : decl.props.id;
}
function searchByTitlesFor(declarations) {
  const titles = /* @__PURE__ */ new Map();
  if (!declarations) return titles;
  const regular = /* @__PURE__ */ new Set();
  for (const decl of declarations) {
    if (decl.kind === "column" && decl.props.visible !== false) regular.add(decl.props.columnName.toLowerCase());
  }
  for (const decl of declarations) {
    if (decl.kind !== "template" || decl.props.visible === false) continue;
    for (const name of decl.props.searchBy ?? []) {
      const key3 = name.toLowerCase();
      if (!regular.has(key3) && !titles.has(key3)) titles.set(key3, decl.props.displayName);
    }
  }
  return titles;
}
function searchHintColumns(fetched, searchColumns, searchByTitles, groupOf) {
  const searched = searchColumns ? new Set(searchColumns.map((n) => n.toLowerCase())) : void 0;
  const groups = { text: [], number: [], date: [] };
  const listed = /* @__PURE__ */ new Set();
  for (const column of fetched) {
    const key3 = column.columnName.toLowerCase();
    if (searched && !searched.has(key3)) continue;
    const group = groupOf(column);
    if (!group) continue;
    const templateTitle = searchByTitles.get(key3);
    if (templateTitle) {
      const listedKey = `${group}|${templateTitle}`;
      if (listed.has(listedKey)) continue;
      listed.add(listedKey);
    }
    groups[group].push(templateTitle ? { ...column, displayName: templateTitle } : column);
  }
  const byTitle = (a, b) => a.displayName.localeCompare(b.displayName);
  for (const columns of Object.values(groups)) columns.sort(byTitle);
  return groups;
}
function relatedSearchKinds(column, columns) {
  return kindsOf(column, (search) => columns && columns.length > 0 ? columns : [search.primaryNameColumn]);
}
function searchedRelatedKinds(column) {
  return kindsOf(column, (search) => search.searchedColumns);
}
function kindsOf(column, searchedOf) {
  const search = column.relatedRecordsSearch;
  if (!search) return [SearchKind.Text];
  const byName = new Map(Object.entries(search.columns).map(([name, kind]) => [name.toLowerCase(), kind]));
  const kinds = /* @__PURE__ */ new Set();
  for (const name of searchedOf(search)) {
    const kind = byName.get(name.toLowerCase());
    if (kind !== void 0) kinds.add(kind);
  }
  return [...kinds];
}
var useStyles18 = makeStyles({
  body: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
    maxWidth: "320px"
  },
  section: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXXS
  },
  columns: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: tokens.spacingHorizontalM
  }
});
function SearchColumnsTooltip({
  text: text2,
  number,
  date
}) {
  const styles = useStyles18();
  const t = useT();
  const sections = [
    { key: "text", intro: t("app.components.grid.search-string-columns-intro"), columns: text2 },
    { key: "number", intro: t("app.components.grid.search-number-columns-intro"), columns: number },
    { key: "date", intro: t("app.components.grid.search-date-columns-intro"), columns: date }
  ];
  return /* @__PURE__ */ jsx("div", { className: styles.body, children: sections.filter((section) => section.columns.length > 0).map((section) => /* @__PURE__ */ jsxs("div", { className: styles.section, children: [
    /* @__PURE__ */ jsx("span", { children: section.intro }),
    /* @__PURE__ */ jsx("div", { className: styles.columns, children: section.columns.map((column) => /* @__PURE__ */ jsx("span", { children: column.displayName }, column.columnName)) })
  ] }, section.key)) });
}
function viewSortOf(columns) {
  const sorted = columns.filter((column) => column.defaultSortDirection != null);
  const ranks = sorted.map((column) => column.defaultSortPriority == null ? NaN : Number(column.defaultSortPriority));
  const ordered = sorted.map((column, i) => ({ column, rank: ranks[i] })).sort((x, y) => x.rank - y.rank);
  if (ordered.some(({ rank }, i) => rank !== i)) return [];
  return ordered.map(({ column }) => ({
    columnName: column.columnName,
    descending: column.defaultSortDirection === SortDirection.Descending
  }));
}
function computeNextSort(prev, columnName, shiftKey) {
  const existingIndex = prev.findIndex((d) => d.columnName === columnName);
  const existing = existingIndex >= 0 ? prev[existingIndex] : void 0;
  if (shiftKey) {
    if (prev.length === 1 && existing) return [];
    if (!existing) return [...prev, { columnName, descending: false }];
    if (!existing.descending) {
      const next = prev.slice();
      next[existingIndex] = { columnName, descending: true };
      return next;
    }
    return prev.filter((_, i) => i !== existingIndex);
  }
  if (prev.length === 1 && existing) {
    return [{ columnName, descending: !existing.descending }];
  }
  return [{ columnName, descending: false }];
}
function sortTargetsFor(declarations) {
  const targets = /* @__PURE__ */ new Map();
  for (const decl of declarations) {
    if (decl.kind === "column" && decl.props.sortBy) {
      targets.set(decl.props.columnName, decl.props.sortBy);
    } else if (decl.kind === "template" && decl.props.sortBy) {
      targets.set(decl.props.id, decl.props.sortBy);
    }
  }
  return targets;
}
function toServerSorts(sort, targets) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const level of sort) {
    const columnName = targets.get(level.columnName) ?? level.columnName;
    const key3 = columnName.toLowerCase();
    if (seen.has(key3)) continue;
    seen.add(key3);
    out.push(columnName === level.columnName ? level : { ...level, columnName });
  }
  return out;
}
var useStyles19 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
    // Wide enough for a column name and its direction side by side; a long
    // column name truncates in its dropdown rather than stretching the panel.
    minWidth: "min(320px, 100%)",
    maxWidth: "560px"
  },
  header: {
    fontWeight: tokens.fontWeightSemibold
  },
  levels: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS
  },
  level: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    rowGap: tokens.spacingVerticalXS
  },
  levelLabel: {
    flexBasis: "100%",
    color: tokens.colorNeutralForeground3
  },
  columnDropdown: {
    flexGrow: 1,
    minWidth: "140px"
  },
  directionDropdown: {
    minWidth: "130px"
  },
  empty: {
    color: tokens.colorNeutralForeground3
  },
  footer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: tokens.spacingHorizontalS
  },
  footerEnd: {
    marginLeft: "auto",
    display: "flex",
    gap: tokens.spacingHorizontalS
  }
});
function GridSortPanel({ columns, sort, onApply, onCancel }) {
  const t = useT();
  const styles = useStyles19();
  const [draft, setDraft] = useState(() => sort.map((level) => ({ ...level })));
  const titleOf = (key3) => columns.find((c) => c.key === key3)?.title ?? key3;
  const unused = columns.filter((c) => !draft.some((level) => level.columnName === c.key));
  const update = (index, change) => setDraft((prev) => prev.map((level, i) => i === index ? { ...level, ...change } : level));
  const move = (index, offset) => setDraft((prev) => {
    const next = prev.slice();
    const [level] = next.splice(index, 1);
    next.splice(index + offset, 0, level);
    return next;
  });
  const remove = (index) => setDraft((prev) => prev.filter((_, i) => i !== index));
  const add = () => {
    const first = unused[0];
    if (first) setDraft((prev) => [...prev, { columnName: first.key, descending: false }]);
  };
  const ascending = t("app.components.grid.sort-ascending");
  const descending = t("app.components.grid.sort-descending");
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-grid-sort-panel", styles.root), children: [
    /* @__PURE__ */ jsx(Text, { className: styles.header, children: t("app.components.grid.sort") }),
    /* @__PURE__ */ jsxs("div", { className: styles.levels, children: [
      draft.length === 0 && /* @__PURE__ */ jsx(Text, { className: styles.empty, children: t("app.components.grid.sort-none") }),
      draft.map((level, index) => {
        const label = index === 0 ? t("app.components.grid.sort-by") : t("app.components.grid.then-by");
        const choices = columns.filter(
          (c) => c.key === level.columnName || !draft.some((other) => other.columnName === c.key)
        );
        return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-grid-sort-level", styles.level), children: [
          /* @__PURE__ */ jsx(Text, { size: 200, className: styles.levelLabel, children: label }),
          /* @__PURE__ */ jsx(
            Dropdown,
            {
              className: styles.columnDropdown,
              "aria-label": label,
              value: titleOf(level.columnName),
              selectedOptions: [level.columnName],
              onOptionSelect: (_, data) => {
                if (data.optionValue) update(index, { columnName: data.optionValue });
              },
              children: choices.map((c) => /* @__PURE__ */ jsx(Option, { value: c.key, children: c.title }, c.key))
            }
          ),
          /* @__PURE__ */ jsxs(
            Dropdown,
            {
              className: styles.directionDropdown,
              "aria-label": t("app.components.grid.sort-direction"),
              value: level.descending ? descending : ascending,
              selectedOptions: [level.descending ? "desc" : "asc"],
              onOptionSelect: (_, data) => update(index, { descending: data.optionValue === "desc" }),
              children: [
                /* @__PURE__ */ jsx(Option, { value: "asc", children: ascending }),
                /* @__PURE__ */ jsx(Option, { value: "desc", children: descending })
              ]
            }
          ),
          /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.grid.sort-move-up"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "subtle",
              icon: /* @__PURE__ */ jsx(ArrowUp20Regular, {}),
              disabledFocusable: index === 0,
              onClick: () => move(index, -1)
            }
          ) }),
          /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.grid.sort-move-down"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "subtle",
              icon: /* @__PURE__ */ jsx(ArrowDown20Regular, {}),
              disabledFocusable: index === draft.length - 1,
              onClick: () => move(index, 1)
            }
          ) }),
          /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.grid.sort-remove-level"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "subtle",
              icon: /* @__PURE__ */ jsx(Dismiss20Regular, {}),
              onClick: () => remove(index)
            }
          ) })
        ] }, index);
      })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles.footer, children: [
      /* @__PURE__ */ jsx(Button, { appearance: "subtle", icon: /* @__PURE__ */ jsx(Add20Regular, {}), disabled: unused.length === 0, onClick: add, children: t("app.components.grid.sort-add-level") }),
      /* @__PURE__ */ jsx(Button, { appearance: "subtle", disabled: draft.length === 0, onClick: () => setDraft([]), children: t("app.components.grid.sort-clear") }),
      /* @__PURE__ */ jsxs("div", { className: styles.footerEnd, children: [
        /* @__PURE__ */ jsx(Button, { onClick: onCancel, children: t("app.buttons.cancel.label") }),
        /* @__PURE__ */ jsx(Button, { appearance: "primary", onClick: () => onApply(draft), children: t("app.components.grid.sort-apply") })
      ] })
    ] })
  ] });
}
var FIGURE_LABEL_KEYS = {
  [QueryAggregate.Sum]: "app.components.grid.column-menu-total-sum",
  [QueryAggregate.Average]: "app.components.grid.column-menu-total-average",
  [QueryAggregate.Minimum]: "app.components.grid.column-menu-total-minimum",
  [QueryAggregate.Maximum]: "app.components.grid.column-menu-total-maximum",
  [QueryAggregate.Count]: "app.components.grid.column-menu-total-count"
};
var useStyles20 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
    minWidth: "min(320px, 100%)",
    maxWidth: "560px"
  },
  header: {
    fontWeight: tokens.fontWeightSemibold
  },
  columns: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM
  },
  column: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXS
  },
  columnPick: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS
  },
  columnDropdown: {
    flexGrow: 1,
    minWidth: "140px"
  },
  figures: {
    display: "flex",
    flexWrap: "wrap",
    columnGap: tokens.spacingHorizontalM
  },
  empty: {
    color: tokens.colorNeutralForeground3
  },
  footer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: tokens.spacingHorizontalS
  },
  footerEnd: {
    marginLeft: "auto",
    display: "flex",
    gap: tokens.spacingHorizontalS
  }
});
var same = (a, b) => a.toLowerCase() === b.toLowerCase();
function GridTotalsPanel({ columns, totals, onApply, onCancel }) {
  const t = useT();
  const styles = useStyles20();
  const [draft, setDraft] = useState(() => {
    const shown = new Map([...totals].map(([name, figures]) => [name.toLowerCase(), figures]));
    return columns.map((column) => ({
      columnName: column.columnName,
      aggregates: column.offered.filter((a) => (shown.get(column.columnName.toLowerCase()) ?? []).includes(a))
    })).filter((row) => row.aggregates.length > 0);
  });
  const columnOf = (columnName) => columns.find((c) => same(c.columnName, columnName));
  const unused = columns.filter((c) => !draft.some((row) => same(row.columnName, c.columnName)));
  const update = (index, row) => setDraft((prev) => prev.map((r, i) => i === index ? row : r));
  const setColumn = (index, columnName) => {
    const offered = columnOf(columnName)?.offered ?? [];
    const kept = offered.filter((a) => draft[index].aggregates.includes(a));
    update(index, { columnName, aggregates: kept.length > 0 ? kept : offered.slice(0, 1) });
  };
  const setFigure = (index, aggregate, shown) => {
    const row = draft[index];
    const offered = columnOf(row.columnName)?.offered ?? [];
    update(index, {
      ...row,
      aggregates: offered.filter((a) => a === aggregate ? shown : row.aggregates.includes(a))
    });
  };
  const add = () => {
    const first = unused[0];
    if (first) setDraft((prev) => [...prev, { columnName: first.columnName, aggregates: first.offered.slice(0, 1) }]);
  };
  const apply = () => onApply(new Map(draft.filter((row) => row.aggregates.length > 0).map((row) => [row.columnName, row.aggregates])));
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-grid-totals-panel", styles.root), children: [
    /* @__PURE__ */ jsx(Text, { className: styles.header, children: t("app.components.grid.totals") }),
    /* @__PURE__ */ jsxs("div", { className: styles.columns, children: [
      draft.length === 0 && /* @__PURE__ */ jsx(Text, { className: styles.empty, children: t("app.components.grid.totals-none") }),
      draft.map((row, index) => {
        const column = columnOf(row.columnName);
        const choices = columns.filter(
          (c) => same(c.columnName, row.columnName) || !draft.some((other) => same(other.columnName, c.columnName))
        );
        return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-grid-totals-column", styles.column), children: [
          /* @__PURE__ */ jsxs("div", { className: styles.columnPick, children: [
            /* @__PURE__ */ jsx(
              Dropdown,
              {
                className: styles.columnDropdown,
                "aria-label": t("app.components.grid.totals-column"),
                value: column?.title ?? row.columnName,
                selectedOptions: [row.columnName],
                onOptionSelect: (_, data) => {
                  if (data.optionValue) setColumn(index, data.optionValue);
                },
                children: choices.map((c) => /* @__PURE__ */ jsx(Option, { value: c.columnName, children: c.title }, c.columnName))
              }
            ),
            /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.grid.totals-remove-column"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
              Button,
              {
                appearance: "subtle",
                icon: /* @__PURE__ */ jsx(Dismiss20Regular, {}),
                onClick: () => setDraft((prev) => prev.filter((_, i) => i !== index))
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx("div", { className: styles.figures, role: "group", "aria-label": column?.title ?? row.columnName, children: (column?.offered ?? []).map((aggregate) => /* @__PURE__ */ jsx(
            Checkbox,
            {
              label: t(FIGURE_LABEL_KEYS[aggregate]),
              checked: row.aggregates.includes(aggregate),
              onChange: (_, data) => setFigure(index, aggregate, data.checked === true)
            },
            aggregate
          )) })
        ] }, index);
      })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles.footer, children: [
      /* @__PURE__ */ jsx(Button, { appearance: "subtle", icon: /* @__PURE__ */ jsx(Add20Regular, {}), disabled: unused.length === 0, onClick: add, children: t("app.components.grid.totals-add-column") }),
      /* @__PURE__ */ jsx(Button, { appearance: "subtle", disabled: draft.length === 0, onClick: () => setDraft([]), children: t("app.components.grid.totals-clear") }),
      /* @__PURE__ */ jsxs("div", { className: styles.footerEnd, children: [
        /* @__PURE__ */ jsx(Button, { onClick: onCancel, children: t("app.buttons.cancel.label") }),
        /* @__PURE__ */ jsx(Button, { appearance: "primary", onClick: apply, children: t("app.components.grid.totals-apply") })
      ] })
    ] })
  ] });
}
var useStyles21 = makeStyles({
  surface: {
    // One control to a line, under the title naming the column; wide enough for Fluent to keep
    // the buttons on one line rather than stack them too.
    width: "min(540px, 92vw)",
    maxWidth: "min(540px, 92vw)"
  }
});
function GridColumnFilterDialog(props) {
  const { open, onCancel } = props;
  return open ? /* @__PURE__ */ jsx(Dialog, { open: true, onOpenChange: (_, data) => !data.open && onCancel(), children: /* @__PURE__ */ jsx(GridColumnFilterDialogSurface, { ...props }) }) : null;
}
function GridColumnFilterDialogSurface({
  table,
  column,
  columnTitle,
  criteria,
  viewFetchXml,
  onApply,
  onCancel,
  onOpenFilter
}) {
  const showsLogicalNames = useShowsLogicalNames();
  const t = useT();
  const styles = useStyles21();
  const metadata = useReadableFetchXmlMetadata();
  const found = useMemo(() => findGridColumnFilter(criteria, viewFetchXml, column), [criteria, viewFetchXml, column]);
  const [draft, setDraft] = useState(() => editedQuery(table, column, found, viewFetchXml));
  const title = t("app.components.grid.column-filter-title", [columnTitle]);
  const builderRef = useRef(null);
  if (found.kind === "other") {
    return /* @__PURE__ */ jsx(DialogSurface, { className: styles.surface, "aria-label": title, children: /* @__PURE__ */ jsxs(DialogBody, { children: [
      /* @__PURE__ */ jsx(DialogTitle, { children: title }),
      /* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsx(MessageBar, { intent: "info", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.components.grid.column-filter-elsewhere") }) }) }),
      /* @__PURE__ */ jsxs(DialogActions, { children: [
        /* @__PURE__ */ jsx(Button, { onClick: onCancel, children: t("app.components.grid.filter-cancel") }),
        /* @__PURE__ */ jsx(Button, { appearance: "primary", onClick: onOpenFilter, children: t("app.components.grid.column-filter-open-filter") })
      ] })
    ] }) });
  }
  const condition = conditionOf(draft);
  return /* @__PURE__ */ jsx(DialogSurface, { className: styles.surface, "aria-label": title, children: /* @__PURE__ */ jsxs(DialogBody, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: title }),
    /* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsx(
      FetchXmlBuilderProvider,
      {
        value: draft,
        onChange: setDraft,
        metadata,
        table,
        allowAggregate: false,
        showLogicalNames: showsLogicalNames,
        children: /* @__PURE__ */ jsxs("div", { ref: builderRef, className: "ppp-fetch-xml-builder ppp-grid-column-filter-dialog", children: [
          /* @__PURE__ */ jsx(SharedTooltip, { containerRef: builderRef }),
          /* @__PURE__ */ jsx(ColumnConditionRow, { columnTitle, isNew: found.kind === "none" })
        ] })
      }
    ) }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      found.kind === "single" && /* @__PURE__ */ jsx(Button, { appearance: "subtle", onClick: () => onApply(setGridColumnFilter(criteria, viewFetchXml, column, void 0)), children: t("app.components.grid.column-filter-clear") }),
      /* @__PURE__ */ jsx(Button, { onClick: onCancel, children: t("app.components.grid.filter-cancel") }),
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "primary",
          disabled: !condition.complete,
          onClick: () => onApply(setGridColumnFilter(criteria, viewFetchXml, column, condition.xml)),
          children: t("app.components.grid.filter-apply")
        }
      )
    ] })
  ] }) });
}
function ColumnConditionRow({ columnTitle, isNew }) {
  const { query, entity, apply, columns, columnSources, detailLoading } = useFetchXmlBuilderContext();
  const condition = entity.filters[0]?.conditions[0];
  const source = condition?.entityName === void 0 ? void 0 : findColumnSource(columnSources, condition.entityName);
  const column = condition && findColumn(source ? source.columns : columns, condition.attribute);
  const defaulted = useRef(!isNew);
  useEffect(() => {
    if (defaulted.current || !condition || !column) return;
    defaulted.current = true;
    apply(updateCondition(query, condition.id, { operator: defaultGridColumnFilterOperator(column.type) }));
  }, [apply, column, condition, query]);
  if (!condition || detailLoading) return /* @__PURE__ */ jsx(Spinner, { size: "small" });
  return /* @__PURE__ */ jsx(
    ConditionRow,
    {
      condition,
      columns,
      sources: columnSources,
      columnTitle,
      layout: "stacked",
      markIncomplete: false,
      onChange: (patch) => apply(updateCondition(query, condition.id, patch))
    }
  );
}
function editedQuery(table, column, found, viewFetchXml) {
  const { alias, name } = splitGridColumn(column);
  const condition = found.kind === "single" ? parseXml(found.condition) : { name: "condition", attributes: { attribute: name, operator: "eq" }, children: [], text: "" };
  if (alias !== void 0) condition.attributes["entityname"] = alias;
  const children = [];
  const join = gridColumnViewJoin(viewFetchXml, column);
  if (join) {
    const attributes = {};
    for (const key3 of ["name", "from", "to", "alias"]) {
      if (join.attributes[key3] !== void 0) attributes[key3] = join.attributes[key3];
    }
    children.push({ name: "link-entity", attributes, children: [], text: "" });
  }
  children.push({ name: "filter", attributes: { type: "and" }, children: [condition], text: "" });
  return serializeXml({
    name: "fetch",
    attributes: {},
    children: [{ name: "entity", attributes: { name: table }, children, text: "" }],
    text: ""
  });
}
function conditionOf(draft) {
  const element = parseXml(draft).children.find((x) => x.name === "entity")?.children.find((x) => x.name === "filter")?.children.find((x) => x.name === "condition");
  if (!element) return { xml: "", complete: false };
  return { xml: serializeXml(element, { indent: "" }), complete: isComplete(draft) };
}
function isComplete(draft) {
  try {
    const condition = parseFetchXml(draft).entity.filters[0]?.conditions[0];
    return !!condition && !isConditionIncomplete(condition);
  } catch {
    return false;
  }
}
var LABEL_KEYS = {
  [QueryAggregate.Sum]: "app.components.grid.column-menu-total-sum",
  [QueryAggregate.Average]: "app.components.grid.column-menu-total-average",
  [QueryAggregate.Minimum]: "app.components.grid.column-menu-total-minimum",
  [QueryAggregate.Maximum]: "app.components.grid.column-menu-total-maximum"
};
var EXAMPLES = [
  ["N0", "app.components.grid.totals-format-example-n0"],
  ["N1", "app.components.grid.totals-format-example-n1"],
  ["N2", "app.components.grid.totals-format-example-n2"],
  ["F0", "app.components.grid.totals-format-example-f0"],
  ["F2", "app.components.grid.totals-format-example-f2"]
];
var SAMPLE = 1234.5678;
var useStyles22 = makeStyles({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM
  },
  description: {
    margin: 0,
    color: tokens.colorNeutralForeground2
  },
  examplesHeading: {
    margin: 0,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold
  },
  examples: {
    display: "grid",
    gridTemplateColumns: "auto 1fr auto",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalM,
    rowGap: tokens.spacingVerticalXXS
  },
  sample: {
    textAlign: "end",
    fontVariantNumeric: "tabular-nums"
  }
});
function GridTotalsFormatDialog({ columnTitle, formats, onApply, onCancel }) {
  const t = useT();
  const { locale } = useLocale();
  const styles = useStyles22();
  const [values, setValues] = useState(
    () => new Map(FORMATTED_AGGREGATES.map((aggregate) => [aggregate, formats.get(aggregate) ?? ""]))
  );
  const target = useRef(FORMATTED_AGGREGATES[0]);
  const valid = [...values.values()].every(isValidAggregateFormat);
  const apply = () => {
    if (valid) onApply(new Map([...values].map(([aggregate, value2]) => [aggregate, value2.trim()])));
  };
  const set = (aggregate, value2) => setValues((current) => new Map(current).set(aggregate, value2));
  return /* @__PURE__ */ jsx(Dialog, { open: true, onOpenChange: (_, data) => !data.open && onCancel(), children: /* @__PURE__ */ jsx(DialogSurface, { className: "ppp-grid-totals-format", style: { width: "min(480px, 94vw)" }, children: /* @__PURE__ */ jsxs(DialogBody, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: t("app.components.grid.totals-format-title", [columnTitle]) }),
    /* @__PURE__ */ jsxs(DialogContent, { className: styles.content, children: [
      /* @__PURE__ */ jsx("p", { className: styles.description, children: t("app.components.grid.totals-format-description") }),
      FORMATTED_AGGREGATES.map((aggregate, index) => {
        const value2 = values.get(aggregate) ?? "";
        const invalid = !isValidAggregateFormat(value2);
        return /* @__PURE__ */ jsx(
          Field,
          {
            label: t(LABEL_KEYS[aggregate]),
            ...invalid && {
              validationState: "error",
              validationMessage: t("app.components.grid.totals-format-invalid")
            },
            children: /* @__PURE__ */ jsx(
              Input,
              {
                value: value2,
                maxLength: MAX_AGGREGATE_FORMAT_LENGTH,
                autoFocus: index === 0,
                onFocus: () => target.current = aggregate,
                onChange: (_, data) => set(aggregate, data.value),
                onKeyDown: (event) => {
                  if (event.key === "Enter") apply();
                }
              }
            )
          },
          aggregate
        );
      }),
      /* @__PURE__ */ jsx("h3", { className: styles.examplesHeading, children: t("app.components.grid.totals-format-examples", [formatValue(SAMPLE, "N4", locale)]) }),
      /* @__PURE__ */ jsx("div", { className: styles.examples, children: EXAMPLES.map(([code, description]) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
        /* @__PURE__ */ jsx(Button, { appearance: "subtle", size: "small", onClick: () => set(target.current, code), children: /* @__PURE__ */ jsx("code", { children: code }) }),
        /* @__PURE__ */ jsx("span", { children: t(description) }),
        /* @__PURE__ */ jsx("span", { className: styles.sample, children: formatValue(SAMPLE, code, locale) })
      ] }, code)) })
    ] }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(Button, { onClick: onCancel, children: t("app.buttons.cancel.label") }),
      /* @__PURE__ */ jsx(Button, { appearance: "primary", disabled: !valid, onClick: apply, children: t("app.components.grid.totals-apply") })
    ] })
  ] }) }) });
}
function readPersistedGridStateFromUrl(queryParameterName) {
  if (!queryParameterName) return null;
  if (typeof window === "undefined") return null;
  const raw = new URLSearchParams(window.location.search).get(queryParameterName);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}
function encodePersistedGridState(state) {
  const compact = {};
  if (state.v) compact.v = state.v;
  if (state.p !== void 0 && state.p > 1) compact.p = state.p;
  if (state.ps !== void 0) compact.ps = state.ps;
  if (state.s && state.s.length > 0) compact.s = state.s;
  if (state.q && state.q.length > 0) compact.q = state.q;
  if (state.l) compact.l = state.l;
  if (state.g) compact.g = state.g;
  if (state.a && Object.keys(state.a).length > 0) compact.a = state.a;
  if (state.f && Object.keys(state.f).length > 0) compact.f = state.f;
  if (state.h && state.h.length > 0) compact.h = state.h;
  if (state.o && state.o.length > 0) compact.o = state.o;
  if (state.n && Object.keys(state.n).length > 0) compact.n = state.n;
  if (state.nr) compact.nr = state.nr;
  return JSON.stringify(compact);
}
var MAX_GROUP_LEVELS = 3;
function serializeGroupLevels(levels) {
  return levels.map(serializeGroupBy);
}
function deserializeGroupLevels(persisted) {
  const levels = Array.isArray(persisted) ? persisted : [persisted];
  return levels.filter((level) => !!level && typeof level === "object").map(deserializeGroupBy).filter((level) => level !== null).slice(0, MAX_GROUP_LEVELS);
}
function serializeGroupBy(groupBy) {
  if (!groupBy) return {};
  const persisted = { c: groupBy.columnName };
  if (groupBy.descending) persisted.d = true;
  if (groupBy.dateGrouping !== void 0 && groupBy.dateGrouping !== DateGrouping.Day) {
    persisted.t = groupBy.dateGrouping;
  }
  const rangeSize = Number(groupBy.rangeSize ?? NaN);
  if (Number.isFinite(rangeSize) && rangeSize > 0) persisted.r = rangeSize;
  return persisted;
}
var DATE_GROUPINGS = QUERY_DATE_GROUPINGS;
function deserializeGroupBy(groupBy) {
  if (typeof groupBy.c !== "string" || groupBy.c.trim().length === 0) return null;
  return {
    columnName: groupBy.c,
    descending: groupBy.d === true,
    dateGrouping: typeof groupBy.t === "number" && DATE_GROUPINGS.includes(groupBy.t) ? groupBy.t : DateGrouping.Day,
    ...typeof groupBy.r === "number" && Number.isFinite(groupBy.r) && groupBy.r > 0 ? { rangeSize: groupBy.r } : {}
  };
}
function serializeAggregateFormats(formats) {
  return Object.fromEntries(
    FORMATTED_AGGREGATES.filter((aggregate) => formats.has(aggregate)).map((aggregate) => [gridAggregateName(aggregate), formats.get(aggregate)])
  );
}
function deserializeAggregateFormats(persisted) {
  const formats = /* @__PURE__ */ new Map();
  if (!persisted || typeof persisted !== "object") return formats;
  for (const [name, format] of Object.entries(persisted)) {
    const aggregate = gridAggregateNamed(name);
    if (aggregate !== void 0 && FORMATTED_AGGREGATES.includes(aggregate) && typeof format === "string" && isValidAggregateFormat(format)) {
      formats.set(aggregate, format);
    }
  }
  return formats;
}
function serializeAggregates(aggregates) {
  return [...new Set(aggregates)].reduce((sum, aggregate) => sum + aggregate, 0);
}
function serializeSorts(sorts) {
  return sorts.map((s) => s.descending ? { c: s.columnName, d: true } : { c: s.columnName });
}
function deserializeSorts(sorts) {
  if (!sorts) return [];
  return sorts.filter((s) => typeof s?.c === "string" && s.c.length > 0).map((s) => s.d ? { columnName: s.c, descending: true } : { columnName: s.c });
}
function writePersistedGridStateToUrl(queryParameterName, state) {
  if (!queryParameterName) return;
  replaceQueryParam(queryParameterName, encodePersistedGridState(state));
}

// src/grids/grid-grouping.ts
function hiddenGroupColumnsOf(levels, grouping, columns, groupsByValue2 = () => true) {
  if (levels.length === 0 || grouping && grouping.status !== QueryGroupingStatus.Grouped) return [];
  const shown = columns.filter((column) => column.type !== ColumnType.RelatedRecords);
  const names2 = new Set(levels.filter(groupsByValue2).map((level) => level.columnName.trim().toLowerCase()));
  const hidden = shown.filter((column) => !column.columnName.includes(".") && names2.has(column.columnName.toLowerCase())).map((column) => column.columnName);
  return hidden.length < shown.length ? hidden : [];
}
function sameGroupByProps(a, b) {
  return a.levels === b.levels && a.column === b.column && a.descending === b.descending && a.dateGrouping === b.dateGrouping;
}
function takesUpUserChoice(from, to, user) {
  if (to.levels !== from.levels && to.levels !== groupBySignatureOf(user)) return false;
  const outermost = user[0];
  const userColumn = outermost ? outermost.columnName.trim().toLowerCase() : null;
  if (to.column !== from.column && to.column !== userColumn) return false;
  if (!outermost) return true;
  return (to.descending === from.descending || to.descending === (outermost.descending ?? false)) && (to.dateGrouping === from.dateGrouping || to.dateGrouping === (outermost.dateGrouping ?? DateGrouping.Day));
}
function levelSignatureOf(level) {
  return `${level.columnName.trim().toLowerCase()}|${level.descending ?? false}|${level.dateGrouping ?? DateGrouping.Day}|${rangeSizeOf(level) ?? ""}`;
}
var MIN_RANGE_SIZE = 1e-10;
var MAX_RANGE_SIZE = 1e18;
var NUMBER_TYPES = [ColumnType.Integer, ColumnType.BigInt, ColumnType.Decimal, ColumnType.Double, ColumnType.Money];
function groupsByValue(level, type, metadata) {
  if (type !== void 0 && NUMBER_TYPES.includes(type)) return rangeSizeOf(level) === null;
  if (type === ColumnType.DateTime) {
    return (level.dateGrouping ?? DateGrouping.Day) === DateGrouping.Day && isDateOnly(metadata);
  }
  return true;
}
function rangeSizeOf(level) {
  const size = Number(level.rangeSize ?? NaN);
  return Number.isFinite(size) && size >= MIN_RANGE_SIZE && size <= MAX_RANGE_SIZE ? size : null;
}
function groupBySignatureOf(levels) {
  return levels.map(levelSignatureOf).join("/");
}
var sameColumn = (a, b) => a.columnName.toLowerCase() === b.columnName.toLowerCase();
function insertGroupLevel(levels, level, index, innermostOnly) {
  const list = [...levels];
  const existing = list.findIndex((l) => sameColumn(l, level));
  if (existing >= 0) {
    level = list[existing];
    list.splice(existing, 1);
    if (existing < index) index--;
  }
  if (innermostOnly(level)) {
    for (let i = list.length - 1; i >= 0; i--) if (innermostOnly(list[i])) list.splice(i, 1);
    index = list.length;
  } else if (list.length > 0 && innermostOnly(list[list.length - 1])) {
    index = Math.min(index, list.length - 1);
  }
  if (list.length >= MAX_GROUP_LEVELS) return null;
  list.splice(Math.max(0, Math.min(index, list.length)), 0, level);
  return list;
}
function replaceGroupLevel(levels, index, level) {
  return levels.map((l, i) => i === index ? level : l);
}
function changeGroupLevel(levels, index, level, innermostOnly) {
  return innermostOnly(level) && index < levels.length - 1 ? insertGroupLevel(removeGroupLevel(levels, index), level, levels.length - 1, innermostOnly) ?? replaceGroupLevel(levels, index, level) : replaceGroupLevel(levels, index, level);
}
function removeGroupLevel(levels, index) {
  return levels.filter((_, i) => i !== index);
}
function groupsByColumn(levels, columnName) {
  return levels.some((l) => l.columnName.toLowerCase() === columnName.toLowerCase());
}
var GROUP_DRAG_TYPE = "text/plain";
var useStyles23 = makeStyles({
  root: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    minHeight: "36px",
    boxSizing: "border-box",
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
    border: `${tokens.strokeWidthThin} dashed ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusMedium,
    color: tokens.colorNeutralForeground3,
    transitionProperty: "background-color, border-color",
    transitionDuration: tokens.durationFaster
  },
  // A header is on its way: the strip shows it can take it, and more so while it is over it.
  ready: {
    borderTopColor: tokens.colorBrandStroke1,
    borderRightColor: tokens.colorBrandStroke1,
    borderBottomColor: tokens.colorBrandStroke1,
    borderLeftColor: tokens.colorBrandStroke1
  },
  over: {
    backgroundColor: tokens.colorBrandBackground2
  },
  hint: {
    fontSize: tokens.fontSizeBase200
  },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXXS,
    // A little room around the controls inside — the span picker, the range box, the buttons.
    paddingTop: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalXXS,
    paddingInlineStart: tokens.spacingHorizontalS,
    paddingInlineEnd: tokens.spacingHorizontalXXS,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    // Clicked anywhere but on its controls, a chip reverses its groups' order.
    cursor: "pointer"
  },
  // A control inside a chip: laid out as if the chip held it directly, with its own cursor.
  chipControl: {
    display: "contents",
    cursor: "auto"
  },
  // A drag over a chip: dropped, its column goes before this one's.
  chipTarget: {
    boxShadow: `inset 3px 0 0 ${tokens.colorBrandStroke1}`
  },
  chipTitle: {
    fontWeight: tokens.fontWeightSemibold,
    paddingInlineEnd: tokens.spacingHorizontalXS
  },
  span: {
    minWidth: "110px"
  },
  range: {
    width: "100px"
  },
  step: {
    minWidth: "64px"
  },
  // Add grouping sits at the strip's end, past the chips.
  add: {
    marginInlineStart: "auto"
  }
});
var SPAN_KEYS = {
  [DateGrouping.Minute]: "app.components.grid.group-span-minute",
  [DateGrouping.Hour]: "app.components.grid.group-span-hour",
  [DateGrouping.Day]: "app.components.grid.group-span-day",
  [DateGrouping.Week]: "app.components.grid.group-span-week",
  [DateGrouping.Month]: "app.components.grid.group-span-month",
  [DateGrouping.Quarter]: "app.components.grid.group-span-quarter",
  [DateGrouping.Year]: "app.components.grid.group-span-year",
  [DateGrouping.FiscalPeriod]: "app.components.grid.group-span-fiscal-period",
  [DateGrouping.FiscalYear]: "app.components.grid.group-span-fiscal-year"
};
var spanKey = (span) => SPAN_KEYS[span] ?? "app.components.grid.group-span-day";
var spansFor = (holdsTime) => QUERY_DATE_GROUPINGS.filter((span) => holdsTime || dateStepsOf(span).length === 0);
var stepOf = (groupBy) => {
  const size = Number(groupBy.rangeSize ?? 1);
  return isDateStep(groupBy.dateGrouping, size) ? size : 1;
};
var stepOptionsOf = (groupBy) => [.../* @__PURE__ */ new Set([...dateStepsOf(groupBy.dateGrouping), stepOf(groupBy)])].sort((a, b) => a - b);
function GridGroupPanel({
  levels,
  isDragging,
  onChipDragStart,
  onChipDragEnd,
  onDrop,
  onChange,
  addableColumns = [],
  onAdd,
  forCards = false
}) {
  const styles = useStyles23();
  const t = useT();
  const [dragDepth, setDragDepth] = useState(0);
  const [overChip, setOverChip] = useState(null);
  useEffect(() => {
    if (!isDragging) {
      setDragDepth(0);
      setOverChip(null);
    }
  }, [isDragging]);
  const allowDrop = (event) => {
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
  };
  const drop = (index) => {
    setDragDepth(0);
    setOverChip(null);
    onDrop(index);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses(
        "ppp-grid-group-panel",
        styles.root,
        isDragging && styles.ready,
        isDragging && dragDepth > 0 && styles.over
      ),
      role: "group",
      "aria-label": t("app.components.grid.group-panel"),
      onDragEnter: (event) => {
        allowDrop(event);
        setDragDepth((depth) => depth + 1);
      },
      onDragOver: allowDrop,
      onDragLeave: () => setDragDepth((depth) => {
        if (depth <= 1) setOverChip(null);
        return Math.max(0, depth - 1);
      }),
      onDrop: (event) => {
        event.preventDefault();
        drop(levels.length);
      },
      children: [
        /* @__PURE__ */ jsx(GroupList20Regular, { "aria-hidden": "true" }),
        levels.length > 0 ? levels.map((level, index) => /* @__PURE__ */ jsx(
          ChipOf,
          {
            level,
            index,
            styles,
            isTarget: isDragging && dragDepth > 0 && overChip === index,
            onDragEnter: () => setOverChip(index),
            onDrop: () => drop(index),
            onChipDragStart,
            onChipDragEnd,
            onChange
          },
          level.groupBy.columnName.toLowerCase()
        )) : !forCards && /* @__PURE__ */ jsx("span", { className: styles.hint, children: t("app.components.grid.group-panel-hint") }),
        onAdd && addableColumns.length > 0 && /* @__PURE__ */ jsxs(Menu, { children: [
          /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsxs(
            Button,
            {
              className: mergeClasses("ppp-grid-group-add", styles.add),
              appearance: "subtle",
              size: "small",
              icon: /* @__PURE__ */ jsx(Add16Regular, {}),
              iconPosition: "before",
              children: [
                t("app.components.grid.group-add"),
                /* @__PURE__ */ jsx(ChevronDown16Regular, { "aria-hidden": "true" })
              ]
            }
          ) }),
          /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: addableColumns.map(
            (column) => column.isDateColumn ? /* @__PURE__ */ jsxs(Menu, { children: [
              /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { children: column.title }) }),
              /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: spansFor(column.holdsTime).map((option) => /* @__PURE__ */ jsx(
                MenuItem,
                {
                  onClick: () => onAdd({ columnName: column.columnName, descending: false, dateGrouping: option }),
                  children: t(spanKey(option))
                },
                option
              )) }) })
            ] }, column.columnName) : /* @__PURE__ */ jsx(
              MenuItem,
              {
                onClick: () => onAdd({ columnName: column.columnName, descending: false }),
                children: column.title
              },
              column.columnName
            )
          ) }) })
        ] })
      ]
    }
  );
}
var CLICK_SLOP = 4;
function ChipOf({ level, index, styles, isTarget, onDragEnter, onDrop, onChipDragStart, onChipDragEnd, onChange }) {
  const t = useT();
  const { groupBy, title, isDateColumn, isNumberColumn, holdsTime } = level;
  const descending = groupBy.descending ?? false;
  const span = groupBy.dateGrouping ?? DateGrouping.Day;
  const reverse = () => onChange(index, { ...groupBy, descending: !descending });
  const keepClick = (event) => event.stopPropagation();
  const press = useRef(null);
  const [spanOpen, setSpanOpen] = useState(false);
  const notePress = (event) => {
    press.current = spanOpen ? null : { x: event.clientX, y: event.clientY };
  };
  const reverseOnClick = (event) => {
    const start = press.current;
    press.current = null;
    if (!start || event.detail > 1) return;
    if (Math.abs(event.clientX - start.x) > CLICK_SLOP || Math.abs(event.clientY - start.y) > CLICK_SLOP) return;
    reverse();
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    index > 0 && /* @__PURE__ */ jsx(ChevronRight16Regular, { "aria-hidden": "true" }),
    /* @__PURE__ */ jsxs(
      "span",
      {
        className: mergeClasses("ppp-grid-group-chip", styles.chip, isTarget && styles.chipTarget),
        onPointerDown: notePress,
        onClick: reverseOnClick,
        onDragEnter,
        onDrop: (event) => {
          event.preventDefault();
          event.stopPropagation();
          onDrop();
        },
        children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              className: styles.chipTitle,
              draggable: true,
              onDragStart: (event) => {
                event.dataTransfer?.setData(GROUP_DRAG_TYPE, groupBy.columnName);
                if (event.dataTransfer) event.dataTransfer.effectAllowed = "move";
                onChipDragStart(groupBy.columnName);
              },
              onDragEnd: onChipDragEnd,
              children: title
            }
          ),
          /* @__PURE__ */ jsx("span", { className: styles.chipControl, onClick: keepClick, onPointerDown: keepClick, children: /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "subtle",
              size: "small",
              icon: descending ? /* @__PURE__ */ jsx(ArrowDown16Regular, {}) : /* @__PURE__ */ jsx(ArrowUp16Regular, {}),
              "data-ppp-tooltip": t("app.components.grid.group-reverse"),
              "aria-label": t("app.components.grid.group-reverse"),
              "aria-pressed": descending,
              onClick: reverse
            }
          ) }),
          isDateColumn && /* @__PURE__ */ jsx("span", { className: styles.chipControl, onClick: keepClick, onPointerDown: keepClick, children: /* @__PURE__ */ jsx(
            Dropdown,
            {
              className: styles.span,
              size: "small",
              "aria-label": t("app.components.grid.group-span", [title]),
              value: t(spanKey(span)),
              selectedOptions: [String(span)],
              onOpenChange: (_, data) => setSpanOpen(data.open),
              onOptionSelect: (_, data) => {
                const next = Number(data.optionValue);
                const { rangeSize: _step, ...rest } = groupBy;
                if (next !== span) onChange(index, { ...rest, dateGrouping: next });
              },
              children: spansFor(holdsTime).map((option) => /* @__PURE__ */ jsx(Option, { value: String(option), children: t(spanKey(option)) }, option))
            }
          ) }),
          isDateColumn && dateStepsOf(span).length > 0 && // How many minutes or hours each group covers.
          /* @__PURE__ */ jsx("span", { className: styles.chipControl, onClick: keepClick, onPointerDown: keepClick, children: /* @__PURE__ */ jsx(
            Dropdown,
            {
              className: styles.step,
              size: "small",
              "aria-label": t(
                span === DateGrouping.Minute ? "app.components.grid.group-step-minutes" : "app.components.grid.group-step-hours",
                [title]
              ),
              value: stepOf(groupBy).toLocaleString(),
              selectedOptions: [String(stepOf(groupBy))],
              onOpenChange: (_, data) => setSpanOpen(data.open),
              onOptionSelect: (_, data) => {
                const next = Number(data.optionValue);
                if (next === stepOf(groupBy)) return;
                const { rangeSize: _previous, ...rest } = groupBy;
                onChange(index, next === 1 ? rest : { ...rest, rangeSize: next });
              },
              children: stepOptionsOf(groupBy).map((step) => /* @__PURE__ */ jsx(Option, { value: String(step), children: step.toLocaleString() }, step))
            }
          ) }),
          isNumberColumn && /* @__PURE__ */ jsx("span", { className: styles.chipControl, onClick: keepClick, onPointerDown: keepClick, children: /* @__PURE__ */ jsx(RangeBox, { level, index, className: styles.range, onChange }, String(groupBy.rangeSize ?? "")) }),
          /* @__PURE__ */ jsx("span", { className: styles.chipControl, onClick: keepClick, onPointerDown: keepClick, children: /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "subtle",
              size: "small",
              icon: /* @__PURE__ */ jsx(Dismiss16Regular, {}),
              "data-ppp-tooltip": t("app.components.grid.group-remove", [title]),
              "aria-label": t("app.components.grid.group-remove", [title]),
              onClick: () => onChange(index, null)
            }
          ) })
        ]
      }
    )
  ] });
}
function RangeBox({
  level,
  index,
  className,
  onChange
}) {
  const t = useT();
  const { groupBy, title } = level;
  const shown = groupBy.rangeSize == null ? "" : String(groupBy.rangeSize);
  const [text2, setText] = useState(shown);
  const commit = (value2) => {
    const typed = Number(value2.trim());
    const size = value2.trim() !== "" && Number.isFinite(typed) && typed >= MIN_RANGE_SIZE && typed <= MAX_RANGE_SIZE ? typed : null;
    const current = Number(groupBy.rangeSize ?? NaN);
    if (size === (Number.isFinite(current) && current > 0 ? current : null)) {
      setText(shown);
      return;
    }
    const { rangeSize: _previous, ...rest } = groupBy;
    onChange(index, size === null ? rest : { ...rest, rangeSize: size });
  };
  return /* @__PURE__ */ jsx(
    Input,
    {
      className: mergeClasses("ppp-grid-group-range", className),
      size: "small",
      type: "number",
      inputMode: "decimal",
      value: text2,
      placeholder: t("app.components.grid.group-range-each"),
      "aria-label": t("app.components.grid.group-range-size", [title]),
      "data-ppp-tooltip": t("app.components.grid.group-range-size", [title]),
      onChange: (_, data) => setText(data.value),
      onBlur: (event) => commit(event.currentTarget.value),
      onKeyDown: (event) => {
        if (event.key === "Enter") commit(event.currentTarget.value);
      }
    }
  );
}
var useStyles24 = makeStyles({
  // Fluent's raised surface, its marks down the leading edge, then its content. Kept in step with the
  // Blazor RecordCard's styles.
  card: {
    display: "flex",
    alignItems: "flex-start",
    columnGap: tokens.spacingHorizontalS,
    minWidth: 0,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalM}`,
    backgroundColor: tokens.colorNeutralBackground1,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusMedium,
    boxShadow: tokens.shadow2,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover
    }
  },
  clickable: {
    cursor: "pointer"
  },
  selected: {
    backgroundColor: tokens.colorNeutralBackground1Selected,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1Selected}`,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Selected
    }
  },
  // The checkbox and the mark of a pending change, down the card's leading edge.
  marks: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: tokens.spacingVerticalXS
  },
  content: {
    flex: "1 1 auto",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS
  },
  // The avatar beside the title.
  heading: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    minWidth: 0
  },
  avatar: {
    flex: "none"
  },
  title: {
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: tokens.fontSizeBase400,
    lineHeight: tokens.lineHeightBase400,
    fontWeight: tokens.fontWeightSemibold
  },
  // Each value beside its label: the labels take what they need, up to half the card.
  fields: {
    display: "grid",
    gridTemplateColumns: "fit-content(50%) minmax(0, 1fr)",
    columnGap: tokens.spacingHorizontalM,
    rowGap: tokens.spacingVerticalXS,
    margin: 0
  },
  field: {
    display: "contents"
  },
  label: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    // A page's own dt styles (often bold) don't reach into the card.
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground3
  },
  value: {
    minWidth: 0,
    margin: 0,
    overflowWrap: "anywhere"
  }
});
function RecordCard({
  marks,
  template,
  children,
  avatar,
  title,
  fields,
  selected,
  clickable,
  onClick,
  onDoubleClick,
  className,
  ...attributes
}) {
  const styles = useStyles24();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...attributes,
      className: mergeClasses(
        "ppp-record-card",
        selected && "ppp-record-card--selected",
        clickable && "ppp-record-card--clickable",
        styles.card,
        selected && styles.selected,
        clickable && styles.clickable,
        className
      ),
      ...onClick && { onClick },
      ...onDoubleClick && { onDoubleClick },
      children: [
        marks !== void 0 && marks !== null && marks !== false && /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-record-card-marks", styles.marks), children: marks }),
        template !== void 0 ? /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-record-card-content ppp-record-card-content--template", styles.content), children: template }) : children !== void 0 ? children : /* @__PURE__ */ jsx(RecordCardContent, { avatar, title, fields: fields ?? [] })
      ]
    }
  );
}
function RecordCardContent({
  banner,
  avatar,
  title,
  titleText,
  titleActions,
  fields
}) {
  const styles = useStyles24();
  const titled = title !== void 0 && title !== null;
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-record-card-content", styles.content), children: [
    banner,
    (titled || avatar !== void 0 && avatar !== null) && /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-record-card-heading", styles.heading), children: [
      avatar,
      titled && /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-record-card-title", styles.title), "data-ppp-tooltip": titleText, children: title }),
      titleActions
    ] }),
    fields.length > 0 && /* @__PURE__ */ jsx("dl", { className: mergeClasses("ppp-record-card-fields", styles.fields), children: fields.map((field, index) => /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-record-card-field", styles.field), children: [
      /* @__PURE__ */ jsx("dt", { className: styles.label, children: field.label }),
      /* @__PURE__ */ jsx("dd", { className: styles.value, children: field.value })
    ] }, field.key ?? index)) })
  ] });
}
function RecordCardAvatar({ name, imageUrl, size }) {
  const styles = useStyles24();
  return /* @__PURE__ */ jsx(
    Avatar,
    {
      className: mergeClasses("ppp-record-card-avatar", styles.avatar),
      ...name && { name },
      ...imageUrl && { image: { src: imageUrl } },
      color: "colorful",
      size
    }
  );
}
var useGridCardStyles = makeStyles({
  // As many cards to a row as fit at --ppp-card-min-width, each growing to
  // --ppp-card-max-width (by default sharing the row's width equally). A card
  // never gets wider than the grid. Kept in step with the Blazor grid's cards.
  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(min(var(--ppp-card-min-width, 320px), 100%), var(--ppp-card-max-width, 1fr)))",
    gap: tokens.spacingHorizontalM,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalM}`
  },
  // File tiles are narrower than other cards. A file's name shares its row
  // with the tile's buttons, so it wraps onto a second line before it is cut short.
  fileCards: {
    gridTemplateColumns: "repeat(auto-fill, minmax(min(var(--ppp-card-min-width, 200px), 100%), var(--ppp-card-max-width, 1fr)))",
    "& .ppp-record-card-title": {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 2,
      whiteSpace: "normal",
      overflowWrap: "anywhere"
    }
  },
  // A tile's file-type icon, or an image's thumbnail, in a band across its top.
  fileIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: `calc(${tokens.spacingVerticalXXXL} * 4)`,
    overflow: "hidden",
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground2
  },
  // A thumbnail fills the band, cropped rather than letterboxed.
  fileThumbnail: {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  cardMuted: {
    opacity: 0.4
  },
  // The selector and the mark of a pending change, as one: a click on either is no click on the card.
  marks: {
    display: "contents"
  },
  // The number a card shares with its pin on the Map layout's map, drawn as the pin is — the pin's
  // shape, not a circle, which the map's clusters are.
  pinNumber: {
    position: "relative",
    display: "block",
    flexShrink: 0,
    width: "24px",
    height: "32px",
    filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.35))",
    "& svg": { display: "block" },
    "& path": {
      fill: tokens.colorBrandBackground,
      stroke: tokens.colorNeutralBackground1,
      strokeWidth: "1.5px"
    }
  },
  pinNumberText: {
    position: "absolute",
    left: 0,
    top: "1px",
    width: "24px",
    height: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: tokens.colorNeutralForegroundOnBrand,
    fontSize: "11px",
    fontWeight: tokens.fontWeightBold,
    lineHeight: 1,
    letterSpacing: "-0.02em",
    '&[data-length="3"]': { fontSize: "9px" },
    '&[data-length="4"]': { fontSize: "7.5px" },
    '&[data-length="5"]': { fontSize: "6px" }
  },
  // Fluent's Checkbox / Radio carry their own padding around the indicator;
  // trimmed so the indicator lines up with the card's title.
  selector: {
    "& .fui-Checkbox__indicator, & .fui-Radio__indicator": {
      margin: 0
    }
  }
});
var TILE_THUMBNAIL_SIZE = 512;
function fileThumbnailUrl(record, fileColumn, fileName, canPreview) {
  if (!fileName || !canPreview || !record.id || fileColumn.includes(".") || !isThumbnailSupported(fileName)) {
    return void 0;
  }
  const fileId = record.properties?.[fileColumn]?.value;
  if (!fileId) return void 0;
  return Routes.api.getRetrieveImageRoute(record.tableName, record.id, fileColumn, fileId, TILE_THUMBNAIL_SIZE);
}
var PIN_PATH = "M12 1C5.9 1 1 5.9 1 12c0 8.3 11 19 11 19s11-10.7 11-19C23 5.9 18.1 1 12 1z";
function GridCardPinNumber({ number, label }) {
  const styles = useGridCardStyles();
  const text2 = String(number);
  return /* @__PURE__ */ jsxs("span", { className: mergeClasses("ppp-grid-card-pin-number", styles.pinNumber), role: "img", "aria-label": label, children: [
    /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 32", width: "24", height: "32", "aria-hidden": "true", focusable: "false", children: /* @__PURE__ */ jsx("path", { d: PIN_PATH }) }),
    /* @__PURE__ */ jsx("span", { className: styles.pinNumberText, "data-length": Math.min(text2.length, 5), "aria-hidden": "true", children: text2 })
  ] });
}
function GridCardFileTile({
  record,
  fileColumn,
  heading
}) {
  const styles = useGridCardStyles();
  const actions = useFileActions(record, fileColumn);
  const { title, titleText, fields } = heading(actions.fileName);
  const thumbnailUrl = fileThumbnailUrl(record, fileColumn, actions.fileName, actions.showPreview);
  const [failedUrl, setFailedUrl] = useState();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      RecordCardContent,
      {
        banner: /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-grid-file-tile-icon", styles.fileIcon), children: thumbnailUrl && thumbnailUrl !== failedUrl ? (
          // The name beneath says what it is.
          /* @__PURE__ */ jsx(
            "img",
            {
              className: mergeClasses("ppp-grid-file-tile-thumbnail", styles.fileThumbnail),
              src: thumbnailUrl,
              alt: "",
              loading: "lazy",
              onError: () => setFailedUrl(thumbnailUrl)
            }
          )
        ) : renderFileTypeIcon(actions.fileName, void 0, 48) }),
        title,
        ...titleText !== void 0 && { titleText },
        ...actions.fileName && { titleActions: /* @__PURE__ */ jsx(FileActionButtons, { actions }) },
        fields
      }
    ),
    actions.dialog
  ] });
}
var GridColumnMenuItem = {
  /**
   * Filtering the rows by the column — one condition on it, which the Filter dialog shows with the
   * rest — and taking its filter away, when `allowFiltering` lets users filter.
   */
  Filter: "filter",
  /**
   * Grouping the rows by the column, by day, month, quarter or year for a date, or by it too, when
   * `allowGrouping` lets users group.
   */
  Group: "group",
  /** The totals under the column: a total, average, minimum, maximum or count, as its type takes. */
  Totals: "totals",
  /**
   * Hiding the column and showing it again, and moving it toward the start or the end — from its
   * menu, or by dragging its header onto another's.
   */
  Columns: "columns",
  /**
   * Pinning the column to the table's start or end edge, where it stays in view while the other
   * columns scroll sideways, and unpinning it — from its menu, or by dragging its header among
   * columns pinned otherwise.
   */
  Pin: "pin"
};
var ALL_COLUMN_MENU_ITEMS = [
  GridColumnMenuItem.Filter,
  GridColumnMenuItem.Group,
  GridColumnMenuItem.Totals,
  GridColumnMenuItem.Columns,
  GridColumnMenuItem.Pin
];
var pinRank = (pin) => pin === GridColumnPin.Start ? 0 : pin === GridColumnPin.End ? 2 : 1;
function pinOrder(ids, pinOf) {
  return ids.map((id, index) => ({ id, index, rank: pinRank(pinOf(id)) })).sort((a, b) => a.rank - b.rank || a.index - b.index).map((x) => x.id);
}
function serializePin(pin) {
  return pin === GridColumnPin.Start ? 1 : pin === GridColumnPin.End ? 2 : 0;
}
function deserializePin(value2) {
  return value2 === 1 ? GridColumnPin.Start : value2 === 2 ? GridColumnPin.End : value2 === 0 ? null : void 0;
}
function arrangeColumns(ids, order) {
  if (!order) return [...ids];
  const positions = /* @__PURE__ */ new Map();
  order.forEach((id, index) => {
    if (!positions.has(id)) positions.set(id, index);
  });
  return ids.map((id, index) => ({ id, index, position: positions.get(id) ?? Number.MAX_SAFE_INTEGER })).sort((a, b) => a.position - b.position || a.index - b.index).map((x) => x.id);
}
function moveColumn(ids, order, hidden, id, offset, pinOf = () => void 0) {
  const arranged = arrangeColumns(ids, order);
  const shown = pinOrder(arranged.filter((x) => !hidden.has(x)), pinOf);
  const index = shown.indexOf(id);
  const neighbor = shown[index + offset];
  if (index < 0 || neighbor === void 0 || pinOf(neighbor) !== pinOf(id)) return order;
  const next = arranged.filter((x) => x !== id);
  const neighborIndex = next.indexOf(neighbor);
  next.splice(offset < 0 ? neighborIndex : neighborIndex + 1, 0, id);
  return next.every((x, i) => x === ids[i]) ? null : next;
}
function moveColumnTo(ids, order, id, targetId, after) {
  const arranged = arrangeColumns(ids, order);
  if (id === targetId || !arranged.includes(id) || !arranged.includes(targetId)) return order;
  const next = arranged.filter((x) => x !== id);
  const targetIndex = next.indexOf(targetId);
  next.splice(after ? targetIndex + 1 : targetIndex, 0, id);
  return next.every((x, i) => x === ids[i]) ? null : next;
}
function pinColumn(ids, order, id, pin, pinOf) {
  const arranged = arrangeColumns(ids, order);
  if (!arranged.includes(id)) return order;
  const next = arranged.filter((x) => x !== id);
  if (pin === void 0) {
    const before = new Set(ids.slice(0, Math.max(0, ids.indexOf(id))));
    let after = -1;
    next.forEach((x, index) => {
      if (pinOf(x) === void 0 && before.has(x)) after = index;
    });
    next.splice(after + 1, 0, id);
  } else {
    const pinned = next.filter((x) => pinOf(x) === pin);
    const edge = pin === GridColumnPin.Start ? pinned[pinned.length - 1] : pinned[0];
    if (edge === void 0) return order;
    next.splice(pin === GridColumnPin.Start ? next.indexOf(edge) + 1 : next.indexOf(edge), 0, id);
  }
  return next.every((x, i) => x === ids[i]) ? null : next;
}
function sortByColumn(sort, columnName, descending) {
  const level = descending ? { columnName, descending: true } : { columnName };
  return sort.some((s) => s.columnName === columnName) ? sort.map((s) => s.columnName === columnName ? level : s) : [level];
}
function addToSort(sort, columnName) {
  return sort.some((s) => s.columnName === columnName) ? [...sort] : [...sort, { columnName }];
}
function removeFromSort(sort, columnName) {
  return sort.filter((s) => s.columnName !== columnName);
}
var useStyles25 = makeStyles({
  button: {
    flex: "0 0 auto",
    minWidth: "auto"
  }
});
var AGGREGATE_LABEL_KEYS = {
  [QueryAggregate.None]: "app.components.grid.column-menu-total-count",
  [QueryAggregate.Sum]: "app.components.grid.column-menu-total-sum",
  [QueryAggregate.Average]: "app.components.grid.column-menu-total-average",
  [QueryAggregate.Minimum]: "app.components.grid.column-menu-total-minimum",
  [QueryAggregate.Maximum]: "app.components.grid.column-menu-total-maximum",
  [QueryAggregate.Count]: "app.components.grid.column-menu-total-count"
};
var DATE_GROUPING_LABEL_KEYS = [
  [DateGrouping.Minute, "app.components.grid.column-menu-group-by-minute"],
  [DateGrouping.Hour, "app.components.grid.column-menu-group-by-hour"],
  [DateGrouping.Day, "app.components.grid.column-menu-group-by-day"],
  [DateGrouping.Week, "app.components.grid.column-menu-group-by-week"],
  [DateGrouping.Month, "app.components.grid.column-menu-group-by-month"],
  [DateGrouping.Quarter, "app.components.grid.column-menu-group-by-quarter"],
  [DateGrouping.Year, "app.components.grid.column-menu-group-by-year"],
  [DateGrouping.FiscalPeriod, "app.components.grid.column-menu-group-by-fiscal-period"],
  [DateGrouping.FiscalYear, "app.components.grid.column-menu-group-by-fiscal-year"]
];
var dateGroupingLabelKeys = (holdsTime) => DATE_GROUPING_LABEL_KEYS.filter(([span]) => holdsTime || span !== DateGrouping.Minute && span !== DateGrouping.Hour);
var stopPropagation = (e) => e.stopPropagation();
function GridColumnMenu({
  title,
  sort,
  filter,
  group,
  totals,
  columns,
  pins,
  onResetColumns
}) {
  const t = useT();
  const styles = useStyles25();
  const sections = [];
  const resetItem = onResetColumns && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(ArrowReset20Regular, {}), onClick: onResetColumns, children: t("app.components.grid.column-menu-reset-columns") });
  if (sort) {
    sections.push(
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        sort.direction !== "ascending" && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(ArrowSortUp20Regular, {}), onClick: () => sort.onSort(false), children: t("app.components.grid.column-menu-sort-ascending") }),
        sort.direction !== "descending" && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(ArrowSortDown20Regular, {}), onClick: () => sort.onSort(true), children: t("app.components.grid.column-menu-sort-descending") }),
        sort.direction === void 0 && sort.levels > 0 && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(ArrowSort20Regular, {}), onClick: sort.onAddToSort, children: t("app.components.grid.column-menu-add-to-sort") }),
        sort.direction !== void 0 && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Dismiss20Regular, {}), onClick: sort.onClearSort, children: t("app.components.grid.column-menu-clear-sort") }),
        sort.levels > 1 && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(DismissCircle20Filled, {}), onClick: sort.onClearAllSorts, children: t("app.components.grid.column-menu-clear-all-sorts") })
      ] }, "sort")
    );
  }
  if (filter) {
    sections.push(
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Filter20Regular, {}), onClick: filter.onFilter, children: t("app.components.grid.column-menu-filter-by") }),
        filter.onClear && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(FilterDismiss20Regular, {}), onClick: filter.onClear, children: t("app.components.grid.column-menu-clear-filter") })
      ] }, "filter")
    );
  }
  if (group && (group.onGroup || group.onAddSubgroup)) {
    sections.push(
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        group.onGroup && group.isDate && /* @__PURE__ */ jsxs(
          Menu,
          {
            checkedValues: { dateGrouping: [] },
            onCheckedValueChange: (_, data) => {
              const picked = data.checkedItems[0];
              if (picked !== void 0) group.onGroup?.(Number(picked));
            },
            children: [
              /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(GroupList20Regular, {}), children: t("app.components.grid.column-menu-group-by") }) }),
              /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: dateGroupingLabelKeys(group.holdsTime).map(([dateGrouping, key3]) => /* @__PURE__ */ jsx(MenuItemRadio, { name: "dateGrouping", value: String(dateGrouping), children: t(key3) }, dateGrouping)) }) })
            ]
          }
        ),
        group.onGroup && !group.isDate && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(GroupList20Regular, {}), onClick: () => group.onGroup?.(DateGrouping.Day), children: t("app.components.grid.column-menu-group-by") }),
        group.onAddSubgroup && group.isDate && /* @__PURE__ */ jsxs(
          Menu,
          {
            checkedValues: { subgroupDateGrouping: [] },
            onCheckedValueChange: (_, data) => {
              const picked = data.checkedItems[0];
              if (picked !== void 0) group.onAddSubgroup?.(Number(picked));
            },
            children: [
              /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TextBulletListTree20Regular, {}), children: t("app.components.grid.column-menu-add-subgroup") }) }),
              /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: dateGroupingLabelKeys(group.holdsTime).map(([dateGrouping, key3]) => /* @__PURE__ */ jsx(MenuItemRadio, { name: "subgroupDateGrouping", value: String(dateGrouping), children: t(key3) }, dateGrouping)) }) })
            ]
          }
        ),
        group.onAddSubgroup && !group.isDate && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TextBulletListTree20Regular, {}), onClick: () => group.onAddSubgroup?.(DateGrouping.Day), children: t("app.components.grid.column-menu-add-subgroup") })
      ] }, "group")
    );
  }
  if (totals && totals.offered.length > 0) {
    sections.push(
      /* @__PURE__ */ jsx(MenuGroup, { children: /* @__PURE__ */ jsxs(
        Menu,
        {
          checkedValues: { totals: totals.shown.map(String) },
          onCheckedValueChange: (_, data) => totals.onChange(totals.offered.filter((aggregate) => data.checkedItems.includes(String(aggregate)))),
          children: [
            /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(MathFormula20Regular, {}), children: t("app.components.grid.totals") }) }),
            /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs(MenuList, { children: [
              totals.offered.map((aggregate) => /* @__PURE__ */ jsx(MenuItemCheckbox, { name: "totals", value: String(aggregate), children: t(AGGREGATE_LABEL_KEYS[aggregate]) }, aggregate)),
              totals.onFormat && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(MenuDivider, {}),
                /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(NumberSymbol20Regular, {}), onClick: totals.onFormat, children: t("app.components.grid.column-menu-totals-format") })
              ] })
            ] }) })
          ]
        }
      ) }, "totals")
    );
  }
  if (columns) {
    sections.push(
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        /* @__PURE__ */ jsx(
          MenuItem,
          {
            icon: /* @__PURE__ */ jsx(TableMoveLeft20Regular, {}),
            disabled: !columns.canMoveLeft,
            onClick: () => columns.onMove(-1),
            children: t("app.components.grid.column-menu-move-left")
          }
        ),
        /* @__PURE__ */ jsx(
          MenuItem,
          {
            icon: /* @__PURE__ */ jsx(TableMoveRight20Regular, {}),
            disabled: !columns.canMoveRight,
            onClick: () => columns.onMove(1),
            children: t("app.components.grid.column-menu-move-right")
          }
        ),
        /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(EyeOff20Regular, {}), disabled: !columns.canHide, onClick: columns.onHide, children: t("app.components.grid.column-menu-hide") }),
        columns.onRemove && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TableDeleteColumn20Regular, {}), onClick: columns.onRemove, children: t("app.components.grid.column-menu-remove") }),
        columns.hidden.length > 0 && /* @__PURE__ */ jsxs(Menu, { children: [
          /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Eye20Regular, {}), children: t("app.components.grid.column-menu-show") }) }),
          /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: columns.hidden.map((hidden) => /* @__PURE__ */ jsx(MenuItem, { onClick: () => columns.onShow(hidden.id), children: hidden.title }, hidden.id)) }) })
        ] }),
        !pins && resetItem
      ] }, "columns")
    );
  }
  if (pins) {
    sections.push(
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        pins.pin !== GridColumnPin.Start && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Pin20Regular, {}), onClick: () => pins.onPin(GridColumnPin.Start), children: t("app.components.grid.column-menu-pin-start") }),
        pins.pin !== GridColumnPin.End && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Pin20Regular, {}), onClick: () => pins.onPin(GridColumnPin.End), children: t("app.components.grid.column-menu-pin-end") }),
        pins.pin !== void 0 && /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(PinOff20Regular, {}), onClick: () => pins.onPin(void 0), children: t("app.components.grid.column-menu-unpin") }),
        resetItem
      ] }, "pins")
    );
  }
  if (sections.length === 0) return null;
  return /* @__PURE__ */ jsxs(Menu, { positioning: "below-end", children: [
    /* @__PURE__ */ jsx(MenuTrigger, { children: /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "subtle",
        size: "small",
        icon: /* @__PURE__ */ jsx(ChevronDown16Regular, {}),
        "aria-label": `${t("app.components.grid.column-menu")}: ${title}`,
        "data-ppp-tooltip": t("app.components.grid.column-menu"),
        className: mergeClasses("ppp-grid-column-menu-button", styles.button),
        onClick: stopPropagation
      }
    ) }),
    /* @__PURE__ */ jsx(MenuPopover, { className: "ppp-grid-column-menu", onClick: stopPropagation, children: /* @__PURE__ */ jsx(MenuList, { children: sections.flatMap(
      (section, index) => index === 0 ? [section] : [/* @__PURE__ */ jsx(MenuDivider, {}, `divider-${index}`), section]
    ) }) })
  ] });
}
var SEARCH_DEBOUNCE_MS2 = 300;
function parsePixelWidth(value2) {
  const trimmed = value2.trim();
  if (!trimmed.toLowerCase().endsWith("px")) return void 0;
  const num = Number(trimmed.slice(0, -2));
  return Number.isFinite(num) ? num : void 0;
}
var columnHelper = createColumnHelper();
var NearDistanceColumn = "@distance";
var NEAREST_FIRST = [{ columnName: NearDistanceColumn, descending: false }];
var NO_NEAR_DISTANCES = { key: "", byId: /* @__PURE__ */ new Map(), truncated: false };
function serializeNear(near) {
  return {
    y: near.latitude,
    x: near.longitude,
    d: near.distance,
    ...near.unit === 1 && { u: 1 },
    t: near.label
  };
}
function deserializeNear(persisted) {
  if (!persisted || typeof persisted !== "object") return null;
  const { y, x, d, u, t: label } = persisted;
  if (![y, x, d].every((value2) => typeof value2 === "number" && Number.isFinite(value2)) || Math.abs(y) > 90 || Math.abs(x) > 180 || d <= 0 || d * (u === 1 ? 1e3 : 1609.344) > Math.PI * 63710088e-1) {
    return null;
  }
  return { latitude: y, longitude: x, distance: d, unit: u === 1 ? 1 : 0, label: typeof label === "string" ? label : "" };
}
var AGGREGATE_ORDER = [
  QueryAggregate.Sum,
  QueryAggregate.Average,
  QueryAggregate.Minimum,
  QueryAggregate.Maximum,
  QueryAggregate.Count
];
var NO_FORMATS = /* @__PURE__ */ new Map();
var NUMERIC_COLUMN_TYPES = /* @__PURE__ */ new Set([
  ColumnType.Integer,
  ColumnType.BigInt,
  ColumnType.Decimal,
  ColumnType.Double,
  ColumnType.Money
]);
function typeAlign(type) {
  if (type === void 0) return void 0;
  if (NUMERIC_COLUMN_TYPES.has(type)) return "end";
  return type === ColumnType.Boolean ? "center" : void 0;
}
var EMPTY_GROUP_KEYS = /* @__PURE__ */ new Set();
var EMPTY_GROUP_LEVELS = [];
var EMPTY_COLUMN_IDS = /* @__PURE__ */ new Set();
var EMPTY_PINS = /* @__PURE__ */ new Map();
var UNFILTERABLE_TYPES = /* @__PURE__ */ new Set([
  ColumnType.File,
  ColumnType.Image,
  ColumnType.RelatedRecords,
  ColumnType.CalendarRules,
  ColumnType.ManagedProperty,
  ColumnType.Virtual
]);
function isRowControlTarget(target) {
  return target instanceof Element && target.closest('a, button, input, select, textarea, [role="button"], [role="link"]') !== null;
}
var PINNED_COLUMN_WIDTH = 150;
var EMPTY_COLUMN_NAMES = [];
var GROUP_KEY_SEPARATOR = "";
var EMPTY_RECORDS = [];
var EMPTY_ROW_SELECTION = {};
var EMPTY_RESOLVED_COLUMNS = [];
var EMPTY_VIEW_LIST = [];
var EMPTY_COLUMN_SIZING = {};
var ADDED_COLUMN_WIDTH = 150;
var DEFAULT_PAGE_SIZES = [10, 20, 50, 100];
var DEFAULT_PAGE_SIZE = 50;
function TemplateColumnEditCell({
  rendererProps,
  editRenderer,
  inlineEditCellClass
}) {
  const { record, setColumnValue } = useRecordContext();
  const editProps = {
    ...rendererProps,
    // Read from the live record-context record (loadedRecord + pendingChanges)
    // rather than the TanStack row snapshot in `rendererProps.record`. The
    // snapshot is frozen at fetch time, but `setColumnValue` writes to the
    // context's working copy — so a custom editRenderer reading
    // `record.properties[col]` off the snapshot never sees its own edits
    // (input appears stuck while the row dirties). Bound `<ColumnEdit>` editors
    // already read the context record via their column hooks; this gives the
    // imperative editRenderer the same live view.
    record: record ?? rendererProps.record,
    setValue: setColumnValue
  };
  return /* @__PURE__ */ jsx("div", { className: inlineEditCellClass, children: editRenderer(editProps) });
}
function MainGrid(props) {
  return /* @__PURE__ */ jsx(MainContext, { children: /* @__PURE__ */ jsx(MainGridImpl, { ...props }) });
}
function MainGridImpl({
  tableName,
  viewId,
  pageSize: initialPageSize = DEFAULT_PAGE_SIZE,
  pageSizes = DEFAULT_PAGE_SIZES,
  pagingMode = PagingMode.Paged,
  layout: layoutProp,
  defaultLayout = GridLayout.Table,
  onLayoutChanged,
  mapLatitudeColumn = "address1_latitude",
  mapLongitudeColumn = "address1_longitude",
  mapHeight,
  mapPageSize = 250,
  mapMaximumRows = 1e3,
  showMapPinNumbers = false,
  showMapPrintButton = false,
  mapShowsSelectedOnly = true,
  mapPrintList = GridMapPrintList.Selected,
  allowNearSearch = false,
  nearDistances: nearDistanceChoices,
  nearDistance,
  nearDistanceUnit,
  allowChangingLayout = false,
  cardRenderer,
  cardImageColumn,
  cardImageSize = 40,
  cardFileColumn,
  minCardWidth,
  allowChangingPageSize = true,
  selectionMode = "multiple",
  onSelectedRecordsChange,
  selectedRecords: controlledSelectedRecords,
  onRefresh,
  cellRenderers,
  typeRenderers,
  filters,
  allowNavigateOnPrimaryNameClick = true,
  allowOpenOnRowDoubleClick = true,
  showRecordLinks = true,
  onNavigate,
  children,
  showRefreshButton = true,
  minHeight = "250px",
  maxHeight,
  fullSize = false,
  parentRecord,
  relationshipName,
  selfReferencingRole,
  dataSource,
  allowSearch = true,
  allowFiltering = false,
  allowSavedViews = false,
  signInUrl = "/Account/Login",
  savedViewsKey,
  allowAddingColumns = false,
  hidePaging = false,
  title,
  persistedStateQueryParameter,
  includeSearchInPersistedState = false,
  initialSearchText,
  onSearchTextChange,
  allowPreviewForFileColumns = true,
  allowDownloadForFileColumns = true,
  columnWidthScale = 1,
  columnAggregates,
  groupBy,
  groupByDescending = false,
  groupByDateGrouping = DateGrouping.Day,
  groupLevels,
  onGroupLevelsChanged,
  maximumRangedValues,
  allowGrouping = false,
  onGroupByChanged,
  columnMenuItems = ALL_COLUMN_MENU_ITEMS,
  defaultViewId: defaultViewId$1,
  viewIds,
  customViewDefinitions,
  viewSort = ViewSort.NameAscending,
  transformViewAsync,
  borderVisible = true,
  selectFromEntireRow = true,
  allowEdit = false,
  editable: editableProp,
  onEditableChanged,
  className,
  style
}) {
  const styles = useMainGridStyles();
  const cardStyles = useGridCardStyles();
  const t = useT();
  const parentTableMetadataQuery = useTableMetadata(parentRecord?.tableName ?? "", {
    enabled: !!parentRecord?.tableName
  });
  const gridTableMetadataQuery = useTableMetadata(tableName ?? "", {
    enabled: !!tableName
  });
  const gridTableMetadata = gridTableMetadataQuery.data;
  const isManyToManySubGrid = useMemo(() => {
    if (!relationshipName || !parentTableMetadataQuery.data) return false;
    return parentTableMetadataQuery.data.manyToMany?.some(
      (rel) => rel.relationshipName === relationshipName
    ) ?? false;
  }, [relationshipName, parentTableMetadataQuery.data]);
  const { declaredColumns, templateColumns, relatedColumns, orderedDeclarations, toolbarChildren } = extractGridColumnOverrides(children);
  const declaredColumnsByName = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    for (const col of declaredColumns) map.set(col.columnName, col);
    return map;
  }, [declaredColumns]);
  const declaredAggregatesKey = JSON.stringify(
    declaredColumns.filter((c) => c.visible !== false && c.aggregates && c.aggregates.length > 0).map((c) => ({ columnName: c.columnName, aggregates: c.aggregates }))
  );
  const columnAggregatesKey = JSON.stringify(columnAggregates ?? null);
  const givenAggregatesByColumn = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    const add = ({ columnName, aggregates }) => {
      if (!aggregates || aggregates.length === 0) return;
      const key3 = columnName.toLowerCase();
      const entry = map.get(key3) ?? { columnName, aggregates: /* @__PURE__ */ new Set(), formats: /* @__PURE__ */ new Map() };
      for (const { aggregate } of aggregates) {
        if (aggregate !== QueryAggregate.None) entry.aggregates.add(aggregate);
      }
      for (const [aggregate, format] of formatsOf(aggregates)) {
        if (!entry.formats.has(aggregate)) entry.formats.set(aggregate, format);
      }
      map.set(key3, entry);
    };
    for (const column of JSON.parse(declaredAggregatesKey)) add(column);
    for (const column of columnAggregates ?? []) add(column);
    return map;
  }, [declaredAggregatesKey, columnAggregatesKey]);
  const templateColumnsById = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    for (const tpl of templateColumns) map.set(tpl.id, tpl);
    return map;
  }, [templateColumns]);
  const relatedColumnsById = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    for (const related of relatedColumns) map.set(related.columnId, related);
    return map;
  }, [relatedColumns]);
  const hasDeclaredColumns = declaredColumns.length > 0 || templateColumns.length > 0 || relatedColumns.length > 0;
  const isVirtualize = pagingMode === PagingMode.Virtualize;
  const warnAboutUnsavedChanges = useWarnAboutUnsavedChanges();
  const parentMainContext = useMainContext();
  const radioGroupName = useId$1("ppp-grid-selection");
  const overlayTargetId = useId$1("ppp-grid-overlay");
  const activeGridOverlay = useOverlayForTarget(overlayTargetId);
  const pageOverlay = useOverlayForTarget(void 0);
  const isDialogOpen = useIsDialogOpen();
  const pageOverlayCovers = pageOverlay !== null && !isDialogOpen;
  const { ppp } = usePowerPortalsPro();
  const dialog = useDialogService();
  const runWithOverlay = useRunWithOverlay();
  const [exporting, setExporting] = useState(false);
  const exportAbortRef = useRef(null);
  useEffect(() => () => exportAbortRef.current?.abort(), []);
  const isNarrowViewport = useIsNarrowViewport();
  const [internalEditable, setInternalEditable] = useState(false);
  const isControlledEditable = editableProp !== void 0;
  const editable = isControlledEditable ? editableProp : internalEditable;
  const [isEditableTransitionPending, startEditableTransition] = useTransition();
  const handleEditableToggle = useCallback(
    async (next) => {
      if (!next && parentMainContext?.isDirty) {
        const proceed = await warnAboutUnsavedChanges();
        if (!proceed) return;
      }
      if (isControlledEditable) {
        onEditableChanged?.(next);
        return;
      }
      startEditableTransition(() => {
        setInternalEditable(next);
      });
      onEditableChanged?.(next);
    },
    [
      isControlledEditable,
      onEditableChanged,
      parentMainContext,
      warnAboutUnsavedChanges
    ]
  );
  const showSettingsEditableRow = allowEdit && !isControlledEditable;
  const showSettingsPageSizeRow = allowChangingPageSize && isNarrowViewport && !isVirtualize;
  const inlineEditDisabled = parentMainContext === null;
  const [initialPersistedState] = useState(
    () => readPersistedGridStateFromUrl(persistedStateQueryParameter)
  );
  const isLayoutControlled = layoutProp !== void 0;
  const [internalLayout, setInternalLayout] = useState(() => {
    const restored = initialPersistedState?.l;
    return allowChangingLayout && Object.values(GridLayout).includes(restored) ? restored : defaultLayout;
  });
  const layout = isLayoutControlled ? layoutProp : internalLayout;
  const GridMap = useGridMapRenderer();
  const isMapLayout = (value2) => value2 === GridLayout.Map || value2 === GridLayout.MapOnly;
  const asksFor = (value2) => layoutProp === value2 || !isLayoutControlled && defaultLayout === value2;
  if (!GridMap && (asksFor(GridLayout.Map) || asksFor(GridLayout.MapOnly))) {
    throw new Error(
      "A grid's Map layouts need @powerportalspro/react-maps: put its <MapsProvider> around the app."
    );
  }
  if (dataSource && asksFor(GridLayout.MapOnly)) {
    throw new Error(
      "A grid's MapOnly layout loads every page itself, which a shared dataSource pages for every grid and chart bound to it: use GridLayout.Map, or a grid of its own."
    );
  }
  const showsMap = isMapLayout(layout) && GridMap !== null;
  const showsMapOnly = layout === GridLayout.MapOnly && GridMap !== null && !dataSource;
  const layoutChoice = layout === GridLayout.Auto ? layout : showsMapOnly ? GridLayout.MapOnly : showsMap ? GridLayout.Map : isMapLayout(layout) ? GridLayout.Cards : layout;
  const showsCards = layout === GridLayout.Cards || isMapLayout(layout) || layout === GridLayout.Auto && isNarrowViewport;
  const [mapFocusId, setMapFocusId] = useState(null);
  const [mapSelectedOnlyChoice, setMapSelectedOnlyChoice] = useState();
  const showsMapBesideCards = showsMap && !showsMapOnly;
  const offersMapPrintList = showsMapBesideCards && showMapPrintButton;
  const mapSelectedOnly = mapSelectedOnlyChoice ?? mapShowsSelectedOnly;
  const keepsMapToSelection = showsMapBesideCards && mapSelectedOnly;
  const [mapPrintListChoice, setMapPrintListChoice] = useState();
  const shownMapPrintList = mapPrintListChoice ?? mapPrintList;
  const mapBoundsRef = useRef(null);
  const [mapPrint, setMapPrint] = useState(null);
  const hasMapColumn = (column) => !!gridTableMetadata?.columns.some((c) => c.columnName?.toLowerCase() === column.toLowerCase());
  const hasMapColumns = hasMapColumn(mapLatitudeColumn) && hasMapColumn(mapLongitudeColumn);
  const offersMapLayout = GridMap !== null && hasMapColumns && !dataSource;
  const mapColumnsKey = showsMap && hasMapColumns ? `${mapLatitudeColumn},${mapLongitudeColumn}` : "";
  const mapColumnsPending = showsMap && !!tableName && gridTableMetadataQuery.status === QueryStatus.Loading;
  const mapTitleColumn = gridTableMetadata?.primaryNameColumn;
  const NearSearchButton = useGridNearSearch();
  const offersNearSearch = allowNearSearch && NearSearchButton !== null && hasMapColumns && !dataSource;
  const [near, setNear] = useState(() => deserializeNear(initialPersistedState?.nr));
  const activeNear = offersNearSearch ? near : null;
  const nearPending = allowNearSearch && !!near && !!tableName && gridTableMetadataQuery.status === QueryStatus.Loading;
  const nearKey = activeNear ? JSON.stringify([activeNear.latitude, activeNear.longitude, activeNear.distance, activeNear.unit]) : "";
  const offersColumnMenu = (item) => columnMenuItems.includes(item);
  const [userAggregates, setUserAggregates] = useState(() => {
    const map = /* @__PURE__ */ new Map();
    if (initialPersistedState?.a && columnMenuItems.includes(GridColumnMenuItem.Totals)) {
      for (const [columnName, value2] of Object.entries(initialPersistedState.a)) {
        if (!columnName || typeof value2 !== "number") continue;
        map.set(columnName.toLowerCase(), {
          columnName,
          aggregates: AGGREGATE_ORDER.filter((aggregate) => (value2 & aggregate) !== 0)
        });
      }
    }
    return map;
  });
  const [userFormats, setUserFormats] = useState(() => {
    const map = /* @__PURE__ */ new Map();
    if (initialPersistedState?.f && typeof initialPersistedState.f === "object" && columnMenuItems.includes(GridColumnMenuItem.Totals)) {
      for (const [columnName, value2] of Object.entries(initialPersistedState.f)) {
        const formats = deserializeAggregateFormats(value2);
        if (columnName && formats.size > 0) map.set(columnName.toLowerCase(), { columnName, formats });
      }
    }
    return map;
  });
  const formatsWith = (formats, columnName) => {
    const key3 = columnName.toLowerCase();
    return new Map([...givenAggregatesByColumn.get(key3)?.formats ?? NO_FORMATS, ...formats.get(key3)?.formats ?? NO_FORMATS]);
  };
  const [totalsFormatOpen, setTotalsFormatOpen] = useState(null);
  const [hiddenColumns, setHiddenColumns] = useState(() => {
    if (!columnMenuItems.includes(GridColumnMenuItem.Columns)) return EMPTY_COLUMN_IDS;
    return new Set((initialPersistedState?.h ?? []).filter((id) => typeof id === "string" && id.length > 0));
  });
  const [viewColumnNames, setViewColumnNames] = useState(EMPTY_COLUMN_NAMES);
  const [columnOrder, setColumnOrder] = useState(() => {
    const order = initialPersistedState?.o?.filter((id) => typeof id === "string" && id.length > 0);
    const arranges = columnMenuItems.includes(GridColumnMenuItem.Columns) || columnMenuItems.includes(GridColumnMenuItem.Pin);
    return arranges && order && order.length > 0 ? order : null;
  });
  const [userPins, setUserPins] = useState(() => {
    const pins = /* @__PURE__ */ new Map();
    if (initialPersistedState?.n && columnMenuItems.includes(GridColumnMenuItem.Pin)) {
      for (const [id, value2] of Object.entries(initialPersistedState.n)) {
        const pin = deserializePin(value2);
        if (id && pin !== void 0) pins.set(id, pin);
      }
    }
    return pins;
  });
  const pinLookupFor = useCallback(
    (pins) => (id) => pins.has(id) ? pins.get(id) ?? void 0 : declaredColumnsByName.get(id)?.pin ?? templateColumnsById.get(id)?.pin ?? relatedColumnsById.get(id)?.pin,
    [declaredColumnsByName, templateColumnsById, relatedColumnsById]
  );
  const pinOf = useMemo(() => pinLookupFor(userPins), [pinLookupFor, userPins]);
  const withPin = (id, pin) => {
    const next = new Map(userPins);
    if (pin === pinLookupFor(EMPTY_PINS)(id)) next.delete(id);
    else next.set(id, pin ?? null);
    return next;
  };
  const aggregatesByColumn = useMemo(() => {
    if (userAggregates.size === 0 && userFormats.size === 0) return givenAggregatesByColumn;
    const map = new Map(givenAggregatesByColumn);
    for (const [key3, { columnName, aggregates }] of userAggregates) {
      if (aggregates.length === 0) map.delete(key3);
      else map.set(key3, { columnName, aggregates: new Set(aggregates), formats: givenAggregatesByColumn.get(key3)?.formats ?? NO_FORMATS });
    }
    for (const [key3, { formats }] of userFormats) {
      const entry = map.get(key3);
      if (entry) map.set(key3, { ...entry, formats: new Map([...entry.formats, ...formats]) });
    }
    return map;
  }, [givenAggregatesByColumn, userAggregates, userFormats]);
  const requestedAggregates = useMemo(() => {
    const hidden = new Set([...hiddenColumns].map((id) => id.toLowerCase()));
    return [...aggregatesByColumn.values()].filter(({ columnName }) => !hidden.has(columnName.toLowerCase())).flatMap(
      ({ columnName, aggregates, formats }) => AGGREGATE_ORDER.filter((aggregate) => aggregates.has(aggregate)).map((aggregate) => ({
        columnName,
        aggregate,
        format: formats.get(aggregate) || null
      }))
    );
  }, [aggregatesByColumn, hiddenColumns]);
  const usersMayGroup = allowGrouping;
  const groupByColumn = groupBy?.trim();
  const groupLevelsKey = groupBySignatureOf(groupLevels ?? EMPTY_GROUP_LEVELS);
  const propsGroupLevels = useMemo(
    () => groupLevels && groupLevels.length > 0 ? groupLevels.filter((level) => level.columnName?.trim()).slice(0, MAX_GROUP_LEVELS).map((level) => ({ ...level, columnName: level.columnName.trim() })) : groupByColumn ? [{ columnName: groupByColumn, descending: groupByDescending, dateGrouping: groupByDateGrouping }] : EMPTY_GROUP_LEVELS,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [groupLevelsKey, groupByColumn, groupByDescending, groupByDateGrouping]
  );
  const groupByProps = {
    levels: groupLevelsKey,
    column: groupByColumn ? groupByColumn.toLowerCase() : null,
    descending: groupByDescending,
    dateGrouping: groupByDateGrouping
  };
  const [groupingState, setGroupingState] = useState(() => ({
    user: usersMayGroup && initialPersistedState?.g ? { value: deserializeGroupLevels(initialPersistedState.g) } : null,
    props: groupByProps
  }));
  let userGroupBy = groupingState.user;
  if (!sameGroupByProps(groupingState.props, groupByProps)) {
    if (userGroupBy && !takesUpUserChoice(groupingState.props, groupByProps, userGroupBy.value)) userGroupBy = null;
    setGroupingState({ user: userGroupBy, props: groupByProps });
  }
  const setUserGroupLevels = (value2) => setGroupingState((previous) => ({ ...previous, user: { value: value2 } }));
  const currentGroupLevels = userGroupBy ? userGroupBy.value : propsGroupLevels.length > 0 || !dataSource ? propsGroupLevels : dataSource.groupBy;
  const activeGroupLevels = currentGroupLevels;
  const currentGroupBy = currentGroupLevels[0] ?? null;
  const activeGroupBy = currentGroupBy;
  const reportGroupingChange = (from, to) => {
    if (groupBySignatureOf(from.slice(0, 1)) !== groupBySignatureOf(to.slice(0, 1))) onGroupByChanged?.(to[0] ?? null);
    if (groupBySignatureOf(from) !== groupBySignatureOf(to)) onGroupLevelsChanged?.([...to]);
  };
  useEffect(() => {
    const restored = groupingState.user;
    if (restored) reportGroupingChange(propsGroupLevels, restored.value);
  }, []);
  const groupBySignature = groupBySignatureOf(activeGroupLevels);
  const persistedGroup = (chosen, next) => usersMayGroup && chosen ? serializeGroupLevels(next) : void 0;
  const showsGroupPanel = allowGrouping;
  const [groupDragColumn, setGroupDragColumn] = useState(null);
  const [columnDrag, setColumnDrag] = useState(null);
  const [columnDrop, setColumnDrop] = useState(null);
  const [collapsedGroupsState, setCollapsedGroupsState] = useState({ signature: "", keys: EMPTY_GROUP_KEYS });
  const sharedCollapsedKey = dataSource && groupBySignatureOf(dataSource.groupBy) === groupBySignature ? [...dataSource.collapsedGroups].sort().join(GROUP_KEY_SEPARATOR) : null;
  const sharedCollapsedGroups = useMemo(
    () => sharedCollapsedKey === null ? null : sharedCollapsedKey ? new Set(sharedCollapsedKey.split(GROUP_KEY_SEPARATOR)) : EMPTY_GROUP_KEYS,
    [sharedCollapsedKey]
  );
  const collapsedGroups = sharedCollapsedGroups ?? (collapsedGroupsState.signature === groupBySignature ? collapsedGroupsState.keys : EMPTY_GROUP_KEYS);
  const collapsedGroupsKey = [...collapsedGroups].sort().join(GROUP_KEY_SEPARATOR);
  const setCollapsedGroups = useCallback(
    (keys) => {
      if (dataSource) dataSource.setCollapsedGroups([...keys]);
      else setCollapsedGroupsState({ signature: groupBySignature, keys });
    },
    [dataSource, groupBySignature]
  );
  const toggleGroup = useCallback(
    (key3) => {
      const keys = new Set(collapsedGroups);
      if (!keys.delete(key3)) keys.add(key3);
      setCollapsedGroups(keys);
    },
    [collapsedGroups, setCollapsedGroups]
  );
  const forwardedGroupingRef = useRef("");
  useEffect(() => {
    if (!dataSource || groupBySignature === forwardedGroupingRef.current) return;
    forwardedGroupingRef.current = groupBySignature;
    dataSource.setGroupBy(activeGroupLevels);
  }, [dataSource, groupBySignature, activeGroupLevels]);
  const [_internalPage, _setInternalPage] = useState(
    () => pagingMode === PagingMode.Virtualize ? 1 : initialPersistedState?.p ?? 1
  );
  const [_internalPageSize, _setInternalPageSize] = useState(
    () => initialPersistedState?.ps ?? initialPageSize
  );
  const [selectedViewId, setSelectedViewId] = useState(
    () => initialPersistedState?.v ?? void 0
  );
  const [_internalSort, _setInternalSort] = useState(
    () => {
      const persisted = deserializeSorts(initialPersistedState?.s);
      if (persisted.length > 0) return persisted;
      for (const col of declaredColumns) {
        if (col.isDefaultSortColumn) {
          return [
            {
              columnName: col.columnName,
              descending: col.initialSortDirection === "desc"
            }
          ];
        }
      }
      return [];
    }
  );
  const startingSearchText = (includeSearchInPersistedState ? initialPersistedState?.q : void 0) || initialSearchText || "";
  const [_internalSearchText, _setInternalSearchText] = useState(startingSearchText);
  const [_internalDebouncedSearchText, _setInternalDebouncedSearchText] = useState(startingSearchText);
  const page = dataSource ? dataSource.page : _internalPage;
  const pageSize = dataSource ? dataSource.pageSize : _internalPageSize;
  const requestPageSize = showsMapOnly ? Math.min(Math.max(Math.trunc(mapPageSize), 1), 5e3) : pageSize;
  const accumulates = isVirtualize || showsMapOnly;
  const sort = dataSource ? dataSource.sort : _internalSort;
  const searchText = dataSource ? dataSource.search : _internalSearchText;
  const debouncedSearchText = dataSource ? dataSource.search : _internalDebouncedSearchText;
  const setPage = useCallback(
    (next) => {
      if (dataSource) dataSource.setPage(next);
      else _setInternalPage(next);
    },
    [dataSource]
  );
  const setPageSize = useCallback(
    (next) => {
      if (dataSource) dataSource.setPageSize(next);
      else _setInternalPageSize(next);
    },
    [dataSource]
  );
  const setSort = useCallback(
    (next) => {
      if (dataSource) dataSource.setSort(next);
      else _setInternalSort(next);
    },
    [dataSource]
  );
  const setSearchText = useCallback(
    (next) => {
      if (dataSource) dataSource.setSearch(next);
      else _setInternalSearchText(next);
    },
    [dataSource]
  );
  const onSearchTextChangeRef = useRef(onSearchTextChange);
  onSearchTextChangeRef.current = onSearchTextChange;
  const setDebouncedSearchText = useCallback(
    (next) => {
      if (!dataSource) _setInternalDebouncedSearchText(next);
    },
    [dataSource]
  );
  const isSelectionControlled = controlledSelectedRecords !== void 0;
  const [internalRowSelection, setInternalRowSelection] = useState({});
  const controlledRowSelection = useMemo(() => {
    if (!isSelectionControlled) return EMPTY_ROW_SELECTION;
    const map = {};
    for (const r of controlledSelectedRecords) {
      if (r.id) map[r.id] = true;
    }
    return map;
  }, [isSelectionControlled, controlledSelectedRecords]);
  const rowSelection = isSelectionControlled ? controlledRowSelection : internalRowSelection;
  const isSelectionControlledRef = useRef(isSelectionControlled);
  isSelectionControlledRef.current = isSelectionControlled;
  const onSelectedRecordsChangeRef = useRef(onSelectedRecordsChange);
  onSelectedRecordsChangeRef.current = onSelectedRecordsChange;
  const requestEmptySelection = useCallback(() => {
    if (isSelectionControlledRef.current) {
      onSelectedRecordsChangeRef.current?.(EMPTY_RECORDS);
    } else {
      setInternalRowSelection(EMPTY_ROW_SELECTION);
    }
  }, []);
  const [columnSizing, setColumnSizing] = useState({});
  const resizingRef = useRef(false);
  const headerPressOnControlRef = useRef(false);
  const tableContainerRef = useRef(null);
  const rootRef = useRef(null);
  const loadMoreSentinelRef = useRef(null);
  const setLoadMoreSentinel = useCallback((element) => {
    loadMoreSentinelRef.current = element;
  }, []);
  const viewsResult = useViewsForTable(tableName ?? "", { enabled: !viewId && !!tableName });
  const dataverseViews = viewsResult.data ?? EMPTY_VIEW_LIST;
  const customViewsKey = JSON.stringify(customViewDefinitions ?? []);
  const viewIdsKey = viewIds ? viewIds.join(",") : "";
  const savedViewsControl = useMemo(
    () => savedViewControl(SavedViewControlKind.Grid, allowSavedViews ? savedViewsKey : void 0),
    [allowSavedViews, savedViewsKey]
  );
  const savedViews = useSavedViews({
    enabled: allowSavedViews && !viewId && !dataSource,
    tableName,
    control: savedViewsControl
  });
  const allCustomViews = useMemo(
    () => savedViews.views.length === 0 ? customViewDefinitions : [...customViewDefinitions ?? [], ...savedViews.views.map((view) => view.definition)],
    // `customViewsKey` covers the page's views' content, as below.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customViewsKey, savedViews.views]
  );
  const views = useMemo(
    () => composeViewsList({
      dataverseViews,
      customViewDefinitions: allCustomViews,
      viewIds: viewIds && savedViews.views.length > 0 ? [...viewIds, ...savedViews.views.map((view) => view.id)] : viewIds,
      viewSort
    }),
    // Structural keys cover content; viewSort is a primitive.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataverseViews, customViewsKey, viewIdsKey, viewSort, allCustomViews]
  );
  const isHiddenView = (id) => savedViews.available && isViewHidden(savedViews.settings, id, savedViewsControl);
  useEffect(() => {
    if (selectedViewId) return;
    if (views.length === 0) return;
    if (savedViews.loading) return;
    const ids = views.map((v) => v.id);
    const preferred = (savedViews.available ? defaultViewId(savedViews.settings, ids, savedViewsControl) : void 0) ?? (defaultViewId$1 && ids.includes(defaultViewId$1) ? defaultViewId$1 : void 0) ?? ids.find((id) => !isHiddenView(id)) ?? ids[0];
    if (preferred) setSelectedViewId(preferred);
  }, [selectedViewId, views, defaultViewId$1, savedViews.loading, savedViews.available, savedViews.settings, savedViewsControl]);
  const resolvedViewId = viewId ?? selectedViewId;
  const pageViewLayouts = useMemo(
    () => new Map((customViewDefinitions ?? []).map((view) => [view.id, viewLayoutOf(view)])),
    // The content stands in for the array, which a page may build anew each render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customViewsKey]
  );
  const viewLayout = (id) => id === void 0 ? void 0 : savedViews.views.find((view) => view.id === id)?.gridLayout ?? pageViewLayouts.get(id);
  const isPageArranged = (id) => id !== void 0 && !savedViews.views.some((view) => view.id === id) && !!pageViewLayouts.get(id);
  const savedColumnLabels = useMemo(() => {
    const labels = /* @__PURE__ */ new Map();
    for (const column of viewLayout(resolvedViewId)?.columns ?? []) {
      if (column.displayLabel?.trim()) labels.set(column.columnName.toLowerCase(), column.displayLabel);
    }
    return labels;
  }, [savedViews.views, pageViewLayouts, resolvedViewId]);
  const isCustomActiveView = isCustomViewId(resolvedViewId, allCustomViews);
  const needsFullViewMetadata = !!transformViewAsync && !isCustomActiveView;
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [userCriteria, setUserCriteria] = useState(null);
  const pickedView = views?.find((v) => v.id === resolvedViewId);
  const pickedViewFetchXml = pickedView?.fetchXml ?? void 0;
  const [columnFilterOpen, setColumnFilterOpen] = useState(null);
  const dataverseViewMetadataResult = useViewMetadata(resolvedViewId ?? "", {
    enabled: (needsFullViewMetadata || ((allowFiltering || allowSavedViews || allowAddingColumns) && !dataSource || userCriteria !== null) && !isCustomActiveView && !pickedViewFetchXml) && !!resolvedViewId
  });
  const [transformedView, setTransformedView] = useState(null);
  useEffect(() => {
    if (!resolvedViewId) {
      setTransformedView(null);
      return;
    }
    if (!transformViewAsync && !isCustomActiveView) {
      setTransformedView(null);
      return;
    }
    let source = null;
    if (isCustomActiveView) {
      const customDef = allCustomViews?.find((v) => v.id === resolvedViewId);
      if (customDef) source = customToViewMetadata(customDef);
    } else if (dataverseViewMetadataResult.status === QueryStatus.Success && dataverseViewMetadataResult.data) {
      source = dataverseViewMetadataResult.data;
    }
    if (!source) {
      setTransformedView(null);
      return;
    }
    let canceled = false;
    (async () => {
      try {
        const result = transformViewAsync ? await transformViewAsync(source) : source;
        if (!canceled) setTransformedView(result);
      } catch (err) {
        if (!canceled) {
          console.error("[MainGrid] transformViewAsync threw", err);
          setTransformedView(null);
        }
      }
    })();
    return () => {
      canceled = true;
    };
  }, [
    resolvedViewId,
    transformViewAsync,
    isCustomActiveView,
    dataverseViewMetadataResult.status,
    dataverseViewMetadataResult.data,
    // A saved view the user saves again is the same view with another query.
    savedViews.views
  ]);
  const criteria = userCriteria && userCriteria.viewId === resolvedViewId ? userCriteria.criteria : void 0;
  useEffect(() => {
    setUserCriteria((current) => current && current.viewId !== resolvedViewId ? null : current);
  }, [resolvedViewId]);
  const [addedColumns, setAddedColumns] = useState(null);
  useEffect(() => {
    setAddedColumns((current) => current && current.viewId !== resolvedViewId ? null : current);
  }, [resolvedViewId]);
  const addedColumnKeys = addedColumns && addedColumns.viewId === resolvedViewId ? addedColumns.keys : EMPTY_COLUMN_NAMES;
  const sourceView = transformedView ?? (pickedViewFetchXml ? pickedView : void 0) ?? (dataverseViewMetadataResult.data?.id === resolvedViewId ? dataverseViewMetadataResult.data : void 0) ?? void 0;
  const addedView = useMemo(() => {
    if (!addedColumns || addedColumns.viewId !== resolvedViewId || !sourceView) return void 0;
    const own = new Set(sourceView.columns.map((column) => column.columnName.toLowerCase()));
    return {
      ...sourceView,
      fetchXml: addedColumns.fetchXml,
      columns: [
        ...sourceView.columns,
        ...addedColumns.keys.filter((key3) => !own.has(key3.toLowerCase())).map((key3) => ({ columnName: key3, width: ADDED_COLUMN_WIDTH }))
      ]
    };
  }, [addedColumns, resolvedViewId, sourceView]);
  const baseView = addedView ?? sourceView;
  const viewFetchXml = baseView?.fetchXml ?? void 0;
  const { viewCriteria, viewTable } = useMemo(() => {
    if (!viewFetchXml) return {};
    try {
      return { viewCriteria: extractGridCriteria(viewFetchXml), viewTable: parseFetchXml(viewFetchXml).entity.name };
    } catch {
      return {};
    }
  }, [viewFetchXml]);
  const criteriaFetchXml = useMemo(() => {
    if (!criteria || !viewFetchXml) return void 0;
    try {
      return applyGridCriteria(viewFetchXml, criteria);
    } catch (error2) {
      console.error("[MainGrid] The filter could not be put in the view's query, so the view's own is used.", error2);
      return null;
    }
  }, [criteria, viewFetchXml]);
  useEffect(() => {
    if (criteriaFetchXml === null) setUserCriteria(null);
  }, [criteriaFetchXml]);
  const criteriaView = useMemo(
    () => criteriaFetchXml && baseView ? { ...baseView, fetchXml: criteriaFetchXml } : null,
    [criteriaFetchXml, baseView]
  );
  const activeView = criteriaView ?? addedView ?? transformedView;
  const criteriaPending = !!criteria && !criteriaView;
  const showsFilterButton = allowFiltering && !dataSource && !!resolvedViewId;
  const currentCriteria = criteria ?? viewCriteria;
  const columnFilters = useMemo(() => {
    if (!currentCriteria) return void 0;
    try {
      return { criteria: currentCriteria, filtered: gridFilteredColumns(currentCriteria), kinds: /* @__PURE__ */ new Map() };
    } catch {
      return void 0;
    }
  }, [currentCriteria]);
  const isFilteredColumn = (columnName) => showsFilterButton && !!columnFilters?.filtered.has(columnName.toLowerCase());
  const hasOwnColumnFilter = (columnName) => {
    if (!columnFilters) return false;
    let kind = columnFilters.kinds.get(columnName.toLowerCase());
    if (kind === void 0) {
      kind = viewFetchXml ? findGridColumnFilter(columnFilters.criteria, viewFetchXml, columnName).kind : "other";
      columnFilters.kinds.set(columnName.toLowerCase(), kind);
    }
    return kind === "single";
  };
  const [refreshing, setRefreshing] = useState(false);
  const writeStateToUrl = (overrides) => {
    if (!persistedStateQueryParameter) return;
    const state = {};
    const viewIdValue = overrides?.viewId ?? resolvedViewId;
    if (viewIdValue) state.v = viewIdValue;
    if (pagingMode === PagingMode.Paged && !showsMapOnly && (overrides?.layout ?? layout) !== GridLayout.MapOnly) {
      const pageValue = overrides?.page ?? page;
      if (pageValue > 1) state.p = pageValue;
    }
    state.ps = overrides?.pageSize ?? pageSize;
    const sortValue = overrides?.sort ?? sort;
    if (sortValue.length > 0) state.s = serializeSorts(sortValue);
    if (includeSearchInPersistedState) {
      const searchValue = overrides?.search ?? debouncedSearchText;
      if (searchValue) state.q = searchValue;
    }
    const layoutValue = overrides?.layout ?? layout;
    if (!isLayoutControlled && layoutValue !== defaultLayout) state.l = layoutValue;
    const group = overrides?.groupLevels !== void 0 ? persistedGroup(overrides.groupLevels !== null, overrides.groupLevels ?? EMPTY_GROUP_LEVELS) : persistedGroup(userGroupBy !== null, currentGroupLevels);
    if (group) state.g = group;
    const aggregatesValue = overrides?.aggregates ?? userAggregates;
    if (aggregatesValue.size > 0) {
      state.a = Object.fromEntries(
        [...aggregatesValue.values()].map(({ columnName, aggregates }) => [columnName, serializeAggregates(aggregates)])
      );
    }
    const formatsValue = [...(overrides?.formats ?? userFormats).values()].filter(({ formats }) => formats.size > 0);
    if (formatsValue.length > 0) {
      state.f = Object.fromEntries(formatsValue.map(({ columnName, formats }) => [columnName, serializeAggregateFormats(formats)]));
    }
    const hiddenValue = overrides?.hidden ?? hiddenColumns;
    if (hiddenValue.size > 0) state.h = [...hiddenValue].sort();
    const orderValue = overrides && "order" in overrides ? overrides.order : columnOrder;
    if (orderValue) state.o = [...orderValue];
    const pinsValue = overrides?.pins ?? userPins;
    if (pinsValue.size > 0) {
      state.n = Object.fromEntries([...pinsValue].map(([id, pin]) => [id, serializePin(pin ?? void 0)]));
    }
    const nearValue = overrides && "near" in overrides ? overrides.near : activeNear;
    if (nearValue) state.nr = serializeNear(nearValue);
    writePersistedGridStateToUrl(persistedStateQueryParameter, state);
  };
  const handlePageSizeChange = (nextPageSize) => {
    if (nextPageSize === pageSize) return;
    setPageSize(nextPageSize);
    setPage(1);
    requestEmptySelection();
    writeStateToUrl({ pageSize: nextPageSize, page: 1 });
  };
  const arrangeAsOpening = (id, left, savedPageSize, state) => {
    setSort([]);
    setColumnSizing(EMPTY_COLUMN_SIZING);
    setHiddenColumns(EMPTY_COLUMN_IDS);
    setColumnOrder(null);
    setUserPins(EMPTY_PINS);
    const opening = viewLayout(id);
    if (allowSavedViews || opening || left) {
      arrangedViewRef.current = id;
      applyArrangement(
        opening ? arrangementFromLayout(opening, isPageArranged(id)) : pageArrangement(),
        id,
        savedPageSize,
        { ...state, sort: [] }
      );
    } else {
      writeStateToUrl({ ...state, viewId: id, sort: [], hidden: EMPTY_COLUMN_IDS, order: null, pins: EMPTY_PINS });
    }
  };
  const handleViewChange = (newViewId) => {
    setSelectedViewId(newViewId);
    setPage(1);
    clearTimeout(searchTimerRef.current);
    searchTimerRef.current = void 0;
    if (shownSearchTextRef.current !== "") onSearchTextChangeRef.current?.("");
    shownSearchTextRef.current = "";
    setSearchText("");
    setDebouncedSearchText("");
    requestEmptySelection();
    const opening = viewLayout(newViewId);
    const left = viewLayout(resolvedViewId);
    arrangeAsOpening(newViewId, left, opening?.pageSize ?? (left?.pageSize !== void 0 ? initialPageSize : void 0), {
      page: 1,
      search: ""
    });
  };
  const applyCriteria = (next, restoreView = false) => {
    setFilterDialogOpen(false);
    setColumnFilterOpen(null);
    setUserCriteria(
      resolvedViewId && !(viewCriteria && sameGridCriteria(next, viewCriteria)) ? { viewId: resolvedViewId, criteria: next } : null
    );
    setPage(1);
    requestEmptySelection();
    if (!restoreView || !resolvedViewId) {
      writeStateToUrl({ page: 1 });
      return;
    }
    setAddedColumns(null);
    arrangeAsOpening(resolvedViewId, viewLayout(resolvedViewId), void 0, { page: 1 });
  };
  const searchTimerRef = useRef(void 0);
  const writeStateToUrlRef = useRef(writeStateToUrl);
  writeStateToUrlRef.current = writeStateToUrl;
  const typeSearchText = (next) => {
    shownSearchTextRef.current = next;
    setSearchText(next);
    clearTimeout(searchTimerRef.current);
    searchTimerRef.current = setTimeout(() => {
      searchTimerRef.current = void 0;
      setDebouncedSearchText(next);
      onSearchTextChangeRef.current?.(next);
      if (!dataSource) setPage(1);
      requestEmptySelection();
      writeStateToUrlRef.current({ search: next, page: 1 });
    }, SEARCH_DEBOUNCE_MS2);
  };
  useEffect(() => () => clearTimeout(searchTimerRef.current), []);
  const changeNear = (next) => {
    setNear(next);
    setSort([]);
    setPage(1);
    requestEmptySelection();
    writeStateToUrl({ near: next, sort: [], page: 1 });
  };
  const shownSearchTextRef = useRef(debouncedSearchText);
  useEffect(() => {
    if (debouncedSearchText === shownSearchTextRef.current) return;
    shownSearchTextRef.current = debouncedSearchText;
    requestEmptySelection();
  }, [debouncedSearchText, requestEmptySelection]);
  const handleSortToggle = (columnName, shiftKey) => {
    applySort(computeNextSort(shownSort, columnName, shiftKey));
  };
  const applySort = (nextSort) => {
    setSort(nextSort);
    setPage(1);
    requestEmptySelection();
    writeStateToUrl({ sort: nextSort, page: 1 });
  };
  const handleGroupingChoice = (next) => {
    if (groupBySignatureOf(next) === groupBySignatureOf(currentGroupLevels)) return;
    setUserGroupLevels(next);
    setPage(1);
    requestEmptySelection();
    reportGroupingChange(currentGroupLevels, next);
    writeStateToUrl({ groupLevels: next, page: 1 });
  };
  const handleLayoutChoice = (next) => {
    if (next === layout) return;
    if (!isLayoutControlled) setInternalLayout(next);
    onLayoutChanged?.(next);
    writeStateToUrl({ layout: next });
  };
  const layoutLabels = {
    [GridLayout.Auto]: t("app.components.grid.layout-auto"),
    [GridLayout.Table]: t("app.components.grid.layout-table"),
    [GridLayout.Cards]: t("app.components.grid.layout-cards"),
    [GridLayout.Map]: t("app.components.grid.layout-map"),
    [GridLayout.MapOnly]: t("app.components.grid.layout-map-only")
  };
  const layoutChoices = [
    GridLayout.Auto,
    GridLayout.Table,
    GridLayout.Cards,
    ...offersMapLayout || showsMap ? [GridLayout.Map, GridLayout.MapOnly] : []
  ];
  const renderLayoutDropdown = (className2) => /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.grid.layout"), relationship: "inaccessible", withArrow: true, children: /* @__PURE__ */ jsx(
    Dropdown,
    {
      ...className2 && { className: className2 },
      "aria-label": t("app.components.grid.layout"),
      value: layoutLabels[layoutChoice],
      selectedOptions: [layoutChoice],
      onOptionSelect: (_, data2) => {
        if (data2.optionValue) handleLayoutChoice(data2.optionValue);
      },
      children: layoutChoices.map((choice2) => /* @__PURE__ */ jsx(Option, { value: choice2, text: layoutLabels[choice2], children: layoutLabels[choice2] }, choice2))
    }
  ) });
  const [sortPanelOpen, setSortPanelOpen] = useState(false);
  const [totalsPanelOpen, setTotalsPanelOpen] = useState(null);
  useEffect(() => {
    if (!showsCards) setTotalsPanelOpen(null);
  }, [showsCards]);
  const pickerViews = savedViews.available ? views.filter((view) => view.id === resolvedViewId || !isHiddenView(view.id)) : views;
  const offersSavedViewsMenu = savedViews.available || savedViews.needsSignIn;
  const showViewPicker = !viewId && !!tableName && (pickerViews?.length ?? 0) > (offersSavedViewsMenu ? 0 : 1);
  const filtersKey = filters ? JSON.stringify(filters) : "";
  const useInlineFetchXml = !!activeView;
  const inlineFetchXml = activeView?.fetchXml;
  const columnsKey = useMemo(() => {
    if (!hasDeclaredColumns) return "";
    const seen = /* @__PURE__ */ new Set();
    const ordered = [];
    for (const decl of orderedDeclarations) {
      if (decl.kind === "column") {
        if (decl.props.visible === false) continue;
        if (!seen.has(decl.props.columnName)) {
          seen.add(decl.props.columnName);
          ordered.push(decl.props.columnName);
        }
      } else if (decl.kind === "template") {
        if (decl.props.visible === false) continue;
        for (const dep of [...decl.props.dependsOn ?? [], ...decl.props.searchBy ?? []]) {
          if (!seen.has(dep)) {
            seen.add(dep);
            ordered.push(dep);
          }
        }
      }
    }
    for (const key3 of addedColumnKeys) {
      if (!seen.has(key3)) {
        seen.add(key3);
        ordered.push(key3);
      }
    }
    return ordered.join(",");
  }, [hasDeclaredColumns, orderedDeclarations, addedColumnKeys]);
  const sortTargetsKey = JSON.stringify([...sortTargetsFor(orderedDeclarations)]);
  const sortTargets = useMemo(
    () => new Map(JSON.parse(sortTargetsKey)),
    [sortTargetsKey]
  );
  const groupedColumnsKey = activeGroupLevels.map((level) => level.columnName.toLowerCase()).join(",");
  const groupedColumns = useMemo(() => new Set(groupedColumnsKey.split(",").filter(Boolean)), [groupedColumnsKey]);
  const searchedColumnsWith = (hidden) => {
    const searched = hasDeclaredColumns ? searchColumnsFor(orderedDeclarations, hidden) : hidden.size === 0 || viewColumnNames.length === 0 ? void 0 : viewColumnNames.filter((name) => !hidden.has(name));
    if (!searched || hidden.size === 0 || groupedColumns.size === 0) return searched;
    const kept = new Set(searched.map((name) => name.toLowerCase()));
    const everything = hasDeclaredColumns ? searchColumnsFor(orderedDeclarations) ?? [] : viewColumnNames;
    const regrouped = everything.filter((name) => groupedColumns.has(name.toLowerCase()) && !kept.has(name.toLowerCase()));
    return regrouped.length > 0 ? [...searched, ...regrouped] : searched;
  };
  const hintColumnsKey = useMemo(
    () => searchedColumnsWith(hiddenColumns)?.join(","),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasDeclaredColumns, orderedDeclarations, hiddenColumns, viewColumnNames, groupedColumns]
  );
  const isSearching = debouncedSearchText.trim().length > 0;
  const searchColumnsKey = useMemo(
    () => isSearching ? hintColumnsKey : searchedColumnsWith(EMPTY_COLUMN_IDS)?.join(","),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isSearching, hintColumnsKey, hasDeclaredColumns, orderedDeclarations, viewColumnNames]
  );
  const searchByTitles = useMemo(
    () => hasDeclaredColumns ? searchByTitlesFor(orderedDeclarations) : /* @__PURE__ */ new Map(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasDeclaredColumns, orderedDeclarations]
  );
  const relatedRecordsKey2 = useMemo(() => {
    const requested = [];
    for (const related of relatedColumns) {
      if (related.visible === false) continue;
      requested.push({
        relationshipName: related.relationshipName,
        ...related.columns && related.columns.length > 0 && { columns: [...related.columns] },
        ...related.selfReferencingRole !== void 0 && { selfReferencingRole: related.selfReferencingRole },
        // Two columns over one relationship share a key, so one not searched says so itself.
        ...related.searchable === false && { searchable: false }
      });
    }
    return requested.length > 0 ? JSON.stringify(requested) : "";
  }, [relatedColumns]);
  const columnsOverride = useMemo(
    () => {
      if (columnsKey) return columnsKey.split(",");
      if (activeView && activeView.columns.length > 0) {
        return activeView.columns.map((c) => c.columnName);
      }
      return void 0;
    },
    [columnsKey, activeView]
  );
  const warnedFetchXmlComboRef = useRef(null);
  useEffect(() => {
    if (!columnsKey || !transformedView) return;
    if (warnedFetchXmlComboRef.current === columnsKey) return;
    warnedFetchXmlComboRef.current = columnsKey;
    console.info(
      `[MainGrid] Declared <GridColumn> children override the column projection of the supplied fetchXml (columns: ${columnsKey.split(",").join(", ")}). Drop the children \u2014 or remove the conflicting <attribute> elements from the fetchXml \u2014 to silence this message.`
    );
  }, [columnsKey, transformedView]);
  const accumulatorResetKey = useMemo(
    () => [
      resolvedViewId ?? "",
      useInlineFetchXml ? inlineFetchXml ?? "" : "",
      debouncedSearchText,
      sort.map((s) => `${s.columnName}:${s.descending ? "d" : "a"}`).join("|"),
      filtersKey,
      criteria ?? "",
      requestPageSize,
      showsMapOnly ? "map-only" : "",
      tableName ?? "",
      groupBySignature,
      collapsedGroupsKey,
      nearKey
    ].join("|"),
    [
      resolvedViewId,
      useInlineFetchXml,
      inlineFetchXml,
      debouncedSearchText,
      sort,
      filtersKey,
      criteria,
      requestPageSize,
      showsMapOnly,
      tableName,
      groupBySignature,
      collapsedGroupsKey,
      nearKey
    ]
  );
  const [pagingCookies] = useState(() => new PagingCookies());
  const [nearDistances, setNearDistances] = useState(
    NO_NEAR_DISTANCES
  );
  const pagingCookieKey = [accumulatorResetKey, columnsKey, searchColumnsKey ?? "", relatedRecordsKey2].join("");
  const searchRequest = useMemo(() => {
    const trimmed = debouncedSearchText.trim();
    const pagingCookie = activeGroupBy ? void 0 : accumulates ? pagingCookies.cookieFor(pagingCookieKey, page) : pagingCookies.cookieBeside(pagingCookieKey, page);
    return {
      ...criteriaView ? { fetchXml: criteriaView.fetchXml, ...resolvedViewId !== void 0 && { viewId: resolvedViewId } } : useInlineFetchXml && inlineFetchXml ? { fetchXml: inlineFetchXml } : resolvedViewId !== void 0 && { viewId: resolvedViewId },
      ...trimmed && { searchText: trimmed },
      // Translate each sorted header to the column the server orders by (see
      // `sortTargets`). Sort UI state stays keyed on the header so its arrow
      // renders against the clicked column.
      ...sort.length > 0 && { sorts: toServerSorts(sort, sortTargets) },
      ...filters && filters.length > 0 && {
        filters
      },
      ...columnsOverride && { columns: [...columnsOverride] },
      // An empty key still goes out as an empty list: declared columns with
      // nothing searchable search nothing, rather than everything fetched.
      ...searchColumnsKey !== void 0 && {
        searchColumns: searchColumnsKey ? searchColumnsKey.split(",") : []
      },
      ...relatedRecordsKey2 && {
        relatedRecords: JSON.parse(relatedRecordsKey2)
      },
      // Fetched without being grid columns: the timestamp of the cards' image
      // column, which their avatars are fetched by, and the tiles' file column.
      ...(cardImageColumn || cardFileColumn || mapColumnsKey) && {
        additionalColumns: [
          ...cardImageColumn ? [`${cardImageColumn}_timestamp`] : [],
          ...cardFileColumn ? [cardFileColumn] : [],
          // The coordinates, beside the grid's columns while the map shows.
          ...mapColumnsKey ? mapColumnsKey.split(",") : []
        ]
      },
      // Grouped: the rows ordered by the group first, the collapsed groups' rows left out — the
      // server works the groups out again to page by them, so with the grid's limit too.
      ...activeGroupBy && { groupBy: [...activeGroupLevels] },
      ...activeGroupBy && collapsedGroupsKey && { collapsedGroups: collapsedGroupsKey.split(GROUP_KEY_SEPARATOR) },
      ...activeGroupBy && maximumRangedValues !== void 0 && { maximumRangedValues },
      // Only the rows near a place, by the coordinates the map reads.
      ...activeNear && {
        near: {
          latitude: activeNear.latitude,
          longitude: activeNear.longitude,
          distance: activeNear.distance,
          unit: activeNear.unit,
          latitudeColumn: mapLatitudeColumn,
          longitudeColumn: mapLongitudeColumn
        }
      },
      pageNumber: page,
      pageSize: requestPageSize,
      ...pagingCookie && { pagingCookie }
    };
  }, [
    resolvedViewId,
    useInlineFetchXml,
    inlineFetchXml,
    criteriaView,
    debouncedSearchText,
    sort,
    sortTargets,
    page,
    requestPageSize,
    filtersKey,
    columnsKey,
    searchColumnsKey,
    relatedRecordsKey2,
    cardImageColumn,
    cardFileColumn,
    mapColumnsKey,
    accumulates,
    pagingCookieKey,
    activeGroupLevels,
    collapsedGroupsKey,
    maximumRangedValues,
    nearKey
  ]);
  const exportQuery = useMemo(() => {
    if (dataSource) return dataSource.currentQuery;
    const {
      pageNumber: _pageNumber,
      pageSize: _pageSize,
      pagingCookie: _pagingCookie,
      groupBy: _groupBy,
      collapsedGroups: _collapsedGroups,
      ...rest
    } = searchRequest;
    return rest;
  }, [dataSource, searchRequest]);
  const transformPending = !!transformViewAsync || isCustomActiveView;
  const recordsResult = useQueryData(searchRequest, {
    // When a shared dataSource is set, IT owns the network fetch
    // the grid's local `useQueryData` stays idle so we don't issue
    // redundant round-trips. The grid reads rows / columns / paging
    // from `dataSource` instead (see the effective-value resolutions
    // below the hook).
    enabled: !dataSource && !criteriaPending && !mapColumnsPending && !nearPending && (transformPending ? !!inlineFetchXml : !!resolvedViewId),
    // Hold the prior page / sort / search result on screen while the next
    // request is in flight, so the loading overlay dims the existing rows
    // instead of the grid collapsing to an empty body between every
    // interaction. The first load still goes through the "loading" state
    // because there's nothing to keep.
    keepPreviousData: true
  });
  const aggregatesRequest = useMemo(() => {
    if (requestedAggregates.length === 0 && !activeGroupBy) return null;
    const {
      sorts: _sorts,
      pageNumber: _pageNumber,
      pageSize: _pageSize,
      pagingCookie: _pagingCookie,
      additionalColumns: _additionalColumns,
      groupBy: _groupBy,
      collapsedGroups: _collapsedGroups,
      ...scope
    } = exportQuery;
    return {
      ...scope,
      pageNumber: 1,
      pageSize: 1,
      figuresOnly: true,
      ...requestedAggregates.length > 0 && { columnAggregates: requestedAggregates },
      ...activeGroupBy && { groupBy: [...activeGroupLevels], includeGroups: true },
      ...activeGroupBy && maximumRangedValues !== void 0 && { maximumRangedValues }
    };
  }, [exportQuery, requestedAggregates, activeGroupBy, activeGroupLevels, maximumRangedValues]);
  const aggregatesResult = useQueryData(aggregatesRequest ?? exportQuery, {
    enabled: !!aggregatesRequest && (!!dataSource || !criteriaPending && (transformPending ? !!inlineFetchXml : !!resolvedViewId)),
    keepPreviousData: true
  });
  const aggregateValues = aggregatesRequest ? aggregatesResult.data?.columnAggregates ?? void 0 : void 0;
  const grouping = activeGroupBy && aggregatesRequest ? aggregatesResult.data?.grouping ?? void 0 : void 0;
  const settledGrouping = aggregatesResult.isFetching ? void 0 : grouping;
  const latestGroupLayout = useMemo(
    () => grouping?.status === QueryGroupingStatus.Grouped ? new GridGroupLayout(grouping.groups ?? [], collapsedGroups) : null,
    [grouping, collapsedGroups]
  );
  useEffect(() => {
    if (settledGrouping && settledGrouping.status !== QueryGroupingStatus.Grouped && collapsedGroups.size > 0) {
      setCollapsedGroups(EMPTY_GROUP_KEYS);
    }
  }, [settledGrouping, collapsedGroups, setCollapsedGroups]);
  const fetchedColumns = recordsResult.data?.columns ?? EMPTY_RESOLVED_COLUMNS;
  const groupabilityRef = useRef(EMPTY_RESOLVED_COLUMNS);
  const ownColumns = useMemo(() => {
    const kept = keepingGroupability(fetchedColumns, groupabilityRef.current);
    if (kept.length > 0) groupabilityRef.current = kept;
    return kept;
  }, [fetchedColumns]);
  const rawResolvedColumns = dataSource ? dataSource.columns.length > 0 ? dataSource.columns : EMPTY_RESOLVED_COLUMNS : ownColumns;
  useEffect(() => {
    if (hasDeclaredColumns || rawResolvedColumns.length === 0) return;
    const names2 = rawResolvedColumns.map((column) => column.columnName);
    setViewColumnNames((previous) => previous.join(",") === names2.join(",") ? previous : names2);
  }, [hasDeclaredColumns, rawResolvedColumns]);
  const resolvedColumns = useMemo(() => {
    if (rawResolvedColumns.length === 0) return rawResolvedColumns;
    const widthByName = /* @__PURE__ */ new Map();
    if (activeView) {
      for (const c of activeView.columns) {
        if (c.width !== void 0 && c.width !== null) widthByName.set(c.columnName, c.width);
      }
    }
    const noOverrides = widthByName.size === 0;
    const noScale = columnWidthScale === 1;
    if (noOverrides && noScale) return rawResolvedColumns;
    return rawResolvedColumns.map((col) => {
      const override = widthByName.get(col.columnName);
      const baseWidth = override !== void 0 ? override : col.width;
      const nextWidth = typeof baseWidth === "number" ? Math.round(baseWidth * columnWidthScale) : baseWidth;
      if (nextWidth === col.width) return col;
      return { ...col, width: nextWidth };
    });
  }, [rawResolvedColumns, activeView, columnWidthScale]);
  const resolvedColumnsByName = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    for (const col of resolvedColumns) map.set(col.columnName, col);
    return map;
  }, [resolvedColumns]);
  const { searchableStringColumns, searchableNumberColumns, searchableDateColumns } = useMemo(() => {
    const { text: text2, number, date } = searchHintColumns(
      resolvedColumns,
      hintColumnsKey === void 0 ? void 0 : hintColumnsKey.split(",").filter(Boolean),
      searchByTitles,
      (col) => {
        const category = getRendererTypeForCode(col.type);
        if (category === "string" || category === "lookup" || category === "choice" || category === "multiSelectChoice") {
          return "text";
        }
        if (category === "number" || category === "money") return "number";
        return category === "date" ? "date" : void 0;
      }
    );
    const groups = { text: [...text2], number: [...number], date: [...date] };
    const addRelated = (base, columnName, displayName, kinds) => {
      for (const kind of kinds) {
        const group = kind === SearchKind.Number ? groups.number : kind === SearchKind.Date ? groups.date : groups.text;
        if (!group.some((c) => c.displayName === displayName)) group.push({ ...base, columnName, displayName });
      }
    };
    if (hasDeclaredColumns) {
      for (const decl of orderedDeclarations) {
        if (decl.kind !== "related" || decl.props.visible === false || decl.props.searchable === false || hiddenColumns.has(decl.props.columnId))
          continue;
        const key3 = decl.props.columnKey.toLowerCase();
        const base = resolvedColumns.find((c) => c.columnName.toLowerCase() === key3) ?? {
          columnName: decl.props.columnKey,
          tableName: "",
          displayName: decl.props.relationshipName,
          type: ColumnType.RelatedRecords,
          isSortable: false
        };
        addRelated(base, decl.props.columnId, decl.props.displayName ?? base.displayName, relatedSearchKinds(base, decl.props.columns));
      }
    } else {
      const searched = hintColumnsKey === void 0 ? void 0 : new Set(hintColumnsKey.split(",").map((n) => n.toLowerCase()));
      for (const column of resolvedColumns) {
        if (column.type !== ColumnType.RelatedRecords || searched && !searched.has(column.columnName.toLowerCase())) continue;
        addRelated(column, column.columnName, column.displayName, searchedRelatedKinds(column));
      }
    }
    const byTitle = (a, b) => a.displayName.localeCompare(b.displayName);
    return {
      searchableStringColumns: groups.text.sort(byTitle),
      searchableNumberColumns: groups.number.sort(byTitle),
      searchableDateColumns: groups.date.sort(byTitle)
    };
  }, [resolvedColumns, hintColumnsKey, searchByTitles, hasDeclaredColumns, orderedDeclarations, hiddenColumns]);
  const hasSearchableColumns = searchableStringColumns.length > 0 || searchableNumberColumns.length > 0 || searchableDateColumns.length > 0;
  const openHandlerRef = useRef(null);
  const createReopenHandlerRef = useRef(null);
  const [hasOpenHandler, setHasOpenHandler] = useState(false);
  const [hasCreateReopenHandler, setHasCreateReopenHandler] = useState(false);
  const registerOpenHandler = useCallback(
    (handler) => {
      openHandlerRef.current = handler;
      setHasOpenHandler(true);
      return () => {
        if (openHandlerRef.current === handler) {
          openHandlerRef.current = null;
          setHasOpenHandler(false);
        }
      };
    },
    []
  );
  const registerCreateReopenHandler = useCallback(
    (handler) => {
      createReopenHandlerRef.current = handler;
      setHasCreateReopenHandler(true);
      return () => {
        if (createReopenHandlerRef.current === handler) {
          createReopenHandlerRef.current = null;
          setHasCreateReopenHandler(false);
        }
      };
    },
    []
  );
  const columnTurnsLinksOn = useMemo(
    () => [...declaredColumnsByName.values()].some((column) => column.showRecordLinks === true),
    [declaredColumnsByName]
  );
  const wantsRecordPages = showRecordLinks || columnTurnsLinksOn;
  const recordPages = useRecordPages({ enabled: wantsRecordPages });
  const pendingDeleteIdsRef = useRef(/* @__PURE__ */ new Set());
  const onNavigateRef = useRef(onNavigate);
  onNavigateRef.current = onNavigate;
  const navigateTo = useCallback((url) => {
    const navigate = onNavigateRef.current;
    if (navigate) navigate(url);
    else window.location.assign(url);
  }, []);
  const pageUrlOf = useCallback(
    (record) => {
      if (!hasSavedId(record) || record.id.startsWith("__pending-create-") || pendingDeleteIdsRef.current.has(record.id)) {
        return void 0;
      }
      const page2 = findRecordPage(recordPages, record.tableName);
      return page2 ? recordPageUrl(page2, record.id) : void 0;
    },
    [recordPages]
  );
  const lookupPageUrl = useCallback(
    (record, columnName, value2) => {
      const lookup = value2;
      if (lookup?.$type !== 6 || !lookup.tableName || !canReadColumn(record, columnName)) return void 0;
      if (!lookup.value || !hasSavedId({ id: lookup.value })) return void 0;
      const page2 = findRecordPage(recordPages, lookup.tableName);
      return page2 ? recordPageUrl(page2, lookup.value) : void 0;
    },
    [recordPages]
  );
  const primaryNameColumn = resolvedColumns.find((column) => column.isPrimaryName)?.columnName;
  const opensRowPages = !editable && ((primaryNameColumn ? declaredColumnsByName.get(primaryNameColumn)?.showRecordLinks : void 0) ?? showRecordLinks);
  const rowPageUrl = useCallback(
    (record) => opensRowPages ? pageUrlOf(record) : void 0,
    [opensRowPages, pageUrlOf]
  );
  const dispatchOpen = useCallback((record) => {
    const id = record.id;
    const isPendingCreate = !!id && id.startsWith("__pending-create-");
    if (isPendingCreate) {
      const idx = Number.parseInt(id.slice("__pending-create-".length), 10);
      const reopen = createReopenHandlerRef.current;
      if (reopen && Number.isFinite(idx)) {
        reopen(record, idx);
        return;
      }
      openHandlerRef.current?.(record);
      return;
    }
    const open = openHandlerRef.current;
    if (open) {
      open(record);
      return;
    }
    const page2 = rowPageUrl(record);
    if (page2) navigateTo(page2);
  }, [rowPageUrl, navigateTo]);
  const hasRowOpenAffordance = hasOpenHandler || hasCreateReopenHandler;
  const relatedResolvedById = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    for (const related of relatedColumns) {
      const base = resolvedColumnsByName.get(related.columnKey) ?? {
        columnName: related.columnKey,
        tableName: "",
        displayName: related.relationshipName,
        type: ColumnType.RelatedRecords,
        isSortable: false
      };
      map.set(related.columnId, {
        ...base,
        ...related.displayName !== void 0 && { displayName: related.displayName },
        ...related.width !== void 0 && { width: related.width },
        ...related.tooltip !== void 0 && { tooltip: related.tooltip === "" ? null : related.tooltip }
      });
    }
    return map;
  }, [relatedColumns, resolvedColumnsByName]);
  const unlabeledResolvedColumns = useMemo(() => {
    if (!hasDeclaredColumns) return resolvedColumns;
    const out = [];
    for (const decl of orderedDeclarations) {
      if (decl.kind === "template" || decl.props.visible === false) continue;
      if (decl.kind === "related") {
        const resolved = relatedResolvedById.get(decl.props.columnId);
        if (resolved) out.push(resolved);
        continue;
      }
      const declared = decl.props;
      const base = resolvedColumnsByName.get(declared.columnName);
      if (!base) {
        console.warn(
          `[MainGrid] <GridColumn columnName="${declared.columnName}"> declared but the server didn't return metadata for it. The column name likely doesn't exist on the table \u2014 check spelling and the table's column metadata.`
        );
        continue;
      }
      const overridden = {
        ...base,
        ...declared.displayName !== void 0 && { displayName: declared.displayName },
        ...declared.width !== void 0 && { width: declared.width },
        ...declared.sortable !== void 0 && { isSortable: declared.sortable },
        ...declared.tooltip !== void 0 && {
          tooltip: declared.tooltip === "" ? null : declared.tooltip
        }
      };
      out.push(overridden);
    }
    for (const key3 of addedColumnKeys) {
      const added = resolvedColumnsByName.get(key3);
      if (added && !out.some((column) => column.columnName === key3)) out.push(added);
    }
    return out;
  }, [hasDeclaredColumns, orderedDeclarations, resolvedColumns, resolvedColumnsByName, relatedResolvedById, addedColumnKeys]);
  const effectiveResolvedColumns = useMemo(
    () => savedColumnLabels.size === 0 ? unlabeledResolvedColumns : unlabeledResolvedColumns.map((column) => {
      const label = column.type === ColumnType.RelatedRecords ? void 0 : savedColumnLabels.get(column.columnName.toLowerCase());
      return label ? { ...column, displayName: label } : column;
    }),
    [unlabeledResolvedColumns, savedColumnLabels]
  );
  const viewOrder = useMemo(() => viewSortOf(effectiveResolvedColumns), [effectiveResolvedColumns]);
  const shownSort = sort.length > 0 ? sort : activeNear && currentGroupLevels.length === 0 ? NEAREST_FIRST : viewOrder;
  const warnedRelatedRecordsRef = useRef(null);
  useEffect(() => {
    if (!dataSource || rawResolvedColumns.length === 0) return;
    const missing = relatedColumns.filter((r) => r.visible !== false && !resolvedColumnsByName.has(r.columnKey)).map((r) => r.relationshipName);
    const key3 = missing.join(",");
    if (!key3 || warnedRelatedRecordsRef.current === key3) return;
    warnedRelatedRecordsRef.current = key3;
    console.warn(
      `[MainGrid] <GridRelatedRecordsColumn> declared for ${missing.join(", ")}, but the bound dataSource doesn't load ${missing.length === 1 ? "it" : "them"}. A grid bound to a dataSource shows the rows the data source loaded: add the relationship to the data source's \`relatedRecords\` option.`
    );
  }, [dataSource, rawResolvedColumns, relatedColumns, resolvedColumnsByName]);
  const effectiveColumnsByName = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    for (const col of effectiveResolvedColumns) {
      if (col.type !== ColumnType.RelatedRecords) map.set(col.columnName, col);
    }
    for (const [id, col] of relatedResolvedById) map.set(id, col);
    return map;
  }, [effectiveResolvedColumns, relatedResolvedById]);
  const groupColumnOf = (columnName) => {
    const name = columnName.toLowerCase();
    return {
      shown: effectiveResolvedColumns.find((column) => column.canGroupBy === true && column.columnName.toLowerCase() === name),
      metadata: gridTableMetadata?.columns.find((column) => column.columnName?.toLowerCase() === name)
    };
  };
  const groupColumnTitle = (columnName) => {
    const { shown, metadata } = groupColumnOf(columnName);
    return shown?.displayName ?? metadata?.displayName ?? columnName;
  };
  const isDateColumnName = (columnName) => {
    const { shown, metadata } = groupColumnOf(columnName);
    return (shown?.type ?? metadata?.columnType) === ColumnType.DateTime;
  };
  const holdsTimeName = (columnName) => isDateColumnName(columnName) && !isDateOnly(groupColumnOf(columnName).metadata);
  const isNumberColumnName = (columnName) => {
    const { shown, metadata } = groupColumnOf(columnName);
    const type = shown?.type ?? metadata?.columnType;
    return type === ColumnType.Integer || type === ColumnType.BigInt || type === ColumnType.Decimal || type === ColumnType.Double || type === ColumnType.Money;
  };
  const groupsByLevelValue = (level) => {
    const { shown, metadata } = groupColumnOf(level.columnName);
    return groupsByValue(level, shown?.type ?? metadata?.columnType, metadata);
  };
  const isInnermostOnly = (level) => isDateColumnName(level.columnName) || rangeSizeOf(level) !== null && isNumberColumnName(level.columnName);
  const groupPanelLevels = currentGroupLevels.map((level) => ({
    groupBy: level,
    title: groupColumnTitle(level.columnName),
    isDateColumn: isDateColumnName(level.columnName),
    isNumberColumn: isNumberColumnName(level.columnName),
    holdsTime: holdsTimeName(level.columnName)
  }));
  const groupedByDate = currentGroupLevels.some(isInnermostOnly);
  const addableGroupColumns = currentGroupLevels.length >= MAX_GROUP_LEVELS ? [] : effectiveResolvedColumns.filter(
    (column, index, all) => column.canGroupBy === true && column.type !== ColumnType.RelatedRecords && !column.columnName.includes(".") && !groupsByColumn(currentGroupLevels, column.columnName) && all.findIndex((other) => other.columnName.toLowerCase() === column.columnName.toLowerCase()) === index
  ).map((column) => ({
    columnName: column.columnName,
    title: groupColumnTitle(column.columnName),
    isDateColumn: isDateColumnName(column.columnName),
    holdsTime: holdsTimeName(column.columnName)
  })).filter((column) => !(column.isDateColumn && groupedByDate));
  const handleGroupAdd = (level) => {
    const next = insertGroupLevel(currentGroupLevels, level, currentGroupLevels.length, isInnermostOnly);
    if (next) handleGroupingChoice(next);
  };
  const handleGroupDrop = (index) => {
    const columnName = groupDragColumn;
    setGroupDragColumn(null);
    if (!columnName) return;
    const next = insertGroupLevel(
      currentGroupLevels,
      { columnName, descending: false, dateGrouping: DateGrouping.Day },
      index,
      isInnermostOnly
    );
    if (next) handleGroupingChoice(next);
  };
  const hiddenGroupColumns = hiddenGroupColumnsOf(activeGroupLevels, settledGrouping, effectiveResolvedColumns, groupsByLevelValue);
  const hiddenGroupColumnsKey = hiddenGroupColumns.join(",");
  const sortableColumns = useMemo(() => {
    const out = [];
    if (!hasDeclaredColumns) {
      for (const column of effectiveResolvedColumns) {
        if (column.isSortable && column.type !== ColumnType.RelatedRecords) {
          out.push({ key: column.columnName, title: column.displayName });
        }
      }
      return out;
    }
    for (const decl of orderedDeclarations) {
      if (decl.props.visible === false || decl.kind === "related") continue;
      if (decl.kind === "template") {
        if (decl.props.sortBy) out.push({ key: decl.props.id, title: decl.props.displayName ?? decl.props.id });
        continue;
      }
      const resolved = effectiveColumnsByName.get(decl.props.columnName);
      if (resolved?.isSortable) out.push({ key: resolved.columnName, title: resolved.displayName });
    }
    return out;
  }, [hasDeclaredColumns, effectiveResolvedColumns, orderedDeclarations, effectiveColumnsByName]);
  const sortPanel = /* @__PURE__ */ jsx(
    GridSortPanel,
    {
      columns: sortableColumns,
      sort: shownSort,
      onApply: (next) => {
        setSortPanelOpen(false);
        applySort(next);
      },
      onCancel: () => setSortPanelOpen(false)
    }
  );
  const givenExportEntries = useMemo(() => {
    const entries = [];
    const seen = /* @__PURE__ */ new Set();
    const add = (entry) => {
      const key3 = entry.name.toLowerCase();
      if (seen.has(key3)) return;
      seen.add(key3);
      entries.push(entry);
    };
    if (!hasDeclaredColumns) {
      for (const column of effectiveResolvedColumns) add({ name: column.columnName, header: column.displayName });
      return entries;
    }
    for (const decl of orderedDeclarations) {
      if (decl.kind === "template" || decl.props.visible === false) continue;
      if (decl.kind === "related") {
        const resolved2 = relatedResolvedById.get(decl.props.columnId);
        if (!resolved2) continue;
        add({
          name: decl.props.columnId,
          header: resolved2.displayName,
          related: {
            key: decl.props.columnKey,
            ...decl.props.columns && decl.props.columns.length > 0 && { columns: [...decl.props.columns] }
          }
        });
        continue;
      }
      const resolved = effectiveColumnsByName.get(decl.props.columnName);
      if (resolved) add({ name: resolved.columnName, header: resolved.displayName });
    }
    return entries;
  }, [hasDeclaredColumns, effectiveResolvedColumns, orderedDeclarations, relatedResolvedById, effectiveColumnsByName]);
  const exportEntries = useMemo(() => {
    const names2 = givenExportEntries.map((entry) => entry.name);
    const pinned = !showsCards && names2.some((name) => pinOf(name) !== void 0);
    if (hiddenColumns.size === 0 && !columnOrder && !pinned) return givenExportEntries;
    const byName = new Map(givenExportEntries.map((entry) => [entry.name, entry]));
    const arranged = arrangeColumns(names2, columnOrder);
    return (pinned ? pinOrder(arranged, pinOf) : arranged).filter((name) => !hiddenColumns.has(name)).map((name) => byName.get(name));
  }, [givenExportEntries, hiddenColumns, columnOrder, pinOf, showsCards]);
  const pageColumns = useMemo(() => {
    const buildRegularColumnDef = (resolvedColumn) => {
      const declared = declaredColumnsByName.get(resolvedColumn.columnName);
      const columnName = resolvedColumn.columnName;
      const typeCode = resolvedColumn.type;
      const align = declared?.align ?? typeAlign(typeCode);
      const ownRenderer = declared?.cellRenderer ?? cellRenderers?.[columnName] ?? typeRenderers?.[getRendererTypeForCode(typeCode)];
      const Renderer = ownRenderer ?? getCellRendererByType(typeCode);
      const width = typeof resolvedColumn.width === "number" ? resolvedColumn.width : void 0;
      const isPrimaryNameLinkTarget = resolvedColumn.isPrimaryName && allowNavigateOnPrimaryNameClick;
      const showsRecordLinks = declared?.showRecordLinks ?? showRecordLinks;
      const hasEditorForType = getEditComponentForType(typeCode) !== null;
      return columnHelper.accessor(
        (row) => row.properties?.[columnName],
        {
          id: columnName,
          // Headers normally show the server-resolved Dataverse display name, which bypasses the
          // client `t()` — so the ?ppp-show-keys aid couldn't reach them. Consult key-mode here too:
          // when it's on, show the column's localization key (the one a consumer would override),
          // keyed by the column's OWN owning table (`resolvedColumn.tableName` — the related table
          // for a linked-entity column, not the grid's primary table). For linked columns the name
          // is a dotted alias path, so take the segment after the last dot as the real column name.
          header: () => isKeyModeEnabled() ? `tables.${resolvedColumn.tableName}.columns.${columnName.split(".").pop() ?? columnName}.label` : resolvedColumn.displayName,
          cell: (cellCtx) => {
            const rowRecord = cellCtx.row.original;
            const rowId = rowRecord.id;
            const isPendingCreateRow = !!rowId && rowId.startsWith("__pending-create-");
            if (editable && !isPendingCreateRow && hasEditorForType && canWriteColumn(rowRecord, columnName)) {
              return (
                // Sizing wrapper — overrides Fluent v9's default
                // <Input> / <Combobox> / <Dropdown> min-width
                // (~200px) so the editor fits the column's actual
                // width instead of bleeding into the neighbor cell.
                // See `styles.inlineEditCell` for the cascade rules.
                /* @__PURE__ */ jsx("div", { className: styles.inlineEditCell, children: /* @__PURE__ */ jsx(
                  ColumnEdit,
                  {
                    columnName,
                    displayLabelWhenAvailable: false,
                    descriptionLocation: DescriptionLocation.None
                  }
                ) })
              );
            }
            const content = /* @__PURE__ */ jsx(
              Renderer,
              {
                value: cellCtx.getValue(),
                columnName,
                record: rowRecord,
                metadata: gridTableMetadata?.columns.find((c) => c.columnName === columnName),
                ...parentRecord && { parentRecord },
                searchText: searchText || null
              }
            );
            const rowHasOpenAffordance = isPendingCreateRow ? hasCreateReopenHandler : hasOpenHandler;
            if (!isPrimaryNameLinkTarget || !rowHasOpenAffordance) {
              const pageUrl = showsRecordLinks ? (isPrimaryNameLinkTarget && !hasOpenHandler ? rowPageUrl(rowRecord) : void 0) ?? // A lookup drawn by the page's own renderer is the page's: it may hold a link of its own.
              (ownRenderer ? void 0 : lookupPageUrl(rowRecord, columnName, cellCtx.getValue())) : void 0;
              if (pageUrl === void 0) return content;
              return /* @__PURE__ */ jsx(
                "a",
                {
                  href: pageUrl,
                  className: mergeClasses("ppp-grid-primary-name-link", styles.primaryNameLink),
                  onClick: (e) => {
                    e.stopPropagation();
                    followRecordLink(e, pageUrl, onNavigateRef.current);
                  },
                  children: content
                }
              );
            }
            return /* @__PURE__ */ jsx(
              "a",
              {
                href: "#",
                className: mergeClasses("ppp-grid-primary-name-link", styles.primaryNameLink),
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  dispatchOpen(cellCtx.row.original);
                },
                children: content
              }
            );
          },
          // Floor for user resize — keep columns from collapsing to a
          // point where neither the header label nor the resize handle
          // is hittable. 40px ≈ checkbox-column + handle width and
          // matches Fluent DataGrid's own minimum.
          minSize: 40,
          ...width !== void 0 && { size: width },
          // The alignment declared on `<GridColumn>`, or the column type's, as the Blazor grid
          // aligns them: numbers and money at the end, yes/no in the middle. Body cell + header
          // cell read this off `columnDef.meta` to apply `textAlign` / `justifyContent`.
          ...align && { meta: { align } }
        }
      );
    };
    const buildTemplateColumnDef = (props) => {
      const width = typeof props.width === "number" ? props.width : typeof props.width === "string" ? parsePixelWidth(props.width) : void 0;
      return columnHelper.display({
        id: props.id,
        header: () => props.displayName,
        cell: (cellCtx) => {
          const rowRecord = cellCtx.row.original;
          const dependsOnMetadata = {};
          if (props.dependsOn) {
            for (const dep of props.dependsOn) {
              dependsOnMetadata[dep] = gridTableMetadata?.columns.find(
                (c) => c.columnName === dep
              );
            }
          }
          const rendererProps = {
            id: props.id,
            record: rowRecord,
            ...parentRecord && { parentRecord },
            // Only a column the search covered has anything to highlight.
            searchText: props.searchBy && props.searchBy.length > 0 ? searchText || null : null,
            dependsOnMetadata
          };
          const rowId = rowRecord.id;
          const isPendingCreateRow = !!rowId && rowId.startsWith("__pending-create-");
          if (editable && !isPendingCreateRow && props.editRenderer) {
            return /* @__PURE__ */ jsx(
              TemplateColumnEditCell,
              {
                rendererProps,
                editRenderer: props.editRenderer,
                inlineEditCellClass: styles.inlineEditCell
              }
            );
          }
          return props.cellRenderer(rendererProps);
        },
        minSize: 40,
        ...width !== void 0 && { size: width },
        ...props.align && { meta: { align: props.align } }
      });
    };
    const buildRelatedRecordsColumnDef = (props, resolvedColumn) => {
      const width = typeof resolvedColumn.width === "number" ? resolvedColumn.width : typeof resolvedColumn.width === "string" ? parsePixelWidth(resolvedColumn.width) : void 0;
      return columnHelper.display({
        id: props.columnId,
        header: () => isKeyModeEnabled() && resolvedColumn.tableName ? `tables.${resolvedColumn.tableName}.collectionLabel` : resolvedColumn.displayName,
        cell: (cellCtx) => {
          const rowRecord = cellCtx.row.original;
          const value2 = readRelatedRecords(rowRecord, props.columnKey);
          const highlight = props.searchable !== false && (props.columns?.length ?? 0) === 0 ? searchText ?? null : null;
          if (props.cellRenderer) {
            const rendererProps = {
              record: rowRecord,
              ...parentRecord && { parentRecord },
              searchText: props.searchable !== false ? searchText ?? null : null,
              columnKey: props.columnKey,
              value: value2,
              records: value2?.value ?? [],
              isTruncated: value2?.isTruncated ?? false
            };
            return props.cellRenderer(rendererProps);
          }
          return /* @__PURE__ */ jsx(
            RelatedRecordsList,
            {
              row: rowRecord,
              value: value2,
              searchText: highlight,
              ...props.separator !== void 0 && { separator: props.separator },
              ...props.urlFor && { urlFor: props.urlFor },
              ...props.onRecordClick && { onRecordClick: props.onRecordClick },
              ...props.itemRenderer && { itemRenderer: props.itemRenderer }
            }
          );
        },
        minSize: 40,
        ...width !== void 0 && { size: width },
        ...props.align && { meta: { align: props.align } }
      });
    };
    if (!hasDeclaredColumns) {
      return effectiveResolvedColumns.map(buildRegularColumnDef);
    }
    const defs = [];
    for (const decl of orderedDeclarations) {
      if (decl.kind === "column") {
        if (decl.props.visible === false) continue;
        const resolved = effectiveColumnsByName.get(decl.props.columnName);
        if (!resolved) continue;
        defs.push(buildRegularColumnDef(resolved));
      } else if (decl.kind === "related") {
        if (decl.props.visible === false) continue;
        const resolved = relatedResolvedById.get(decl.props.columnId);
        if (!resolved) continue;
        defs.push(
          buildRelatedRecordsColumnDef(decl.props, resolved)
        );
      } else {
        if (decl.props.visible === false) continue;
        defs.push(
          buildTemplateColumnDef(decl.props)
        );
      }
    }
    for (const key3 of addedColumnKeys) {
      const added = effectiveColumnsByName.get(key3);
      if (added && !declaredColumnsByName.has(key3)) defs.push(buildRegularColumnDef(added));
    }
    return defs;
  }, [
    effectiveResolvedColumns,
    effectiveColumnsByName,
    declaredColumnsByName,
    hasDeclaredColumns,
    orderedDeclarations,
    addedColumnKeys,
    cellRenderers,
    typeRenderers,
    searchText,
    hasRowOpenAffordance,
    hasOpenHandler,
    hasCreateReopenHandler,
    dispatchOpen,
    allowNavigateOnPrimaryNameClick,
    showRecordLinks,
    rowPageUrl,
    lookupPageUrl,
    styles,
    editable,
    parentRecord,
    gridTableMetadata
  ]);
  const pageRecords = dataSource ? dataSource.rows : recordsResult.data?.tableRecords ?? EMPTY_RECORDS;
  const [accumulatedRows, setAccumulatedRows] = useState(null);
  const appliedResetKeyRef = useRef(accumulatorResetKey);
  const loadMorePageRef = useRef(null);
  const [landed, setLanded] = useState(null);
  const resetForMapOnlyRef = useRef(showsMapOnly);
  const resetVirtualizedView = useCallback(() => {
    setAccumulatedRows([]);
    setPage(1);
    tableContainerRef.current?.scrollTo({ top: 0 });
  }, []);
  useEffect(() => {
    appliedResetKeyRef.current = accumulatorResetKey;
    loadMorePageRef.current = null;
    if (accumulates) {
      resetVirtualizedView();
    } else {
      setAccumulatedRows(null);
      if (resetForMapOnlyRef.current) setPage(1);
    }
    resetForMapOnlyRef.current = showsMapOnly;
  }, [accumulates, accumulatorResetKey]);
  useEffect(() => {
    if (!accumulates) return;
    if (recordsResult.status !== QueryStatus.Success) return;
    if (!recordsResult.isFetching && loadMorePageRef.current === page) loadMorePageRef.current = null;
    if (pageRecords.length === 0) return;
    setAccumulatedRows((prev) => {
      const base = prev ?? [];
      const seen = /* @__PURE__ */ new Set();
      for (const r of base) if (r.id) seen.add(r.id);
      const additions = pageRecords.filter((r) => r.id && !seen.has(r.id));
      if (additions.length === 0) return base;
      return [...base, ...additions];
    });
  }, [accumulates, recordsResult.status, pageRecords]);
  const { locale: distanceLocale } = useLocale();
  const nearUnit = activeNear?.unit;
  const columns = useMemo(() => {
    if (nearUnit === void 0) return pageColumns;
    const unitKey = nearUnit === 1 ? "app.components.grid.distance-kilometers" : "app.components.grid.distance-miles";
    return [
      ...pageColumns,
      columnHelper.display({
        id: NearDistanceColumn,
        header: () => t("app.components.grid.distance"),
        cell: (cellCtx) => {
          const distance = cellCtx.row.original.id ? nearDistancesRef.current.get(cellCtx.row.original.id.toLowerCase()) : void 0;
          return distance === void 0 ? null : t(unitKey, [distance.toLocaleString(distanceLocale, { maximumFractionDigits: distance < 10 ? 1 : 0 })]);
        },
        minSize: 40,
        size: 140,
        meta: { align: "end" }
      })
    ];
  }, [pageColumns, nearUnit, distanceLocale, nearDistances]);
  const nearDistancesRef = useRef(nearDistances.byId);
  nearDistancesRef.current = nearDistances.byId;
  useEffect(() => {
    const landed2 = recordsResult.data;
    if (!landed2) return;
    pagingCookies.record(pagingCookieKey, page, landed2.pagingInfo?.pagingCookie);
    setLanded({ page: `${accumulatorResetKey}${page}`, mapOnly: showsMapOnly });
    const landedDistances = landed2.near?.distances ?? {};
    setNearDistances((held) => {
      const next = new Map(held.key === accumulatorResetKey && accumulates ? held.byId : []);
      for (const [id, distance] of Object.entries(landedDistances)) next.set(id.toLowerCase(), Number(distance));
      return { key: accumulatorResetKey, byId: next, truncated: landed2.near?.truncated === true };
    });
  }, [recordsResult.data]);
  const rowsInHand = accumulates ? accumulatedRows ?? EMPTY_RECORDS : pageRecords;
  const data = landed?.mapOnly && !showsMapOnly && rowsInHand.length > pageSize ? rowsInHand.slice(0, pageSize) : rowsInHand;
  const [pendingRowUpdates, setPendingRowUpdates] = useState(() => /* @__PURE__ */ new Map());
  const [pendingRowCreates, setPendingRowCreates] = useState(() => []);
  const [pendingRowAssociates, setPendingRowAssociates] = useState(() => []);
  const [pendingRowDisassociates, setPendingRowDisassociates] = useState(() => []);
  const [pendingRowDeletes, setPendingRowDeletes] = useState(() => []);
  const displayedData = useMemo(() => {
    const overlaid = pendingRowUpdates.size === 0 ? [...data] : data.map((row) => {
      const rowId = row.id;
      if (!rowId) return row;
      const pending = pendingRowUpdates.get(rowId);
      if (!pending) return row;
      const properties = {
        ...row.properties ?? {}
      };
      for (const [col, val] of pending.dirty) {
        if (val === null) {
          delete properties[col];
        } else {
          properties[col] = val;
        }
      }
      return { ...row, properties };
    });
    if (pendingRowCreates.length === 0 && pendingRowAssociates.length === 0) {
      return overlaid;
    }
    const pendingCreateRows = pendingRowCreates.map((create, idx) => ({
      ...create.record,
      id: `__pending-create-${idx}`
    }));
    return [...pendingCreateRows, ...pendingRowAssociates, ...overlaid];
  }, [pendingRowCreates, pendingRowAssociates, pendingRowUpdates, data]);
  const pendingCreateIds = useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (let i = 0; i < pendingRowCreates.length; i++) {
      set.add(`__pending-create-${i}`);
    }
    return set;
  }, [pendingRowCreates]);
  const pendingAssociateIds = useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (const r of pendingRowAssociates) {
      if (r.id) set.add(r.id);
    }
    return set;
  }, [pendingRowAssociates]);
  const pendingDisassociateIds = useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (const r of pendingRowDisassociates) {
      if (r.id) set.add(r.id);
    }
    return set;
  }, [pendingRowDisassociates]);
  const pendingDeleteIds = useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (const r of pendingRowDeletes) {
      if (r.id) set.add(r.id);
    }
    return set;
  }, [pendingRowDeletes]);
  pendingDeleteIdsRef.current = pendingDeleteIds;
  const columnOrderState = useMemo(() => {
    const arranged = arrangeColumns(columns.flatMap((column) => column.id ? [column.id] : []), columnOrder);
    return showsCards ? arranged : pinOrder(arranged, pinOf);
  }, [columns, columnOrder, pinOf, showsCards]);
  const columnVisibility = useMemo(
    () => ({
      ...Object.fromEntries([...hiddenColumns].map((id) => [id, false])),
      ...Object.fromEntries(hiddenGroupColumns.map((id) => [id, false]))
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hiddenColumns, hiddenGroupColumnsKey]
  );
  const columnsResolved = rawResolvedColumns.length > 0 || orderedDeclarations.every((d) => d.kind === "template");
  useEffect(() => {
    const ids = columns.map((column) => column.id);
    if (columnsResolved && ids.length > 0 && ids.every((id) => id !== void 0 && hiddenColumns.has(id))) {
      setHiddenColumns(EMPTY_COLUMN_IDS);
      writeStateToUrlRef.current({ hidden: EMPTY_COLUMN_IDS });
    }
  }, [columns, hiddenColumns, columnsResolved]);
  const table = useReactTable({
    data: displayedData,
    columns,
    getCoreRowModel: getCoreRowModel(),
    // TanStack's row id defaults to the row index, which means
    // `rowSelection` keys would collide across pages. Key on the
    // record's primary id instead so the selection map is stable.
    getRowId: (row, index) => row.id ?? String(index),
    enableRowSelection: selectionMode !== "none",
    enableMultiRowSelection: selectionMode === "multiple",
    // Column resizing: drag the right edge of any header to resize.
    // `onChange` mode updates `columnSizing` on every mousemove so cells
    // track the drag live; cheap at our page size (25 rows × few
    // columns). `'onEnd'` would defer until release but requires a
    // floating-indicator div to give the user feedback during drag.
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    state: { rowSelection, columnSizing, columnOrder: columnOrderState, columnVisibility },
    onRowSelectionChange: (updater) => {
      const next = typeof updater === "function" ? updater(rowSelection) : updater;
      if (isSelectionControlled) {
        if (!onSelectedRecordsChangeRef.current) return;
        const records = displayedData.filter((r) => r.id && next[r.id]);
        onSelectedRecordsChangeRef.current(records);
      } else {
        setInternalRowSelection(next);
      }
    },
    onColumnSizingChange: setColumnSizing
  });
  const allColumnIds = table.getAllColumns().flatMap((column) => column.getLeafColumns().map((leaf) => leaf.id));
  const shownColumnIds = table.getVisibleLeafColumns().map((column) => column.id);
  const columnTitleFor = (id) => effectiveColumnsByName.get(id)?.displayName ?? templateColumnsById.get(id)?.displayName ?? id;
  const chooseGroupBy = (next) => handleGroupingChoice(next);
  const chooseTotals = (columnName, aggregates) => {
    const next = new Map(userAggregates);
    next.set(columnName.toLowerCase(), { columnName, aggregates });
    setUserAggregates(next);
    writeStateToUrl({ aggregates: next });
  };
  const applyTotalsFormats = (columnName, formats) => {
    setTotalsFormatOpen(null);
    const key3 = columnName.toLowerCase();
    const given = givenAggregatesByColumn.get(key3)?.formats ?? NO_FORMATS;
    const chosen = new Map(userFormats.get(key3)?.formats ?? NO_FORMATS);
    for (const [aggregate, format] of formats) {
      if (format === (given.get(aggregate) ?? "")) chosen.delete(aggregate);
      else chosen.set(aggregate, format);
    }
    const next = new Map(userFormats);
    if (chosen.size > 0) next.set(key3, { columnName, formats: chosen });
    else next.delete(key3);
    setUserFormats(next);
    writeStateToUrl({ formats: next });
  };
  const arrangeColumnsTo = (hidden, order, pins = userPins) => {
    setHiddenColumns(hidden);
    setColumnOrder(order);
    setUserPins(pins);
    writeStateToUrl({ hidden, order, pins });
  };
  const pinColumnTo = (columnId, pin) => {
    const pins = withPin(columnId, pin);
    arrangeColumnsTo(hiddenColumns, pinColumn(allColumnIds, columnOrder, columnId, pin, pinLookupFor(pins)), pins);
  };
  const hiddenColumnEntries = arrangeColumns(allColumnIds, columnOrder).filter((id) => hiddenColumns.has(id)).map((id) => ({ id, title: columnTitleFor(id) }));
  const renderColumnMenu = (columnId, sortable, sortDirective) => {
    const resolved = templateColumnsById.has(columnId) ? void 0 : effectiveColumnsByName.get(columnId);
    const regular = resolved && resolved.type !== ColumnType.RelatedRecords ? resolved : void 0;
    const groupable = usersMayGroup && offersColumnMenu(GridColumnMenuItem.Group) && regular?.canGroupBy === true;
    const groupedByThis = !!regular && groupsByColumn(activeGroupLevels, regular.columnName);
    const offersSubgroup = groupable && !!regular && activeGroupLevels.length > 0 && activeGroupLevels.length < MAX_GROUP_LEVELS && !groupsByColumn(activeGroupLevels, regular.columnName);
    const offeredTotals = offersColumnMenu(GridColumnMenuItem.Totals) ? regular?.aggregates ?? [] : [];
    const filterable = showsFilterButton && offersColumnMenu(GridColumnMenuItem.Filter) && !!regular && !!currentCriteria && !!viewFetchXml && !UNFILTERABLE_TYPES.has(regular.type) && ((regular.permissions ?? ColumnSecurityPermission.All) & ColumnSecurityPermission.Read) === ColumnSecurityPermission.Read;
    const shownIndex = shownColumnIds.indexOf(columnId);
    const pin = pinOf(columnId);
    const canMove = (offset) => {
      const neighbor = shownIndex >= 0 ? shownColumnIds[shownIndex + offset] : void 0;
      return neighbor !== void 0 && pinOf(neighbor) === pin;
    };
    return /* @__PURE__ */ jsx(
      GridColumnMenu,
      {
        title: columnTitleFor(columnId),
        sort: sortable ? {
          direction: sortDirective ? sortDirective.descending ? "descending" : "ascending" : void 0,
          levels: sort.length,
          onSort: (descending) => applySort(sortByColumn(sort, columnId, descending)),
          onAddToSort: () => applySort(addToSort(sort, columnId)),
          onClearSort: () => applySort(removeFromSort(sort, columnId)),
          onClearAllSorts: () => applySort([])
        } : void 0,
        filter: filterable && regular ? {
          onFilter: () => setColumnFilterOpen(regular.columnName),
          onClear: hasOwnColumnFilter(regular.columnName) ? () => applyCriteria(setGridColumnFilter(currentCriteria, viewFetchXml, regular.columnName, void 0)) : void 0
        } : void 0,
        group: groupable && regular ? {
          isDate: regular.type === ColumnType.DateTime,
          holdsTime: regular.type === ColumnType.DateTime && holdsTimeName(regular.columnName),
          onGroup: groupedByThis ? void 0 : (dateGrouping) => chooseGroupBy([{ columnName: regular.columnName, descending: false, dateGrouping }]),
          onAddSubgroup: offersSubgroup ? (dateGrouping) => {
            const next = insertGroupLevel(
              currentGroupLevels,
              { columnName: regular.columnName, descending: false, dateGrouping },
              currentGroupLevels.length,
              isInnermostOnly
            );
            if (next) chooseGroupBy(next);
          } : void 0
        } : void 0,
        totals: regular && offeredTotals.length > 0 ? {
          offered: offeredTotals,
          shown: [...aggregatesByColumn.get(regular.columnName.toLowerCase())?.aggregates ?? []],
          onChange: (aggregates) => chooseTotals(regular.columnName, aggregates),
          // A number's or money's: a count, a date's figures and the rest keep their own format.
          onFormat: NUMERIC_COLUMN_TYPES.has(regular.type) ? () => setTotalsFormatOpen(regular.columnName) : void 0
        } : void 0,
        columns: offersColumnMenu(GridColumnMenuItem.Columns) ? {
          canMoveLeft: canMove(-1),
          canMoveRight: canMove(1),
          canHide: shownColumnIds.length > 1,
          hidden: hiddenColumnEntries,
          onMove: (offset) => arrangeColumnsTo(hiddenColumns, moveColumn(allColumnIds, columnOrder, hiddenColumns, columnId, offset, pinOf)),
          onHide: () => arrangeColumnsTo(/* @__PURE__ */ new Set([...hiddenColumns, columnId]), columnOrder),
          ...addedColumnKeys.includes(columnId) && { onRemove: () => void removeAddedColumn(columnId) },
          onShow: (id) => arrangeColumnsTo(new Set([...hiddenColumns].filter((hidden) => hidden !== id)), columnOrder)
        } : void 0,
        pins: offersColumnMenu(GridColumnMenuItem.Pin) ? { pin, onPin: (next) => pinColumnTo(columnId, next) } : void 0,
        onResetColumns: (offersColumnMenu(GridColumnMenuItem.Columns) || offersColumnMenu(GridColumnMenuItem.Pin)) && (hiddenColumns.size > 0 || columnOrder !== null || userPins.size > 0) ? () => arrangeColumnsTo(EMPTY_COLUMN_IDS, null, EMPTY_PINS) : void 0
      }
    );
  };
  const headerWidthFor = (columnName) => {
    const width = givenWidthFor(columnName);
    return pinOf(columnName) && (width === void 0 || !/^\d+(\.\d+)?px$/.test(width.trim())) ? `${PINNED_COLUMN_WIDTH}px` : width;
  };
  const givenWidthFor = (columnName) => {
    const userSize = columnSizing[columnName];
    if (typeof userSize === "number") return `${userSize}px`;
    const declaredWidth = declaredColumnsByName.get(columnName)?.width ?? templateColumnsById.get(columnName)?.width ?? relatedColumnsById.get(columnName)?.width;
    if (declaredWidth !== void 0) {
      return typeof declaredWidth === "number" ? `${declaredWidth}px` : declaredWidth;
    }
    const viewWidth = effectiveColumnsByName.get(columnName)?.width;
    return typeof viewWidth === "number" ? `${viewWidth}px` : void 0;
  };
  const hasPixelWidth = (columnName) => {
    const width = headerWidthFor(columnName);
    return width !== void 0 && /^\d+(\.\d+)?px$/.test(width.trim());
  };
  const isRegularColumn = (id) => !templateColumnsById.has(id) && !relatedColumnsById.has(id);
  const pageArrangement = () => ({
    order: null,
    hidden: EMPTY_COLUMN_IDS,
    pins: EMPTY_PINS,
    sizing: EMPTY_COLUMN_SIZING,
    aggregates: /* @__PURE__ */ new Map(),
    formats: /* @__PURE__ */ new Map(),
    group: null,
    layout: isLayoutControlled ? layout : defaultLayout
  });
  const arrangementFromLayout = (saved, authored = false) => {
    const declaredPin = pinLookupFor(EMPTY_PINS);
    const pins = /* @__PURE__ */ new Map();
    const sizing = {};
    const aggregates = /* @__PURE__ */ new Map();
    const formats = /* @__PURE__ */ new Map();
    for (const column of saved.columns) {
      const { columnName: key3, pin } = column;
      if ((authored || offersColumnMenu(GridColumnMenuItem.Pin)) && pin !== declaredPin(key3)) pins.set(key3, pin ?? null);
      const declaredWidth = declaredColumnsByName.get(key3)?.width ?? templateColumnsById.get(key3)?.width ?? relatedColumnsById.get(key3)?.width;
      const width = typeof column.width === "number" ? column.width : void 0;
      if (width && declaredWidth !== void 0 && declaredWidth !== width && declaredWidth !== `${width}px`) {
        sizing[key3] = width;
      }
      if ((authored || offersColumnMenu(GridColumnMenuItem.Totals)) && isRegularColumn(key3)) {
        const chosen = totalsToAggregates(column.aggregates);
        const given = [...givenAggregatesByColumn.get(key3.toLowerCase())?.aggregates ?? []].reduce((all, x) => all | x, 0);
        if (chosen !== given) {
          aggregates.set(key3.toLowerCase(), {
            columnName: key3,
            aggregates: AGGREGATE_ORDER.filter((aggregate) => (chosen & aggregate) !== 0)
          });
        }
        const givenFormats = givenAggregatesByColumn.get(key3.toLowerCase())?.formats ?? NO_FORMATS;
        const shownIn = /* @__PURE__ */ new Map();
        const seen = /* @__PURE__ */ new Set();
        for (const { aggregate, format: savedFormat } of column.aggregates ?? []) {
          if (seen.has(aggregate) || !FORMATTED_AGGREGATES.includes(aggregate)) continue;
          seen.add(aggregate);
          const format = savedFormat?.trim();
          if (format !== void 0 && isValidAggregateFormat(format) && format !== (givenFormats.get(aggregate) ?? "")) {
            shownIn.set(aggregate, format);
          }
        }
        if (shownIn.size > 0) formats.set(key3.toLowerCase(), { columnName: key3, formats: shownIn });
      }
    }
    const group = saved.groupBy.slice(0, MAX_GROUP_LEVELS);
    const savedLayout = saved.layout;
    return {
      order: saved.columns.map((column) => column.columnName),
      hidden: authored || offersColumnMenu(GridColumnMenuItem.Columns) ? new Set(saved.columns.filter((column) => column.hidden).map((column) => column.columnName)) : EMPTY_COLUMN_IDS,
      pins,
      sizing,
      aggregates,
      formats,
      // A view the page defines groups the rows only when it names a grouping: one that names none
      // leaves the page's. A saved view's none is the user's choice to have none.
      group: (authored ? group.length > 0 : usersMayGroup) && groupBySignatureOf(group) !== groupBySignatureOf(propsGroupLevels) ? group : null,
      layout: (authored || allowChangingLayout) && !isLayoutControlled && savedLayout ? savedLayout : isLayoutControlled ? layout : defaultLayout
    };
  };
  const pixelWidthWith = (sizing, id) => {
    const dragged = sizing[id];
    if (typeof dragged === "number") return Math.round(dragged);
    const declared = declaredColumnsByName.get(id)?.width ?? templateColumnsById.get(id)?.width ?? relatedColumnsById.get(id)?.width;
    const width = declared ?? effectiveColumnsByName.get(id)?.width;
    if (typeof width === "number") return width > 0 ? Math.round(width) : void 0;
    const pixels = typeof width === "string" ? /^(\d+(?:\.\d+)?)px$/.exec(width.trim()) : null;
    return pixels ? Math.round(Number(pixels[1])) : void 0;
  };
  const layoutOf2 = (arrangement) => {
    const pinFor = pinLookupFor(arrangement.pins);
    return {
      version: 1,
      pageSize,
      layout: arrangement.layout,
      groupBy: [...arrangement.group ?? propsGroupLevels],
      columns: arrangeColumns(allColumnIds, arrangement.order).map((id) => {
        const pin = pinFor(id);
        const aggregates = isRegularColumn(id) ? arrangement.aggregates.get(id.toLowerCase())?.aggregates ?? [...givenAggregatesByColumn.get(id.toLowerCase())?.aggregates ?? []] : [];
        const width = pixelWidthWith(arrangement.sizing, id);
        const totals = aggregatesToTotals(aggregates.reduce((all, x) => all | x, 0), formatsWith(arrangement.formats, id));
        const shown = isRegularColumn(id) ? effectiveColumnsByName.get(id) : void 0;
        const displayLabel = shown && shown.type !== ColumnType.RelatedRecords ? shown.displayName : void 0;
        return {
          columnName: id,
          ...width !== void 0 && { width },
          ...arrangement.hidden.has(id) && { hidden: true },
          ...pin && { pin },
          ...totals && { aggregates: totals },
          ...displayLabel && { displayLabel }
        };
      })
    };
  };
  const applyArrangement = (arrangement, forViewId, savedPageSize, state) => {
    setColumnOrder(arrangement.order);
    setHiddenColumns(arrangement.hidden);
    setUserPins(arrangement.pins);
    setColumnSizing(arrangement.sizing);
    setUserAggregates(arrangement.aggregates);
    setUserFormats(arrangement.formats);
    const groupBefore = currentGroupLevels;
    setGroupingState((previous) => ({ ...previous, user: arrangement.group ? { value: arrangement.group } : null }));
    reportGroupingChange(groupBefore, arrangement.group ?? propsGroupLevels);
    if (!isLayoutControlled && arrangement.layout !== layout) {
      setInternalLayout(arrangement.layout);
      onLayoutChanged?.(arrangement.layout);
    }
    const nextPageSize = savedPageSize && pageSizes.includes(savedPageSize) ? savedPageSize : void 0;
    if (nextPageSize !== void 0) setPageSize(nextPageSize);
    writeStateToUrl({
      ...state,
      viewId: forViewId,
      order: arrangement.order,
      hidden: arrangement.hidden,
      pins: arrangement.pins,
      aggregates: arrangement.aggregates,
      formats: arrangement.formats,
      groupLevels: arrangement.group,
      layout: arrangement.layout,
      ...nextPageSize !== void 0 && { pageSize: nextPageSize }
    });
  };
  const arrangedViewRef = useRef(void 0);
  useEffect(() => {
    if (savedViews.loading || !resolvedViewId || arrangedViewRef.current !== void 0) return;
    const opening = viewLayout(resolvedViewId);
    if (!allowSavedViews && !opening) return;
    arrangedViewRef.current = resolvedViewId;
    const url = initialPersistedState;
    const urlArranged = !!url && (url.a !== void 0 || url.f !== void 0 || url.h !== void 0 || url.o !== void 0 || url.n !== void 0 || url.g !== void 0 || url.l !== void 0);
    if (opening && !urlArranged) {
      applyArrangement(arrangementFromLayout(opening, isPageArranged(resolvedViewId)), resolvedViewId, url?.ps === void 0 ? opening.pageSize : void 0);
    }
  }, [allowSavedViews, savedViews.loading, resolvedViewId, pageViewLayouts]);
  const shownSavedView = savedViews.views.find((view) => view.id === resolvedViewId);
  const declaredDefaultSort = declaredColumns.find((column) => column.isDefaultSortColumn);
  const hasUserSort = sort.length > 0 && !(sort.length === 1 && declaredDefaultSort && sort[0].columnName === declaredDefaultSort.columnName && !!sort[0].descending === (declaredDefaultSort.initialSortDirection === "desc"));
  const viewCustomized = (savedViews.available || savedViews.needsSignIn) && (!!criteria || hasUserSort || !savedGridViewLayoutsArrangeAlike(
    layoutOf2({
      order: columnOrder,
      hidden: hiddenColumns,
      pins: userPins,
      sizing: columnSizing,
      aggregates: userAggregates,
      formats: userFormats,
      group: userGroupBy?.value ?? null,
      layout
    }),
    layoutOf2((() => {
      const opened = viewLayout(resolvedViewId);
      return opened ? arrangementFromLayout(opened, isPageArranged(resolvedViewId)) : pageArrangement();
    })())
  ));
  const savedViewQuery = () => {
    const source = (addedColumns && addedColumns.viewId === resolvedViewId ? addedColumns.fetchXml : void 0) ?? shownSavedView?.definition.fetchXml ?? allCustomViews?.find((view) => view.id === resolvedViewId)?.fetchXml ?? (pickedViewFetchXml || void 0) ?? (dataverseViewMetadataResult.data?.id === resolvedViewId ? dataverseViewMetadataResult.data?.fetchXml ?? void 0 : void 0);
    if (!source) return void 0;
    const fetch2 = parseXml(criteria ? applyGridCriteria(source, criteria) : source);
    for (const name of ["count", "page", "paging-cookie", "returntotalrecordcount"]) delete fetch2.attributes[name];
    const entity = fetch2.children.find((x) => x.name === "entity");
    if (entity && hasUserSort) {
      entity.children = [
        ...entity.children.filter((x) => x.name !== "order"),
        // A joined column's sort names its join, as the grid's own query does.
        ...sort.map((x) => {
          const dot = x.columnName.indexOf(".");
          return {
            name: "order",
            attributes: {
              ...dot > 0 && { entityname: x.columnName.slice(0, dot) },
              attribute: dot > 0 ? x.columnName.slice(dot + 1) : x.columnName,
              descending: x.descending ? "true" : "false"
            },
            children: [],
            text: ""
          };
        })
      ];
    }
    return serializeXml(fetch2);
  };
  const currentSavedLayout = () => layoutOf2({
    order: columnOrder,
    hidden: hiddenColumns,
    pins: userPins,
    sizing: columnSizing,
    aggregates: userAggregates,
    formats: userFormats,
    group: userGroupBy?.value ?? null,
    layout
  });
  const showSavedView = (id) => {
    arrangedViewRef.current = id;
    setSelectedViewId(id);
    setUserCriteria(null);
    setAddedColumns(null);
    setSort([]);
    writeStateToUrl({ viewId: id, sort: [] });
  };
  const viewNameOf = (id) => {
    const view = views.find((v) => v.id === id);
    return view ? viewLabelOf(view, t) : id;
  };
  const savedViewSession = useSavedViewSession({
    saved: savedViews,
    signInUrl,
    // Over the page — and the Manage views panel it starts from — while a view is deleted.
    deletingText: t("app.components.grid.saved-views-deleting"),
    operations: {
      shownViewId: resolvedViewId,
      savedViewName: (id) => savedViews.views.some((view) => view.id === id) ? viewNameOf(id) : void 0,
      managedViewName: viewNameOf,
      managedViews: () => managedViews,
      save: async () => {
        const fetchXml = savedViewQuery();
        if (!shownSavedView || !fetchXml) return;
        await savedViews.update(shownSavedView.id, { fetchXml, gridLayout: currentSavedLayout() });
        showSavedView(shownSavedView.id);
      },
      saveAs: async (name) => {
        const fetchXml = savedViewQuery();
        if (!fetchXml) return;
        const created = await savedViews.create(name, fetchXml, { gridLayout: currentSavedLayout() });
        showSavedView(created.id);
      },
      clone: async (id, name) => {
        const source = allCustomViews?.find((view) => view.id === id)?.fetchXml ?? views.find((view) => view.id === id)?.fetchXml;
        if (source)
          await savedViews.create(name, source, {
            gridLayout: viewLayout(id),
            calendarLayout: savedViews.views.find((view) => view.id === id)?.calendarLayout
          });
      },
      rename: async (id, name) => void await savedViews.update(id, { name }),
      remove: async (id) => {
        await savedViews.remove(id);
        if (id !== resolvedViewId) return;
        const ids = views.map((view) => view.id).filter((viewId2) => viewId2 !== id);
        const next = defaultViewId(savedViews.settings, ids, savedViewsControl) ?? (defaultViewId$1 && ids.includes(defaultViewId$1) ? defaultViewId$1 : void 0) ?? ids.find((viewId2) => !isHiddenView(viewId2)) ?? ids[0];
        if (next) handleViewChange(next);
      },
      openView: (id) => {
        if (id !== resolvedViewId) handleViewChange(id);
      },
      // The Manage views panel offers to retitle a saved view's columns, on the view.
      editColumnLabels: (id) => {
        if (id !== resolvedViewId) handleViewChange(id);
        setLabelsViewId(id);
      }
    }
  });
  const runSavedViewChange = savedViewSession.run;
  const showsColumnsButton = allowAddingColumns && !dataSource && !!resolvedViewId;
  const [columnsDialogOpen, setColumnsDialogOpen] = useState(false);
  const ownColumnKeys = allColumnIds.filter((id) => isRegularColumn(id) && !addedColumnKeys.includes(id));
  const { ownJoinAliases, ownAttributeKeys } = useMemo(() => {
    if (!sourceView?.fetchXml) return { ownJoinAliases: EMPTY_COLUMN_NAMES, ownAttributeKeys: EMPTY_COLUMN_NAMES };
    try {
      const query = parseFetchXml(sourceView.fetchXml);
      return {
        ownJoinAliases: getLinkAliases(query),
        ownAttributeKeys: [
          ...query.entity.attributes.map((attribute) => attribute.name),
          ...getAllLinkEntities(query).flatMap(
            (link) => link.alias ? link.attributes.map((attribute) => `${link.alias}.${attribute.name}`) : []
          )
        ]
      };
    } catch {
      return { ownJoinAliases: EMPTY_COLUMN_NAMES, ownAttributeKeys: EMPTY_COLUMN_NAMES };
    }
  }, [sourceView?.fetchXml]);
  const criteriaJoins = useMemo(() => {
    if (!criteria || !viewCriteria) return 0;
    const count = (fetchXml) => {
      try {
        return getAllLinkEntities(parseFetchXml(fetchXml)).length;
      } catch {
        return 0;
      }
    };
    return Math.max(0, count(criteria) - count(viewCriteria));
  }, [criteria, viewCriteria]);
  const forgetColumns = (keys) => {
    if (keys.length === 0) return;
    const gone = new Set(keys.map((key3) => key3.toLowerCase()));
    const isGone = (key3) => gone.has(key3.toLowerCase());
    setHiddenColumns((current) => new Set([...current].filter((key3) => !isGone(key3))));
    setUserPins((current) => new Map([...current].filter(([key3]) => !isGone(key3))));
    setColumnSizing((current) => Object.fromEntries(Object.entries(current).filter(([key3]) => !isGone(key3))));
    setUserAggregates((current) => new Map([...current].filter(([, value2]) => !isGone(value2.columnName))));
    setUserFormats((current) => new Map([...current].filter(([, value2]) => !isGone(value2.columnName))));
    setColumnOrder((current) => current && current.some(isGone) ? current.filter((key3) => !isGone(key3)) : current);
    if (currentGroupLevels.some((level) => isGone(level.columnName))) {
      setUserGroupLevels(currentGroupLevels.filter((level) => !isGone(level.columnName)));
    }
    if (sort.some((directive) => isGone(directive.columnName))) setSort(sort.filter((directive) => !isGone(directive.columnName)));
  };
  const applyColumns = async (choice2) => {
    setColumnsDialogOpen(false);
    const changed = choice2.added.length !== addedColumnKeys.length || choice2.added.some((key3, index) => key3.toLowerCase() !== addedColumnKeys[index]?.toLowerCase());
    if (changed && (gridIsDirtyRef.current || parentMainContext?.isDirty) && !await warnAboutUnsavedChanges()) return;
    const hidden = new Set([...hiddenColumns].filter((id) => !ownColumnKeys.includes(id)));
    for (const key3 of choice2.hiddenOwn) hidden.add(key3);
    for (const key3 of choice2.added) hidden.delete(key3);
    arrangeColumnsTo(hidden, columnOrder);
    if (!changed || !resolvedViewId) return;
    forgetColumns(addedColumnKeys.filter((key3) => !choice2.added.some((added) => added.toLowerCase() === key3.toLowerCase())));
    setAddedColumns(choice2.added.length === 0 ? null : { viewId: resolvedViewId, fetchXml: choice2.fetchXml, keys: choice2.added });
    setPage(1);
    requestEmptySelection();
  };
  const removeAddedColumn = async (key3) => {
    if (!addedColumns || !resolvedViewId) return;
    if ((gridIsDirtyRef.current || parentMainContext?.isDirty) && !await warnAboutUnsavedChanges()) return;
    const keys = addedColumns.keys.filter((x) => x !== key3);
    const choice2 = choose(addedColumns.fetchXml, [...ownColumnKeys, ...keys], ownColumnKeys, ownJoinAliases, ownAttributeKeys);
    forgetColumns([key3]);
    setAddedColumns(keys.length === 0 ? null : { viewId: resolvedViewId, fetchXml: choice2.fetchXml, keys });
    setPage(1);
    requestEmptySelection();
  };
  const [labelsViewId, setLabelsViewId] = useState(null);
  const columnLabels = arrangeColumns(allColumnIds, columnOrder).flatMap((id) => {
    const own = isRegularColumn(id) ? unlabeledResolvedColumns.find((column) => column.columnName === id) : void 0;
    if (!own || own.type === ColumnType.RelatedRecords) return [];
    const label = savedViews.views.find((view) => view.id === labelsViewId)?.gridLayout?.columns.find((column) => column.columnName === id)?.displayLabel;
    return [{ key: id, ownTitle: own.displayName ?? id, ...label && { label } }];
  });
  const saveColumnLabels = (labels) => {
    const id = labelsViewId;
    setLabelsViewId(null);
    const saved = savedViews.views.find((view) => view.id === id);
    if (!id || !saved) return;
    const stored = saved.gridLayout ?? layoutOf2(pageArrangement());
    const layout2 = {
      ...stored,
      columns: stored.columns.map((column) => {
        if (!labels.has(column.columnName)) return column;
        const { displayLabel: _, ...rest } = column;
        const label = labels.get(column.columnName)?.trim();
        return label ? { ...rest, displayLabel: label } : rest;
      })
    };
    void runSavedViewChange(() => savedViews.update(id, { gridLayout: layout2 }).then(() => void 0));
  };
  const shownDefaultViewId = savedViews.available ? defaultViewId(savedViews.settings, views.map((view) => view.id), savedViewsControl) : void 0;
  const managedViews = views.map((view) => ({
    id: view.id,
    name: viewNameOf(view.id),
    isSaved: savedViews.views.some((saved) => saved.id === view.id),
    isDefault: view.id === shownDefaultViewId,
    isHidden: isHiddenView(view.id),
    isShown: view.id === resolvedViewId
  })).sort((a, b) => Number(a.isSaved) - Number(b.isSaved) || a.name.localeCompare(b.name));
  const savedViewsMenu = savedViewSession.menu({
    canSave: viewCustomized && !!shownSavedView,
    canSaveAs: viewCustomized,
    canSetDefault: !!resolvedViewId && resolvedViewId !== shownDefaultViewId
  });
  const filterMenu = {
    changed: !!criteria || offersSavedViewsMenu && viewCustomized,
    ...showsFilterButton && { onEditFilters: () => setFilterDialogOpen(true) },
    ...offersSavedViewsMenu && { savedViews: savedViewsMenu }
  };
  const settingsMenu = {
    ...showsColumnsButton && { onColumns: () => setColumnsDialogOpen(true) },
    ...sortableColumns.length > 0 && { onSort: () => setSortPanelOpen(true) },
    ...showSettingsPageSizeRow && { pageSize: { value: pageSize, options: pageSizes, onChange: handlePageSizeChange } },
    ...showSettingsEditableRow && {
      editable: {
        checked: editable,
        ...inlineEditDisabled && { disabledReason: t("app.components.grid.editable-disabled-tooltip") },
        onChange: handleEditableToggle
      }
    },
    ...showsMapBesideCards && { mapSelectedOnly: { checked: mapSelectedOnly, onChange: setMapSelectedOnlyChoice } },
    ...offersMapPrintList && { mapPrintList: { value: shownMapPrintList, onChange: setMapPrintListChoice } }
  };
  const hasUnsizedColumn = table.getVisibleLeafColumns().some((column) => {
    const width = headerWidthFor(column.id);
    return width === void 0 || width.trim() === "auto";
  });
  const recordShownWidthBeforeResize = (columnId, handle) => {
    if (hasPixelWidth(columnId)) return;
    const shown = handle.closest("th")?.getBoundingClientRect().width;
    if (!shown) return;
    const recorded = Math.round(shown);
    flushSync(() => setColumnSizing((previous) => ({ ...previous, [columnId]: recorded })));
    const dropIfUnmoved = () => {
      window.removeEventListener("mouseup", dropIfUnmoved);
      window.removeEventListener("touchend", dropIfUnmoved);
      setTimeout(
        () => setColumnSizing((previous) => {
          if (previous[columnId] !== recorded) return previous;
          const { [columnId]: _unmoved, ...rest } = previous;
          return rest;
        })
      );
    };
    window.addEventListener("mouseup", dropIfUnmoved);
    window.addEventListener("touchend", dropIfUnmoved);
  };
  const selectedRecords = useMemo(() => {
    if (selectionMode === "none") return EMPTY_RECORDS;
    return table.getSelectedRowModel().rows.map((r) => r.original);
  }, [rowSelection, selectionMode, data]);
  useEffect(() => {
    if (!onSelectedRecordsChange) return;
    if (isSelectionControlled) return;
    onSelectedRecordsChange(selectedRecords);
  }, [selectedRecords, onSelectedRecordsChange, isSelectionControlled]);
  const totalCount = (() => {
    const raw = dataSource ? dataSource.totalCount : recordsResult.data?.pagingInfo?.totalRecordCount;
    if (raw == null) return void 0;
    return typeof raw === "number" ? raw : Number(raw);
  })();
  const hasMoreRowsToLoad2 = accumulates && hasMoreRowsToLoad({
    accumulatedCount: accumulatedRows?.length ?? 0,
    totalCount,
    moreRecords: dataSource ? dataSource.moreRecords : recordsResult.data?.pagingInfo?.moreRecords,
    // "A page has landed and it carried no rows." In standalone mode
    // `data` is only ever defined for a landed response (errors wipe it);
    // the datasource has no data handle, so idle-after-success stands in.
    lastPageEmpty: dataSource ? dataSource.status === QueryStatus.Success && !dataSource.isFetching && dataSource.rows.length === 0 : recordsResult.data !== void 0 && pageRecords.length === 0
  });
  const isResolvingView = !!tableName && !viewId && viewsResult.status === QueryStatus.Loading;
  const isLoading = dataSource ? dataSource.status === QueryStatus.Loading : isResolvingView || recordsResult.status === QueryStatus.Loading;
  const isRefetching = dataSource ? !isLoading && dataSource.isFetching : !isLoading && recordsResult.isFetching;
  const error = dataSource ? dataSource.error : viewsResult.error ?? recordsResult.error;
  const isLoadingMoreRows = isVirtualize && isRefetching && page > 1 && loadMorePageRef.current === page && appliedResetKeyRef.current === accumulatorResetKey;
  const rowsFetching = dataSource ? dataSource.isFetching || groupBySignatureOf(dataSource.currentQuery.groupBy ?? EMPTY_GROUP_LEVELS) !== groupBySignature || [...dataSource.currentQuery.collapsedGroups ?? []].sort().join(GROUP_KEY_SEPARATOR) !== collapsedGroupsKey : recordsResult.isFetching;
  const fetchedCollapsedGroupsRef = useRef(EMPTY_GROUP_KEYS);
  if (!rowsFetching) fetchedCollapsedGroupsRef.current = activeGroupBy ? collapsedGroups : EMPTY_GROUP_KEYS;
  const fetchedCollapsedGroups = fetchedCollapsedGroupsRef.current;
  const settledGroupLayoutRef = useRef(null);
  const groupsSettled = !aggregatesResult.isFetching && (!rowsFetching || isLoadingMoreRows);
  if (!activeGroupBy) settledGroupLayoutRef.current = null;
  else if (groupsSettled) settledGroupLayoutRef.current = latestGroupLayout;
  const groupLayout = activeGroupBy ? settledGroupLayoutRef.current : null;
  const isLoadingAggregates = !!aggregatesRequest && aggregatesResult.isFetching;
  const mapOnlyPageLanded = landed?.page === `${accumulatorResetKey}${page}`;
  const mapOnlyWantsMore = hasMoreRowsToLoad2 && page * requestPageSize < mapMaximumRows;
  const isLoadingMapOnlyRows = showsMapOnly && !error && (!mapOnlyPageLanded || recordsResult.isFetching || mapOnlyWantsMore);
  const showsLoadingOverlay = (isLoading || isRefetching && !isLoadingMoreRows || isLoadingAggregates || isEditableTransitionPending || isLoadingMapOnlyRows) && activeGridOverlay === null && !pageOverlayCovers;
  const onRefreshRef = useRef(onRefresh);
  onRefreshRef.current = onRefresh;
  const hasAggregatesRequest = !!aggregatesRequest;
  const refetchAggregates = aggregatesResult.refetch;
  const refresh = useCallback(async () => {
    const aggregatesRefetch = hasAggregatesRequest ? refetchAggregates() : Promise.resolve();
    if (dataSource) {
      if (pagingMode === PagingMode.Virtualize) {
        resetVirtualizedView();
      }
      await Promise.all([dataSource.refresh(), aggregatesRefetch]);
      onRefreshRef.current?.();
      return;
    }
    if (pagingMode === PagingMode.Virtualize) {
      const wasOnFirstPage = page === 1;
      resetVirtualizedView();
      if (wasOnFirstPage) {
        await recordsResult.refetch();
      }
      await aggregatesRefetch;
      onRefreshRef.current?.();
      return;
    }
    await Promise.all([recordsResult.refetch(), aggregatesRefetch]);
    onRefreshRef.current?.();
  }, [dataSource, pagingMode, page, recordsResult.refetch, resetVirtualizedView, hasAggregatesRequest, refetchAggregates]);
  const pendingRowUpdatesRef = useRef(pendingRowUpdates);
  pendingRowUpdatesRef.current = pendingRowUpdates;
  const pendingRowCreatesRef = useRef(pendingRowCreates);
  pendingRowCreatesRef.current = pendingRowCreates;
  const pendingRowAssociatesRef = useRef(pendingRowAssociates);
  pendingRowAssociatesRef.current = pendingRowAssociates;
  const pendingRowDeletesRef = useRef(pendingRowDeletes);
  pendingRowDeletesRef.current = pendingRowDeletes;
  const pendingRowDisassociatesRef = useRef(pendingRowDisassociates);
  pendingRowDisassociatesRef.current = pendingRowDisassociates;
  const isManyToManySubGridRef = useRef(isManyToManySubGrid);
  isManyToManySubGridRef.current = isManyToManySubGrid;
  const queueRowUpdate = useCallback((update) => {
    setPendingRowUpdates((prev) => {
      const next = new Map(prev);
      if (update.dirty.size === 0) {
        next.delete(update.recordId);
      } else {
        next.set(update.recordId, update);
      }
      return next;
    });
  }, []);
  const queueRowCreate = useCallback((create) => {
    setPendingRowCreates((prev) => [...prev, create]);
  }, []);
  const updatePendingRowCreate = useCallback(
    (index, create) => {
      setPendingRowCreates((prev) => {
        if (index < 0 || index >= prev.length) return prev;
        const next = prev.slice();
        next[index] = create;
        return next;
      });
    },
    []
  );
  const clearPendingRowUpdates = useCallback(() => {
    setPendingRowUpdates(/* @__PURE__ */ new Map());
    setPendingRowCreates([]);
    setPendingRowAssociates([]);
    setPendingRowDisassociates([]);
    setPendingRowDeletes([]);
  }, []);
  const queueRowAssociates = useCallback(
    (records) => {
      if (records.length === 0) return;
      const toAdd = records;
      setPendingRowDisassociates(
        (prev) => prev.filter(
          (r) => !toAdd.some((a) => a.tableName === r.tableName && a.id === r.id)
        )
      );
      setPendingRowAssociates((prev) => {
        const seen = new Set(prev.map((r) => `${r.tableName}:${r.id}`));
        const next = prev.slice();
        for (const r of toAdd) {
          const key3 = `${r.tableName}:${r.id}`;
          if (!seen.has(key3)) {
            seen.add(key3);
            next.push(r);
          }
        }
        return next.length === prev.length ? prev : next;
      });
    },
    []
  );
  const queueRowDisassociates = useCallback(
    (records) => {
      if (records.length === 0) return;
      const createSyntheticIdsToDrop = /* @__PURE__ */ new Set();
      const realIds = [];
      for (const r of records) {
        if (!r.id) continue;
        if (r.id.startsWith("__pending-create-")) {
          createSyntheticIdsToDrop.add(r.id);
        } else {
          realIds.push(r);
        }
      }
      if (createSyntheticIdsToDrop.size > 0) {
        setPendingRowCreates((prev) => {
          const next = prev.filter(
            (_, idx) => !createSyntheticIdsToDrop.has(`__pending-create-${idx}`)
          );
          return next.length === prev.length ? prev : next;
        });
      }
      const currentAssociates = pendingRowAssociatesRef.current;
      const associatesToDrop = [];
      const realDisassociates = [];
      for (const r of realIds) {
        const inAssociates = currentAssociates.some(
          (a) => a.tableName === r.tableName && a.id === r.id
        );
        if (inAssociates) {
          associatesToDrop.push(r);
        } else {
          realDisassociates.push(r);
        }
      }
      if (associatesToDrop.length > 0) {
        setPendingRowAssociates(
          (prev) => prev.filter(
            (r) => !associatesToDrop.some(
              (a) => a.tableName === r.tableName && a.id === r.id
            )
          )
        );
      }
      if (realDisassociates.length > 0) {
        setPendingRowDisassociates((prev) => {
          const seen = new Set(prev.map((r) => `${r.tableName}:${r.id}`));
          const next = prev.slice();
          for (const r of realDisassociates) {
            const key3 = `${r.tableName}:${r.id}`;
            if (!seen.has(key3)) {
              seen.add(key3);
              next.push(r);
            }
          }
          return next.length === prev.length ? prev : next;
        });
      }
    },
    []
  );
  const queueRowDeletes = useCallback(
    (records) => {
      if (records.length === 0) return;
      const syntheticIdsToDrop = /* @__PURE__ */ new Set();
      const realIds = [];
      for (const r of records) {
        if (!r.id) continue;
        if (r.id.startsWith("__pending-create-")) {
          syntheticIdsToDrop.add(r.id);
        } else {
          realIds.push(r);
        }
      }
      if (syntheticIdsToDrop.size > 0) {
        setPendingRowCreates((prev) => {
          const next = prev.filter(
            (_, idx) => !syntheticIdsToDrop.has(`__pending-create-${idx}`)
          );
          return next.length === prev.length ? prev : next;
        });
      }
      if (realIds.length > 0) {
        setPendingRowDeletes((prev) => {
          const seen = /* @__PURE__ */ new Set();
          for (const r of prev) seen.add(`${r.tableName}:${r.id}`);
          const next = [...prev];
          for (const r of realIds) {
            const key3 = `${r.tableName}:${r.id}`;
            if (!seen.has(key3)) {
              seen.add(key3);
              next.push(r);
            }
          }
          return next.length === prev.length ? prev : next;
        });
      }
    },
    []
  );
  const clearSelection = useCallback(async () => {
    requestEmptySelection();
  }, [requestEmptySelection]);
  const validate = useCallback(() => true, []);
  const buildPendingRowChangeRequests = useCallback(() => {
    const updates = pendingRowUpdatesRef.current;
    const creates = pendingRowCreatesRef.current;
    const associates = pendingRowAssociatesRef.current;
    const disassociates = pendingRowDisassociatesRef.current;
    const deletes = pendingRowDeletesRef.current;
    if (updates.size === 0 && creates.length === 0 && associates.length === 0 && disassociates.length === 0 && deletes.length === 0) {
      return [];
    }
    const requests = [];
    for (const update of updates.values()) {
      const properties = {};
      for (const [col, val] of update.dirty) {
        properties[col] = val;
      }
      requests.push({
        $type: "UpdateRequest",
        record: {
          id: update.recordId,
          tableName: update.tableName,
          properties
        }
      });
    }
    for (const create of creates) {
      requests.push({
        $type: "CreateRequest",
        record: create.record
      });
    }
    const parentRefId = parentRecord ? getRecordReferenceId(parentRecord) : void 0;
    if (parentRecord?.tableName && parentRefId && relationshipName) {
      const parentRef = {
        tableName: parentRecord.tableName,
        id: parentRefId
      };
      if (isManyToManySubGridRef.current && creates.length > 0) {
        const createRefs = [];
        for (const c of creates) {
          if (!c.record.tableName) continue;
          const createRefId = getRecordReferenceId(c.record);
          if (!createRefId) continue;
          createRefs.push({ tableName: c.record.tableName, id: createRefId });
        }
        if (createRefs.length > 0) {
          requests.push({
            $type: "AssociateRequest",
            record: parentRef,
            relationshipName,
            ...selfReferencingRole !== void 0 && { role: selfReferencingRole },
            relatedRecords: createRefs
          });
        }
      }
      if (associates.length > 0) {
        const relatedRecords = [];
        for (const a of associates) {
          if (!a.tableName || !a.id) continue;
          relatedRecords.push({ tableName: a.tableName, id: a.id });
        }
        if (relatedRecords.length > 0) {
          requests.push({
            $type: "AssociateRequest",
            record: parentRef,
            relationshipName,
            ...selfReferencingRole !== void 0 && { role: selfReferencingRole },
            relatedRecords
          });
        }
      }
      if (disassociates.length > 0) {
        requests.push({
          $type: "DisassociateRequest",
          record: parentRef,
          relationshipName,
          ...selfReferencingRole !== void 0 && { role: selfReferencingRole },
          relatedRecords: disassociates
        });
      }
    }
    for (const ref of deletes) {
      if (!ref.tableName || !ref.id) continue;
      requests.push({
        $type: "DeleteRequest",
        record: { tableName: ref.tableName, id: ref.id }
      });
    }
    return requests;
  }, [parentRecord, relationshipName, selfReferencingRole]);
  const gridIsDirty = pendingRowUpdates.size > 0 || pendingRowCreates.length > 0 || pendingRowAssociates.length > 0 || pendingRowDisassociates.length > 0 || pendingRowDeletes.length > 0;
  const gridIsDirtyRef = useRef(gridIsDirty);
  gridIsDirtyRef.current = gridIsDirty;
  useEffect(() => {
    if (!parentMainContext) return;
    return parentMainContext.registerDescendant({
      getRequests: () => buildPendingRowChangeRequests(),
      validate,
      refresh: async () => {
        clearPendingRowUpdates();
        await refresh();
      },
      // Cancel/Discard: drop the queued row updates / creates / associates
      // / disassociates without touching the server. Doesn't clear the
      // visible selection — that's a separate primitive (clearSelection).
      resetState: clearPendingRowUpdates,
      isDirty: () => gridIsDirtyRef.current
    });
  }, [parentMainContext?.registerDescendant, refresh, buildPendingRowChangeRequests, clearPendingRowUpdates, validate]);
  const parentMainContextRef = useRef(parentMainContext);
  parentMainContextRef.current = parentMainContext;
  useEffect(() => {
    parentMainContextRef.current?.notifyDescendantDirtyChanged();
  }, [gridIsDirty]);
  const tablePermissions2 = dataSource ? dataSource.tablePermissions : recordsResult.data?.tablePermissions;
  const exportQueryKey = useMemo(() => JSON.stringify(exportQuery), [exportQuery]);
  const shownData = dataSource ? dataSource.rows : recordsResult.data;
  const gridFetching = dataSource ? dataSource.isFetching : recordsResult.isFetching;
  const gridLoaded = (dataSource ? dataSource.status : recordsResult.status) === QueryStatus.Success;
  const [loadedExportQueryKey, setLoadedExportQueryKey] = useState(null);
  useEffect(() => {
    if (gridLoaded && !gridFetching) setLoadedExportQueryKey(exportQueryKey);
  }, [shownData, gridFetching, gridLoaded]);
  const canExport = loadedExportQueryKey === exportQueryKey && exportEntries.length > 0 && (exportQuery.viewId !== void 0 || !!exportQuery.fetchXml);
  const exportHandlerRef = useRef(async () => {
  });
  const exportAsync = useCallback((format) => exportHandlerRef.current(format), []);
  const gridContextValue = useMemo(
    () => ({
      selectedRecords,
      tableName,
      viewTableName: viewTable,
      viewId: resolvedViewId,
      columns: resolvedColumns,
      refresh,
      overlayTargetId,
      isDirty: gridIsDirty,
      registerOpenHandler,
      registerCreateReopenHandler,
      dispatchOpen,
      hasRowOpenAffordance,
      tablePermissions: tablePermissions2,
      pendingRowUpdates,
      pendingRowCreates,
      pendingRowAssociates,
      pendingRowDisassociates,
      parentRecord,
      relationshipName,
      selfReferencingRole,
      queueRowUpdate,
      queueRowCreate,
      updatePendingRowCreate,
      queueRowAssociates,
      queueRowDisassociates,
      pendingRowDeletes,
      queueRowDeletes,
      clearPendingRowUpdates,
      clearSelection,
      validate,
      loadedRecords: data,
      allowPreviewForFileColumns,
      allowDownloadForFileColumns,
      exportAsync,
      canExport: canExport && !exporting
    }),
    [
      selectedRecords,
      tableName,
      viewTable,
      resolvedViewId,
      resolvedColumns,
      refresh,
      overlayTargetId,
      gridIsDirty,
      registerOpenHandler,
      registerCreateReopenHandler,
      dispatchOpen,
      hasRowOpenAffordance,
      tablePermissions2,
      pendingRowUpdates,
      pendingRowCreates,
      pendingRowAssociates,
      pendingRowDisassociates,
      pendingRowDeletes,
      parentRecord,
      relationshipName,
      selfReferencingRole,
      queueRowUpdate,
      queueRowCreate,
      updatePendingRowCreate,
      queueRowAssociates,
      queueRowDisassociates,
      queueRowDeletes,
      clearPendingRowUpdates,
      clearSelection,
      validate,
      data,
      allowPreviewForFileColumns,
      allowDownloadForFileColumns,
      exportAsync,
      canExport,
      exporting
    ]
  );
  useEffect(() => {
    if (!isVirtualize) return;
    const sentinel = loadMoreSentinelRef.current;
    const root = tableContainerRef.current;
    if (!sentinel || !root) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry?.isIntersecting) return;
        if (recordsResult.isFetching) return;
        if (!hasMoreRowsToLoad2) return;
        loadMorePageRef.current = page + 1;
        setPage(page + 1);
      },
      {
        root,
        // Pre-fetch a half-page before the user actually hits bottom so
        // the scroll doesn't visibly stall while the next page loads.
        rootMargin: "200px 0px 200px 0px",
        threshold: 0
      }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [isVirtualize, showsCards, showsMap, hasMoreRowsToLoad2, recordsResult.isFetching, page, setPage]);
  useEffect(() => {
    if (!showsMapOnly || error || !mapOnlyPageLanded || recordsResult.isFetching || !mapOnlyWantsMore) return;
    setPage(page + 1);
  }, [showsMapOnly, error, mapOnlyPageLanded, recordsResult.isFetching, recordsResult.data, mapOnlyWantsMore, page, setPage]);
  const handlePageChange = (nextPage) => {
    if (nextPage === page) return;
    setPage(nextPage);
    requestEmptySelection();
    writeStateToUrl({ page: nextPage });
  };
  const selectedView = views?.find((v) => v.id === resolvedViewId);
  const singleViewTitle = selectedView ? resolveViewLabel(selectedView, t) ?? void 0 : void 0;
  const handleExport = async (format) => {
    if (exportAbortRef.current !== null || !canExport) return;
    const abort = new AbortController();
    exportAbortRef.current = abort;
    setExporting(true);
    let result;
    let failed = false;
    try {
      const name = title ?? singleViewTitle ?? selectedView?.tableName ?? tableName ?? "";
      result = await runWithOverlay(
        { targetId: overlayTargetId, description: t("app.components.grid.export-progress") },
        () => ppp.exportGridAsync({
          format,
          fileName: `${name} ${localDate()}`.trim(),
          // With the footer's figures and the grid's grouping, so a workbook has its totals and
          // groups, the ones the grid shows collapsed collapsed. Every group's records are in it.
          query: {
            ...exportQuery,
            ...requestedAggregates.length > 0 && { columnAggregates: requestedAggregates },
            ...activeGroupBy && { groupBy: [...activeGroupLevels] },
            ...activeGroupBy && collapsedGroupsKey && { collapsedGroups: collapsedGroupsKey.split(GROUP_KEY_SEPARATOR) },
            ...activeGroupBy && maximumRangedValues !== void 0 && { maximumRangedValues }
          },
          columns: exportEntries.map((e) => e.name),
          columnHeaders: Object.fromEntries(exportEntries.map((e) => [e.name, e.header])),
          ...exportEntries.some((e) => e.related) && {
            relatedRecordsColumns: Object.fromEntries(
              exportEntries.filter((e) => e.related).map((e) => [e.name, e.related])
            )
          }
        }, abort.signal)
      );
      if (abort.signal.aborted) return;
      triggerBlobDownload(result.data, result.fileName);
    } catch (err) {
      if (abort.signal.aborted) return;
      console.error("[MainGrid] Exporting the grid failed.", err);
      failed = true;
    } finally {
      if (exportAbortRef.current === abort) exportAbortRef.current = null;
      if (!abort.signal.aborted) setExporting(false);
    }
    if (failed) {
      await dialog.showErrorAsync(t("app.components.grid.export-failed-message"), {
        title: t("app.components.grid.export-failed-title")
      });
    } else if (result?.isTruncated) {
      await dialog.showWarningAsync(
        t("app.components.grid.export-truncated-message", [result.recordCount.toLocaleString()]),
        { title: t("app.components.grid.export-truncated-title") }
      );
    }
  };
  useLayoutEffect(() => {
    exportHandlerRef.current = handleExport;
  });
  const rowStateFor = (row) => {
    const isSelected = row.getIsSelected();
    const rowId = row.original.id;
    const isPendingCreate = rowId !== void 0 && pendingCreateIds.has(rowId);
    const isPendingAssociate = rowId !== void 0 && !isPendingCreate && pendingAssociateIds.has(rowId);
    const isPendingDisassociate = rowId !== void 0 && !isPendingCreate && !isPendingAssociate && pendingDisassociateIds.has(rowId);
    const isPendingDelete = rowId !== void 0 && !isPendingCreate && !isPendingAssociate && !isPendingDisassociate && pendingDeleteIds.has(rowId);
    const isPendingUpdate = rowId !== void 0 && !isPendingCreate && !isPendingAssociate && !isPendingDisassociate && !isPendingDelete && pendingRowUpdates.has(rowId);
    const isHighlightMuted = (() => {
      if (!dataSource || !dataSource.highlight) return false;
      const property = row.original.properties?.[dataSource.highlight.column];
      if (!property) return true;
      return !highlightMatches(dataSource.highlight, readColumnWireValue(property));
    })();
    const rowDoubleClickAffordance = isPendingCreate ? hasCreateReopenHandler : hasOpenHandler || !isPendingDelete && rowPageUrl(row.original) !== void 0;
    const handleRowDoubleClick = allowOpenOnRowDoubleClick && rowDoubleClickAffordance ? (ev) => {
      if (isRowControlTarget(ev.target)) return;
      dispatchOpen(row.original);
    } : void 0;
    const handleRowClick = selectFromEntireRow && selectionMode !== "none" ? (ev) => {
      if (isRowControlTarget(ev.target)) return;
      row.toggleSelected(!isSelected);
    } : void 0;
    const isRowInlineEditable = editable && !isPendingCreate && !isPendingAssociate && !!row.original.id && !!row.original.tableName;
    return {
      isSelected,
      isPendingCreate,
      isPendingAssociate,
      isPendingDisassociate,
      isPendingDelete,
      isPendingUpdate,
      isHighlightMuted,
      canOpen: rowDoubleClickAffordance,
      handleRowDoubleClick,
      handleRowClick,
      isRowInlineEditable
    };
  };
  const pendingIconFor = (state) => state.isPendingCreate ? /* @__PURE__ */ jsx(
    Add16Regular,
    {
      className: styles.pendingIconCreate,
      "aria-label": t("app.components.grid.pending-operation-create")
    }
  ) : state.isPendingAssociate ? /* @__PURE__ */ jsx(
    LinkAdd16Regular,
    {
      className: styles.pendingIconCreate,
      "aria-label": t("app.components.grid.pending-operation-link")
    }
  ) : state.isPendingDisassociate ? /* @__PURE__ */ jsx(
    LinkDismiss16Regular,
    {
      className: styles.pendingIconUpdate,
      "aria-label": t("app.components.grid.pending-operation-unlink")
    }
  ) : state.isPendingDelete ? /* @__PURE__ */ jsx(
    Delete16Regular,
    {
      className: styles.pendingIconUpdate,
      "aria-label": t("app.components.grid.pending-operation-delete")
    }
  ) : state.isPendingUpdate ? /* @__PURE__ */ jsx(
    Edit16Regular,
    {
      className: styles.pendingIconUpdate,
      "aria-label": t("app.components.grid.pending-operation-update")
    }
  ) : null;
  const cellContentFor = (cell) => {
    const renderer = cell.column.columnDef.cell;
    return typeof renderer === "function" ? renderer(cell.getContext()) : renderer;
  };
  const aggregateLabel = (aggregate) => {
    switch (aggregate) {
      case QueryAggregate.Sum:
        return t("app.components.grid.aggregate-sum");
      case QueryAggregate.Average:
        return t("app.components.grid.aggregate-average");
      case QueryAggregate.Minimum:
        return t("app.components.grid.aggregate-minimum");
      case QueryAggregate.Maximum:
        return t("app.components.grid.aggregate-maximum");
      default:
        return t("app.components.grid.aggregate-count");
    }
  };
  const totalsColumnIds = table.getVisibleLeafColumns().map((column) => column.id).filter((id) => !templateColumnsById.has(id) && aggregatesByColumn.has(id.toLowerCase()));
  const hasTotals = totalsColumnIds.length > 0;
  const totalsPanelColumns = showsCards && offersColumnMenu(GridColumnMenuItem.Totals) ? table.getVisibleLeafColumns().map((column) => column.id).filter((id) => !templateColumnsById.has(id)).flatMap((id) => {
    const resolved = effectiveColumnsByName.get(id);
    if (!resolved || resolved.type === ColumnType.RelatedRecords || !resolved.aggregates?.length) return [];
    return [{
      columnName: resolved.columnName,
      title: columnTitleFor(id),
      offered: resolved.aggregates
    }];
  }) : [];
  const applyTotalsPanel = (totals) => {
    setTotalsPanelOpen(null);
    const next = new Map(userAggregates);
    let changed = false;
    for (const column of totalsPanelColumns) {
      const key3 = column.columnName.toLowerCase();
      const chosen = column.offered.filter((a) => (totals.get(column.columnName) ?? []).includes(a));
      const shown = column.offered.filter((a) => aggregatesByColumn.get(key3)?.aggregates.has(a));
      if (chosen.join() === shown.join()) continue;
      next.set(key3, { columnName: column.columnName, aggregates: chosen });
      changed = true;
    }
    if (!changed) return;
    setUserAggregates(next);
    writeStateToUrl({ aggregates: next });
  };
  const totalsPanel = /* @__PURE__ */ jsx(
    GridTotalsPanel,
    {
      columns: totalsPanelColumns,
      totals: new Map(
        totalsPanelColumns.map((column) => [
          column.columnName.toLowerCase(),
          [...aggregatesByColumn.get(column.columnName.toLowerCase())?.aggregates ?? []]
        ])
      ),
      onApply: applyTotalsPanel,
      onCancel: () => setTotalsPanelOpen(null)
    }
  );
  const renderTotals = (columnId, values = aggregateValues) => {
    const entry = aggregatesByColumn.get(columnId.toLowerCase());
    if (!entry) return null;
    return AGGREGATE_ORDER.filter((aggregate) => entry.aggregates.has(aggregate)).map((aggregate) => {
      const format = entry.formats.get(aggregate) ?? "";
      const value2 = values?.find(
        (v) => v.aggregate === aggregate && v.columnName.toLowerCase() === columnId.toLowerCase() && (v.format ?? "") === format
      );
      const unavailable = value2?.isAvailable === false || !value2 && !!aggregatesResult.error;
      const text2 = unavailable ? "\u2014" : value2 ? value2.formattedValue ?? "\u2014" : "";
      const label = aggregateLabel(aggregate);
      return /* @__PURE__ */ jsxs(
        "span",
        {
          className: styles.total,
          "data-ppp-tooltip": unavailable ? t("app.components.grid.aggregate-unavailable") : `${label} ${text2}`,
          children: [
            /* @__PURE__ */ jsx("span", { className: styles.totalLabel, children: label }),
            /* @__PURE__ */ jsx("span", { className: styles.totalValue, children: text2 }),
            unavailable && /* @__PURE__ */ jsx("span", { className: styles.visuallyHidden, children: t("app.components.grid.aggregate-unavailable") })
          ]
        },
        aggregate
      );
    });
  };
  const totalsAlignEnd = (columnId) => (declaredColumnsByName.get(columnId)?.align ?? typeAlign(effectiveColumnsByName.get(columnId)?.type)) === "end";
  const bodyItems = (() => {
    const rows = table.getRowModel().rows;
    if (!groupLayout) return rows.map((row) => ({ kind: "row", row }));
    const pendingCount = pendingRowCreates.length + pendingRowAssociates.length;
    const records = rows.slice(pendingCount);
    const firstRecord = accumulates ? 0 : (page - 1) * pageSize;
    const items = rows.slice(0, pendingCount).map((row) => ({ kind: "row", row }));
    for (const item of groupLayout.pageItems(firstRecord, records.length)) {
      if (item.kind === "header") {
        items.push({ kind: "header", group: item.group, collapsed: item.collapsed, level: item.level });
      } else {
        const row = records[item.index - firstRecord];
        if (row) items.push({ kind: "row", row });
      }
    }
    return items;
  })();
  const pinNumbers = /* @__PURE__ */ new Map();
  if (showMapPinNumbers && showsMap && !showsMapOnly) {
    let next = (accumulates ? 0 : (page - 1) * pageSize) + 1;
    for (const item of bodyItems) {
      if (item.kind === "header") continue;
      const record = item.row.original;
      if (hasSavedId(record) && !record.id.startsWith("__pending-create-")) pinNumbers.set(record.id, next++);
    }
  }
  const pinnedPlaces = /* @__PURE__ */ new Map();
  const leadingPlaces = {};
  {
    const widthOf = (id) => Number.parseFloat(headerWidthFor(id) ?? "") || PINNED_COLUMN_WIDTH;
    const startIds = shownColumnIds.filter((id) => pinOf(id) === GridColumnPin.Start);
    const endIds = shownColumnIds.filter((id) => pinOf(id) === GridColumnPin.End);
    let offset = 0;
    if (startIds.length > 0) {
      if (selectionMode !== "none") {
        leadingPlaces.select = { pin: GridColumnPin.Start, offset, edge: false };
        offset += LEADING_COLUMN_WIDTH;
      }
      if (gridIsDirty) {
        leadingPlaces.pending = { pin: GridColumnPin.Start, offset, edge: false };
        offset += LEADING_COLUMN_WIDTH;
      }
    }
    startIds.forEach((id, index) => {
      pinnedPlaces.set(id, { pin: GridColumnPin.Start, offset, edge: index === startIds.length - 1 });
      offset += widthOf(id);
    });
    offset = 0;
    for (let index = endIds.length - 1; index >= 0; index--) {
      const id = endIds[index];
      pinnedPlaces.set(id, { pin: GridColumnPin.End, offset, edge: index === 0 });
      offset += widthOf(id);
    }
  }
  const pinnedCell = (place, part) => place ? {
    className: mergeClasses(
      part === "body" && PINNED_BODY_CELL_CLASS,
      part === "header" ? styles.pinnedHeaderCell : part === "totals" ? styles.pinnedTotalsCell : styles.pinnedBodyCell,
      place.edge && (place.pin === GridColumnPin.Start ? styles.pinnedStartEdge : styles.pinnedEndEdge)
    ),
    style: place.pin === GridColumnPin.Start ? { insetInlineStart: `${place.offset}px` } : { insetInlineEnd: `${place.offset}px` }
  } : { className: void 0, style: void 0 };
  const headerSelectCell = pinnedCell(leadingPlaces.select, "header");
  const headerPendingCell = pinnedCell(leadingPlaces.pending, "header");
  const bodySelectCell = pinnedCell(leadingPlaces.select, "body");
  const bodyPendingCell = pinnedCell(leadingPlaces.pending, "body");
  const totalsSelectCell = pinnedCell(leadingPlaces.select, "totals");
  const totalsPendingCell = pinnedCell(leadingPlaces.pending, "totals");
  const visibleLeafColumns = table.getVisibleLeafColumns();
  const firstFiguresColumn = visibleLeafColumns.findIndex(
    (column) => !templateColumnsById.has(column.id) && aggregatesByColumn.has(column.id.toLowerCase())
  );
  const groupLabelSpan = firstFiguresColumn < 0 ? Math.max(1, visibleLeafColumns.length) : Math.max(1, firstFiguresColumn);
  const firstColumnFigures = firstFiguresColumn === 0 ? visibleLeafColumns[0]?.id : void 0;
  const onToggleGroup = (group, collapsed) => {
    toggleGroup(group.key);
    if (isVirtualize || !latestGroupLayout) return;
    const count = Number(group.count);
    const records = latestGroupLayout.recordCount + (collapsed ? count : -count);
    const lastPage = Math.max(1, Math.ceil(records / pageSize));
    if (page > lastPage) setPage(lastPage);
  };
  const renderGroupLabel = (group, collapsed, level, figuresColumnId) => {
    const label = group.label ?? "";
    const toggleText = collapsed ? t("app.components.grid.group-expand", [label]) : t("app.components.grid.group-collapse", [label]);
    return /* @__PURE__ */ jsxs("div", { className: styles.groupLabel, style: { "--ppp-group-level": level }, children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          size: "small",
          icon: collapsed ? /* @__PURE__ */ jsx(ChevronRight16Regular, {}) : /* @__PURE__ */ jsx(ChevronDown16Regular, {}),
          "data-ppp-tooltip": toggleText,
          "aria-label": toggleText,
          "aria-expanded": !collapsed,
          onClick: (e) => {
            e.stopPropagation();
            onToggleGroup(group, collapsed);
          }
        }
      ),
      /* @__PURE__ */ jsx("span", { className: styles.groupName, children: label }),
      /* @__PURE__ */ jsx("span", { className: styles.groupCount, children: t("app.components.grid.group-count", [group.count]) }),
      figuresColumnId && /* @__PURE__ */ jsx("span", { className: mergeClasses(styles.groupFigures, styles.groupFiguresAfterName), children: renderTotals(figuresColumnId, group.columnAggregates) })
    ] });
  };
  const firstScrolling = visibleLeafColumns.findIndex((column) => pinnedPlaces.get(column.id)?.pin !== GridColumnPin.Start);
  const pinnedLabelSpan = Math.min(groupLabelSpan, firstScrolling < 0 ? visibleLeafColumns.length : firstScrolling);
  const labelPlace = pinnedLabelSpan > 0 ? {
    ...pinnedPlaces.get(visibleLeafColumns[0].id),
    edge: pinnedPlaces.get(visibleLeafColumns[pinnedLabelSpan - 1].id).edge
  } : void 0;
  const groupLabelCell = pinnedCell(labelPlace, "body");
  const renderGroupHeaderRow = (group, collapsed, level) => {
    return /* @__PURE__ */ jsxs("tr", { className: styles.groupRow, onClick: () => onToggleGroup(group, collapsed), children: [
      selectionMode !== "none" && /* @__PURE__ */ jsx("td", { className: mergeClasses(styles.groupCell, styles.selectCell, bodySelectCell.className), style: bodySelectCell.style }),
      gridIsDirty && /* @__PURE__ */ jsx("td", { className: mergeClasses(styles.groupCell, styles.pendingCell, bodyPendingCell.className), style: bodyPendingCell.style }),
      /* @__PURE__ */ jsx(
        "td",
        {
          className: mergeClasses(styles.groupCell, groupLabelCell.className, labelPlace && styles.groupLabelCellPinned),
          style: groupLabelCell.style,
          colSpan: labelPlace ? pinnedLabelSpan : groupLabelSpan,
          children: renderGroupLabel(group, collapsed, level, firstColumnFigures)
        }
      ),
      labelPlace && groupLabelSpan > pinnedLabelSpan && /* @__PURE__ */ jsx("td", { className: styles.groupCell, colSpan: groupLabelSpan - pinnedLabelSpan }),
      visibleLeafColumns.slice(groupLabelSpan).map((column) => {
        const pinned = pinnedCell(pinnedPlaces.get(column.id), "body");
        return /* @__PURE__ */ jsx("td", { className: mergeClasses(styles.groupCell, pinned.className), style: pinned.style, children: !templateColumnsById.has(column.id) && aggregatesByColumn.has(column.id.toLowerCase()) && /* @__PURE__ */ jsx("div", { className: mergeClasses(styles.groupFigures, totalsAlignEnd(column.id) && styles.groupFiguresEnd), children: renderTotals(column.id, group.columnAggregates) }) }, column.id);
      })
    ] }, `group:${group.key}`);
  };
  const renderCardsGroupHeader = (group, collapsed, level) => /* @__PURE__ */ jsxs(
    "div",
    {
      role: "listitem",
      className: mergeClasses("ppp-grid-cards-group", styles.cardsGroup),
      style: { "--ppp-group-level": level },
      onClick: () => onToggleGroup(group, collapsed),
      children: [
        renderGroupLabel(group, collapsed, 0),
        totalsColumnIds.map((columnId) => /* @__PURE__ */ jsxs("div", { className: styles.cardsGroupFigures, children: [
          /* @__PURE__ */ jsx("span", { className: styles.cardsTotalColumn, children: declaredColumnsByName.get(columnId)?.displayName ?? effectiveColumnsByName.get(columnId)?.displayName ?? columnId }),
          /* @__PURE__ */ jsx("span", { className: styles.groupFigures, children: renderTotals(columnId, group.columnAggregates) })
        ] }, columnId))
      ]
    },
    `group:${group.key}`
  );
  const groupingMessage = (() => {
    if (!activeGroupBy || !settledGrouping || settledGrouping.status === QueryGroupingStatus.Grouped) return null;
    const title2 = settledGrouping.columnTitle ?? activeGroupBy.columnName;
    return settledGrouping.status === QueryGroupingStatus.TooManyGroups ? t("app.components.grid.grouping-too-many", [title2]) : t("app.components.grid.grouping-unavailable", [title2]);
  })();
  const collapsedRecordCount = activeGroupBy && grouping?.status === QueryGroupingStatus.Grouped ? GridGroupLayout.recordsIn(grouping.groups ?? [], fetchedCollapsedGroups) : 0;
  const shownRecordCount = totalCount !== void 0 ? totalCount + collapsedRecordCount : void 0;
  const cardColumnLabels = () => {
    const labels = /* @__PURE__ */ new Map();
    for (const header of table.getFlatHeaders()) {
      const renderer = header.column.columnDef.header;
      const label = typeof renderer === "function" ? renderer(header.getContext()) : renderer;
      if (typeof label === "string") labels.set(header.column.id, label);
    }
    return labels;
  };
  const cardColumnMetadata = (column) => gridTableMetadata?.columns.find((c) => c.columnName?.toLowerCase() === column.toLowerCase());
  const renderCards = () => {
    if (bodyItems.length === 0) return null;
    const labels = cardColumnLabels();
    const visibleColumns = table.getVisibleLeafColumns();
    const titleColumnId = visibleColumns.find(
      (column) => !templateColumnsById.has(column.id) && effectiveColumnsByName.get(column.id)?.isPrimaryName
    )?.id ?? visibleColumns[0]?.id;
    const selectLabel = t("app.components.grid.select-row");
    const showsFileTiles = !!cardFileColumn?.trim() && !cardRenderer;
    const primaryNameColumn2 = effectiveResolvedColumns.find((column) => column.isPrimaryName)?.columnName ?? gridTableMetadata?.primaryNameColumn;
    const titleNameColumn = titleColumnId && effectiveColumnsByName.has(titleColumnId) ? titleColumnId : void 0;
    const avatarNameFor = (record) => primaryNameColumn2 && resolveColumnDisplayValue(record, primaryNameColumn2) || titleNameColumn && resolveColumnDisplayValue(record, titleNameColumn) || void 0;
    const cardFieldsOf = (cardCells) => cardCells.map((cell) => ({
      key: cell.column.id,
      label: labels.get(cell.column.id) ?? cell.column.id,
      value: cellContentFor(cell)
    }));
    const imageUrlFor = (record, pending) => {
      if (!cardImageColumn || pending || !record.id) return void 0;
      const timestamp = record.properties?.[`${cardImageColumn}_timestamp`];
      const version = timestamp?.value;
      if (version === null || version === void 0) return void 0;
      return Routes.api.getRetrieveImageRoute(record.tableName, record.id, cardImageColumn, version, cardImageSize * 2);
    };
    return /* @__PURE__ */ jsx(
      "div",
      {
        role: "list",
        className: mergeClasses("ppp-grid-cards", cardStyles.cards, showsFileTiles && cardStyles.fileCards),
        ...minCardWidth?.trim() && !showsMap && { style: { "--ppp-card-min-width": minCardWidth } },
        children: bodyItems.map((item) => {
          if (item.kind === "header") return renderCardsGroupHeader(item.group, item.collapsed, item.level);
          const row = item.row;
          const state = rowStateFor(row);
          const cells = row.getVisibleCells();
          const imageUrl = imageUrlFor(row.original, state.isPendingCreate);
          const avatar = cardImageColumn ? /* @__PURE__ */ jsx(RecordCardAvatar, { name: avatarNameFor(row.original), imageUrl, size: cardImageSize }) : void 0;
          const cellFor = (column) => {
            const id = relatedColumns.find((related) => related.relationshipName === column)?.columnId ?? column;
            return cells.find((cell) => cell.column.id === id) ?? cells.find((cell) => cell.column.id.toLowerCase() === id.toLowerCase());
          };
          let content;
          if (cardRenderer) {
            content = {
              template: cardRenderer({
                record: row.original,
                ...parentRecord && { parentRecord },
                isSelected: state.isSelected,
                setSelected: (selected) => row.toggleSelected(selected),
                canOpen: state.canOpen,
                open: () => {
                  if (state.canOpen) dispatchOpen(row.original);
                },
                imageUrl,
                avatar,
                searchText: searchText || null,
                field: (column) => {
                  const cell = cellFor(column);
                  return cell ? cellContentFor(cell) : resolveColumnDisplayText(row.original, column, cardColumnMetadata(column));
                },
                label: (column) => {
                  const cell = cellFor(column);
                  return cell ? labels.get(cell.column.id) : void 0;
                },
                displayValue: (column) => resolveColumnDisplayText(row.original, column, cardColumnMetadata(column))
              })
            };
          } else if (showsFileTiles && cardFileColumn) {
            const titleCell = cells.find((cell) => cell.column.id === titleColumnId);
            const fileColumn = cardFileColumn.toLowerCase();
            content = {
              children: /* @__PURE__ */ jsx(
                GridCardFileTile,
                {
                  record: row.original,
                  fileColumn: cardFileColumn,
                  heading: (fileName) => {
                    const titleText = titleCell ? resolveColumnDisplayValue(row.original, titleCell.column.id) ?? void 0 : void 0;
                    const titledByCell = titleCell !== void 0 && (!fileName || titleText === fileName);
                    return {
                      title: titledByCell ? cellContentFor(titleCell) : fileName,
                      titleText: titledByCell ? titleText : fileName,
                      // The file column's file is the tile's; the title column,
                      // when it titles the tile, is its title.
                      fields: cardFieldsOf(
                        cells.filter(
                          (cell) => cell.column.id.toLowerCase() !== fileColumn && !(titledByCell && cell === titleCell)
                        )
                      )
                    };
                  }
                }
              )
            };
          } else {
            const titleCell = cells.find((cell) => cell.column.id === titleColumnId);
            content = {
              ...titleCell && { title: cellContentFor(titleCell) },
              ...avatar && { avatar },
              fields: cardFieldsOf(cells.filter((cell) => cell !== titleCell))
            };
          }
          const pendingIcon = pendingIconFor(state);
          const pinNumber = row.original.id ? pinNumbers.get(row.original.id) : void 0;
          const selectorTabIndex = editable ? -1 : void 0;
          const selectorMarks = selectionMode !== "none" || pendingIcon ? /* @__PURE__ */ jsxs("div", { className: cardStyles.marks, onClick: (e) => e.stopPropagation(), children: [
            selectionMode === "single" && /* @__PURE__ */ jsx(
              Radio,
              {
                className: cardStyles.selector,
                "aria-label": selectLabel,
                name: radioGroupName,
                value: row.id,
                checked: state.isSelected,
                onChange: () => row.toggleSelected(true),
                tabIndex: selectorTabIndex
              }
            ),
            selectionMode === "multiple" && /* @__PURE__ */ jsx(
              Checkbox,
              {
                className: cardStyles.selector,
                "aria-label": selectLabel,
                checked: state.isSelected,
                onChange: (_, data2) => row.toggleSelected(!!data2.checked),
                tabIndex: selectorTabIndex
              }
            ),
            pendingIcon
          ] }) : void 0;
          const marks = pinNumber !== void 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(GridCardPinNumber, { number: pinNumber, label: t("app.components.grid.map-pin-number", [pinNumber]) }),
            selectorMarks
          ] }) : selectorMarks;
          const card = /* @__PURE__ */ jsx(
            RecordCard,
            {
              role: "listitem",
              className: mergeClasses("ppp-grid-card", state.isHighlightMuted && cardStyles.cardMuted),
              selected: state.isSelected,
              clickable: state.handleRowClick !== void 0 || showsMap && !editable,
              ...marks && { marks },
              ...content,
              ...showsMap && !editable ? {
                // Beside the map, a card clicked is brought into view on it, selectable or not —
                // not for a click on a control in it, which keeps the click to itself.
                onClick: (event) => {
                  if (row.original.id && !isRowControlTarget(event.target)) setMapFocusId(row.original.id);
                  state.handleRowClick?.(event);
                }
              } : state.handleRowClick && { onClick: state.handleRowClick },
              ...state.handleRowDoubleClick && { onDoubleClick: state.handleRowDoubleClick }
            },
            row.id
          );
          return state.isRowInlineEditable && row.original.id ? /* @__PURE__ */ jsx(
            RecordContext,
            {
              table: row.original.tableName,
              id: row.original.id,
              loadedRecord: row.original,
              children: card
            },
            row.id
          ) : card;
        })
      }
    );
  };
  const shownView = resolvedViewId ? views.find((view) => view.id === resolvedViewId) : void 0;
  const printTitle = shownView ? viewLabelOf(shownView, t) : void 0;
  const mapPrintEntries = (items, firstColumnId) => {
    const labels = cardColumnLabels();
    const columns2 = table.getVisibleLeafColumns().filter((column) => effectiveColumnsByName.has(column.id));
    const entries = [];
    for (const item of items) {
      if (item.kind === "header") continue;
      const record = item.row.original;
      if (!hasSavedId(record) || record.id.startsWith("__pending-create-")) continue;
      const named = mapTitleColumn ? resolveColumnDisplayValue(record, mapTitleColumn) : void 0;
      const titleColumn = named ? mapTitleColumn : firstColumnId;
      const title2 = named || firstColumnId && resolveColumnDisplayValue(record, firstColumnId) || t("app.components.map.untitled");
      const details = columns2.filter((column) => column.id.toLowerCase() !== titleColumn?.toLowerCase()).map((column) => ({
        label: labels.get(column.id) ?? column.id,
        value: resolveColumnDisplayText(record, column.id, cardColumnMetadata(column.id)) ?? ""
      })).filter((detail) => detail.value.trim());
      const label = pinNumbers.get(record.id)?.toString();
      entries.push({ title: title2, ...label && { label }, ...details.length && { details } });
    }
    return entries;
  };
  const renderMapLayout = () => {
    const firstColumnId = table.getVisibleLeafColumns().find((column) => effectiveColumnsByName.has(column.id))?.id;
    const pins = [];
    const rowsById = /* @__PURE__ */ new Map();
    const pinnedItems = isLoadingMapOnlyRows || error ? [] : bodyItems.filter((item) => item.kind !== "header");
    const selectedIds = new Set(table.getSelectedRowModel().rows.map((row) => row.original.id));
    const selectedItems = pinnedItems.filter((item) => selectedIds.has(item.row.original.id));
    const mappedItems = keepsMapToSelection && selectedItems.length > 0 ? selectedItems : pinnedItems;
    const printedItems = () => {
      if (shownMapPrintList === GridMapPrintList.Selected) return selectedItems.length > 0 ? selectedItems : pinnedItems;
      if (shownMapPrintList !== GridMapPrintList.InView) return pinnedItems;
      const bounds = mapBoundsRef.current;
      const inView = new Set(pins.filter((pin) => !bounds || boundsHold(bounds, pin.latitude, pin.longitude)).map((pin) => pin.id));
      return pinnedItems.filter((item) => inView.has(item.row.original.id ?? ""));
    };
    for (const item of showsMapOnly ? pinnedItems.slice(0, mapMaximumRows) : mappedItems) {
      const record = item.row.original;
      if (!hasSavedId(record) || record.id.startsWith("__pending-create-")) continue;
      const position = resolvePosition(record, mapLatitudeColumn, mapLongitudeColumn);
      if (!position) continue;
      const { latitude, longitude } = position;
      rowsById.set(record.id, item.row);
      const title2 = mapTitleColumn && resolveColumnDisplayValue(record, mapTitleColumn) || firstColumnId && resolveColumnDisplayValue(record, firstColumnId) || void 0;
      const url = rowPageUrl(record);
      const label = pinNumbers.get(record.id)?.toString();
      pins.push({ id: record.id, latitude, longitude, ...title2 && { title: title2 }, ...url && { url }, ...label && { label } });
    }
    const selected = table.getSelectedRowModel().rows.map((row) => row.original.id).filter((id) => !!id && rowsById.has(id));
    const focusedIds = selected.length > 0 ? selected : mapFocusId && rowsById.has(mapFocusId) ? [mapFocusId] : [];
    const onPinClick = (id) => {
      const row = rowsById.get(id);
      if (!row) return;
      setMapFocusId(id);
      if (selectionMode !== "none" && !editable && !keepsMapToSelection) row.toggleSelected(!row.getIsSelected());
    };
    const map = GridMap && /* @__PURE__ */ jsx(
      GridMap,
      {
        pins,
        focusedIds,
        onPinClick,
        onNavigate: navigateTo,
        near: activeNear,
        ...showMapPrintButton && {
          onPrintChange: setMapPrint,
          ...printTitle && { printTitle },
          // Made as the map is printed, not on every render.
          ...!showsMapOnly && shownMapPrintList !== GridMapPrintList.None && { printEntries: () => mapPrintEntries(printedItems(), firstColumnId) }
        },
        ...offersMapPrintList && {
          onViewChange: (bounds) => {
            mapBoundsRef.current = bounds;
          }
        }
      }
    );
    const heightStyle = mapHeight?.trim() && { style: { "--ppp-grid-map-height": mapHeight } };
    if (showsMapOnly) {
      const truncated = !isLoadingMapOnlyRows && !error && (hasMoreRowsToLoad2 || (accumulatedRows?.length ?? 0) > mapMaximumRows);
      return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-grid-map-only", styles.mapOnly), ...heightStyle, children: [
        truncated && /* @__PURE__ */ jsx(MessageBar, { intent: "info", className: "ppp-grid-map-message", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.components.grid.map-truncated", [mapMaximumRows]) }) }),
        /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-grid-map-pane", styles.mapPane, styles.mapOnlyPane), children: map })
      ] });
    }
    return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-grid-map-layout", styles.mapLayout), ...heightStyle, children: [
      /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-grid-map-cards", styles.mapCards), style: { "--ppp-card-min-width": "100%" }, children: [
        renderCards(),
        isVirtualize && hasMoreRowsToLoad2 && /* @__PURE__ */ jsx("div", { ref: setLoadMoreSentinel, className: styles.loadMoreSentinel, children: isLoadingMoreRows && /* @__PURE__ */ jsx(Spinner, { size: "tiny", "aria-label": t("app.components.grid.loading") }) })
      ] }),
      /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-grid-map-pane", styles.mapPane), children: map })
    ] });
  };
  const searchTooltip = /* @__PURE__ */ jsx(SearchColumnsTooltip, { text: searchableStringColumns, number: searchableNumberColumns, date: searchableDateColumns });
  return /* @__PURE__ */ jsx(GridContextProvider, { value: gridContextValue, children: /* @__PURE__ */ jsxs(
    FluentOverlayTarget,
    {
      targetId: overlayTargetId,
      rootRef,
      className: mergeClasses(
        "ppp-main-grid",
        styles.wrapper,
        fullSize && styles.wrapperFullSize,
        !borderVisible && styles.wrapperBorderless,
        className
      ),
      style: {
        ...!fullSize && {
          minHeight: typeof minHeight === "number" ? `${minHeight}px` : minHeight
        },
        ...!fullSize && maxHeight !== void 0 && {
          maxHeight: typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight
        },
        ...style
      },
      children: [
        /* @__PURE__ */ jsx(SharedTooltip, { containerRef: rootRef }),
        /* @__PURE__ */ jsxs("div", { className: mergeClasses(styles.toolbar, showsGroupPanel && styles.toolbarAboveGroupPanel), children: [
          showViewPicker && /* @__PURE__ */ jsx(
            ViewPicker,
            {
              className: styles.viewPicker,
              options: pickerViews.map((view) => ({ id: view.id, label: viewLabelOf(view, t) })),
              value: resolvedViewId,
              onChange: handleViewChange,
              isUserView: (id) => savedViews.views.some((view) => view.id === id)
            }
          ),
          !showViewPicker && title && /* @__PURE__ */ jsx(Text, { className: styles.title, children: title }),
          !showViewPicker && !title && singleViewTitle && /* @__PURE__ */ jsx(Text, { className: styles.title, children: singleViewTitle }),
          /* @__PURE__ */ jsx(Overflow, { padding: 20, children: /* @__PURE__ */ jsxs("div", { className: styles.toolbarOverflow, children: [
            toolbarChildren !== null && /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Actions, children: /* @__PURE__ */ jsx("div", { className: styles.toolbarSlot, children: toolbarChildren }) }),
            pendingRowCreates.length > 0 && /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles.pendingIndicator,
                "data-ppp-tooltip": `${pendingRowCreates.length} pending create${pendingRowCreates.length === 1 ? "" : "s"}`,
                children: [
                  /* @__PURE__ */ jsx("span", { className: styles.visuallyHidden, children: `${pendingRowCreates.length} pending create${pendingRowCreates.length === 1 ? "" : "s"}` }),
                  /* @__PURE__ */ jsx(Add16Regular, { className: styles.pendingIconCreate }),
                  /* @__PURE__ */ jsx(
                    CounterBadge,
                    {
                      count: pendingRowCreates.length,
                      size: "small",
                      color: "informative",
                      appearance: "filled"
                    }
                  )
                ]
              }
            ),
            pendingRowUpdates.size > 0 && /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles.pendingIndicator,
                "data-ppp-tooltip": `${pendingRowUpdates.size} pending edit${pendingRowUpdates.size === 1 ? "" : "s"}`,
                children: [
                  /* @__PURE__ */ jsx("span", { className: styles.visuallyHidden, children: `${pendingRowUpdates.size} pending edit${pendingRowUpdates.size === 1 ? "" : "s"}` }),
                  /* @__PURE__ */ jsx(Edit16Regular, { className: styles.pendingIconUpdate }),
                  /* @__PURE__ */ jsx(
                    CounterBadge,
                    {
                      count: pendingRowUpdates.size,
                      size: "small",
                      color: "brand",
                      appearance: "filled"
                    }
                  )
                ]
              }
            ),
            pendingRowAssociates.length > 0 && /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles.pendingIndicator,
                "data-ppp-tooltip": `${pendingRowAssociates.length} pending link${pendingRowAssociates.length === 1 ? "" : "s"}`,
                children: [
                  /* @__PURE__ */ jsx("span", { className: styles.visuallyHidden, children: `${pendingRowAssociates.length} pending link${pendingRowAssociates.length === 1 ? "" : "s"}` }),
                  /* @__PURE__ */ jsx(LinkAdd16Regular, { className: styles.pendingIconCreate }),
                  /* @__PURE__ */ jsx(
                    CounterBadge,
                    {
                      count: pendingRowAssociates.length,
                      size: "small",
                      color: "informative",
                      appearance: "filled"
                    }
                  )
                ]
              }
            ),
            pendingRowDisassociates.length > 0 && /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles.pendingIndicator,
                "data-ppp-tooltip": `${pendingRowDisassociates.length} pending unlink${pendingRowDisassociates.length === 1 ? "" : "s"}`,
                children: [
                  /* @__PURE__ */ jsx("span", { className: styles.visuallyHidden, children: `${pendingRowDisassociates.length} pending unlink${pendingRowDisassociates.length === 1 ? "" : "s"}` }),
                  /* @__PURE__ */ jsx(LinkDismiss16Regular, { className: styles.pendingIconUpdate }),
                  /* @__PURE__ */ jsx(
                    CounterBadge,
                    {
                      count: pendingRowDisassociates.length,
                      size: "small",
                      color: "brand",
                      appearance: "filled"
                    }
                  )
                ]
              }
            ),
            pendingRowDeletes.length > 0 && /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles.pendingIndicator,
                "data-ppp-tooltip": `${pendingRowDeletes.length} pending delete${pendingRowDeletes.length === 1 ? "" : "s"}`,
                children: [
                  /* @__PURE__ */ jsx("span", { className: styles.visuallyHidden, children: `${pendingRowDeletes.length} pending delete${pendingRowDeletes.length === 1 ? "" : "s"}` }),
                  /* @__PURE__ */ jsx(Delete16Regular, { className: styles.pendingIconUpdate }),
                  /* @__PURE__ */ jsx(
                    CounterBadge,
                    {
                      count: pendingRowDeletes.length,
                      size: "small",
                      color: "danger",
                      appearance: "filled"
                    }
                  )
                ]
              }
            ),
            allowChangingLayout && /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Layout, children: /* @__PURE__ */ jsx("div", { className: styles.toolbarItemWrapper, children: renderLayoutDropdown(styles.layoutPicker) }) }),
            totalsPanelColumns.length > 0 && /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Totals, children: /* @__PURE__ */ jsx("div", { className: styles.toolbarItemWrapper, children: /* @__PURE__ */ jsxs(
              Popover,
              {
                positioning: "below-end",
                withArrow: true,
                trapFocus: true,
                open: totalsPanelOpen === "toolbar" && totalsPanelColumns.length > 0,
                onOpenChange: (_, data2) => setTotalsPanelOpen(data2.open ? "toolbar" : null),
                children: [
                  /* @__PURE__ */ jsx(PopoverTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.grid.totals"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
                    Button,
                    {
                      appearance: "subtle",
                      icon: /* @__PURE__ */ jsx(MathFormula24Regular, {})
                    }
                  ) }) }),
                  /* @__PURE__ */ jsx(PopoverSurface, { children: totalsPanel })
                ]
              }
            ) }) }),
            offersNearSearch && NearSearchButton && /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Near, priority: PINNED_PRIORITY, children: /* @__PURE__ */ jsx("div", { className: styles.toolbarItemWrapper, children: /* @__PURE__ */ jsx(
              NearSearchButton,
              {
                value: activeNear,
                onChange: changeNear,
                distances: nearDistanceChoices,
                defaultDistance: nearDistance,
                defaultUnit: nearDistanceUnit
              }
            ) }) }),
            allowSearch && // Wrapping the SearchBox (and its optional Tooltip) in a plain
            // `<div>` instead of making it the OverflowItem's direct
            // child sidesteps a measurement / data-attribute drift: with
            // OverflowItem's `applyTriggerPropsToChildren` recursively
            // unwrapping FluentTrigger components (Tooltip is one), the
            // `data-overflowing` attribute could land on the SearchBox's
            // root while the visible wrapper kept the slot space. A
            // plain div is not a FluentTrigger, so OverflowItem registers
            // its ref directly on the div, measures the div's
            // offsetWidth, and toggles `data-overflowing` on the div
            // which Fluent's `[overflowingItems] [data-overflowing]
            // { display: none }` then collapses to zero width.
            /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Search, children: /* @__PURE__ */ jsx("div", { className: styles.searchBoxWrapper, children: /* @__PURE__ */ jsx(
              ViewSearchBox,
              {
                className: styles.searchBox,
                placeholder: t("app.components.grid.search-placeholder"),
                value: searchText,
                onTextChange: typeSearchText,
                tooltipPositioning: "below-end",
                ...hasSearchableColumns && { tooltip: searchTooltip }
              }
            ) }) }),
            showMapPrintButton && mapPrint && /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Print, priority: PINNED_PRIORITY, children: /* @__PURE__ */ jsx("div", { className: styles.toolbarItemWrapper, children: /* @__PURE__ */ jsx(
              MapPrintButton,
              {
                inToolbar: true,
                canSaveImage: mapPrint.canSaveImage,
                disabled: mapPrint.printing,
                onPrint: mapPrint.print,
                onSaveImage: mapPrint.saveImage
              }
            ) }) }),
            offersViewFilterMenu(filterMenu) && /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Filter, priority: PINNED_PRIORITY, children: /* @__PURE__ */ jsx("div", { className: styles.toolbarItemWrapper, children: /* @__PURE__ */ jsx(ViewFilterMenu, { ...filterMenu }) }) }),
            showRefreshButton && (() => {
              const handleRefreshClick = async () => {
                const subtreeDirty = parentMainContext?.isDirty ?? false;
                if (gridIsDirty || subtreeDirty) {
                  const proceed = await warnAboutUnsavedChanges();
                  if (!proceed) return;
                  clearPendingRowUpdates();
                }
                setRefreshing(true);
                try {
                  await refresh();
                } finally {
                  setRefreshing(false);
                }
              };
              return /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Refresh, priority: PINNED_PRIORITY, children: /* @__PURE__ */ jsx("div", { className: styles.toolbarItemWrapper, children: /* @__PURE__ */ jsx(ViewRefreshButton, { disabled: refreshing, onClick: () => void handleRefreshClick() }) }) });
            })(),
            offersGridSettings(settingsMenu) && /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Settings, priority: PINNED_PRIORITY, children: /* @__PURE__ */ jsx("div", { className: styles.toolbarItemWrapper, children: /* @__PURE__ */ jsx(GridSettingsButton, { ...settingsMenu }) }) }),
            /* @__PURE__ */ jsxs(GridToolbarOverflowMenu, { ariaLabel: t("app.components.grid.more-actions"), children: [
              toolbarChildren !== null && /* @__PURE__ */ jsx(OverflowMenuItem, { itemId: GridToolbarOverflowId.Actions, children: /* @__PURE__ */ jsx("div", { className: styles.menuActionRow, children: toolbarChildren }) }),
              allowChangingLayout && /* @__PURE__ */ jsx(OverflowMenuItem, { itemId: GridToolbarOverflowId.Layout, children: /* @__PURE__ */ jsx("div", { className: styles.menuActionRow, children: renderLayoutDropdown() }) }),
              totalsPanelColumns.length > 0 && /* @__PURE__ */ jsx(OverflowMenuItem, { itemId: GridToolbarOverflowId.Totals, children: /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(MathFormula20Regular, {}), onClick: () => setTotalsPanelOpen("menu"), children: t("app.components.grid.totals") }) }),
              allowSearch && /* @__PURE__ */ jsx(OverflowMenuItem, { itemId: GridToolbarOverflowId.Search, children: /* @__PURE__ */ jsx("div", { className: styles.menuActionRow, children: /* @__PURE__ */ jsx(
                ViewSearchBox,
                {
                  className: styles.menuSearchBox,
                  placeholder: t("app.components.grid.search-placeholder"),
                  value: searchText,
                  onTextChange: typeSearchText,
                  contentBefore: /* @__PURE__ */ jsx(Search20Regular, {})
                }
              ) }) }),
              showMapPrintButton && mapPrint && /* @__PURE__ */ jsx(OverflowMenuItem, { itemId: GridToolbarOverflowId.Print, children: /* @__PURE__ */ jsx(
                MapPrintMenuItems,
                {
                  canSaveImage: mapPrint.canSaveImage,
                  disabled: mapPrint.printing,
                  onPrint: mapPrint.print,
                  onSaveImage: mapPrint.saveImage
                }
              ) }),
              offersViewFilterMenu(filterMenu) && /* @__PURE__ */ jsx(OverflowMenuItem, { itemId: GridToolbarOverflowId.Filter, children: /* @__PURE__ */ jsx(ViewFilterMenuOverflowItem, { ...filterMenu }) }),
              showRefreshButton && /* @__PURE__ */ jsx(OverflowMenuItem, { itemId: GridToolbarOverflowId.Refresh, children: /* @__PURE__ */ jsx(
                MenuItem,
                {
                  icon: /* @__PURE__ */ jsx(ArrowClockwise20Regular, {}),
                  disabled: refreshing,
                  onClick: async () => {
                    const subtreeDirty = parentMainContext?.isDirty ?? false;
                    if (gridIsDirty || subtreeDirty) {
                      const proceed = await warnAboutUnsavedChanges();
                      if (!proceed) return;
                      clearPendingRowUpdates();
                    }
                    setRefreshing(true);
                    try {
                      await refresh();
                    } finally {
                      setRefreshing(false);
                    }
                  },
                  children: t("app.buttons.refresh.label")
                }
              ) }),
              offersGridSettings(settingsMenu) && /* @__PURE__ */ jsx(OverflowMenuItem, { itemId: GridToolbarOverflowId.Settings, children: /* @__PURE__ */ jsx(GridSettingsOverflowItem, { ...settingsMenu }) })
            ] }),
            /* @__PURE__ */ jsx(
              Dialog,
              {
                open: sortPanelOpen,
                onOpenChange: (_, data2) => setSortPanelOpen(data2.open),
                children: /* @__PURE__ */ jsx(DialogSurface, { "aria-label": t("app.components.grid.sort"), children: sortPanel })
              }
            ),
            /* @__PURE__ */ jsx(
              Dialog,
              {
                open: totalsPanelOpen === "menu" && totalsPanelColumns.length > 0,
                onOpenChange: (_, data2) => setTotalsPanelOpen(data2.open ? "menu" : null),
                children: /* @__PURE__ */ jsx(DialogSurface, { "aria-label": t("app.components.grid.totals"), children: totalsPanel })
              }
            ),
            showsColumnsButton && sourceView && /* @__PURE__ */ jsx(
              GridColumnsDialog,
              {
                open: columnsDialogOpen,
                fetchXml: (addedView ?? sourceView).fetchXml ?? "",
                ownColumns: ownColumnKeys,
                ownJoins: ownJoinAliases,
                keptColumns: ownAttributeKeys,
                extraJoins: criteriaJoins,
                shown: shownColumnIds.filter((id) => isRegularColumn(id)),
                onApply: (choice2) => void applyColumns(choice2),
                onCancel: () => setColumnsDialogOpen(false)
              }
            ),
            savedViews.available && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
              GridColumnLabelsDialog,
              {
                open: labelsViewId !== null && labelsViewId === resolvedViewId,
                columns: columnLabels,
                onSave: saveColumnLabels,
                onCancel: () => setLabelsViewId(null)
              }
            ) }),
            /* @__PURE__ */ jsx(SavedViewDialogs, { session: savedViewSession }),
            showsFilterButton && viewTable && viewCriteria !== void 0 && /* @__PURE__ */ jsx(
              GridFilterDialog,
              {
                open: filterDialogOpen,
                table: viewTable,
                criteria: criteria ?? viewCriteria,
                viewCriteria,
                onApply: applyCriteria,
                onCancel: () => setFilterDialogOpen(false)
              }
            ),
            totalsFormatOpen !== null && /* @__PURE__ */ jsx(
              GridTotalsFormatDialog,
              {
                columnTitle: columnTitleFor(totalsFormatOpen),
                formats: formatsWith(userFormats, totalsFormatOpen),
                onApply: (formats) => applyTotalsFormats(totalsFormatOpen, formats),
                onCancel: () => setTotalsFormatOpen(null)
              }
            ),
            showsFilterButton && viewTable && viewFetchXml && currentCriteria !== void 0 && columnFilterOpen !== null && /* @__PURE__ */ jsx(
              GridColumnFilterDialog,
              {
                open: true,
                table: viewTable,
                column: columnFilterOpen,
                columnTitle: columnTitleFor(columnFilterOpen),
                criteria: currentCriteria,
                viewFetchXml,
                onApply: applyCriteria,
                onCancel: () => setColumnFilterOpen(null),
                onOpenFilter: () => {
                  setColumnFilterOpen(null);
                  setFilterDialogOpen(true);
                }
              }
            )
          ] }) })
        ] }),
        showsGroupPanel && // On the toolbar's band, under it, as the Blazor grid draws it.
        /* @__PURE__ */ jsx("div", { className: styles.groupPanelBand, children: /* @__PURE__ */ jsx(
          GridGroupPanel,
          {
            levels: groupPanelLevels,
            isDragging: groupDragColumn !== null,
            onChipDragStart: setGroupDragColumn,
            onChipDragEnd: () => setGroupDragColumn(null),
            onDrop: handleGroupDrop,
            addableColumns: addableGroupColumns,
            onAdd: handleGroupAdd,
            forCards: showsCards,
            onChange: (index, level) => handleGroupingChoice(
              level ? changeGroupLevel(currentGroupLevels, index, level, isInnermostOnly) : removeGroupLevel(currentGroupLevels, index)
            )
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: styles.bodyArea, children: [
          groupingMessage && /* @__PURE__ */ jsx(MessageBar, { intent: "info", className: styles.groupingMessage, children: /* @__PURE__ */ jsx(MessageBarBody, { children: groupingMessage }) }),
          activeNear && nearDistances.truncated && nearDistances.key === accumulatorResetKey && /* @__PURE__ */ jsx(MessageBar, { intent: "info", className: mergeClasses("ppp-grid-near-message", styles.groupingMessage), children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.components.grid.near-truncated", [totalCount ?? 0]) }) }),
          isLoading ? (
            // Nothing yet: holds the body's height under the loading overlay (below), which says the
            // rows are on their way.
            /* @__PURE__ */ jsx("div", { className: styles.bodyFill })
          ) : error ? /* @__PURE__ */ jsx(
            "div",
            {
              className: mergeClasses(styles.statusFill, styles.statusFillError),
              role: "alert",
              children: error.message || t("app.components.grid.load-records-error")
            }
          ) : /* @__PURE__ */ jsxs("div", { className: styles.tableContainer, ref: tableContainerRef, children: [
            showsCards ? showsMap ? renderMapLayout() : renderCards() : /* @__PURE__ */ jsxs(
              "table",
              {
                className: styles.table,
                style: {
                  width: `${table.getTotalSize() + (selectionMode !== "none" ? LEADING_COLUMN_WIDTH : 0) + (gridIsDirty ? LEADING_COLUMN_WIDTH : 0)}px`,
                  ...hasUnsizedColumn && { minWidth: "100%" }
                },
                children: [
                  (selectionMode !== "none" || gridIsDirty) && /* @__PURE__ */ jsxs("colgroup", { children: [
                    selectionMode !== "none" && /* @__PURE__ */ jsx("col", { style: { width: `${LEADING_COLUMN_WIDTH}px` } }),
                    gridIsDirty && /* @__PURE__ */ jsx("col", { style: { width: `${LEADING_COLUMN_WIDTH}px` } })
                  ] }),
                  /* @__PURE__ */ jsx("thead", { children: table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ jsxs("tr", { className: styles.headerRow, children: [
                    selectionMode !== "none" && /* @__PURE__ */ jsx("th", { className: mergeClasses(styles.headerCell, styles.selectCell, headerSelectCell.className), style: headerSelectCell.style, children: selectionMode === "multiple" && /* @__PURE__ */ jsx(
                      Checkbox,
                      {
                        "aria-label": t("app.components.grid.select-all-rows"),
                        checked: table.getIsAllRowsSelected() ? true : table.getIsSomeRowsSelected() ? "mixed" : false,
                        onChange: (_, data2) => table.toggleAllRowsSelected(!!data2.checked)
                      }
                    ) }),
                    gridIsDirty && /* @__PURE__ */ jsx(
                      "th",
                      {
                        className: mergeClasses(styles.headerCell, styles.pendingCell, headerPendingCell.className),
                        style: headerPendingCell.style,
                        "aria-label": t("app.components.grid.pending-operation")
                      }
                    ),
                    headerGroup.headers.map((header) => {
                      const columnName = header.column.id;
                      const widthValue = headerWidthFor(columnName);
                      const declaredAlign = header.column.columnDef.meta?.align;
                      const pinnedHeader = pinnedCell(pinnedPlaces.get(columnName), "header");
                      const headerStyle = {
                        ...pinnedHeader.style,
                        ...widthValue !== void 0 && { width: widthValue },
                        ...declaredAlign && {
                          textAlign: (
                            // The logical sides, so a right-to-left page lines numbers up at its end too.
                            declaredAlign === "end" ? "end" : declaredAlign === "center" ? "center" : "start"
                          )
                        }
                      };
                      const effectiveCol = effectiveColumnsByName.get(columnName);
                      const templateDecl = templateColumnsById.get(columnName);
                      const sortable = templateDecl ? !!templateDecl.sortBy : columnName === NearDistanceColumn || (effectiveCol?.isSortable ?? false);
                      const headerTooltip = effectiveCol?.tooltip?.trim() || void 0;
                      const inHeaderCell = (event) => event.target instanceof Node && event.currentTarget.contains(event.target);
                      const headerRenderer = header.column.columnDef.header;
                      const headerContent = typeof headerRenderer === "function" ? headerRenderer(header.getContext()) : headerRenderer;
                      const sortIndex = shownSort.findIndex((d) => d.columnName === columnName);
                      const sortDirective = sortIndex >= 0 ? shownSort[sortIndex] : void 0;
                      const SortIcon = sortDirective ? sortDirective.descending ? ArrowSortDown16Regular : ArrowSortUp16Regular : null;
                      const showSortPosition = sortDirective && shownSort.length > 1;
                      const groupDraggable = showsGroupPanel && !templateDecl && effectiveCol?.canGroupBy === true;
                      const columnDraggable = offersColumnMenu(GridColumnMenuItem.Columns);
                      const dropHere = columnDrop?.columnId === columnName ? columnDrop : null;
                      const dropOn = (event) => {
                        if (!columnDrag || columnDrag === columnName) return null;
                        if (pinOf(columnDrag) !== pinOf(columnName) && !offersColumnMenu(GridColumnMenuItem.Pin)) return null;
                        const bounds = event.currentTarget.getBoundingClientRect();
                        const pastMiddle = event.clientX > bounds.left + bounds.width / 2;
                        const rightToLeft = getComputedStyle(event.currentTarget).direction === "rtl";
                        return { columnId: columnName, after: pastMiddle !== rightToLeft };
                      };
                      return /* @__PURE__ */ jsxs(
                        "th",
                        {
                          className: mergeClasses(
                            styles.headerCell,
                            sortable && styles.headerCellSortable,
                            dropHere ? dropHere.after ? styles.headerCellDropAfter : styles.headerCellDropBefore : void 0,
                            pinnedHeader.className
                          ),
                          style: headerStyle,
                          ...(groupDraggable || columnDraggable) && {
                            draggable: true,
                            onPointerDown: (event) => {
                              headerPressOnControlRef.current = !inHeaderCell(event) || event.target instanceof Element && event.target.closest('button, [role="separator"]') !== null;
                            },
                            onDragStart: (event) => {
                              if (headerPressOnControlRef.current || !inHeaderCell(event)) {
                                event.preventDefault();
                                return;
                              }
                              event.dataTransfer.setData(GROUP_DRAG_TYPE, columnName);
                              event.dataTransfer.effectAllowed = "move";
                              if (groupDraggable) setGroupDragColumn(columnName);
                              if (columnDraggable) setColumnDrag(columnName);
                            },
                            onDragEnd: () => {
                              setGroupDragColumn(null);
                              setColumnDrag(null);
                              setColumnDrop(null);
                            }
                          },
                          onDragOver: (event) => {
                            const drop = dropOn(event);
                            if (!drop) return;
                            event.preventDefault();
                            event.dataTransfer.dropEffect = "move";
                            if (dropHere?.after !== drop.after) setColumnDrop(drop);
                          },
                          onDragLeave: (event) => {
                            if (dropHere && !event.currentTarget.contains(event.relatedTarget)) setColumnDrop(null);
                          },
                          onDrop: (event) => {
                            const drop = dropOn(event);
                            if (!drop || !columnDrag) return;
                            event.preventDefault();
                            setColumnDrag(null);
                            setColumnDrop(null);
                            arrangeColumnsTo(
                              hiddenColumns,
                              moveColumnTo(allColumnIds, columnOrder, columnDrag, drop.columnId, drop.after),
                              pinOf(columnDrag) === pinOf(drop.columnId) ? userPins : withPin(columnDrag, pinOf(drop.columnId))
                            );
                          },
                          "aria-sort": sortDirective ? sortDirective.descending ? "descending" : "ascending" : sortable ? "none" : void 0,
                          onClick: sortable ? (e) => {
                            if (resizingRef.current || !inHeaderCell(e)) return;
                            handleSortToggle(columnName, e.shiftKey);
                          } : void 0,
                          children: [
                            /* @__PURE__ */ jsxs("div", { className: styles.headerCellContent, children: [
                              /* @__PURE__ */ jsxs(
                                "span",
                                {
                                  className: mergeClasses(styles.headerCellInner, styles.headerCellInnerFill),
                                  style: {
                                    justifyContent: declaredAlign === "end" ? "flex-end" : declaredAlign === "center" ? "center" : "flex-start"
                                  },
                                  children: [
                                    /* @__PURE__ */ jsx(
                                      Tooltip,
                                      {
                                        relationship: "description",
                                        content: /* @__PURE__ */ jsxs(Fragment, { children: [
                                          /* @__PURE__ */ jsx("div", { className: styles.headerTooltipTitle, "aria-hidden": "true", children: headerContent }),
                                          headerTooltip && /* @__PURE__ */ jsx("div", { children: headerTooltip })
                                        ] }),
                                        children: /* @__PURE__ */ jsx(
                                          "span",
                                          {
                                            className: mergeClasses(
                                              styles.headerCellLabel,
                                              (groupDraggable || columnDraggable) && styles.headerCellGroupDrag
                                            ),
                                            children: headerContent
                                          }
                                        )
                                      }
                                    ),
                                    !templateColumnsById.has(columnName) && isFilteredColumn(columnName) && /* @__PURE__ */ jsx(
                                      Filter16Regular,
                                      {
                                        className: mergeClasses("ppp-grid-header-filtered", styles.headerFiltered),
                                        role: "img",
                                        "aria-label": t("app.components.grid.column-filtered"),
                                        "data-ppp-tooltip": t("app.components.grid.column-filtered")
                                      }
                                    ),
                                    SortIcon && /* @__PURE__ */ jsx(SortIcon, { className: styles.sortIcon, "aria-hidden": "true" }),
                                    showSortPosition && /* @__PURE__ */ jsx("span", { className: styles.sortPosition, "aria-hidden": "true", children: sortIndex + 1 })
                                  ]
                                }
                              ),
                              renderColumnMenu(columnName, sortable, sortDirective)
                            ] }),
                            /* @__PURE__ */ jsx(
                              "div",
                              {
                                role: "separator",
                                "aria-orientation": "vertical",
                                "aria-label": t("app.components.grid.resize-column"),
                                className: mergeClasses(
                                  styles.resizeHandle,
                                  header.column.getIsResizing() && styles.resizeHandleActive
                                ),
                                onMouseDown: (e) => {
                                  e.stopPropagation();
                                  resizingRef.current = true;
                                  setTimeout(() => {
                                    resizingRef.current = false;
                                  }, 0);
                                  recordShownWidthBeforeResize(header.column.id, e.currentTarget);
                                  header.getResizeHandler()(e);
                                },
                                onTouchStart: (e) => {
                                  e.stopPropagation();
                                  resizingRef.current = true;
                                  setTimeout(() => {
                                    resizingRef.current = false;
                                  }, 0);
                                  recordShownWidthBeforeResize(header.column.id, e.currentTarget);
                                  header.getResizeHandler()(e);
                                },
                                onClick: (e) => e.stopPropagation()
                              }
                            )
                          ]
                        },
                        header.id
                      );
                    })
                  ] }, headerGroup.id)) }),
                  /* @__PURE__ */ jsxs("tbody", { style: { "--ppp-group-depth": Math.max(0, activeGroupLevels.length - 1) }, children: [
                    !isLoading && !error && bodyItems.map((item) => {
                      if (item.kind === "header") return renderGroupHeaderRow(item.group, item.collapsed, item.level);
                      const row = item.row;
                      const rowState = rowStateFor(row);
                      const {
                        isSelected,
                        handleRowDoubleClick,
                        handleRowClick,
                        isHighlightMuted,
                        isRowInlineEditable
                      } = rowState;
                      const rowBody = /* @__PURE__ */ jsxs(Fragment, { children: [
                        selectionMode !== "none" && /* @__PURE__ */ jsx(
                          "td",
                          {
                            className: mergeClasses(styles.bodyCell, styles.selectCell, bodySelectCell.className),
                            style: bodySelectCell.style,
                            onClick: (e) => e.stopPropagation(),
                            children: selectionMode === "single" ? /* @__PURE__ */ jsx(
                              Radio,
                              {
                                "aria-label": t("app.components.grid.select-row"),
                                name: radioGroupName,
                                value: row.id,
                                checked: isSelected,
                                onChange: () => row.toggleSelected(true),
                                tabIndex: editable ? -1 : void 0
                              }
                            ) : /* @__PURE__ */ jsx(
                              Checkbox,
                              {
                                "aria-label": t("app.components.grid.select-row"),
                                checked: isSelected,
                                onChange: (_, data2) => row.toggleSelected(!!data2.checked),
                                tabIndex: editable ? -1 : void 0
                              }
                            )
                          }
                        ),
                        gridIsDirty && /* @__PURE__ */ jsx(
                          "td",
                          {
                            className: mergeClasses(styles.bodyCell, styles.pendingCell, bodyPendingCell.className),
                            style: bodyPendingCell.style,
                            children: pendingIconFor(rowState)
                          }
                        ),
                        row.getVisibleCells().map((cell, cellIndex) => {
                          const cellAlign = cell.column.columnDef.meta?.align;
                          const pinned = pinnedCell(pinnedPlaces.get(cell.column.id), "body");
                          const cellStyle = cellAlign ? {
                            ...pinned.style,
                            textAlign: (
                              // The logical sides, as the header's.
                              cellAlign === "end" ? "end" : cellAlign === "center" ? "center" : "start"
                            )
                          } : pinned.style;
                          const cellRenderer = cell.column.columnDef.cell;
                          const cellContent = typeof cellRenderer === "function" ? cellRenderer(cell.getContext()) : cellRenderer;
                          return /* @__PURE__ */ jsx(
                            "td",
                            {
                              className: mergeClasses(
                                styles.bodyCell,
                                !!groupLayout && cellIndex === 0 && !pendingCreateIds.has(row.id) && !pendingAssociateIds.has(row.id) && styles.groupedRecordCell,
                                pinned.className
                              ),
                              ...cellStyle && { style: cellStyle },
                              children: cellContent
                            },
                            cell.id
                          );
                        })
                      ] });
                      return /* @__PURE__ */ jsx(
                        "tr",
                        {
                          className: mergeClasses(
                            styles.bodyRow,
                            isSelected && styles.bodyRowSelected,
                            handleRowClick !== void 0 && styles.bodyRowClickable,
                            isHighlightMuted && styles.bodyRowMuted
                          ),
                          ...handleRowDoubleClick !== void 0 && {
                            onDoubleClick: handleRowDoubleClick
                          },
                          ...handleRowClick !== void 0 && {
                            onClick: handleRowClick
                          },
                          children: isRowInlineEditable && row.original.id ? /* @__PURE__ */ jsx(
                            RecordContext,
                            {
                              table: row.original.tableName,
                              id: row.original.id,
                              loadedRecord: row.original,
                              children: rowBody
                            }
                          ) : rowBody
                        },
                        row.id
                      );
                    }),
                    isVirtualize && hasMoreRowsToLoad2 && /* @__PURE__ */ jsx("tr", { ref: setLoadMoreSentinel, children: /* @__PURE__ */ jsx(
                      "td",
                      {
                        className: styles.loadMoreCell,
                        colSpan: table.getVisibleLeafColumns().length + (selectionMode !== "none" ? 1 : 0) + (gridIsDirty ? 1 : 0),
                        children: /* @__PURE__ */ jsx("div", { className: styles.loadMoreSpinner, children: isLoadingMoreRows && /* @__PURE__ */ jsx(Spinner, { size: "tiny", "aria-label": t("app.components.grid.loading") }) })
                      }
                    ) })
                  ] }),
                  hasTotals && /* @__PURE__ */ jsx("tfoot", { children: /* @__PURE__ */ jsxs("tr", { "aria-label": t("app.components.grid.totals"), children: [
                    selectionMode !== "none" && /* @__PURE__ */ jsx("td", { className: mergeClasses(styles.totalsCell, styles.selectCell, totalsSelectCell.className), style: totalsSelectCell.style }),
                    gridIsDirty && /* @__PURE__ */ jsx("td", { className: mergeClasses(styles.totalsCell, styles.pendingCell, totalsPendingCell.className), style: totalsPendingCell.style }),
                    table.getVisibleLeafColumns().map((column) => {
                      const pinned = pinnedCell(pinnedPlaces.get(column.id), "totals");
                      return /* @__PURE__ */ jsx("td", { className: mergeClasses(styles.totalsCell, pinned.className), style: pinned.style, children: !templateColumnsById.has(column.id) && /* @__PURE__ */ jsx(
                        "div",
                        {
                          className: mergeClasses(
                            styles.totalsStack,
                            totalsAlignEnd(column.id) && styles.totalsStackEnd
                          ),
                          children: renderTotals(column.id)
                        }
                      ) }, column.id);
                    })
                  ] }) })
                ]
              }
            ),
            displayedData.length === 0 && bodyItems.length === 0 && /* @__PURE__ */ jsx("div", { className: styles.emptyStateRow, children: t("app.components.grid.empty-content") }),
            showsCards && !showsMap && isVirtualize && hasMoreRowsToLoad2 && // The sentinel shows the spinner for a page loaded by scrolling, which the loading overlay
            // leaves alone so the rows already loaded stay usable. A fresh list (refresh / sort /
            // search / view switch) starts again at page 1 under the overlay, with no spinner here.
            /* @__PURE__ */ jsx("div", { ref: setLoadMoreSentinel, className: styles.loadMoreSentinel, children: isLoadingMoreRows && /* @__PURE__ */ jsx(Spinner, { size: "tiny", "aria-label": t("app.components.grid.loading") }) })
          ] })
        ] }),
        showsCards && hasTotals && /* @__PURE__ */ jsx("div", { className: styles.cardsTotals, role: "group", "aria-label": t("app.components.grid.totals"), children: totalsColumnIds.map((columnId) => /* @__PURE__ */ jsxs("div", { className: styles.cardsTotal, children: [
          /* @__PURE__ */ jsx("span", { className: styles.cardsTotalColumn, children: declaredColumnsByName.get(columnId)?.displayName ?? effectiveColumnsByName.get(columnId)?.displayName ?? columnId }),
          renderTotals(columnId)
        ] }, columnId)) }),
        !hidePaging && !accumulates && !isLoading && !error && (data.length > 0 || page > 1 || (shownRecordCount ?? 0) > 0) && /* @__PURE__ */ jsx(
          MainGridPaging,
          {
            page,
            pageSize,
            totalCount,
            ...shownRecordCount !== void 0 && { recordCount: shownRecordCount },
            dataLength: data.length,
            onPageChange: handlePageChange,
            onPageSizeChange: handlePageSizeChange,
            pageSizes,
            showPageSize: allowChangingPageSize && !isNarrowViewport
          }
        ),
        !hidePaging && accumulates && !isLoading && !error && (data.length > 0 || (shownRecordCount ?? 0) > 0) && // A collapsed group's records are held, not waiting to load, so they count as loaded. The map
        // alone counts no more than it shows.
        /* @__PURE__ */ jsx(
          MainGridVirtualizeFooter,
          {
            loadedCount: showsMapOnly ? Math.min(data.length, mapMaximumRows) : data.length + collapsedRecordCount,
            totalCount: shownRecordCount
          }
        ),
        showsLoadingOverlay && /* @__PURE__ */ jsx("div", { className: styles.loadingOverlay, children: /* @__PURE__ */ jsx(Spinner, { size: "large", "aria-label": t("app.components.grid.loading") }) }),
        /* @__PURE__ */ jsx("span", { className: styles.visuallyHidden, role: "status", "aria-live": "polite", children: showsLoadingOverlay || isLoadingMoreRows ? t("app.components.grid.loading") : "" })
      ]
    }
  ) });
}
function localDate() {
  const now = /* @__PURE__ */ new Date();
  const pad2 = (n) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`;
}
var VIEW_TYPE_PUBLIC = 0;
var useLookupFormStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    width: "100%",
    // Fill the dialog's scrollable body so the grid can stretch to the dialog
    // height. minHeight:0 lets this flex item shrink below its content height so
    // the grid's own scroll region — not this container — absorbs row overflow.
    flex: "1 1 auto",
    minHeight: 0
  },
  // Picker row — label + dropdown laid out horizontally.
  // `<FluentStack Orientation="Horizontal">` around the table-type select.
  pickerRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    flexWrap: "wrap"
  },
  pickerLabel: {
    color: tokens.colorNeutralForeground2
  },
  pickerDropdown: {
    minWidth: "200px"
  }
});
function LookupForm({
  tableNames,
  defaultTable,
  viewIds,
  selectionMode = "single",
  onSelectedRecordsChange,
  selectedRecords,
  pageSize = 10,
  filters,
  tableFilters,
  initialSearchText,
  className,
  style,
  gridClassName,
  gridStyle
}) {
  const styles = useLookupFormStyles();
  const t = useT();
  if (tableNames.length === 0) {
    throw new Error("LookupForm: `tableNames` must contain at least one table.");
  }
  const initialTable = useMemo(() => {
    if (defaultTable && tableNames.includes(defaultTable)) return defaultTable;
    return tableNames[0];
  }, [defaultTable, tableNames]);
  const [selectedTable, setSelectedTable] = useState(initialTable);
  const searchTextRef = useRef(initialSearchText ?? "");
  const rememberSearchText = useCallback((text2) => {
    searchTextRef.current = text2;
  }, []);
  const viewsResult = useViewsForTable(selectedTable);
  const gridFilters = [...filters ?? [], ...tableFilters?.[selectedTable] ?? []];
  const viewsStatus = viewsResult.status;
  const viewsData = viewsResult.data;
  const allowedViews = useMemo(() => {
    if (viewsStatus !== QueryStatus.Success || !viewsData) return [];
    const publicViews = viewsData.filter((v) => v.type === VIEW_TYPE_PUBLIC);
    const allow = viewIds?.[selectedTable];
    if (!allow || allow.length === 0) return publicViews;
    const allowSet = new Set(allow);
    return publicViews.filter((v) => allowSet.has(v.id));
  }, [viewsStatus, viewsData, viewIds, selectedTable]);
  const allowedViewIds = useMemo(() => allowedViews.map((v) => v.id), [allowedViews]);
  const defaultViewId = useMemo(
    () => (allowedViews.find((v) => v.isDefault) ?? allowedViews[0])?.id,
    [allowedViews]
  );
  const handleTableChange = (next) => {
    if (next === selectedTable) return;
    setSelectedTable(next);
    onSelectedRecordsChange?.([]);
  };
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-lookup-form", styles.root, className), style, children: [
    tableNames.length > 1 && /* @__PURE__ */ jsxs("div", { className: styles.pickerRow, children: [
      /* @__PURE__ */ jsx(Label, { className: styles.pickerLabel, htmlFor: "ppp-lookup-form-table", children: t("app.components.lookup-form.table-type") }),
      /* @__PURE__ */ jsx(
        Dropdown,
        {
          id: "ppp-lookup-form-table",
          className: styles.pickerDropdown,
          value: tableLabel2(t, selectedTable),
          selectedOptions: [selectedTable],
          onOptionSelect: (_, data) => {
            if (data.optionValue) handleTableChange(data.optionValue);
          },
          children: tableNames.map((name) => {
            const label = tableLabel2(t, name);
            return /* @__PURE__ */ jsx(Option, { value: name, text: label, children: label }, name);
          })
        }
      )
    ] }),
    allowedViews.length > 0 && /* @__PURE__ */ jsx(
      MainGrid,
      {
        tableName: selectedTable,
        viewIds: allowedViewIds,
        ...defaultViewId ? { defaultViewId } : {},
        selectionMode,
        showRecordLinks: false,
        selectFromEntireRow: true,
        fullSize: true,
        pageSize,
        ...gridFilters.length > 0 ? { filters: gridFilters } : {},
        ...searchTextRef.current ? { initialSearchText: searchTextRef.current } : {},
        onSearchTextChange: rememberSearchText,
        ...onSelectedRecordsChange ? { onSelectedRecordsChange } : {},
        ...selectedRecords !== void 0 ? { selectedRecords } : {},
        ...gridClassName !== void 0 ? { className: gridClassName } : {},
        ...gridStyle !== void 0 ? { style: gridStyle } : {}
      },
      selectedTable
    )
  ] });
}
function tableLabel2(t, tableName) {
  const key3 = `tables.${tableName}.label`;
  const resolved = t(key3);
  return resolved === key3 ? tableName : resolved;
}
var useLookupDialogStyles = makeStyles({
  // Override Fluent's default dialog width — lookup dialogs need most of
  // the viewport so the embedded grid has room.
  // `style="--dialog-width: 95% !important"`. The flex column + explicit
  // height-constraints chain (surface → scrollableBody) is the load-
  // bearing piece for keeping the footer pinned at the bottom and the
  // body scrollable when the grid is taller than the surface allows.
  surface: {
    maxWidth: "95vw",
    width: "95vw",
    display: "flex",
    flexDirection: "column"
  },
  // Title row — DialogTitle keeps Fluent's heading typography (it
  // renders an `<h2>` with the right aria semantics), and the close
  // button sits on the right via flex. Wrapping in a row is necessary
  // because DialogTitle's intrinsic `action` slot only positions
  // correctly inside a `<DialogBody>` grid — without that wrapper, the
  // action element renders inline after the title text. Owning the row
  // ourselves keeps the X reliably in the top-right.
  titleRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    columnGap: tokens.spacingHorizontalS,
    flex: "0 0 auto"
  },
  titleText: {
    flex: "1 1 auto",
    minWidth: 0
  },
  titleClose: {
    flex: "0 0 auto"
  },
  // Scrollable body region — flex 1 so it expands to fill the space
  // between title and footer, `minHeight: 0` to let it shrink past its
  // content's intrinsic height (otherwise the grid pushes the surface
  // taller than the dialog's maxHeight and the footer scrolls off
  // screen). `overflow: auto` is what turns this into the actual scroll
  // container.
  scrollableBody: {
    flex: "1 1 auto",
    minHeight: 0,
    // Flex column so the LookupForm child (flex:1 1 auto) actually fills this
    // region. Without it this is a display:block scroll container, so the form —
    // and the fullSize grid inside it — collapse to content height and sit at the
    // top, leaving empty space below the grid when there are only a few rows.
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    overflowX: "hidden",
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS
  },
  // Footer region. `flex: 0 0 auto` keeps it pinned at the bottom of the
  // surface regardless of body size; the inner flex with
  // `justify-content: space-between` lays the selected-records readout
  // on the left and the action buttons on the right.
  footer: {
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    columnGap: tokens.spacingHorizontalM,
    paddingTop: tokens.spacingVerticalM,
    marginTop: tokens.spacingVerticalS,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`
  },
  selectedText: {
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase200,
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "left"
  },
  footerButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    flex: "0 0 auto"
  }
});
function LookupDialog({
  hidden = true,
  onHiddenChange,
  title,
  actionLabel,
  onActionClicked,
  onSelectedRecordsChange,
  minHeight = "600px",
  maxHeight = "95vh",
  className,
  style,
  ...lookupFormProps
}) {
  const styles = useLookupDialogStyles();
  const t = useT();
  const [selected, setSelected] = useState([]);
  const handleSelectedRecordsChange = useCallback(
    (records) => {
      setSelected((prev) => {
        if (prev.length === records.length && prev.every((r, i) => r === records[i])) {
          return prev;
        }
        return records;
      });
      onSelectedRecordsChange?.(records);
    },
    [onSelectedRecordsChange]
  );
  const close = () => onHiddenChange?.(true);
  const handleActionClicked = () => {
    onActionClicked?.(selected);
    close();
  };
  const tableNameForSelection = selected[0]?.tableName;
  const tableMetaQuery = useTableMetadata(tableNameForSelection ?? "", {
    enabled: !!tableNameForSelection
  });
  const selectedSummary = useMemo(() => {
    if (selected.length === 0) {
      return t("app.messages.no-records-selected");
    }
    const primaryNameColumn = tableMetaQuery.data?.primaryNameColumn;
    if (!primaryNameColumn) return t("app.messages.no-records-selected");
    const emptyName = t("app.messages.empty-primary-name");
    const names2 = selected.map((record) => {
      const value2 = resolveColumnDisplayValue(record, primaryNameColumn);
      return value2 || emptyName;
    });
    return names2.join(", ");
  }, [selected, tableMetaQuery.data, t]);
  const action = actionLabel ?? t("app.buttons.ok.label");
  const cancel = t("app.buttons.cancel.label");
  const selectedRecordsLabel = t("app.components.lookup-form.selected-records");
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      open: !hidden,
      onOpenChange: (_, data) => {
        if (!data.open) close();
      },
      modalType: "modal",
      children: /* @__PURE__ */ jsxs(
        DialogSurface,
        {
          className: mergeClasses("ppp-lookup-dialog", styles.surface, className),
          style: { minHeight, maxHeight, ...style },
          children: [
            /* @__PURE__ */ jsxs("div", { className: styles.titleRow, children: [
              /* @__PURE__ */ jsx(DialogTitle, { className: styles.titleText, children: title }),
              /* @__PURE__ */ jsx(
                Button,
                {
                  className: styles.titleClose,
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(Dismiss24Regular, {}),
                  "aria-label": cancel,
                  onClick: close
                }
              )
            ] }),
            /* @__PURE__ */ jsx("div", { className: styles.scrollableBody, children: /* @__PURE__ */ jsx(
              LookupForm,
              {
                ...lookupFormProps,
                onSelectedRecordsChange: handleSelectedRecordsChange
              }
            ) }),
            /* @__PURE__ */ jsxs("div", { className: styles.footer, children: [
              /* @__PURE__ */ jsxs("div", { className: styles.selectedText, children: [
                selectedRecordsLabel,
                " ",
                selectedSummary
              ] }),
              /* @__PURE__ */ jsxs("div", { className: styles.footerButtons, children: [
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    appearance: "primary",
                    icon: /* @__PURE__ */ jsx(LinkAdd20Regular, {}),
                    disabled: selected.length === 0,
                    onClick: handleActionClicked,
                    children: action
                  }
                ),
                /* @__PURE__ */ jsx(Button, { onClick: close, autoFocus: true, children: cancel })
              ] })
            ] })
          ]
        }
      )
    }
  );
}
var useStyles26 = makeStyles({
  /**
   * One wrapping row holding the chosen records and the button that adds another.
   *
   * The tags used to sit in a column above the button, which read as two separate
   * controls stacked rather than one list you are adding to. In a single flow they
   * run inline, drop to the next line only when they will not fit, and the button
   * stays last wherever that lands.
   */
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalXS,
    rowGap: tokens.spacingVerticalXS,
    minWidth: 0
  },
  /**
   * The group contributes no box of its own, so its tags become items of the row
   * above rather than one item containing all of them — which is what would put
   * the button after the whole block instead of after the last tag.
   *
   * `display: contents` removes the box, not the semantics: the list and its items
   * stay in the accessibility tree.
   */
  tags: {
    display: "contents"
  },
  /**
   * Capped at the same 225px as every other control in the row. A record name has
   * no length limit, and an uncapped tag pushed the row wider than the ones above
   * and below it.
   */
  tag: {
    maxWidth: "225px"
  },
  /**
   * The tag's content area. Default cursor because nothing happens when it is
   * clicked — a pointer would promise an action the tag does not have.
   *
   * `minWidth: 0` on both the button and its text: each is a grid item, and a grid
   * item's floor is its content unless told otherwise — without it the text refuses
   * to shrink and the cap just overflows instead of truncating.
   */
  tagPrimary: {
    cursor: "default",
    minWidth: 0,
    [`& .${interactionTagPrimaryClassNames.primaryText}`]: {
      minWidth: 0,
      // Longhands rather than the `overflow` shorthand, which griffel rejects.
      overflowX: "hidden",
      overflowY: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  },
  /**
   * Grows into whatever the tags leave, rather than claiming the full width.
   *
   * With no tags it is the only item, so it still fills the row slot and lines up
   * with the fixed-width controls beside it. With tags it takes the rest of their
   * line, and when less than its own text will fit it wraps to the next line and
   * fills that instead — so it is always last and never squeezed to nothing.
   */
  button: {
    flexGrow: 1,
    justifyContent: "center"
  }
});
function LookupValueEditor({
  values,
  onChange,
  column,
  multiple,
  disabled,
  className
}) {
  const styles = useStyles26();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { metadata, lookupNames } = useFetchXmlBuilderContext();
  const [dialogHidden, setDialogHidden] = useState(true);
  const rootRef = useRef(null);
  const tableNames = column.targets ?? [];
  const canBrowse = tableNames.length > 0;
  const tableFor = (entry) => entry.uiType ?? (tableNames.length === 1 ? tableNames[0] : void 0);
  const unnamed = useMemo(() => {
    const byTable = /* @__PURE__ */ new Map();
    for (const entry of values) {
      if (entry.uiName !== void 0 && entry.uiName !== "") continue;
      const table = tableFor(entry);
      if (table === void 0 || entry.value === "") continue;
      const ids = byTable.get(table);
      if (ids === void 0) byTable.set(table, [entry.value]);
      else ids.push(entry.value);
    }
    return byTable;
  }, [values, column]);
  useEffect(() => {
    for (const [table, ids] of unnamed) lookupNames.request(table, ids);
  }, [unnamed, lookupNames]);
  const labelFor = (entry) => {
    if (entry.uiName !== void 0 && entry.uiName !== "") return entry.uiName;
    const table = tableFor(entry);
    return (table === void 0 ? void 0 : lookupNames.get(table, entry.value)) ?? entry.value;
  };
  const commit = (records) => {
    void (async () => {
      const resolved = await Promise.all(records.map((record) => toLookupValueEntry(record, metadata)));
      const chosen = resolved.filter((entry) => entry !== void 0);
      if (chosen.length === 0) return;
      if (!multiple) {
        onChange([chosen[0]]);
        return;
      }
      const existing = new Set(values.map((entry) => entry.value));
      onChange([...values, ...chosen.filter((entry) => !existing.has(entry.value))]);
    })();
  };
  return /* @__PURE__ */ jsxs("div", { ref: rootRef, className, children: [
    /* @__PURE__ */ jsx(SharedTooltip, { containerRef: rootRef }),
    /* @__PURE__ */ jsxs("div", { className: styles.root, children: [
      values.length === 0 ? null : /* @__PURE__ */ jsx(
        TagGroup,
        {
          className: styles.tags,
          onDismiss: (_, data) => onChange(values.filter((entry) => entry.value !== data.value)),
          "aria-label": t("selected-records"),
          children: values.map((entry) => (
            // InteractionTag rather than Tag. A dismissible `Tag` renders its root
            // as a <button> that dismisses on click, so the whole chip removes the
            // record — including the name you clicked to read it. InteractionTag
            // splits that in two: the name is inert, and only the X dismisses.
            // No size override: TagGroup defaults to medium, which is the same
            // 32px as the Input and Dropdown beside it. The small tags this
            // replaced sat noticeably short of the row they belong to.
            /* @__PURE__ */ jsxs(InteractionTag, { value: entry.value, className: styles.tag, children: [
              /* @__PURE__ */ jsx(
                InteractionTagPrimary,
                {
                  className: styles.tagPrimary,
                  hasSecondaryAction: disabled !== true,
                  "data-ppp-tooltip": labelFor(entry),
                  children: labelFor(entry)
                }
              ),
              disabled === true ? null : /* @__PURE__ */ jsx(InteractionTagSecondary, { "aria-label": t("remove-record") })
            ] }, entry.value)
          ))
        }
      ),
      disabled === true || !multiple && values.length > 0 ? null : /* @__PURE__ */ jsx(
        Button,
        {
          className: styles.button,
          appearance: "secondary",
          ...canBrowse ? { icon: /* @__PURE__ */ jsx(Add20Regular, {}) } : {},
          disabled: !canBrowse,
          onClick: () => setDialogHidden(false),
          children: canBrowse ? t("select-record") : t("no-lookup-targets")
        }
      )
    ] }),
    canBrowse ? /* @__PURE__ */ jsx(
      LookupDialog,
      {
        hidden: dialogHidden,
        onHiddenChange: setDialogHidden,
        title: t("select-record"),
        tableNames,
        selectionMode: multiple ? "multiple" : "single",
        onActionClicked: commit
      }
    ) : null
  ] });
}
async function toLookupValueEntry(record, metadata) {
  const id = getRecordReferenceId(record);
  if (id === void 0) return void 0;
  return {
    value: id,
    uiName: await primaryName(record, metadata),
    uiType: record.tableName
  };
}
async function primaryName(record, metadata) {
  try {
    const detail = await metadata.getTable(record.tableName);
    const column = detail?.primaryNameColumn;
    if (column === void 0 || column === "") return void 0;
    return resolveColumnDisplayValue(record, column) ?? void 0;
  } catch {
    return void 0;
  }
}
var LOOKUP_TYPES = [
  ColumnType.Lookup,
  ColumnType.Customer,
  ColumnType.Owner,
  ColumnType.PartyList
];
function isLookupColumn(column) {
  return column?.type !== void 0 && LOOKUP_TYPES.includes(column.type);
}
var EMPTY_COLUMNS2 = [];
function ConditionRow({
  condition,
  columns,
  sources,
  onChange,
  onRemove,
  columnTitle,
  layout,
  markIncomplete = true
}) {
  const stacked = layout === "stacked";
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const source = sources === void 0 ? void 0 : findColumnSource(sources, condition.entityName);
  const available = sources === void 0 ? condition.entityName === void 0 ? columns : EMPTY_COLUMNS2 : source?.columns ?? EMPTY_COLUMNS2;
  const column = findColumn(available, condition.attribute);
  const columnType = column?.type;
  const comparisonMode = getComparisonMode(condition);
  const operators = useMemo(() => {
    const forColumn = getConditionOperatorsForColumnType(columnType);
    return comparisonMode === "column" ? forColumn.filter((info) => supportsColumnComparison(info.operator)) : forColumn;
  }, [columnType, comparisonMode]);
  const displayOperator = getDisplayOperator(condition);
  const selected = operators.find((info) => info.operator === displayOperator) ?? getConditionOperatorsForColumnType(void 0).find(
    (info) => info.operator === displayOperator
  );
  const operatorLabel = (info) => t(`operators.${info.name}`);
  const comparableColumns = useMemo(
    () => sources === void 0 ? getComparableColumns(available, column).map((candidate) => ({
      logicalName: candidate.logicalName,
      displayName: metadataLabel(candidate)
    })) : sources.flatMap(
      (candidateSource) => candidateSource.columns.filter(
        (candidate) => isComparableColumn(
          column,
          candidate,
          candidateSource.alias === (condition.entityName ?? "").trim()
        )
      ).map((candidate) => ({
        logicalName: columnSourceKey(candidateSource.alias, candidate.logicalName),
        displayName: metadataLabel(candidate),
        ...sources.length > 1 ? { group: candidateSource.label } : {}
      }))
    ),
    [sources, available, column, condition.entityName]
  );
  return /* @__PURE__ */ jsx("div", { className: "ppp-fetch-xml-condition", children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses(
        styles.row,
        stacked && styles.rowStacked,
        // A column not yet chosen counts too: the row is as unfinished as one missing its value.
        markIncomplete && isConditionUnfinished(condition) ? styles.rowIncomplete : void 0
      ),
      children: [
        columnTitle !== void 0 ? stacked ? null : /* @__PURE__ */ jsx("span", { className: mergeClasses(styles.rowControl, styles.fixedColumn), "data-ppp-tooltip": columnTitle, children: columnTitle }) : sources === void 0 ? /* @__PURE__ */ jsx(
          MetadataPicker,
          {
            className: styles.rowControl,
            value: condition.attribute ?? "",
            onChange: (value2) => {
              const attribute = value2 === "" ? void 0 : value2;
              onChange(changeConditionColumn(condition, attribute, findColumn(columns, attribute)));
            },
            items: available,
            placeholder: t("column-placeholder"),
            ariaLabel: t("column")
          }
        ) : /* @__PURE__ */ jsx(
          ConditionColumnPicker,
          {
            className: styles.rowControl,
            condition,
            sources,
            onChange
          }
        ),
        /* @__PURE__ */ jsx(
          Dropdown,
          {
            className: styles.rowControl,
            "aria-label": t("operator"),
            value: selected ? operatorLabel(selected) : "",
            selectedOptions: [String(displayOperator)],
            onOptionSelect: (_, data) => {
              const next = Number(data.optionValue);
              onChange(changeConditionOperator(condition, next));
            },
            children: operators.map((info) => /* @__PURE__ */ jsx(Option, { value: String(info.operator), text: operatorLabel(info), children: operatorLabel(info) }, info.operator))
          }
        ),
        selected !== void 0 && supportsColumnComparison(selected.operator) ? /* @__PURE__ */ jsxs(
          Dropdown,
          {
            className: styles.rowControlNarrow,
            "aria-label": t("compare-mode"),
            value: comparisonMode === "column" ? t("compare-by-column") : t("compare-by-value"),
            selectedOptions: [comparisonMode],
            onOptionSelect: (_, data) => onChange(setComparisonMode(condition, data.optionValue)),
            children: [
              /* @__PURE__ */ jsx(Option, { value: "value", children: t("compare-by-value") }),
              /* @__PURE__ */ jsx(Option, { value: "column", children: t("compare-by-column") })
            ]
          }
        ) : null,
        comparisonMode === "column" ? /* @__PURE__ */ jsx(
          MetadataPicker,
          {
            className: styles.rowControl,
            value: condition.valueOfColumn ?? "",
            onChange: (value2) => onChange(setValueOfColumn(value2)),
            items: comparableColumns,
            placeholder: t("compare-column-placeholder"),
            ariaLabel: t("compare-column")
          }
        ) : /* @__PURE__ */ jsx(
          ConditionValueEditor,
          {
            condition,
            column,
            info: selected,
            onChange
          }
        ),
        onRemove && /* @__PURE__ */ jsx("div", { className: styles.rowActions, children: /* @__PURE__ */ jsx(Tooltip, { content: t("remove-condition"), relationship: "label", children: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(Delete20Regular, {}),
            onClick: onRemove,
            "aria-label": t("remove-condition")
          }
        ) }) })
      ]
    }
  ) });
}
function ConditionColumnPicker({
  condition,
  sources,
  onChange,
  className
}) {
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const items = useMemo(
    () => sources.flatMap(
      (source) => source.columns.map((column) => ({
        logicalName: columnSourceKey(source.alias, column.logicalName),
        displayName: metadataLabel(column),
        // A heading over a single table would be labeling the obvious.
        ...sources.length > 1 ? { group: source.label } : {}
      }))
    ),
    [sources]
  );
  const current = condition.attribute === void 0 || condition.attribute === "" ? "" : columnSourceKey((condition.entityName ?? "").trim(), condition.attribute);
  return /* @__PURE__ */ jsx(
    MetadataPicker,
    {
      className,
      value: current,
      items,
      placeholder: t("column-placeholder"),
      ariaLabel: t("column"),
      onChange: (key3) => {
        const { alias, logicalName } = parseColumnSourceKey(key3);
        const picked = findColumnSource(sources, alias);
        const pickedColumn = picked?.columns.find(
          (candidate) => candidate.logicalName === logicalName
        );
        onChange({
          // Clearing the value and re-typing the operator is the same work
          // changing a column has always done — the previous column's comparand
          // means nothing against the new one.
          ...changeConditionColumn(condition, logicalName, pickedColumn),
          entityName: alias === "" ? void 0 : alias
        });
      }
    }
  );
}
function ConditionValueEditor({ condition, column, info, onChange }) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { tables } = useFetchXmlBuilderContext();
  if (!info || info.arity === "none") return null;
  if (isLookupColumn(column) && info.valueKind === "column") {
    if (info.arity === "one" || info.arity === "many") {
      const multiple = info.arity === "many";
      return /* @__PURE__ */ jsx(
        LookupValueEditor,
        {
          className: styles.rowControlFlexible,
          values: getConditionValueEntries(condition),
          column,
          multiple,
          onChange: (next) => onChange(
            multiple ? setConditionValues(next) : (
              // A single-valued operator writes the `value` attribute, and the
              // record's name alongside it on the condition itself.
              {
                value: next[0]?.value,
                values: void 0,
                uiName: next[0]?.uiName,
                uiType: next[0]?.uiType
              }
            )
          )
        }
      );
    }
  }
  const options = column?.options;
  if (options !== void 0 && options.length > 0 && info.valueKind === "column") {
    if (info.arity === "one" || info.arity === "many") {
      const multiple = info.arity === "many";
      return /* @__PURE__ */ jsx(
        ChoiceValueEditor,
        {
          className: styles.rowControl,
          values: getConditionValues(condition),
          options,
          multiple,
          ariaLabel: multiple ? t("value-list") : t("value"),
          onChange: (next) => onChange(
            multiple ? setConditionValues(next) : (
              // A single-valued operator writes the `value` attribute, not
              // `<value>` children, so it goes through the text path.
              setConditionText(condition, next[0] ?? "")
            )
          )
        }
      );
    }
  }
  if (column?.type === ColumnType.EntityName && info.valueKind === "column" && info.arity === "one") {
    return /* @__PURE__ */ jsx(
      MetadataPicker,
      {
        className: styles.rowControl,
        value: getConditionText(condition),
        onChange: (logicalName) => onChange(setConditionText(condition, logicalName)),
        items: tables,
        ariaLabel: t("value"),
        placeholder: t("value")
      }
    );
  }
  if (column?.type === ColumnType.Memo && info.valueKind === "column" && info.arity === "one") {
    return /* @__PURE__ */ jsx(
      Textarea,
      {
        className: styles.rowControl,
        "aria-label": t("value"),
        placeholder: t("value"),
        resize: "vertical",
        value: getConditionText(condition),
        onChange: (_, data) => onChange(setConditionText(condition, data.value))
      }
    );
  }
  if (column?.type === ColumnType.DateTime && info.valueKind === "column") {
    const dateOnly = column.dateOnly === true;
    if (info.arity === "one") {
      return /* @__PURE__ */ jsx(
        DateValueEditor,
        {
          label: t("value"),
          dateOnly,
          value: getConditionText(condition),
          onChange: (next) => onChange(setConditionText(condition, next))
        }
      );
    }
    if (info.arity === "two") {
      const between = getConditionValues(condition);
      const from = parseConditionDate(between[0] ?? "");
      const to = parseConditionDate(between[1] ?? "");
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          DateValueEditor,
          {
            label: t("value-from"),
            dateOnly,
            ...to === void 0 ? {} : { max: to },
            value: between[0] ?? "",
            onChange: (next) => onChange(setConditionValueAt(condition, 0, next))
          }
        ),
        /* @__PURE__ */ jsx(
          DateValueEditor,
          {
            label: t("value-to"),
            dateOnly,
            ...from === void 0 ? {} : { min: from },
            value: between[1] ?? "",
            onChange: (next) => onChange(setConditionValueAt(condition, 1, next))
          }
        )
      ] });
    }
  }
  const kind = numericInputKind(column, info);
  if (info.arity === "two") {
    const values = getConditionValues(condition);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        NumericInput,
        {
          className: styles.rowControl,
          label: t("value-from"),
          kind,
          value: values[0] ?? "",
          onChange: (next) => onChange(setConditionValueAt(condition, 0, next))
        }
      ),
      /* @__PURE__ */ jsx(
        NumericInput,
        {
          className: styles.rowControl,
          label: t("value-to"),
          kind,
          value: values[1] ?? "",
          onChange: (next) => onChange(setConditionValueAt(condition, 1, next))
        }
      )
    ] });
  }
  if (info.arity === "many") {
    return /* @__PURE__ */ jsx(
      ValueListInput,
      {
        className: styles.rowControl,
        label: t("value-list"),
        placeholder: t("value-list-placeholder"),
        kind,
        values: getConditionValues(condition),
        onChange: (values) => onChange(setConditionValues(values))
      }
    );
  }
  return /* @__PURE__ */ jsx(
    NumericInput,
    {
      className: styles.rowControl,
      label: t("value"),
      kind,
      value: getConditionText(condition),
      onChange: (next) => onChange(setConditionText(condition, next))
    }
  );
}
function NumericInput({ value: value2, onChange, kind, label, className }) {
  return /* @__PURE__ */ jsx(
    Input,
    {
      className,
      "aria-label": label,
      placeholder: label,
      type: "text",
      ...kind === "none" ? {} : { inputMode: kind === "decimal" ? "decimal" : "numeric" },
      value: value2,
      onChange: (_, data) => {
        if (!isAllowedNumericInput(data.value, kind)) return;
        onChange(data.value);
      }
    }
  );
}
function ValueListInput({ values, onChange, kind, label, placeholder, className }) {
  const external = formatValueList(values);
  const [draft, setDraft] = useState(external);
  useEffect(() => {
    if (external !== formatValueList(parseValueList(draft))) setDraft(external);
  }, [external]);
  return /* @__PURE__ */ jsx(
    Input,
    {
      className,
      "aria-label": label,
      placeholder,
      value: draft,
      ...kind === "none" ? {} : { inputMode: kind === "decimal" ? "decimal" : "numeric" },
      onChange: (_, data) => {
        if (!isAllowedNumericList(data.value, kind)) return;
        setDraft(data.value);
        onChange(parseValueList(data.value));
      }
    }
  );
}
function FilterGroup({
  filter,
  columns,
  sources,
  onToggleUnionHint,
  unionHintTaken,
  onUpdateFilter,
  onUpdateCondition,
  onAddCondition,
  onAddGroup,
  onAddRelatedEntity,
  renderLinkEntity,
  onRemoveNode,
  extraChildren,
  removable = true,
  nested = false,
  allowRelatedEntity = true,
  onInvertFilter,
  hiddenFilterId
}) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const invertible = canInvertFilter(filter);
  const isOr = filter.type === LogicalOperator.Or;
  const hasUnionHint = filter.hint === UNION_FILTER_HINT;
  const groups = filter.filters.filter((nested2) => nested2.id !== hiddenFilterId);
  const isEmpty = filter.conditions.length === 0 && groups.length === 0 && (filter.linkEntities ?? []).length === 0;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses("ppp-fetch-xml-filter-group", styles.group),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: mergeClasses(
              styles.groupHeader,
              nested ? styles.groupHeaderNested : void 0,
              isOr ? styles.groupHeaderOr : void 0
            ),
            children: [
              /* @__PURE__ */ jsxs(
                Dropdown,
                {
                  className: styles.groupMatchControl,
                  "aria-label": t("match"),
                  value: isOr ? t("match-any") : t("match-all"),
                  selectedOptions: [String(filter.type)],
                  onOptionSelect: (_, data) => onUpdateFilter(filter.id, { type: Number(data.optionValue) }),
                  children: [
                    /* @__PURE__ */ jsx(Option, { value: String(LogicalOperator.And), children: t("match-all") }),
                    /* @__PURE__ */ jsx(Option, { value: String(LogicalOperator.Or), children: t("match-any") })
                  ]
                }
              ),
              onInvertFilter ? /* @__PURE__ */ jsx(
                Tooltip,
                {
                  content: invertible ? t("invert-conditions-hint") : t("invert-conditions-unavailable"),
                  relationship: "label",
                  children: /* @__PURE__ */ jsx(
                    Button,
                    {
                      appearance: "subtle",
                      icon: /* @__PURE__ */ jsx(ArrowSwap20Regular, {}),
                      "aria-label": t("invert-conditions"),
                      disabled: !invertible,
                      onClick: () => onInvertFilter(filter.id)
                    }
                  )
                }
              ) : null,
              onToggleUnionHint && (isOr || hasUnionHint) ? /* @__PURE__ */ jsx(
                Tooltip,
                {
                  content: unionHintTaken && !hasUnionHint ? t("union-hint-taken") : t("union-hint-help"),
                  relationship: "label",
                  children: /* @__PURE__ */ jsx(
                    ToggleButton,
                    {
                      appearance: "subtle",
                      icon: /* @__PURE__ */ jsx(ArrowSplit20Regular, {}),
                      "aria-label": t("union-hint"),
                      checked: hasUnionHint,
                      disabled: unionHintTaken === true && !hasUnionHint,
                      onClick: () => onToggleUnionHint(filter.id)
                    }
                  )
                }
              ) : null,
              removable ? /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(Delete20Regular, {}),
                  onClick: () => onRemoveNode(filter.id),
                  "aria-label": t("remove-group")
                }
              ) : null
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: mergeClasses(
              styles.groupChildren,
              isOr ? styles.groupOr : void 0,
              styles.groupChildrenContinues
            ),
            children: [
              isEmpty ? /* @__PURE__ */ jsx("span", { className: mergeClasses(styles.emptyHint, styles.emptyRow), children: t("group-empty") }) : null,
              filter.conditions.map((condition) => /* @__PURE__ */ jsx(
                ConditionRow,
                {
                  condition,
                  columns,
                  sources,
                  onChange: (patch) => onUpdateCondition(condition.id, patch),
                  onRemove: () => onRemoveNode(condition.id)
                },
                condition.id
              )),
              groups.map((nested2) => /* @__PURE__ */ jsx(
                FilterGroup,
                {
                  filter: nested2,
                  columns,
                  sources,
                  onToggleUnionHint,
                  unionHintTaken,
                  onUpdateFilter,
                  onUpdateCondition,
                  onAddCondition,
                  onAddGroup,
                  onAddRelatedEntity,
                  onRemoveNode,
                  renderLinkEntity,
                  onInvertFilter,
                  hiddenFilterId,
                  nested: true,
                  allowRelatedEntity: false
                },
                nested2.id
              )),
              (filter.linkEntities ?? []).map((link) => /* @__PURE__ */ jsx(Fragment$1, { children: renderLinkEntity?.(link) }, link.id)),
              extraChildren
            ]
          }
        ),
        /* @__PURE__ */ jsx("div", { className: mergeClasses(styles.groupAdd, isOr ? styles.groupAddOr : void 0), children: /* @__PURE__ */ jsxs(Menu, { children: [
          /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuButton, { appearance: "subtle", icon: /* @__PURE__ */ jsx(Add20Regular, {}), size: "small", children: t("add") }) }),
          /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs(MenuList, { children: [
            /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(AddCircle20Regular, {}), onClick: () => onAddCondition(filter.id), children: t("add-row") }),
            /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(TextBulletListLtr20Regular, {}), onClick: () => onAddGroup(filter.id), children: t("add-group") }),
            onAddRelatedEntity ? allowRelatedEntity ? /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Table20Regular, {}), onClick: onAddRelatedEntity, children: t("add-related-entity") }) : (
              // Says why it can't be used here rather than leaving a disabled item with no
              // explanation beside it.
              /* @__PURE__ */ jsx(Tooltip, { content: t("add-related-entity-nested"), relationship: "description", children: /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Table20Regular, {}), disabled: true, children: t("add-related-entity") }) })
            ) : null
          ] }) })
        ] }) })
      ]
    }
  );
}
function linkEntityFromRelationship(relationship, usedAliases) {
  const intersectTable = relationship.intersectTable;
  const relatedIntersectColumn = relationship.relatedIntersectColumn;
  if (intersectTable !== void 0 && intersectTable !== "") {
    const targets = relatedIntersectColumn ? [
      createLinkEntity({
        name: relationship.relatedTable,
        from: relationship.relatedKey || relatedIntersectColumn,
        to: relatedIntersectColumn,
        alias: uniqueAlias(relationship.relatedTable, usedAliases),
        linkType: JoinOperator.Inner,
        filters: [createFilterWithRow()]
      })
    ] : [];
    return createLinkEntity({
      name: intersectTable,
      from: relationship.from,
      to: relationship.to,
      linkType: JoinOperator.Inner,
      intersect: true,
      linkEntities: targets
    });
  }
  return createLinkEntity({
    name: relationship.relatedTable,
    from: relationship.from,
    to: relationship.to,
    alias: uniqueAlias(relationship.relatedTable, usedAliases),
    // Inner by default: a join added to narrow a query is meant to require a
    // match. An outer join added by accident silently widens the result instead.
    linkType: JoinOperator.Inner,
    // A join exists to be filtered on. Arriving with an empty filter and a blank
    // row means the next thing to do is visible, rather than behind two more
    // clicks through controls the user has to go looking for.
    filters: [createFilterWithRow()]
  });
}
var JOIN_TYPE_KEYS = {
  [JoinOperator.Inner]: "join-inner",
  [JoinOperator.LeftOuter]: "join-outer",
  [JoinOperator.Exists]: "join-exists",
  [JoinOperator.In]: "join-in",
  [JoinOperator.Any]: "join-any",
  [JoinOperator.NotAny]: "join-not-any",
  [JoinOperator.All]: "join-all",
  [JoinOperator.NotAll]: "join-not-all",
  [JoinOperator.Natural]: "join-natural",
  [JoinOperator.MatchFirstRowUsingCrossApply]: "join-match-first-row"
};
var JOIN_TYPE_GROUPS = [
  {
    labelKey: "join-group-returns-columns",
    joinTypes: [
      JoinOperator.Inner,
      JoinOperator.LeftOuter,
      JoinOperator.MatchFirstRowUsingCrossApply
    ]
  },
  {
    labelKey: "join-group-filter-only",
    joinTypes: [
      JoinOperator.Exists,
      JoinOperator.In,
      JoinOperator.Any,
      JoinOperator.NotAny,
      JoinOperator.All
    ]
  }
];
var NO_DATA_CHOICE = "no-data";
var OFFERED_JOIN_TYPES = JOIN_TYPE_GROUPS.flatMap(
  (group) => group.joinTypes
);
function joinTypeOptions(current) {
  return OFFERED_JOIN_TYPES.includes(current) ? OFFERED_JOIN_TYPES : [...OFFERED_JOIN_TYPES, current];
}
function joinTypeKey(joinOperator) {
  return JOIN_TYPE_KEYS[joinOperator];
}
function isLinkAliasDuplicate(link, aliases) {
  const alias = (link.alias ?? "").trim();
  if (alias === "") return false;
  return aliases.filter((candidate) => candidate.trim() === alias).length > 1;
}
function isLinkAliasMissing(link) {
  if (link.intersect) return false;
  if (!joinTypeReturnsColumns(link.linkType ?? JoinOperator.Inner)) return false;
  return (link.alias ?? "").trim() === "";
}
function LinkEntityEditor({
  link,
  sourceColumns,
  sourceRelationships,
  className
}) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { query, apply, metadata, tables, aliases, readOnly, showLogicalNames } = useFetchXmlBuilderContext();
  const { data: detail, loading } = useFetchXmlTableDetail(metadata, link.name);
  const columns = detail?.columns ?? [];
  const [pickerOpen, setPickerOpen] = useState(false);
  const relationship = findRelationshipForLink(link, sourceRelationships);
  const described = relationship === void 0 ? void 0 : describeRelationship(relationship, tables, sourceColumns, showLogicalNames);
  const table = tables.find((candidate) => candidate.logicalName === link.name);
  const tableText = described?.table ?? (table ? nameWithLogicalName(table, showLogicalNames) : link.name);
  const linkType = link.linkType ?? JoinOperator.Inner;
  const aliasDuplicate = isLinkAliasDuplicate(link, aliases);
  const noData = hasNoDataFilter(query, link, detail?.primaryIdColumn);
  const renderChild = (child) => /* @__PURE__ */ jsx(
    LinkEntityEditor,
    {
      link: child,
      sourceColumns: columns,
      sourceRelationships: detail?.relationships ?? []
    }
  );
  const nested = link.linkEntities.map((child) => /* @__PURE__ */ jsx(Fragment$1, { children: renderChild(child) }, child.id));
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-fetch-xml-link-entity", styles.group, className), children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: mergeClasses(
          styles.groupHeader,
          styles.groupHeaderNested,
          styles.linkEntityHeader
        ),
        children: [
          /* @__PURE__ */ jsxs("span", { className: styles.linkEntityTitle, children: [
            /* @__PURE__ */ jsx(Link16Regular, { className: styles.linkEntityIcon, "aria-hidden": true }),
            /* @__PURE__ */ jsxs("span", { className: styles.linkEntityName, children: [
              described?.lookup ?? tableText,
              described?.lookup === void 0 ? null : /* @__PURE__ */ jsx("span", { className: styles.linkEntityDetail, children: ` - ${tableText}` })
            ] })
          ] }),
          /* @__PURE__ */ jsx(Tooltip, { content: t("join-type-help"), relationship: "description", children: /* @__PURE__ */ jsxs(
            Dropdown,
            {
              className: styles.rowControl,
              "aria-label": t("join-type"),
              disabled: readOnly,
              value: noData ? t("join-no-data") : t(joinTypeKey(linkType)),
              selectedOptions: [noData ? NO_DATA_CHOICE : String(linkType)],
              onOptionSelect: (_, data) => {
                if (data.optionValue === NO_DATA_CHOICE) {
                  if (detail?.primaryIdColumn === void 0) return;
                  apply(setNoDataFilter(query, link.id, detail.primaryIdColumn));
                  return;
                }
                const cleared = noData ? clearNoDataFilter(query, link.id, detail?.primaryIdColumn) : query;
                apply(setLinkJoinType(cleared, link.id, Number(data.optionValue)));
              },
              children: [
                JOIN_TYPE_GROUPS.map((group) => /* @__PURE__ */ jsx(OptionGroup, { label: t(group.labelKey), children: group.joinTypes.map((option) => /* @__PURE__ */ jsx(Option, { value: String(option), children: t(joinTypeKey(option)) }, option)) }, group.labelKey)),
                /* @__PURE__ */ jsx(OptionGroup, { label: t("join-group-presets"), children: /* @__PURE__ */ jsx(
                  Option,
                  {
                    value: NO_DATA_CHOICE,
                    disabled: detail?.primaryIdColumn === void 0,
                    children: t("join-no-data")
                  }
                ) }),
                OFFERED_JOIN_TYPES.includes(linkType) ? null : /* @__PURE__ */ jsx(Option, { value: String(linkType), children: t(joinTypeKey(linkType)) })
              ]
            }
          ) }),
          joinTypeReturnsColumns(linkType) && showLogicalNames ? /* @__PURE__ */ jsx(
            Tooltip,
            {
              content: aliasDuplicate ? t("join-alias-duplicate") : t("join-alias-help"),
              relationship: "description",
              children: /* @__PURE__ */ jsx(
                Input,
                {
                  className: mergeClasses(
                    styles.rowControl,
                    // Both faults get the same marker: an alias that names nothing and an
                    // alias that names two things are equally unusable, and the tooltip
                    // is what says which one this is.
                    isLinkAliasMissing(link) || aliasDuplicate ? styles.rowIncomplete : void 0
                  ),
                  "aria-label": t("join-alias"),
                  required: true,
                  placeholder: t("join-alias-placeholder"),
                  disabled: readOnly,
                  value: link.alias ?? "",
                  onChange: (_, data) => apply(renameLinkAlias(query, link.id, data.value))
                }
              )
            }
          ) : null,
          readOnly ? null : /* @__PURE__ */ jsx(Tooltip, { content: t("remove-join"), relationship: "label", children: /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "subtle",
              icon: /* @__PURE__ */ jsx(Delete20Regular, {}),
              "aria-label": t("remove-join"),
              onClick: () => apply(removeNode(query, link.id))
            }
          ) })
        ]
      }
    ),
    link.filters.length === 0 ? /* @__PURE__ */ jsx(
      "span",
      {
        className: mergeClasses(
          styles.emptyHint,
          // "Add filter" follows it: the join's line runs past the hint to that branch.
          readOnly ? void 0 : styles.emptyHintContinues
        ),
        children: loading ? t("loading-columns") : noData ? t("join-no-data-hint") : t("join-no-filter")
      }
    ) : null,
    link.filters.length === 0 ? null : /* @__PURE__ */ jsx("div", { className: styles.linkEntityChildren, children: link.filters.map((filter, index) => /* @__PURE__ */ jsx(
      FilterGroup,
      {
        filter,
        columns,
        onUpdateFilter: (id, patch) => apply(updateFilter(query, id, patch)),
        onUpdateCondition: (id, patch) => apply(updateCondition(query, id, patch)),
        onAddCondition: (filterId) => apply(addCondition(query, filterId, createCondition())),
        onAddGroup: (filterId) => (
          // And, matching every other new filter — see the note in the root
          // filters section.
          apply(addFilter(query, filterId, createFilterWithRow()))
        ),
        onAddRelatedEntity: detail === void 0 || detail.relationships.length === 0 ? void 0 : () => setPickerOpen(true),
        onRemoveNode: (id) => apply(removeNode(query, id)),
        onInvertFilter: readOnly ? void 0 : (id) => apply(invertFilterConditions(query, id)),
        renderLinkEntity: renderChild,
        extraChildren: index === 0 ? nested : void 0,
        nested: true
      },
      filter.id
    )) }),
    link.filters.length === 0 && !readOnly ? /* @__PURE__ */ jsx(
      "div",
      {
        className: mergeClasses(
          styles.groupAdd,
          // The join's related tables hang below it, so the line carries on to them.
          link.linkEntities.length > 0 ? styles.groupAddContinues : void 0
        ),
        children: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            size: "small",
            disabled: noData,
            onClick: () => apply(addFilter(query, link.id, createFilterWithRow(LogicalOperator.And))),
            children: t("add-filter")
          }
        )
      }
    ) : null,
    /* @__PURE__ */ jsx(
      RelationshipPickerDialog,
      {
        open: pickerOpen,
        relationships: detail?.relationships ?? [],
        tables,
        sourceColumns: columns,
        onCommit: (relationship2) => {
          setPickerOpen(false);
          apply(
            addLinkEntity(query, link.id, linkEntityFromRelationship(relationship2, aliases))
          );
        },
        onCancel: () => setPickerOpen(false)
      }
    ),
    link.filters.length === 0 && link.linkEntities.length > 0 ? /* @__PURE__ */ jsx("div", { className: styles.groupChildren, children: nested }) : null
  ] });
}
function FetchXmlLoadingOverlay() {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { detailLoading } = useFetchXmlBuilderContext();
  if (!detailLoading) return null;
  return /* @__PURE__ */ jsx("div", { className: styles.loadingScrim, "aria-live": "polite", "aria-busy": "true", children: /* @__PURE__ */ jsx(Spinner, { size: "medium", label: t("loading-metadata") }) });
}
function joinNames(names2) {
  return names2.length === 0 ? void 0 : names2.join(", ");
}
function FetchXmlTableSection({ className, ...shell }) {
  useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { query, entity, apply, tables, selectableTables, tablesLoading, tableLocked, readOnly, showLogicalNames } = useFetchXmlBuilderContext();
  const table = tables.find((candidate) => candidate.logicalName === entity.name);
  const summary = entity.name === "" ? void 0 : table ? nameWithLogicalName(table, showLogicalNames) : entity.name;
  return /* @__PURE__ */ jsx(
    FetchXmlSectionShell,
    {
      markerClass: "ppp-fetch-xml-table-section",
      title: t("table-title"),
      summary,
      className,
      ...shell,
      children: /* @__PURE__ */ jsx(Field, { hint: tableLocked ? t("table-locked-hint") : t("table-hint"), children: /* @__PURE__ */ jsx(
        MetadataPicker,
        {
          value: entity.name,
          disabled: tableLocked || readOnly,
          onChange: (name) => {
            if (name === entity.name) return;
            apply(
              updateEntity(query, entity.id, {
                name,
                attributes: [],
                orders: [],
                filters: [],
                linkEntities: [],
                allAttributes: void 0
              })
            );
          },
          items: selectableTables,
          loading: tablesLoading,
          placeholder: t("table-placeholder"),
          ariaLabel: t("table")
        }
      ) })
    }
  );
}
var GROUP_BY_CHOICE = "group-by";
var AGGREGATE_LABEL_KEYS2 = {
  [AggregateType.None]: "group-by",
  [AggregateType.Count]: "aggregate-count",
  [AggregateType.CountColumn]: "aggregate-count-column",
  [AggregateType.Sum]: "aggregate-sum",
  [AggregateType.Avg]: "aggregate-avg",
  [AggregateType.Min]: "aggregate-min",
  [AggregateType.Max]: "aggregate-max"
};
function aggregateLabelKey(aggregate) {
  return AGGREGATE_LABEL_KEYS2[aggregate] ?? "group-by";
}
var DATE_GROUPINGS2 = [
  { value: DateGrouping.Day, labelKey: "date-grouping-day" },
  { value: DateGrouping.Week, labelKey: "date-grouping-week" },
  { value: DateGrouping.Month, labelKey: "date-grouping-month" },
  { value: DateGrouping.Quarter, labelKey: "date-grouping-quarter" },
  { value: DateGrouping.Year, labelKey: "date-grouping-year" },
  { value: DateGrouping.FiscalPeriod, labelKey: "date-grouping-fiscal-period" },
  { value: DateGrouping.FiscalYear, labelKey: "date-grouping-fiscal-year" }
];
function aggregateChoice(attribute) {
  if (attribute.groupBy === true) return GROUP_BY_CHOICE;
  if (attribute.aggregate === void 0 || attribute.aggregate === AggregateType.None) return "";
  return String(attribute.aggregate);
}
function defaultAliasFor(choice2, columnName) {
  if (choice2 === "" || columnName === "") return void 0;
  if (choice2 === GROUP_BY_CHOICE) return `group_${columnName}`;
  const prefix = aggregateTypeToFetchXml(Number(choice2));
  return prefix === void 0 ? void 0 : `${prefix}_${columnName}`;
}
function uniqueDefaultAlias(base, taken2) {
  if (!taken2.includes(base)) return base;
  for (let suffix = 2; ; suffix += 1) {
    const candidate = `${base}${suffix}`;
    if (!taken2.includes(candidate)) return candidate;
  }
}
function aggregateChoicePatch(choice2, attribute, takenAliases) {
  const alias = (attribute.alias ?? "").trim();
  const wasDefaulted = alias === "" || alias === defaultAliasFor(aggregateChoice(attribute), attribute.name);
  const suggestion = defaultAliasFor(choice2, attribute.name);
  const aliasPatch = wasDefaulted && suggestion !== void 0 ? { alias: uniqueDefaultAlias(suggestion, takenAliases) } : {};
  if (choice2 === GROUP_BY_CHOICE) {
    return { groupBy: true, aggregate: void 0, distinct: void 0, ...aliasPatch };
  }
  return {
    groupBy: void 0,
    aggregate: Number(choice2),
    dateGrouping: void 0,
    userTimeZone: void 0,
    ...Number(choice2) === AggregateType.CountColumn ? {} : { distinct: void 0 },
    ...aliasPatch
  };
}
function FetchXmlColumnsSection({ className, ...shell }) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { query, entity, apply, columnSources, detailLoading, readOnly, allowAggregate, showLogicalNames } = useFetchXmlBuilderContext();
  const [dialogOpen, setDialogOpen] = useState(false);
  const aggregating = query.aggregate === true;
  const projected = useMemo(
    () => columnSources.flatMap((source) => {
      const owner = getAllEntities(query).find((candidate) => candidate.id === source.entityId);
      return (owner?.attributes ?? []).map((attribute) => ({ source, attribute }));
    }),
    [columnSources, query]
  );
  const duplicateAliases = useMemo(
    () => getDuplicateColumnAliases(projected.map(({ attribute }) => attribute)),
    [projected]
  );
  const projectedKeys = useMemo(
    () => projected.map(({ source, attribute }) => columnSourceKey(source.alias, attribute.name)),
    [projected]
  );
  useEffect(() => {
    if (readOnly) setDialogOpen(false);
  }, [readOnly]);
  const commitColumns = useCallback(
    (keys) => {
      const chosen = new Set(keys);
      const byAlias = /* @__PURE__ */ new Map();
      for (const key3 of chosen) {
        const { alias, logicalName } = parseColumnSourceKey(key3);
        const existing = byAlias.get(alias);
        if (existing === void 0) byAlias.set(alias, /* @__PURE__ */ new Set([logicalName]));
        else existing.add(logicalName);
      }
      let next = query;
      for (const source of columnSources) {
        const wanted = byAlias.get(source.alias) ?? /* @__PURE__ */ new Set();
        const owner = getAllEntities(next).find((candidate) => candidate.id === source.entityId);
        if (owner === void 0) continue;
        const kept = owner.attributes.filter((attribute) => wanted.has(attribute.name));
        const keptNames = new Set(kept.map((attribute) => attribute.name));
        const added = [...wanted].filter((name) => !keptNames.has(name)).map((name) => createAttribute(name));
        if (kept.length === owner.attributes.length && added.length === 0) continue;
        next = updateEntity(next, source.entityId, {
          attributes: [...kept, ...added],
          // Explicit columns and <all-attributes /> are mutually exclusive, and
          // choosing columns is the clearer statement of intent.
          allAttributes: void 0
        });
      }
      setDialogOpen(false);
      apply(next);
    },
    [apply, columnSources, query]
  );
  const summary = entity.allAttributes === true ? t("all-columns") : joinNames(
    projected.map(({ source, attribute }) => {
      const match = source.columns.find(
        (column) => column.logicalName === attribute.name
      );
      const label = match ? metadataLabel(match) : attribute.name;
      return source.alias === "" ? label : showLogicalNames ? `${label} (${source.alias})` : `${label} \u2014 ${source.label}`;
    })
  );
  return /* @__PURE__ */ jsxs(
    FetchXmlSectionShell,
    {
      markerClass: "ppp-fetch-xml-columns-section",
      title: t("columns-title"),
      summary,
      className,
      ...shell,
      actions: readOnly ? null : /* @__PURE__ */ jsxs("div", { className: styles.headerActions, children: [
        allowAggregate ? /* @__PURE__ */ jsx(Tooltip, { content: t("aggregate-hint"), relationship: "description", children: /* @__PURE__ */ jsx(
          Checkbox,
          {
            label: t("aggregate"),
            disabled: readOnly,
            checked: aggregating,
            onChange: (_, data) => apply(
              updateQuery(query, {
                aggregate: data.checked === true ? true : void 0,
                // The limit only means anything on an aggregate query, and
                // left behind it would serialize onto one that isn't.
                ...data.checked === true ? {} : { aggregateLimit: void 0 }
              })
            )
          }
        ) }) : null,
        /* @__PURE__ */ jsx(
          Checkbox,
          {
            label: t("all-columns"),
            disabled: readOnly || aggregating,
            checked: entity.allAttributes === true,
            onChange: (_, data) => apply(
              updateEntity(query, entity.id, {
                allAttributes: data.checked === true ? true : void 0,
                ...data.checked === true ? { attributes: [] } : {}
              })
            )
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: projected.length === 0 ? /* @__PURE__ */ jsx(Add20Regular, {}) : /* @__PURE__ */ jsx(Edit20Regular, {}),
            disabled: entity.name === "" || entity.allAttributes === true,
            onClick: () => setDialogOpen(true),
            children: projected.length === 0 ? t("add-column") : t("edit-columns")
          }
        )
      ] }),
      children: [
        entity.allAttributes === true ? /* @__PURE__ */ jsx("span", { className: styles.emptyHint, children: t("all-columns-hint") }) : entity.name === "" ? /* @__PURE__ */ jsx("span", { className: styles.emptyHint, children: t("columns-need-table") }) : projected.length === 0 ? /* @__PURE__ */ jsx("span", { className: styles.emptyHint, children: t("columns-empty") }) : projected.map(({ source, attribute }) => /* @__PURE__ */ jsxs("div", { className: styles.row, children: [
          /* @__PURE__ */ jsx(
            ColumnLabel,
            {
              className: styles.rowControlFlexible,
              columns: source.columns,
              logicalName: attribute.name,
              ...source.alias === "" ? {} : { qualifier: source.alias }
            }
          ),
          aggregating ? /* @__PURE__ */ jsx(
            AggregateColumnControls,
            {
              attribute,
              column: findColumn(source.columns, attribute.name),
              takenAliases: projected.filter((other) => other.attribute.id !== attribute.id).map((other) => (other.attribute.alias ?? "").trim()).filter((alias) => alias !== ""),
              disabled: readOnly,
              onChange: (patch) => apply(updateAttribute(query, attribute.id, patch))
            }
          ) : null,
          /* @__PURE__ */ jsx(
            Tooltip,
            {
              content: duplicateAliases.has((attribute.alias ?? "").trim()) ? t("column-alias-duplicate") : t("column-alias-hint"),
              relationship: "description",
              children: /* @__PURE__ */ jsx(
                Input,
                {
                  className: mergeClasses(
                    styles.rowControl,
                    // Two faults, one marker. An aggregate query returns its values
                    // under these names and has no column name to fall back on, so a
                    // blank one is unfinished; and a name two columns share cannot
                    // return both of them. The tooltip says which.
                    hasBadColumnAlias(attribute, aggregating, duplicateAliases) ? styles.rowIncomplete : void 0
                  ),
                  value: attribute.alias ?? "",
                  placeholder: aggregating ? t("alias-required") : t("alias-placeholder"),
                  "aria-label": t("column-alias"),
                  disabled: readOnly,
                  onChange: (_, data) => apply(
                    updateAttribute(query, attribute.id, {
                      alias: data.value === "" ? void 0 : data.value
                    })
                  )
                }
              )
            }
          ),
          readOnly ? null : /* @__PURE__ */ jsx("div", { className: styles.rowActions, children: /* @__PURE__ */ jsx(Tooltip, { content: t("remove-column"), relationship: "label", children: /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "subtle",
              icon: /* @__PURE__ */ jsx(Delete20Regular, {}),
              "aria-label": t("remove-column"),
              onClick: () => apply(removeNode(query, attribute.id))
            }
          ) }) })
        ] }, attribute.id)),
        /* @__PURE__ */ jsx(
          ColumnSelectDialog,
          {
            open: dialogOpen,
            sources: columnSources,
            loading: detailLoading,
            selected: projectedKeys,
            onCommit: commitColumns,
            onCancel: () => setDialogOpen(false)
          }
        )
      ]
    }
  );
}
function ColumnLabel({
  columns,
  logicalName,
  qualifier,
  className
}) {
  const styles = useFetchXmlBuilderStyles();
  const showLogicalNames = useShowLogicalNames();
  const match = columns.find((column) => column.logicalName === logicalName);
  const display = match ? metadataLabel(match) : logicalName;
  const qualified = qualifier === void 0 || qualifier === "" ? logicalName : `${qualifier}.${logicalName}`;
  if (match && !showLogicalNames) {
    return /* @__PURE__ */ jsx("span", { className: mergeClasses(styles.columnLabel, className), "data-ppp-tooltip": display, children: /* @__PURE__ */ jsx("span", { className: styles.columnLabelName, children: display }) });
  }
  return /* @__PURE__ */ jsxs(
    "span",
    {
      className: mergeClasses(styles.columnLabel, className),
      "data-ppp-tooltip": match ? `${display} (${qualified})` : qualified,
      children: [
        /* @__PURE__ */ jsx("span", { className: styles.columnLabelName, children: display }),
        match ? /* @__PURE__ */ jsxs("span", { className: styles.columnLabelLogical, children: [
          "(",
          qualified,
          ")"
        ] }) : null
      ]
    }
  );
}
function FetchXmlFilterSection({ className, ...shell }) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const {
    query,
    entity,
    apply,
    columns,
    columnSources,
    relationships,
    tables,
    aliases,
    metadata,
    readOnly
  } = useFetchXmlBuilderContext();
  const [relationshipPickerOpen, setRelationshipPickerOpen] = useState(false);
  const findFilterId = findColumnsFilter(entity)?.id;
  const filters = useMemo(
    () => entity.filters.filter((filter) => filter.id !== findFilterId),
    [entity.filters, findFilterId]
  );
  const renderLink = useCallback(
    (link) => /* @__PURE__ */ jsx(LinkEntityEditor, { link, sourceColumns: columns, sourceRelationships: relationships }),
    [columns, relationships]
  );
  const links = entity.linkEntities.map((link) => /* @__PURE__ */ jsx(Fragment$1, { children: renderLink(link) }, link.id));
  const unionHintTaken = useMemo(() => hasUnionFilterHint(query), [query]);
  const [viewPickerOpen, setViewPickerOpen] = useState(false);
  const [views, setViews] = useState(EMPTY_VIEWS);
  const [viewsLoading, setViewsLoading] = useState(false);
  useEffect(() => {
    const load = metadata.getViews;
    if (!viewPickerOpen || load === void 0 || entity.name === "") return;
    let current = true;
    setViewsLoading(true);
    void load.call(metadata, entity.name).then((loaded) => {
      if (current) setViews(loaded);
    }).catch(() => {
      if (current) setViews(EMPTY_VIEWS);
    }).finally(() => {
      if (current) setViewsLoading(false);
    });
    return () => {
      current = false;
    };
  }, [viewPickerOpen, metadata, entity.name]);
  const toggleUnionHint = useCallback(
    (filterId) => {
      apply(
        transformQuery(query, {
          filter: (candidate) => candidate.id === filterId ? {
            ...candidate,
            hint: candidate.hint === UNION_FILTER_HINT ? void 0 : UNION_FILTER_HINT
          } : candidate
        })
      );
    },
    [apply, query]
  );
  const handleUpdateFilter = useCallback(
    (id, patch) => apply(updateFilter(query, id, patch)),
    [apply, query]
  );
  const handleUpdateCondition = useCallback(
    (id, patch) => apply(updateCondition(query, id, patch)),
    [apply, query]
  );
  const handleAddCondition = useCallback(
    (filterId) => apply(addCondition(query, filterId, createCondition())),
    [apply, query]
  );
  const handleAddGroup = useCallback(
    (filterId) => apply(addFilter(query, filterId, createFilterWithRow())),
    [apply, query]
  );
  const handleInvertFilter = useCallback(
    (id) => apply(invertFilterConditions(query, id)),
    [apply, query]
  );
  const handleRemoveNode = useCallback(
    (id) => {
      let next = removeNode(query, id);
      const searched = findColumns(entity);
      if (searched.length > 0 && findColumnsFilter(next.entity) === void 0) {
        next = setFindColumns(next, searched);
      }
      const isRootFilter = entity.filters.some((filter) => filter.id === id);
      apply(isRootFilter ? updateEntity(next, entity.id, { linkEntities: [] }) : next);
    },
    [apply, entity, query]
  );
  const summary = joinNames(
    distinctFilterColumns(filters, findFilterId).map((name) => {
      const match = columns.find((column) => column.logicalName === name);
      return match ? metadataLabel(match) : name;
    })
  );
  return /* @__PURE__ */ jsxs(
    FetchXmlSectionShell,
    {
      markerClass: "ppp-fetch-xml-filter-section",
      title: t("filters-title"),
      summary,
      className,
      ...shell,
      actions: /* @__PURE__ */ jsxs("div", { className: styles.headerActions, children: [
        readOnly || metadata.getViews === void 0 || entity.name === "" ? null : /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(DocumentTable20Regular, {}),
            onClick: () => setViewPickerOpen(true),
            children: t("select-view")
          }
        ),
        readOnly || filters.length > 0 ? null : /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(Add20Regular, {}),
            disabled: entity.name === "",
            onClick: () => apply(addFilter(query, entity.id, createFilterWithRow(LogicalOperator.And))),
            children: t("add-filter")
          }
        ),
        readOnly || filters.length > 0 || relationships.length === 0 ? null : /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(Link20Regular, {}),
            disabled: entity.name === "",
            onClick: () => setRelationshipPickerOpen(true),
            children: t("add-related-entity")
          }
        )
      ] }),
      children: [
        /* @__PURE__ */ jsx(
          ViewPickerDialog,
          {
            open: viewPickerOpen,
            views,
            loading: viewsLoading,
            onCommit: (view) => {
              setViewPickerOpen(false);
              const result = readFetchXml(view.fetchXml, void 0);
              if (result.query !== void 0) apply(result.query);
            },
            onCancel: () => setViewPickerOpen(false)
          }
        ),
        filters.length === 0 && links.length === 0 ? /* @__PURE__ */ jsx("span", { className: styles.emptyHint, children: t("filters-empty") }) : filters.length === 0 ? null : filters.map((filter, index) => /* @__PURE__ */ jsx(
          FilterGroup,
          {
            filter,
            columns,
            sources: columnSources,
            onToggleUnionHint: readOnly ? void 0 : toggleUnionHint,
            unionHintTaken,
            onUpdateFilter: handleUpdateFilter,
            onUpdateCondition: handleUpdateCondition,
            onAddCondition: handleAddCondition,
            onAddGroup: handleAddGroup,
            onAddRelatedEntity: readOnly || relationships.length === 0 ? void 0 : () => setRelationshipPickerOpen(true),
            onRemoveNode: handleRemoveNode,
            onInvertFilter: readOnly ? void 0 : handleInvertFilter,
            hiddenFilterId: findFilterId,
            renderLinkEntity: renderLink,
            extraChildren: index === 0 ? links : void 0
          },
          filter.id
        )),
        filters.length === 0 ? links : null,
        /* @__PURE__ */ jsx(
          RelationshipPickerDialog,
          {
            open: relationshipPickerOpen,
            relationships,
            tables,
            sourceColumns: columns,
            onCommit: (relationship) => {
              setRelationshipPickerOpen(false);
              apply(
                addLinkEntity(query, entity.id, linkEntityFromRelationship(relationship, aliases))
              );
            },
            onCancel: () => setRelationshipPickerOpen(false)
          }
        )
      ]
    }
  );
}
function distinctFilterColumns(filters, hiddenFilterId) {
  const seen = /* @__PURE__ */ new Set();
  const visit = (filter) => {
    for (const condition of filter.conditions) {
      if (condition.attribute !== void 0 && condition.attribute !== "") {
        seen.add(condition.attribute);
      }
    }
    for (const nested of filter.filters) {
      if (nested.id !== hiddenFilterId) visit(nested);
    }
  };
  for (const filter of filters) visit(filter);
  return [...seen];
}
function SortColumnLabel({
  order,
  sources,
  className
}) {
  const source = findColumnSource(sources, order.entityName);
  return /* @__PURE__ */ jsx(
    ColumnLabel,
    {
      className,
      columns: source?.columns ?? [],
      logicalName: order.attribute ?? "",
      ...source === void 0 || source.alias === "" ? {} : { qualifier: source.alias }
    }
  );
}
function AggregateColumnControls({
  attribute,
  column,
  takenAliases,
  disabled,
  onChange
}) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const choice2 = aggregateChoice(attribute);
  const grouped = attribute.groupBy === true;
  const offered = useMemo(() => {
    const allowed = aggregateTypesForColumn(column?.type);
    const current = attribute.aggregate;
    return current === void 0 || current === AggregateType.None || allowed.includes(current) ? allowed : [...allowed, current];
  }, [column?.type, attribute.aggregate]);
  const label = choice2 === "" ? "" : choice2 === GROUP_BY_CHOICE ? t("group-by") : t(aggregateLabelKey(Number(choice2)));
  const datePart = grouped && column?.type === ColumnType.DateTime;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Dropdown,
      {
        className: styles.aggregateFunctionControl,
        "aria-label": t("aggregate-function"),
        placeholder: t("aggregate-function"),
        disabled,
        value: label,
        selectedOptions: [choice2],
        onOptionSelect: (_, data) => onChange(aggregateChoicePatch(data.optionValue ?? "", attribute, takenAliases)),
        children: [
          /* @__PURE__ */ jsx(Option, { value: GROUP_BY_CHOICE, children: t("group-by") }),
          offered.map((value2) => /* @__PURE__ */ jsx(Option, { value: String(value2), children: t(aggregateLabelKey(value2)) }, value2))
        ]
      }
    ),
    datePart ? /* @__PURE__ */ jsxs(
      Dropdown,
      {
        className: styles.dateGroupingControl,
        "aria-label": t("date-grouping"),
        disabled,
        value: attribute.dateGrouping === void 0 ? t("date-grouping-none") : t(
          DATE_GROUPINGS2.find(
            (candidate) => candidate.value === attribute.dateGrouping
          )?.labelKey ?? "date-grouping-none"
        ),
        selectedOptions: [String(attribute.dateGrouping ?? "")],
        onOptionSelect: (_, data) => onChange({
          dateGrouping: data.optionValue === "" ? void 0 : Number(data.optionValue),
          // The time zone only decides which bucket a moment falls in, so it
          // goes with the bucketing.
          ...data.optionValue === "" ? { userTimeZone: void 0 } : {}
        }),
        children: [
          /* @__PURE__ */ jsx(Option, { value: "", children: t("date-grouping-none") }),
          DATE_GROUPINGS2.map((bucket) => /* @__PURE__ */ jsx(Option, { value: String(bucket.value), children: t(bucket.labelKey) }, bucket.value))
        ]
      }
    ) : null,
    datePart && attribute.dateGrouping !== void 0 ? /* @__PURE__ */ jsx(Tooltip, { content: t("date-grouping-utc-hint"), relationship: "description", children: /* @__PURE__ */ jsx(
      Checkbox,
      {
        label: t("date-grouping-utc"),
        disabled,
        checked: attribute.userTimeZone === false,
        onChange: (_, data) => onChange({ userTimeZone: data.checked === true ? false : void 0 })
      }
    ) }) : null,
    attribute.aggregate === AggregateType.CountColumn ? /* @__PURE__ */ jsx(Tooltip, { content: t("aggregate-distinct-hint"), relationship: "description", children: /* @__PURE__ */ jsx(
      Checkbox,
      {
        label: t("aggregate-distinct"),
        disabled,
        checked: attribute.distinct === true,
        onChange: (_, data) => onChange({ distinct: data.checked === true ? true : void 0 })
      }
    ) }) : null
  ] });
}
function toRunnableQuery(fetchXml, query) {
  if (query.entity.name === "") return void 0;
  const columns = getAllEntities(query).flatMap((entity) => entity.attributes).map((attribute) => (attribute.alias ?? "").trim() || attribute.name).filter((name) => name !== "");
  if (columns.length === 0) return void 0;
  const runnable = findColumnsFilter(query.entity) === void 0 ? fetchXml : toFetchXml(setFindColumns(query, []));
  return { fetchXml: runnable, tableName: query.entity.name, columns };
}
function FetchXmlResultsSection({
  renderResults,
  className,
  ...shell
}) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { query, fetchXml, columnSources, readOnly } = useFetchXmlBuilderContext();
  const [running, setRunning] = useState(void 0);
  const runnable = useMemo(() => toRunnableQuery(fetchXml, query), [fetchXml, query]);
  const unresolved = useMemo(
    () => !readOnly && hasUnresolvedFields(query, columnSources),
    [readOnly, query, columnSources]
  );
  const canRun = runnable !== void 0 && !unresolved;
  return /* @__PURE__ */ jsxs(
    FetchXmlSectionShell,
    {
      markerClass: "ppp-fetch-xml-results-section",
      title: t("results-title"),
      className,
      ...shell,
      actions: /* @__PURE__ */ jsxs("div", { className: styles.headerActions, children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "primary",
            icon: /* @__PURE__ */ jsx(Play20Regular, {}),
            disabled: !canRun,
            onClick: () => {
              if (canRun) setRunning(runnable);
            },
            children: t("run-query")
          }
        ),
        running === void 0 ? null : /* @__PURE__ */ jsx(Button, { appearance: "subtle", onClick: () => setRunning(void 0), children: t("clear-results") })
      ] }),
      children: [
        runnable === void 0 ? /* @__PURE__ */ jsx("span", { className: styles.emptyHint, children: t("results-need-columns") }) : unresolved ? /* @__PURE__ */ jsx("span", { className: styles.emptyHint, children: t("results-need-fixes") }) : null,
        running === void 0 ? null : renderResults(running)
      ]
    }
  );
}
function FetchXmlSortSection({ className, ...shell }) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { query, entity, apply, columnSources, detailLoading, readOnly, showLogicalNames } = useFetchXmlBuilderContext();
  const [dialogOpen, setDialogOpen] = useState(false);
  const aggregating = query.aggregate === true;
  const sortableAliases = useMemo(
    () => getAllEntities(query).flatMap((candidate) => candidate.attributes).map((attribute) => (attribute.alias ?? "").trim()).filter((alias) => alias !== ""),
    [query]
  );
  const orderKey = useCallback(
    (order) => columnSourceKey((order.entityName ?? "").trim(), order.attribute ?? ""),
    []
  );
  const sortedKeys = useMemo(
    () => entity.orders.map(orderKey),
    [entity.orders, orderKey]
  );
  const commitSorts = useCallback(
    (keys) => {
      const chosen = new Set(keys);
      const kept = entity.orders.filter((order) => chosen.has(orderKey(order)));
      const keptKeys = new Set(kept.map(orderKey));
      const added = keys.filter((key3) => !keptKeys.has(key3)).map((key3) => {
        const { alias, logicalName } = parseColumnSourceKey(key3);
        return {
          ...createOrder(logicalName),
          // A joined column is sorted from the root entity carrying the join's
          // alias — an order nested in the join would be applied after every
          // root order whatever this list showed.
          ...alias === "" ? {} : { entityName: alias }
        };
      });
      setDialogOpen(false);
      apply(updateEntity(query, entity.id, { orders: [...kept, ...added] }));
    },
    [apply, entity.id, entity.orders, orderKey, query]
  );
  const summary = joinNames(
    entity.orders.filter((order) => order.attribute !== void 0 && order.attribute !== "").map((order) => {
      const source = findColumnSource(columnSources, order.entityName);
      const match = source?.columns.find(
        (column) => column.logicalName === order.attribute
      );
      const label = match ? metadataLabel(match) : order.attribute ?? "";
      const qualified = source === void 0 || source.alias === "" ? label : showLogicalNames ? `${label} (${source.alias})` : `${label} \u2014 ${source.label}`;
      return `${qualified} ${order.descending === true ? "\u2193" : "\u2191"}`;
    })
  );
  return /* @__PURE__ */ jsxs(
    FetchXmlSectionShell,
    {
      markerClass: "ppp-fetch-xml-sort-section",
      title: t("sorts-title"),
      summary,
      className,
      ...shell,
      actions: readOnly ? null : aggregating ? (
        // No dialog: the choices are this query's own aliases, a short list that
        // changes as the columns do, so a row with a dropdown is the whole of it.
        /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(Add20Regular, {}),
            disabled: sortableAliases.length === 0,
            onClick: () => apply(addOrder(query, entity.id, { ...createOrder(), alias: "" })),
            children: t("add-sort")
          }
        )
      ) : /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: entity.orders.length === 0 ? /* @__PURE__ */ jsx(Add20Regular, {}) : /* @__PURE__ */ jsx(Edit20Regular, {}),
          disabled: entity.name === "",
          onClick: () => setDialogOpen(true),
          children: entity.orders.length === 0 ? t("add-sort") : t("edit-sorts")
        }
      ),
      children: [
        /* @__PURE__ */ jsx(
          ColumnSelectDialog,
          {
            open: dialogOpen && !aggregating,
            sources: columnSources,
            loading: detailLoading,
            selected: sortedKeys,
            title: t("select-sorts-title"),
            onCommit: commitSorts,
            onCancel: () => setDialogOpen(false)
          }
        ),
        entity.orders.length === 0 ? /* @__PURE__ */ jsx("span", { className: styles.emptyHint, children: t("sorts-empty") }) : entity.orders.map((order, index) => /* @__PURE__ */ jsxs("div", { className: styles.row, children: [
          aggregating ? /* @__PURE__ */ jsxs(
            Dropdown,
            {
              className: styles.rowControlFlexible,
              "aria-label": t("sort-alias"),
              placeholder: t("sort-alias"),
              disabled: readOnly,
              value: (order.alias ?? "").trim(),
              selectedOptions: [(order.alias ?? "").trim()],
              onOptionSelect: (_, data) => apply(
                updateOrder(query, order.id, {
                  alias: data.optionValue ?? "",
                  // The two are mutually exclusive in the document; a sort that
                  // names an alias must not also name a column.
                  attribute: void 0,
                  entityName: void 0
                })
              ),
              children: [
                sortableAliases.map((alias) => /* @__PURE__ */ jsx(Option, { value: alias, children: alias }, alias)),
                (order.alias ?? "").trim() !== "" && !sortableAliases.includes((order.alias ?? "").trim()) ? /* @__PURE__ */ jsx(Option, { value: (order.alias ?? "").trim(), children: (order.alias ?? "").trim() }) : null
              ]
            }
          ) : (
            /* Chosen in the dialog, so the row shows what was chosen and edits
               only what the dialog cannot express — the direction, and where the
               sort sits in the order. */
            /* @__PURE__ */ jsx(
              SortColumnLabel,
              {
                className: styles.rowControlFlexible,
                order,
                sources: columnSources
              }
            )
          ),
          /* @__PURE__ */ jsxs(
            Dropdown,
            {
              className: styles.rowControl,
              "aria-label": t("sort-direction"),
              disabled: readOnly,
              value: order.descending === true ? t("sort-descending") : t("sort-ascending"),
              selectedOptions: [order.descending === true ? "desc" : "asc"],
              onOptionSelect: (_, data) => apply(updateOrder(query, order.id, { descending: data.optionValue === "desc" })),
              children: [
                /* @__PURE__ */ jsx(Option, { value: "asc", children: t("sort-ascending") }),
                /* @__PURE__ */ jsx(Option, { value: "desc", children: t("sort-descending") })
              ]
            }
          ),
          readOnly ? null : /* @__PURE__ */ jsxs("div", { className: styles.rowActions, children: [
            /* @__PURE__ */ jsx(Tooltip, { content: t("move-up"), relationship: "label", children: /* @__PURE__ */ jsx(
              Button,
              {
                appearance: "subtle",
                icon: /* @__PURE__ */ jsx(ArrowUp20Regular, {}),
                "aria-label": t("move-up"),
                disabled: index === 0,
                onClick: () => apply(moveOrder(query, entity.id, index, index - 1))
              }
            ) }),
            /* @__PURE__ */ jsx(Tooltip, { content: t("move-down"), relationship: "label", children: /* @__PURE__ */ jsx(
              Button,
              {
                appearance: "subtle",
                icon: /* @__PURE__ */ jsx(ArrowDown20Regular, {}),
                "aria-label": t("move-down"),
                disabled: index === entity.orders.length - 1,
                onClick: () => apply(moveOrder(query, entity.id, index, index + 1))
              }
            ) }),
            /* @__PURE__ */ jsx(Tooltip, { content: t("remove-sort"), relationship: "label", children: /* @__PURE__ */ jsx(
              Button,
              {
                appearance: "subtle",
                icon: /* @__PURE__ */ jsx(Delete20Regular, {}),
                "aria-label": t("remove-sort"),
                onClick: () => apply(removeNode(query, order.id))
              }
            ) })
          ] })
        ] }, order.id))
      ]
    }
  );
}
function FetchXmlFindColumnsSection({ className, ...shell }) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { query, entity, apply, columns, columnSources, detailLoading, readOnly } = useFetchXmlBuilderContext();
  const [dialogOpen, setDialogOpen] = useState(false);
  const searched = useMemo(() => findColumns(entity), [entity]);
  const ownSource = useMemo(
    () => columnSources.filter((source) => source.alias === ""),
    [columnSources]
  );
  const labelOf = useCallback(
    (name) => {
      const match = columns.find((column) => column.logicalName === name);
      return match ? metadataLabel(match) : name;
    },
    [columns]
  );
  const commit = useCallback(
    (keys) => {
      const chosen = keys.map((key3) => parseColumnSourceKey(key3).logicalName);
      const wanted = new Set(chosen.map((x) => x.toLowerCase()));
      const kept = searched.filter((x) => wanted.has(x.toLowerCase()));
      const keptKeys = new Set(kept.map((x) => x.toLowerCase()));
      setDialogOpen(false);
      apply(
        setFindColumns(query, [...kept, ...chosen.filter((x) => !keptKeys.has(x.toLowerCase()))])
      );
    },
    [apply, query, searched]
  );
  return /* @__PURE__ */ jsxs(
    FetchXmlSectionShell,
    {
      markerClass: "ppp-fetch-xml-find-columns-section",
      title: t("find-columns-title"),
      summary: joinNames(searched.map(labelOf)),
      className,
      ...shell,
      actions: readOnly ? null : /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: searched.length === 0 ? /* @__PURE__ */ jsx(Add20Regular, {}) : /* @__PURE__ */ jsx(Edit20Regular, {}),
          disabled: entity.name === "",
          onClick: () => setDialogOpen(true),
          children: t("edit-find-columns")
        }
      ),
      children: [
        /* @__PURE__ */ jsx(
          ColumnSelectDialog,
          {
            open: dialogOpen,
            sources: ownSource,
            loading: detailLoading,
            selected: searched,
            title: t("select-find-columns-title"),
            onCommit: commit,
            onCancel: () => setDialogOpen(false)
          }
        ),
        entity.name === "" ? /* @__PURE__ */ jsx("span", { className: styles.emptyHint, children: t("columns-need-table") }) : searched.length === 0 ? /* @__PURE__ */ jsx("span", { className: styles.emptyHint, children: t("find-columns-empty") }) : searched.map((name) => /* @__PURE__ */ jsxs("div", { className: styles.row, children: [
          /* @__PURE__ */ jsx("span", { className: styles.rowControlFlexible, children: labelOf(name) }),
          readOnly ? null : /* @__PURE__ */ jsx("div", { className: styles.rowActions, children: /* @__PURE__ */ jsx(Tooltip, { content: t("remove-find-column"), relationship: "label", children: /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "subtle",
              icon: /* @__PURE__ */ jsx(Delete20Regular, {}),
              "aria-label": t("remove-find-column"),
              onClick: () => apply(
                setFindColumns(
                  query,
                  searched.filter((x) => x.toLowerCase() !== name.toLowerCase())
                )
              )
            }
          ) }) })
        ] }, name))
      ]
    }
  );
}
var QUERY_HINTS = [
  "ForceOrder",
  "DisableRowGoal",
  "EnableOptimizerHotfixes",
  "LoopJoin",
  "MergeJoin",
  "HashJoin",
  "NO_PERFORMANCE_SPOOL",
  "ENABLE_HIST_AMENDMENT_FOR_ASC_KEYS"
];
function parseQueryHints(options) {
  return (options ?? "").split(",").map((hint) => hint.trim()).filter((hint) => hint !== "");
}
function FetchXmlOptionsSection({ className, ...shell }) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { query, apply, readOnly } = useFetchXmlBuilderContext();
  return /* @__PURE__ */ jsx(
    FetchXmlSectionShell,
    {
      markerClass: "ppp-fetch-xml-options-section",
      title: t("options-title"),
      className,
      ...shell,
      children: /* @__PURE__ */ jsxs("div", { className: styles.optionsGrid, children: [
        /* @__PURE__ */ jsx(Field, { label: t("top"), hint: t("top-hint"), children: /* @__PURE__ */ jsx(
          Input,
          {
            className: styles.rowControlNarrow,
            type: "number",
            min: 1,
            disabled: readOnly,
            value: query.top === void 0 ? "" : String(query.top),
            onChange: (_, data) => {
              const parsed = Number.parseInt(data.value, 10);
              apply(
                updateQuery(query, {
                  top: data.value === "" || Number.isNaN(parsed) ? void 0 : parsed
                })
              );
            }
          }
        ) }),
        query.aggregate === true ? /* @__PURE__ */ jsx(Field, { label: t("aggregate-limit"), hint: t("aggregate-limit-hint"), children: /* @__PURE__ */ jsx(
          Input,
          {
            className: styles.rowControlNarrow,
            type: "number",
            min: 1,
            max: 5e4,
            disabled: readOnly,
            value: query.aggregateLimit === void 0 ? "" : String(query.aggregateLimit),
            onChange: (_, data) => {
              const parsed = Number.parseInt(data.value, 10);
              apply(
                updateQuery(query, {
                  aggregateLimit: data.value === "" || Number.isNaN(parsed) ? void 0 : parsed
                })
              );
            }
          }
        ) }) : null,
        /* @__PURE__ */ jsx(
          Checkbox,
          {
            label: t("distinct"),
            disabled: readOnly,
            checked: query.distinct === true,
            onChange: (_, data) => apply(updateQuery(query, { distinct: data.checked === true ? true : void 0 }))
          }
        ),
        /* @__PURE__ */ jsx(Field, { hint: t("return-total-record-count-hint"), children: /* @__PURE__ */ jsx(
          Checkbox,
          {
            label: t("return-total-record-count"),
            disabled: readOnly,
            checked: query.returnTotalRecordCount === true,
            onChange: (_, data) => apply(
              updateQuery(query, {
                // Back to absent rather than `false`, so switching it off leaves
                // the query serializing exactly as one that never set it.
                returnTotalRecordCount: data.checked === true ? true : void 0
              })
            )
          }
        ) }),
        /* @__PURE__ */ jsx(Field, { hint: t("late-materialize-hint"), children: /* @__PURE__ */ jsx(
          Checkbox,
          {
            label: t("late-materialize"),
            disabled: readOnly,
            checked: query.lateMaterialize === true,
            onChange: (_, data) => apply(
              updateQuery(query, {
                lateMaterialize: data.checked === true ? true : void 0
              })
            )
          }
        ) }),
        /* @__PURE__ */ jsx(Field, { label: t("query-hints"), hint: t("query-hints-hint"), children: /* @__PURE__ */ jsx(
          Dropdown,
          {
            className: styles.rowControlWide,
            multiselect: true,
            disabled: readOnly,
            value: parseQueryHints(query.options).join(", "),
            selectedOptions: parseQueryHints(query.options),
            onOptionSelect: (_, data) => apply(
              updateQuery(query, {
                // Back to absent when the last one comes off, so a query that
                // never had hints serializes exactly as it did before.
                options: data.selectedOptions.length > 0 ? data.selectedOptions.join(",") : void 0
              })
            ),
            children: QUERY_HINTS.map((hint) => /* @__PURE__ */ jsx(Option, { value: hint, children: hint }, hint))
          }
        ) })
      ] })
    }
  );
}
var PARSE_DEBOUNCE_MS = 1e3;
var EMPTY_VIEWS = [];
var NO_PROBLEMS2 = [];
function FetchXmlPreviewSection({ className, ...shell }) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { fetchXml, apply, readOnly } = useFetchXmlBuilderContext();
  const [copied, setCopied] = useState(false);
  const [draft, setDraft] = useState(void 0);
  const [problems, setProblems] = useState(NO_PROBLEMS2);
  const [malformed, setMalformed] = useState(void 0);
  const lastApplied = useRef(void 0);
  useEffect(() => {
    if (fetchXml === lastApplied.current) return;
    setDraft(void 0);
    setProblems(NO_PROBLEMS2);
    setMalformed(void 0);
  }, [fetchXml]);
  const read2 = useCallback(
    (source) => {
      if (source.trim() === "") {
        setProblems(NO_PROBLEMS2);
        setMalformed(void 0);
        return;
      }
      const result = readFetchXml(source, void 0);
      setMalformed(result.parseError);
      setProblems(result.problems);
      if (result.query === void 0) return;
      lastApplied.current = toFetchXml(result.query);
      apply(result.query);
    },
    [apply]
  );
  useEffect(() => {
    if (draft === void 0) return;
    const timer = setTimeout(() => read2(draft), PARSE_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [draft, read2]);
  const text2 = draft ?? fetchXml;
  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 2e3);
    return () => clearTimeout(timer);
  }, [copied]);
  const copy = useCallback(() => {
    void navigator.clipboard?.writeText(text2).then(
      () => setCopied(true),
      () => setCopied(false)
    );
  }, [text2]);
  return /* @__PURE__ */ jsxs(
    FetchXmlSectionShell,
    {
      markerClass: "ppp-fetch-xml-preview",
      title: t("preview-title"),
      className: mergeClasses(styles.previewSection, className),
      ...shell,
      actions: /* @__PURE__ */ jsx(Button, { appearance: "subtle", icon: /* @__PURE__ */ jsx(Copy20Regular, {}), onClick: copy, children: copied ? t("copied") : t("copy") }),
      children: [
        readOnly ? /* @__PURE__ */ jsx("pre", { className: styles.preview, children: text2 }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("span", { className: styles.emptyHint, children: t("preview-hint") }),
          /* @__PURE__ */ jsx(
            Textarea,
            {
              className: styles.editor,
              textarea: { className: styles.editorText, spellCheck: false },
              resize: "vertical",
              "aria-label": t("preview-title"),
              value: text2,
              onChange: (_, data) => setDraft(data.value)
            }
          )
        ] }),
        /* @__PURE__ */ jsx(FetchXmlProblemList, { problems, malformed })
      ]
    }
  );
}
function FetchXmlProblemList({
  problems,
  malformed,
  title
}) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  if (malformed === void 0 && problems.length === 0) return null;
  const blocking = malformed !== void 0 || hasBlockingProblem(problems);
  return /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: blocking ? "error" : "warning", children: /* @__PURE__ */ jsxs(MessageBarBody, { children: [
    title === void 0 || !blocking ? null : /* @__PURE__ */ jsx(MessageBarTitle, { children: title }),
    /* @__PURE__ */ jsxs("ul", { className: styles.problems, children: [
      malformed === void 0 ? null : /* @__PURE__ */ jsx("li", { children: malformed }),
      problems.map((problem, index) => (
        // Keyed by what it says and where, plus the index: a problem has no
        // identity of its own and the whole list is replaced on every read.
        /* @__PURE__ */ jsxs("li", { children: [
          t("problem-" + problem.code, problem.args),
          /* @__PURE__ */ jsx("span", { className: styles.problemPath, children: problem.path })
        ] }, problem.code + problem.path + String(index))
      ))
    ] })
  ] }) });
}
function FetchXmlBuilder({
  value: value2,
  defaultValue,
  onChange,
  metadata,
  table,
  sections,
  readOnly,
  allowedTables,
  allowAggregate,
  showLogicalNames,
  renderResults,
  className
}) {
  return /* @__PURE__ */ jsx(
    FetchXmlBuilderProvider,
    {
      value: value2,
      defaultValue,
      onChange,
      metadata,
      table,
      readOnly,
      allowedTables,
      allowAggregate,
      showLogicalNames,
      children: /* @__PURE__ */ jsx(
        FetchXmlBuilderLayout,
        {
          sections,
          renderResults,
          className
        }
      )
    }
  );
}
function FetchXmlBuilderLayout({
  sections,
  renderResults,
  className
}) {
  const styles = useFetchXmlBuilderStyles();
  const t = usePrefixedT(FETCH_XML_BUILDER_STRINGS_PREFIX);
  const { parseError, problems } = useFetchXmlBuilderContext();
  const show = (section) => section === "findColumns" ? sections?.findColumns === true : sections?.[section] !== false;
  const hasQueryTab = show("table") || show("columns") || show("sorts") || show("findColumns") || show("filters");
  const tabs = [
    hasQueryTab ? "query" : void 0,
    show("options") ? "options" : void 0,
    show("preview") ? "preview" : void 0
  ].filter((tab) => tab !== void 0);
  const [requested, setRequested] = useState("query");
  const selected = tabs.includes(requested) ? requested : tabs[0] ?? "query";
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-fetch-xml-builder", styles.root, className), children: [
    /* @__PURE__ */ jsx(
      FetchXmlProblemList,
      {
        problems,
        malformed: parseError,
        title: t("parse-error-title")
      }
    ),
    tabs.length > 1 ? /* @__PURE__ */ jsxs(
      TabList,
      {
        selectedValue: selected,
        onTabSelect: (_, data) => setRequested(data.value),
        children: [
          tabs.includes("query") ? /* @__PURE__ */ jsx(Tab, { value: "query", children: t("tab-query") }) : null,
          tabs.includes("options") ? /* @__PURE__ */ jsx(Tab, { value: "options", children: t("options-title") }) : null,
          tabs.includes("preview") ? /* @__PURE__ */ jsx(Tab, { value: "preview", children: t("preview-title") }) : null
        ]
      }
    ) : null,
    selected === "query" ? /* @__PURE__ */ jsxs("div", { className: styles.tabPanel, children: [
      show("table") ? /* @__PURE__ */ jsx(FetchXmlTableSection, {}) : null,
      show("columns") ? /* @__PURE__ */ jsx(FetchXmlColumnsSection, {}) : null,
      show("sorts") ? /* @__PURE__ */ jsx(FetchXmlSortSection, {}) : null,
      show("findColumns") ? /* @__PURE__ */ jsx(FetchXmlFindColumnsSection, {}) : null,
      show("filters") ? /* @__PURE__ */ jsx(FetchXmlFilterSection, {}) : null
    ] }) : null,
    selected === "options" ? /* @__PURE__ */ jsx(FetchXmlOptionsSection, { hideTitle: tabs.length > 1 }) : null,
    selected === "preview" ? /* @__PURE__ */ jsx(FetchXmlPreviewSection, { hideTitle: tabs.length > 1 }) : null,
    renderResults !== void 0 && show("results") ? /* @__PURE__ */ jsx(FetchXmlResultsSection, { renderResults }) : null,
    /* @__PURE__ */ jsx(FetchXmlLoadingOverlay, {})
  ] });
}
var useStyles27 = makeStyles({
  surface: {
    width: "min(1200px, 94vw)",
    maxWidth: "min(1200px, 94vw)"
  },
  tabs: {
    marginBottom: "var(--spacingVerticalM)"
  },
  // The builder takes the whole height of its parent, here the dialog's content: under the tab bar
  // that ends below the content, which scrolls with room to spare. Sized to its rows, as the grid's
  // Filter dialog sizes it, it lets the dialog grow to fit them.
  builder: {
    height: "auto"
  }
});
function MultiTableFilterDialog(props) {
  const { open, onCancel } = props;
  return open ? /* @__PURE__ */ jsx(Dialog, { open: true, onOpenChange: (_, data) => !data.open && onCancel(), children: /* @__PURE__ */ jsx(MultiTableFilterDialogSurface, { ...props }) }) : null;
}
function MultiTableFilterDialogSurface({ tabs, viewTabs, onApply, onCancel }) {
  const t = useT();
  const { locale } = useLocale();
  const styles = useStyles27();
  const showsLogicalNames = useShowsLogicalNames();
  const metadata = useReadableFetchXmlMetadata();
  const [restoring, setRestoring] = useState(false);
  const shown = restoring ? viewTabs ?? tabs : tabs;
  const ordered = useMemo(
    () => [...shown].sort((a, b) => a.label.localeCompare(b.label, locale, { sensitivity: "base" })),
    [shown, locale]
  );
  const [active, setActive] = useState(ordered[0]?.table);
  const [drafts, setDrafts] = useState({});
  const draftOf = (tab) => drafts[tab.table] ?? tab.criteria;
  const activeTab = ordered.find((tab) => tab.table === active) ?? ordered[0];
  const reset = () => {
    setDrafts(Object.fromEntries((viewTabs ?? tabs).map((tab) => [tab.table, tab.viewCriteria])));
    setRestoring(true);
  };
  const canApply = useMemo(
    () => Object.values(drafts).every((draft) => {
      try {
        return !hasIncompleteCondition(parseFetchXml(draft).entity);
      } catch {
        return false;
      }
    }),
    [drafts]
  );
  return /* @__PURE__ */ jsx(DialogSurface, { className: styles.surface, "aria-label": t("app.components.grid.filter-title"), children: /* @__PURE__ */ jsxs(DialogBody, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: t("app.components.grid.filter-title") }),
    /* @__PURE__ */ jsxs(DialogContent, { children: [
      ordered.length > 1 && /* @__PURE__ */ jsx(
        TabList,
        {
          className: styles.tabs,
          selectedValue: activeTab?.table,
          onTabSelect: (_, data) => setActive(String(data.value)),
          children: ordered.map((tab) => /* @__PURE__ */ jsx(Tab, { value: tab.table, children: tab.label }, tab.table))
        }
      ),
      activeTab && /* @__PURE__ */ jsx(
        FetchXmlBuilder,
        {
          className: styles.builder,
          value: draftOf(activeTab),
          onChange: (value2) => setDrafts((current) => ({ ...current, [activeTab.table]: value2 })),
          metadata,
          table: activeTab.table,
          allowAggregate: false,
          showLogicalNames: showsLogicalNames,
          sections: { table: false, columns: false, sorts: false, options: false, preview: false }
        },
        activeTab.table
      )
    ] }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(Button, { appearance: "subtle", onClick: reset, children: t("app.components.grid.filter-reset") }),
      /* @__PURE__ */ jsx(Button, { onClick: onCancel, children: t("app.components.grid.filter-cancel") }),
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "primary",
          disabled: !canApply,
          onClick: () => onApply(Object.fromEntries(shown.map((tab) => [tab.table, draftOf(tab)])), restoring),
          children: t("app.components.grid.filter-apply")
        }
      )
    ] })
  ] }) });
}
function everyRow(table) {
  return `<fetch><entity name="${table}" /></fetch>`;
}
function multiTableFilterQueries(tables, viewFetchXml) {
  return Promise.all(
    tables.map(async (table) => ({
      table,
      fetchXml: table.viewType === MultiTableViewType.SystemView && table.viewId ? await viewFetchXml(table.viewId) ?? null : (table.viewType ?? MultiTableViewType.FetchXml) === MultiTableViewType.FetchXml ? table.fetchXml?.trim() ? table.fetchXml : everyRow(table.table ?? "") : null
    }))
  );
}
function multiTableFilterTabs(queries, isShown, labelOf, criteria) {
  const tabs = [];
  for (const { table, fetchXml } of queries) {
    const name = table.table ?? "";
    if (!fetchXml || !isShown(name)) continue;
    let viewCriteria;
    try {
      viewCriteria = extractGridCriteria(fetchXml);
    } catch {
      continue;
    }
    tabs.push({ table: name, label: table.label ?? labelOf(name), criteria: criteria?.[name] ?? viewCriteria, viewCriteria });
  }
  return tabs;
}
function applyMultiTableFilter(queries, tabs, criteria) {
  const changed = Object.fromEntries(
    tabs.filter((tab) => criteria[tab.table] !== void 0 && !sameGridCriteria(criteria[tab.table], tab.viewCriteria)).map((tab) => [tab.table, criteria[tab.table]])
  );
  if (Object.keys(changed).length === 0) return null;
  const tables = [];
  for (const { table, fetchXml } of queries) {
    const given = changed[table.table ?? ""];
    if (!fetchXml || given === void 0) {
      tables.push(table);
      continue;
    }
    let query;
    try {
      query = applyGridCriteria(fetchXml, given);
    } catch {
      return null;
    }
    tables.push({
      table: table.table,
      viewType: MultiTableViewType.FetchXml,
      fetchXml: query,
      ...table.overrides ? { overrides: table.overrides } : {},
      ...table.label ? { label: table.label } : {}
    });
  }
  return { tables, criteria: changed };
}

// src/views/multi-table-table-set.ts
var EVERY_TABLE_VIEW_ID = "00000000-0000-0000-0000-000000000000";
var EVERY_ACTIVITY = "activitypointer";
var NONE = [];
var sameId3 = (a, b) => !!a && !!b && a.toLowerCase() === b.toLowerCase();
function tablesOf(tables, registered, allowed, stored, isStoredView) {
  let named;
  if (tables) named = tables.map((x) => x.table ?? "");
  else if (isStoredView) {
    if (!stored) return null;
    named = [...stored];
  } else named = registered.map((x) => x.table ?? "");
  const expanded = named.flatMap(
    (table) => table.toLowerCase() === EVERY_ACTIVITY ? registered.filter((x) => x.isActivity).map((x) => x.table ?? "") : [table.toLowerCase()]
  );
  return [...new Set(expanded)].filter((table) => registered.some((x) => x.table === table) && (!allowed || allowed.has(table)));
}
function hiddenByDefault(viewId, shown, defaults) {
  if (viewId !== EVERY_TABLE_VIEW_ID || !shown.some((table) => defaults.has(table))) return [];
  return shown.filter((table) => !defaults.has(table));
}
function registeredFor(response, use) {
  const isFor = (uses) => ((uses ?? 3) & use) !== 0;
  return {
    ...response,
    tables: (response.tables ?? []).filter((x) => isFor(x.uses)),
    views: (response.views ?? []).filter((x) => isFor(x.uses))
  };
}
function useMultiTableTableSet({ use, viewId, scope = "", tables, defaultTables }) {
  const { ppp, authState, viewMetadataCache } = usePowerPortalsPro();
  const t = useT();
  const user = authState.status === "authenticated" ? authState.user?.userId ?? null : null;
  const tablesKey = (tables ?? []).map((table) => table.trim().toLowerCase()).join(",");
  const allowed = useMemo(() => tablesKey ? new Set(tablesKey.split(",")) : null, [tablesKey]);
  const defaultsKey = defaultTables.map((table) => table.trim().toLowerCase()).join(",");
  const defaults = useMemo(() => new Set(defaultsKey.split(",").filter(Boolean)), [defaultsKey]);
  const askedRef = useRef(null);
  const latestRef = useRef(null);
  const [registered, setRegistered] = useState(null);
  const registeredAsync = () => {
    let asked = askedRef.current;
    if (!asked || asked.user !== user) {
      const answer = ppp.getMultiTableTablesAsync().then((response) => registeredFor(response, use));
      asked = askedRef.current = { user, answer };
      answer.then(
        (response) => {
          if (askedRef.current?.answer !== answer) return;
          latestRef.current = response;
          setRegistered(response);
        },
        () => {
          if (askedRef.current?.answer === answer) askedRef.current = null;
        }
      );
    }
    return asked.answer;
  };
  const infoIn = (response, table) => response?.tables?.find((x) => x.table === table);
  const storedRef = useRef({ user, tables: /* @__PURE__ */ new Map(), names: /* @__PURE__ */ new Map() });
  const stored = () => {
    if (storedRef.current.user !== user) storedRef.current = { user, tables: /* @__PURE__ */ new Map(), names: /* @__PURE__ */ new Map() };
    return storedRef.current;
  };
  const tablesOfView = (named, multiTableViewId) => {
    const response = latestRef.current;
    const registeredView = !named && multiTableViewId ? (response?.views ?? []).find((view) => sameId3(view.id, multiTableViewId)) : void 0;
    return tablesOf(
      named ?? registeredView?.tables ?? null,
      response?.tables ?? [],
      allowed,
      multiTableViewId ? stored().tables.get(multiTableViewId.toLowerCase()) : null,
      !named && !registeredView && !!multiTableViewId
    );
  };
  const storedViewName = (id) => {
    const names2 = stored().names;
    const key3 = id.toLowerCase();
    let known2 = names2.get(key3);
    if (!known2) {
      known2 = ppp.retrieveRecordAsync(MultiTableViewSchema.table, id, [MultiTableViewSchema.name]).then(
        (stored2) => {
          const name = stored2.properties?.[MultiTableViewSchema.name]?.value;
          return { readable: true, name: typeof name === "string" ? name : null };
        },
        (error) => {
          console.warn(`[Views] The multi-table view ${id} doesn't exist or the user may not read it.`, error);
          return { readable: false, name: null };
        }
      );
      names2.set(key3, known2);
    }
    return known2;
  };
  const [knownState, setKnownState] = useState({ viewId: void 0, tables: NONE });
  const [hiddenChoice, setHiddenChoice] = useState(null);
  const [filterState, setFilterState] = useState(null);
  const [dialogState, setDialogState] = useState(null);
  const keptFor = (kept, id) => !!kept && kept.scope === scope && kept.viewId === id;
  useEffect(() => {
    setHiddenChoice((current) => current && !(current.scope === scope && current.viewId === viewId) ? null : current);
    setFilterState((current) => current && !(current.scope === scope && current.viewId === viewId) ? null : current);
  }, [scope, viewId]);
  const hiddenIn = (id, of) => keptFor(hiddenChoice, id) ? hiddenChoice.tables : hiddenByDefault(id, of, defaults);
  const shownIn = (id, of, byView = false) => {
    const off = byView ? hiddenByDefault(id, of, defaults) : hiddenIn(id, of);
    return of.length < 2 ? [...of] : of.filter((table) => !off.includes(table));
  };
  const known = knownState.viewId === viewId ? knownState.tables : NONE;
  const hidden = hiddenIn(viewId, known);
  const hiddenAtOpen = hiddenByDefault(viewId, known, defaults);
  const kinds = known.length > 1 ? known : NONE;
  useLocalization(known.map((table) => `tables.${table}`));
  const tableLabel4 = (table) => {
    const key3 = `tables.${table}.label`;
    const label = t(key3);
    return label && label !== key3 ? label : table;
  };
  const shownRef = useRef({ scope, viewId });
  shownRef.current = { scope, viewId };
  const filterIn = (id) => keptFor(filterState, id) ? filterState : null;
  const openFilter = (id, queries, of, label) => {
    if (shownRef.current.scope !== scope || shownRef.current.viewId !== id) return;
    const response = latestRef.current;
    const named = queries.map((x) => (x.table.table ?? "").toLowerCase());
    const isShownAmong = (shownNow) => {
      const lower = shownNow.map((x) => x.toLowerCase());
      return (table) => table.toLowerCase() === EVERY_ACTIVITY ? shownNow.some((x) => infoIn(response, x)?.isActivity && !named.includes(x.toLowerCase())) : lower.includes(table.toLowerCase());
    };
    const tabs = multiTableFilterTabs(queries, isShownAmong(shownIn(id, of)), label, filterIn(id)?.criteria);
    const viewTabs = multiTableFilterTabs(queries, isShownAmong(shownIn(id, of, true)), label);
    if (tabs.length > 0) setDialogState({ scope, viewId: id, tables: queries, tabs, viewTabs });
  };
  const applyFilter = (criteria, restoreView) => {
    const dialog = dialogState;
    setDialogState(null);
    if (!dialog || dialog.scope !== shownRef.current.scope || dialog.viewId !== shownRef.current.viewId) return false;
    const applied = applyMultiTableFilter(dialog.tables, restoreView ? dialog.viewTabs : dialog.tabs, criteria);
    setFilterState(applied ? { ...applied, scope: dialog.scope, viewId: dialog.viewId } : null);
    if (restoreView) setHiddenChoice(null);
    return true;
  };
  return {
    registered,
    registeredAsync,
    forget: () => {
      askedRef.current = null;
      storedRef.current = { user, tables: /* @__PURE__ */ new Map(), names: /* @__PURE__ */ new Map() };
    },
    infoOf: (table) => infoIn(registered, table),
    allowed,
    tablesOf: tablesOfView,
    learnTables: (storedViewId, read2) => {
      stored().tables.set(storedViewId.toLowerCase(), read2);
      return tablesOfView(null, storedViewId) ?? [];
    },
    storedViewName,
    known,
    setKnown: (id, read2) => setKnownState({ viewId: id, tables: read2 }),
    hidden,
    hiddenAtOpen,
    shown: shownIn(viewId, known),
    kinds,
    tablesChanged: kinds.some((table) => hidden.includes(table) !== hiddenAtOpen.includes(table)),
    hidesAny: kinds.some((table) => hidden.includes(table)),
    hiddenIn,
    shownIn,
    showTable: (table, shown) => setHiddenChoice({ scope, viewId, tables: shown ? hidden.filter((x) => x !== table) : [.../* @__PURE__ */ new Set([...hidden, table])] }),
    menuTables: (label) => kinds.map((table) => ({ table, label: label(table), shown: !hidden.includes(table) })),
    hiddenChoice,
    // Only the choices kept with the scope: those another scope left are taken away with nothing to read again.
    choiceKey: JSON.stringify([
      hiddenChoice?.scope === scope ? hiddenChoice : null,
      filterState?.scope === scope ? [filterState.viewId, filterState.tables] : null
    ]),
    tableLabel: tableLabel4,
    filter: filterIn(viewId),
    filterIn,
    filterDialog: dialogState,
    filterQueries: (named) => multiTableFilterQueries(named, async (id) => (await viewMetadataCache.getAsync(id))?.fetchXml),
    openFilter,
    applyFilter,
    closeFilter: () => setDialogState(null),
    clearFilter: () => setFilterState(null),
    reset: () => {
      setHiddenChoice(null);
      setFilterState(null);
    }
  };
}
function ViewLoadMessages({ failed, errorText, failedTables, retryText, onRetry, retryDisabled }) {
  if (failed) {
    return /* @__PURE__ */ jsx(MessageBar, { intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: errorText }) });
  }
  if (!failedTables) return null;
  return /* @__PURE__ */ jsxs(MessageBar, { intent: "warning", children: [
    /* @__PURE__ */ jsx(MessageBarBody, { children: failedTables }),
    /* @__PURE__ */ jsx(MessageBarActions, { children: /* @__PURE__ */ jsx(Button, { size: "small", disabled: retryDisabled ?? false, onClick: () => onRetry?.(), children: retryText }) })
  ] });
}
var useStyles28 = makeStyles({
  // Two groups: the view picker or title, then the rest at the end. On a narrow screen the end group
  // wraps below the first as a whole rather than squeezing it.
  root: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    rowGap: tokens.spacingVerticalXS,
    columnGap: tokens.spacingHorizontalS,
    paddingInline: 0
  },
  start: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    flex: "1 1 auto",
    minWidth: 0
  },
  end: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: tokens.spacingHorizontalXS,
    marginInlineStart: "auto",
    minWidth: 0
  }
});
function ViewToolbar({ start, children, ariaLabel, className }) {
  const styles = useStyles28();
  return /* @__PURE__ */ jsxs(Toolbar, { className: mergeClasses("ppp-view-toolbar", styles.root, className), "aria-label": ariaLabel, children: [
    /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-view-toolbar-start", styles.start), children: start }),
    /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-view-toolbar-end", styles.end), children })
  ] });
}
function RecordDialogShell({
  open,
  onOpenChange,
  location,
  tableName,
  enablePanelResizing,
  children
}) {
  if (location !== "center") {
    return /* @__PURE__ */ jsx(
      SidePanel,
      {
        open,
        onOpenChange,
        position: location === "panel-left" ? "start" : "end",
        enableResizing: enablePanelResizing,
        widthStorageKey: `ppp.record-panel.${tableName}.width`,
        children
      }
    );
  }
  return /* @__PURE__ */ jsx(Dialog, { open, onOpenChange: (_, data) => onOpenChange(data.open), modalType: "modal", children: /* @__PURE__ */ jsx(DialogSurface, { children }) });
}
function RecordDialogFrame({ location, title, actions, children }) {
  if (location !== "center") {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      title !== void 0 && /* @__PURE__ */ jsx(SidePanelHeader, { children: title }),
      /* @__PURE__ */ jsx(SidePanelBody, { children }),
      actions !== void 0 && /* @__PURE__ */ jsx(SidePanelFooter, { children: actions })
    ] });
  }
  if (title === void 0 && actions === void 0) return /* @__PURE__ */ jsx(Fragment, { children });
  return /* @__PURE__ */ jsxs(DialogBody, { children: [
    title !== void 0 && /* @__PURE__ */ jsx(DialogTitle, { children: title }),
    /* @__PURE__ */ jsx(DialogContent, { children }),
    actions !== void 0 && /* @__PURE__ */ jsx(DialogActions, { children: actions })
  ] });
}
var useDefaultFormStyles = makeStyles({
  fields: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM
  }
});
function DefaultFormFields({ className, columns }) {
  const styles = useDefaultFormStyles();
  return /* @__PURE__ */ jsx("div", { className: mergeClasses(className, styles.fields), children: columns.map((column) => /* @__PURE__ */ jsx(ColumnEdit, { columnName: column }, column)) });
}
var MultiTableFormContext = createContext(null);
function useMultiTableForm() {
  return useContext(MultiTableFormContext);
}
function MultiTableDefaultForm() {
  const definition = useMultiTableForm()?.definition;
  if (!definition) return null;
  const columns = [
    ...new Set(
      [
        definition.title,
        definition.calendar?.start,
        definition.calendar?.end,
        definition.calendar?.allDay,
        definition.timeline?.start,
        definition.owner,
        ...definition.recipients ?? [],
        definition.body
      ].filter((column) => !!column)
    )
  ];
  return /* @__PURE__ */ jsx(DefaultFormFields, { className: "ppp-multi-table-default-form", columns });
}
function MultiTableRecordPanel({
  title,
  record,
  recordChanged = false,
  existing,
  loaded,
  form,
  definition,
  location = "panel",
  onSaved,
  onClose
}) {
  const translate = useT();
  const table = existing?.table ?? record?.tableName ?? "";
  const Form = form ?? MultiTableDefaultForm;
  return /* @__PURE__ */ jsx(RecordDialogShell, { open: true, onOpenChange: (open) => !open && onClose(), location, tableName: table, enablePanelResizing: true, children: /* @__PURE__ */ jsx(MultiTableFormContext.Provider, { value: { table, definition }, children: /* @__PURE__ */ jsx(
    RecordContext,
    {
      table,
      isolated: true,
      ...existing ? { id: existing.id, ...loaded ? { loadedRecord: loaded } : {} } : record ? { initialRecord: record, initialRecordChanged: recordChanged } : {},
      children: /* @__PURE__ */ jsx(
        RecordDialogFrame,
        {
          location,
          title,
          actions: /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(Button, { onClick: onClose, children: translate("app.buttons.cancel.label") }),
            /* @__PURE__ */ jsx(
              SaveContextButton,
              {
                label: translate(existing ? "app.buttons.save.label" : "app.buttons.create.label"),
                appearance: "primary",
                onSaved
              }
            )
          ] }),
          children: /* @__PURE__ */ jsx(Form, {})
        }
      )
    }
  ) }) });
}
var NOTE_TABLE = "annotation";
var PORTAL_COMMUNICATION_TABLE = "ppp_portalcommunication";
var PORTAL_COMMUNICATION_ATTACHMENT_COLUMN = "ppp_attachment";
var POWER_PAGES_NOTE_SUBJECT = /^Note created on .+ by (.+) \[contact:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\]$/i;
var EDIT_THRESHOLD_MS = 6e4;
function timelineColumns() {
  return {
    "*": ["createdon", "modifiedon", "overriddencreatedon", "createdby"],
    [NOTE_TABLE]: ["isdocument", "filename"],
    [PORTAL_COMMUNICATION_TABLE]: [PORTAL_COMMUNICATION_ATTACHMENT_COLUMN]
  };
}
function kindOf(table) {
  return table === NOTE_TABLE ? "note" : table === PORTAL_COMMUNICATION_TABLE ? "portalCommunication" : "activity";
}
function toTimelineItem(row) {
  const record = row.record;
  const table = row.table ?? "";
  const kind = kindOf(table);
  let title = row.title ?? null;
  const owner = row.owner;
  let author = owner && (owner.name || owner.id) ? { name: owner.name ?? "", tableName: owner.tableName ?? null, id: owner.id ?? null, isPortalUser: owner.tableName === "contact" } : lookupAuthor(record, "createdby");
  let attachment = null;
  if (kind === "note") {
    const portalUser = title?.match(POWER_PAGES_NOTE_SUBJECT);
    if (portalUser) {
      title = null;
      author = { name: portalUser[1], tableName: "contact", id: portalUser[2], isPortalUser: true };
    }
    const fileName = text(record, "filename");
    if (bool(record, "isdocument") && fileName) attachment = { fileName, column: null };
  } else if (kind === "portalCommunication") {
    const fileName = text(record, `${PORTAL_COMMUNICATION_ATTACHMENT_COLUMN}_name`);
    if (fileName) attachment = { fileName, column: PORTAL_COMMUNICATION_ATTACHMENT_COLUMN };
  }
  const createdOn = text(record, "createdon");
  const modifiedOn = text(record, "modifiedon");
  const writtenOn = text(record, "overriddencreatedon") ?? createdOn;
  const edited = modifiedOn !== null && writtenOn !== null && Date.parse(modifiedOn) - Date.parse(writtenOn) > EDIT_THRESHOLD_MS;
  return {
    key: `${table}:${row.id}`,
    kind,
    table,
    id: row.id ?? "",
    title,
    body: row.body ?? null,
    createdOn: row.start ?? "",
    createdOnText: row.startText ?? null,
    modifiedOn: edited ? modifiedOn : null,
    modifiedOnText: edited ? record.formattedValues?.["modifiedon"] || null : null,
    author,
    attachment,
    permissions: row.permissions ?? TableSecurityPermission.Read,
    source: row
  };
}
function lookupAuthor(record, column) {
  const lookup = record.properties?.[column];
  if (!lookup?.value) return null;
  return { name: lookup.name ?? "", tableName: lookup.tableName ?? null, id: lookup.value, isPortalUser: lookup.tableName === "contact" };
}
function value(record, column) {
  const property = record.properties?.[column];
  return property?.value ?? null;
}
function text(record, column) {
  const found = value(record, column);
  return typeof found === "string" && found !== "" ? found : null;
}
function bool(record, column) {
  return value(record, column) === true;
}
var DEFAULT_TABLES = [NOTE_TABLE, "email", PORTAL_COMMUNICATION_TABLE];
var COLLAPSED_LINES = 6;
function timeSpan(upcoming) {
  if (!upcoming) return null;
  const totalHours = Math.max(0, (upcoming.days ?? 0) * 24 + (upcoming.hours ?? 0));
  if (totalHours === 0) return null;
  const days = Math.floor(totalHours / 24);
  const hours = Math.floor(totalHours % 24);
  const minutes = Math.round(totalHours % 1 * 60);
  const two = (value2) => String(value2).padStart(2, "0");
  return `${days}.${two(hours)}:${two(minutes)}:00`;
}
var useStyles29 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM
  },
  // A new message, or one being changed: its editors, then its buttons.
  composer: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS,
    alignSelf: "stretch",
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalM}`,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusMedium
  },
  formActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: tokens.spacingHorizontalS
  },
  // The items, scrolling within maxHeight when it is set; the header and composer stay in view.
  scroll: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
    minHeight: 0,
    overflowY: "auto"
  },
  list: {
    listStyleType: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column"
  },
  entry: {
    display: "grid",
    gridTemplateColumns: "auto minmax(0, 1fr)",
    columnGap: tokens.spacingHorizontalM,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalS}`,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`
  },
  // What is still to come, on a surface of its own: a light gray, or in dark a shade lighter.
  upcomingEntry: {
    backgroundColor: tokens.colorNeutralCardBackground
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: tokens.spacingVerticalXS,
    minWidth: 0
  },
  // The item's whole width, so its table's icon sits in the top corner.
  meta: {
    alignSelf: "stretch",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    color: tokens.colorNeutralForeground2
  },
  // What the item is, in its top corner.
  tableIcon: {
    display: "inline-flex",
    marginInlineStart: "auto",
    paddingInlineEnd: tokens.spacingHorizontalS,
    color: tokens.colorNeutralForeground3
  },
  // Dataverse's icon for the table, as a mask in the text's color: it follows the theme, and runs
  // nothing it carries.
  tableIconImage: {
    width: "20px",
    height: "20px",
    backgroundColor: "currentColor",
    maskImage: "var(--ppp-timeline-table-icon)",
    maskPosition: "center",
    maskSize: "contain",
    maskRepeat: "no-repeat",
    WebkitMaskImage: "var(--ppp-timeline-table-icon)",
    WebkitMaskPosition: "center",
    WebkitMaskSize: "contain",
    WebkitMaskRepeat: "no-repeat"
  },
  body: {
    alignSelf: "stretch",
    overflow: "hidden"
  },
  collapsed: {
    maxHeight: `calc(${COLLAPSED_LINES} * 1.4286em)`
  },
  // Only on a body the cap cuts off: one that fits shows its last line as written.
  faded: {
    maskImage: "linear-gradient(to bottom, black 60%, transparent)"
  },
  footer: {
    display: "flex",
    justifyContent: "center"
  },
  // "Upcoming" above what is still to come, "Earlier" above the rest. Sticky within its group, so it
  // stays at the top of the scrolling list while its rows pass under it, and the next group's heading
  // pushes it off as that group arrives. Its surface sets it apart from the rows of both.
  heading: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
    backgroundColor: tokens.colorNeutralCardBackgroundSelected,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`
  },
  // What a search looks in, as a grid's tooltip lists its columns.
  searchTooltip: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
    maxWidth: "320px"
  },
  searchTooltipColumns: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: tokens.spacingHorizontalM
  },
  // An attachment's download button, and beside it the preview for a file that can be shown.
  attachment: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS
  },
  // Wider than Fluent's default surface, so a PDF or an image has room; inside the viewport.
  previewSurface: {
    maxWidth: "min(1200px, 90vw)",
    width: "90vw"
  },
  previewContent: {
    overflow: "hidden",
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS
  },
  // The spinner while the file downloads, with room enough that the dialog doesn't jump.
  previewLoading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "200px"
  }
});
function Timeline({
  regarding,
  filterByRecord = true,
  tables,
  creatableTables,
  defaultTables = DEFAULT_TABLES,
  viewIds,
  multiTableViewIds,
  customViewDefinitions,
  defaultViewId: defaultViewId$1,
  viewSort = ViewSort.NameAscending,
  pageSize = 10,
  upcoming,
  ascending = false,
  matchParties,
  series,
  allowSearch = true,
  maxHeight,
  title,
  templates,
  forms,
  formLocation = "right",
  showRecordLinks = true,
  onNavigate,
  allowSavedViews = false,
  savedViewsKey,
  signInUrl = "/Account/Login",
  allowFiltering = false,
  className,
  style
}) {
  const styles = useStyles29();
  const t = usePrefixedT("app.components.timeline");
  const translate = useT();
  const { ppp, authState } = usePowerPortalsPro();
  const recordPages = useRecordPages({ enabled: showRecordLinks });
  const dialog = useDialogService();
  const overlayService = useOverlayService();
  const savedViewsControl = useMemo(
    () => savedViewControl(SavedViewControlKind.Timeline, allowSavedViews ? savedViewsKey : void 0),
    [allowSavedViews, savedViewsKey]
  );
  const saved = useSavedViews({ enabled: allowSavedViews, tableName: MultiTableViewSchema.table, control: savedViewsControl });
  const multiSaved = useMultiTableViews({ enabled: allowSavedViews && saved.available, control: savedViewsControl });
  const savedKey = JSON.stringify([
    multiSaved.views.map((view) => [view.id, view.name, view.tables]),
    saved.settings.map((setting) => [setting.viewId, setting.control, setting.isDefault, setting.isHidden])
  ]);
  const awaitsSavedViews = allowSavedViews && (authState.status === "loading" || saved.loading || multiSaved.loading);
  const allViews = useRef([]);
  const overlayTargetId = useId$1("ppp-timeline-overlay");
  const record = useRecordContextOptional()?.record ?? null;
  const about = regarding?.id ? regarding : filterByRecord && record?.id ? { tableName: record.tableName, id: record.id } : null;
  const aboutKey = about ? `${about.tableName}:${about.id}` : "";
  const creating = !regarding && filterByRecord && !!record && !record.id;
  const upcomingSpan = ascending ? null : timeSpan(upcoming);
  const [search, setSearch] = useState("");
  const term = search.trim();
  const [items, setItems] = useState([]);
  const [next, setNext] = useState(null);
  const [failures, setFailures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);
  const [available, setAvailable] = useState(true);
  const [now, setNow] = useState(() => Date.now());
  const [draft, setDraft] = useState(null);
  const [editingKey, setEditingKey] = useState(null);
  const [panel, setPanel] = useState(null);
  const [version, setVersion] = useState(0);
  const [refreshes, setRefreshes] = useState(0);
  const shownRequest = useRef(null);
  const viewsRead = useRef(null);
  const [views, setViews] = useState([]);
  const [shownView, setShownView] = useState(null);
  const viewsKey = JSON.stringify([viewIds ?? [], multiTableViewIds ?? [], customViewDefinitions ?? [], defaultViewId$1 ?? null]);
  const tablesKey = (tables ?? []).map((x) => x.trim().toLowerCase()).join(",");
  const tableSet = useMultiTableTableSet({ use: MultiTableUses.Timeline, viewId: shownView?.id, scope: viewsKey, tables, defaultTables });
  const tableIcons = useTableIcons(tableSet.known);
  const defaultsKey = defaultTables.map((table) => table.trim().toLowerCase()).join(",");
  const [chosen, setChosen] = useState({ viewsKey, viewId: null });
  const viewChoice = chosen.viewsKey === viewsKey ? chosen.viewId : null;
  const setViewChoice = (viewId) => {
    setChosen({ viewsKey, viewId });
    tableSet.reset();
  };
  useEffect(() => setDraft(null), [aboutKey]);
  useEffect(() => {
    shownRequest.current = null;
    setItems([]);
    setNext(null);
    setFailures([]);
    setFailed(false);
    setLoading(false);
    setEditingKey(null);
    if (creating) return;
    if (awaitsSavedViews) {
      setLoading(true);
      return;
    }
    const controller = new AbortController();
    setLoading(true);
    void (async () => {
      try {
        const readable = await tableSet.registeredAsync();
        if (controller.signal.aborted) return;
        if (viewsRead.current?.key !== `${viewsKey}#${savedKey}#${viewChoice ?? ""}`) {
          const listed = [];
          for (const id of [...new Set(viewIds ?? [])]) {
            const metadata = await ppp.retrieveViewMetadataAsync(id, controller.signal);
            if (!metadata) {
              console.warn(`[Timeline] The view ${id} doesn't exist, so it isn't listed.`);
              continue;
            }
            listed.push({
              id,
              // Named as a grid names a view: its label in the user's language, else its own name.
              name: viewLabelOf(metadata, translate),
              multiTableViewId: null,
              tables: [{ table: metadata.tableName.toLowerCase(), viewType: MultiTableViewType.SystemView, viewId: id }]
            });
          }
          for (const id of [...new Set(multiTableViewIds ?? [])]) {
            const known2 = readable.views.find((view2) => view2.id === id);
            if (known2) {
              listed.push({ id, name: known2.name ?? null, multiTableViewId: id, tables: null });
              continue;
            }
            const stored = await tableSet.storedViewName(id);
            if (stored.readable) listed.push({ id, name: stored.name, multiTableViewId: id, tables: null });
          }
          for (const definition of customViewDefinitions ?? [])
            listed.push({ id: definition.id, name: definition.displayName, multiTableViewId: null, tables: definition.tables });
          if (listed.length === 0) listed.push({ id: EVERY_TABLE_VIEW_ID, name: null, multiTableViewId: null, tables: null });
          for (const own of multiSaved.views) listed.push({ id: own.id, name: own.name, multiTableViewId: null, tables: [...own.tables] });
          allViews.current = [...listed];
          const userDefault2 = defaultViewId(saved.settings, listed.map((x) => x.id), savedViewsControl);
          const ordered = userDefault2 ? [...listed.filter((x) => x.id === userDefault2), ...listed.filter((x) => x.id !== userDefault2)] : listed;
          const offered = ordered.filter((x) => x.id === viewChoice || !isViewHidden(saved.settings, x.id, savedViewsControl));
          viewsRead.current = { key: `${viewsKey}#${savedKey}#${viewChoice ?? ""}`, views: offered.length > 0 ? offered : ordered };
        }
        const listedViews = viewsRead.current.views;
        const userDefault = defaultViewId(saved.settings, listedViews.map((x) => x.id), savedViewsControl);
        const view = listedViews.find((x) => x.id === viewChoice) ?? listedViews.find((x) => x.id === userDefault) ?? listedViews.find((x) => x.id === defaultViewId$1) ?? listedViews[0];
        setViews(listedViews);
        setShownView(view);
        const known = tableSet.tablesOf(view.tables, view.multiTableViewId);
        const shown = known ?? [];
        tableSet.setKnown(view.id, shown);
        if (known) {
          setAvailable(shown.length > 0 || listedViews.length > 1);
          if (shown.length === 0) return;
        }
        const filter = tableSet.filterIn(view.id);
        const request = {
          viewId: filter ? null : view.multiTableViewId,
          tables: filter ? [...filter.tables] : view.tables ? [...view.tables] : null,
          // With one table there is nothing to choose among, so nothing hidden; a view whose tables
          // aren't known yet is read as the timeline allows.
          includeTables: known ? tableSet.shownIn(view.id, shown) : tableSet.allowed ? [...tableSet.allowed] : null,
          regarding: about ? { tableName: about.tableName, id: about.id } : null,
          matchParties: matchParties ?? null,
          series: series ?? null,
          search: term || null,
          pageSize,
          ascending,
          upcoming: upcomingSpan,
          columns: timelineColumns()
        };
        const page = await ppp.loadMultiTableFeedAsync(request, controller.signal);
        if (controller.signal.aborted) return;
        if (!known && view.multiTableViewId) {
          const read2 = tableSet.learnTables(view.multiTableViewId, page.tables ?? []);
          tableSet.setKnown(view.id, read2);
          setAvailable(read2.length > 0 || listedViews.length > 1);
        }
        shownRequest.current = request;
        setNow(Date.now());
        setItems((page.items ?? []).map(toTimelineItem));
        setNext(page.next ?? null);
        setFailures(page.failures ?? []);
      } catch (error) {
        if (!controller.signal.aborted) {
          console.error("[Timeline] The timeline could not be loaded.", error);
          setFailed(true);
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    })();
    return () => controller.abort();
  }, [ppp, aboutKey, creating, term, viewsKey, savedKey, awaitsSavedViews, tablesKey, viewChoice, pageSize, tableSet.choiceKey, defaultsKey, upcomingSpan, ascending, matchParties, series, version, refreshes]);
  const loadMore = useCallback(async () => {
    const request = shownRequest.current;
    if (!request || !next) return;
    setLoading(true);
    try {
      const page = await ppp.loadMultiTableFeedAsync({ ...request, cursor: next });
      if (shownRequest.current !== request) return;
      setItems((shown) => [...shown, ...(page.items ?? []).map(toTimelineItem)]);
      setNext(page.next ?? null);
      setFailures((known) => [...known, ...(page.failures ?? []).filter((x) => !known.some((k) => k.table === x.table))]);
    } catch (error) {
      if (shownRequest.current === request) {
        console.error("[Timeline] More of the timeline could not be loaded.", error);
        setFailed(true);
      }
    } finally {
      if (shownRequest.current === request) setLoading(false);
    }
  }, [ppp, next]);
  const infoOf = tableSet.infoOf;
  const may = (item, permission) => (item.permissions & permission) === permission;
  const ownFields = (table, form) => (table === NOTE_TABLE || table === PORTAL_COMMUNICATION_TABLE) && !form;
  const inline = formLocation === "inline";
  const editedInPlace = (item) => inline || ownFields(item.table, forms?.[item.table]?.edit);
  const writtenInPlace = (table) => inline || ownFields(table, forms?.[table]?.create);
  const inPlaceForm = (table, form) => {
    const Form = form;
    return /* @__PURE__ */ jsx(MultiTableFormContext.Provider, { value: { table, definition: infoOf(table)?.definition ?? {} }, children: Form ? /* @__PURE__ */ jsx(Form, {}) : /* @__PURE__ */ jsx(EditorLabelPositionProvider, { position: EditorLabelPosition.Above, children: /* @__PURE__ */ jsx(MultiTableDefaultForm, {}) }) });
  };
  const creatable = [...new Set((creatableTables ?? [NOTE_TABLE, PORTAL_COMMUNICATION_TABLE]).map((x) => x.trim().toLowerCase()))].filter(
    (table) => ((infoOf(table)?.permissions ?? 0) & TableSecurityPermission.Create) === TableSecurityPermission.Create && // A note or message needs the timeline's record, wherever it is written.
    (!ownFields(table, forms?.[table]?.create) || !!about)
  );
  const filtered = tableSet.filter;
  const viewChanged = !!filtered || tableSet.tablesChanged;
  const canReload = editingKey === null && panel === null;
  const refresh = () => {
    tableSet.forget();
    setRefreshes((x) => x + 1);
  };
  const upcomingItem = (item) => !ascending && Date.parse(item.createdOn) > now;
  const firstEarlier = items.findIndex((item) => !upcomingItem(item));
  const upcomingCount = firstEarlier < 0 ? items.length : firstEarlier;
  const groups = upcomingCount === 0 ? [{ heading: null, upcoming: false, items }] : [
    { heading: t("upcoming"), upcoming: true, items: items.slice(0, upcomingCount) },
    ...upcomingCount < items.length ? [{ heading: t("earlier"), upcoming: false, items: items.slice(upcomingCount) }] : []
  ];
  const kindLabel = (table) => kindOf(table) === "note" ? t("note") : kindOf(table) === "portalCommunication" ? t("portal-communication") : tableSet.tableLabel(table);
  const newLabel = (table) => kindOf(table) === "note" ? t("new-note") : kindOf(table) === "portalCommunication" ? t("new-message") : t("new-item", [kindLabel(table)]);
  const startCreating = (table) => {
    const regardingColumn = infoOf(table)?.definition?.regarding;
    const created = {
      tableName: table,
      properties: about && regardingColumn ? { [regardingColumn]: { $type: ColumnType.Lookup, tableName: about.tableName, value: about.id } } : {}
    };
    if (writtenInPlace(table)) setDraft(created);
    else setPanel({ table, record: created });
  };
  const remove = async (item) => {
    const [titleKey, failedKey, deletingKey] = item.kind === "note" ? ["delete-note-title", "delete-note-failed", "deleting-note"] : item.kind === "portalCommunication" ? ["delete-title", "delete-failed", "deleting"] : ["delete-item-title", "delete-item-failed", "deleting-item"];
    const answer = await dialog.showConfirmationAsync(t("delete-confirmation"), {
      title: t(titleKey),
      primaryText: t("delete"),
      secondaryText: t("cancel")
    });
    if (answer.canceled) return;
    const progress = createProgressOverlay(overlayService, overlayTargetId);
    progress.show(t(deletingKey));
    try {
      await ppp.deleteRecordAsync(item.table, item.id);
      setItems((shown) => shown.filter((x) => x.key !== item.key));
    } catch (error) {
      progress.close();
      console.error(`[Timeline] The ${item.table} ${item.id} could not be deleted.`, error);
      await dialog.showErrorAsync(error instanceof Error ? error.message : String(error), { title: t(failedKey) });
    } finally {
      progress.close();
    }
  };
  const findSavedView = (id) => id ? multiSaved.views.find((x) => x.id.toLowerCase() === id.toLowerCase()) : void 0;
  const shownSaved = findSavedView(shownView?.id);
  const tablesOfView = (view) => {
    if (!view) return [];
    if (view.tables) return [...view.tables];
    if (view.multiTableViewId) return [...tableSet.registered?.views.find((x) => x.id === view.multiTableViewId)?.tables ?? []];
    return (tableSet.tablesOf(null) ?? []).map((table) => ({ table }));
  };
  const currentTables = () => {
    const tablesNow = filtered ? [...filtered.tables] : shownView?.tables || shownView?.multiTableViewId ? tablesOfView(shownView) : tableSet.shown.map((table) => ({ table }));
    return shownViewTables(tablesNow, tableSet.known, tableSet.shown, (table) => !!infoOf(table)?.isActivity);
  };
  const canSaveView = currentTables().length > 0;
  const savedViewChanged = !!shownSaved && viewChanged;
  const isUserDefault = !!shownView && defaultViewId(saved.settings, allViews.current.map((x) => x.id), savedViewsControl) === shownView.id;
  const filterableTables = () => {
    if (!shownView) return null;
    if (shownView.tables) return [...shownView.tables];
    if (shownView.multiTableViewId)
      return tableSet.registered?.views.find((x) => x.id === shownView.multiTableViewId)?.tables ? tablesOfView(shownView) : null;
    return tableSet.known.map((table) => ({ table }));
  };
  const showsFilterButton = allowFiltering && (filterableTables()?.length ?? 0) > 0;
  const openFilter = async () => {
    const view = shownView;
    const tablesOfIt = filterableTables();
    if (!view || !tablesOfIt) return;
    try {
      tableSet.openFilter(view.id, await tableSet.filterQueries(tablesOfIt), tableSet.known, kindLabel);
    } catch (error) {
      console.warn("[Timeline] The filters of the view shown could not be read.", error);
    }
  };
  const viewName = (id) => allViews.current.find((x) => x.id.toLowerCase() === id.toLowerCase())?.name ?? findSavedView(id)?.name ?? t("title");
  const session = useSavedViewSession({
    saved,
    signInUrl,
    operations: {
      shownViewId: shownView?.id,
      savedViewName: (id) => findSavedView(id)?.name,
      managedViewName: viewName,
      managedViews: () => allViews.current.map((view) => ({
        id: view.id,
        name: view.name ?? t("title"),
        isSaved: !!findSavedView(view.id),
        isDefault: defaultViewId(saved.settings, allViews.current.map((x) => x.id), savedViewsControl) === view.id,
        isHidden: isViewHidden(saved.settings, view.id, savedViewsControl),
        isShown: view.id === shownView?.id
      })),
      save: async () => {
        const tablesNow = currentTables();
        if (!shownSaved || tablesNow.length === 0) return;
        await multiSaved.update(shownSaved.id, { tables: tablesNow });
        setViewChoice(shownSaved.id);
      },
      saveAs: async (name) => {
        const tablesNow = currentTables();
        if (tablesNow.length === 0) return;
        const view = await multiSaved.create(name, tablesNow, {});
        setViewChoice(view.id);
      },
      clone: async (id, name) => {
        const tablesOfIt = findSavedView(id)?.tables ?? tablesOfView(allViews.current.find((x) => x.id === id));
        if (tablesOfIt.length === 0) return;
        await multiSaved.create(name, tablesOfIt, {});
      },
      rename: async (id, name) => void await multiSaved.update(id, { name }),
      remove: async (id) => {
        await multiSaved.remove(id);
        await saved.reloadSettings();
        if (shownView?.id === id) setViewChoice(null);
      },
      openView: (id) => {
        if (id !== shownView?.id) setViewChoice(id);
      }
    }
  });
  if (!available) return null;
  const panelInfo = panel ? infoOf(panel.table) : null;
  return /* @__PURE__ */ jsx("section", { className: mergeClasses("ppp-timeline", className), style, children: /* @__PURE__ */ jsxs(FluentOverlayTarget, { targetId: overlayTargetId, className: styles.root, children: [
    /* @__PURE__ */ jsxs(
      ViewToolbar,
      {
        className: "ppp-timeline-header",
        ariaLabel: t("toolbar"),
        start: (
          // A choice of one where the user saves views: the picker is how they reach theirs.
          views.length > (session.showsMenu ? 0 : 1) ? /* @__PURE__ */ jsx(
            ViewPicker,
            {
              className: "ppp-timeline-view-picker",
              options: views.map((view) => ({ id: view.id, label: view.name ?? t("title") })),
              sort: viewSort,
              value: shownView?.id,
              onChange: setViewChoice,
              isUserView: (id) => !!findSavedView(id),
              disabled: !canReload
            }
          ) : /* @__PURE__ */ jsx(Subtitle2, { as: "h2", children: title ?? shownView?.name ?? t("title") })
        ),
        children: [
          !draft && creatable.length === 1 && /* @__PURE__ */ jsx(Button, { icon: /* @__PURE__ */ jsx(ComposeRegular, {}), onClick: () => startCreating(creatable[0]), children: newLabel(creatable[0]) }),
          !draft && creatable.length > 1 && /* @__PURE__ */ jsxs(Menu, { children: [
            /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Button, { icon: /* @__PURE__ */ jsx(ComposeRegular, {}), children: t("new") }) }),
            /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: creatable.map((table) => /* @__PURE__ */ jsx(MenuItem, { onClick: () => startCreating(table), children: kindLabel(table) }, table)) }) })
          ] }),
          allowSearch && /* @__PURE__ */ jsx(
            ViewSearchBox,
            {
              value: search,
              onChange: setSearch,
              placeholder: t("search"),
              tooltip: (
                // What a search looks in, as a grid's tooltip lists its columns.
                /* @__PURE__ */ jsxs("div", { className: styles.searchTooltip, children: [
                  /* @__PURE__ */ jsxs("div", { children: [
                    /* @__PURE__ */ jsx("span", { children: t("search-text-intro") }),
                    /* @__PURE__ */ jsxs("div", { className: styles.searchTooltipColumns, children: [
                      /* @__PURE__ */ jsx("span", { children: t("subject") }),
                      /* @__PURE__ */ jsx("span", { children: t("text") })
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxs("div", { children: [
                    /* @__PURE__ */ jsx("span", { children: t("search-date-intro") }),
                    /* @__PURE__ */ jsx("div", { className: styles.searchTooltipColumns, children: /* @__PURE__ */ jsx("span", { children: t("date") }) })
                  ] })
                ] })
              )
            }
          ),
          /* @__PURE__ */ jsx(
            ViewFilterMenu,
            {
              changed: viewChanged,
              disabled: !canReload,
              onEditFilters: showsFilterButton ? () => void openFilter() : void 0,
              tables: tableSet.menuTables(kindLabel),
              onTableShownChange: tableSet.showTable,
              savedViews: session.menu({
                canSave: savedViewChanged,
                canSaveAs: canSaveView && viewChanged,
                canSetDefault: !!shownView && !isUserDefault
              })
            }
          ),
          /* @__PURE__ */ jsx(ViewRefreshButton, { disabled: !canReload, onClick: refresh })
        ]
      }
    ),
    draft && /* @__PURE__ */ jsx(
      Composer,
      {
        draft,
        form: ownFields(draft.tableName ?? "", forms?.[draft.tableName ?? ""]?.create) ? null : inPlaceForm(draft.tableName ?? "", forms?.[draft.tableName ?? ""]?.create),
        onClose: () => setDraft(null),
        onSent: () => {
          setDraft(null);
          setVersion((x) => x + 1);
        }
      }
    ),
    /* @__PURE__ */ jsx(
      ViewLoadMessages,
      {
        failed,
        errorText: t("error"),
        failedTables: failures.length > 0 ? t("failed-tables", [failures.map((x) => kindLabel(x.table ?? "")).join(", ")]) : null,
        retryText: t("retry"),
        onRetry: refresh,
        retryDisabled: !canReload
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-timeline-scroll", styles.scroll), style: maxHeight ? { maxHeight } : void 0, children: [
      items.length > 0 && /* @__PURE__ */ jsx("div", { className: "ppp-timeline-groups", children: groups.map((group) => /* @__PURE__ */ jsxs("section", { className: "ppp-timeline-group", children: [
        group.heading && /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-timeline-heading", styles.heading), role: "heading", "aria-level": 3, children: /* @__PURE__ */ jsx(Text, { weight: "semibold", children: group.heading }) }),
        /* @__PURE__ */ jsx("ol", { className: styles.list, children: group.items.map((item) => {
          const template = templates?.[item.table];
          const page = showRecordLinks ? findRecordPage(recordPages, item.table) : void 0;
          return /* @__PURE__ */ jsx(
            TimelineEntry,
            {
              item,
              ...page && { pageUrl: recordPageUrl(page, item.id) },
              ...onNavigate && { onNavigate },
              upcoming: upcomingItem(item),
              ...tableIcons && item.table.toLowerCase() in tableIcons ? { tableIcon: tableIcons[item.table.toLowerCase()] ?? null } : {},
              ...template ? { template: template(item.source) } : {},
              actions: {
                canEdit: may(item, TableSecurityPermission.Write),
                canDelete: may(item, TableSecurityPermission.Delete),
                editing: editingKey === item.key,
                form: editingKey === item.key && !ownFields(item.table, forms?.[item.table]?.edit) ? inPlaceForm(item.table, forms?.[item.table]?.edit) : null,
                onEdit: () => editedInPlace(item) ? setEditingKey(item.key) : setPanel({ table: item.table, id: item.id }),
                onStopEditing: () => setEditingKey(null),
                onSaved: () => {
                  setEditingKey(null);
                  setVersion((x) => x + 1);
                },
                onDelete: () => void remove(item)
              }
            },
            item.key
          );
        }) })
      ] }, group.upcoming ? "upcoming" : "rest")) }),
      loading && /* @__PURE__ */ jsx(Spinner, { size: "tiny", label: t("loading") }),
      !loading && !failed && items.length === 0 && /* @__PURE__ */ jsx(Text, { children: term ? t("empty-search") : tableSet.hidesAny || filtered ? t("empty-filter") : t("empty") }),
      !loading && next && /* @__PURE__ */ jsx("div", { className: styles.footer, children: /* @__PURE__ */ jsx(Button, { onClick: () => void loadMore(), children: t("load-more") }) })
    ] }),
    /* @__PURE__ */ jsx(
      MultiTableFilterDialog,
      {
        open: tableSet.filterDialog !== null,
        tabs: tableSet.filterDialog?.tabs ?? [],
        viewTabs: tableSet.filterDialog?.viewTabs,
        onApply: (criteria, restoreView) => void tableSet.applyFilter(criteria, restoreView),
        onCancel: tableSet.closeFilter
      }
    ),
    /* @__PURE__ */ jsx(SavedViewDialogs, { session }),
    panel && panelInfo?.definition && /* @__PURE__ */ jsx(
      MultiTableRecordPanel,
      {
        title: panel.record ? newLabel(panel.table) : t("edit-item", [kindLabel(panel.table)]),
        ...panel.record ? { record: panel.record } : {},
        ...panel.id ? { existing: { table: panel.table, id: panel.id } } : {},
        form: panel.record ? forms?.[panel.table]?.create : forms?.[panel.table]?.edit,
        location: formLocation === "left" ? "panel-left" : formLocation === "center" ? "center" : "panel",
        definition: panelInfo.definition,
        onClose: () => setPanel(null),
        onSaved: () => {
          setPanel(null);
          setVersion((x) => x + 1);
        }
      }
    )
  ] }) });
}
function Composer({ draft, form, onClose, onSent }) {
  const styles = useStyles29();
  const t = usePrefixedT("app.components.timeline");
  const note = draft.tableName === NOTE_TABLE;
  return /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-timeline-composer", styles.composer), children: /* @__PURE__ */ jsxs(RecordContext, { table: draft.tableName, initialRecord: draft, isolated: true, children: [
    form ?? /* @__PURE__ */ jsxs(EditorLabelPositionProvider, { position: EditorLabelPosition.Above, children: [
      /* @__PURE__ */ jsx(TextEdit, { columnName: "subject", label: t("subject") }),
      note ? /* @__PURE__ */ jsx(RichEdit, { columnName: "notetext", label: t("note"), rows: 4, toolbarMode: RichEditToolbarMode.Condensed }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(RichEdit, { columnName: "description", label: t("message"), rows: 4, toolbarMode: RichEditToolbarMode.Condensed }),
        /* @__PURE__ */ jsx(FileEdit, { columnName: PORTAL_COMMUNICATION_ATTACHMENT_COLUMN, label: t("attachment") })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles.formActions, children: [
      /* @__PURE__ */ jsx(Button, { onClick: onClose, children: t("cancel") }),
      /* @__PURE__ */ jsx(SaveContextButton, { label: t("send"), appearance: "primary", onSaved: onSent })
    ] })
  ] }) });
}
function useTableIcons(tables) {
  const { ppp } = usePowerPortalsPro();
  const [icons2, setIcons] = useState({});
  const shows = tables.length > 1;
  const key3 = tables.map((x) => x.toLowerCase()).join(",");
  useEffect(() => {
    const missing = key3.split(",").filter((x) => shows && x && !(x in icons2));
    if (missing.length === 0) return;
    let current = true;
    ppp.retrieveTableMetadataBatchAsync(missing.map((tableName) => ({ tableName, columns: [], relationships: [] }))).then((tables2) => {
      if (!current) return;
      const read2 = Object.fromEntries(missing.map((x) => [x, tables2.find((table) => table.tableName?.toLowerCase() === x)?.iconUrl ?? null]));
      setIcons((before) => ({ ...before, ...read2 }));
    }).catch((error) => {
      console.warn("[Timeline] The icons of its tables could not be read.", error);
      if (current) setIcons((before) => ({ ...before, ...Object.fromEntries(missing.map((x) => [x, null])) }));
    });
    return () => {
      current = false;
    };
  }, [ppp, key3, shows]);
  return shows ? icons2 : void 0;
}
function FallbackTableIcon({ table }) {
  switch (table.toLowerCase()) {
    case NOTE_TABLE:
      return /* @__PURE__ */ jsx(Note20Regular, {});
    case PORTAL_COMMUNICATION_TABLE:
      return /* @__PURE__ */ jsx(Chat20Regular, {});
    case "appointment":
    case "recurringappointmentmaster":
      return /* @__PURE__ */ jsx(CalendarLtr20Regular, {});
    case "task":
      return /* @__PURE__ */ jsx(TaskListSquareLtr20Regular, {});
    case "phonecall":
      return /* @__PURE__ */ jsx(Call20Regular, {});
    case "email":
      return /* @__PURE__ */ jsx(Mail20Regular, {});
    case "letter":
      return /* @__PURE__ */ jsx(DocumentText20Regular, {});
    default:
      return /* @__PURE__ */ jsx(Document20Regular, {});
  }
}
function TimelineEntry({
  item,
  actions,
  template,
  upcoming,
  tableIcon,
  pageUrl,
  onNavigate
}) {
  const styles = useStyles29();
  const t = usePrefixedT("app.components.timeline");
  const translate = useT();
  const { locale } = useLocale();
  const timeZone = useUserTimeZone();
  const { ppp } = usePowerPortalsPro();
  const [downloadFailed, setDownloadFailed] = useState(false);
  const [preview, setPreview] = useState(null);
  const previewRequest = useRef(0);
  const name = item.author?.name || t("unknown-author");
  const previewable = !!item.attachment && categorizeFile({ mimeType: getMimeFromFileName(item.attachment.fileName), fileName: item.attachment.fileName }) !== "download";
  const created = item.createdOnText ?? formatDate2(item.createdOn, locale, timeZone);
  const kind = item.kind === "note" ? t("note") : item.kind === "portalCommunication" ? t("portal-communication") : tableLabel3(translate, item.table);
  const attachmentBytes = async (attachment) => {
    const bytes = attachment.column === null ? noteBytes(await ppp.retrieveRecordAsync(NOTE_TABLE, item.id, ["documentbody"])) : await fetchFileBytes(ppp, item.table, item.id, attachment.column);
    if (!bytes) throw new Error(`${attachment.fileName} has no content.`);
    return bytes;
  };
  const download = async () => {
    const attachment = item.attachment;
    if (!attachment) return;
    setDownloadFailed(false);
    try {
      triggerBlobDownload(await attachmentBytes(attachment), attachment.fileName);
    } catch (error) {
      console.error("[Timeline] The attachment could not be downloaded.", error);
      setDownloadFailed(true);
    }
  };
  const showPreview = async () => {
    const attachment = item.attachment;
    if (!attachment) return;
    const request = ++previewRequest.current;
    setPreview({ fileName: attachment.fileName, source: null, failed: false });
    try {
      const source = { kind: "bytes", value: await attachmentBytes(attachment), fileName: attachment.fileName };
      if (previewRequest.current === request) setPreview({ fileName: attachment.fileName, source, failed: false });
    } catch (error) {
      console.error("[Timeline] The attachment could not be previewed.", error);
      if (previewRequest.current === request) setPreview({ fileName: attachment.fileName, source: null, failed: true });
    }
  };
  const closePreview = () => {
    previewRequest.current++;
    setPreview(null);
  };
  return /* @__PURE__ */ jsxs(
    "li",
    {
      className: mergeClasses("ppp-timeline-item", styles.entry, upcoming && styles.upcomingEntry),
      "data-kind": item.kind,
      "data-upcoming": upcoming ? "true" : void 0,
      children: [
        /* @__PURE__ */ jsx(Avatar, { name, color: "colorful", size: 32 }),
        /* @__PURE__ */ jsxs("div", { className: styles.content, children: [
          /* @__PURE__ */ jsxs("div", { className: styles.meta, children: [
            /* @__PURE__ */ jsx(Text, { weight: "semibold", children: name }),
            /* @__PURE__ */ jsx(Caption1, { children: /* @__PURE__ */ jsx("time", { dateTime: item.createdOn, children: created }) }),
            item.modifiedOn && /* @__PURE__ */ jsx(Tooltip, { content: item.modifiedOnText ?? formatDate2(item.modifiedOn, locale, timeZone), relationship: "description", children: /* @__PURE__ */ jsx(Caption1, { children: t("edited") }) }),
            !actions.editing && actions.canEdit && /* @__PURE__ */ jsx(Tooltip, { content: t("edit"), relationship: "label", children: /* @__PURE__ */ jsx(Button, { appearance: "transparent", size: "small", icon: /* @__PURE__ */ jsx(EditRegular, {}), onClick: actions.onEdit }) }),
            !actions.editing && actions.canDelete && /* @__PURE__ */ jsx(Tooltip, { content: t("delete"), relationship: "label", children: /* @__PURE__ */ jsx(Button, { appearance: "transparent", size: "small", icon: /* @__PURE__ */ jsx(DeleteRegular, {}), onClick: actions.onDelete }) }),
            tableIcon !== void 0 && /* @__PURE__ */ jsx(Tooltip, { content: kind, relationship: "label", children: /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-timeline-table-icon", styles.tableIcon), role: "img", children: tableIcon ? /* @__PURE__ */ jsx(
              "span",
              {
                className: mergeClasses("ppp-timeline-table-icon-image", styles.tableIconImage),
                style: { "--ppp-timeline-table-icon": `url('${tableIcon}')` }
              }
            ) : /* @__PURE__ */ jsx(FallbackTableIcon, { table: item.table }) }) })
          ] }),
          actions.editing ? /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-timeline-composer", styles.composer), children: /* @__PURE__ */ jsxs(RecordContext, { table: item.table, id: item.id, isolated: true, children: [
            actions.form ?? /* @__PURE__ */ jsxs(EditorLabelPositionProvider, { position: EditorLabelPosition.Above, children: [
              (item.kind !== "note" || item.title !== null) && /* @__PURE__ */ jsx(TextEdit, { columnName: "subject", label: t("subject") }),
              /* @__PURE__ */ jsx(
                RichEdit,
                {
                  columnName: item.kind === "note" ? "notetext" : "description",
                  label: t(item.kind === "note" ? "note" : "message"),
                  rows: 4,
                  toolbarMode: RichEditToolbarMode.Condensed
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("div", { className: styles.formActions, children: [
              /* @__PURE__ */ jsx(Button, { onClick: actions.onStopEditing, children: t("cancel") }),
              /* @__PURE__ */ jsx(SaveContextButton, { label: t("save"), appearance: "primary", onSaved: actions.onSaved })
            ] })
          ] }) }) : template !== void 0 ? template : /* @__PURE__ */ jsxs(Fragment, { children: [
            item.title && /* @__PURE__ */ jsx(Body1Strong, { children: pageUrl !== void 0 ? /* @__PURE__ */ jsx(RecordLink, { href: pageUrl, onNavigate, children: item.title }) : item.title }),
            item.body && /* @__PURE__ */ jsx(TimelineBody, { value: item.body }),
            item.attachment && /* @__PURE__ */ jsxs("div", { className: styles.attachment, children: [
              /* @__PURE__ */ jsx(Tooltip, { content: t("download", [item.attachment.fileName]), relationship: "description", children: /* @__PURE__ */ jsx(Button, { appearance: "subtle", size: "small", icon: /* @__PURE__ */ jsx(AttachRegular, {}), onClick: () => void download(), children: item.attachment.fileName }) }),
              previewable && /* @__PURE__ */ jsx(Tooltip, { content: translate("app.buttons.preview-item", [item.attachment.fileName]), relationship: "label", children: /* @__PURE__ */ jsx(Button, { appearance: "transparent", size: "small", icon: /* @__PURE__ */ jsx(EyeRegular, {}), onClick: () => void showPreview() }) })
            ] }),
            downloadFailed && item.attachment && /* @__PURE__ */ jsx(MessageBar, { intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("download-failed", [item.attachment.fileName]) }) })
          ] })
        ] }),
        /* @__PURE__ */ jsx(Dialog, { open: preview !== null, onOpenChange: (_, data) => !data.open && closePreview(), modalType: "modal", children: /* @__PURE__ */ jsx(DialogSurface, { className: styles.previewSurface, children: preview && /* @__PURE__ */ jsxs(DialogBody, { children: [
          /* @__PURE__ */ jsx(DialogTitle, { children: preview.fileName }),
          /* @__PURE__ */ jsx(DialogContent, { className: styles.previewContent, children: preview.source ? /* @__PURE__ */ jsx(FileViewer, { source: preview.source, fileName: preview.fileName }) : preview.failed ? /* @__PURE__ */ jsx(MessageBar, { intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: translate("app.components.file-grid.preview-load-error-title") }) }) : /* @__PURE__ */ jsx("div", { className: styles.previewLoading, children: /* @__PURE__ */ jsx(Spinner, { label: t("loading") }) }) }),
          /* @__PURE__ */ jsx(DialogActions, { children: /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: closePreview, children: translate("app.buttons.close.label") }) })
        ] }) }) })
      ]
    }
  );
}
function tableLabel3(translate, table) {
  const key3 = `tables.${table}.label`;
  const label = translate(key3);
  return label && label !== key3 ? label : table;
}
function TimelineBody({ value: value2 }) {
  const styles = useStyles29();
  const t = usePrefixedT("app.components.timeline");
  const container = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);
  useLayoutEffect(() => {
    const element = container.current;
    if (!element || expanded) return;
    const measure = () => setOverflows(element.scrollHeight > element.clientHeight + 1);
    measure();
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure);
    observer?.observe(element);
    return () => observer?.disconnect();
  }, [value2, expanded]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { ref: container, className: mergeClasses(styles.body, !expanded && styles.collapsed, !expanded && overflows && styles.faded), children: /* @__PURE__ */ jsx(RichTextView, { value: value2 }) }),
    (overflows || expanded) && /* @__PURE__ */ jsx(Button, { appearance: "transparent", size: "small", onClick: () => setExpanded((open) => !open), children: expanded ? t("show-less") : t("show-more") })
  ] });
}
function noteBytes(note) {
  const body = note.properties?.["documentbody"]?.value;
  return typeof body === "string" && body !== "" ? base64ToBytes(body) : null;
}
function formatDate2(value2, locale, timeZone) {
  const date = new Date(value2);
  if (Number.isNaN(date.getTime())) return value2;
  try {
    return new Intl.DateTimeFormat(locale, { ...timeZone ? { timeZone } : {}, dateStyle: "medium", timeStyle: "short" }).format(date);
  } catch {
    return date.toLocaleString();
  }
}
var buttonKeys = {
  [CloseRecordAction.Win]: "win-opportunity",
  [CloseRecordAction.Lose]: "lose-opportunity",
  [CloseRecordAction.Resolve]: "resolve-case",
  [CloseRecordAction.WinQuote]: "win-quote",
  [CloseRecordAction.CloseQuote]: "close-quote",
  [CloseRecordAction.FulfillOrder]: "fulfill-order",
  [CloseRecordAction.CancelOrder]: "cancel-order"
};
var titleKeys = {
  [CloseRecordAction.Win]: "win",
  [CloseRecordAction.Lose]: "lose",
  [CloseRecordAction.Resolve]: "resolve",
  [CloseRecordAction.WinQuote]: "win-quote",
  [CloseRecordAction.CloseQuote]: "close-quote",
  [CloseRecordAction.FulfillOrder]: "fulfill-order",
  [CloseRecordAction.CancelOrder]: "cancel-order"
};
function closeRecordButtonKey(action) {
  return buttonKeys[action];
}
function closeRecordActionName(action) {
  return Object.entries(CloseRecordAction).find(([, value2]) => value2 === action)?.[0] ?? String(action);
}
var COMPETITOR_TABLE = "competitor";
var COMPETITOR_COLUMN = "competitorid";
var COMPETITOR_ACCESS = TableSecurityPermission.Read | TableSecurityPermission.AppendTo;
var COMPETITOR_RESULTS = 10;
var SEARCH_DEBOUNCE_MS3 = 300;
function useCloseRecordDialog() {
  const dialog = useDialogService();
  const t = useT();
  const timeZone = useUserTimeZone();
  return useCallback(
    async ({ record, tableMetadata, action, statusReason }) => {
      const definition = closeRecordDefinition(action);
      if (record.tableName.toLowerCase() !== definition.table) {
        throw new Error(
          `A record is closed with ${closeRecordActionName(action)} only when it is an ${definition.table}, and this one is of '${record.tableName}'.`
        );
      }
      const states = getStateColumn(tableMetadata, "state");
      const reasons = getStateColumn(tableMetadata, "status");
      if (!reasons) throw new Error(`'${record.tableName}' has no status reason column.`);
      const offered = closeReasonsFor(action, states, reasons);
      if (offered.length === 0) {
        throw new Error(
          `'${record.tableName}' has no status reason to close a record with ${closeRecordActionName(action)}: the state it closes into has no reason that isn't hidden, and no default.`
        );
      }
      const initial = offered.some((x) => x.value === statusReason) ? statusReason : states?.choices.find((x) => x.value === definition.state)?.defaultStatus ?? void 0;
      const estimated = record.properties?.["estimatedvalue"]?.value;
      const result = await dialog.showDialogAsync(
        (handle) => /* @__PURE__ */ jsx(
          CloseRecordDialogContent,
          {
            handle,
            record: { tableName: record.tableName, id: record.id },
            action,
            closeTable: definition.closeTable,
            reasonLabel: t(`tables.${record.tableName}.columns.${reasons.columnName}.label`),
            offered,
            initial: initial ?? void 0,
            estimatedValue: action === CloseRecordAction.Win && typeof estimated === "number" ? estimated : void 0,
            timeZone,
            labelOf: (x) => resolveChoiceLabel(t, record.tableName, reasons.columnName, reasons.choiceLogicalName ?? "", x.value, x.displayName ?? "")
          }
        ),
        {
          title: t(`app.components.close-record-dialog.${titleKeys[action]}-title`),
          primaryText: t(`app.buttons.${buttonKeys[action]}.label`),
          secondaryText: t("app.buttons.cancel.label")
        }
      );
      return result.canceled ? void 0 : result.data;
    },
    [dialog, t, timeZone]
  );
}
var useStyles30 = makeStyles({
  root: { display: "flex", flexDirection: "column", rowGap: tokens.spacingVerticalM }
});
function today(timeZone) {
  const now = timeZone ? toZonedWallClock(/* @__PURE__ */ new Date(), timeZone) : /* @__PURE__ */ new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}
function CloseRecordDialogContent({
  handle,
  record,
  action,
  closeTable,
  reasonLabel,
  offered,
  initial,
  estimatedValue,
  timeZone,
  labelOf
}) {
  const t = useT();
  const styles = useStyles30();
  const resolves = action === CloseRecordAction.Resolve;
  const [reason, setReason] = useState(offered.some((x) => x.value === initial) ? initial : offered[0]?.value);
  const [revenue, setRevenue] = useState(estimatedValue === void 0 ? "" : String(estimatedValue));
  const [closeDate, setCloseDate] = useState(() => resolves ? null : today(timeZone));
  const [resolution, setResolution] = useState("");
  const [billableMinutes, setBillableMinutes] = useState("");
  const [description, setDescription] = useState("");
  const [competitor, setCompetitor] = useState(null);
  const [resolutionMissing, setResolutionMissing] = useState(false);
  const label = (key3) => t(`app.components.close-record-dialog.${key3}`);
  handle.onPrimary(async () => {
    if (resolves && resolution.trim() === "") {
      setResolutionMissing(true);
      return KEEP_OPEN;
    }
    if (reason === void 0) return KEEP_OPEN;
    const properties = {};
    if (action === CloseRecordAction.Win && revenue.trim() !== "" && Number.isFinite(Number(revenue))) {
      properties["actualrevenue"] = { $type: ColumnType.Money, value: Number(revenue) };
    }
    if (!resolves && closeDate) {
      const day = new Date(closeDate.getFullYear(), closeDate.getMonth(), closeDate.getDate());
      properties["actualend"] = {
        $type: ColumnType.DateTime,
        value: (timeZone ? fromZonedWallClock(day, timeZone) : day).toISOString()
      };
    }
    if (resolves) {
      properties["subject"] = { $type: ColumnType.String, value: resolution.trim() };
      const minutes = Number.parseInt(billableMinutes, 10);
      if (Number.isFinite(minutes)) properties["timespent"] = { $type: ColumnType.Integer, value: minutes };
    }
    if (action === CloseRecordAction.Lose && competitor) {
      properties[COMPETITOR_COLUMN] = { $type: ColumnType.Lookup, tableName: COMPETITOR_TABLE, value: competitor.id, name: competitor.name };
    }
    if (description.trim() !== "") properties["description"] = { $type: ColumnType.String, value: description };
    return {
      $type: "CloseRecordRequest",
      record,
      statusReason: reason,
      details: { tableName: closeTable, properties }
    };
  });
  return /* @__PURE__ */ jsxs("div", { className: `ppp-close-record-dialog ${styles.root}`, children: [
    offered.length === 1 ? (
      // One reason leaves nothing to choose: it is shown, not offered.
      /* @__PURE__ */ jsx(Field, { label: reasonLabel, children: /* @__PURE__ */ jsx(Text, { children: labelOf(offered[0]) }) })
    ) : /* @__PURE__ */ jsx(Field, { label: reasonLabel, children: /* @__PURE__ */ jsx(RadioGroup, { value: reason === void 0 ? "" : String(reason), onChange: (_, data) => setReason(Number(data.value)), children: offered.map((x) => /* @__PURE__ */ jsx(Radio, { value: String(x.value), label: labelOf(x) }, x.value)) }) }),
    action === CloseRecordAction.Win && /* @__PURE__ */ jsx(Field, { label: label("actual-revenue"), children: /* @__PURE__ */ jsx(Input, { type: "number", min: 0, step: "0.01", value: revenue, onChange: (_, data) => setRevenue(data.value) }) }),
    action === CloseRecordAction.Lose && /* @__PURE__ */ jsx(CompetitorField, { label: label("competitor"), value: competitor, onChange: setCompetitor }),
    !resolves && /* @__PURE__ */ jsx(Field, { label: label("close-date"), children: /* @__PURE__ */ jsx(DatePicker, { value: closeDate, onSelectDate: (date) => setCloseDate(date ?? null), allowTextInput: true }) }),
    resolves && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Field,
        {
          label: label("resolution"),
          required: true,
          validationState: resolutionMissing ? "error" : "none",
          ...resolutionMissing && { validationMessage: label("resolution-required") },
          children: /* @__PURE__ */ jsx(
            Input,
            {
              maxLength: 200,
              value: resolution,
              onChange: (_, data) => {
                setResolution(data.value);
                if (data.value.trim() !== "") setResolutionMissing(false);
              }
            }
          )
        }
      ),
      /* @__PURE__ */ jsx(Field, { label: label("billable-time"), children: /* @__PURE__ */ jsx(Input, { type: "number", min: 0, step: "1", value: billableMinutes, onChange: (_, data) => setBillableMinutes(data.value) }) })
    ] }),
    /* @__PURE__ */ jsx(Field, { label: label("description"), children: /* @__PURE__ */ jsx(Textarea, { value: description, onChange: (_, data) => setDescription(data.value), resize: "vertical" }) })
  ] });
}
function CompetitorField({
  label,
  value: value2,
  onChange
}) {
  const t = useT();
  const { ppp } = usePowerPortalsPro();
  const permissions = useTablePermissions(COMPETITOR_TABLE);
  const allowed = permissions.status === QueryStatus.Success && (Number(permissions.data ?? 0) & COMPETITOR_ACCESS) === COMPETITOR_ACCESS;
  const [query, setQuery] = useState(null);
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [refused, setRefused] = useState(false);
  useEffect(() => {
    if (!allowed || refused || query === null) return;
    const controller = new AbortController();
    const timer = setTimeout(() => {
      setSearching(true);
      ppp.searchLookupAsync(
        { tableName: COMPETITOR_TABLE, ...query.trim() && { searchText: query.trim() }, maxRecords: COMPETITOR_RESULTS },
        controller.signal
      ).then((response) => {
        if (controller.signal.aborted) return;
        const nameColumn = response.columns.find((x) => x.isPrimaryName)?.columnName ?? "name";
        setResults(
          response.tableRecords.flatMap((x) => {
            const name = x.properties?.[nameColumn]?.value;
            return x.id ? [{ id: x.id, name: typeof name === "string" ? name : "" }] : [];
          })
        );
      }).catch((error) => {
        if (controller.signal.aborted) return;
        if (error instanceof UnauthorizedAccessError || error instanceof PowerPortalsProError && error.status === 403) setRefused(true);
        setResults([]);
      }).finally(() => {
        if (!controller.signal.aborted) setSearching(false);
      });
    }, SEARCH_DEBOUNCE_MS3);
    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [allowed, refused, query, ppp]);
  useEffect(() => {
    if (refused && value2) onChange(null);
  }, [refused, value2, onChange]);
  if (!allowed || refused) return null;
  return /* @__PURE__ */ jsx(Field, { label, children: /* @__PURE__ */ jsx(
    Combobox,
    {
      className: "ppp-close-record-competitor",
      clearable: true,
      expandIcon: /* @__PURE__ */ jsx(Search20Regular, {}),
      value: query ?? value2?.name ?? "",
      selectedOptions: value2 ? [value2.id] : [],
      onChange: (event) => setQuery(event.target.value),
      onOpenChange: (_, data) => {
        if (data.open) setQuery((x) => x ?? "");
        else setQuery(null);
      },
      onOptionSelect: (_, data) => {
        const chosen = results.find((x) => x.id === data.optionValue) ?? (data.optionValue === value2?.id ? value2 : null);
        onChange(chosen ?? null);
        setQuery(null);
      },
      children: searching ? /* @__PURE__ */ jsx(Option, { value: "__searching__", text: t("app.components.lookup-edit.searching"), disabled: true, children: t("app.components.lookup-edit.searching") }, "__searching__") : results.length === 0 ? /* @__PURE__ */ jsx(Option, { value: "__none__", text: t("app.components.lookup-edit.no-matches"), disabled: true, children: t("app.components.lookup-edit.no-matches") }, "__none__") : results.map((x) => /* @__PURE__ */ jsx(Option, { value: x.id, text: x.name || t("app.components.lookup-edit.unnamed-record"), children: x.name || t("app.components.lookup-edit.unnamed-record") }, x.id))
    }
  ) });
}
function SearchHighlightedText({
  text: text2,
  highlight,
  className
}) {
  if (highlight?.kind === "text") return /* @__PURE__ */ jsx(Highlighter, { text: text2, searchText: highlight.term, className });
  if (highlight?.kind === "whole") return /* @__PURE__ */ jsx(HighlightFull, { text: text2, className });
  return /* @__PURE__ */ jsx("span", { className, children: text2 });
}
var KanbanBoardContext = createContext(null);
function useKanbanBoardContext() {
  const board = useContext(KanbanBoardContext);
  if (!board) throw new Error("useKanbanBoardContext must be used inside a <KanbanBoard>.");
  return board;
}
function KanbanBoardButton({ onClick, label, icon, tooltip, appearance = "subtle", disabled = false, className }) {
  const board = useKanbanBoardContext();
  const [working, setWorking] = useState(false);
  const click = async () => {
    if (working || !onClick) return;
    setWorking(true);
    try {
      await onClick(board);
    } finally {
      setWorking(false);
    }
  };
  const button = /* @__PURE__ */ jsx(
    Button,
    {
      className: mergeClasses("ppp-kanban-button", className),
      appearance,
      disabled: disabled || working,
      icon: icon ?? null,
      "aria-label": label === void 0 ? tooltip : void 0,
      onClick: () => void click(),
      children: label
    }
  );
  return tooltip ? /* @__PURE__ */ jsx(Tooltip, { content: tooltip, relationship: label === void 0 ? "label" : "description", withArrow: true, children: button }) : button;
}
function KanbanDefaultForm() {
  const definition = useMultiTableForm()?.definition;
  const columns = [
    ...new Map(
      (definition?.columns ?? []).filter((column) => !column.includes(".")).map((column) => [column.toLowerCase(), column])
    ).values()
  ];
  return /* @__PURE__ */ jsx(DefaultFormFields, { className: "ppp-kanban-default-form", columns });
}
var GUID2 = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function readPersistedKanbanState(queryParameterName) {
  if (!queryParameterName || typeof window === "undefined") return {};
  const raw = new URLSearchParams(window.location.search).get(queryParameterName);
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
    const { v, q, c } = parsed;
    const state = {};
    if (typeof v === "string" && GUID2.test(v)) state.v = v.toLowerCase();
    if (typeof q === "string" && q.trim()) state.q = q;
    if (Array.isArray(c)) state.c = c.filter((x) => typeof x === "string");
    return state;
  } catch {
    return {};
  }
}
function encodePersistedKanbanState(state) {
  const compact = {};
  if (state.v) compact.v = state.v;
  if (state.q?.trim()) compact.q = state.q;
  if (state.c) compact.c = state.c;
  return Object.keys(compact).length > 0 ? JSON.stringify(compact) : null;
}
function writePersistedKanbanState(queryParameterName, state) {
  if (!queryParameterName) return;
  replaceQueryParam(queryParameterName, encodePersistedKanbanState(state) ?? void 0);
}
var entityOf = (fetch2) => fetch2.children.find((x) => x.name === "entity");
function joinsOf(element) {
  return element.children.flatMap((x) => x.name === "link-entity" ? [x, ...joinsOf(x)] : []);
}
function queriedColumns2(fetchXml) {
  const entity = entityOf(parseXml(fetchXml));
  if (!entity) return [];
  const names2 = (element) => element.children.filter((x) => x.name === "attribute" && x.attributes["name"]).map((x) => x.attributes["name"]);
  const columns = names2(entity);
  for (const join of joinsOf(entity)) {
    const alias = join.attributes["alias"];
    if (alias) columns.push(...names2(join).map((name) => `${alias}.${name}`));
  }
  return columns;
}
function joinAliases(fetchXml) {
  const entity = entityOf(parseXml(fetchXml));
  return entity ? joinsOf(entity).flatMap((x) => x.attributes["alias"] ? [x.attributes["alias"]] : []) : [];
}
function joinCount(fetchXml) {
  try {
    const root = parseXml(fetchXml);
    const entity = entityOf(root) ?? root;
    return joinsOf(entity).length;
  } catch {
    return 0;
  }
}
function querySorts(fetchXml) {
  const entity = entityOf(parseXml(fetchXml));
  return (entity?.children ?? []).filter((x) => x.name === "order" && x.attributes["attribute"]).map((x) => {
    const alias = x.attributes["entityname"];
    return {
      columnName: alias ? `${alias}.${x.attributes["attribute"]}` : x.attributes["attribute"],
      ...x.attributes["descending"]?.toLowerCase() === "true" && { descending: true }
    };
  });
}
function boardQuery(source, criteria, sort) {
  const fetch2 = parseXml(criteria ? applyGridCriteria(source, criteria) : source);
  for (const name of ["count", "page", "paging-cookie", "returntotalrecordcount"]) delete fetch2.attributes[name];
  const entity = entityOf(fetch2);
  if (entity && sort && sort.length > 0) {
    entity.children = [
      ...entity.children.filter((x) => x.name !== "order"),
      // A joined column's sort names its join, as a grid's does.
      ...sort.map((x) => {
        const dot = x.columnName.indexOf(".");
        return {
          name: "order",
          attributes: {
            ...dot > 0 && { entityname: x.columnName.slice(0, dot) },
            attribute: dot > 0 ? x.columnName.slice(dot + 1) : x.columnName,
            descending: x.descending ? "true" : "false"
          },
          children: [],
          text: ""
        };
      })
    ];
  }
  return serializeXml(fetch2);
}
var useKanbanStyles = makeStyles({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    minHeight: 0
  },
  lanes: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    alignItems: "stretch",
    columnGap: tokens.spacingHorizontalM,
    overflowX: "auto",
    overflowY: "hidden",
    paddingBottom: tokens.spacingVerticalXS,
    scrollSnapType: "x proximity"
  },
  lane: {
    flex: "0 0 280px",
    width: "280px",
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: tokens.borderRadiusLarge,
    scrollSnapAlign: "start",
    outlineStyle: "solid",
    outlineWidth: tokens.strokeWidthThick,
    outlineColor: "transparent",
    outlineOffset: `calc(${tokens.strokeWidthThin} * -1)`,
    "@media (max-width: 600px)": {
      flexBasis: "min(85vw, 280px)",
      width: "min(85vw, 280px)"
    }
  },
  // A lane holding more cards than its limit, edged in the danger color as the Blazor board's is.
  laneOverLimit: {
    boxShadow: `inset 0 0 0 ${tokens.strokeWidthThick} ${tokens.colorStatusDangerBorder2}`
  },
  // The lane a card being dragged would drop in.
  laneOver: {
    backgroundColor: tokens.colorNeutralBackground2Hover,
    outlineColor: tokens.colorBrandStroke1
  },
  laneCollapsed: {
    flex: "0 0 auto",
    width: "auto",
    "@media (max-width: 600px)": {
      flexBasis: "auto",
      width: "auto"
    }
  },
  // The header stays at the lane's top while its cards scroll under it.
  header: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalS} ${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`
  },
  heading: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    minWidth: 0
  },
  label: {
    flex: "0 1 auto",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontWeight: tokens.fontWeightSemibold
  },
  // The lane's Add and collapse buttons, together at the end of its heading.
  laneActions: {
    display: "flex",
    alignItems: "center",
    marginInlineStart: "auto"
  },
  dot: {
    flex: "none",
    width: "10px",
    height: "10px",
    borderRadius: tokens.borderRadiusCircular,
    // The option's own color is set on the element; this outlines a light one on a light lane.
    boxShadow: `0 0 0 ${tokens.strokeWidthThin} ${tokens.colorNeutralStroke2}`
  },
  // The lane's totals, each under its label, as a grid's totals row stacks them.
  totals: {
    display: "flex",
    flexWrap: "wrap",
    rowGap: tokens.spacingVerticalXXS,
    columnGap: tokens.spacingHorizontalM,
    margin: 0
  },
  total: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0
  },
  totalLabel: {
    fontSize: tokens.fontSizeBase100,
    lineHeight: tokens.lineHeightBase100,
    color: tokens.colorNeutralForeground3,
    fontWeight: tokens.fontWeightRegular
  },
  totalValue: {
    margin: 0,
    fontWeight: tokens.fontWeightSemibold
  },
  body: {
    position: "relative",
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    overflowY: "auto",
    padding: `0 ${tokens.spacingHorizontalS} ${tokens.spacingVerticalS}`
  },
  // No cards: said at the top of the lane, over the space a card is dropped in.
  empty: {
    position: "absolute",
    insetInline: tokens.spacingHorizontalS,
    top: tokens.spacingVerticalM,
    textAlign: "center",
    color: tokens.colorNeutralForeground3,
    pointerEvents: "none"
  },
  loading: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS
  },
  failed: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    rowGap: tokens.spacingVerticalS
  },
  // The cards: a list the whole lane's height, so a card can be dropped anywhere in it.
  cards: {
    flex: "1 0 auto",
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    minHeight: `calc(${tokens.spacingVerticalXXXL} * 2)`,
    margin: 0,
    padding: 0,
    listStyleType: "none"
  },
  // A card, with its Move to menu in its top corner.
  card: {
    position: "relative",
    borderRadius: tokens.borderRadiusMedium,
    ":focus-visible": {
      outlineStyle: "solid",
      outlineWidth: tokens.strokeWidthThick,
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: tokens.strokeWidthThin
    }
  },
  // Room for the Move to button beside the card's content.
  recordCard: {
    paddingInlineEnd: `calc(${tokens.spacingHorizontalXXL} + ${tokens.spacingHorizontalS})`
  },
  // Where the card being dragged was: a dashed outline, the card itself in the overlay.
  cardDragging: {
    opacity: 0.4,
    outlineStyle: "dashed",
    outlineWidth: tokens.strokeWidthThin,
    outlineColor: tokens.colorBrandStroke1
  },
  // The card being dragged, raised.
  overlay: {
    boxShadow: tokens.shadow16,
    cursor: "grabbing"
  },
  actions: {
    position: "absolute",
    top: tokens.spacingVerticalXS,
    insetInlineEnd: tokens.spacingHorizontalXS
  },
  // A card dragged by its grip, on a touch screen, so a finger can still scroll the board.
  grip: {
    display: "flex",
    alignItems: "center",
    padding: 0,
    border: "none",
    background: "none",
    color: tokens.colorNeutralForeground3,
    cursor: "grab",
    touchAction: "none"
  },
  // A collapsed lane: a narrow strip, its name and count on their side; a click opens it.
  strip: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: tokens.spacingVerticalS,
    height: "100%",
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalS}`,
    border: "none",
    borderRadius: tokens.borderRadiusLarge,
    background: "none",
    color: tokens.colorNeutralForeground1,
    font: "inherit",
    cursor: "pointer",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground2Hover
    },
    ":focus-visible": {
      outlineStyle: "solid",
      outlineWidth: tokens.strokeWidthThick,
      outlineColor: tokens.colorStrokeFocus2
    }
  },
  stripLabel: {
    writingMode: "vertical-rl",
    whiteSpace: "nowrap",
    fontWeight: tokens.fontWeightSemibold
  },
  // Its own height, which a full lane's column would otherwise squeeze below its text.
  // A collapsed lane whose count couldn't be read.
  stripFailed: {
    display: "flex",
    color: tokens.colorStatusWarningForeground1
  },
  loadMore: {
    alignSelf: "center",
    flexShrink: 0
  },
  // A group's heading in the Settings menu, as Fluent UI's own group heading reads.
  menuGroup: {
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalS} ${tokens.spacingVerticalXS}`,
    cursor: "default"
  },
  search: {
    width: "220px",
    maxWidth: "100%"
  },
  title: {
    marginTop: 0,
    marginBottom: 0
  },
  visuallyHidden: {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    whiteSpace: "nowrap",
    border: 0
  }
});
var DATE_LANE_LABELS = {
  [KanbanDateLane.Earlier.key]: "app.components.kanban-board.date-lanes.earlier",
  [KanbanDateLane.Overdue.key]: "app.components.kanban-board.date-lanes.overdue",
  [KanbanDateLane.Yesterday.key]: "app.components.kanban-board.date-lanes.yesterday",
  [KanbanDateLane.Today.key]: "app.components.kanban-board.date-lanes.today",
  [KanbanDateLane.Tomorrow.key]: "app.components.kanban-board.date-lanes.tomorrow",
  [KanbanDateLane.LastWeek.key]: "app.components.kanban-board.date-lanes.last-week",
  [KanbanDateLane.ThisWeek.key]: "app.components.kanban-board.date-lanes.this-week",
  [KanbanDateLane.NextWeek.key]: "app.components.kanban-board.date-lanes.next-week",
  [KanbanDateLane.LastMonth.key]: "app.components.kanban-board.date-lanes.last-month",
  [KanbanDateLane.ThisMonth.key]: "app.components.kanban-board.date-lanes.this-month",
  [KanbanDateLane.NextMonth.key]: "app.components.kanban-board.date-lanes.next-month",
  [KanbanDateLane.LastCalendarQuarter.key]: "app.components.kanban-board.date-lanes.last-calendar-quarter",
  [KanbanDateLane.ThisCalendarQuarter.key]: "app.components.kanban-board.date-lanes.this-calendar-quarter",
  [KanbanDateLane.NextCalendarQuarter.key]: "app.components.kanban-board.date-lanes.next-calendar-quarter",
  [KanbanDateLane.LastFiscalQuarter.key]: "app.components.kanban-board.date-lanes.last-fiscal-quarter",
  [KanbanDateLane.ThisFiscalQuarter.key]: "app.components.kanban-board.date-lanes.this-fiscal-quarter",
  [KanbanDateLane.NextFiscalQuarter.key]: "app.components.kanban-board.date-lanes.next-fiscal-quarter",
  [KanbanDateLane.LastCalendarYear.key]: "app.components.kanban-board.date-lanes.last-calendar-year",
  [KanbanDateLane.ThisCalendarYear.key]: "app.components.kanban-board.date-lanes.this-calendar-year",
  [KanbanDateLane.NextCalendarYear.key]: "app.components.kanban-board.date-lanes.next-calendar-year",
  [KanbanDateLane.LastFiscalYear.key]: "app.components.kanban-board.date-lanes.last-fiscal-year",
  [KanbanDateLane.ThisFiscalYear.key]: "app.components.kanban-board.date-lanes.this-fiscal-year",
  [KanbanDateLane.NextFiscalYear.key]: "app.components.kanban-board.date-lanes.next-fiscal-year",
  [KanbanDateLane.Later.key]: "app.components.kanban-board.date-lanes.later",
  [KanbanDateLane.NoDate.key]: "app.components.kanban-board.date-lanes.no-date"
};
var FISCAL_PERIODS = [KanbanDatePeriod.FiscalQuarter, KanbanDatePeriod.FiscalYear];
var isFiscalLane = (lane) => [lane.from, lane.until].some((bound) => bound?.period !== void 0 && FISCAL_PERIODS.includes(bound.period));
function browserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}
function dateSortKey(value2) {
  const ms = typeof value2 === "string" || value2 instanceof Date ? new Date(value2).getTime() : Number.NaN;
  return Number.isNaN(ms) ? Number.POSITIVE_INFINITY : ms;
}
var sameDay = (a, b) => !!a && !!b && a.year === b.year && a.month === b.month && a.day === b.day;
var PARALLEL_LANE_READS = 4;
var COUNT_LIMIT = 5e3;
var PAGES_WAIT_MS = 5e3;
var LANE_ORDER_LIMIT = 5e3;
var PAGE_SIZES = [10, 20, 50, 100];
var NOT_READ = "";
var emptyLane = (forKey) => ({
  for: forKey,
  figuresFor: forKey,
  cards: [],
  count: void 0,
  wholeCount: void 0,
  pagesLoaded: 0,
  pagingCookie: void 0,
  moreRecords: false,
  loading: false,
  loadingMore: false,
  failed: false,
  totals: void 0,
  columnPermissions: void 0,
  emptyAtLoad: false
});
var countsShifted = (data, by) => ({
  ...data.count !== void 0 && { count: data.count + by },
  ...data.wholeCount !== void 0 && { wholeCount: data.wholeCount + by }
});
var sameName = (a, b) => a.toLowerCase() === b.toLowerCase();
var includesName = (names2, name) => names2.some((x) => sameName(x, name));
var cardIdOf = (record) => (record.id ?? "").toLowerCase();
var numberOf2 = (value2) => {
  if (value2 === null || value2 === void 0 || value2 === "") return void 0;
  const number = Number(value2);
  return Number.isFinite(number) ? number : void 0;
};
var valueOf = (record, column) => record.properties?.[column]?.value;
function withValue(record, column, value2) {
  const formattedValues = { ...record.formattedValues ?? {} };
  delete formattedValues[column];
  return { ...record, properties: { ...record.properties ?? {}, [column]: value2 }, formattedValues };
}
function createGate(limit) {
  let active = 0;
  const waiting = [];
  return {
    async acquire() {
      if (active < limit) {
        active++;
        return;
      }
      await new Promise((resolve) => waiting.push(resolve));
      active++;
    },
    release() {
      active--;
      waiting.shift()?.();
    }
  };
}
function kanbanDropTarget(overId, laneOfCard, laneKeyOfDroppable, laneLength) {
  const card = laneOfCard(overId);
  if (card) return card;
  const laneKey = laneKeyOfDroppable(overId);
  return laneKey === void 0 ? void 0 : { laneKey, index: laneLength(laneKey) };
}
var KanbanPointerSensor = class extends PointerSensor {
  static activators = [
    {
      eventName: "onPointerDown",
      handler: ({ nativeEvent: event }, { onActivation }) => {
        if (!event.isPrimary || event.button !== 0 || event.pointerType === "touch") return false;
        onActivation?.({ event });
        return true;
      }
    }
  ];
};
function KanbanBoard({
  defaultViewId: defaultViewId$1,
  viewIds,
  customViewDefinitions,
  viewSort = ViewSort.NameAscending,
  laneColumn,
  lanes: laneKeys,
  lookupLanes,
  showEmptyLanes = true,
  rankColumn,
  dateLanes: dateLanesProp,
  dateLaneDrop = KanbanDateLaneDrop.ChangeDate,
  dateLaneOrder = KanbanDateLaneOrder.Rank,
  laneLimits,
  enforceLaneLimits = false,
  laneAggregates,
  laneAggregateFormats,
  pageSize = 20,
  cardRenderer,
  cardImageColumn,
  editable = false,
  allowNew = true,
  prepareNewRecord,
  onCardMove,
  formLocation = "center",
  form,
  showRecordLinks = true,
  onNavigate,
  allowSearch = true,
  allowFiltering = false,
  allowSavedViews = false,
  savedViewsKey,
  signInUrl = "/Account/Login",
  persistedStateQueryParameter,
  includeSearchInPersistedState = false,
  title,
  height = "600px",
  className,
  style,
  children
}) {
  const styles = useKanbanStyles();
  const t = usePrefixedT("app.components.kanban-board");
  const tAll = useT();
  const { locale } = useLocale();
  const userTimeZone = useUserTimeZone();
  const dialog = useDialogService();
  const closeRecordDialog = useCloseRecordDialog();
  const recordPages = useRecordPages({ enabled: showRecordLinks });
  const { ppp, authState, tableMetadataCache, viewMetadataCache, organizationSettingsCache } = usePowerPortalsPro();
  const boardId = useId().replace(/[^a-zA-Z0-9_-]/g, "");
  const user = authState.status === "authenticated" ? authState.user?.userId ?? null : null;
  const definedKey = useMemo(() => JSON.stringify(customViewDefinitions ?? []), [customViewDefinitions]);
  const defined2 = useMemo(
    () => new Map((customViewDefinitions ?? []).map((view2) => [view2.id.toLowerCase(), view2])),
    // The key covers the list's content.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [definedKey]
  );
  const pageViewIds = useMemo(
    () => [
      ...new Set(
        [...defaultViewId$1 ? [defaultViewId$1] : [], ...viewIds ?? [], ...(customViewDefinitions ?? []).map((view2) => view2.id)].map(
          (id) => id.toLowerCase()
        )
      )
    ],
    // The keys cover the lists' content.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [defaultViewId$1, (viewIds ?? []).join(","), definedKey]
  );
  const [setup, setSetup] = useState({ status: "loading" });
  const [setupRun, setSetupRun] = useState(0);
  useEffect(() => {
    let current = true;
    setSetup({ status: "loading" });
    void (async () => {
      if (pageViewIds.length === 0) {
        console.error("[KanbanBoard] A KanbanBoard needs a view: set its defaultViewId, viewIds or customViewDefinitions.");
        if (current) setSetup({ status: "error", message: t("error") });
        return;
      }
      try {
        const dataverseIds = pageViewIds.filter((id) => !defined2.has(id));
        const read2 = /* @__PURE__ */ new Map();
        (await Promise.all(dataverseIds.map((id) => viewMetadataCache.getAsync(id).catch(() => void 0)))).forEach((view2, i) => {
          if (view2) read2.set(dataverseIds[i], view2);
        });
        const table2 = pageViewIds.map((id) => defined2.get(id)?.tableName ?? read2.get(id)?.tableName).find((x) => !!x?.trim());
        const pageViews = new Map([...read2].filter(([, view2]) => table2 !== void 0 && sameName(view2.tableName, table2)));
        const definedViews = new Map([...defined2].filter(([, view2]) => table2 !== void 0 && sameName(view2.tableName, table2)));
        if (table2 === void 0) {
          console.error("[KanbanBoard] None of its views could be read.");
          if (current) setSetup({ status: "failed" });
          return;
        }
        const metadata = await tableMetadataCache.getAsync(table2);
        const laneMeta2 = metadata?.columns?.find((x) => sameName(x.columnName, laneColumn));
        if (!metadata || !laneMeta2 || kanbanLaneKind(laneMeta2) === void 0) {
          if (current) setSetup({ status: "error", message: t("wrong-column", [laneMeta2?.displayName || laneColumn]) });
          return;
        }
        const rank = rankColumn?.trim() ? metadata.columns.find((x) => sameName(x.columnName, rankColumn)) : void 0;
        const rankMeta2 = rank && rank.$type === ColumnType.Decimal ? rank : void 0;
        if (rankColumn?.trim() && !rankMeta2) {
          console.warn(
            `[KanbanBoard] Its rankColumn '${rankColumn}' must be a Decimal column of '${table2}': its cards follow the view's sort, and aren't reordered.`
          );
        }
        if (current) setSetup({ status: "ready", table: table2, metadata, laneMeta: laneMeta2, rankMeta: rankMeta2, pageViews, definedViews });
      } catch (error) {
        console.error("[KanbanBoard] It couldn\u2019t be read.", error);
        if (current) setSetup({ status: "failed" });
      }
    })();
    return () => {
      current = false;
    };
  }, [pageViewIds, defined2, laneColumn, rankColumn, viewMetadataCache, tableMetadataCache, setupRun]);
  const ready = setup.status === "ready" ? setup : void 0;
  const table = ready?.table;
  const laneMeta = ready?.laneMeta;
  const isDateBoard = laneMeta?.$type === ColumnType.DateTime;
  const dateOrdered = isDateBoard && dateLaneOrder === KanbanDateLaneOrder.Date;
  const rankMeta = dateOrdered ? void 0 : ready?.rankMeta;
  useLocalization(table ? [`tables.${table}`] : []);
  const dateZone = userTimeZone ?? (authState.status !== "loading" ? browserTimeZone() : void 0);
  const weekStart = firstDayOfWeek(locale);
  const dateBehavior = Number(
    laneMeta?.dateTimeBehavior ?? DateTimeBehavior.UserLocal
  );
  const definedDateLanesKey = JSON.stringify(dateLanesProp ?? null);
  const definedDateLanes = useMemo(
    () => dateLanesProp ?? KanbanDateLane.Defaults,
    // The key covers the list's content.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [definedDateLanesKey]
  );
  const dateLanesMistake = useMemo(() => {
    try {
      validateKanbanDateLanes(definedDateLanes);
      return void 0;
    } catch (error) {
      return error instanceof Error ? error.message : String(error);
    }
  }, [definedDateLanes]);
  useEffect(() => {
    if (isDateBoard && dateLanesMistake) console.error(`[KanbanBoard] Its dateLanes can't be shown: ${dateLanesMistake}`);
  }, [isDateBoard, dateLanesMistake]);
  const needsFiscalYear = definedDateLanes.some(isFiscalLane);
  const [fiscalYear, setFiscalYear] = useState(void 0);
  useEffect(() => {
    if (!needsFiscalYear || fiscalYear) return;
    let current = true;
    organizationSettingsCache.getAsync().then(
      (settings) => {
        if (current) setFiscalYear({ start: settings?.fiscalYearStart ?? null });
      },
      (error) => {
        console.error("[KanbanBoard] The organization\u2019s fiscal year couldn\u2019t be read; its fiscal lanes start the year on 1 January.", error);
        if (current) setFiscalYear({ start: null });
      }
    );
    return () => {
      current = false;
    };
  }, [needsFiscalYear, fiscalYear, organizationSettingsCache]);
  const fiscalYearKnown = !needsFiscalYear || fiscalYear !== void 0;
  const fiscalYearStart = needsFiscalYear ? fiscalYear?.start ?? null : null;
  const today2 = dateZone ? todayIn(dateZone, /* @__PURE__ */ new Date()) : void 0;
  const todayKey = today2 ? `${today2.year}-${today2.month}-${today2.day}` : "";
  const dateLanesNow = useMemo(
    () => isDateBoard && dateZone && today2 && fiscalYearKnown && !dateLanesMistake ? {
      behavior: dateBehavior,
      timeZone: dateZone,
      lanes: resolveKanbanDateLanes(definedDateLanes, today2, weekStart, fiscalYearStart)
    } : void 0,
    // `today` is followed through its key: a new object each render, the same day all day.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isDateBoard, dateZone, todayKey, fiscalYearKnown, dateLanesMistake, dateBehavior, definedDateLanes, weekStart, fiscalYearStart]
  );
  const resolvedDateLane = (lane) => dateLanesNow?.lanes.find((x) => x.key === lane.key);
  const dateLaneFirstDay = (lane) => resolvedDateLane(lane)?.firstDay;
  const holdsNoDate = (lane) => !!resolvedDateLane(lane)?.holdsNoDate;
  const dateOf = (record) => valueOf(record, laneMeta?.columnName ?? "");
  const savedViewsControl = useMemo(
    () => savedViewControl(SavedViewControlKind.Board, allowSavedViews ? savedViewsKey : void 0),
    [allowSavedViews, savedViewsKey]
  );
  const saved = useSavedViews({ enabled: allowSavedViews && !!table, tableName: table, control: savedViewsControl });
  const findSaved = (id) => id ? saved.views.find((x) => sameName(x.id, id)) : void 0;
  const [persisted] = useState(() => readPersistedKanbanState(persistedStateQueryParameter));
  const [pickedViewId, setPickedViewId] = useState(persisted.v);
  const pageViewOrder = useMemo(
    () => ready ? pageViewIds.filter((id) => ready.pageViews.has(id) || ready.definedViews.has(id)) : [],
    [ready, pageViewIds]
  );
  const savedIds = useMemo(() => saved.views.map((x) => x.id.toLowerCase()), [saved.views]);
  const allViewIds = useMemo(() => [.../* @__PURE__ */ new Set([...pageViewOrder, ...savedIds])], [pageViewOrder, savedIds]);
  const settledRef = useRef(false);
  if (ready && authState.status !== "loading" && !saved.loading) settledRef.current = true;
  const settled = settledRef.current;
  const openedViewRef = useRef(void 0);
  const shownViewId = pickedViewId ?? openedViewRef.current;
  const offered = useMemo(() => {
    if (!saved.available) return pageViewOrder;
    let all = allViewIds;
    const userDefault = defaultViewId(saved.settings, all, savedViewsControl);
    if (userDefault) all = [userDefault, ...all.filter((x) => x !== userDefault)];
    const shown = all.filter((id) => id === shownViewId || !isViewHidden(saved.settings, id, savedViewsControl));
    return shown.length > 0 ? shown : all;
  }, [saved.available, saved.settings, pageViewOrder, allViewIds, savedViewsControl, shownViewId]);
  const viewId = shownViewId && allViewIds.includes(shownViewId) ? shownViewId : offered[0];
  if (settled && viewId) openedViewRef.current ??= viewId;
  const viewOf = (id) => {
    if (!id || !ready) return void 0;
    const own = findSaved(id);
    if (own) {
      const layout = parseSavedKanbanLayout(own.kanbanLayout);
      const queried = queriedColumns2(own.definition.fetchXml);
      const ordered = (layout?.columns ?? []).map((x) => x.columnName).filter((x) => includesName(queried, x));
      const columns2 = [...ordered, ...queried].filter((x, i, all) => all.findIndex((y) => sameName(x, y)) === i);
      return { id, name: own.name, fetchXml: own.definition.fetchXml, columns: columns2, isPageView: false, isDefined: false, layout, saved: own };
    }
    const definedView = ready.definedViews.get(id);
    if (definedView) {
      return {
        id,
        name: viewLabelOf(customToViewMetadata(definedView), tAll),
        fetchXml: definedView.fetchXml,
        columns: definedView.columns.length ? definedView.columns.map((x) => x.columnName) : queriedColumns2(definedView.fetchXml),
        isPageView: true,
        isDefined: true,
        layout: kanbanLayoutOf(definedView),
        saved: void 0
      };
    }
    const page = ready.pageViews.get(id);
    if (!page) return void 0;
    const columns = page.columns?.length ? page.columns.map((x) => x.columnName) : queriedColumns2(page.fetchXml ?? "");
    return {
      id,
      name: viewLabelOf(page, tAll),
      fetchXml: page.fetchXml ?? "",
      columns,
      isPageView: true,
      isDefined: false,
      layout: void 0,
      saved: void 0
    };
  };
  const view = settled ? viewOf(viewId) : void 0;
  const viewName = (id) => viewOf(id)?.name ?? id;
  const primaryId = ready?.metadata.primaryIdColumn;
  const arrangeFor = (shown, collapsedFromUrl) => {
    const layout = shown.layout;
    const totals = {};
    const hiddenColumns = [];
    const titles = {};
    let size = pageSize > 0 ? Math.min(pageSize, COUNT_LIMIT) : 20;
    let collapsed2 = [];
    let hiddenLanes2 = [];
    if (layout) {
      if (layout.pageSize && layout.pageSize > 0) size = Math.min(layout.pageSize, COUNT_LIMIT);
      for (const column of layout.columns) {
        if (column.hidden) hiddenColumns.push(column.columnName);
        if (column.displayLabel?.trim()) titles[column.columnName] = column.displayLabel;
        if (column.aggregates?.length) totals[column.columnName] = [...column.aggregates];
      }
      collapsed2 = [...layout.collapsedLanes];
      hiddenLanes2 = [...layout.hiddenLanes];
    }
    if (shown.saved ? !layout : !layout?.columns.some((column) => column.aggregates?.length)) {
      for (const info of laneAggregates ?? []) {
        const format = laneAggregateFormats?.[info.columnName];
        const figures = info.aggregates.map((x) => {
          const own = x.format ?? format;
          return { aggregate: x.aggregate, ...own !== void 0 && { format: own } };
        });
        if (figures.length > 0) totals[info.columnName] = [...totals[info.columnName] ?? [], ...figures];
      }
    }
    const arrangement2 = {
      viewId: shown.id,
      columns: [...shown.columns],
      hiddenColumns,
      titles,
      totals,
      pageSize: size,
      collapsed: collapsed2,
      hiddenLanes: hiddenLanes2,
      columnsQuery: null,
      criteria: null,
      userSort: null,
      opening: { query: "", layout: "", collapsed: collapsed2 }
    };
    arrangement2.opening = {
      query: currentQueryOf(shown, arrangement2),
      layout: savedKanbanLayoutToJson(layoutOf(arrangement2)),
      collapsed: collapsed2
    };
    return collapsedFromUrl ? { ...arrangement2, collapsed: [...collapsedFromUrl] } : arrangement2;
  };
  const [arrangementState, setArrangementState] = useState(null);
  const usedUrlCollapsed = useRef(false);
  const fresh = useMemo(
    () => {
      if (!view || arrangementState?.viewId === view.id) return null;
      const fromUrl = !usedUrlCollapsed.current && persisted.c && view.id === (persisted.v ?? openedViewRef.current) ? persisted.c : void 0;
      return arrangeFor(view, fromUrl);
    },
    // A new arrangement only for another view.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [view?.id, arrangementState?.viewId]
  );
  const arrangement = arrangementState?.viewId === view?.id ? arrangementState : fresh;
  useEffect(() => {
    if (fresh) {
      usedUrlCollapsed.current = true;
      setArrangementState(fresh);
    }
  }, [fresh]);
  const arrangementRef = useRef(arrangement);
  arrangementRef.current = arrangement;
  const arrange = (change) => {
    const current = arrangementRef.current;
    if (current) setArrangementState(change(current));
  };
  const currentQuery = view && arrangement ? currentQueryOf(view, arrangement) : void 0;
  const readsViewAlone = !!view && !!arrangement && view.isPageView && !view.isDefined && currentQuery === arrangement.opening.query;
  const layoutJson = arrangement ? savedKanbanLayoutToJson(layoutOf(arrangement)) : "";
  const viewChanged = !!arrangement && (currentQuery !== arrangement.opening.query || layoutJson !== arrangement.opening.layout);
  const viewCardColumns = (arrangement?.columns ?? []).filter(
    (x) => !sameName(x, laneColumn) && !(ready?.rankMeta && sameName(x, ready.rankMeta.columnName)) && !(primaryId && sameName(x, primaryId))
  );
  const cardColumns = viewCardColumns.filter((x) => !includesName(arrangement?.hiddenColumns ?? [], x));
  const [serverColumns, setServerColumns] = useState([]);
  const takeColumns = (response) => {
    const columns = response.columns ?? [];
    setServerColumns(
      (known) => columns.length === known.length && columns.every((x, i) => x.columnName === known[i]?.columnName && x.displayName === known[i]?.displayName) ? known : columns
    );
  };
  const metadataOf = (column) => column.includes(".") ? void 0 : ready?.metadata.columns.find((x) => sameName(x.columnName, column));
  const columnTitle = (column) => {
    const own = Object.entries(arrangement?.titles ?? {}).find(([name]) => sameName(name, column))?.[1];
    if (own) return own;
    const server = serverColumns.find((x) => sameName(x.columnName, column))?.displayName;
    if (server) return server;
    const metadata = metadataOf(column);
    if (metadata) return metadata.displayName;
    return includesName(arrangement?.columns ?? [], column) || Object.keys(arrangement?.totals ?? {}).some((x) => sameName(x, column)) ? column : void 0;
  };
  const displayValue = (record, column) => resolveColumnDisplayText(record, column, metadataOf(column));
  const [refreshes, setRefreshes] = useState(0);
  const [lookupRecords, setLookupRecords] = useState(null);
  const searchFromUrl = includeSearchInPersistedState && allowSearch ? persisted.q ?? "" : "";
  const [search, setSearch] = useState(searchFromUrl);
  const baseRequest = () => readsViewAlone ? { viewId: view.id } : { ...view?.isPageView && { viewId: view.id }, fetchXml: currentQuery ?? null };
  const baseKey = JSON.stringify([view?.id ?? null, readsViewAlone ? null : currentQuery ?? null]);
  const lookupKey2 = JSON.stringify([baseKey, refreshes, user]);
  const isLookup2 = laneMeta?.$type === ColumnType.Lookup;
  useEffect(() => {
    if (!isLookup2 || lookupLanes || !view || !laneMeta || lookupRecords?.for === lookupKey2) return;
    let current = true;
    void (async () => {
      try {
        const response = await ppp.loadQueryAsync({
          ...baseRequest(),
          figuresOnly: true,
          groupBy: [{ columnName: laneMeta.columnName }],
          includeGroups: true
        });
        const target = laneMeta.targetTables?.[0] ?? "";
        const records = (response.grouping?.groups ?? []).flatMap((group) => {
          const value2 = group.value;
          if (value2 && value2.$type === ColumnType.Lookup && value2.value) return [{ ...value2, name: value2.name ?? group.label ?? null }];
          return /^[0-9a-f-]{36}$/i.test(group.key) ? [{ value: group.key, name: group.label ?? null, tableName: target }] : [];
        });
        if (current) setLookupRecords({ for: lookupKey2, records });
      } catch (error) {
        console.error("[KanbanBoard] The records its lookup names couldn\u2019t be read.", error);
        if (current) setLookupRecords({ for: lookupKey2, records: [] });
      }
    })();
    return () => {
      current = false;
    };
  }, [isLookup2, lookupLanes, lookupKey2, !!view, !!laneMeta]);
  const laneKeysKey = (laneKeys ?? []).join("\n");
  const lookupLanesKey = JSON.stringify((lookupLanes ?? []).map((x) => [x.value, x.name]));
  const stateColumn = useMemo(
    () => ready?.metadata.columns.find((x) => x.$type === ColumnType.State),
    [ready]
  );
  const lanes = useMemo(() => {
    if (!ready || !laneMeta) return [];
    let all;
    if (laneMeta.$type === ColumnType.Lookup) {
      const records = lookupLanes ?? lookupRecords?.records;
      if (!records) return [];
      all = kanbanLookupLanes(laneMeta, records);
    } else {
      all = kanbanLanes(laneMeta, stateColumn, definedDateLanes);
    }
    return arrangeKanbanLanes(all, laneKeys ? [...laneKeys] : void 0);
  }, [ready, laneMeta, stateColumn, definedDateLanes, laneKeysKey, lookupLanesKey, lookupRecords]);
  const laneLabel = (lane) => {
    if (isDateBoard) {
      const title2 = definedDateLanes.find((x) => x.key === lane.key)?.title;
      if (title2) return title2;
      const label = DATE_LANE_LABELS[lane.key];
      return label ? tAll(label) : lane.key;
    }
    if (lane.key === KANBAN_NO_VALUE_KEY) return t("no-value");
    if (!laneMeta || !table || laneMeta.$type === ColumnType.Lookup) return lane.label;
    const choiceName = laneMeta.choiceLogicalName;
    const keys = [`tables.${table}.columns.${laneMeta.columnName}.values.${lane.key}.label`];
    if (choiceName) keys.push(`tables.${table}.choices.${choiceName}.values.${lane.key}.label`, `choices.${choiceName}.values.${lane.key}.label`);
    for (const key3 of keys) {
      const label = tAll(key3);
      if (label && label !== key3) return label;
    }
    return lane.label;
  };
  const [laneData, setLaneData] = useState({});
  const [access, setAccess] = useState({
    table: void 0,
    columns: void 0
  });
  const takeAccess = (response) => setAccess({ table: numberOf2(response.tablePermissions), columns: response.columnPermissions });
  const laneDataRef = useRef(laneData);
  laneDataRef.current = laneData;
  const hiddenLanes = arrangement?.hiddenLanes ?? [];
  const collapsed = arrangement?.collapsed ?? [];
  const isCollapsed = (lane) => collapsed.includes(lane.key);
  const shownLanes = lanes.filter((lane) => !hiddenLanes.includes(lane.key) && (showEmptyLanes || !laneData[lane.key]?.emptyAtLoad));
  const laneSorts = () => {
    if (dateOrdered && laneMeta && currentQuery) {
      return [
        { columnName: laneMeta.columnName },
        ...querySorts(currentQuery).filter((x) => !sameName(x.columnName, laneMeta.columnName))
      ];
    }
    if (!rankMeta || !currentQuery) return null;
    return [
      { columnName: rankMeta.columnName },
      ...querySorts(currentQuery).filter((x) => !sameName(x.columnName, rankMeta.columnName))
    ];
  };
  const additionalColumns = [
    ...laneMeta ? [laneMeta.columnName] : [],
    ...rankMeta ? [rankMeta.columnName] : [],
    ...cardImageColumn ? [`${cardImageColumn}_timestamp`] : []
  ];
  const requestedTotals = Object.entries(arrangement?.totals ?? {}).flatMap(
    ([columnName, figures]) => [...new Set(figures.map((x) => x.aggregate))].sort((a, b) => a - b).map((aggregate) => {
      const format = figures.find((x) => x.aggregate === aggregate)?.format;
      return { columnName, aggregate, ...aggregate !== QueryAggregate.Count && format !== void 0 && { format } };
    })
  );
  const searched = allowSearch ? search.trim() : "";
  const searchColumns = searched && !cardRenderer && cardColumns.length > 0 ? cardColumns : null;
  const laneFilterOf = (lane) => {
    const resolved = resolvedDateLane(lane);
    return dateLanesNow && resolved ? kanbanDateLaneFilter(laneMeta.columnName, dateLanesNow.behavior, resolved, dateLanesNow.timeZone) : kanbanLaneFilter(laneMeta.columnName, lane);
  };
  const laneRequest = (lane, page, pagingCookie, withTotals) => ({
    ...baseRequest(),
    filters: [laneFilterOf(lane)],
    searchText: searched || null,
    ...searchColumns && { searchColumns: [...searchColumns] },
    sorts: laneSorts(),
    pageNumber: page,
    pageSize: arrangement?.pageSize ?? 20,
    pagingCookie: pagingCookie ?? null,
    additionalColumns,
    columnAggregates: withTotals && requestedTotals.length > 0 ? requestedTotals : null
  });
  const wholeLaneRequest = (lane) => ({
    ...arrangement?.columnsQuery ? { ...view.isPageView && { viewId: view.id }, fetchXml: arrangement.columnsQuery } : view.isPageView && !view.isDefined ? { viewId: view.id } : { ...view.isPageView && { viewId: view.id }, fetchXml: view.fetchXml },
    filters: [laneFilterOf(lane)]
  });
  const narrowed = !!searched || arrangement?.criteria != null;
  const limitOf = (lane) => {
    const limit = laneLimits ? Object.entries(laneLimits).find(([key3]) => key3 === lane.key)?.[1] : void 0;
    return typeof limit === "number" && Number.isFinite(limit) && limit >= 0 ? limit : void 0;
  };
  const wholeCountRequest = (lane) => narrowed && limitOf(lane) !== void 0 && view ? { ...wholeLaneRequest(lane), pageNumber: 1, pageSize: 1 } : void 0;
  const limitCountOf = (data) => narrowed ? data?.wholeCount : data?.count;
  const isOverLimit = (lane) => {
    const limit = limitOf(lane);
    const count = limitCountOf(laneData[lane.key]);
    return limit !== void 0 && count !== void 0 && count > limit;
  };
  const isFull = (lane, data = laneData) => {
    if (!enforceLaneLimits) return false;
    const limit = limitOf(lane);
    const count = limitCountOf(data[lane.key]);
    return limit !== void 0 && count !== void 0 && count >= limit;
  };
  const dateKey = dateLanesNow ? [dateLanesNow.behavior, dateLanesNow.timeZone, dateLanesNow.lanes] : null;
  const loadKey = JSON.stringify([
    baseKey,
    searched,
    searchColumns,
    laneSorts(),
    arrangement?.pageSize ?? null,
    requestedTotals,
    additionalColumns,
    dateKey,
    refreshes,
    user
  ]);
  const requestRef = useRef(laneRequest);
  requestRef.current = laneRequest;
  const wholeCountRequestRef = useRef(wholeCountRequest);
  wholeCountRequestRef.current = wholeCountRequest;
  const loadKeyRef = useRef(loadKey);
  loadKeyRef.current = loadKey;
  const generations = useRef(/* @__PURE__ */ new Map());
  const gate = useRef(createGate(PARALLEL_LANE_READS));
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const loadWholeCount = useCallback(
    async (lane, generation) => {
      const request = wholeCountRequestRef.current(lane);
      if (!request) return;
      const key3 = lane.key;
      await gate.current.acquire();
      try {
        if (generations.current.get(key3) !== generation || !mounted.current) return;
        const response = await ppp.loadQueryAsync(request);
        if (generations.current.get(key3) !== generation || !mounted.current) return;
        const total = numberOf2(response.pagingInfo?.totalRecordCount);
        if (total === void 0 || total < 0) return;
        setLaneData((all) => all[key3] ? { ...all, [key3]: { ...all[key3], wholeCount: total } } : all);
      } catch (error) {
        console.error(`[KanbanBoard] It couldn't count the whole lane '${key3}' of '${table}'.`, error);
      } finally {
        gate.current.release();
      }
    },
    // The request is the latest render's, through its ref.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ppp, table]
  );
  const loadLane = useCallback(
    async (lane) => {
      const key3 = lane.key;
      const forKey = loadKeyRef.current;
      const generation = (generations.current.get(key3) ?? 0) + 1;
      generations.current.set(key3, generation);
      const request = requestRef.current(lane, 1, null, true);
      setLaneData((all) => ({ ...all, [key3]: { ...all[key3] ?? emptyLane(forKey), for: forKey, loading: true, failed: false } }));
      await gate.current.acquire();
      try {
        const response = await ppp.loadQueryAsync(request);
        if (generations.current.get(key3) !== generation || !mounted.current) return;
        takeColumns(response);
        takeAccess(response);
        const cards = response.tableRecords ?? [];
        const total = numberOf2(response.pagingInfo?.totalRecordCount);
        const count = total !== void 0 && total >= 0 ? total : cards.length;
        setLaneData((all) => ({
          ...all,
          [key3]: {
            for: forKey,
            cards,
            count,
            wholeCount: all[key3]?.wholeCount,
            pagesLoaded: 1,
            pagingCookie: response.pagingInfo?.pagingCookie,
            moreRecords: response.pagingInfo?.moreRecords ?? count > cards.length,
            loading: false,
            loadingMore: false,
            failed: false,
            totals: response.columnAggregates,
            columnPermissions: response.columnPermissions,
            emptyAtLoad: count === 0,
            figuresFor: forKey
          }
        }));
        void loadWholeCount(lane, generation);
      } catch (error) {
        if (generations.current.get(key3) !== generation || !mounted.current) return;
        console.error(`[KanbanBoard] It couldn't read the lane '${key3}' of '${table}'.`, error);
        setLaneData((all) => ({
          ...all,
          [key3]: { ...all[key3] ?? emptyLane(forKey), for: forKey, loading: false, failed: true, emptyAtLoad: false }
        }));
      } finally {
        gate.current.release();
      }
    },
    // The request is the latest render's, through its ref.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ppp, table, loadWholeCount]
  );
  const readLaneKeys = lanes.filter((lane) => !hiddenLanes.includes(lane.key) && !isCollapsed(lane)).map((lane) => lane.key);
  const collapsedLaneKeys = lanes.filter((lane) => !hiddenLanes.includes(lane.key) && isCollapsed(lane)).map((lane) => lane.key);
  useEffect(() => {
    if (!view || !arrangement || !laneMeta || isDateBoard && !dateLanesNow) return;
    for (const key3 of readLaneKeys) {
      const lane = lanes.find((x) => x.key === key3);
      if (!lane || laneDataRef.current[key3]?.for === loadKey) continue;
      void loadLane(lane);
    }
    for (const key3 of collapsedLaneKeys) {
      const lane = lanes.find((x) => x.key === key3);
      const data = laneDataRef.current[key3];
      if (!lane || data?.for === loadKey || data?.figuresFor === loadKey) continue;
      setLaneData((all) => ({
        ...all,
        [key3]: { ...emptyLane(NOT_READ), figuresFor: loadKey, emptyAtLoad: all[key3]?.emptyAtLoad ?? false }
      }));
      void loadLaneFigures(lane, true);
    }
  }, [loadKey, readLaneKeys.join("\n"), collapsedLaneKeys.join("\n"), lanes, !!view, !!arrangement, !!dateLanesNow]);
  const loadLaneFigures = async (lane, atLoad = false) => {
    const key3 = lane.key;
    const forKey = loadKeyRef.current;
    let generation = generations.current.get(key3);
    if (atLoad) {
      generation = (generation ?? 0) + 1;
      generations.current.set(key3, generation);
    } else {
      const data = laneDataRef.current[key3];
      if (data?.for !== forKey && data?.figuresFor !== forKey) return;
    }
    await gate.current.acquire();
    try {
      if (generations.current.get(key3) !== generation || !mounted.current) return;
      const response = await ppp.loadQueryAsync({ ...requestRef.current(lane, 1, null, true), pageSize: 1 });
      if (generations.current.get(key3) !== generation || !mounted.current) return;
      takeAccess(response);
      const total = numberOf2(response.pagingInfo?.totalRecordCount);
      const count = total !== void 0 && total >= 0 ? total : void 0;
      setLaneData((all) => {
        const now = all[key3];
        if (!now) return all;
        return {
          ...all,
          [key3]: {
            ...now,
            ...count !== void 0 && { count },
            totals: response.columnAggregates,
            // A lane without a count isn't known to be empty.
            ...atLoad && { emptyAtLoad: count === 0, failed: false }
          }
        };
      });
      void loadWholeCount(lane, generation);
    } catch (error) {
      console.error(`[KanbanBoard] It couldn't read the count of the lane '${key3}' of '${table}'.`, error);
      if (atLoad && generations.current.get(key3) === generation && mounted.current) {
        setLaneData((all) => {
          const now = all[key3];
          return now ? { ...all, [key3]: { ...now, failed: true, emptyAtLoad: false } } : all;
        });
      }
    } finally {
      gate.current.release();
    }
  };
  const loadMore = async (lane) => {
    const data = laneDataRef.current[lane.key];
    if (!data || data.loadingMore || !data.moreRecords) return;
    const generation = generations.current.get(lane.key);
    setLaneData((all) => ({ ...all, [lane.key]: { ...all[lane.key], loadingMore: true } }));
    try {
      const response = await ppp.loadQueryAsync(laneRequest(lane, data.pagesLoaded + 1, data.pagingCookie, false));
      if (generations.current.get(lane.key) !== generation || !mounted.current) return;
      setLaneData((all) => {
        const now = all[lane.key];
        const shown = new Set(now.cards.map(cardIdOf));
        return {
          ...all,
          [lane.key]: {
            ...now,
            cards: [...now.cards, ...(response.tableRecords ?? []).filter((x) => !shown.has(cardIdOf(x)))],
            pagesLoaded: now.pagesLoaded + 1,
            pagingCookie: response.pagingInfo?.pagingCookie,
            moreRecords: response.pagingInfo?.moreRecords ?? (now.count ?? 0) > now.cards.length + (response.tableRecords?.length ?? 0),
            loadingMore: false
          }
        };
      });
    } catch (error) {
      console.error(`[KanbanBoard] It couldn't read more of the lane '${lane.key}' of '${table}'.`, error);
      setLaneData((all) => ({ ...all, [lane.key]: { ...all[lane.key], loadingMore: false } }));
      await dialog.showErrorAsync(t("lane-failed"));
    }
  };
  const refresh = () => {
    if (setup.status === "failed") {
      setSetupRun((x) => x + 1);
      return;
    }
    setRefreshes((x) => x + 1);
  };
  const formatCount = (count) => count >= COUNT_LIMIT ? t("count-many", [String(COUNT_LIMIT)]) : String(count);
  const countText = (lane) => {
    const limit = limitOf(lane);
    if (limit !== void 0) {
      const whole = limitCountOf(laneData[lane.key]);
      return whole === void 0 ? void 0 : t("lane-limit", [formatCount(whole), String(limit)]);
    }
    const count = laneData[lane.key]?.count;
    return count === void 0 ? void 0 : formatCount(count);
  };
  const aggregateLabel = (aggregate) => tAll(
    aggregate === QueryAggregate.Sum ? "app.components.grid.aggregate-sum" : aggregate === QueryAggregate.Average ? "app.components.grid.aggregate-average" : aggregate === QueryAggregate.Minimum ? "app.components.grid.aggregate-minimum" : aggregate === QueryAggregate.Maximum ? "app.components.grid.aggregate-maximum" : "app.components.grid.aggregate-count"
  );
  const laneTotals = (lane) => requestedTotals.map((asked) => {
    const value2 = laneData[lane.key]?.totals?.find((x) => sameName(x.columnName, asked.columnName) && Number(x.aggregate) === Number(asked.aggregate));
    const text2 = value2 === void 0 ? "" : value2.isAvailable !== false && value2.formattedValue ? value2.formattedValue : "\u2014";
    return { key: `${asked.columnName}|${asked.aggregate}`, label: `${columnTitle(asked.columnName) ?? asked.columnName} \xB7 ${aggregateLabel(Number(asked.aggregate))}`, text: text2 };
  });
  const laneOfCard = (cardId) => {
    for (const lane of lanes) {
      const index = laneData[lane.key]?.cards.findIndex((x) => cardIdOf(x) === cardId) ?? -1;
      if (index >= 0) return { lane, index, record: laneData[lane.key].cards[index] };
    }
    return void 0;
  };
  const savingRef = useRef(/* @__PURE__ */ new Set());
  const [saving, setSaving] = useState(() => /* @__PURE__ */ new Set());
  const markSaving = (cardId, isSaving) => {
    if (isSaving) savingRef.current.add(cardId);
    else savingRef.current.delete(cardId);
    setSaving(new Set(savingRef.current));
  };
  const canMoveCard = (record, lane) => editable && !!laneMeta?.isValidForUpdate && (Number(record.permissions ?? 0) & TableSecurityPermission.Write) === TableSecurityPermission.Write && canWriteColumn(record, laneMeta.columnName) && !!lane?.letsGo && (!isDateBoard || dateLaneDrop === KanbanDateLaneDrop.ChangeDate || canReorder(lane)) && !saving.has(cardIdOf(record));
  const canRank = (lane) => {
    if (!editable || !rankMeta?.isValidForUpdate) return false;
    const permissions = laneData[lane.key]?.columnPermissions;
    const rank = permissions ? Object.entries(permissions).find(([name]) => sameName(name, rankMeta.columnName))?.[1] : void 0;
    return rank === void 0 || (Number(rank) & ColumnSecurityPermission.Write) === ColumnSecurityPermission.Write;
  };
  const canReorder = (lane) => {
    if (dateOrdered) {
      return editable && !!laneMeta?.isValidForUpdate && dateLaneDrop === KanbanDateLaneDrop.ChangeDate && !holdsNoDate(lane);
    }
    return canRank(lane) && !(lane.isClosed && isGovernedTable(stateColumn));
  };
  const laneTakesDrops = (lane) => lane.takesDrops && (!isDateBoard || holdsNoDate(lane) || dateLaneFirstDay(lane) !== void 0);
  const laneAccepts = (from, to) => {
    if (from.key === to.key) return true;
    if (!laneTakesDrops(to)) return false;
    if (isDateBoard) return dateLaneDrop === KanbanDateLaneDrop.ChangeDate;
    return kanbanMoveOf(stateColumn, from, to).kind !== StateChangeKind.Refused;
  };
  const laneTakes = (from, to, data = laneData) => laneAccepts(from, to) && (from.key === to.key || !isFull(to, data));
  const moveTargets = (from) => shownLanes.filter((x) => x.key !== from.key && laneTakes(from, x));
  const rankOf = (record) => rankMeta ? numberOf2(valueOf(record, rankMeta.columnName)) ?? null : null;
  const cardName = (record) => {
    const first = cardColumns[0];
    const titleText = first ? displayValue(record, first) : null;
    if (titleText) return titleText;
    const nameColumn = ready?.metadata.primaryNameColumn;
    const name = nameColumn ? displayValue(record, nameColumn) : null;
    return name || (record.id ?? "");
  };
  const [announcement, setAnnouncement] = useState("");
  const announce = (text2) => setAnnouncement((before) => before === text2 ? `${text2} ` : text2);
  const latest = useRef({ laneOfCard, canMoveCard, canRank, canReorder, laneAccepts, isFull, laneLabel, cardName, rankOf, lanes });
  latest.current = { laneOfCard, canMoveCard, canRank, canReorder, laneAccepts, isFull, laneLabel, cardName, rankOf, lanes };
  const mayRank = (record) => !!rankMeta && (Number(record.permissions ?? 0) & TableSecurityPermission.Write) === TableSecurityPermission.Write && canWriteColumn(record, rankMeta.columnName);
  const laneOrderRequest = (lane) => ({
    ...wholeLaneRequest(lane),
    columns: [rankMeta.columnName],
    sorts: laneSorts(),
    pageNumber: 1,
    pageSize: LANE_ORDER_LIMIT
  });
  const showMoveError = (error) => dialog.showErrorAsync(error instanceof PowerPortalsProError && error.detail ? error.detail : t("move-failed"), {
    title: t("move-failed")
  });
  const stateLabel = (state) => {
    const choice2 = stateColumn?.choices.find((x) => Number(x.value) === state);
    if (!stateColumn || !table || state === void 0) return choice2?.displayName ?? "";
    return resolveChoiceLabel(tAll, table, stateColumn.columnName, stateColumn.choiceLogicalName ?? "", state, choice2?.displayName ?? String(state));
  };
  const moveCard = async (cardId, toKey, requestedIndex) => {
    if (savingRef.current.has(cardId)) return;
    const now = latest.current;
    const found = now.laneOfCard(cardId);
    const to = now.lanes.find((x) => x.key === toKey);
    if (!found || !to || !table || !laneMeta) return;
    const { lane: from, index: oldIndex, record } = found;
    const sameLane = from.key === to.key;
    if (!now.canMoveCard(record, from) || !sameLane && !now.laneAccepts(from, to) || sameLane && !now.canReorder(from)) return;
    if (!sameLane && now.isFull(to, laneDataRef.current)) {
      announce(t("lane-full", [now.laneLabel(to), String(limitOf(to))]));
      return;
    }
    const stateChange = sameLane ? { kind: StateChangeKind.Same } : kanbanMoveOf(stateColumn, from, to);
    if (stateChange.kind === StateChangeKind.Refused) return;
    const toData = laneDataRef.current[to.key];
    const others = (toData?.cards ?? []).filter((x) => cardIdOf(x) !== cardId);
    const index = Math.max(0, Math.min(Math.trunc(requestedIndex), others.length));
    if (sameLane && index === oldIndex) return;
    const dates = dateLanesNow;
    let dateValue;
    if (dates && (!sameLane || dateOrdered)) {
      if (holdsNoDate(to)) {
        dateValue = null;
      } else {
        const above = dateOrdered ? others[index - 1] : void 0;
        const day = (above && kanbanDateDayOf(dates.behavior, dateOf(above), dates.timeZone)) ?? dateLaneFirstDay(to);
        if (!day) return;
        const current = dateOf(record);
        if (sameLane && sameDay(kanbanDateDayOf(dates.behavior, current, dates.timeZone), day)) return;
        dateValue = kanbanDateValueFor(dates.behavior, current, day, dates.timeZone);
        if (kanbanDateLaneKeyOf(dates.behavior, dateValue, dates.lanes, dates.timeZone) !== to.key) return;
      }
    }
    const target = dateValue === void 0 ? to : { ...to, value: dateValue === null ? null : { $type: ColumnType.DateTime, value: dateValue } };
    const writesLane = !sameLane || dateValue !== void 0;
    const placeIn = (cards, shownCard) => {
      if (!dateOrdered) return index;
      const at = dateSortKey(dateOf(shownCard));
      const after = cards.findIndex((x) => dateSortKey(dateOf(x)) > at);
      return after < 0 ? cards.length : after;
    };
    const closing = stateChange.kind === StateChangeKind.Close;
    const confirming = stateChange.kind === StateChangeKind.Update && isGovernedTable(stateColumn) && from.state !== to.state;
    const reopening = confirming && from.isClosed;
    const changesState = closing || confirming && (from.isClosed || to.isClosed);
    const keepsRank = !(changesState && from.isClosed && (closing || to.isClosed));
    const ranks = !!rankMeta && now.canRank(to) && keepsRank;
    const laneShown = !!toData && toData.for === loadKeyRef.current && !toData.loading;
    const wholeLaneShown = laneShown && !toData.moreRecords && !searched && arrangement?.criteria == null;
    const stamp = [generations.current.get(from.key), generations.current.get(to.key)];
    const readAgainSince = () => generations.current.get(from.key) !== stamp[0] || generations.current.get(to.key) !== stamp[1];
    const originals = /* @__PURE__ */ new Map();
    const restore = (cards) => cards.map((x) => originals.get(cardIdOf(x)) ?? x);
    const putBack = () => {
      if (readAgainSince()) return;
      setLaneData((all) => {
        const fromData = all[from.key];
        if (!fromData) return all;
        const next = { ...all };
        for (const [key3, data] of Object.entries(all)) {
          if (key3 === from.key) continue;
          const held = data.cards.some((x) => cardIdOf(x) === cardId);
          if (held || key3 === to.key) {
            next[key3] = {
              ...data,
              cards: restore(data.cards.filter((x) => cardIdOf(x) !== cardId)),
              ...held && countsShifted(data, -1)
            };
          }
        }
        const back = fromData.cards.filter((x) => cardIdOf(x) !== cardId);
        back.splice(Math.min(oldIndex, back.length), 0, record);
        const returned = !sameLane && !fromData.cards.some((x) => cardIdOf(x) === cardId);
        next[from.key] = { ...fromData, cards: restore(back), ...returned && countsShifted(fromData, 1) };
        return next;
      });
    };
    markSaving(cardId, true);
    let saved2 = false;
    const movedLanes = sameLane ? [to] : [from, to];
    let shownAt = index;
    try {
      const shown = writesLane ? withValue(record, laneMeta.columnName, kanbanMoveUpdate(table, record.id, laneMeta, target).properties?.[laneMeta.columnName]) : record;
      setLaneData((all) => {
        const next = { ...all };
        const fromData = next[from.key];
        const intoData = next[to.key] ?? emptyLane(NOT_READ);
        if (!fromData) return all;
        const fromCards = fromData.cards.filter((x) => cardIdOf(x) !== cardId);
        if (sameLane) {
          shownAt = placeIn(fromCards, shown);
          fromCards.splice(shownAt, 0, shown);
          next[from.key] = { ...fromData, cards: fromCards };
        } else {
          const intoCards = intoData.cards.filter((x) => cardIdOf(x) !== cardId);
          shownAt = placeIn(intoCards, shown);
          intoCards.splice(shownAt, 0, shown);
          next[from.key] = { ...fromData, cards: fromCards, ...countsShifted(fromData, -1) };
          next[to.key] = { ...intoData, cards: intoCards, ...countsShifted(intoData, 1) };
        }
        return next;
      });
      const rankUpdate = (id, value2) => ({
        tableName: table,
        id,
        properties: { [rankMeta.columnName]: { $type: ColumnType.Decimal, value: value2 } }
      });
      let close;
      let into = to;
      if (closing) {
        const action = stateChange.action;
        if (!ready || action === void 0) {
          putBack();
          return;
        }
        close = await closeRecordDialog({
          record,
          tableMetadata: ready.metadata,
          action,
          statusReason: Number(to.key)
        });
        if (!close) {
          putBack();
          return;
        }
        const reason = String(close.statusReason);
        const chosen = reason === to.key ? void 0 : now.lanes.find((x) => x.key === reason) ?? reasonLane(reason, to);
        if (chosen) {
          if (now.isFull(chosen, laneDataRef.current)) {
            putBack();
            announce(t("lane-full", [now.laneLabel(chosen), String(limitOf(chosen))]));
            return;
          }
          const shownThere = shownLanes.some((x) => x.key === chosen.key);
          const closed = withValue(record, laneMeta.columnName, kanbanMoveUpdate(table, record.id, laneMeta, chosen).properties?.[laneMeta.columnName]);
          setLaneData((all) => {
            const next = { ...all };
            const toData2 = next[to.key];
            if (toData2) {
              next[to.key] = { ...toData2, cards: toData2.cards.filter((x) => cardIdOf(x) !== cardId), ...countsShifted(toData2, -1) };
            }
            if (shownThere) {
              const chosenData = next[chosen.key] ?? emptyLane(NOT_READ);
              next[chosen.key] = {
                ...chosenData,
                cards: [closed, ...chosenData.cards.filter((x) => cardIdOf(x) !== cardId)],
                ...countsShifted(chosenData, 1)
              };
            }
            return next;
          });
          into = chosen;
          movedLanes.push(chosen);
        }
      } else if (confirming) {
        const confirmation = await dialog.showConfirmationAsync(
          t("state-change-confirmation", [now.cardName(record), stateLabel(from.state), stateLabel(to.state)]),
          {
            title: t("state-change-title"),
            primaryText: t("state-change-confirm"),
            secondaryText: tAll("app.buttons.cancel.label")
          }
        );
        if (confirmation.canceled) {
          putBack();
          return;
        }
      }
      let rank;
      const otherRanks = [];
      let refused;
      if (ranks && rankMeta && into.key === to.key) {
        try {
          const range = rankMeta;
          const precision = numberOf2(range.precision) ?? 10;
          const least = numberOf2(range.min) ?? null;
          const most = numberOf2(range.max) ?? null;
          let order = others;
          let at = index;
          let between;
          if (!wholeLaneShown && laneShown) {
            const above = others[index - 1];
            const below = others[index];
            const aboveRank = above ? now.rankOf(above) : null;
            const belowRank = below ? now.rankOf(below) : null;
            if (aboveRank !== null && belowRank !== null) {
              const changes = kanbanRanksForDrop([aboveRank, belowRank], 1, precision, least, most);
              if (changes.length === 1) between = changes[0].rank;
            }
          }
          if (!wholeLaneShown && between === void 0) {
            const response = await ppp.loadQueryAsync(laneOrderRequest(to));
            if (response.pagingInfo?.moreRecords) refused = { text: t("reorder-too-many") };
            else {
              order = (response.tableRecords ?? []).filter((x) => cardIdOf(x) !== cardId);
              const above = others[index - 1];
              const below = others[index];
              const aboveAt = above ? order.findIndex((x) => cardIdOf(x) === cardIdOf(above)) : -1;
              const belowAt = below ? order.findIndex((x) => cardIdOf(x) === cardIdOf(below)) : -1;
              at = aboveAt >= 0 ? aboveAt + 1 : belowAt >= 0 ? belowAt : order.length;
            }
          }
          if (!refused && between !== void 0) rank = between;
          else if (!refused) {
            const after = [...order];
            after.splice(at, 0, record);
            const changes = kanbanRanksForDrop(order.map(now.rankOf), at, precision, least, most);
            if (changes.length === 0) refused = { text: t("reorder-too-many") };
            for (const change of changes) {
              const changed = after[change.index];
              if (cardIdOf(changed) === cardId) rank = change.rank;
              else otherRanks.push({ record: changed, rank: change.rank });
            }
          }
        } catch (error) {
          console.error(`[KanbanBoard] It couldn't read the order of the lane '${to.key}' of '${table}'.`, error);
          refused = { text: t("move-failed"), error };
        }
        if (!refused && otherRanks.some((x) => !mayRank(x.record))) refused = { text: t("reorder-blocked") };
        if (refused) {
          if (!changesState) {
            putBack();
            announce(refused.text);
            if (refused.error !== void 0) {
              markSaving(cardId, false);
              await showMoveError(refused.error);
            }
            return;
          }
          rank = void 0;
          otherRanks.length = 0;
        } else if (changesState && otherRanks.length > 0) {
          rank = void 0;
          otherRanks.length = 0;
        } else {
          const newRanks = new Map(otherRanks.map((x) => [cardIdOf(x.record), x.rank]));
          if (rank !== void 0) newRanks.set(cardId, rank);
          for (const card of others) if (newRanks.has(cardIdOf(card))) originals.set(cardIdOf(card), card);
          const rankColumnName = rankMeta.columnName;
          setLaneData((all) => {
            const lane = all[to.key];
            if (!lane) return all;
            const cards = lane.cards.map((card) => {
              const value2 = newRanks.get(cardIdOf(card));
              return value2 === void 0 ? card : withValue(card, rankColumnName, { $type: ColumnType.Decimal, value: value2 });
            });
            return { ...all, [to.key]: { ...lane, cards } };
          });
        }
      }
      const update = close ? rank !== void 0 ? rankUpdate(record.id, rank) : { tableName: table, id: record.id, properties: {} } : !writesLane ? rankUpdate(record.id, rank) : reopening ? kanbanMoveUpdate(table, record.id, laneMeta, target) : kanbanMoveUpdate(table, record.id, laneMeta, target, rank === void 0 ? null : rankMeta.columnName, rank ?? null);
      const otherUpdates = reopening ? rank !== void 0 ? [rankUpdate(record.id, rank)] : [] : otherRanks.map((x) => rankUpdate(x.record.id, x.rank));
      announce(t("moved", [now.cardName(record), now.laneLabel(into)]));
      let failure;
      let savedMove;
      try {
        const move = {
          record,
          from,
          to: into,
          index: into === to ? shownAt : 0,
          rank,
          update,
          otherUpdates,
          changesLane: !sameLane,
          ...close && { close }
        };
        if (onCardMove) {
          savedMove = await onCardMove(move);
        } else if (close) {
          await ppp.executeMultipleAsync(
            [...rank !== void 0 ? [{ $type: "UpdateRequest", record: update }] : [], close],
            { returnResponses: false }
          );
          savedMove = true;
        } else {
          if (otherUpdates.length > 0) {
            await ppp.executeMultipleAsync(
              [update, ...otherUpdates].map((x) => ({ $type: "UpdateRequest", record: x })),
              { returnResponses: false }
            );
          } else {
            await ppp.updateRecordAsync(update);
          }
          savedMove = true;
        }
      } catch (error) {
        console.error(`[KanbanBoard] It couldn't move ${table} ${record.id} to the lane '${to.key}'.`, error);
        failure = error;
        savedMove = false;
      }
      if (!savedMove) {
        putBack();
        announce(t("move-failed"));
        markSaving(cardId, false);
        if (failure !== void 0) await showMoveError(failure);
        return;
      }
      saved2 = true;
    } finally {
      markSaving(cardId, false);
    }
    if (saved2 && !onCardMove) await Promise.all(movedLanes.map((lane) => loadLaneFigures(lane)));
  };
  const reasonLane = (key3, like) => {
    const option = laneMeta?.choices?.find(
      (x) => String(x.value) === key3
    );
    return {
      key: key3,
      label: option?.displayName ?? key3,
      value: { $type: ColumnType.Choice, value: Number(key3) },
      ...like.state !== void 0 && { state: like.state },
      isClosed: true,
      ...like.closeAction && { closeAction: like.closeAction },
      takesDrops: false,
      letsGo: false
    };
  };
  const [coarsePointer] = useState(() => typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches);
  const sensors = useSensors(
    useSensor(KanbanPointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 250, tolerance: 5 } }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
      // Enter opens a card; Space picks it up and puts it down.
      keyboardCodes: { start: ["Space"], cancel: ["Escape"], end: ["Space", "Enter"] }
    })
  );
  const [activeCardId, setActiveCardId] = useState(null);
  const [overLaneKey, setOverLaneKey] = useState(null);
  const droppablePrefix = `${boardId}-lane-`;
  const laneKeyOfDroppable = (id) => id.startsWith(droppablePrefix) ? lanes[Number(id.slice(droppablePrefix.length))]?.key : void 0;
  const dropTarget = (overId) => kanbanDropTarget(
    overId,
    (cardId) => {
      const found = laneOfCard(cardId);
      return found && { laneKey: found.lane.key, index: found.index };
    },
    laneKeyOfDroppable,
    (laneKey) => laneData[laneKey]?.cards.length ?? 0
  );
  const dragging = useRef(false);
  const boardRef = useRef(null);
  useEffect(() => {
    const onClick = (event) => {
      if (dragging.current && event.target instanceof Node && boardRef.current?.contains(event.target)) event.preventDefault();
    };
    window.addEventListener("click", onClick, true);
    return () => window.removeEventListener("click", onClick, true);
  }, []);
  const endDragging = () => setTimeout(() => dragging.current = false, 0);
  const onDragStart = (event) => {
    dragging.current = true;
    setActiveCardId(String(event.active.id));
  };
  const takesCard = (cardId, laneKey) => {
    const found = laneOfCard(String(cardId));
    const lane = laneKey === void 0 ? void 0 : lanes.find((x) => x.key === laneKey);
    return !!found && !!lane && laneTakes(found.lane, lane);
  };
  const onDragOver = (event) => {
    const laneKey = event.over ? dropTarget(String(event.over.id))?.laneKey : void 0;
    setOverLaneKey(laneKey !== void 0 && takesCard(event.active.id, laneKey) ? laneKey : null);
  };
  const onDragEnd = (event) => {
    endDragging();
    setActiveCardId(null);
    setOverLaneKey(null);
    if (!event.over) return;
    const target = dropTarget(String(event.over.id));
    if (target) void moveCard(String(event.active.id), target.laneKey, target.index);
  };
  const onDragCancel = () => {
    endDragging();
    setActiveCardId(null);
    setOverLaneKey(null);
  };
  const cardNameById = (id) => {
    const found = laneOfCard(String(id));
    return found ? cardName(found.record) : "";
  };
  const laneNameAt = (id) => {
    const target = id === void 0 ? void 0 : dropTarget(String(id));
    const lane = target && lanes.find((x) => x.key === target.laneKey);
    return lane ? laneLabel(lane) : "";
  };
  const announcements = {
    onDragStart: ({ active }) => t("drag", [cardNameById(active.id)]),
    // Nothing of a lane that won't take the card: the drop puts it back.
    onDragOver: ({ active, over }) => over && takesCard(active.id, dropTarget(String(over.id))?.laneKey) ? t("move-to-lane", [laneNameAt(over.id)]) : void 0,
    onDragEnd: ({ active, over }) => over && takesCard(active.id, dropTarget(String(over.id))?.laneKey) ? t("moved", [cardNameById(active.id), laneNameAt(over.id)]) : void 0,
    onDragCancel: () => void 0
  };
  const [openRecord, setOpenRecord] = useState(null);
  const cardPage = showRecordLinks && !form && table ? findRecordPage(recordPages, table) : void 0;
  const cardUrl = (record) => cardPage && record.id && hasSavedId({ id: record.id }) ? recordPageUrl(cardPage, record.id) : void 0;
  const pagesRef = useRef(recordPages);
  pagesRef.current = recordPages;
  const pagesWaiting = useRef([]);
  useEffect(() => {
    if (recordPages !== void 0) for (const resume of pagesWaiting.current.splice(0)) resume();
  }, [recordPages]);
  const pagesRead = () => pagesRef.current !== void 0 ? Promise.resolve() : new Promise((resolve) => {
    pagesWaiting.current.push(resolve);
    setTimeout(resolve, PAGES_WAIT_MS);
  });
  const openCard = async (record) => {
    if (!table || !record.id) return;
    if (dragging.current) return;
    const linksCard = showRecordLinks && !form;
    if (linksCard) await pagesRead();
    const page = linksCard ? findRecordPage(pagesRef.current, table) : void 0;
    const url = page && hasSavedId({ id: record.id }) ? recordPageUrl(page, record.id) : void 0;
    if (url !== void 0) {
      if (onNavigate) onNavigate(url);
      else window.location.assign(url);
      return;
    }
    try {
      const read2 = await ppp.retrieveRecordAsync(table, record.id);
      const permissions = Number(read2.permissions ?? 0);
      setOpenRecord(
        editable ? read2 : { ...read2, permissions: permissions & ~(TableSecurityPermission.Write | TableSecurityPermission.Delete) }
      );
    } catch (error) {
      console.error(`[KanbanBoard] The ${table} ${record.id} couldn't be read for its form.`, error);
      await dialog.showErrorAsync(t("open-failed"));
    }
  };
  const canCreateIn = (lane) => {
    if (!editable || !allowNew || !table || !laneMeta?.isValidForCreate || lane.isClosed || isFull(lane)) return false;
    if (isDateBoard && (!dateLanesNow || !holdsNoDate(lane) && !dateLaneFirstDay(lane))) return false;
    if (access.table === void 0 || (access.table & TableSecurityPermission.Create) !== TableSecurityPermission.Create) return false;
    const column = access.columns ? Object.entries(access.columns).find(([name]) => sameName(name, laneMeta.columnName))?.[1] : void 0;
    return column === void 0 || (Number(column) & ColumnSecurityPermission.Write) === ColumnSecurityPermission.Write;
  };
  const laneForNew = (laneKey) => laneKey === void 0 ? shownLanes.find(canCreateIn) : shownLanes.find((x) => x.key === laneKey && canCreateIn(x));
  const [newRecord, setNewRecord] = useState(null);
  const newCardRun = useRef(0);
  const showNewCardError = (error) => dialog.showErrorAsync(
    error instanceof PowerPortalsProError && error.detail ? error.detail : error instanceof Error && error.message ? error.message : tAll("app.errors.create-record"),
    { title: tAll("app.errors.create-record") }
  );
  const newCard = async (laneKey) => {
    const lane = laneForNew(laneKey);
    if (!lane || !table || !laneMeta) return;
    const dates = dateLanesNow;
    const undated = dates ? holdsNoDate(lane) : lane.key === KANBAN_NO_VALUE_KEY;
    const firstDay = dates && !undated ? dateLaneFirstDay(lane) : void 0;
    if (dates && !undated && !firstDay) return;
    const into = dates && firstDay ? { ...lane, value: { $type: ColumnType.DateTime, value: kanbanDateValueFor(dates.behavior, null, firstDay, dates.timeZone) } } : lane;
    const value2 = undated ? void 0 : kanbanMoveUpdate(table, "", laneMeta, into).properties?.[laneMeta.columnName];
    let record = { tableName: table, properties: value2 ? { [laneMeta.columnName]: value2 } : {} };
    const run = ++newCardRun.current;
    if (prepareNewRecord) {
      try {
        record = await prepareNewRecord(record, lane);
      } catch (error) {
        if (run !== newCardRun.current || !mounted.current) return;
        console.error(`[KanbanBoard] Its prepareNewRecord failed for a new ${table} in the lane '${lane.key}'.`, error);
        await showNewCardError(error);
        return;
      }
    }
    if (run !== newCardRun.current || !mounted.current) return;
    setNewRecord(record);
  };
  const isUserDefault = !!viewId && defaultViewId(saved.settings, allViewIds, savedViewsControl) === viewId;
  const shownSaved = findSaved(viewId);
  const openView = (id) => {
    if (sameName(id, viewId ?? "")) return;
    if (!includeSearchInPersistedState) setSearch("");
    setPickedViewId(id.toLowerCase());
  };
  const adopt = (savedView2) => {
    const id = savedView2.id.toLowerCase();
    const shown = {
      id,
      name: savedView2.name,
      fetchXml: savedView2.definition.fetchXml,
      columns: arrangementRef.current?.columns ?? [],
      layout: parseSavedKanbanLayout(savedView2.kanbanLayout),
      saved: savedView2
    };
    const collapsedNow = arrangementRef.current?.collapsed ?? [];
    const next = arrangeFor(shown);
    setArrangementState({ ...next, collapsed: [...collapsedNow], opening: { ...next.opening, collapsed: [...collapsedNow] } });
    setPickedViewId(id);
  };
  const session = useSavedViewSession({
    saved,
    signInUrl,
    deletingText: tAll("app.components.grid.saved-views-deleting"),
    operations: {
      shownViewId: viewId,
      savedViewName: (id) => findSaved(id)?.name,
      managedViewName: viewName,
      managedViews: () => {
        const userDefault = defaultViewId(saved.settings, allViewIds, savedViewsControl);
        return allViewIds.map((id) => ({
          id,
          name: viewName(id),
          isSaved: !!findSaved(id),
          isDefault: id === userDefault,
          isHidden: isViewHidden(saved.settings, id, savedViewsControl),
          isShown: id === viewId
        })).sort((a, b) => Number(a.isSaved) - Number(b.isSaved) || a.name.localeCompare(b.name));
      },
      save: async () => {
        if (!shownSaved || !currentQuery || !arrangement) return;
        const updated = await saved.update(shownSaved.id, { fetchXml: currentQuery, kanbanLayout: layoutJson });
        adopt(updated);
      },
      saveAs: async (name) => {
        if (!currentQuery || !arrangement) return;
        adopt(await saved.create(name, currentQuery, { kanbanLayout: layoutJson }));
      },
      clone: async (id, name) => {
        const own = findSaved(id);
        if (own) {
          await saved.create(name, own.definition.fetchXml, {
            gridLayout: own.gridLayout,
            calendarLayout: own.calendarLayout,
            kanbanLayout: own.kanbanLayout
          });
          return;
        }
        const definedView = ready?.definedViews.get(id.toLowerCase());
        if (definedView) {
          const layout = kanbanLayoutOf(definedView);
          await saved.create(name, definedView.fetchXml, layout ? { kanbanLayout: savedKanbanLayoutToJson(layout) } : {});
          return;
        }
        const page = ready?.pageViews.get(id.toLowerCase());
        if (page?.fetchXml) await saved.create(name, page.fetchXml, {});
      },
      rename: async (id, name) => void await saved.update(id, { name }),
      remove: async (id) => {
        await saved.remove(id);
        if (sameName(id, viewId ?? "")) {
          const next = offered.find((x) => !sameName(x, id));
          if (next) setPickedViewId(next);
        }
      },
      openView
    }
  });
  const collapsedKey = [...collapsed].sort().join("\n");
  useEffect(() => {
    if (!persistedStateQueryParameter || !view || !arrangement) return;
    const sorted = [...collapsed].sort();
    const opening = [...arrangement.opening.collapsed].sort();
    writePersistedKanbanState(persistedStateQueryParameter, {
      ...view.id !== offered[0] && { v: view.id },
      ...includeSearchInPersistedState && allowSearch && search.trim() && { q: search },
      ...sorted.join("\n") !== opening.join("\n") && { c: sorted }
    });
  }, [persistedStateQueryParameter, view?.id, offered[0], search, collapsedKey, arrangement?.opening]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [columnsOpen, setColumnsOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  const [totalsOpen, setTotalsOpen] = useState(false);
  const viewCriteria = useMemo(() => view ? safely(() => extractGridCriteria(view.fetchXml)) : void 0, [view?.fetchXml]);
  const applyCriteria = (next, restoreView) => {
    setFilterOpen(false);
    if (!view) return;
    const own = viewCriteria !== void 0 && sameGridCriteria(next, viewCriteria) ? null : next;
    if (restoreView) {
      const arranged = arrangeFor(view);
      setArrangementState({ ...arranged, criteria: own });
    } else arrange((x) => ({ ...x, criteria: own }));
  };
  const ownColumns = view ? [.../* @__PURE__ */ new Set([...view.columns, ...queriedColumns2(view.fetchXml)])] : [];
  const applyColumns = (choice2) => {
    setColumnsOpen(false);
    if (!view) return;
    const own = view.columns;
    arrange((x) => ({
      ...x,
      columnsQuery: choice2.fetchXml,
      columns: [...own, ...choice2.added.filter((added) => !includesName(own, added))],
      hiddenColumns: [
        ...x.hiddenColumns.filter((hidden) => !includesName(own, hidden)),
        ...own.filter((column) => includesName(choice2.hiddenOwn, column))
      ]
    }));
  };
  const sortColumns2 = viewCardColumns.map((column) => ({ key: column, title: columnTitle(column) ?? column }));
  const shownSort = currentQuery ? querySorts(currentQuery).filter((x) => !(rankMeta && sameName(x.columnName, rankMeta.columnName))) : [];
  const applySort = (sort) => {
    setSortOpen(false);
    arrange((x) => ({ ...x, userSort: sort.length > 0 ? sort : null }));
  };
  const totalsColumns = [...viewCardColumns, ...Object.keys(arrangement?.totals ?? {})].filter((x, i, all) => !x.includes(".") && all.findIndex((y) => sameName(x, y)) === i).flatMap((column) => {
    const offeredFigures = serverColumns.find((x) => sameName(x.columnName, column))?.aggregates ?? [];
    return offeredFigures.length > 0 ? [{ columnName: column, title: columnTitle(column) ?? column, offered: offeredFigures }] : [];
  });
  const shownTotals = new Map(Object.entries(arrangement?.totals ?? {}).map(([column, figures]) => [column, figures.map((x) => x.aggregate)]));
  const applyTotals = (totals) => {
    setTotalsOpen(false);
    arrange((x) => {
      const next = { ...x.totals };
      for (const column of totalsColumns) {
        const chosenKey = [...totals.keys()].find((key4) => sameName(key4, column.columnName));
        const chosen = column.offered.filter((figure) => (chosenKey ? totals.get(chosenKey) ?? [] : []).includes(figure));
        const key3 = Object.keys(next).find((name) => sameName(name, column.columnName)) ?? column.columnName;
        const earlier = next[key3] ?? [];
        if (chosen.length === 0) {
          delete next[key3];
          continue;
        }
        const pageFormat = laneAggregateFormats?.[column.columnName];
        next[key3] = chosen.map((aggregate) => {
          const format = earlier.find((e) => e.aggregate === aggregate)?.format ?? pageFormat;
          return { aggregate, ...format !== void 0 && { format } };
        });
      }
      return { ...x, totals: next };
    });
  };
  const pageSizes = [...new Set([...PAGE_SIZES, pageSize].filter((x) => x > 0))].sort((a, b) => a - b);
  const collapse = (lane) => {
    arrange((x) => ({ ...x, collapsed: [.../* @__PURE__ */ new Set([...x.collapsed, lane.key])] }));
    announce(t("collapse", [laneLabel(lane)]));
  };
  const expand = (lane) => {
    arrange((x) => ({ ...x, collapsed: x.collapsed.filter((key3) => key3 !== lane.key) }));
    if (laneData[lane.key]?.failed) void loadLane(lane);
  };
  const showLane = (key3, shown) => arrange((x) => ({ ...x, hiddenLanes: shown ? x.hiddenLanes.filter((k) => k !== key3) : [.../* @__PURE__ */ new Set([...x.hiddenLanes, key3])] }));
  const context = {
    table,
    viewId,
    lanes: shownLanes,
    refresh,
    canCreate: (laneKey) => !!laneForNew(laneKey),
    newCard: (laneKey) => void newCard(laneKey)
  };
  const formDefinition = laneMeta ? { title: cardColumns[0] ?? null, columns: [...cardColumns.filter((x) => !x.includes(".")), laneMeta.columnName] } : void 0;
  const viewOptions = offered.map((id) => ({ id, label: viewName(id) }));
  const showsViewPicker = viewOptions.length > 1 || saved.available && viewOptions.length > 0;
  const dialogLocation = formLocation === "left" ? "panel-left" : formLocation === "right" ? "panel" : "center";
  const configError = setup.status === "error" ? setup.message : isDateBoard && dateLanesMistake ? t("error") : void 0;
  const activeCard = activeCardId ? laneOfCard(activeCardId) : void 0;
  const imageUrlOf = (record) => {
    if (!cardImageColumn || !record.id || !table) return void 0;
    const version = valueOf(record, `${cardImageColumn}_timestamp`);
    return version === null || version === void 0 ? void 0 : Routes.api.getRetrieveImageRoute(table, record.id, cardImageColumn, version, 80);
  };
  const shownValue = (record, column, isTitle = false, recordLink = true) => {
    const shown = displayValue(record, column);
    if (shown === null || shown === "") return shown;
    const type = serverColumns.find((x) => sameName(x.columnName, column))?.type ?? metadataOf(column)?.$type;
    const highlight = searchHighlightFor(numberOf2(type), record.properties?.[column], shown, searched, locale);
    const text2 = /* @__PURE__ */ jsx(SearchHighlightedText, { text: shown, highlight, className: "ppp-kanban-card-value" });
    const url = isTitle ? cardUrl(record) : recordLink && showRecordLinks ? lookupUrl(record, column) : void 0;
    if (url === void 0) return text2;
    return /* @__PURE__ */ jsx("span", { className: "ppp-kanban-card-link", onClick: (event) => event.stopPropagation(), children: /* @__PURE__ */ jsx(RecordLink, { href: url, onNavigate, children: text2 }) });
  };
  const lookupUrl = (record, column) => {
    const own = record.properties?.[column];
    const lookup = own?.$type === "RelatedRecordValue" ? own.value : own;
    if (lookup?.$type !== ColumnType.Lookup || !lookup.tableName || !lookup.value || !canReadColumn(record, column)) return void 0;
    if (!hasSavedId({ id: lookup.value })) return void 0;
    const page = findRecordPage(recordPages, lookup.tableName);
    return page ? recordPageUrl(page, lookup.value) : void 0;
  };
  const cardContent = (record, lane) => {
    const canMove = canMoveCard(record, lane);
    if (cardRenderer) {
      return {
        template: cardRenderer({
          record,
          lane,
          field: (column, options) => shownValue(record, column, false, options?.recordLink ?? true),
          searchText: searched.replace(/\*/g, ""),
          label: columnTitle,
          displayValue: (column) => displayValue(record, column),
          canOpen: !!record.id,
          open: () => void openCard(record),
          canMove,
          moveTo: (laneKey) => moveCard(cardIdOf(record), laneKey, 0)
        })
      };
    }
    const [first, ...rest] = cardColumns;
    return {
      ...cardImageColumn && { avatar: /* @__PURE__ */ jsx(RecordCardAvatar, { name: cardName(record), imageUrl: imageUrlOf(record), size: 40 }) },
      ...first && { title: shownValue(record, first, true) },
      fields: rest.map((column) => ({ key: column, label: columnTitle(column), value: shownValue(record, column) }))
    };
  };
  const searchGroups = searchHintColumns(
    (cardRenderer ? arrangement?.columns ?? [] : cardColumns).map((column) => ({
      columnName: column,
      displayName: columnTitle(column) ?? column,
      type: numberOf2(serverColumns.find((x) => sameName(x.columnName, column))?.type ?? metadataOf(column)?.$type)
    })),
    void 0,
    /* @__PURE__ */ new Map(),
    (column) => searchKindOf(column.type)
  );
  const searchTooltip = searchGroups.text.length + searchGroups.number.length + searchGroups.date.length > 0 ? /* @__PURE__ */ jsx(SearchColumnsTooltip, { text: searchGroups.text, number: searchGroups.number, date: searchGroups.date }) : void 0;
  const overLimitId = (index) => `${boardId}-list-${index}-over-limit`;
  const countBadge = (lane, index, strip) => {
    const text2 = countText(lane);
    if (text2 === void 0) return null;
    const over = isOverLimit(lane);
    const limit = String(limitOf(lane) ?? "");
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Badge,
        {
          className: mergeClasses("ppp-kanban-lane-count", strip && "ppp-kanban-lane-strip-count", over && "ppp-kanban-lane-count--over-limit"),
          appearance: "tint",
          color: over ? "danger" : "brand",
          size: "small",
          "data-ppp-tooltip": over && !strip ? t("over-limit", [limit]) : void 0,
          children: text2
        }
      ),
      over && /* @__PURE__ */ jsx("span", { id: overLimitId(index), className: mergeClasses("ppp-kanban-lane-over-limit", styles.visuallyHidden), children: t("over-limit", [limit]) })
    ] });
  };
  const laneDot = (lane) => lane.color?.trim() ? /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-kanban-lane-dot", styles.dot), style: { backgroundColor: lane.color }, "aria-hidden": true }) : null;
  const settingsMenu = /* @__PURE__ */ jsxs(Menu, { children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: tAll("app.buttons.settings.label"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(Button, { className: "ppp-kanban-settings", appearance: "subtle", icon: /* @__PURE__ */ jsx(Settings24Regular, {}) }) }) }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs(
      MenuList,
      {
        checkedValues: { pageSize: [String(arrangement?.pageSize ?? pageSize)] },
        onCheckedValueChange: (_, data) => {
          const size = Number(data.checkedItems[0]);
          if (size > 0) arrange((x) => ({ ...x, pageSize: size }));
        },
        children: [
          /* @__PURE__ */ jsx(MenuItem, { className: "ppp-kanban-settings-columns", icon: /* @__PURE__ */ jsx(TableAdd20Regular, {}), onClick: () => setColumnsOpen(true), children: tAll("app.components.grid.columns") }),
          sortColumns2.length > 0 && /* @__PURE__ */ jsx(MenuItem, { className: "ppp-kanban-settings-sort", icon: /* @__PURE__ */ jsx(ArrowSort20Regular, {}), onClick: () => setSortOpen(true), children: tAll("app.components.grid.sort") }),
          /* @__PURE__ */ jsx(MenuDivider, {}),
          /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-kanban-menu-group", styles.menuGroup), role: "presentation", children: t("cards-per-lane") }),
          pageSizes.map((size) => /* @__PURE__ */ jsx(MenuItemRadio, { className: "ppp-kanban-settings-page-size", name: "pageSize", value: String(size), children: size }, size))
        ]
      }
    ) })
  ] });
  const lanesView = /* @__PURE__ */ jsxs(
    DndContext,
    {
      sensors,
      accessibility: { announcements, screenReaderInstructions: { draggable: t("drag-instructions") } },
      onDragStart,
      onDragOver,
      onDragEnd,
      onDragCancel,
      children: [
        /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-kanban-lanes", styles.lanes), children: shownLanes.map((lane) => {
          const index = lanes.indexOf(lane);
          const label = laneLabel(lane);
          const data = laneData[lane.key];
          const overLimit = isOverLimit(lane);
          return isCollapsed(lane) ? /* @__PURE__ */ jsx(
            "div",
            {
              className: mergeClasses(
                "ppp-kanban-lane ppp-kanban-lane--collapsed",
                overLimit && "ppp-kanban-lane--over-limit",
                styles.lane,
                styles.laneCollapsed
              ),
              "data-lane-key": lane.key,
              children: /* @__PURE__ */ jsxs(
                "button",
                {
                  type: "button",
                  className: mergeClasses("ppp-kanban-lane-strip", styles.strip),
                  "aria-expanded": false,
                  "aria-label": t("expand", [label]),
                  "data-ppp-tooltip": [
                    t("expand", [label]),
                    ...data?.failed ? [t("lane-failed")] : overLimit ? [t("over-limit", [String(limitOf(lane) ?? "")])] : []
                  ].join("\n"),
                  ...data?.failed ? { "aria-describedby": `${boardId}-list-${index}-failed` } : overLimit && { "aria-describedby": overLimitId(index) },
                  onClick: () => expand(lane),
                  children: [
                    laneDot(lane),
                    /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-kanban-lane-strip-label", styles.stripLabel), children: label }),
                    data?.failed ? /* @__PURE__ */ jsx(
                      "span",
                      {
                        id: `${boardId}-list-${index}-failed`,
                        className: mergeClasses("ppp-kanban-lane-strip-failed", styles.stripFailed),
                        role: "img",
                        "aria-label": t("lane-failed"),
                        children: /* @__PURE__ */ jsx(Warning16Regular, {})
                      }
                    ) : countBadge(lane, index, true)
                  ]
                }
              )
            },
            lane.key
          ) : /* @__PURE__ */ jsx(
            KanbanLaneView,
            {
              lane,
              takesDrops: laneTakesDrops(lane),
              droppableId: `${droppablePrefix}${index}`,
              listId: `${boardId}-list-${index}`,
              label,
              over: overLaneKey === lane.key && activeCardId !== null,
              ...overLimit && { overLimitId: overLimitId(index) },
              header: /* @__PURE__ */ jsxs("header", { className: mergeClasses("ppp-kanban-lane-header", styles.header), children: [
                /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-kanban-lane-heading", styles.heading), children: [
                  laneDot(lane),
                  /* @__PURE__ */ jsx("span", { id: `${boardId}-list-${index}-label`, className: mergeClasses("ppp-kanban-lane-label", styles.label), children: label }),
                  countBadge(lane, index, false),
                  /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-kanban-lane-actions", styles.laneActions), children: [
                    canCreateIn(lane) && /* @__PURE__ */ jsx(
                      Button,
                      {
                        className: "ppp-kanban-lane-new",
                        appearance: "transparent",
                        size: "small",
                        icon: /* @__PURE__ */ jsx(Add16Regular, {}),
                        "aria-label": t("new-in", [label]),
                        "data-ppp-tooltip": t("new-in", [label]),
                        onClick: () => void newCard(lane.key)
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Button,
                      {
                        className: "ppp-kanban-lane-collapse",
                        appearance: "transparent",
                        size: "small",
                        icon: /* @__PURE__ */ jsx(ChevronDoubleLeft16Regular, {}),
                        "aria-label": t("collapse", [label]),
                        "data-ppp-tooltip": t("collapse", [label]),
                        onClick: () => collapse(lane)
                      }
                    )
                  ] })
                ] }),
                requestedTotals.length > 0 && /* @__PURE__ */ jsx("dl", { className: mergeClasses("ppp-kanban-lane-totals", styles.totals), children: laneTotals(lane).map((total) => /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-kanban-lane-total", styles.total), children: [
                  /* @__PURE__ */ jsx("dt", { className: styles.totalLabel, children: total.label }),
                  /* @__PURE__ */ jsx("dd", { className: styles.totalValue, children: total.text })
                ] }, total.key)) })
              ] }),
              children: data?.failed ? /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-kanban-lane-failed", styles.failed), children: [
                /* @__PURE__ */ jsx(Text, { children: t("lane-failed") }),
                /* @__PURE__ */ jsx(Button, { size: "small", onClick: () => void loadLane(lane), children: t("retry") })
              ] }) : !data || data.for === NOT_READ || data.loading && data.pagesLoaded === 0 ? /* @__PURE__ */ jsx(Skeleton, { className: mergeClasses("ppp-kanban-lane-loading", styles.loading), "aria-label": t("loading"), children: [0, 1, 2].map((x) => /* @__PURE__ */ jsx(SkeletonItem, { style: { height: "72px" } }, x)) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
                data.cards.length === 0 && /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-kanban-lane-empty", styles.empty), children: t("empty-lane") }),
                /* @__PURE__ */ jsx(
                  SortableContext,
                  {
                    id: `${boardId}-list-${index}`,
                    items: data.cards.map(cardIdOf),
                    strategy: canReorder(lane) ? verticalListSortingStrategy : () => null,
                    children: /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-kanban-cards", styles.cards), role: "list", "aria-labelledby": `${boardId}-list-${index}-label`, children: data.cards.map((record) => {
                      const targets = moveTargets(lane);
                      const canMove = canMoveCard(record, lane);
                      return /* @__PURE__ */ jsx(
                        KanbanCardView,
                        {
                          id: cardIdOf(record),
                          disabled: !canMove,
                          coarsePointer,
                          gripLabel: t("drag", [cardName(record)]),
                          onOpen: () => void openCard(record),
                          content: cardContent(record, lane),
                          moveMenu: canMove && targets.length > 0 ? /* @__PURE__ */ jsxs(Menu, { children: [
                            /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
                              Button,
                              {
                                className: "ppp-kanban-move",
                                appearance: "transparent",
                                size: "small",
                                icon: /* @__PURE__ */ jsx(MoreHorizontal16Regular, {}),
                                "aria-label": t("move-to"),
                                "data-ppp-tooltip": t("move-to")
                              }
                            ) }),
                            /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: targets.map((target) => /* @__PURE__ */ jsx(
                              MenuItem,
                              {
                                className: "ppp-kanban-move-to",
                                "data-lane-key": target.key,
                                onClick: () => void moveCard(cardIdOf(record), target.key, 0),
                                children: t("move-to-lane", [laneLabel(target)])
                              },
                              target.key
                            )) }) })
                          ] }) : void 0
                        },
                        cardIdOf(record)
                      );
                    }) })
                  }
                ),
                data.moreRecords && /* @__PURE__ */ jsx(
                  Button,
                  {
                    className: mergeClasses("ppp-kanban-load-more", styles.loadMore),
                    appearance: "subtle",
                    disabled: data.loadingMore,
                    onClick: () => void loadMore(lane),
                    children: t("load-more")
                  }
                )
              ] })
            },
            lane.key
          );
        }) }),
        /* @__PURE__ */ jsx(DragOverlay, { children: activeCard ? /* @__PURE__ */ jsx(
          RecordCard,
          {
            className: mergeClasses("ppp-kanban-record-card", styles.recordCard, styles.overlay),
            ...cardContent(activeCard.record, activeCard.lane)
          }
        ) : null })
      ]
    }
  );
  return /* @__PURE__ */ jsxs("section", { ref: boardRef, className: mergeClasses("ppp-kanban", styles.root, className), style: { height, ...style }, children: [
    /* @__PURE__ */ jsx(SharedTooltip, { containerRef: boardRef }),
    /* @__PURE__ */ jsxs(
      ViewToolbar,
      {
        className: "ppp-kanban-toolbar",
        ariaLabel: t("toolbar"),
        start: showsViewPicker ? /* @__PURE__ */ jsx(
          ViewPicker,
          {
            className: "ppp-kanban-view-picker",
            options: viewOptions,
            sort: viewSort,
            value: viewId,
            onChange: openView,
            isUserView: (id) => saved.available && !!findSaved(id)
          }
        ) : title ? /* @__PURE__ */ jsx(Text, { as: "h2", size: 400, weight: "semibold", className: styles.title, children: title }) : void 0,
        children: [
          children !== void 0 && /* @__PURE__ */ jsx(KanbanBoardContext.Provider, { value: context, children }),
          !configError && totalsColumns.length > 0 && /* @__PURE__ */ jsxs(Popover, { positioning: "below-end", withArrow: true, trapFocus: true, open: totalsOpen, onOpenChange: (_, data) => setTotalsOpen(data.open), children: [
            /* @__PURE__ */ jsx(PopoverTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: tAll("app.components.grid.totals"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(Button, { className: "ppp-kanban-totals", appearance: "subtle", icon: /* @__PURE__ */ jsx(MathFormula24Regular, {}) }) }) }),
            /* @__PURE__ */ jsx(PopoverSurface, { children: totalsOpen && /* @__PURE__ */ jsx(GridTotalsPanel, { columns: totalsColumns, totals: shownTotals, onApply: applyTotals, onCancel: () => setTotalsOpen(false) }) })
          ] }),
          allowSearch && /* @__PURE__ */ jsx(
            ViewSearchBox,
            {
              className: mergeClasses("ppp-kanban-search", styles.search),
              ...searchTooltip && { tooltip: searchTooltip },
              placeholder: t("search-placeholder"),
              value: search,
              onChange: setSearch
            }
          ),
          /* @__PURE__ */ jsx(
            ViewFilterMenu,
            {
              changed: viewChanged,
              onEditFilters: allowFiltering && view && table ? () => setFilterOpen(true) : void 0,
              tables: lanes.map((lane) => ({ table: lane.key, label: laneLabel(lane), shown: !hiddenLanes.includes(lane.key) })),
              onTableShownChange: showLane,
              savedViews: session.menu({ canSave: !!shownSaved && viewChanged, canSaveAs: viewChanged, canSetDefault: !!viewId && !isUserDefault })
            }
          ),
          /* @__PURE__ */ jsx(ViewRefreshButton, { className: "ppp-kanban-refresh", onClick: refresh }),
          !configError && view && settingsMenu
        ]
      }
    ),
    configError ? /* @__PURE__ */ jsx(MessageBar, { intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: configError }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(ViewLoadMessages, { failed: setup.status === "failed", errorText: t("error"), retryText: t("retry"), onRetry: refresh }),
      lanesView
    ] }),
    /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-kanban-visually-hidden", styles.visuallyHidden), role: "status", "aria-live": "polite", children: announcement }),
    filterOpen && table && view && viewCriteria !== void 0 && /* @__PURE__ */ jsx(
      GridFilterDialog,
      {
        open: true,
        table,
        criteria: arrangement?.criteria ?? viewCriteria,
        viewCriteria,
        onApply: applyCriteria,
        onCancel: () => setFilterOpen(false)
      }
    ),
    columnsOpen && view && arrangement && /* @__PURE__ */ jsx(
      GridColumnsDialog,
      {
        open: true,
        fetchXml: arrangement.columnsQuery ?? view.fetchXml,
        ownColumns,
        ownJoins: joinAliases(view.fetchXml),
        keptColumns: ownColumns,
        extraJoins: arrangement.criteria ? joinCount(arrangement.criteria) : 0,
        shown: cardColumns,
        onApply: applyColumns,
        onCancel: () => setColumnsOpen(false)
      }
    ),
    /* @__PURE__ */ jsx(Dialog, { open: sortOpen, onOpenChange: (_, data) => setSortOpen(data.open), children: /* @__PURE__ */ jsx(DialogSurface, { "aria-label": tAll("app.components.grid.sort"), children: sortOpen && /* @__PURE__ */ jsx(GridSortPanel, { columns: sortColumns2, sort: shownSort, onApply: applySort, onCancel: () => setSortOpen(false) }) }) }),
    /* @__PURE__ */ jsx(SavedViewDialogs, { session }),
    openRecord && table && formDefinition && /* @__PURE__ */ jsx(
      MultiTableRecordPanel,
      {
        title: cardName(openRecord),
        existing: { table, id: openRecord.id },
        loaded: openRecord,
        form: form ?? KanbanDefaultForm,
        location: dialogLocation,
        definition: formDefinition,
        onSaved: () => {
          setOpenRecord(null);
          setRefreshes((x) => x + 1);
        },
        onClose: () => setOpenRecord(null)
      },
      openRecord.id
    ),
    newRecord && table && formDefinition && /* @__PURE__ */ jsx(
      MultiTableRecordPanel,
      {
        title: tAll("app.messages.create-record-title", [tAll(`tables.${table}.label`)]),
        record: newRecord,
        recordChanged: Object.keys(newRecord.properties ?? {}).length > 0,
        form: form ?? KanbanDefaultForm,
        location: dialogLocation,
        definition: formDefinition,
        onSaved: () => {
          setNewRecord(null);
          setRefreshes((x) => x + 1);
        },
        onClose: () => setNewRecord(null)
      }
    )
  ] });
}
function currentQueryOf(view, arrangement) {
  const source = arrangement.columnsQuery ?? view.fetchXml;
  return safely(() => boardQuery(source, arrangement.criteria, arrangement.userSort)) ?? source;
}
function layoutOf(arrangement) {
  const columns = arrangement.columns.map((columnName) => {
    const totals = Object.entries(arrangement.totals).find(([name]) => sameName(name, columnName))?.[1];
    const title = Object.entries(arrangement.titles).find(([name]) => sameName(name, columnName))?.[1];
    return {
      columnName,
      ...includesName(arrangement.hiddenColumns, columnName) && { hidden: true },
      ...title && { displayLabel: title },
      ...totals && { aggregates: totals }
    };
  });
  for (const [columnName, aggregates] of Object.entries(arrangement.totals)) {
    if (!includesName(arrangement.columns, columnName)) columns.push({ columnName, hidden: true, aggregates });
  }
  return {
    version: SAVED_KANBAN_LAYOUT_VERSION,
    pageSize: arrangement.pageSize,
    columns,
    collapsedLanes: [...arrangement.collapsed].sort(),
    hiddenLanes: [...arrangement.hiddenLanes].sort()
  };
}
function safely(read2) {
  try {
    return read2();
  } catch {
    return void 0;
  }
}
function KanbanLaneView({
  lane,
  droppableId,
  listId,
  label,
  over,
  overLimitId,
  takesDrops,
  header,
  children
}) {
  const styles = useKanbanStyles();
  const { setNodeRef } = useDroppable({ id: droppableId, disabled: !takesDrops });
  return /* @__PURE__ */ jsxs(
    "section",
    {
      ref: setNodeRef,
      className: mergeClasses(
        "ppp-kanban-lane",
        styles.lane,
        over && "ppp-kanban-lane--over",
        over && styles.laneOver,
        overLimitId !== void 0 && "ppp-kanban-lane--over-limit",
        overLimitId !== void 0 && styles.laneOverLimit
      ),
      "data-lane-key": lane.key,
      "aria-labelledby": `${listId}-label`,
      "aria-label": label,
      ...overLimitId !== void 0 && { "aria-describedby": overLimitId },
      children: [
        header,
        /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-kanban-lane-body", styles.body), children })
      ]
    }
  );
}
function KanbanCardView({
  id,
  disabled,
  coarsePointer,
  gripLabel,
  onOpen,
  content,
  moveMenu
}) {
  const styles = useKanbanStyles();
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({ id, disabled });
  const { onKeyDown: dragKeyDown, ...pointerListeners } = listeners ?? {};
  const onKeyDown = (event) => {
    if (event.key === "Enter" && !isDragging && event.target === event.currentTarget) {
      event.preventDefault();
      onOpen();
      return;
    }
    dragKeyDown?.(event);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: setNodeRef,
      role: "listitem",
      className: mergeClasses("ppp-kanban-card", styles.card, isDragging && styles.cardDragging),
      "data-card-id": id,
      style: { transform: CSS$1.Transform.toString(transform), transition },
      children: [
        /* @__PURE__ */ jsx(
          RecordCard,
          {
            ...attributes,
            ...!coarsePointer && pointerListeners,
            role: "button",
            "aria-disabled": void 0,
            onKeyDown,
            className: mergeClasses("ppp-kanban-record-card", styles.recordCard),
            clickable: true,
            onClick: onOpen,
            ...content,
            ...coarsePointer && !disabled && {
              // Its tooltip, the board's, shows for a mouse or a pen but not a finger, which pressing
              // the grip is starting a drag; a press hides it.
              marks: /* @__PURE__ */ jsx(
                "span",
                {
                  ref: setActivatorNodeRef,
                  className: mergeClasses("ppp-kanban-grip", styles.grip),
                  "aria-hidden": true,
                  "data-ppp-tooltip": gripLabel,
                  ...pointerListeners,
                  children: /* @__PURE__ */ jsx(ReOrderDotsVertical16Regular, {})
                }
              )
            }
          }
        ),
        moveMenu && /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-kanban-card-actions", styles.actions), children: moveMenu })
      ]
    }
  );
}
function defaultStatusBadgeTone(state) {
  return state === 0 ? { color: "brand", appearance: "tint" } : { color: "informative", appearance: "outline" };
}
function ColumnStatusBadge({
  labelColumn = "statuscode",
  stateColumn = "statecode",
  tone = defaultStatusBadgeTone,
  size = "medium",
  isVisible = true,
  className,
  style,
  id
}) {
  const label = useColumnValue(labelColumn);
  const state = useColumnValue(stateColumn);
  if (!isVisible || !label.readable || !label.formatted) return null;
  const { color, appearance } = tone(state.raw);
  return /* @__PURE__ */ jsx(
    Badge,
    {
      id,
      className: mergeClasses("ppp-column-status-badge", className),
      style,
      color,
      appearance,
      size,
      children: label.formatted
    }
  );
}
var AddressMapServiceContext = createContext(null);
function useAddressMapService() {
  return useContext(AddressMapServiceContext);
}
var useAddressDisplayValueStyles = makeStyles({
  value: {
    // Same rhythm as <ColumnDisplayValue>, so the two sit together in a form layout.
    minHeight: tokens.lineHeightBase300,
    padding: `${tokens.spacingVerticalXS} 0`,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    // <address> is italic by default; an address here is data, not a citation.
    fontStyle: "normal",
    whiteSpace: "normal",
    wordBreak: "break-word"
  },
  empty: {
    color: tokens.colorNeutralForeground3
  },
  // The address with its map pin in the top right corner.
  withMap: {
    display: "flex",
    alignItems: "flex-start",
    columnGap: tokens.spacingHorizontalXS
  },
  withMapAddress: {
    flexGrow: 1,
    minWidth: 0
  }
});
function AddressDisplayValue({
  prefix = "address1",
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  homeCountry,
  isVisible = true,
  emptyPlaceholder = "\u2014",
  className,
  style,
  id,
  showMap = false,
  latitudeColumn,
  longitudeColumn
}) {
  const { record, dirtyColumns } = useRecordContext();
  const addressMap = useAddressMapService();
  if (showMap && !addressMap) {
    throw new Error(
      "AddressDisplayValue's showMap needs @powerportalspro/react-maps: put its <MapsProvider> around the app."
    );
  }
  const compositeColumn = `${prefix}_composite`;
  const metadata = useColumnMetadata(compositeColumn);
  const styles = useAddressDisplayValueStyles();
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, compositeColumn, record?.tableName, t);
  const layoutClassName = useEditorLabelLayoutClass(
    labelPosition,
    displayLabelWhenAvailable && !!resolvedLabel
  );
  if (!isVisible) return null;
  const resolvedDescription = resolveDescription(description, metadata, compositeColumn, record?.tableName, t);
  const lines = record ? resolveAddressLines(record, prefix, homeCountry, dirtyColumns) : [];
  const isEmpty = lines.length === 0;
  const storedPosition = () => record ? resolveAddressPosition(
    record,
    prefix,
    latitudeColumn ?? `${prefix}_latitude`,
    longitudeColumn ?? `${prefix}_longitude`,
    dirtyColumns
  ) : null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    className: editorLabelClassName,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const address = /* @__PURE__ */ jsx(
    "address",
    {
      id,
      className: mergeClasses(styles.value, isEmpty && styles.empty, showMap && styles.withMapAddress, className),
      style,
      children: isEmpty ? emptyPlaceholder : lines.map((line, i) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
        i > 0 && /* @__PURE__ */ jsx("br", {}),
        line
      ] }, i))
    }
  );
  const showMapLabel = t("app.components.address-display-value.show-map");
  const mapButton = addressMap && record && (!isEmpty || storedPosition()) ? /* @__PURE__ */ jsx(Tooltip, { content: showMapLabel, relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
    Button,
    {
      className: "ppp-address-display-value-map",
      appearance: "subtle",
      size: "small",
      icon: /* @__PURE__ */ jsx(LocationRegular, {}),
      "aria-label": showMapLabel,
      onClick: () => addressMap.show({
        title: resolvedLabel || t("app.components.address-display-value.map-title"),
        lines,
        query: resolveAddressQuery(record, prefix, dirtyColumns),
        position: storedPosition() ?? void 0
      })
    }
  ) }) : null;
  return /* @__PURE__ */ jsx(Field, { className: mergeClasses(
    "ppp-address-display-value",
    layoutClassName,
    layoutClassName && "ppp-label-text"
  ), label: labelSlot, hint: fieldHint, children: showMap ? /* @__PURE__ */ jsxs("div", { className: styles.withMap, children: [
    address,
    mapButton
  ] }) : address });
}
function TimeZoneDropdown({ value: value2, onChange, disabled, readOnly, id, className, style }) {
  const { ppp } = usePowerPortalsPro();
  const t = useT();
  const [timeZones, setTimeZones] = useState(void 0);
  useEffect(() => {
    const abort = new AbortController();
    ppp.getTimeZonesAsync(abort.signal).then(setTimeZones).catch(() => {
      if (!abort.signal.aborted) setTimeZones([]);
    });
    return () => abort.abort();
  }, [ppp]);
  const chosen = value2 ?? void 0;
  const selectedName = chosen === void 0 ? "" : timeZones?.find((zone) => Number(zone.code) === chosen)?.name ?? String(chosen);
  if (readOnly) {
    return /* @__PURE__ */ jsx(ReadOnlyValue, { ...id !== void 0 && { id }, children: timeZones ? selectedName : "" });
  }
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      id,
      className,
      style,
      value: timeZones ? selectedName : "",
      selectedOptions: chosen === void 0 ? [] : [String(chosen)],
      placeholder: t("app.components.time-zone-edit.placeholder"),
      disabled: disabled || !timeZones,
      onOptionSelect: (_, data) => {
        if (data.optionValue !== void 0) onChange(Number(data.optionValue));
      },
      children: (timeZones ?? []).map((zone) => /* @__PURE__ */ jsx(Option, { value: String(zone.code), text: zone.name, children: zone.name }, zone.code))
    }
  );
}
function TimeZoneEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  validate
}) {
  const { value: value2, setValue: rawSetValue } = useNumberColumn(columnName, "int");
  const { record } = useRecordContext();
  const recordLocked = useRecordLocked();
  const metadata = useColumnMetadata(columnName);
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = resolveDescription(description, metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled,
    columnName,
    recordLocked
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const validationErrors = useColumnValidation(
    columnName,
    { kind: "number", required: resolvedRequired, label: resolvedLabel, value: value2 ?? null },
    validate
  );
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-time-zone-edit"),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...buildFieldValidationProps(validationErrors, displayValidationErrorMessage),
      children: /* @__PURE__ */ jsx(
        TimeZoneDropdown,
        {
          id,
          className,
          style,
          value: value2,
          onChange: setValue,
          disabled: resolvedDisabled,
          readOnly: resolvedReadOnly && !resolvedDisabled
        }
      )
    }
  );
}
function buildFilter(parentRecord, relationshipName, mode, selfReferencingRole) {
  return {
    $type: "RelationshipFilter",
    parentRecord: {
      tableName: parentRecord.tableName,
      id: getRecordReferenceId(parentRecord)
    },
    relationshipName,
    mode,
    ...selfReferencingRole !== void 0 && { selfReferencingRole }
  };
}
function buildRequests(parentRecord, relationshipName, relatedTableName, pendingAdds, pendingRemoveIds, initialSelection, selfReferencingRole) {
  if (!relatedTableName) return [];
  if (pendingAdds.length === 0 && pendingRemoveIds.length === 0) return [];
  const requests = [];
  const parentRef = {
    tableName: parentRecord.tableName,
    id: getRecordReferenceId(parentRecord)
  };
  if (pendingAdds.length > 0) {
    const associate = {
      $type: "AssociateRequest",
      record: parentRef,
      relationshipName,
      ...selfReferencingRole !== void 0 && { role: selfReferencingRole },
      relatedRecords: pendingAdds.map((r) => ({
        tableName: r.source.tableName,
        id: r.id
      }))
    };
    requests.push(associate);
  }
  if (pendingRemoveIds.length > 0) {
    const removedRecords = initialSelection.filter((r) => pendingRemoveIds.includes(r.id)).map((r) => ({ tableName: r.source.tableName, id: r.id }));
    if (removedRecords.length > 0) {
      const disassociate = {
        $type: "DisassociateRequest",
        record: parentRef,
        relationshipName,
        ...selfReferencingRole !== void 0 && { role: selfReferencingRole },
        relatedRecords: removedRecords
      };
      requests.push(disassociate);
    }
  }
  return requests;
}
function resolveDisplayName(record, primaryNameColumn) {
  const formatted = record.formattedValues?.[primaryNameColumn];
  if (formatted && formatted.length > 0) return formatted;
  const raw = record.properties?.[primaryNameColumn];
  if (raw && typeof raw === "object" && "value" in raw) {
    const v = raw.value;
    if (typeof v === "string" && v.length > 0) return v;
  }
  return void 0;
}
var ManyToManyLookupEditorType = {
  /** Fluent `TagPicker` — selected records render as removable chips above the input. */
  TagPicker: "tagPicker",
  /** Fluent `Combobox` in `multiselect` mode — selected records render comma-separated. */
  Combobox: "combobox"
};
var VIEW_TYPE_PUBLIC2 = 0;
var DEFAULT_MAX_RECORDS_RETURNED = 20;
var SEARCH_DEBOUNCE_MS4 = 300;
var useStyles31 = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXS,
    width: "100%"
  },
  // Dropdown list — caps the internal height + enables scrolling so the
  // popup can't grow off the bottom of the viewport when there are many
  // suggestions. `paddingTop: 0` / `paddingBottom: 0` remove Fluent's
  // default vertical insets so the sticky view-picker header and the
  // sticky Advanced Search footer sit flush against the list edges
  // (otherwise scrolling rows are briefly visible inside the padding
  // strip before being clipped behind the sticky element). The actual
  // min-height / max-height values come from the component's
  // `popupMinHeight` / `popupMaxHeight` props, applied inline on the slot.
  dropdownList: {
    overflowY: "auto",
    paddingTop: "0",
    paddingBottom: "0"
  },
  labelRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalXS
  },
  control: {
    width: "100%"
  },
  // Sticky-header view picker. Mirrors slot on the
  // autocomplete — only shown when there are multiple views to choose from.
  // `position: sticky` keeps it pinned while the user scrolls suggestions.
  // The background fill avoids see-through against scrolling rows.
  // Its z-index is above the Advanced Search footer's: the view list
  // belongs to this header's stacking layer, and with few suggestions it
  // reaches down over the footer, which would otherwise be drawn on top.
  viewPickerHeader: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: tokens.colorNeutralBackground1,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    display: "flex",
    flexDirection: "column",
    padding: tokens.spacingHorizontalS
  },
  // Sticky-footer Advanced Search button inside the picker dropdown.
  // Mirrors the LookupEdit footer + the in
  // ManyToManyLookupEdit.razor.
  advancedSearchFooter: {
    position: "sticky",
    bottom: 0,
    backgroundColor: tokens.colorNeutralBackground1,
    borderTop: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    display: "flex",
    justifyContent: "flex-end",
    padding: tokens.spacingHorizontalS
  },
  inlineSpinner: {
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM
  },
  emptyOption: {
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    color: tokens.colorNeutralForeground3,
    fontStyle: "italic"
  },
  // Multi-column option row — one vertical stack per row. The Fluent
  // option chrome (focus ring, hover state) wraps this so the rows still
  // behave like single options.
  optionStack: {
    display: "flex",
    flexDirection: "column",
    rowGap: "2px",
    width: "100%"
  },
  optionFirstLine: {
    fontWeight: tokens.fontWeightSemibold
  },
  optionSubLine: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground2
  },
  // Empty-value placeholder rendered when a column has no value for this
  // row. Muted styling so it doesn't compete with real values.
  nullValue: {
    color: tokens.colorNeutralForeground3,
    fontStyle: "italic"
  }
});
function ManyToManyLookupEdit({
  relationshipName,
  selfReferencingRole,
  editorType = ManyToManyLookupEditorType.TagPicker,
  label,
  description,
  descriptionLocation = DescriptionLocation.Tooltip,
  labelPosition,
  defaultViewId,
  viewIds,
  maxRecordsReturned = DEFAULT_MAX_RECORDS_RETURNED,
  popupMaxHeight = "320px",
  popupMinHeight,
  minimumNumberOfItems,
  maximumNumberOfItems,
  required,
  disabled = false,
  readOnly: readOnlyProp = false,
  displayLabelWhenAvailable = true,
  displayValidationErrorMessage = true,
  isVisible = true,
  className,
  style,
  id,
  filter,
  filterProvider
}) {
  const styles = useStyles31();
  const t = useT();
  const resolvedDescription = nonBlankDescription(description);
  const { ppp } = usePowerPortalsPro();
  const { record: parentRecord } = useRecordContext();
  const mainContext = useMainContext();
  const parentMetadataQuery = useTableMetadata(parentRecord?.tableName ?? "", {
    enabled: !!parentRecord?.tableName
  });
  const parentMetadata = parentMetadataQuery.data;
  const relatedTableName = useMemo(() => {
    if (!parentMetadata) return void 0;
    const mtm = parentMetadata.manyToMany?.find((x) => x.relationshipName === relationshipName);
    if (!mtm) return void 0;
    return parentMetadata.tableName === mtm.table1 ? mtm.table2 : mtm.table1;
  }, [parentMetadata, relationshipName]);
  const isNewParent = !!parentRecord && (!parentRecord.id || parentRecord.id === EMPTY_GUID);
  const parentTablePermissions = useTablePermissions(parentRecord?.tableName ?? "", { enabled: isNewParent });
  const relatedTablePermissions = useTablePermissions(relatedTableName ?? "");
  const linking = TableSecurityPermission.Append | TableSecurityPermission.AppendTo;
  const recordNeeds = linking | (isNewParent ? TableSecurityPermission.Create : TableSecurityPermission.Write);
  const recordPermissions = isNewParent ? parentTablePermissions.data : parentRecord?.permissions;
  const linkingDenied = recordPermissions != null && (recordPermissions & recordNeeds) !== recordNeeds || relatedTablePermissions.data !== void 0 && (relatedTablePermissions.data & linking) !== linking;
  const readOnly = readOnlyProp || linkingDenied;
  const relatedMetadataQuery = useTableMetadata(relatedTableName ?? "", {
    enabled: !!relatedTableName
  });
  const relatedPrimaryName = relatedMetadataQuery.data?.primaryNameColumn;
  const viewsForTable = useViewsForTable(relatedTableName ?? "", {
    enabled: !!relatedTableName
  });
  const resolvedViews = useMemo(() => {
    if (!viewsForTable.data) return [];
    const allowList = viewIds && viewIds.length > 0 ? new Set(viewIds) : null;
    return viewsForTable.data.filter((v) => v.type === VIEW_TYPE_PUBLIC2 && v.fetchXml && v.fetchXml.length > 0).filter((v) => allowList ? allowList.has(v.id) : true).slice().sort((a, b) => a.name.localeCompare(b.name));
  }, [viewsForTable.data, viewIds]);
  const [selectedViewId, setSelectedViewId] = useState(void 0);
  const lastSeededViewListRef = useRef(void 0);
  useEffect(() => {
    if (resolvedViews.length === 0) return;
    if (lastSeededViewListRef.current === resolvedViews) return;
    lastSeededViewListRef.current = resolvedViews;
    const defaultMatch = defaultViewId ? resolvedViews.find((v) => v.id === defaultViewId) : void 0;
    const tableDefault = resolvedViews.find((v) => v.isDefault);
    const chosen = defaultMatch ?? tableDefault ?? resolvedViews[0];
    if (chosen) setSelectedViewId(chosen.id);
  }, [resolvedViews, defaultViewId]);
  const [initialSelection, setInitialSelection] = useState([]);
  const [pendingAdds, setPendingAdds] = useState([]);
  const [pendingRemoveIds, setPendingRemoveIds] = useState([]);
  const currentSelection = useMemo(() => {
    const removed = new Set(pendingRemoveIds);
    const kept = initialSelection.filter((r) => !removed.has(r.id));
    return [...kept, ...pendingAdds];
  }, [initialSelection, pendingAdds, pendingRemoveIds]);
  const selectedIds = useMemo(
    () => new Set(currentSelection.map((r) => r.id)),
    [currentSelection]
  );
  const parentRefId = getRecordReferenceId(parentRecord);
  const canQuery = !!parentRecord && !!parentRefId && !!relatedTableName && !!relatedPrimaryName && !!selectedViewId;
  const initialLoadRequest = useMemo(() => {
    if (!canQuery || !parentRecord) {
      return { fetchXml: '<fetch><entity name="placeholder"/></fetch>' };
    }
    return {
      viewId: selectedViewId,
      filters: [
        buildFilter(
          parentRecord,
          relationshipName,
          RelationshipFilterMode.IncludeExistingRecords,
          selfReferencingRole
        )
      ],
      pageSize: 500
      // initial-selection load — return up to 500 records associated to this parent.
    };
  }, [canQuery, parentRecord, selectedViewId, relationshipName, selfReferencingRole]);
  const initialLoad = useQueryData(initialLoadRequest, { enabled: canQuery });
  const resolvedColumns = useMemo(() => {
    return initialLoad.data?.columns ?? [];
  }, [initialLoad.data?.columns]);
  const primaryNameColumn = useMemo(() => {
    const flagged = resolvedColumns.find((c) => c.isPrimaryName);
    if (flagged) return flagged.columnName;
    return relatedPrimaryName;
  }, [resolvedColumns, relatedPrimaryName]);
  const lastSeededRecordIdRef = useRef(void 0);
  const initialLoadRef = useRef(initialLoad);
  initialLoadRef.current = initialLoad;
  const supersededLoadRef = useRef(void 0);
  useEffect(() => {
    if (initialLoad.status !== QueryStatus.Success || !initialLoad.data) return;
    if (!primaryNameColumn || !parentRecord) return;
    if (initialLoad.data === supersededLoadRef.current) return;
    if (lastSeededRecordIdRef.current === parentRefId) return;
    lastSeededRecordIdRef.current = parentRefId;
    const seeded = initialLoad.data.tableRecords.map((r) => ({
      id: r.id,
      displayName: resolveDisplayName(r, primaryNameColumn) ?? "",
      source: r
    }));
    setInitialSelection(seeded);
    setPendingAdds([]);
    setPendingRemoveIds([]);
  }, [initialLoad.status, initialLoad.data, parentRecord, primaryNameColumn, parentRefId]);
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedQuery(query), SEARCH_DEBOUNCE_MS4);
    return () => clearTimeout(timer);
  }, [query]);
  const removingLinks = pendingRemoveIds.length > 0;
  const pageFiltersNow = relatedTableName ? lookupFiltersFor(filter, filterProvider, parentRecord, relatedTableName) : [];
  const pageFiltersKey = lookupFiltersKey(pageFiltersNow);
  const pageFilters = useMemo(() => pageFiltersNow, [pageFiltersKey]);
  const searchFilters = useMemo(
    () => [
      ...removingLinks || !parentRecord ? [] : [
        buildFilter(
          parentRecord,
          relationshipName,
          RelationshipFilterMode.ExcludeExistingRecords,
          selfReferencingRole
        )
      ],
      ...pageFilters
    ],
    // The record's table and reference id are all `buildFilter` reads of it:
    // the record itself is new with every edit.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [removingLinks, parentRecord?.tableName, parentRefId, relationshipName, selfReferencingRole, pageFilters]
  );
  useEffect(() => {
    if (!canQuery || !selectedViewId || !relatedTableName) return;
    const controller = new AbortController();
    setSearchLoading(true);
    const trimmed = debouncedQuery.trim();
    const request = {
      tableName: relatedTableName,
      viewId: selectedViewId,
      ...trimmed.length > 0 && { searchText: trimmed },
      ...searchFilters.length > 0 && { filters: searchFilters },
      maxRecords: maxRecordsReturned
    };
    ppp.searchLookupAsync(request, controller.signal).then((resp) => {
      if (controller.signal.aborted) return;
      const nameColumn = resp.columns.find((c) => c.isPrimaryName)?.columnName ?? primaryNameColumn ?? "";
      setSearchResults(
        resp.tableRecords.map((r) => ({
          id: r.id,
          displayName: resolveDisplayName(r, nameColumn) ?? "",
          source: r
        }))
      );
    }).catch((err) => {
      if (controller.signal.aborted) return;
      console.warn("[ManyToManyLookupEdit] autocomplete fetch failed", err);
    }).finally(() => {
      if (!controller.signal.aborted) setSearchLoading(false);
    });
    return () => controller.abort();
  }, [
    canQuery,
    selectedViewId,
    relatedTableName,
    searchFilters,
    debouncedQuery,
    maxRecordsReturned,
    primaryNameColumn,
    ppp
  ]);
  const addRecord = useCallback(
    (rec) => {
      if (readOnly || selectedIds.has(rec.id)) return;
      const wasInitial = initialSelection.some((r) => r.id === rec.id);
      if (wasInitial) {
        setPendingRemoveIds((prev) => prev.filter((id2) => id2 !== rec.id));
      } else {
        setPendingAdds((prev) => [...prev, rec]);
      }
    },
    [initialSelection, selectedIds, readOnly]
  );
  const removeRecord = useCallback(
    (recordId) => {
      if (readOnly) return;
      const isPendingAdd = pendingAdds.some((r) => r.id === recordId);
      if (isPendingAdd) {
        setPendingAdds((prev) => prev.filter((r) => r.id !== recordId));
        return;
      }
      setPendingRemoveIds((prev) => prev.includes(recordId) ? prev : [...prev, recordId]);
    },
    [pendingAdds, readOnly]
  );
  const selectionCount = currentSelection.length;
  const minError = !readOnly && minimumNumberOfItems !== void 0 && selectionCount < minimumNumberOfItems ? t("app.errors.value-min-count", [minimumNumberOfItems]) : null;
  const maxError = !readOnly && maximumNumberOfItems !== void 0 && selectionCount > maximumNumberOfItems ? t("app.errors.value-max-count", [maximumNumberOfItems]) : null;
  const validationError = minError ?? maxError;
  useEffect(() => {
    if (!linkingDenied) return;
    setPendingAdds((prev) => prev.length === 0 ? prev : []);
    setPendingRemoveIds((prev) => prev.length === 0 ? prev : []);
  }, [linkingDenied]);
  const isDirty = pendingAdds.length > 0 || pendingRemoveIds.length > 0;
  const pendingAddsRef = useRef(pendingAdds);
  pendingAddsRef.current = pendingAdds;
  const pendingRemoveIdsRef = useRef(pendingRemoveIds);
  pendingRemoveIdsRef.current = pendingRemoveIds;
  const initialSelectionRef = useRef(initialSelection);
  initialSelectionRef.current = initialSelection;
  const validationRef = useRef(validationError);
  validationRef.current = validationError;
  const isDirtyRef = useRef(isDirty);
  isDirtyRef.current = isDirty;
  useEffect(() => {
    if (!mainContext || !parentRecord) return;
    return mainContext.registerDescendant({
      // Ref-backed getter so dirty transitions don't tear the
      // registration down + re-create it (which would cascade context
      // re-renders and disrupt focus in any open inline editors). The
      // notify effect below pokes the parent on actual transitions.
      isDirty: () => isDirtyRef.current,
      getRequests: () => buildRequests(
        parentRecord,
        relationshipName,
        relatedTableName,
        pendingAddsRef.current,
        pendingRemoveIdsRef.current,
        initialSelectionRef.current,
        selfReferencingRole
      ),
      validate: () => validationRef.current === null,
      // The save went through, so the pending edits are what's linked now:
      // they stay shown while the refresh below loads the links again, and
      // if that load fails.
      afterSave: async () => {
        const removed = new Set(pendingRemoveIdsRef.current);
        setInitialSelection([
          ...initialSelectionRef.current.filter((r) => !removed.has(r.id)),
          ...pendingAddsRef.current
        ]);
        setPendingAdds([]);
        setPendingRemoveIds([]);
      },
      refresh: async () => {
        setPendingAdds([]);
        setPendingRemoveIds([]);
        lastSeededRecordIdRef.current = void 0;
        if (!initialLoadRef.current.data) return;
        supersededLoadRef.current = initialLoadRef.current.data;
        initialLoadRef.current.refetch().catch(() => {
        });
      },
      // Cancel/Discard: just drop the pending adds/removes; the
      // seed-guard refs stay so the initial selection (already loaded
      // from the server) is what the editor renders after reset.
      resetState: () => {
        setPendingAdds([]);
        setPendingRemoveIds([]);
      }
    });
  }, [mainContext?.registerDescendant, parentRecord, relationshipName, relatedTableName]);
  const mainContextRef = useRef(mainContext);
  mainContextRef.current = mainContext;
  useEffect(() => {
    mainContextRef.current?.notifyDescendantDirtyChanged();
  }, [isDirty]);
  const [dialogHidden, setDialogHidden] = useState(true);
  const openAdvancedSearch = () => setDialogHidden(false);
  const onDialogActionClicked = useCallback(
    (records) => {
      if (!primaryNameColumn) return;
      for (const r of records) {
        if (!r.id) continue;
        addRecord({
          id: r.id,
          displayName: resolveDisplayName(r, primaryNameColumn) ?? "",
          source: r
        });
      }
    },
    [addRecord, primaryNameColumn]
  );
  const advancedSearchAllowList = useMemo(() => {
    if (!relatedTableName) return void 0;
    if (!viewIds || viewIds.length === 0) return void 0;
    return { [relatedTableName]: viewIds };
  }, [relatedTableName, viewIds]);
  const showLabel = displayLabelWhenAvailable && !!label;
  const layoutClassName = useEditorLabelLayoutClass(labelPosition, showLabel);
  const stateClassName = useEditorStateClass(readOnly, disabled);
  if (!isVisible) return null;
  if (!parentRecord) return null;
  const readOnlyView = readOnly && !disabled;
  const resolvedRequired = required ?? (minimumNumberOfItems !== void 0 && minimumNumberOfItems > 0);
  const suggestions = searchResults.filter((r) => !selectedIds.has(r.id));
  const renderInput = {
    id,
    disabled,
    currentSelection,
    suggestions,
    searchLoading,
    query,
    onQueryChange: setQuery,
    onPick: addRecord,
    onUnpick: removeRecord,
    onAdvancedSearchClicked: openAdvancedSearch,
    resolvedColumns,
    resolvedViews,
    selectedViewId,
    onViewChange: setSelectedViewId,
    popupMaxHeight,
    popupMinHeight,
    styles,
    t
  };
  const editorTypeRendered = readOnlyView ? /* @__PURE__ */ jsx(ReadOnlyValue, { ...id !== void 0 && { id }, "aria-label": label, children: currentSelection.map((r) => r.displayName).join("; ") }) : editorType === ManyToManyLookupEditorType.Combobox ? renderCombobox(renderInput) : renderTagPicker(renderInput);
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-many-to-many-lookup-edit", className), style, children: [
    /* @__PURE__ */ jsx(
      Field,
      {
        className: mergeClasses(layoutClassName, stateClassName),
        ...showLabel && { label: { children: label, className: editorLabelClassName } },
        ...descriptionLocation === DescriptionLocation.BelowControl && resolvedDescription !== void 0 && {
          hint: resolvedDescription
        },
        ...resolvedRequired && { required: true },
        ...validationError && {
          validationState: "error",
          ...displayValidationErrorMessage && { validationMessage: validationError }
        },
        children: /* @__PURE__ */ jsxs("div", { className: styles.wrapper, children: [
          resolvedDescription !== void 0 && descriptionLocation === DescriptionLocation.Tooltip && /* @__PURE__ */ jsx("div", { className: styles.labelRow, children: /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription }) }),
          editorTypeRendered
        ] })
      }
    ),
    relatedTableName && !dialogHidden && /* @__PURE__ */ jsx(
      LookupDialog,
      {
        hidden: false,
        onHiddenChange: setDialogHidden,
        title: label ?? relatedTableName,
        tableNames: [relatedTableName],
        ...advancedSearchAllowList !== void 0 && { viewIds: advancedSearchAllowList },
        ...query.trim() && { initialSearchText: query.trim() },
        ...searchFilters.length > 0 && { filters: searchFilters },
        selectionMode: "multiple",
        actionLabel: t("app.buttons.link.label"),
        onActionClicked: onDialogActionClicked
      }
    )
  ] });
}
function renderOptionContent({
  record,
  resolvedColumns,
  fallbackText,
  query,
  styles
}) {
  if (resolvedColumns.length === 0) {
    return /* @__PURE__ */ jsx(Highlighter, { text: fallbackText, searchText: query });
  }
  return /* @__PURE__ */ jsx("div", { className: styles.optionStack, children: resolvedColumns.map((col, idx) => {
    const value2 = resolveColumnDisplayValue(record, col.columnName);
    const isFirst = idx === 0;
    if (!value2 || value2.trim().length === 0) {
      return /* @__PURE__ */ jsx(
        "span",
        {
          className: `${isFirst ? styles.optionFirstLine : styles.optionSubLine} ${styles.nullValue}`,
          children: "[NULL]"
        },
        col.columnName
      );
    }
    return /* @__PURE__ */ jsx(
      Highlighter,
      {
        text: value2,
        searchText: query,
        className: isFirst ? styles.optionFirstLine : styles.optionSubLine
      },
      col.columnName
    );
  }) });
}
function renderViewPicker(input) {
  const { resolvedViews, selectedViewId, onViewChange, styles, t } = input;
  if (resolvedViews.length <= 1) return null;
  const selectedView = resolvedViews.find((v) => v.id === selectedViewId);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: styles.viewPickerHeader,
      onMouseDown: (e) => e.preventDefault(),
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          size: "small",
          inlinePopup: true,
          positioning: { strategy: "fixed" },
          "aria-label": t("app.components.view-selector.view-name"),
          selectedOptions: selectedViewId ? [selectedViewId] : [],
          value: selectedView?.name ?? "",
          onOptionSelect: (event, data) => {
            event.stopPropagation();
            if (data.optionValue) onViewChange(data.optionValue);
          },
          onOpenChange: (event) => {
            event.stopPropagation();
          },
          children: resolvedViews.map((v) => /* @__PURE__ */ jsx(Option, { value: v.id, text: v.name, children: v.name }, v.id))
        }
      )
    }
  );
}
function renderTagPicker(input) {
  const {
    id,
    disabled,
    currentSelection,
    suggestions,
    searchLoading,
    query,
    onQueryChange,
    onPick,
    onUnpick,
    onAdvancedSearchClicked,
    resolvedColumns,
    resolvedViews,
    popupMaxHeight,
    popupMinHeight,
    styles,
    t
  } = input;
  const selectedIds = currentSelection.map((r) => r.id);
  const viewIdSet = new Set(resolvedViews.map((v) => v.id));
  return /* @__PURE__ */ jsxs(
    TagPicker,
    {
      disabled,
      selectedOptions: selectedIds,
      positioning: {
        position: "below",
        align: "start",
        useTransform: resolvedViews.length <= 1
      },
      onOptionSelect: (_, data) => {
        const next = new Set(
          data.selectedOptions.filter((id2) => !viewIdSet.has(id2))
        );
        const previous = new Set(selectedIds);
        for (const newId of next) {
          if (previous.has(newId)) continue;
          const found = suggestions.find((r) => r.id === newId);
          if (found) onPick(found);
        }
        for (const oldId of previous) {
          if (!next.has(oldId)) onUnpick(oldId);
        }
        onQueryChange("");
      },
      children: [
        /* @__PURE__ */ jsxs(TagPickerControl, { className: styles.control, children: [
          /* @__PURE__ */ jsx(TagPickerGroup, { children: currentSelection.map((r) => /* @__PURE__ */ jsx(
            Tag,
            {
              value: r.id,
              shape: "rounded",
              dismissible: true,
              dismissIcon: { "aria-label": t("app.buttons.remove.label") },
              children: r.displayName
            },
            r.id
          )) }),
          /* @__PURE__ */ jsx(
            TagPickerInput,
            {
              id,
              "aria-label": t("app.components.lookup-edit.search-placeholder"),
              value: query,
              onChange: (e) => onQueryChange(e.target.value)
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(
          TagPickerList,
          {
            className: styles.dropdownList,
            style: {
              maxHeight: popupMaxHeight,
              ...popupMinHeight !== void 0 && { minHeight: popupMinHeight }
            },
            children: [
              renderViewPicker(input),
              searchLoading && /* @__PURE__ */ jsx("div", { className: styles.inlineSpinner, children: /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) }),
              !searchLoading && suggestions.length === 0 && /* @__PURE__ */ jsx("div", { className: styles.emptyOption, children: t("app.components.lookup-edit.no-matches") }),
              suggestions.map((r) => (
                // `text` is what Fluent uses for accessibility (announced by
                // screen readers, falls back to the input when the option is
                // matched against typed text); pass the primary-name line so
                // the announcement matches the visual primary line.
                /* @__PURE__ */ jsx(TagPickerOption, { value: r.id, text: r.displayName, children: renderOptionContent({
                  record: r.source,
                  resolvedColumns,
                  fallbackText: r.displayName,
                  query,
                  styles
                }) }, r.id)
              )),
              /* @__PURE__ */ jsx("div", { className: styles.advancedSearchFooter, onMouseDown: (e) => e.preventDefault(), children: /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(Search20Regular, {}),
                  onClick: onAdvancedSearchClicked,
                  children: t("app.buttons.advanced-search.label")
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}
function renderCombobox(input) {
  const {
    id,
    disabled,
    currentSelection,
    suggestions,
    searchLoading,
    query,
    onQueryChange,
    onPick,
    onUnpick,
    onAdvancedSearchClicked,
    resolvedColumns,
    resolvedViews,
    popupMaxHeight,
    popupMinHeight,
    styles,
    t
  } = input;
  const selectedIds = currentSelection.map((r) => r.id);
  const viewIdSet = new Set(resolvedViews.map((v) => v.id));
  return /* @__PURE__ */ jsxs(
    Combobox,
    {
      id,
      multiselect: true,
      disabled: disabled || void 0,
      value: query,
      selectedOptions: selectedIds,
      positioning: {
        position: "below",
        align: "start",
        useTransform: resolvedViews.length <= 1
      },
      listbox: {
        className: styles.dropdownList,
        style: {
          maxHeight: popupMaxHeight,
          ...popupMinHeight !== void 0 && { minHeight: popupMinHeight }
        }
      },
      onChange: (e) => onQueryChange(e.target.value),
      onOptionSelect: (_, data) => {
        const previous = new Set(selectedIds);
        const next = new Set(
          data.selectedOptions.filter((id2) => !viewIdSet.has(id2))
        );
        for (const newId of next) {
          if (previous.has(newId)) continue;
          const found = suggestions.find((r) => r.id === newId);
          if (found) onPick(found);
        }
        for (const oldId of previous) {
          if (!next.has(oldId)) onUnpick(oldId);
        }
        onQueryChange("");
      },
      className: styles.control,
      children: [
        renderViewPicker(input),
        currentSelection.map((r) => /* @__PURE__ */ jsx(Option, { value: r.id, text: r.displayName, children: r.displayName }, r.id)),
        searchLoading && /* @__PURE__ */ jsx("div", { className: styles.inlineSpinner, children: /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) }),
        !searchLoading && suggestions.length === 0 && /* @__PURE__ */ jsx("div", { className: styles.emptyOption, children: t("app.components.lookup-edit.no-matches") }),
        suggestions.map((r) => /* @__PURE__ */ jsx(Option, { value: r.id, text: r.displayName, children: renderOptionContent({
          record: r.source,
          resolvedColumns,
          fallbackText: r.displayName,
          query,
          styles
        }) }, r.id)),
        /* @__PURE__ */ jsx("div", { className: styles.advancedSearchFooter, onMouseDown: (e) => e.preventDefault(), children: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(Search20Regular, {}),
            onClick: onAdvancedSearchClicked,
            children: t("app.buttons.advanced-search.label")
          }
        ) })
      ]
    }
  );
}
async function runPrimaryAsync(handler, close) {
  const result = handler ? await handler() : void 0;
  if (result === KEEP_OPEN) return false;
  close(result);
  return true;
}
var nextCustomDialogId = 0;
var useStyles32 = makeStyles({
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS
  },
  iconSuccess: { color: tokens.colorStatusSuccessForeground1 },
  iconWarning: { color: tokens.colorStatusWarningForeground1 },
  iconError: { color: tokens.colorStatusDangerForeground1 },
  iconInfo: { color: tokens.colorBrandForeground1 },
  iconConfirmation: { color: tokens.colorBrandForeground1 }
});
var DEFAULT_TITLE_KEYS = {
  success: "app.components.dialog.success-title",
  warning: "app.components.dialog.warning-title",
  error: "app.components.dialog.error-title",
  info: "app.components.dialog.information-title",
  confirmation: "app.components.dialog.confirmation-title"
};
function FluentDialogProvider({ children }) {
  const styles = useStyles32();
  const t = useT();
  const [queue, setQueue] = useState([]);
  const current = queue[0];
  const [customDialogs, setCustomDialogs] = useState([]);
  const primaryRef = useRef(null);
  useEffect(() => {
    if (current) primaryRef.current?.focus();
  }, [current]);
  const dialogService = useMemo(() => {
    function enqueue(variant, message, options) {
      return new Promise((resolve) => {
        setQueue((prev) => [
          ...prev,
          {
            variant,
            message,
            ...options?.title !== void 0 && { title: options.title },
            ...options?.primaryText !== void 0 && { primaryText: options.primaryText },
            ...options?.secondaryText !== void 0 && {
              secondaryText: options.secondaryText
            },
            resolve
          }
        ]);
      });
    }
    return {
      showSuccessAsync: (m, o) => enqueue("success", m, o),
      showWarningAsync: (m, o) => enqueue("warning", m, o),
      showErrorAsync: (m, o) => enqueue("error", m, o),
      showInfoAsync: (m, o) => enqueue("info", m, o),
      showConfirmationAsync: (m, o) => enqueue("confirmation", m, o),
      showDialogAsync: (render, options) => new Promise((resolve) => {
        const request = {
          id: nextCustomDialogId++,
          render,
          options: options ?? {},
          resolve
        };
        setCustomDialogs((prev) => [...prev, request]);
      })
    };
  }, []);
  const closeCustomDialog = useCallback((request, result) => {
    request.resolve(result);
    setCustomDialogs((prev) => prev.filter((r) => r.id !== request.id));
  }, []);
  const dismiss = useCallback(
    (canceled) => {
      if (!current) return;
      current.resolve({ canceled });
      setQueue((prev) => prev.slice(1));
    },
    [current]
  );
  return /* @__PURE__ */ jsxs(DialogServiceProvider, { value: dialogService, children: [
    /* @__PURE__ */ jsx(DialogOpenProvider, { open: current !== void 0 || customDialogs.length > 0, children }),
    customDialogs.map((request) => /* @__PURE__ */ jsx(
      CustomDialogView,
      {
        request,
        onClose: closeCustomDialog,
        dialogService
      },
      request.id
    )),
    current && /* @__PURE__ */ jsx(
      Dialog,
      {
        open: true,
        onOpenChange: (_, data) => {
          if (!data.open) {
            dismiss(current.variant === "confirmation");
          }
        },
        modalType: "modal",
        children: /* @__PURE__ */ jsx(DialogSurface, { children: /* @__PURE__ */ jsxs(DialogBody, { children: [
          /* @__PURE__ */ jsx(DialogTitle, { children: /* @__PURE__ */ jsxs("div", { className: styles.titleRow, children: [
            /* @__PURE__ */ jsx(VariantIcon, { variant: current.variant, styles }),
            /* @__PURE__ */ jsx("span", { children: current.title ?? t(DEFAULT_TITLE_KEYS[current.variant]) })
          ] }) }),
          /* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsx("div", { dangerouslySetInnerHTML: { __html: current.message } }) }),
          /* @__PURE__ */ jsxs(DialogActions, { children: [
            current.variant === "confirmation" && /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: () => dismiss(true), children: current.secondaryText ?? t("app.buttons.no.label") }),
            /* @__PURE__ */ jsx(
              Button,
              {
                ref: (element) => {
                  primaryRef.current = element;
                },
                appearance: "primary",
                onClick: () => dismiss(false),
                children: current.primaryText ?? t(current.variant === "confirmation" ? "app.buttons.yes.label" : "app.buttons.ok.label")
              }
            )
          ] })
        ] }) })
      }
    )
  ] });
}
var CustomDialogContent = memo(function CustomDialogContent2({
  render,
  handle
}) {
  return /* @__PURE__ */ jsx(Fragment, { children: render(handle) });
});
var useCustomDialogStyles = makeStyles({
  // Only with a width of its own: without one, Fluent's own 600px limit applies.
  sized: { maxWidth: "100vw" }
});
function CustomDialogView({
  request,
  onClose,
  dialogService
}) {
  const styles = useCustomDialogStyles();
  const t = useT();
  const { options } = request;
  const [primaryEnabled, setPrimaryEnabled] = useState(true);
  const primaryEnabledRef = useRef(true);
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);
  const closedRef = useRef(false);
  const onPrimaryRef = useRef(null);
  const handle = useMemo(
    () => ({
      close: (data) => {
        closedRef.current = true;
        onClose(request, data === void 0 ? { canceled: false } : { canceled: false, data });
      },
      cancel: () => {
        closedRef.current = true;
        onClose(request, { canceled: true });
      },
      // Safe to call while the content renders, as onPrimary is: the state update is deferred, so it
      // never updates this component during the content's render, and a repeated value is a no-op.
      setPrimaryEnabled: (enabled) => {
        if (primaryEnabledRef.current === enabled) return;
        primaryEnabledRef.current = enabled;
        queueMicrotask(() => setPrimaryEnabled(enabled));
      },
      onPrimary: (handler) => {
        onPrimaryRef.current = handler;
      }
    }),
    [onClose, request]
  );
  const runPrimary = async () => {
    if (busyRef.current || !primaryEnabledRef.current) return;
    busyRef.current = true;
    setBusy(true);
    try {
      await runPrimaryAsync(onPrimaryRef.current, (data) => {
        if (!closedRef.current) handle.close(data);
      });
    } catch (error) {
      console.error("A custom dialog's primary action failed.", error);
      if (!closedRef.current) void dialogService.showErrorAsync(t("app.components.dialog.action-failed"));
    } finally {
      busyRef.current = false;
      if (!closedRef.current) setBusy(false);
    }
  };
  const cancelFromButton = () => {
    if (!busyRef.current) handle.cancel();
  };
  const showTitle = options.title !== void 0 || options.showDismiss !== false;
  const showActions = options.primaryText !== void 0 || options.secondaryText !== void 0;
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      open: true,
      modalType: "modal",
      onOpenChange: (_, data) => {
        if (data.open || busyRef.current) return;
        if (data.type === "escapeKeyDown" && options.preventDismissOnEscape) return;
        if (data.type === "backdropClick") return;
        handle.cancel();
      },
      children: /* @__PURE__ */ jsx(
        DialogSurface,
        {
          className: mergeClasses("ppp-custom-dialog", options.width ? styles.sized : void 0),
          style: options.width ? { width: options.width } : void 0,
          children: /* @__PURE__ */ jsxs(DialogBody, { children: [
            showTitle && /* @__PURE__ */ jsx(
              DialogTitle,
              {
                action: options.showDismiss === false ? null : /* @__PURE__ */ jsx(
                  Button,
                  {
                    appearance: "subtle",
                    "aria-label": t("app.buttons.close.label"),
                    icon: /* @__PURE__ */ jsx(Dismiss24Regular, {}),
                    disabled: busy,
                    onClick: cancelFromButton
                  }
                ),
                children: options.title
              }
            ),
            /* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsx(DialogHandleProvider, { handle, children: /* @__PURE__ */ jsx(CustomDialogContent, { render: request.render, handle }) }) }),
            showActions && /* @__PURE__ */ jsxs(DialogActions, { children: [
              options.secondaryText !== void 0 && /* @__PURE__ */ jsx(Button, { appearance: "secondary", disabled: busy, onClick: cancelFromButton, children: options.secondaryText }),
              options.primaryText !== void 0 && /* @__PURE__ */ jsx(Button, { appearance: "primary", disabled: busy || !primaryEnabled, onClick: () => void runPrimary(), children: options.primaryText })
            ] })
          ] })
        }
      )
    }
  );
}
function VariantIcon({
  variant,
  styles
}) {
  switch (variant) {
    case "success":
      return /* @__PURE__ */ jsx(CheckmarkCircle24Regular, { className: styles.iconSuccess });
    case "warning":
      return /* @__PURE__ */ jsx(Warning24Regular, { className: styles.iconWarning });
    case "error":
      return /* @__PURE__ */ jsx(DismissCircle24Regular, { className: styles.iconError });
    case "info":
      return /* @__PURE__ */ jsx(Info24Regular, { className: styles.iconInfo });
    case "confirmation":
      return /* @__PURE__ */ jsx(QuestionCircle24Regular, { className: styles.iconConfirmation });
  }
}
var ThemeMode = {
  Light: "light",
  Dark: "dark",
  System: "system"
};
var TextDirection2 = {
  Ltr: "ltr",
  Rtl: "rtl"
};
var ThemeContext = createContext(null);
var ThemeContextProvider = ThemeContext.Provider;
function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error(
      "useTheme() was called outside <PowerPortalsProThemeProvider>. Wrap your app in the provider at the same level you mount <FluentProvider>."
    );
  }
  return ctx;
}
var OFFICE_ACCENT_DEFINITIONS = [
  { name: "default", hex: "#036ac4", officeColorIndex: 0, officeColorNames: ["Default"] },
  { name: "access", hex: "#a4373a", officeColorIndex: 1, officeColorNames: ["Access"] },
  { name: "booking", hex: "#00a99d", officeColorIndex: 2, officeColorNames: ["Booking"] },
  {
    name: "exchange",
    hex: "#0078d4",
    officeColorIndex: 3,
    officeColorNames: ["Exchange", "OneDrive", "SharePoint", "Skype", "Windows"]
  },
  { name: "excel", hex: "#217346", officeColorIndex: 4, officeColorNames: ["Excel"] },
  { name: "group-me", hex: "#00bcf2", officeColorIndex: 5, officeColorNames: ["GroupMe"] },
  { name: "office", hex: "#d83b01", officeColorIndex: 6, officeColorNames: ["Office"] },
  { name: "one-note", hex: "#7719aa", officeColorIndex: 8, officeColorNames: ["OneNote"] },
  { name: "outlook", hex: "#0f6cbd", officeColorIndex: 9, officeColorNames: ["Outlook"] },
  {
    name: "planner",
    hex: "#31752f",
    officeColorIndex: 10,
    officeColorNames: ["Planner", "Project"]
  },
  { name: "power-apps", hex: "#742774", officeColorIndex: 11, officeColorNames: ["PowerApps"] },
  { name: "power-bi", hex: "#f2c811", officeColorIndex: 12, officeColorNames: ["PowerBI"] },
  { name: "power-point", hex: "#b7472a", officeColorIndex: 13, officeColorNames: ["PowerPoint"] },
  { name: "publisher", hex: "#077568", officeColorIndex: 15, officeColorNames: ["Publisher"] },
  { name: "stream", hex: "#bc1948", officeColorIndex: 18, officeColorNames: ["Stream"] },
  { name: "sway", hex: "#008272", officeColorIndex: 19, officeColorNames: ["Sway"] },
  { name: "teams", hex: "#6264a7", officeColorIndex: 20, officeColorNames: ["Teams"] },
  { name: "visio", hex: "#3955a3", officeColorIndex: 21, officeColorNames: ["Visio"] },
  { name: "word", hex: "#2b579a", officeColorIndex: 23, officeColorNames: ["Word"] },
  { name: "yammer", hex: "#106ebe", officeColorIndex: 24, officeColorNames: ["Yammer"] }
];
var STOPS = [
  10,
  20,
  30,
  40,
  50,
  60,
  70,
  80,
  90,
  100,
  110,
  120,
  130,
  140,
  150,
  160
];
function lightnessForStop(stop, baseLightness) {
  if (stop === 80) return baseLightness;
  if (stop < 80) {
    const t2 = (stop - 10) / 70;
    return 8 + (baseLightness - 8) * t2;
  }
  const t = (stop - 80) / 80;
  return Math.min(97, baseLightness + (95 - baseLightness) * t);
}
function hexToHsl(hex) {
  const cleaned = hex.replace(/^#/, "");
  const r = parseInt(cleaned.slice(0, 2), 16) / 255;
  const g = parseInt(cleaned.slice(2, 4), 16) / 255;
  const b = parseInt(cleaned.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let s = 0;
  let h = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
        break;
      case g:
        h = ((b - r) / d + 2) / 6;
        break;
      case b:
        h = ((r - g) / d + 4) / 6;
        break;
    }
  }
  return [h * 360, s * 100, l * 100];
}
function hslToHex(h, s, l) {
  const hue = (h % 360 + 360) % 360;
  const sat = Math.max(0, Math.min(100, s)) / 100;
  const lum = Math.max(0, Math.min(100, l)) / 100;
  const c = (1 - Math.abs(2 * lum - 1)) * sat;
  const x = c * (1 - Math.abs(hue / 60 % 2 - 1));
  const m = lum - c / 2;
  let r = 0;
  let g = 0;
  let b = 0;
  if (hue < 60) {
    r = c;
    g = x;
  } else if (hue < 120) {
    r = x;
    g = c;
  } else if (hue < 180) {
    g = c;
    b = x;
  } else if (hue < 240) {
    g = x;
    b = c;
  } else if (hue < 300) {
    r = x;
    b = c;
  } else {
    r = c;
    b = x;
  }
  const toHex = (v) => Math.round((v + m) * 255).toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
function hexToBrandVariants(hex) {
  const [h, s, baseL] = hexToHsl(hex);
  const variants = {};
  for (const stop of STOPS) {
    variants[stop] = hslToHex(h, s, lightnessForStop(stop, baseL));
  }
  return variants;
}
function relativeLuminance(hex) {
  const clean2 = hex.replace(/^#/, "");
  const r = parseInt(clean2.slice(0, 2), 16) / 255;
  const g = parseInt(clean2.slice(2, 4), 16) / 255;
  const b = parseInt(clean2.slice(4, 6), 16) / 255;
  const toLinear = (c) => c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
}
function foregroundForBrandBg(brandHex) {
  return relativeLuminance(brandHex) > 0.4 ? "#000000" : "#ffffff";
}
var OFFICE_ACCENT_THEMES = (() => {
  const map = {};
  for (const { name, hex } of OFFICE_ACCENT_DEFINITIONS) {
    const variants = hexToBrandVariants(hex);
    const light = createLightTheme(variants);
    const dark = createDarkTheme(variants);
    light.colorNeutralForegroundOnBrand = foregroundForBrandBg(variants[80]);
    dark.colorNeutralForegroundOnBrand = foregroundForBrandBg(variants[70]);
    map[name] = { light, dark };
  }
  map.default = { light: webLightTheme, dark: webDarkTheme };
  map.teams = { light: teamsLightTheme, dark: teamsDarkTheme };
  return map;
})();
var OFFICE_COLOR_NAME_TO_ACCENT = (() => {
  const map = {};
  for (const def of OFFICE_ACCENT_DEFINITIONS) {
    for (const enumName of def.officeColorNames) {
      map[enumName] = def.name;
    }
  }
  return map;
})();
var OFFICE_ACCENT_HEX_TO_NAME = (() => {
  const map = {};
  for (const def of OFFICE_ACCENT_DEFINITIONS) {
    map[def.hex.toLowerCase()] = def.name;
  }
  return map;
})();
function normalizeHex(raw) {
  const lower = raw.trim().toLowerCase();
  if (/^#[0-9a-f]{6}$/.test(lower)) return lower;
  if (/^#[0-9a-f]{3}$/.test(lower)) {
    return `#${lower[1]}${lower[1]}${lower[2]}${lower[2]}${lower[3]}${lower[3]}`;
  }
  return null;
}
function officeColorValueToAccentName(raw) {
  if (!raw) return null;
  const hex = normalizeHex(raw);
  if (hex !== null) return OFFICE_ACCENT_HEX_TO_NAME[hex] ?? null;
  return OFFICE_COLOR_NAME_TO_ACCENT[raw.trim()] ?? null;
}
var BUILT_IN_ACCENTS = OFFICE_ACCENT_THEMES;
var useGlobalBodyStyles = makeStaticStyles({
  // Fluent's `webDarkTheme.colorNeutralBackground4` (#0a0a0a) — same
  // token the side nav rail uses, so the body and rail share one
  // continuous surface in dark mode.
  "body.ppp-theme-dark": {
    backgroundColor: "#0a0a0a",
    color: "#ffffff"
  },
  // Fluent's `webLightTheme.colorNeutralBackground2` (#fafafa) — a
  // hair off pure white, mirroring what most Fluent v9 demo apps
  // use as their page background in light mode.
  "body.ppp-theme-light": {
    backgroundColor: "#fafafa",
    color: "#242424"
  },
  // Native scrollbars (the grid's, the page's, a popup's) and form controls
  // draw light unless `color-scheme` says otherwise. It inherits, and the
  // page's own scrollbar reads it from `<html>`, so it goes on the root.
  "html:has(> body.ppp-theme-dark)": {
    colorScheme: "dark"
  }
});
var DEFAULT_MODE_STORAGE_KEY = "ppp-theme-mode";
var DEFAULT_ACCENT_STORAGE_KEY = "ppp-theme-accent";
var DEFAULT_DIRECTION_STORAGE_KEY = "ppp-theme-direction";
function readStoredMode(storageKey) {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (raw === ThemeMode.Light || raw === ThemeMode.Dark || raw === ThemeMode.System) {
      return raw;
    }
    return null;
  } catch {
    return null;
  }
}
function readStoredString(storageKey) {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(storageKey);
  } catch {
    return null;
  }
}
function readStoredDirection(storageKey) {
  const raw = readStoredString(storageKey);
  return raw === TextDirection2.Ltr || raw === TextDirection2.Rtl ? raw : null;
}
function writeStored(storageKey, value2) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(storageKey, value2);
  } catch {
  }
}
function getSystemPrefersDark() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}
function PowerPortalsProThemeProvider({
  children,
  defaultMode = ThemeMode.System,
  defaultAccentColor = "default",
  defaultTextDirection = TextDirection2.Ltr,
  lockAccentColor = false,
  customAccents,
  storageKey = DEFAULT_MODE_STORAGE_KEY,
  style,
  fluentProviderProps
}) {
  const accentStorageKey = storageKey === DEFAULT_MODE_STORAGE_KEY ? DEFAULT_ACCENT_STORAGE_KEY : `${storageKey}-accent`;
  const directionStorageKey = storageKey === DEFAULT_MODE_STORAGE_KEY ? DEFAULT_DIRECTION_STORAGE_KEY : `${storageKey}-direction`;
  const accentMap = useMemo(
    () => ({ ...BUILT_IN_ACCENTS, ...customAccents }),
    // Stringified keys = stable identity for the customAccents map
    // when its contents don't actually change (a consumer passing
    // a fresh inline object literal each render is common).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customAccents ? Object.keys(customAccents).join("|") : ""]
  );
  const availableAccents = useMemo(
    () => Object.keys(accentMap),
    [accentMap]
  );
  const [mode, setModeState] = useState(
    () => readStoredMode(storageKey) ?? defaultMode
  );
  const [accentColor, setAccentColorState] = useState(() => {
    const configured = defaultAccentColor in accentMap ? defaultAccentColor : "default";
    if (lockAccentColor) return configured;
    const stored = readStoredString(accentStorageKey);
    if (stored && stored in accentMap) return stored;
    return configured;
  });
  const [textDirection, setTextDirectionState] = useState(
    () => readStoredDirection(directionStorageKey) ?? defaultTextDirection
  );
  const [systemPrefersDark, setSystemPrefersDark] = useState(
    () => getSystemPrefersDark()
  );
  useEffect(() => {
    if (typeof window === "undefined") return void 0;
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (event) => setSystemPrefersDark(event.matches);
    if (media.addEventListener) {
      media.addEventListener("change", handler);
      return () => media.removeEventListener("change", handler);
    }
    media.addListener(handler);
    return () => media.removeListener(handler);
  }, []);
  const isDark = useMemo(() => {
    if (mode === ThemeMode.Dark) return true;
    if (mode === ThemeMode.Light) return false;
    return systemPrefersDark;
  }, [mode, systemPrefersDark]);
  useGlobalBodyStyles();
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.body.classList.toggle("ppp-theme-dark", isDark);
    document.body.classList.toggle("ppp-theme-light", !isDark);
  }, [isDark]);
  useEffect(() => {
    if (!lockAccentColor) return;
    const configured = defaultAccentColor in accentMap ? defaultAccentColor : "default";
    setAccentColorState(configured);
    writeStored(accentStorageKey, configured);
  }, [lockAccentColor, defaultAccentColor, accentMap, accentStorageKey]);
  const setMode = useCallback(
    (next) => {
      setModeState(next);
      writeStored(storageKey, next);
    },
    [storageKey]
  );
  const setAccentColor = useCallback(
    (next) => {
      if (lockAccentColor) return;
      if (!(next in accentMap)) return;
      setAccentColorState(next);
      writeStored(accentStorageKey, next);
    },
    [lockAccentColor, accentMap, accentStorageKey]
  );
  const setTextDirection = useCallback(
    (next) => {
      setTextDirectionState(next);
      writeStored(directionStorageKey, next);
    },
    [directionStorageKey]
  );
  const accentColors = useMemo(() => {
    const map = {};
    for (const [name, pair] of Object.entries(accentMap)) {
      map[name] = pair.light.colorBrandBackground;
    }
    return map;
  }, [accentMap]);
  const value2 = useMemo(
    () => ({
      mode,
      isDark,
      setMode,
      accentColor,
      setAccentColor,
      availableAccents,
      accentColors,
      accentColorLocked: lockAccentColor,
      textDirection,
      setTextDirection
    }),
    [
      mode,
      isDark,
      setMode,
      accentColor,
      setAccentColor,
      availableAccents,
      accentColors,
      lockAccentColor,
      textDirection,
      setTextDirection
    ]
  );
  const accentPair = accentMap[accentColor] ?? accentMap.default ?? BUILT_IN_ACCENTS.default;
  const resolvedTheme = isDark ? accentPair.dark : accentPair.light;
  return /* @__PURE__ */ jsx(ThemeContextProvider, { value: value2, children: /* @__PURE__ */ jsx(
    FluentProvider,
    {
      theme: resolvedTheme,
      dir: textDirection,
      ...style && { style },
      ...fluentProviderProps,
      children
    }
  ) });
}
var MODE_ORDER = [
  ThemeMode.Light,
  ThemeMode.Dark,
  ThemeMode.System
];
function ThemeSelector({ readOnly, label, width }) {
  const { mode, setMode } = useTheme();
  const t = useT();
  const labelId = useId();
  const optionLabel = useCallback(
    (m) => t(`app.components.theme-selector.mode.${m}`),
    [t]
  );
  const handleOptionSelect = (_event, data) => {
    const next = data.optionValue;
    if (next === ThemeMode.Light || next === ThemeMode.Dark || next === ThemeMode.System) {
      setMode(next);
    }
  };
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: "ppp-theme-selector",
      label: label ?? t("app.components.theme-selector.theme-label"),
      id: labelId,
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          "aria-labelledby": labelId,
          value: optionLabel(mode),
          selectedOptions: [mode],
          onOptionSelect: handleOptionSelect,
          disabled: readOnly,
          ...width && { style: { width } },
          children: MODE_ORDER.map((m) => /* @__PURE__ */ jsx(Option, { value: m, text: optionLabel(m), children: optionLabel(m) }, m))
        }
      )
    }
  );
}
var useStyles33 = makeStyles({
  // Color swatch rendered as the first child of each `<Option>`. Sized
  // to align with single-line text (14px ≈ text height at the dropdown's
  // default font size). The neutral-stroke border keeps a very light
  // accent (e.g. PowerBI yellow) visible against the dropdown panel's
  // white background.
  swatch: {
    display: "inline-block",
    width: "14px",
    height: "14px",
    borderRadius: tokens.borderRadiusSmall,
    marginRight: tokens.spacingHorizontalS,
    verticalAlign: "middle",
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    flexShrink: 0
  }
});
function ThemeColorSelector({
  readOnly,
  label,
  width,
  accentLabels
}) {
  const { accentColor, setAccentColor, availableAccents, accentColors, accentColorLocked } = useTheme();
  const t = useT();
  const labelId = useId();
  const styles = useStyles33();
  const optionLabel = useCallback(
    (accent) => {
      const override = accentLabels?.[accent];
      if (override !== void 0) return override;
      const key3 = `app.components.theme-color-selector.accent.${accent}`;
      const resolved = t(key3);
      return resolved === key3 ? accent : resolved;
    },
    [t, accentLabels]
  );
  if (accentColorLocked) return null;
  const handleOptionSelect = (_event, data) => {
    const next = data.optionValue;
    if (next && availableAccents.includes(next)) {
      setAccentColor(next);
    }
  };
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: "ppp-theme-color-selector",
      label: label ?? t("app.components.theme-color-selector.color-label"),
      id: labelId,
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          "aria-labelledby": labelId,
          value: optionLabel(accentColor),
          selectedOptions: [accentColor],
          onOptionSelect: handleOptionSelect,
          disabled: readOnly,
          ...width && { style: { width } },
          children: availableAccents.map((accent) => {
            const swatch = accentColors[accent];
            return /* @__PURE__ */ jsxs(Option, { value: accent, text: optionLabel(accent), children: [
              swatch && /* @__PURE__ */ jsx(
                "span",
                {
                  className: styles.swatch,
                  style: { backgroundColor: swatch },
                  "aria-hidden": "true"
                }
              ),
              optionLabel(accent)
            ] }, accent);
          })
        }
      )
    }
  );
}
var DIRECTION_ORDER = [
  TextDirection2.Ltr,
  TextDirection2.Rtl
];
function ThemeTextDirection({
  readOnly,
  label,
  width
}) {
  const { textDirection, setTextDirection } = useTheme();
  const t = useT();
  const labelId = useId();
  const optionLabel = useCallback(
    (dir) => t(`app.components.theme-text-direction.direction.${dir}`),
    [t]
  );
  const handleOptionSelect = (_event, data) => {
    const next = data.optionValue;
    if (next === TextDirection2.Ltr || next === TextDirection2.Rtl) {
      setTextDirection(next);
    }
  };
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: "ppp-theme-text-direction",
      label: label ?? t("app.components.theme-text-direction.direction-label"),
      id: labelId,
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          "aria-labelledby": labelId,
          value: optionLabel(textDirection),
          selectedOptions: [textDirection],
          onOptionSelect: handleOptionSelect,
          disabled: readOnly,
          ...width && { style: { width } },
          children: DIRECTION_ORDER.map((dir) => /* @__PURE__ */ jsx(Option, { value: dir, text: optionLabel(dir), children: optionLabel(dir) }, dir))
        }
      )
    }
  );
}
function resolveDisplayName2(locale, displayNative) {
  if (typeof Intl === "undefined" || typeof Intl.DisplayNames === "undefined") {
    return locale;
  }
  try {
    const native = new Intl.DisplayNames([locale], { type: "language" }).of(locale);
    if (!displayNative) {
      const english2 = new Intl.DisplayNames(["en"], { type: "language" }).of(locale);
      return english2 ?? locale;
    }
    const english = new Intl.DisplayNames(["en"], { type: "language" }).of(locale);
    if (!native) return english ?? locale;
    if (!english || english === native) return native;
    return `${native} (${english})`;
  } catch {
    return locale;
  }
}
function LanguageDropdown({
  supportedLocales,
  label,
  displayNativeLanguage = true,
  width,
  readOnly,
  persistToCookie = true
}) {
  const { locale, setLocale } = useLocale();
  const t = useT();
  const labelId = useId();
  const urlCultureStrategy = useUrlCultureStrategy();
  const defaultLocale = useDefaultLocale();
  const serverLocales = useSupportedLocales({ enabled: urlCultureStrategy !== void 0 });
  const discovered = useSupportedLocales({ enabled: supportedLocales === void 0 });
  const effectiveLocales = supportedLocales ?? (discovered.status === QueryStatus.Success ? discovered.data : null);
  const options = useMemo(() => {
    const list = effectiveLocales ? [...effectiveLocales] : [locale];
    if (!list.includes(locale)) list.push(locale);
    return list.map((value2) => ({
      value: value2,
      label: resolveDisplayName2(value2, displayNativeLanguage)
    })).sort((a, b) => a.label.localeCompare(b.label));
  }, [effectiveLocales, locale, displayNativeLanguage]);
  const handleOptionSelect = useCallback(
    (_event, data) => {
      const next = data.optionValue;
      if (!next || next === locale) return;
      if (persistToCookie) setAspNetCultureCookie(next);
      if (urlCultureStrategy && urlCultureStrategy !== "CookieOnly" && defaultLocale && serverLocales.data && typeof window !== "undefined") {
        const path = buildLocalePath({
          strategy: urlCultureStrategy,
          locale: next,
          defaultLocale,
          pathname: window.location.pathname,
          supportedLocales: serverLocales.data
        });
        window.location.assign(`${path}${window.location.search}${window.location.hash}`);
        return;
      }
      setLocale(next);
    },
    [locale, setLocale, persistToCookie, urlCultureStrategy, defaultLocale, serverLocales.data]
  );
  const currentLabel = options.find((o) => o.value === locale)?.label ?? resolveDisplayName2(locale, displayNativeLanguage);
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-language-dropdown"),
      label: label ?? t("app.language-label"),
      id: labelId,
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          "aria-labelledby": labelId,
          value: currentLabel,
          selectedOptions: [locale],
          onOptionSelect: handleOptionSelect,
          disabled: readOnly || options.length <= 1,
          ...width && { style: { width } },
          children: options.map((option) => /* @__PURE__ */ jsx(Option, { value: option.value, text: option.label, children: option.label }, option.value))
        }
      )
    }
  );
}
var MINIMUM_QUERY_LENGTH = 3;
var MAXIMUM_RESULTS = 50;
var SEARCH_DEBOUNCE_MS5 = 300;
var GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
var useStyles34 = makeStyles({
  surface: {
    maxWidth: "480px",
    display: "flex",
    flexDirection: "column"
  },
  titleRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    columnGap: tokens.spacingHorizontalS
  },
  titleText: {
    flexGrow: 1,
    minWidth: 0
  },
  body: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
    paddingTop: tokens.spacingVerticalM
  },
  results: {
    display: "flex",
    flexDirection: "column",
    // Fixed height, not min/max: a list that resizes on every keystroke makes the confirm button
    // jump around under the pointer while the administrator is still reading.
    height: "280px",
    overflowY: "auto",
    // Full shorthand — griffel types `borderColor` and friends as `never`, so the longhand
    // properties aren't usable here.
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1
  },
  result: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    cursor: "pointer",
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    textAlign: "left",
    background: "none",
    // A native <button> does NOT inherit color or font from its container — the user-agent
    // stylesheet gives it `color: buttontext` and its own font stack. Without these three the
    // rows rendered as near-black text on the dark surface in dark mode, which is how this was
    // first spotted. Set explicitly rather than relying on inheritance.
    color: tokens.colorNeutralForeground1,
    fontFamily: "inherit",
    fontSize: tokens.fontSizeBase300,
    // The UA also gives buttons a border; `background: none` alone leaves it drawing a box
    // around every row. Only three sides — borderBottom above is the row separator.
    borderTop: "none",
    borderRight: "none",
    borderLeft: "none",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
      color: tokens.colorNeutralForeground1Hover
    },
    ":focus-visible": {
      outline: `2px solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "-2px"
    }
  },
  resultSelected: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    ":hover": {
      backgroundColor: tokens.colorBrandBackgroundHover,
      // Repeated because the base row's :hover also sets color, and whichever griffel emits
      // last would otherwise win — leaving selected-and-hovered text unreadable on the brand fill.
      color: tokens.colorNeutralForegroundOnBrand
    }
  },
  resultText: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0
  },
  name: {
    fontSize: tokens.fontSizeBase300,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  email: {
    fontSize: tokens.fontSizeBase200,
    opacity: 0.8,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  status: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    padding: tokens.spacingVerticalXL,
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200
  },
  warning: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    columnGap: tokens.spacingHorizontalS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2,
    borderLeft: `3px solid ${tokens.colorPaletteRedBackground3}`,
    fontSize: tokens.fontSizeBase200
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    columnGap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalM
  }
});
function ImpersonationPickerDialog({
  open,
  onClose,
  returnUrl = "/",
  className
}) {
  const auth = useAuth();
  const styles = useStyles34();
  const t = useT();
  const { searchImpersonationTargets, impersonate } = auth;
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [selected, setSelected] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [isStarting, setIsStarting] = useState(false);
  const requestIdRef = useRef(0);
  useEffect(() => {
    if (open) return;
    setQuery("");
    setResults([]);
    setSelected(null);
    setIsSearching(false);
    setHasSearched(false);
    setHasMore(false);
    setIsStarting(false);
  }, [open]);
  const trimmed = query.trim();
  const isTooShort = trimmed.length > 0 && trimmed.length < MINIMUM_QUERY_LENGTH;
  useEffect(() => {
    if (!open) return;
    const requestId = ++requestIdRef.current;
    if (trimmed.length < MINIMUM_QUERY_LENGTH && !GUID_PATTERN.test(trimmed)) {
      setResults([]);
      setHasSearched(false);
      setHasMore(false);
      setIsSearching(false);
      return;
    }
    let canceled = false;
    const timer = setTimeout(async () => {
      setIsSearching(true);
      try {
        const response = await searchImpersonationTargets(trimmed);
        if (canceled || requestId !== requestIdRef.current) return;
        setResults(response.results ?? []);
        setHasMore(response.hasMore ?? false);
        setHasSearched(true);
      } catch {
        if (canceled || requestId !== requestIdRef.current) return;
        setResults([]);
        setHasMore(false);
        setHasSearched(true);
      } finally {
        if (!canceled && requestId === requestIdRef.current) {
          setIsSearching(false);
        }
      }
    }, SEARCH_DEBOUNCE_MS5);
    return () => {
      canceled = true;
      clearTimeout(timer);
    };
  }, [open, searchImpersonationTargets, trimmed]);
  const handleQueryChange = useCallback((value2) => {
    setQuery(value2);
    setSelected(null);
  }, []);
  const handleConfirm = useCallback(async () => {
    if (!selected?.contactId) return;
    setIsStarting(true);
    try {
      const response = await impersonate(selected.contactId);
      if (response.result === ImpersonateResult.Started) {
        window.location.assign(returnUrl);
        return;
      }
      setIsStarting(false);
      onClose();
    } catch {
      setIsStarting(false);
    }
  }, [impersonate, onClose, returnUrl, selected]);
  return /* @__PURE__ */ jsx(Dialog, { open, onOpenChange: (_, data) => {
    if (!data.open) onClose();
  }, children: /* @__PURE__ */ jsxs(
    DialogSurface,
    {
      className: mergeClasses("ppp-impersonation-picker-dialog", styles.surface, className),
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles.titleRow, children: [
          /* @__PURE__ */ jsx(DialogTitle, { className: styles.titleText, children: t("app.components.impersonation-picker.title") }),
          /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "subtle",
              icon: /* @__PURE__ */ jsx(Dismiss24Regular, {}),
              "aria-label": t("app.components.impersonation-picker.cancel"),
              onClick: onClose
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: styles.body, children: [
          /* @__PURE__ */ jsx(
            SearchBox,
            {
              value: query,
              onChange: (_, data) => handleQueryChange(data.value),
              placeholder: t("app.components.impersonation-picker.search-placeholder"),
              appearance: "outline",
              style: { width: "100%" }
            }
          ),
          /* @__PURE__ */ jsx("div", { className: styles.results, role: "listbox", children: isSearching ? /* @__PURE__ */ jsxs("div", { className: styles.status, children: [
            /* @__PURE__ */ jsx(Spinner, { size: "tiny" }),
            /* @__PURE__ */ jsx("span", { children: t("app.components.impersonation-picker.searching") })
          ] }) : isTooShort ? (
            // Distinct from "no matches": the search hasn't run. Conflating the two reads as
            // "this person doesn't exist" when the user has simply typed too few characters.
            /* @__PURE__ */ jsx("div", { className: styles.status, children: t("app.components.impersonation-picker.hint", [String(MINIMUM_QUERY_LENGTH)]) })
          ) : hasSearched && results.length === 0 ? /* @__PURE__ */ jsx("div", { className: styles.status, children: t("app.components.impersonation-picker.no-matches") }) : /* @__PURE__ */ jsxs(Fragment, { children: [
            results.map((candidate) => {
              const isSelected = selected?.contactId === candidate.contactId;
              return /* @__PURE__ */ jsxs(
                "button",
                {
                  type: "button",
                  role: "option",
                  "aria-selected": isSelected,
                  className: mergeClasses(
                    styles.result,
                    isSelected && styles.resultSelected
                  ),
                  onClick: () => setSelected(candidate),
                  children: [
                    /* @__PURE__ */ jsx(Person20Regular, {}),
                    /* @__PURE__ */ jsxs("span", { className: styles.resultText, children: [
                      /* @__PURE__ */ jsx("span", { className: styles.name, children: candidate.fullName ?? candidate.email ?? candidate.contactId }),
                      candidate.email && /* @__PURE__ */ jsx("span", { className: styles.email, children: candidate.email })
                    ] })
                  ]
                },
                candidate.contactId
              );
            }),
            hasMore && /* @__PURE__ */ jsx("div", { className: styles.status, children: t("app.components.impersonation-picker.too-many", [String(MAXIMUM_RESULTS)]) })
          ] }) }),
          selected && /* @__PURE__ */ jsxs("div", { className: styles.warning, children: [
            /* @__PURE__ */ jsx(Warning20Regular, {}),
            /* @__PURE__ */ jsx("span", { children: t("app.components.impersonation-picker.warning") })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: styles.footer, children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "primary",
              icon: /* @__PURE__ */ jsx(EyeTracking20Regular, {}),
              disabled: !selected || isStarting,
              onClick: handleConfirm,
              children: t("app.components.impersonation-picker.confirm")
            }
          ),
          /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: onClose, disabled: isStarting, children: t("app.components.impersonation-picker.cancel") })
        ] })
      ]
    }
  ) });
}
var IMPERSONATION_ROLE = "SystemAdmin";
var useStyles35 = makeStyles({
  trigger: {
    backgroundColor: "transparent",
    border: "none",
    padding: 0,
    cursor: "pointer",
    borderRadius: "50%",
    // Keep the focus ring snug around the avatar without the
    // default Fluent button-style padding distorting the circular
    // hit-target.
    ":focus-visible": {
      outline: `2px solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "2px"
    }
  },
  popoverBody: {
    minWidth: "260px",
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalM
  },
  identity: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalM
  },
  identityText: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0
  },
  identityLabel: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200
  },
  identityValue: {
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXS
  }
});
function ProfileMainMenu({
  accountUrl,
  accountLabel,
  headerSlot,
  footerSlot,
  anonymousContent,
  signInUrl = "/login"
}) {
  const auth = useAuth();
  const styles = useStyles35();
  const t = useT();
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const handleLogout = useCallback(async () => {
    try {
      await auth.logout();
    } catch {
    }
  }, [auth]);
  const handleSwitchIdentity = useCallback(async () => {
    try {
      const response = await auth.switchIdentity();
      if (response.result === SwitchIdentityResult.Switched) {
        window.location.reload();
      }
    } catch {
    }
  }, [auth]);
  if (auth.status === AuthStatus.Loading) {
    return /* @__PURE__ */ jsx(
      Avatar,
      {
        className: "ppp-profile-main-menu",
        size: 28,
        "aria-label": t("app.messages.record-loading")
      }
    );
  }
  if (auth.status === AuthStatus.Anonymous) {
    if (anonymousContent !== void 0) return /* @__PURE__ */ jsx(Fragment, { children: anonymousContent });
    return /* @__PURE__ */ jsx(
      Button,
      {
        as: "a",
        href: signInUrl,
        appearance: "subtle",
        icon: /* @__PURE__ */ jsx(ArrowExit20Regular, {}),
        className: "ppp-profile-main-menu",
        children: t("app.buttons.login.label")
      }
    );
  }
  const email = auth.user.email ?? auth.user.userName ?? "";
  const initials = email.length > 0 ? email[0].toUpperCase() : "?";
  const resolvedAccountLabel = accountLabel ?? t("app.components.profile-main-menu.account");
  const signedInAsLabel = t("app.components.profile-main-menu.signed-in-as");
  const logoutLabel = t("app.buttons.logout.label");
  const canImpersonate = (auth.user.roles?.includes(IMPERSONATION_ROLE) ?? false) && auth.user.portalUserType === PortalUserType.SystemUser;
  const altIdentityTableName = auth.user.isImpersonating ? null : auth.user.altIdentityTableName;
  const switchIdentityLabel = altIdentityTableName ? t("app.components.profile-main-menu.switch-to", [
    altIdentityTableName === "systemuser" ? t("app.components.profile-main-menu.alt-kind-systemuser") : t("app.components.profile-main-menu.alt-kind-contact")
  ]) : null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Menu, { children: [
      /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: mergeClasses("ppp-profile-main-menu", styles.trigger),
          "aria-label": email || logoutLabel,
          children: /* @__PURE__ */ jsx(Avatar, { size: 28, initials, name: email })
        }
      ) }),
      /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs("div", { className: styles.popoverBody, children: [
        headerSlot,
        /* @__PURE__ */ jsxs("div", { className: styles.identity, children: [
          /* @__PURE__ */ jsx(Avatar, { size: 40, initials, name: email }),
          /* @__PURE__ */ jsxs("div", { className: styles.identityText, children: [
            /* @__PURE__ */ jsx("span", { className: styles.identityLabel, children: signedInAsLabel }),
            /* @__PURE__ */ jsx(Tooltip, { content: email, relationship: "inaccessible", withArrow: true, children: /* @__PURE__ */ jsx("span", { className: styles.identityValue, children: email }) })
          ] })
        ] }),
        /* @__PURE__ */ jsx(Divider, {}),
        /* @__PURE__ */ jsxs(MenuList, { className: styles.actions, children: [
          accountUrl && /* @__PURE__ */ jsx(
            MenuItem,
            {
              icon: /* @__PURE__ */ jsx(PersonEdit20Regular, {}),
              onClick: () => {
                window.location.href = accountUrl;
              },
              children: resolvedAccountLabel
            }
          ),
          switchIdentityLabel && /* @__PURE__ */ jsx(
            MenuItem,
            {
              icon: /* @__PURE__ */ jsx(ArrowSwap20Regular, {}),
              onClick: handleSwitchIdentity,
              children: switchIdentityLabel
            }
          ),
          canImpersonate && /* @__PURE__ */ jsx(
            MenuItem,
            {
              icon: /* @__PURE__ */ jsx(EyeTracking20Regular, {}),
              onClick: () => setIsPickerOpen(true),
              children: t("app.components.profile-main-menu.impersonate")
            }
          ),
          /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(SignOut20Regular, {}), onClick: handleLogout, children: logoutLabel })
        ] }),
        footerSlot && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Divider, {}),
          footerSlot
        ] })
      ] }) })
    ] }),
    canImpersonate && /* @__PURE__ */ jsx(
      ImpersonationPickerDialog,
      {
        open: isPickerOpen,
        onClose: () => setIsPickerOpen(false)
      }
    )
  ] });
}
function ImpersonationBanner({
  returnUrl = "/",
  className
}) {
  const auth = useAuth();
  const t = useT();
  const [isStopping, setIsStopping] = useState(false);
  const { stopImpersonation } = auth;
  const handleStop = useCallback(async () => {
    setIsStopping(true);
    try {
      await stopImpersonation();
      window.location.assign(returnUrl);
    } catch {
      setIsStopping(false);
    }
  }, [returnUrl, stopImpersonation]);
  if (auth.status !== AuthStatus.Authenticated || !auth.user.isImpersonating) {
    return null;
  }
  const viewingAs = auth.user.email ?? auth.user.userName ?? "";
  const impersonator = auth.user.impersonatorName;
  return (
    // The class is placement only — PageLayout targets it to assign the grid row. It carries no
    // appearance of its own; Fluent owns all of that.
    /* @__PURE__ */ jsxs(
      MessageBar,
      {
        className: mergeClasses("ppp-impersonation-banner", className),
        intent: "error",
        children: [
          /* @__PURE__ */ jsxs(MessageBarBody, { children: [
            /* @__PURE__ */ jsx(MessageBarTitle, { children: t("app.components.impersonation-banner.viewing-as", [viewingAs]) }),
            impersonator ? ` ${t("app.components.impersonation-banner.you-are", [impersonator])}` : null
          ] }),
          /* @__PURE__ */ jsx(MessageBarActions, { children: /* @__PURE__ */ jsx(
            Button,
            {
              icon: /* @__PURE__ */ jsx(ArrowExit20Regular, {}),
              iconPosition: "after",
              disabled: isStopping,
              onClick: handleStop,
              children: t("app.components.impersonation-banner.stop")
            }
          ) })
        ]
      }
    )
  );
}
var usePanelStyles = makeStyles({
  // Vertical stack of setting sections with consistent gap. Matches the
  // panel body the SiteSettingsButton's drawer renders, but extracted
  // so consumers can mount it elsewhere (a dedicated /settings page, a
  // tab inside profile-management, an embedded preferences card).
  body: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalL
  }
});
function SiteSettingsPanel({
  allowLanguageChange = true,
  allowThemeChange = true,
  allowColorChange = true,
  allowRightToLeftChange = false,
  supportedLocales,
  accentLabels,
  className,
  style
}) {
  const styles = usePanelStyles();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses("ppp-site-settings-panel", styles.body, className),
      style,
      children: [
        allowLanguageChange && /* @__PURE__ */ jsx(
          LanguageDropdown,
          {
            ...supportedLocales && { supportedLocales },
            width: "100%"
          }
        ),
        allowThemeChange && /* @__PURE__ */ jsx(ThemeSelector, { width: "100%" }),
        allowColorChange && /* @__PURE__ */ jsx(
          ThemeColorSelector,
          {
            width: "100%",
            ...accentLabels && { accentLabels }
          }
        ),
        allowRightToLeftChange && /* @__PURE__ */ jsx(ThemeTextDirection, { width: "100%" })
      ]
    }
  );
}
var useStyles36 = makeStyles({
  // Wraps the standalone panel inside the drawer body to add the small
  // top inset that the popover's title visually expects. The panel
  // itself stays inset-free so it doesn't carry extra padding when
  // mounted elsewhere (a dedicated /settings page, a tab in an account
  // dashboard).
  body: {
    paddingTop: tokens.spacingVerticalM
  }
});
function SiteSettingsButton({
  allowLanguageChange = true,
  allowThemeChange = true,
  allowColorChange = true,
  allowRightToLeftChange = false,
  supportedLocales,
  buttonAppearance = "subtle",
  accentLabels
}) {
  const t = useT();
  const styles = useStyles36();
  const [open, setOpen] = useState(false);
  const label = t("app.site-settings-label");
  const panelTitle = t("app.components.site-settings-panel.label");
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Tooltip, { content: label, relationship: "label", children: /* @__PURE__ */ jsx(
      Button,
      {
        type: "button",
        appearance: buttonAppearance,
        icon: /* @__PURE__ */ jsx(Settings20Regular, {}),
        "aria-label": label,
        onClick: () => setOpen(true),
        className: "ppp-site-settings-button"
      }
    ) }),
    /* @__PURE__ */ jsx(
      SidePanel,
      {
        open,
        onOpenChange: setOpen,
        title: panelTitle,
        widthStorageKey: "ppp.site-settings-panel.width",
        children: /* @__PURE__ */ jsx(
          SiteSettingsPanel,
          {
            className: styles.body,
            allowLanguageChange,
            allowThemeChange,
            allowColorChange,
            allowRightToLeftChange,
            ...supportedLocales && { supportedLocales },
            ...accentLabels && { accentLabels }
          }
        )
      }
    )
  ] });
}
function LogoutButton({
  label,
  icon,
  appearance = "subtle",
  disabled,
  onLoggedOut,
  onError,
  className
}) {
  const auth = useAuth();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.logout.label");
  const resolvedIcon = icon === void 0 ? /* @__PURE__ */ jsx(SignOut20Regular, {}) : icon;
  const handleClick = useCallback(async () => {
    try {
      await auth.logout();
      if (onLoggedOut) await onLoggedOut();
    } catch (err) {
      if (onError) {
        await onError(err);
      }
    }
  }, [auth, onLoggedOut, onError]);
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      appearance,
      disabled: disabled === true,
      onClick: handleClick,
      ...resolvedIcon !== null && { icon: resolvedIcon },
      className: mergeClasses("ppp-logout-button", className),
      children: resolvedLabel
    }
  );
}
var useMenuBarStyles = makeStyles({
  // `overflow: hidden` + `min-width: 0` is what lets the Overflow primitive
  // measure correctly — without `min-width: 0`, the container's intrinsic
  // min-content (sum of children's min sizes) prevents it from being narrower
  // than its content in a flex-row parent, so overflow never triggers. With
  // it, the primitive can shrink the container and decide which items fit.
  // `column-gap` puts a consistent spacing between items without producing a
  // leading / trailing margin. Same shape as the existing `toolbarOverflow`
  // in `main-grid-styles.ts` (the other Overflow-based toolbar in this lib).
  // `min-height` is critical: the Overflow primitive observes the container
  // via ResizeObserver. With `overflow: hidden` and no `min-height`, a single
  // mis-step where the algorithm marks items as overflowing (briefly common
  // during initial mount as async refs/measurements settle) sets
  // `display: none` on every item via `[data-overflowing] { display: none }`,
  // which collapses the container's height to 0. That height delta re-fires
  // the ResizeObserver, the algorithm runs against a now-empty container,
  // and the visible/hidden state can oscillate before settling in the
  // "all hidden" state — leaving the bar empty in the DOM. Pinning the
  // height to a Fluent medium-button (~32px) breaks the feedback loop: the
  // container's height never changes when items toggle, the observer fires
  // only on real layout changes, and the algorithm settles correctly with
  // items visible.
  root: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    minWidth: 0,
    minHeight: "32px",
    overflow: "hidden"
  },
  // Plain `<div>` wrapper around each child that gives `<OverflowItem>` a
  // guaranteed ref target. `<OverflowItem>` is a trigger-only component — it
  // clones its child and forwards a ref to it; the Overflow primitive uses
  // that ref to measure the item. Most of our context-action buttons
  // (SaveContextButton, RefreshContextButton, DeleteContextButton, …) are
  // plain function components that DON'T accept refs, so without this wrapper
  // the primitive can't measure them, treats them as not-fitting, and hides
  // everything. A `<div>` with `display: flex` (not `inline-flex` on a
  // `<span>` — the established `toolbarSlot` pattern in `main-grid-styles.ts`
  // uses div+flex and that's the proven shape) is a guaranteed measurement
  // surface and works for any consumer child regardless of whether it uses
  // forwardRef.
  itemSlot: {
    display: "flex",
    alignItems: "center"
  },
  // The popover stacks overflow items vertically
  // `<FluentStack Orientation="Vertical">` inside the `<FluentPopover>`.
  popoverItems: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    alignItems: "flex-start"
  }
});
function MenuBar({ children, className, style, overflowLabel }) {
  const styles = useMenuBarStyles();
  const items = Children.toArray(children).filter(isValidElement).map((element, idx) => ({
    id: `ppp-menubar-item-${idx}`,
    element
  }));
  return /* @__PURE__ */ jsx(Overflow, { children: /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-menu-bar", styles.root, className), style, children: [
    items.map(({ id, element }) => /* @__PURE__ */ jsx(OverflowItem, { id, children: /* @__PURE__ */ jsx("div", { className: styles.itemSlot, children: element }) }, id)),
    items.length > 0 && /* @__PURE__ */ jsx(OverflowPopover, { items, popoverItemsClass: styles.popoverItems, overflowLabel })
  ] }) });
}
function OverflowPopover({ items, popoverItemsClass, overflowLabel }) {
  const { ref, isOverflowing, overflowCount } = useOverflowMenu();
  if (!isOverflowing) return null;
  return /* @__PURE__ */ jsxs(Popover, { children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        ref,
        appearance: "subtle",
        icon: /* @__PURE__ */ jsx(MoreVerticalRegular, {}),
        "aria-label": overflowLabel ?? `${overflowCount} more items`
      }
    ) }),
    /* @__PURE__ */ jsx(PopoverSurface, { children: /* @__PURE__ */ jsx("div", { className: popoverItemsClass, children: items.map((item) => /* @__PURE__ */ jsx(OverflowPopoverItem, { ...item }, item.id)) }) })
  ] });
}
function OverflowPopoverItem({ id, element }) {
  const isVisible = useIsOverflowItemVisible(id);
  if (isVisible) return null;
  return element;
}
var NavigationDrawerContext = createContext(null);
var useNavMenuStyles = makeStyles({
  // Width + border so the side rail sits next to the body in PageLayout's
  // navigation slot. Width default
  // Background is intentionally NOT set here — `PageLayout`'s
  // `navigation` grid-area paints the rail's background so the color
  // covers the entire vertical extent of the side band regardless of
  // how short the actual nav content is. Painting it on the `<Nav>`
  // element instead left a hard horizontal edge mid-page in dark mode
  // (the painted region ended where the last `<NavItem>` ended, with
  // a different lighter color bleeding through below).
  nav: {
    minWidth: "250px",
    maxWidth: "320px",
    height: "100%",
    borderRight: `1px solid ${tokens.colorNeutralStroke2}`,
    // Paint the rail directly on `<Nav>` so the full vertical extent
    // of the side band is uniform. `colorNeutralBackground4` matches the
    // background tone Fluent's `<NavSubItem>` ships with — the rail's
    // empty area and its items now share one continuous surface
    // instead of showing a horizontal seam between Fluent's default
    // outer-Nav background and the inner-item background.
    backgroundColor: tokens.colorNeutralBackground4
  },
  // Inline icon for sub-items. Fluent UI 9's <NavSubItem> doesn't have a
  // dedicated `icon` slot (sub-items are text-only in the Fluent design
  // language), so we render the icon as a leading inline-flex span inside
  // the link's content. Width is fixed so labels still align vertically
  // across rows whether their icon is present or not.
  subItemIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    // Accent-colored icons. Fluent icons fill with currentColor, so
    // coloring the wrapper tints the glyph.
    color: tokens.colorBrandForeground1,
    // Size the <svg> directly. Fluent's icon components set their own font-size, so a
    // font-size on this wrapper span never reaches them — only sizing the SVG actually
    // enlarges the glyph. No marginRight: the row's flex gap on .ppp-nav-item is the
    // only icon-to-label spacing.
    "& svg": {
      width: "20px",
      height: "20px",
      fontSize: "20px"
    }
  }
});
var useNavMenuDarkSurfaceStyles = makeStaticStyles({
  "body.ppp-theme-dark .ppp-nav-menu": {
    "--colorNeutralBackground4": "var(--colorNeutralBackground2)",
    "--colorNeutralBackground4Hover": "var(--colorNeutralBackground2Hover)",
    "--colorNeutralBackground4Pressed": "var(--colorNeutralBackground2Pressed)"
  }
});
var useNavSelectedStyles = makeStaticStyles({
  // Every nav item gets a stacking context so the highlight pseudo (z-index:-1)
  // paints behind the label yet stays contained to the item (not behind the rail).
  // Both pseudo-elements are defined on every item at opacity 0 and fade to 1 on
  // the active one, so selecting/deselecting a route eases the highlight + marker
  // in and out instead of popping.
  // Category header label matches the nav items (primary foreground / white in dark),
  // not Fluent's secondary gray. Coloring the root sets the label (and the expand
  // chevron, which inherits); the icon slot below keeps its own accent color.
  ".ppp-nav-menu .fui-NavCategoryItem": {
    color: "var(--colorNeutralForeground1)",
    // Fluent's item reset top-aligns the row (alignItems: flex-start), which floats the
    // icon above the text baseline. Center it so the glyph sits level with the label.
    alignItems: "center"
  },
  // Parent (category) header icons. Fluent's icon slot sets no font-size, so the
  // resizable category icons render at the inherited text size (~14px) and look tiny.
  // Size the <svg> directly to match the sub-item icons; bump the slot's min box so the
  // larger glyph isn't clipped by its overflow:hidden.
  ".ppp-nav-menu .fui-NavCategoryItem__icon": {
    minWidth: "20px",
    minHeight: "20px",
    // Accent-tint the category icons to match the sub-item icons (Fluent icons fill
    // with currentColor, so coloring the slot tints the glyph).
    color: "var(--colorBrandForeground1)"
  },
  ".ppp-nav-menu .fui-NavCategoryItem__icon svg": {
    width: "20px",
    height: "20px",
    fontSize: "20px"
  },
  ".ppp-nav-menu .ppp-nav-item": {
    position: "relative",
    zIndex: 0,
    // Center icon with the label vertically (Fluent's reset top-aligns via flex-start).
    alignItems: "center",
    // Nav item label uses the primary foreground (white in dark mode) instead of
    // Fluent's secondary gray. The icon keeps its own brand color (set on the icon
    // span, which wins for the glyph). Theme-aware: dark text in light mode.
    color: "var(--colorNeutralForeground1)",
    // Tighten the row. Fluent defaults to a wide icon-to-label flex gap
    // (spacingVerticalL ~16px) plus the icon's own margin and a deep 46px sub-item
    // indent, which reads as too spread out. Pull the label in (8px gap), trim the
    // vertical padding so items sit closer together, and reduce the indent.
    gap: "var(--spacingHorizontalM)",
    // +1px over spacingVerticalS on each side: grows the row pitch by 2px AND, because
    // the highlight pill insets a fixed 2px from the row edges, grows the pill height
    // by 2px to match.
    paddingTop: "calc(var(--spacingVerticalS) + 1px)",
    paddingBottom: "calc(var(--spacingVerticalS) + 1px)",
    paddingInlineStart: "32px"
  },
  // Neutralize Fluent's full-bleed hover background on the row (it paints
  // `colorNeutralBackground4Hover` edge-to-edge on the <a>). Keeping the item at the
  // rail color on hover means only our inset, rounded highlight (::before) shows
  // same geometry as the selected state, not an edge-to-edge shade.
  ".ppp-nav-menu .ppp-nav-item:hover": {
    backgroundColor: "var(--colorNeutralBackground4)"
  },
  // Row highlight: an inset, rounded rectangle behind the label. `::before` (Fluent
  // uses `::after` for its indicator, never `::before`, so no collision). Inset on
  // all sides + rounded corners give the padded "pill". Hover and selected use the
  // SAME shade — the marker is what distinguishes the active route.
  // Tracks the dark-surface remap above. z-index:-1 (contained by the
  // item's z-index:0 context) keeps it behind the label.
  ".ppp-nav-menu .ppp-nav-item::before": {
    content: '""',
    position: "absolute",
    top: "2px",
    bottom: "2px",
    insetInlineStart: "3px",
    insetInlineEnd: "3px",
    margin: 0,
    borderRadius: "var(--borderRadiusMedium)",
    backgroundColor: "var(--colorNeutralBackground4Hover)",
    zIndex: -1,
    opacity: 0,
    transition: "opacity 0.2s ease-in-out"
  },
  // Themed accent marker: short rounded bar a couple of px in from the rail's
  // inline-start edge (left in LTR, right in RTL), inset top+bottom so it clears the
  // highlight's rounded corners. Reuses Fluent's indicator slot (`::after`) but
  // re-anchors it (`margin:0` kills Fluent's negative offset) and drives the fade
  // ourselves via opacity (`animationName:none` disables Fluent's own background
  // keyframe so our brand color + fade win).
  ".ppp-nav-menu .ppp-nav-item::after": {
    content: '""',
    position: "absolute",
    insetInlineStart: "6px",
    insetInlineEnd: "auto",
    top: "10px",
    bottom: "10px",
    width: "3px",
    height: "auto",
    margin: 0,
    animationName: "none",
    borderRadius: "var(--borderRadiusCircular)",
    backgroundColor: "var(--colorBrandStroke1)",
    opacity: 0,
    transition: "opacity 0.2s ease-in-out"
  },
  // Hover fades the highlight in (lighter Hover shade from the base ::before); the
  // marker (::after) stays hidden since hover isn't the active route.
  ".ppp-nav-menu .ppp-nav-item:hover::before": {
    opacity: 1
  },
  // Selected shows the same highlight as hover, plus the accent marker (::after).
  '.ppp-nav-menu .ppp-nav-item[aria-current="page"]::before': {
    opacity: 1
  },
  '.ppp-nav-menu .ppp-nav-item[aria-current="page"]::after': {
    opacity: 1
  }
});
function NavMenu({ children, width, className, style }) {
  const styles = useNavMenuStyles();
  useNavMenuDarkSurfaceStyles();
  useNavSelectedStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const drawer = useContext(NavigationDrawerContext);
  const mountedLocationKey = useRef(location.key);
  useEffect(() => {
    if (location.key !== mountedLocationKey.current) drawer?.close();
  }, [location.key, drawer]);
  const { allRoutes, groups, defaultOpenIndexes } = useMemo(
    () => collectNavTree(children),
    [children]
  );
  const selectedRoute = useMemo(
    () => bestRouteMatch(allRoutes, location.pathname),
    [allRoutes, location.pathname]
  );
  const [openIndexes, setOpenIndexes] = useState(
    () => /* @__PURE__ */ new Set([
      ...defaultOpenIndexes,
      // Seed the active route's group too, so it's open on first paint
      // (the effect below only fires after mount).
      ...selectedRoute && selectedRoute.groupIndex >= 0 ? [selectedRoute.groupIndex] : []
    ])
  );
  const selectedGroupIndex = selectedRoute?.groupIndex ?? -1;
  useEffect(() => {
    if (selectedGroupIndex < 0) return;
    setOpenIndexes(
      (prev) => prev.has(selectedGroupIndex) ? prev : new Set(prev).add(selectedGroupIndex)
    );
  }, [selectedGroupIndex]);
  const openCategories = useMemo(
    () => groups.filter((_, index) => openIndexes.has(index)),
    [groups, openIndexes]
  );
  const handleSelect = (_, data) => {
    const value2 = data.value;
    if (typeof value2 === "string" && value2.startsWith("/")) {
      navigate(value2);
    }
  };
  const handleCategoryToggle = (_, data) => {
    if (data.categoryValue === void 0) return;
    const index = groups.indexOf(data.categoryValue);
    if (index < 0) return;
    setOpenIndexes((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };
  const navStyle = width && !drawer ? { ...style, minWidth: width, maxWidth: width } : style;
  return /* @__PURE__ */ jsx(
    Nav,
    {
      selectedValue: selectedRoute?.to ?? "",
      onNavItemSelect: handleSelect,
      openCategories,
      onNavCategoryItemToggle: handleCategoryToggle,
      className: mergeClasses("ppp-nav-menu", styles.nav, className),
      style: navStyle,
      children
    }
  );
}
function NavGroup({ label, icon, value: value2, children }) {
  const groupValue = value2 ?? `group:${label}`;
  return /* @__PURE__ */ jsxs(NavCategory, { value: groupValue, children: [
    icon !== void 0 ? /* @__PURE__ */ jsx(NavCategoryItem, { icon, children: label }) : /* @__PURE__ */ jsx(NavCategoryItem, { children: label }),
    /* @__PURE__ */ jsx(NavSubItemGroup, { children })
  ] });
}
function NavItem({ to, icon, children }) {
  const styles = useNavMenuStyles();
  const navigate = useNavigate();
  const handleClick = (e) => {
    if (e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    navigate(to);
  };
  return /* @__PURE__ */ jsxs(NavSubItem, { as: "a", value: to, href: to, onClick: handleClick, className: "ppp-nav-item", children: [
    icon !== void 0 && /* @__PURE__ */ jsx("span", { className: styles.subItemIcon, children: icon }),
    children
  ] });
}
function collectNavTree(children) {
  const allRoutes = [];
  const groups = [];
  const defaultOpenIndexes = [];
  const visit = (nodes, groupIndex) => {
    Children.forEach(nodes, (child) => {
      if (!isValidElement(child)) return;
      if (child.type === NavGroup) {
        const props = child.props;
        const value2 = props.value ?? `group:${props.label}`;
        const index = groups.length;
        groups.push(value2);
        if (props.defaultExpanded) defaultOpenIndexes.push(index);
        visit(props.children, index);
        return;
      }
      if (child.type === NavItem) {
        const props = child.props;
        allRoutes.push({
          to: props.to,
          match: props.match ?? (props.to === "/" ? "exact" : "prefix"),
          groupIndex
        });
        return;
      }
      const wrapperChildren = child.props.children;
      if (wrapperChildren !== void 0) visit(wrapperChildren, groupIndex);
    });
  };
  visit(children, -1);
  return { allRoutes, groups, defaultOpenIndexes };
}
function bestRouteMatch(routes, pathname) {
  const normalize = (p) => p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p;
  const target = normalize(pathname);
  let best;
  let bestLen = -1;
  for (const candidate of routes) {
    const route = normalize(candidate.to);
    const matches = route === target || candidate.match === "prefix" && (route === "/" || target.startsWith(route + "/"));
    if (matches && route.length > bestLen) {
      best = candidate;
      bestLen = route.length;
    }
  }
  return best;
}
var useStyles37 = makeStyles({
  // Centered placeholder used while prefixes are being fetched. Same
  // shape as the spinner blocks in `<NewRecordGridButton>` /
  // `<OpenRecordGridButton>` dialogs (~160px min height + vertical
  // centering) so a boundary swap doesn't pop the surrounding layout
  // around. Consumers wanting a tighter / inline fallback can pass
  // their own `fallback` prop.
  fallback: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "160px",
    rowGap: tokens.spacingVerticalM
  }
});
function LocalizationBoundary({
  prefixes,
  fallback,
  keepOnLocaleChange = false,
  children
}) {
  const styles = useStyles37();
  const resolvedPrefixes = prefixes ?? EMPTY_PREFIXES;
  const { locale } = useLocale();
  useLocalization(resolvedPrefixes);
  const isLoaded = useLocalizationLoaded(resolvedPrefixes);
  const [ready, setReady] = useState(isLoaded);
  const lastLocaleRef = useRef(locale);
  useEffect(() => {
    if (locale !== lastLocaleRef.current) {
      lastLocaleRef.current = locale;
      if (keepOnLocaleChange) return;
      setReady(false);
      return;
    }
    if (isLoaded && !ready) {
      setReady(true);
    }
  }, [isLoaded, locale, ready, keepOnLocaleChange]);
  if (ready) return /* @__PURE__ */ jsx(Fragment, { children });
  if (fallback !== void 0) return /* @__PURE__ */ jsx(Fragment, { children: fallback });
  return /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-localization-boundary", styles.fallback), role: "status", "aria-live": "polite", children: /* @__PURE__ */ jsx(Spinner, { size: "medium" }) });
}
var EMPTY_PREFIXES = Object.freeze([]);

// src/localization/translation-size.ts
var LARGE_TRANSLATION_THRESHOLD = 1e4;
function countTranslatableStrings(content) {
  const start = content.indexOf("{");
  const end = content.lastIndexOf("}");
  if (start < 0 || end < start) return void 0;
  let parsed;
  try {
    parsed = JSON.parse(withoutTrailingCommas(content.slice(start, end + 1)));
  } catch {
    return void 0;
  }
  const distinct = /* @__PURE__ */ new Set();
  collectStrings(parsed, distinct);
  return distinct.size;
}
function collectStrings(value2, into) {
  if (typeof value2 === "string") {
    if (value2.trim() !== "") into.add(value2);
    return;
  }
  if (Array.isArray(value2)) {
    for (const item of value2) collectStrings(item, into);
    return;
  }
  if (value2 !== null && typeof value2 === "object") {
    for (const item of Object.values(value2)) collectStrings(item, into);
  }
}
function withoutTrailingCommas(json2) {
  let result = "";
  let inString = false;
  let escaped = false;
  for (let index = 0; index < json2.length; index++) {
    const character = json2[index];
    if (inString) {
      result += character;
      if (escaped) escaped = false;
      else if (character === "\\") escaped = true;
      else if (character === '"') inString = false;
      continue;
    }
    if (character === '"') {
      inString = true;
      result += character;
      continue;
    }
    if (character === ",") {
      let next = index + 1;
      while (next < json2.length && /\s/.test(json2[next])) next++;
      if (json2[next] === "}" || json2[next] === "]") continue;
    }
    result += character;
  }
  return result;
}
var useStyles38 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalL,
    maxWidth: "760px"
  },
  targets: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXS
  },
  resultRow: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    flexWrap: "wrap"
  },
  cultureCell: { minWidth: "80px" },
  muted: { color: tokens.colorNeutralForeground2 }
});
function readFileAsBase642(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result);
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
function downloadBase64(fileName, base64, contentType) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  const url = URL.createObjectURL(new Blob([bytes], { type: contentType }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
function detectSourceLanguage(fileName) {
  const withoutExt = fileName.replace(/\.[^.]+$/, "");
  const parts = withoutExt.split(".");
  const candidate = parts.length >= 2 ? parts[parts.length - 1] : void 0;
  if (candidate === void 0) return void 0;
  const language = candidate.split("-")[0] ?? "";
  return /^[a-zA-Z]{2,3}$/.test(language) ? candidate : void 0;
}
function isSameLanguage(a, b) {
  const primary = (code) => code.trim().split("-")[0]?.toLowerCase() ?? "";
  const primaryA = primary(a);
  return primaryA.length > 0 && primaryA === primary(b);
}
function LocalizationTranslator({ className }) {
  const styles = useStyles38();
  const t = useT();
  const { ppp } = usePowerPortalsPro();
  const dialog = useDialogService();
  const [availability, setAvailability] = useState(null);
  const [availabilityError, setAvailabilityError] = useState();
  const [fileName, setFileName] = useState();
  const [fileBase64, setFileBase64] = useState();
  const [translatableCount, setTranslatableCount] = useState();
  const [sourceLanguage, setSourceLanguage] = useState("");
  const [selectedTargets, setSelectedTargets] = useState([]);
  const [isDragOver, setIsDragOver] = useState(false);
  const [isTranslating, setIsTranslating] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState();
  const inputRef = useRef(null);
  useEffect(() => {
    let canceled = false;
    ppp.getTranslationAvailabilityAsync().then((value2) => {
      if (!canceled) setAvailability(value2);
    }).catch((reason) => {
      if (!canceled) setAvailabilityError(reason instanceof Error ? reason.message : String(reason));
    });
    return () => {
      canceled = true;
    };
  }, [ppp]);
  const onFile = useCallback(async (file) => {
    const [base64, text2] = await Promise.all([readFileAsBase642(file), file.text()]);
    setFileName(file.name);
    setFileBase64(base64);
    setTranslatableCount(countTranslatableStrings(text2));
    setResult(null);
    const detected = detectSourceLanguage(file.name);
    if (detected) setSourceLanguage(detected);
  }, []);
  const onInputChange = useCallback(
    (ev) => {
      const file = ev.target.files?.[0];
      if (file) void onFile(file);
      ev.target.value = "";
    },
    [onFile]
  );
  const toggleTarget = useCallback((cultureCode, checked) => {
    setSelectedTargets(
      (prev) => checked ? [...prev, cultureCode] : prev.filter((code) => code !== cultureCode)
    );
  }, []);
  useEffect(() => {
    setSelectedTargets((prev) => {
      const filtered = prev.filter((code) => !isSameLanguage(code, sourceLanguage));
      return filtered.length === prev.length ? prev : filtered;
    });
  }, [sourceLanguage]);
  const canTranslate = !!fileBase64 && selectedTargets.length > 0 && sourceLanguage.trim().length > 0 && !isTranslating;
  const onTranslate = useCallback(async () => {
    if (!fileBase64 || !fileName) return;
    if (translatableCount !== void 0) {
      const requestedCount = translatableCount * selectedTargets.length;
      if (requestedCount > LARGE_TRANSLATION_THRESHOLD) {
        const confirmation = await dialog.showConfirmationAsync(
          t("app.localization-admin.translate-large-message", [
            translatableCount.toLocaleString(),
            selectedTargets.length,
            requestedCount.toLocaleString()
          ]),
          {
            title: t("app.localization-admin.translate-large-title"),
            primaryText: t("app.localization-admin.translate-large-continue"),
            secondaryText: t("app.buttons.cancel.label")
          }
        );
        if (confirmation.canceled) return;
      }
    }
    setIsTranslating(true);
    setResult(null);
    setError(void 0);
    try {
      const value2 = await ppp.translateLocalizationFileAsync({
        sourceLanguage: sourceLanguage.trim(),
        targetCultureCodes: [...selectedTargets],
        fileName,
        sourceContent: fileBase64
      });
      setResult(value2);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : String(reason));
    } finally {
      setIsTranslating(false);
    }
  }, [ppp, dialog, t, fileBase64, fileName, sourceLanguage, selectedTargets, translatableCount]);
  let content;
  if (availabilityError !== void 0) {
    content = /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.localization-admin.load-failed", [availabilityError]) }) });
  } else if (!availability) {
    content = /* @__PURE__ */ jsx(Spinner, {});
  } else if (!availability.isConfigured) {
    content = null;
  } else if (!availability.isSolutionInstalled) {
    content = /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "info", children: /* @__PURE__ */ jsx(MessageBarBody, { children: /* @__PURE__ */ jsx(
      "span",
      {
        dangerouslySetInnerHTML: {
          __html: t("app.localization-admin.translate-solution-missing")
        }
      }
    ) }) });
  } else {
    const dropZoneStyle = {
      border: `1px dashed ${isDragOver ? tokens.colorBrandStroke1 : tokens.colorNeutralStroke1}`,
      borderRadius: tokens.borderRadiusMedium,
      padding: tokens.spacingVerticalXL,
      textAlign: "center",
      cursor: "pointer",
      backgroundColor: isDragOver ? tokens.colorNeutralBackground1Hover : void 0
    };
    content = /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Title3, { children: t("app.localization-admin.translate-title") }),
      /* @__PURE__ */ jsx(Text, { children: t("app.localization-admin.translate-description") }),
      /* @__PURE__ */ jsxs(
        "div",
        {
          style: dropZoneStyle,
          role: "button",
          tabIndex: 0,
          onClick: () => inputRef.current?.click(),
          onKeyDown: (ev) => {
            if (ev.key === "Enter" || ev.key === " ") {
              ev.preventDefault();
              inputRef.current?.click();
            }
          },
          onDragOver: (ev) => {
            ev.preventDefault();
            setIsDragOver(true);
          },
          onDragLeave: () => setIsDragOver(false),
          onDrop: (ev) => {
            ev.preventDefault();
            setIsDragOver(false);
            const file = ev.dataTransfer.files?.[0];
            if (file) void onFile(file);
          },
          children: [
            /* @__PURE__ */ jsx("input", { ref: inputRef, type: "file", accept: ".json,.js", hidden: true, onChange: onInputChange }),
            /* @__PURE__ */ jsx(Text, { children: fileName ?? t("app.localization-admin.translate-upload-prompt") })
          ]
        }
      ),
      /* @__PURE__ */ jsx(
        Field,
        {
          label: t("app.localization-admin.translate-source-language"),
          hint: t("app.localization-admin.translate-source-language-hint"),
          children: /* @__PURE__ */ jsx(Input, { value: sourceLanguage, onChange: (_, data) => setSourceLanguage(data.value) })
        }
      ),
      /* @__PURE__ */ jsx(
        Field,
        {
          label: t("app.localization-admin.translate-target-languages"),
          hint: t("app.localization-admin.translate-target-languages-hint"),
          children: /* @__PURE__ */ jsx("div", { className: styles.targets, children: availability.targetLanguages.map((language) => {
            const isSource = isSameLanguage(language.cultureCode, sourceLanguage);
            return /* @__PURE__ */ jsx(
              Checkbox,
              {
                label: language.isSupportedByProvider ? language.displayName : `${language.displayName} ${t("app.localization-admin.translate-unsupported-suffix")}`,
                checked: selectedTargets.includes(language.cultureCode),
                disabled: !language.isSupportedByProvider || isSource,
                onChange: (_, data) => toggleTarget(language.cultureCode, data.checked === true)
              },
              language.cultureCode
            );
          }) })
        }
      ),
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Button, { appearance: "primary", disabled: !canTranslate, onClick: () => void onTranslate(), children: isTranslating ? t("app.localization-admin.translating") : t("app.localization-admin.translate-button") }) }),
      error !== void 0 && /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.localization-admin.translate-failed", [error]) }) }),
      result && /* @__PURE__ */ jsxs("div", { className: styles.root, children: [
        result.files.map((file) => /* @__PURE__ */ jsxs("div", { className: styles.resultRow, children: [
          /* @__PURE__ */ jsx(Text, { weight: "semibold", className: styles.cultureCell, children: file.targetCultureCode }),
          /* @__PURE__ */ jsx(Text, { className: styles.muted, children: t("app.localization-admin.translate-summary", [file.translatedCount, file.reusedCount]) }),
          /* @__PURE__ */ jsx(
            Button,
            {
              size: "small",
              onClick: () => downloadBase64(file.fileName, file.content, "application/json"),
              children: file.fileName
            }
          )
        ] }, file.targetCultureCode)),
        /* @__PURE__ */ jsxs("div", { className: styles.resultRow, children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "primary",
              onClick: () => downloadBase64(result.zipFileName, result.zipContent, "application/zip"),
              children: t("app.localization-admin.translate-download-all")
            }
          ),
          /* @__PURE__ */ jsx(Text, { className: styles.muted, children: t("app.localization-admin.translate-summary", [result.totalTranslated, result.totalReused]) })
        ] })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-localization-translator", styles.root, className), children: content });
}
var PPP_HEADER_CLASS = "ppp-header";
var useHeaderStyles = makeStyles({
  // Single source of truth for the framework's header-band visual
  // treatment. Mirrors token-for-token
  // any change here propagates automatically to every consumer
  // (`<Section>` header bands, future `<MainGrid>` toolbars, future
  // `<MenuBar>` headers, standalone consumer usage). The mapping from
  // calibrated for visual parity:
  // --neutral-layer-4 → tokens.colorNeutralBackground5
  // --neutral-stroke-rest → tokens.colorNeutralStroke1
  // --control-corner-radius → tokens.borderRadiusMedium
  // 2*--design-unit (8px) → tokens.spacingVerticalS
  // 3*--design-unit (12px) → tokens.spacingHorizontalM
  // Corners are rounded unconditionally. The rounding is invisible
  // without a parent border to align against, so unbordered consumers
  // (e.g. an unbordered `<Section>`) pay nothing visually. Bordered
  // consumers get the flush-against-border-radius look.
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground5,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderTopLeftRadius: tokens.borderRadiusMedium,
    borderTopRightRadius: tokens.borderRadiusMedium,
    // h-tag margin reset —.
    // Lets consumers write `<Header><h2>Title</h2></Header>` without
    // browser-default heading margins pushing the title off-center.
    "& h1, & h2, & h3, & h4, & h5, & h6": { margin: 0 }
  }
});
function Header({ children, className, style, ...rest }) {
  const styles = useHeaderStyles();
  return /* @__PURE__ */ jsx(
    "header",
    {
      ...rest,
      className: mergeClasses(styles.root, PPP_HEADER_CLASS, className),
      style,
      children
    }
  );
}
var SectionColumnOrientation = {
  Vertical: "vertical",
  Horizontal: "horizontal"
};
var useSectionStyles = makeStyles({
  section: {
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    boxSizing: "border-box"
  },
  // Optional outer border, applied to <Section> when `borderVisible` is on.
  sectionBorder: {
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    width: "100%"
  },
  // (Header / Footer band chrome moved to `layout/header.tsx` and
  // `layout/footer.tsx` as the framework-wide source of truth. Section
  // composes with `<Header>` / `<Footer>` so a CSS change there
  // propagates here without per-component edits.)
  // The flex row that wraps the columns. Wraps to a new line when there
  // isn't enough horizontal space for the columns' min-widths. Gap is a
  // literal 15px — no Fluent token equals 15px.
  body: {
    display: "flex",
    flexDirection: "row",
    columnGap: "15px",
    rowGap: "15px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    flexWrap: "wrap"
  },
  bodyBorderedSection: {
    padding: "0 1rem"
  },
  // A single column. Default flex weight 3.4 — single-Section columns
  // get the full content width.
  column: {
    flex: "3.4 1 0%",
    display: "block",
    boxSizing: "border-box",
    backgroundColor: tokens.colorNeutralBackground1
  },
  columnBorder: {
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    width: "100%"
  },
  // Combined-state margins between the column and the section's own
  // header / border / footer.
  columnMarginTop: { marginTop: "1rem" },
  columnMarginBottom: { marginBottom: "1rem" },
  columnContent: {
    width: "100%",
    padding: "1rem"
  },
  // Inner flex container for the column's children. Vertical (column)
  // stacking is the default for forms; horizontal is the alternate for
  // toolbars or filter rows.
  columnContentStack: {
    display: "flex",
    width: "100%"
  }
});
function SectionColumn(_props) {
  return null;
}
function Section({
  children,
  header,
  footer,
  headerText,
  footerText,
  borderVisible = false,
  columnCount,
  columnMinWidth = "340px",
  editorLabelPosition,
  className,
  style,
  childContentClassName,
  childContentStyle,
  headerClassName,
  headerStyle,
  footerClassName,
  footerStyle,
  id
}) {
  const styles = useSectionStyles();
  if (columnCount !== void 0 && (columnCount < 1 || columnCount > 4)) {
    throw new Error(
      `Section: 'columnCount' must be between 1 and 4 inclusive (got ${columnCount}).`
    );
  }
  const columns = [];
  Children.forEach(children, (child) => {
    if (isValidElement(child) && child.type === SectionColumn) {
      columns.push(child.props);
    }
  });
  const effectiveCount = columnCount ?? columns.length;
  const headerNode = resolveHeaderSlot(header, headerText);
  const footerNode = resolveFooterSlot(footer, footerText);
  const hasHeader = headerNode !== void 0;
  const hasFooter = footerNode !== void 0;
  return /* @__PURE__ */ jsx(EditorLabelPositionProvider, { position: editorLabelPosition, children: /* @__PURE__ */ jsxs(
    "div",
    {
      id,
      className: mergeClasses(
        "ppp-section",
        styles.section,
        borderVisible && styles.sectionBorder,
        className
      ),
      style,
      children: [
        hasHeader && /* @__PURE__ */ jsx(
          Header,
          {
            ...headerClassName !== void 0 && { className: headerClassName },
            ...headerStyle !== void 0 && { style: headerStyle },
            children: headerNode
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: mergeClasses(
              "ppp-section-body",
              styles.body,
              borderVisible && styles.bodyBorderedSection,
              childContentClassName
            ),
            style: childContentStyle,
            children: Array.from({ length: effectiveCount }).map((_, i) => {
              const col = columns[i];
              if (!col) {
                return /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: mergeClasses("ppp-section-column", styles.column),
                    style: { minWidth: columnMinWidth }
                  },
                  `__empty_${i}`
                );
              }
              return /* @__PURE__ */ jsx(
                SectionColumnRenderer,
                {
                  column: col,
                  columnMinWidth,
                  sectionHasHeader: hasHeader,
                  sectionHasFooter: hasFooter,
                  sectionHasBorder: borderVisible
                },
                i
              );
            })
          }
        ),
        hasFooter && /* @__PURE__ */ jsx(
          Footer,
          {
            ...footerClassName !== void 0 && { className: footerClassName },
            ...footerStyle !== void 0 && { style: footerStyle },
            children: footerNode
          }
        )
      ]
    }
  ) });
}
function resolveHeaderSlot(node, text2) {
  if (node !== void 0) return node;
  if (text2 !== void 0 && text2.trim() !== "") return /* @__PURE__ */ jsx("h5", { children: text2 });
  return void 0;
}
function resolveFooterSlot(node, text2) {
  if (node !== void 0) return node;
  if (text2 !== void 0 && text2.trim() !== "") return text2;
  return void 0;
}
function SectionColumnRenderer({
  column,
  columnMinWidth,
  sectionHasHeader,
  sectionHasFooter,
  sectionHasBorder
}) {
  const styles = useSectionStyles();
  const inheritedLabelPosition = useContext(EditorLabelPositionContext);
  const {
    children,
    header,
    footer,
    headerText,
    footerText,
    borderVisible = true,
    columnContentOrientation = SectionColumnOrientation.Vertical,
    horizontalGap = 10,
    verticalGap = 10,
    width,
    editorLabelPosition,
    className,
    style
  } = column;
  const headerNode = resolveHeaderSlot(header, headerText);
  const footerNode = resolveFooterSlot(footer, footerText);
  const hasColumnHeader = headerNode !== void 0;
  const wantsMarginTop = sectionHasHeader && hasColumnHeader || sectionHasHeader && borderVisible || sectionHasBorder && borderVisible;
  const wantsMarginBottom = sectionHasFooter && borderVisible || sectionHasBorder && borderVisible;
  const flexStyle = {
    minWidth: columnMinWidth,
    ...width !== void 0 ? { flex: `${width} 1 0%` } : {},
    ...style
  };
  const horizontal = columnContentOrientation === SectionColumnOrientation.Horizontal;
  const stackStyle = {
    columnGap: `${verticalGap}px`,
    rowGap: `${horizontalGap}px`,
    flexDirection: horizontal ? "row" : "column",
    flexWrap: horizontal ? "wrap" : "nowrap"
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses(
        "ppp-section-column",
        styles.column,
        borderVisible && styles.columnBorder,
        wantsMarginTop && styles.columnMarginTop,
        wantsMarginBottom && styles.columnMarginBottom,
        className
      ),
      style: flexStyle,
      children: [
        hasColumnHeader && /* @__PURE__ */ jsx(Header, { children: headerNode }),
        /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-section-column-content", styles.columnContent), children: /* @__PURE__ */ jsx(
          "div",
          {
            className: mergeClasses(
              "ppp-section-column-content-stack",
              styles.columnContentStack
            ),
            style: stackStyle,
            children: /* @__PURE__ */ jsx(
              EditorLabelPositionProvider,
              {
                position: editorLabelPosition ?? (horizontal && (inheritedLabelPosition ?? EditorLabelPosition.Auto) === EditorLabelPosition.Auto ? EditorLabelPosition.Above : void 0),
                children
              }
            )
          }
        ) }),
        footerNode !== void 0 && /* @__PURE__ */ jsx(Footer, { children: footerNode })
      ]
    }
  );
}
var useStyles39 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalL
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    flexWrap: "wrap"
  },
  lastReloaded: {
    opacity: 0.7,
    fontSize: tokens.fontSizeBase200
  },
  configList: {
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    columnGap: tokens.spacingHorizontalL,
    rowGap: tokens.spacingVerticalXS,
    margin: 0
  },
  configTerm: {
    margin: 0,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground2
  },
  configValue: { margin: 0 },
  // Horizontal scroll viewport so widening any column past the panel width
  // scrolls instead of clipping — mirrors the Blazor grid-scroll wrapper.
  gridScroll: { overflowX: "auto", width: "100%" },
  numericCell: { textAlign: "right", fontVariantNumeric: "tabular-nums" },
  // The '#' (load order) column only ever holds a 1–2 digit number — keep it narrow.
  orderCell: {
    width: "35px",
    minWidth: "35px",
    maxWidth: "35px",
    textAlign: "right",
    fontVariantNumeric: "tabular-nums"
  },
  // 'Source' values are often long absolute file paths / web-resource names with no
  // spaces — cap the width and let them wrap (break mid-token) instead of overflowing.
  sourceCell: {
    width: "320px",
    maxWidth: "320px",
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    wordBreak: "break-word"
  },
  overriding: { color: "var(--accent-foreground-rest, var(--accent-fill-rest))" },
  failed: { color: tokens.colorPaletteRedForeground1 },
  skipped: { opacity: 0.6 },
  downloadCell: {
    display: "flex",
    flexWrap: "wrap",
    gap: tokens.spacingHorizontalXS
  },
  mergedButtons: {
    display: "flex",
    flexWrap: "wrap",
    gap: tokens.spacingHorizontalL
  },
  // One culture group: language label + inspect button + download button, kept together.
  mergedCulture: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS
  },
  mergedCultureLabel: { fontSize: tokens.fontSizeBase200 },
  dialogSurface: { maxWidth: "1100px", width: "90vw" },
  dialogToolbar: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    flexWrap: "wrap",
    marginBottom: tokens.spacingVerticalS
  },
  // Scroll viewport for the merged grid so a tall result set scrolls inside the dialog.
  dialogGrid: { maxHeight: "60vh", overflowY: "auto", overflowX: "auto" },
  // Merged-snapshot cells. Keys and sources are long single tokens (dotted keys,
  // backslash-only absolute paths) with no natural break opportunity, so without
  // this the text paints straight over the neighboring column. `overflow-wrap:
  // anywhere` (not just `break-word`) is what makes the flex cell honor its
  // column width — it counts the soft breaks toward min-content — so the token
  // wraps inside the column instead of stretching it. Same recipe as
  // `sourceCell` in the per-source loads table above.
  mergedCell: {
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    wordBreak: "break-word"
  },
  filterInput: { minWidth: "260px" },
  pager: { display: "flex", alignItems: "center", gap: tokens.spacingHorizontalS },
  grow: { flex: 1 },
  sectionBody: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS,
    width: "100%"
  }
});
var KIND_KEY = { 0: "tablemetadata", 1: "webresource", 2: "folderfile" };
var STATUS_KEY = { 0: "loaded", 1: "failed", 2: "skipped" };
var toNumber2 = (value2) => Number(value2);
function downloadBytes(fileName, data, contentType = "application/json") {
  const url = URL.createObjectURL(new Blob([new Uint8Array(data)], { type: contentType }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
var kindKeyOf = (kind) => KIND_KEY[Number(kind)] ?? "tablemetadata";
function cultureLabel(culture) {
  try {
    const name = new Intl.DisplayNames(void 0, { type: "language" }).of(culture);
    return name && name.toLowerCase() !== culture.toLowerCase() ? `${name} (${culture})` : culture;
  } catch {
    return culture;
  }
}
function LocalizationAdmin({ className }) {
  const styles = useStyles39();
  const t = useT();
  const { ppp } = usePowerPortalsPro();
  const timeZone = useUserTimeZone();
  const [overview, setOverview] = useState(null);
  const [loadError, setLoadError] = useState();
  const [isReloading, setIsReloading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [message, setMessage] = useState();
  const [mergedDialogCulture, setMergedDialogCulture] = useState(null);
  const loadOverview = useCallback(async () => {
    try {
      const value2 = await ppp.getLocalizationOverviewAsync();
      setOverview(value2);
      setLoadError(void 0);
    } catch (reason) {
      setOverview(null);
      setLoadError(reason instanceof Error ? reason.message : String(reason));
    }
  }, [ppp]);
  useEffect(() => {
    void loadOverview();
  }, [loadOverview]);
  const onReload = useCallback(async () => {
    setIsReloading(true);
    setMessage(void 0);
    try {
      const result = await ppp.clearCacheAsync("StringLocalizer");
      if (result === null) {
        setMessage({ intent: "error", text: t("app.localization-admin.reload-not-found") });
        return;
      }
      if (!result.succeeded) {
        setMessage({
          intent: "error",
          text: t("app.localization-admin.reload-failed", [result.error ?? ""])
        });
        return;
      }
      await loadOverview();
      setMessage({
        intent: "success",
        text: t("app.localization-admin.reload-success", [toNumber2(result.elapsedMs)])
      });
    } catch (reason) {
      setMessage({
        intent: "error",
        text: t("app.localization-admin.reload-failed", [
          reason instanceof Error ? reason.message : String(reason)
        ])
      });
    } finally {
      setIsReloading(false);
    }
  }, [ppp, t, loadOverview]);
  const runDownload = useCallback(
    async (fetch2) => {
      setIsDownloading(true);
      setMessage(void 0);
      try {
        const download = await fetch2();
        if (download === null || download.data.length === 0) {
          setMessage({ intent: "warning", text: t("app.localization-admin.download-empty") });
          return;
        }
        downloadBytes(download.fileName, download.data);
      } catch (reason) {
        setMessage({
          intent: "error",
          text: t("app.localization-admin.download-failed", [
            reason instanceof Error ? reason.message : String(reason)
          ])
        });
      } finally {
        setIsDownloading(false);
      }
    },
    [t]
  );
  const onDownloadSource = useCallback(
    (sourceId, culture) => void runDownload(() => ppp.downloadLocalizationSourceAsync(sourceId, culture)),
    [ppp, runDownload]
  );
  const onDownloadMerged = useCallback(
    (culture) => void runDownload(() => ppp.downloadMergedLocalizationsAsync(culture)),
    [ppp, runDownload]
  );
  const availableCultures = useMemo(() => {
    if (!overview) return [];
    const set = /* @__PURE__ */ new Set();
    for (const load of overview.sourceLoads) for (const culture of load.cultures) set.add(culture);
    return [...set].sort((a, b) => a.localeCompare(b, void 0, { sensitivity: "base" }));
  }, [overview]);
  let content;
  if (loadError !== void 0) {
    content = /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.localization-admin.load-failed", [loadError]) }) });
  } else if (!overview) {
    content = /* @__PURE__ */ jsx(Spinner, {});
  } else {
    const config = overview.configuration;
    content = /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: styles.toolbar, children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "primary",
            disabled: isReloading,
            icon: isReloading ? /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) : /* @__PURE__ */ jsx(ArrowSyncRegular, {}),
            onClick: () => void onReload(),
            children: isReloading ? t("app.localization-admin.reloading") : t("app.localization-admin.reload")
          }
        ),
        overview.lastReloadedOn != null && /* @__PURE__ */ jsx("span", { className: styles.lastReloaded, children: t("app.localization-admin.last-reloaded", [
          new Date(overview.lastReloadedOn).toLocaleString(void 0, timeZone ? { timeZone } : {})
        ]) })
      ] }),
      message && /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: message.intent, children: /* @__PURE__ */ jsx(MessageBarBody, { children: message.text }) }),
      /* @__PURE__ */ jsx(Section, { headerText: t("app.localization-admin.configuration-title"), borderVisible: true, children: /* @__PURE__ */ jsx(SectionColumn, { children: /* @__PURE__ */ jsxs("div", { className: styles.sectionBody, children: [
        /* @__PURE__ */ jsx(Text, { children: t("app.localization-admin.configuration-description") }),
        /* @__PURE__ */ jsxs("dl", { className: mergeClasses("ppp-localization-admin-config", styles.configList), children: [
          /* @__PURE__ */ jsx(
            ConfigRow,
            {
              styles,
              label: t("app.localization-admin.config-tables"),
              value: config.tablesToLocalize.length > 0 ? config.tablesToLocalize.join(", ") : t("app.localization-admin.config-none")
            }
          ),
          /* @__PURE__ */ jsx(
            ConfigRow,
            {
              styles,
              label: t("app.localization-admin.config-publisher-prefixes"),
              value: config.tablePublisherPrefixesToLocalize.length > 0 ? config.tablePublisherPrefixesToLocalize.join(", ") : t("app.localization-admin.config-none")
            }
          ),
          /* @__PURE__ */ jsx(
            ConfigRow,
            {
              styles,
              label: t("app.localization-admin.config-web-resources"),
              value: config.webResourcePathPattern
            }
          ),
          /* @__PURE__ */ jsx("dt", { className: styles.configTerm, children: t("app.localization-admin.config-directories") }),
          /* @__PURE__ */ jsx("dd", { className: styles.configValue, children: config.localizationDirectories.length > 0 ? config.localizationDirectories.map((dir) => /* @__PURE__ */ jsx("div", { children: dir }, dir)) : t("app.localization-admin.config-none") }),
          config.localizationFiles.length > 0 && /* @__PURE__ */ jsx(
            ConfigRow,
            {
              styles,
              label: t("app.localization-admin.config-files"),
              value: config.localizationFiles.join(", ")
            }
          ),
          /* @__PURE__ */ jsx(
            ConfigRow,
            {
              styles,
              label: t("app.localization-admin.config-default-culture"),
              value: config.defaultCulture
            }
          )
        ] })
      ] }) }) }),
      /* @__PURE__ */ jsx(LocalizationTranslator, {}),
      availableCultures.length > 0 && /* @__PURE__ */ jsx(Section, { headerText: t("app.localization-admin.download-merged-title"), borderVisible: true, children: /* @__PURE__ */ jsx(SectionColumn, { children: /* @__PURE__ */ jsxs("div", { className: styles.sectionBody, children: [
        /* @__PURE__ */ jsx(Text, { children: t("app.localization-admin.download-merged-description") }),
        /* @__PURE__ */ jsx("div", { className: styles.mergedButtons, children: availableCultures.map((culture) => /* @__PURE__ */ jsxs("div", { className: styles.mergedCulture, children: [
          /* @__PURE__ */ jsx("span", { className: styles.mergedCultureLabel, children: cultureLabel(culture) }),
          /* @__PURE__ */ jsx(
            Tooltip,
            {
              content: t("app.localization-admin.view-merged-tooltip", [
                cultureLabel(culture)
              ]),
              relationship: "label",
              children: /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "outline",
                  icon: /* @__PURE__ */ jsx(EyeRegular, {}),
                  onClick: () => setMergedDialogCulture(culture)
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(
            Tooltip,
            {
              content: t("app.localization-admin.download-merged-tooltip", [
                cultureLabel(culture)
              ]),
              relationship: "label",
              children: /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  disabled: isDownloading,
                  icon: /* @__PURE__ */ jsx(ArrowDownloadRegular, {}),
                  onClick: () => onDownloadMerged(culture)
                }
              )
            }
          )
        ] }, culture)) })
      ] }) }) }),
      /* @__PURE__ */ jsx(Section, { headerText: t("app.localization-admin.sources-title"), borderVisible: true, children: /* @__PURE__ */ jsx(SectionColumn, { children: /* @__PURE__ */ jsxs("div", { className: styles.sectionBody, children: [
        /* @__PURE__ */ jsx(Text, { children: t("app.localization-admin.sources-description") }),
        overview.sourceLoads.length === 0 ? /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "info", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.localization-admin.sources-empty") }) }) : /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-localization-admin-grid-scroll", styles.gridScroll), children: /* @__PURE__ */ jsxs(Table$1, { size: "small", "aria-label": t("app.localization-admin.sources-title"), children: [
          /* @__PURE__ */ jsx(TableHeader$1, { children: /* @__PURE__ */ jsxs(TableRow, { children: [
            /* @__PURE__ */ jsx(TableHeaderCell, { className: styles.orderCell, children: t("app.localization-admin.column-order") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-kind") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { className: styles.sourceCell, children: t("app.localization-admin.column-source") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-cultures") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-keys") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-overriding") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-duration") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-status") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-download") })
          ] }) }),
          /* @__PURE__ */ jsx(TableBody, { children: overview.sourceLoads.map((load) => /* @__PURE__ */ jsx(
            SourceRow,
            {
              load,
              styles,
              t,
              isDownloading,
              onDownloadSource
            },
            `${load.loadOrder}-${load.sourceId}`
          )) })
        ] }) })
      ] }) }) })
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-localization-admin", styles.root, className), children: [
    content,
    mergedDialogCulture !== null && /* @__PURE__ */ jsx(
      MergedSourcesDialog,
      {
        culture: mergedDialogCulture,
        label: cultureLabel(mergedDialogCulture),
        onClose: () => setMergedDialogCulture(null),
        onDownload: () => onDownloadMerged(mergedDialogCulture),
        isDownloading,
        ppp,
        t,
        styles
      }
    )
  ] });
}
function ConfigRow({ styles, label, value: value2 }) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("dt", { className: styles.configTerm, children: label }),
    /* @__PURE__ */ jsx("dd", { className: styles.configValue, children: value2 })
  ] });
}
function SourceRow({
  load,
  styles,
  t,
  isDownloading,
  onDownloadSource
}) {
  const kindKey = KIND_KEY[Number(load.kind)] ?? "tablemetadata";
  const statusValue = Number(load.status);
  const statusKey = STATUS_KEY[statusValue] ?? "loaded";
  const statusText = t(`app.localization-admin.status-${statusKey}`);
  const overriding = toNumber2(load.keysOverriding);
  return /* @__PURE__ */ jsxs(TableRow, { children: [
    /* @__PURE__ */ jsx(TableCell$1, { className: styles.orderCell, children: toNumber2(load.loadOrder) }),
    /* @__PURE__ */ jsx(TableCell$1, { children: t(`app.localization-admin.kind-${kindKey}`) }),
    /* @__PURE__ */ jsx(TableCell$1, { className: styles.sourceCell, children: load.displayName }),
    /* @__PURE__ */ jsx(TableCell$1, { children: load.cultures.length > 0 ? load.cultures.join(", ") : "\u2014" }),
    /* @__PURE__ */ jsx(TableCell$1, { className: styles.numericCell, children: toNumber2(load.keysContributed) }),
    /* @__PURE__ */ jsx(TableCell$1, { className: styles.numericCell, children: overriding > 0 ? /* @__PURE__ */ jsx("span", { className: styles.overriding, children: overriding }) : overriding }),
    /* @__PURE__ */ jsx(TableCell$1, { className: styles.numericCell, children: toNumber2(load.durationMs).toLocaleString() }),
    /* @__PURE__ */ jsx(TableCell$1, { children: statusValue === 1 && load.error ? /* @__PURE__ */ jsx(Tooltip, { content: load.error, relationship: "description", children: /* @__PURE__ */ jsx("span", { className: styles.failed, children: statusText }) }) : statusValue === 2 ? /* @__PURE__ */ jsx("span", { className: styles.skipped, children: statusText }) : statusText }),
    /* @__PURE__ */ jsx(TableCell$1, { children: load.cultures.length === 0 ? /* @__PURE__ */ jsx("span", { className: styles.skipped, children: "\u2014" }) : /* @__PURE__ */ jsx("div", { className: styles.downloadCell, children: load.cultures.map((culture) => /* @__PURE__ */ jsx(
      Tooltip,
      {
        content: t("app.localization-admin.download-source-tooltip", [culture]),
        relationship: "label",
        children: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            size: "small",
            disabled: isDownloading,
            icon: /* @__PURE__ */ jsx(ArrowDownloadRegular, {}),
            onClick: () => onDownloadSource(load.sourceId, culture),
            children: culture
          }
        )
      },
      culture
    )) }) })
  ] });
}
var MERGED_PAGE_SIZE = 100;
function MergedSourcesDialog({
  culture,
  label,
  onClose,
  onDownload,
  isDownloading,
  ppp,
  t,
  styles
}) {
  const [entries, setEntries] = useState(null);
  const [loadError, setLoadError] = useState();
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(0);
  const [sortState, setSortState] = useState({
    sortColumn: "key",
    sortDirection: "ascending"
  });
  useEffect(() => {
    let canceled = false;
    void (async () => {
      try {
        const value2 = await ppp.getMergedLocalizationEntriesAsync(culture);
        if (!canceled) {
          setEntries(value2);
          setLoadError(void 0);
        }
      } catch (reason) {
        if (!canceled) {
          setEntries(null);
          setLoadError(reason instanceof Error ? reason.message : String(reason));
        }
      }
    })();
    return () => {
      canceled = true;
    };
  }, [ppp, culture]);
  const columns = useMemo(
    () => [
      createTableColumn({
        columnId: "key",
        compare: (a, b) => a.key.localeCompare(b.key),
        renderHeaderCell: () => t("app.localization-admin.merged-column-key"),
        renderCell: (item) => item.key
      }),
      createTableColumn({
        columnId: "kind",
        compare: (a, b) => Number(a.sourceKind) - Number(b.sourceKind),
        renderHeaderCell: () => t("app.localization-admin.merged-column-kind"),
        renderCell: (item) => t(`app.localization-admin.kind-${kindKeyOf(item.sourceKind)}`)
      }),
      createTableColumn({
        columnId: "source",
        compare: (a, b) => a.sourceDisplayName.localeCompare(b.sourceDisplayName),
        renderHeaderCell: () => t("app.localization-admin.merged-column-source"),
        renderCell: (item) => item.sourceDisplayName
      }),
      createTableColumn({
        columnId: "value",
        compare: (a, b) => a.value.localeCompare(b.value),
        renderHeaderCell: () => t("app.localization-admin.merged-column-value"),
        renderCell: (item) => item.value
      })
    ],
    [t]
  );
  const filtered = useMemo(() => {
    if (!entries) return [];
    const q = filter.trim().toLowerCase();
    const base = q ? entries.filter(
      (e) => e.key.toLowerCase().includes(q) || e.value.toLowerCase().includes(q) || e.sourceDisplayName.toLowerCase().includes(q)
    ) : entries;
    return [...base];
  }, [entries, filter]);
  const sorted = useMemo(() => {
    const column = columns.find((c) => c.columnId === sortState.sortColumn);
    if (!column?.compare) return filtered;
    const sign = sortState.sortDirection === "ascending" ? 1 : -1;
    return [...filtered].sort((a, b) => sign * column.compare(a, b));
  }, [filtered, columns, sortState]);
  useEffect(() => {
    setPage(0);
  }, [filter, sortState]);
  const pageCount = Math.max(1, Math.ceil(sorted.length / MERGED_PAGE_SIZE));
  const currentPage = Math.min(page, pageCount - 1);
  const paged = sorted.slice(currentPage * MERGED_PAGE_SIZE, currentPage * MERGED_PAGE_SIZE + MERGED_PAGE_SIZE);
  const columnSizingOptions = useMemo(
    () => ({
      key: { minWidth: 200, defaultWidth: 320 },
      kind: { minWidth: 110, defaultWidth: 140 },
      source: { minWidth: 200, defaultWidth: 300 },
      value: { minWidth: 200, defaultWidth: 360 }
    }),
    []
  );
  return /* @__PURE__ */ jsx(Dialog, { open: true, onOpenChange: (_event, data) => !data.open && onClose(), children: /* @__PURE__ */ jsx(DialogSurface, { className: styles.dialogSurface, children: /* @__PURE__ */ jsxs(DialogBody, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: t("app.localization-admin.merged-dialog-title", [label]) }),
    /* @__PURE__ */ jsx(DialogContent, { children: loadError !== void 0 ? /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.localization-admin.merged-load-failed", [loadError]) }) }) : entries === null ? /* @__PURE__ */ jsx(Spinner, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: styles.dialogToolbar, children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            className: styles.filterInput,
            value: filter,
            onChange: (_event, data) => setFilter(data.value),
            contentBefore: /* @__PURE__ */ jsx(SearchRegular, {}),
            placeholder: t("app.localization-admin.merged-filter-placeholder")
          }
        ),
        /* @__PURE__ */ jsx("span", { className: styles.lastReloaded, children: t("app.localization-admin.merged-count", [sorted.length, entries.length]) }),
        /* @__PURE__ */ jsx("span", { className: styles.grow }),
        pageCount > 1 && /* @__PURE__ */ jsxs("span", { className: styles.pager, children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              size: "small",
              appearance: "subtle",
              disabled: currentPage === 0,
              onClick: () => setPage(currentPage - 1),
              children: t("app.localization-admin.merged-prev")
            }
          ),
          /* @__PURE__ */ jsx("span", { className: styles.lastReloaded, children: t("app.localization-admin.merged-page", [currentPage + 1, pageCount]) }),
          /* @__PURE__ */ jsx(
            Button,
            {
              size: "small",
              appearance: "subtle",
              disabled: currentPage >= pageCount - 1,
              onClick: () => setPage(currentPage + 1),
              children: t("app.localization-admin.merged-next")
            }
          )
        ] })
      ] }),
      sorted.length === 0 ? /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "info", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.localization-admin.merged-empty") }) }) : /* @__PURE__ */ jsx("div", { className: styles.dialogGrid, children: /* @__PURE__ */ jsxs(
        DataGrid,
        {
          items: paged,
          columns,
          sortable: true,
          resizableColumns: true,
          sortState,
          onSortChange: (_event, next) => setSortState(next),
          columnSizingOptions,
          getRowId: (item) => item.key,
          size: "small",
          children: [
            /* @__PURE__ */ jsx(DataGridHeader, { children: /* @__PURE__ */ jsx(DataGridRow, { children: ({ renderHeaderCell }) => /* @__PURE__ */ jsx(DataGridHeaderCell, { children: renderHeaderCell() }) }) }),
            /* @__PURE__ */ jsx(DataGridBody, { children: ({ item, rowId }) => /* @__PURE__ */ jsx(DataGridRow, { children: ({ renderCell }) => /* @__PURE__ */ jsx(DataGridCell, { className: styles.mergedCell, children: renderCell(item) }) }, rowId) })
          ]
        }
      ) })
    ] }) }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "primary",
          icon: /* @__PURE__ */ jsx(ArrowDownloadRegular, {}),
          disabled: isDownloading,
          onClick: onDownload,
          children: t("app.localization-admin.merged-download-button")
        }
      ),
      /* @__PURE__ */ jsx(Button, { appearance: "secondary", icon: /* @__PURE__ */ jsx(DismissRegular, {}), onClick: onClose, children: t("app.buttons.close.label") })
    ] })
  ] }) }) });
}
var useStyles40 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
    maxWidth: "760px"
  },
  individual: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS
  },
  cacheRow: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    flexWrap: "wrap"
  },
  cacheButton: { minWidth: "220px", flex: "0 0 auto" },
  muted: { color: tokens.colorNeutralForeground2, fontSize: tokens.fontSizeBase200 }
});
var toMs = (value2) => Number(value2);
function CacheAdmin({ className }) {
  const styles = useStyles40();
  const t = useT();
  const { ppp } = usePowerPortalsPro();
  const [cacheNames, setCacheNames] = useState([]);
  const [isClearingAll, setIsClearingAll] = useState(false);
  const [clearingName, setClearingName] = useState();
  const [message, setMessage] = useState();
  const isBusy = isClearingAll || clearingName !== void 0;
  const runWithOverlay = useRunWithOverlay();
  useEffect(() => {
    let canceled = false;
    runWithOverlay({ description: t("app.cache-admin.loading") }, () => ppp.getCacheNamesAsync()).then((names2) => {
      if (!canceled) {
        setCacheNames(
          [...names2].sort((a, b) => a.localeCompare(b, void 0, { sensitivity: "base" }))
        );
      }
    }).catch((reason) => {
      if (!canceled) {
        setMessage({
          intent: "warning",
          text: t("app.cache-admin.load-failed", [reason instanceof Error ? reason.message : String(reason)])
        });
      }
    });
    return () => {
      canceled = true;
    };
  }, [ppp, t, runWithOverlay]);
  const onClearAll = useCallback(async () => {
    setIsClearingAll(true);
    setMessage(void 0);
    try {
      const results = await ppp.clearAllCachesAsync();
      const failed = results.filter((r) => !r.succeeded);
      const totalMs = results.reduce((sum, r) => sum + toMs(r.elapsedMs), 0);
      if (failed.length === 0) {
        setMessage({ intent: "success", text: t("app.cache-admin.clear-all-success", [results.length, totalMs]) });
      } else {
        setMessage({
          intent: "warning",
          text: t("app.cache-admin.clear-all-partial", [
            results.length - failed.length,
            results.length,
            failed.length
          ])
        });
      }
    } catch (reason) {
      setMessage({
        intent: "error",
        text: t("app.cache-admin.clear-all-error", [reason instanceof Error ? reason.message : String(reason)])
      });
    } finally {
      setIsClearingAll(false);
    }
  }, [ppp, t]);
  const onClearOne = useCallback(
    async (name) => {
      setClearingName(name);
      setMessage(void 0);
      try {
        const result = await ppp.clearCacheAsync(name);
        if (result === null) {
          setMessage({ intent: "warning", text: t("app.cache-admin.clear-one-not-found", [name]) });
        } else if (result.succeeded) {
          setMessage({
            intent: "success",
            text: t("app.cache-admin.clear-one-success", [result.name, toMs(result.elapsedMs)])
          });
        } else {
          setMessage({
            intent: "error",
            text: t("app.cache-admin.clear-one-failed", [result.name, result.error ?? ""])
          });
        }
      } catch (reason) {
        setMessage({
          intent: "error",
          text: t("app.cache-admin.clear-all-error", [reason instanceof Error ? reason.message : String(reason)])
        });
      } finally {
        setClearingName(void 0);
      }
    },
    [ppp, t]
  );
  const rows = useMemo(
    () => cacheNames.map((name) => {
      const descKey = `app.cache-descriptions.${name}`;
      const desc = t(descKey);
      return { name, description: desc === descKey ? void 0 : desc };
    }),
    [cacheNames, t]
  );
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-cache-admin", styles.root, className), children: [
    /* @__PURE__ */ jsx(Title3, { children: t("app.cache-admin.title") }),
    /* @__PURE__ */ jsx(Text, { children: t("app.cache-admin.description") }),
    message && /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: message.intent, children: /* @__PURE__ */ jsx(MessageBarBody, { children: message.text }) }),
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "primary",
        disabled: isBusy,
        icon: isClearingAll ? /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) : /* @__PURE__ */ jsx(ArrowSyncRegular, {}),
        onClick: () => void onClearAll(),
        children: isClearingAll ? t("app.cache-admin.clear-all-running") : t("app.cache-admin.clear-all-button")
      }
    ) }),
    rows.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Divider, {}),
      /* @__PURE__ */ jsx(Title3, { children: t("app.cache-admin.clear-individual-title") }),
      /* @__PURE__ */ jsx(Text, { className: styles.muted, children: t("app.cache-admin.clear-individual-description") }),
      /* @__PURE__ */ jsx("div", { className: styles.individual, children: rows.map(({ name, description }) => {
        const isThisRunning = clearingName === name;
        return /* @__PURE__ */ jsxs("div", { className: styles.cacheRow, children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "outline",
              className: styles.cacheButton,
              disabled: isBusy,
              icon: isThisRunning ? /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) : /* @__PURE__ */ jsx(ArrowSyncRegular, {}),
              onClick: () => void onClearOne(name),
              children: isThisRunning ? t("app.cache-admin.clear-all-running") : name
            }
          ),
          description && /* @__PURE__ */ jsx(Text, { className: styles.muted, children: description })
        ] }, name);
      }) })
    ] }) : null
  ] });
}
var useStyles41 = makeStyles({
  list: {
    margin: 0,
    paddingLeft: tokens.spacingHorizontalXL,
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXXS
  }
});
function ValidationSummary({
  title,
  columns,
  className,
  style
}) {
  const styles = useStyles41();
  const t = useT();
  const validation = useValidationContext();
  const resolvedTitle = title === void 0 ? t("app.errors.form-validation-errors") : title;
  if (!validation) return null;
  const entries = columns ? Array.from(validation.errors.entries()).filter(([col]) => columns.includes(col)) : Array.from(validation.errors.entries());
  const items = entries.flatMap(
    ([col, errs]) => errs.map((message, idx) => ({ key: `${col}:${idx}`, message }))
  );
  if (items.length === 0) return null;
  return /* @__PURE__ */ jsx(
    MessageBar,
    {
      layout: "multiline",
      intent: "error",
      icon: /* @__PURE__ */ jsx(ErrorCircle20Regular, {}),
      className,
      style,
      children: /* @__PURE__ */ jsxs(MessageBarBody, { children: [
        resolvedTitle && /* @__PURE__ */ jsx(MessageBarTitle, { children: resolvedTitle }),
        /* @__PURE__ */ jsx("ul", { className: styles.list, children: items.map((item) => /* @__PURE__ */ jsx("li", { children: item.message }, item.key)) })
      ] })
    }
  );
}
function RefreshContextButton({
  disabled,
  onBeforeRefresh,
  onRefreshed,
  onError,
  label,
  appearance = "subtle"
}) {
  const ctx = useMainContext();
  const dialog = useDialogService();
  const warn = useWarnAboutUnsavedChanges();
  const runWithOverlay = useRunWithOverlay();
  const t = useT();
  const [refreshing, setRefreshing] = useState(false);
  const resolvedLabel = label ?? t("app.buttons.refresh.label");
  const handleClick = useCallback(async () => {
    if (!ctx) return;
    setRefreshing(true);
    try {
      if (onBeforeRefresh) await onBeforeRefresh();
      if (ctx.isDirty) {
        const proceed = await warn();
        if (!proceed) return;
      }
      await runWithOverlay(
        { description: t("app.messages.record-loading") },
        () => ctx.refreshAll()
      );
      if (onRefreshed) await onRefreshed();
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
          title: t("app.errors.generic-error")
        });
      }
    } finally {
      setRefreshing(false);
    }
  }, [ctx, dialog, warn, runWithOverlay, t, onBeforeRefresh, onRefreshed, onError]);
  const isDisabled = !ctx || refreshing || disabled === true;
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      className: "ppp-refresh-context-button",
      appearance,
      icon: /* @__PURE__ */ jsx(ArrowClockwise24Regular, {}),
      disabled: isDisabled,
      onClick: handleClick,
      children: resolvedLabel
    }
  );
}
function DeleteContextButton({
  disabled,
  onBeforeDelete,
  onDeleted,
  onError,
  label,
  appearance = "subtle"
}) {
  const { ppp } = usePowerPortalsPro();
  const ctx = useRecordContext();
  const dialog = useDialogService();
  const runWithOverlay = useRunWithOverlay();
  const t = useT();
  const [deleting, setDeleting] = useState(false);
  const resolvedLabel = label ?? t("app.buttons.delete.label");
  const record = ctx.record;
  const canDelete = record?.permissions !== void 0 && (record.permissions & TableSecurityPermission.Delete) === TableSecurityPermission.Delete;
  const handleClick = useCallback(async () => {
    if (!record || !canDelete || !record.id || !record.tableName) return;
    const recordTableName = record.tableName;
    const recordId = record.id;
    setDeleting(true);
    try {
      await ctx.runBeforeDelete();
      if (onBeforeDelete) await onBeforeDelete();
      const result = await dialog.showConfirmationAsync(
        t("app.messages.delete-record-confirmation"),
        {
          title: t("app.messages.delete-title"),
          primaryText: t("app.buttons.delete.label"),
          secondaryText: t("app.buttons.cancel.label")
        }
      );
      if (result.canceled) return;
      await runWithOverlay(
        { description: t("app.messages.deleting-record") },
        () => ppp.deleteRecordAsync(recordTableName, recordId)
      );
      if (onDeleted) {
        await onDeleted();
      } else {
        window.history.back();
      }
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
          title: t("app.errors.record-delete")
        });
      }
    } finally {
      setDeleting(false);
    }
  }, [ppp, ctx, record, canDelete, dialog, runWithOverlay, t, onBeforeDelete, onDeleted, onError]);
  const isDisabled = !record || !canDelete || deleting || disabled === true;
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      className: "ppp-delete-context-button",
      appearance,
      icon: /* @__PURE__ */ jsx(Delete24Regular, {}),
      disabled: isDisabled,
      onClick: handleClick,
      children: resolvedLabel
    }
  );
}
var activeAndInactiveMove = (activates) => ({
  componentName: activates ? "ActivateRecordButton" : "DeactivateRecordButton",
  key: activates ? "activate" : "deactivate",
  className: activates ? "ppp-activate-record-button" : "ppp-deactivate-record-button",
  icon: activates ? () => /* @__PURE__ */ jsx(CheckmarkCircle24Regular, {}) : () => /* @__PURE__ */ jsx(Prohibited24Regular, {}),
  states: (states) => {
    const both = getActiveAndInactive(states);
    if (!both) return void 0;
    return activates ? { to: both.active.value, from: [both.inactive.value] } : { to: both.inactive.value, from: [both.active.value] };
  }
});
var ACTIVATE = activeAndInactiveMove(true);
var DEACTIVATE = activeAndInactiveMove(false);
var REOPEN_OPPORTUNITY = {
  componentName: "ReopenOpportunityButton",
  key: "reopen-opportunity",
  className: "ppp-reopen-opportunity-button",
  icon: () => /* @__PURE__ */ jsx(ArrowCounterclockwise24Regular, {}),
  table: "opportunity",
  // Open, from Won or Lost.
  states: () => ({ to: 0, from: [1, 2] })
};
var REACTIVATE_CASE = {
  componentName: "ReactivateCaseButton",
  key: "reactivate-case",
  className: "ppp-reactivate-case-button",
  icon: () => /* @__PURE__ */ jsx(ArrowCounterclockwise24Regular, {}),
  table: "incident",
  // Active, from Resolved or Canceled.
  states: () => ({ to: 0, from: [1, 2] })
};
var CANCEL_CASE = {
  componentName: "CancelCaseButton",
  key: "cancel-case",
  className: "ppp-cancel-case-button",
  icon: () => /* @__PURE__ */ jsx(Prohibited24Regular, {}),
  table: "incident",
  // Canceled, from Active.
  states: () => ({ to: 2, from: [0] })
};
var ACTIVATE_QUOTE = {
  componentName: "ActivateQuoteButton",
  key: "activate-quote",
  className: "ppp-activate-quote-button",
  icon: () => /* @__PURE__ */ jsx(DocumentCheckmark24Regular, {}),
  table: "quote",
  // Active, from Draft.
  states: () => ({ to: 1, from: [0] })
};
var SUBMIT_ORDER = {
  componentName: "SubmitOrderButton",
  key: "submit-order",
  className: "ppp-submit-order-button",
  icon: () => /* @__PURE__ */ jsx(Send24Regular, {}),
  table: "salesorder",
  // Submitted, from Active.
  states: () => ({ to: 1, from: [0] })
};
function ActivateRecordButton(props) {
  return /* @__PURE__ */ jsx(RecordStatusButton, { ...props, move: ACTIVATE });
}
function DeactivateRecordButton(props) {
  return /* @__PURE__ */ jsx(RecordStatusButton, { ...props, move: DEACTIVATE });
}
function ReopenOpportunityButton(props) {
  return /* @__PURE__ */ jsx(RecordStatusButton, { ...props, move: REOPEN_OPPORTUNITY });
}
function ReactivateCaseButton(props) {
  return /* @__PURE__ */ jsx(RecordStatusButton, { ...props, move: REACTIVATE_CASE });
}
function CancelCaseButton(props) {
  return /* @__PURE__ */ jsx(RecordStatusButton, { ...props, move: CANCEL_CASE });
}
function ActivateQuoteButton(props) {
  return /* @__PURE__ */ jsx(RecordStatusButton, { ...props, move: ACTIVATE_QUOTE });
}
function SubmitOrderButton(props) {
  return /* @__PURE__ */ jsx(RecordStatusButton, { ...props, move: SUBMIT_ORDER });
}
function RecordStatusButton({
  move,
  disabled,
  onError,
  label,
  appearance = "subtle"
}) {
  const { ppp } = usePowerPortalsPro();
  const ctx = useRecordContext();
  const main = useMainContext();
  const validation = useValidationContext();
  const dialog = useDialogService();
  const runWithOverlay = useRunWithOverlay();
  const t = useT();
  const [busy, setBusy] = useState(false);
  const { key: key3 } = move;
  const resolvedLabel = label ?? t(`app.buttons.${key3}.label`);
  const { record, tableMetadata } = ctx;
  const states = getStateColumn(tableMetadata, "state");
  const reasons = getStateColumn(tableMetadata, "status");
  const tableName = record?.tableName ?? tableMetadata?.tableName;
  if (move.table && tableName && tableName.toLowerCase() !== move.table) {
    throw new Error(`${move.componentName} works on the table '${move.table}', and this record is of '${tableName}'.`);
  }
  const target = tableMetadata ? move.states(states) : void 0;
  if (tableMetadata && (!target || !reasons)) {
    throw new Error(
      move.table ? `${move.componentName} changes a record's status reason, and '${tableMetadata.tableName}' has no status reason column.` : `${move.componentName} works on a table whose only states are Active and Inactive, and '${tableMetadata.tableName}' has ` + (states ? `the states ${states.choices.map((x) => x.invariantName).join(", ")}.` : "no state column.")
    );
  }
  const to = target?.to;
  const offered = to !== void 0 && reasons ? stateReasonsOf(to, states, reasons) : [];
  const canChange = !!record && !!states && !!reasons && offered.length > 0 && ((record.permissions ?? 0) & TableSecurityPermission.Write) === TableSecurityPermission.Write && canWriteColumn(record, states.columnName) && canWriteColumn(record, reasons.columnName);
  const handleClick = useCallback(async () => {
    if (!record?.id || !states || !reasons || to === void 0 || offered.length === 0) return;
    let reason;
    if (offered.length === 1) {
      const confirmation = await dialog.showConfirmationAsync(t(`app.messages.${key3}-record-confirmation`), {
        title: t(`app.messages.${key3}-title`),
        primaryText: resolvedLabel,
        secondaryText: t("app.buttons.cancel.label")
      });
      if (confirmation.canceled) return;
      reason = offered[0].value;
    } else {
      const choice2 = await dialog.showDialogAsync(
        (handle) => /* @__PURE__ */ jsx(
          StatusReasonPicker,
          {
            handle,
            label: t(`tables.${record.tableName}.columns.${reasons.columnName}.label`),
            offered,
            initial: states.choices.find((x) => x.value === to)?.defaultStatus ?? void 0,
            labelOf: (x) => resolveChoiceLabel(t, record.tableName, reasons.columnName, reasons.choiceLogicalName ?? "", x.value, x.displayName ?? "")
          }
        ),
        {
          title: t(`app.messages.${key3}-title`),
          primaryText: resolvedLabel,
          secondaryText: t("app.buttons.cancel.label")
        }
      );
      if (choice2.canceled) return;
      reason = choice2.data;
    }
    if (reason === void 0 || reason === null) return;
    setBusy(true);
    let title = "app.errors.record-save";
    try {
      if (ctx.isDirty) {
        if (main?.forceSuccessfulValidationBeforeSave && validation && !await validation.validateAll()) return;
        await runWithOverlay({ description: t("app.messages.record-save") }, () => ctx.save());
      }
      title = "app.errors.record-status-change";
      const change = {
        tableName: record.tableName,
        id: record.id,
        properties: {
          [states.columnName]: { $type: 11, value: to },
          [reasons.columnName]: { $type: 11, value: reason }
        }
      };
      await runWithOverlay(
        { description: t("app.messages.record-status-changing") },
        () => ppp.updateRecordAsync(change)
      );
      await ctx.reload();
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), { title: t(title) });
      }
    } finally {
      setBusy(false);
    }
  }, [record, states, reasons, to, dialog, t, key3, resolvedLabel, ctx, main, validation, runWithOverlay, ppp, onError]);
  if (!record || isNewRecord(record) || !canChange || !states || !target) return null;
  const current = heldChoiceValue(record, states.columnName);
  if (current === void 0 || !target.from.includes(current)) return null;
  if (stateChangeOf(states, current, target.to).kind !== StateChangeKind.Update) return null;
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      className: move.className,
      appearance,
      icon: move.icon(),
      disabled: busy || disabled === true,
      onClick: handleClick,
      children: resolvedLabel
    }
  );
}
function StatusReasonPicker({
  handle,
  label,
  offered,
  initial,
  labelOf
}) {
  const [selected, setSelected] = useState(
    offered.some((x) => x.value === initial) ? initial : offered[0]?.value
  );
  handle.onPrimary(async () => selected);
  return /* @__PURE__ */ jsx(Field, { label, children: /* @__PURE__ */ jsx(RadioGroup, { value: selected === void 0 ? "" : String(selected), onChange: (_, data) => setSelected(Number(data.value)), children: offered.map((reason) => /* @__PURE__ */ jsx(Radio, { value: String(reason.value), label: labelOf(reason) }, reason.value)) }) });
}
function WinOpportunityButton(props) {
  return /* @__PURE__ */ jsx(CloseRecordButton, { ...props, action: CloseRecordAction.Win });
}
function LoseOpportunityButton(props) {
  return /* @__PURE__ */ jsx(CloseRecordButton, { ...props, action: CloseRecordAction.Lose });
}
function ResolveCaseButton(props) {
  return /* @__PURE__ */ jsx(CloseRecordButton, { ...props, action: CloseRecordAction.Resolve });
}
function WinQuoteButton(props) {
  return /* @__PURE__ */ jsx(CloseRecordButton, { ...props, action: CloseRecordAction.WinQuote });
}
function CloseQuoteButton(props) {
  return /* @__PURE__ */ jsx(CloseRecordButton, { ...props, action: CloseRecordAction.CloseQuote });
}
function FulfillOrderButton(props) {
  return /* @__PURE__ */ jsx(CloseRecordButton, { ...props, action: CloseRecordAction.FulfillOrder });
}
function CancelOrderButton(props) {
  return /* @__PURE__ */ jsx(CloseRecordButton, { ...props, action: CloseRecordAction.CancelOrder });
}
var componentNames = {
  [CloseRecordAction.Win]: "WinOpportunityButton",
  [CloseRecordAction.Lose]: "LoseOpportunityButton",
  [CloseRecordAction.Resolve]: "ResolveCaseButton",
  [CloseRecordAction.WinQuote]: "WinQuoteButton",
  [CloseRecordAction.CloseQuote]: "CloseQuoteButton",
  [CloseRecordAction.FulfillOrder]: "FulfillOrderButton",
  [CloseRecordAction.CancelOrder]: "CancelOrderButton"
};
var icons = {
  [CloseRecordAction.Win]: () => /* @__PURE__ */ jsx(Trophy24Regular, {}),
  [CloseRecordAction.Lose]: () => /* @__PURE__ */ jsx(DismissCircle24Regular, {}),
  [CloseRecordAction.Resolve]: () => /* @__PURE__ */ jsx(CheckmarkCircle24Regular, {}),
  [CloseRecordAction.WinQuote]: () => /* @__PURE__ */ jsx(Trophy24Regular, {}),
  [CloseRecordAction.CloseQuote]: () => /* @__PURE__ */ jsx(DocumentDismiss24Regular, {}),
  [CloseRecordAction.FulfillOrder]: () => /* @__PURE__ */ jsx(BoxCheckmark24Regular, {}),
  [CloseRecordAction.CancelOrder]: () => /* @__PURE__ */ jsx(BoxDismiss24Regular, {})
};
function CloseRecordButton({
  action,
  disabled,
  onError,
  label,
  appearance = "subtle"
}) {
  const ctx = useRecordContext();
  const main = useMainContext();
  const validation = useValidationContext();
  const dialog = useDialogService();
  const closeRecordDialog = useCloseRecordDialog();
  const runWithOverlay = useRunWithOverlay();
  const t = useT();
  const [busy, setBusy] = useState(false);
  const key3 = closeRecordButtonKey(action);
  const resolvedLabel = label ?? t(`app.buttons.${key3}.label`);
  const { record, tableMetadata } = ctx;
  const definition = closeRecordDefinition(action);
  const states = getStateColumn(tableMetadata, "state");
  const reasons = getStateColumn(tableMetadata, "status");
  const tableName = record?.tableName ?? tableMetadata?.tableName;
  if (tableName && tableName.toLowerCase() !== definition.table) {
    throw new Error(`${componentNames[action]} works on the table '${definition.table}', and this record is of '${tableName}'.`);
  }
  const canChange = !!record && !!states && !!reasons && closeReasonsFor(action, states, reasons).length > 0 && ((record.permissions ?? 0) & TableSecurityPermission.Write) === TableSecurityPermission.Write && canWriteColumn(record, states.columnName) && canWriteColumn(record, reasons.columnName);
  const handleClick = useCallback(async () => {
    if (!record?.id || !tableMetadata || !main) return;
    setBusy(true);
    try {
      const request = await closeRecordDialog({ record, tableMetadata, action });
      if (!request) return;
      if (ctx.isDirty && main.forceSuccessfulValidationBeforeSave && validation && !await validation.validateAll()) return;
      const unregister = main.registerDescendant({
        getRequests: () => [request],
        validate: () => true,
        refresh: async () => {
        },
        resetState: () => {
        },
        isDirty: () => true
      });
      try {
        await runWithOverlay({ description: t("app.messages.record-closing") }, () => ctx.save());
      } finally {
        unregister();
      }
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
          title: t("app.errors.record-status-change")
        });
      }
    } finally {
      setBusy(false);
    }
  }, [record, tableMetadata, closeRecordDialog, action, ctx, main, validation, runWithOverlay, t, onError, dialog]);
  if (!record || isNewRecord(record) || !canChange || !states) return null;
  const change = stateChangeOf(states, heldChoiceValue(record, states.columnName), definition.state);
  if (change.kind !== StateChangeKind.Close || change.action !== action) return null;
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      className: `ppp-${key3}-button`,
      appearance,
      icon: icons[action](),
      disabled: busy || disabled === true,
      onClick: handleClick,
      children: resolvedLabel
    }
  );
}
var OperationButtonBehavior = {
  /** The button isn't shown — the default, as the close and status buttons do. */
  Hide: "hide",
  /** The button is shown, disabled. */
  Disable: "disable"
};
function recordParameterValue(tableName, id) {
  return { $type: 6, tableName, value: id };
}
function isLookup(value2) {
  return !!value2 && value2.$type === 6 && typeof value2.value === "string";
}
var keyOf2 = (tableName, id) => `${tableName.toLowerCase()}:${id.toLowerCase()}`;
var noRecords = [];
function useOperationButton(props, records = noRecords) {
  const { operation, parameters, getParameters, recordParameter, confirmationMessage, busyMessage, onError } = props;
  const { ppp } = usePowerPortalsPro();
  const dialog = useDialogService();
  const t = useT();
  const access = useOperationAccess(operation);
  const [busy, setBusy] = useState(false);
  const [read2, setRead] = useState(/* @__PURE__ */ new Map());
  const reading = useRef(/* @__PURE__ */ new Set());
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const named = useMemo(() => {
    const list = Object.values(parameters ?? {}).filter(isLookup).map((x) => ({ tableName: x.tableName, id: x.value }));
    return [...list, ...records];
  }, [parameters, records]);
  useEffect(() => {
    for (const { tableName, id } of named) {
      const key3 = keyOf2(tableName, id);
      if (read2.has(key3) || reading.current.has(key3)) continue;
      reading.current.add(key3);
      (async () => {
        let permissions = null;
        try {
          const metadata = await ppp.retrieveTableMetadataAsync(tableName);
          const record = await ppp.retrieveRecordAsync(tableName, id, [metadata.primaryIdColumn]);
          permissions = record.permissions ?? 0;
        } catch {
        }
        reading.current.delete(key3);
        if (mounted.current) setRead((current) => current.has(key3) ? current : new Map(current).set(key3, permissions));
      })();
    }
  }, [ppp, named, read2]);
  const permissionsOfRecord = useCallback(
    (tableName, id) => read2.get(keyOf2(tableName, id)) ?? void 0,
    [read2]
  );
  const knownNames = useMemo(() => {
    const names2 = Object.keys(parameters ?? {});
    if (recordParameter && !names2.some((x) => x.toLowerCase() === recordParameter.toLowerCase())) names2.push(recordParameter);
    return names2;
  }, [parameters, recordParameter]);
  const allows = useCallback(
    (recordPermissions) => operationGrantsAllow(access.grants, knownNames, (name) => {
      if (recordParameter && name.toLowerCase() === recordParameter.toLowerCase()) return recordPermissions;
      const value2 = Object.entries(parameters ?? {}).find(([x]) => x.toLowerCase() === name.toLowerCase())?.[1];
      return isLookup(value2) ? permissionsOfRecord(value2.tableName, value2.value) : void 0;
    }),
    [access.grants, knownNames, recordParameter, parameters, permissionsOfRecord]
  );
  const gather = useCallback(async () => {
    if (confirmationMessage) {
      const answer = await dialog.showConfirmationAsync(confirmationMessage);
      if (answer.canceled) return null;
    }
    const gathered = getParameters ? await getParameters() : {};
    if (!gathered) return null;
    return { ...parameters ?? {}, ...gathered };
  }, [confirmationMessage, dialog, getParameters, parameters]);
  const requestOf = useCallback(
    (sent) => ({ requestName: operation, inputParameters: sent }),
    [operation]
  );
  const report = useCallback(
    async (err) => {
      if (err instanceof UnauthorizedAccessError || err instanceof PowerPortalsProError && err.status === 403) access.askAgain();
      if (onError) {
        await onError(err);
        return;
      }
      await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), { title: t("app.errors.operation-failed") });
    },
    [access, onError, dialog, t]
  );
  const busyText = busyMessage ?? t("app.messages.operation-running");
  return { ppp, t, access, busy, setBusy, allows, permissionsOfRecord, gather, requestOf, report, busyText };
}
function answerTo(operation, responses) {
  const name = operation.toLowerCase();
  return [...responses].reverse().find((x) => x.responseName?.toLowerCase() === name);
}
function completedOf(operation, responses) {
  const first = responses[0];
  return { operation, responses, outputs: first?.outputParameters ?? {} };
}
function OperationButton(props) {
  const {
    operation,
    record,
    refreshRecord = true,
    children,
    recordParameter,
    whenNotAllowed = OperationButtonBehavior.Hide,
    label,
    icon,
    tooltip,
    appearance = "subtle",
    disabled,
    onCompleted
  } = props;
  const ctx = useRecordContextOptional();
  const main = useMainContext();
  const validation = useValidationContext();
  const runWithOverlay = useRunWithOverlay();
  const referenced = useMemo(
    () => record?.id ? [{ tableName: record.tableName, id: record.id }] : [],
    [record?.tableName, record?.id]
  );
  const op = useOperationButton(props, referenced);
  const boundToForm = !!recordParameter && !record && !!ctx;
  const formRecord = boundToForm ? ctx?.record : void 0;
  const bound = record?.id ? { tableName: record.tableName, id: record.id } : formRecord && !isNewRecord(formRecord) && formRecord.id ? { tableName: formRecord.tableName, id: formRecord.id } : void 0;
  const boundPermissions = record?.id ? op.permissionsOfRecord(record.tableName, record.id) : bound ? formRecord?.permissions : void 0;
  const allowed = (!recordParameter || !!bound) && op.allows(boundPermissions);
  const { busy, setBusy, gather, requestOf, report, busyText, access, ppp, t } = op;
  const handleClick = useCallback(async () => {
    if (busy || !allowed) return;
    setBusy(true);
    try {
      const parameters = await gather();
      if (!parameters) return;
      if (recordParameter && bound) parameters[recordParameter] = recordParameterValue(bound.tableName, bound.id);
      const request = requestOf(parameters);
      if (boundToForm && ctx && main && !access.runsAlone) {
        if (ctx.isDirty && main.forceSuccessfulValidationBeforeSave && validation && !await validation.validateAll()) return;
        let sent = false;
        let answer;
        const unregister = main.registerDescendant({
          getRequests: () => [request],
          validate: () => true,
          refresh: async () => {
          },
          resetState: () => {
          },
          isDirty: () => true,
          saved: (responses2) => {
            sent = true;
            answer = answerTo(operation, responses2);
          }
        });
        try {
          await runWithOverlay({ description: busyText }, () => ctx.save());
        } finally {
          unregister();
        }
        if (sent) await onCompleted?.(completedOf(operation, answer ? [answer] : []));
        return;
      }
      if (boundToForm && ctx?.isDirty) {
        if (main?.forceSuccessfulValidationBeforeSave && validation && !await validation.validateAll()) return;
        await runWithOverlay({ description: t("app.messages.record-save") }, () => ctx.save());
      }
      const responses = await runWithOverlay({ description: busyText }, () => ppp.executeMultipleAsync([request]));
      if (boundToForm && refreshRecord) await ctx?.reload();
      await onCompleted?.(completedOf(operation, responses));
    } catch (err) {
      await report(err);
    } finally {
      setBusy(false);
    }
  }, [
    busy,
    allowed,
    setBusy,
    gather,
    recordParameter,
    bound,
    requestOf,
    boundToForm,
    ctx,
    main,
    access.runsAlone,
    validation,
    operation,
    runWithOverlay,
    busyText,
    onCompleted,
    t,
    ppp,
    refreshRecord,
    report
  ]);
  if (!allowed && whenNotAllowed === OperationButtonBehavior.Hide) return null;
  const iconProps = icon !== void 0 ? { icon } : {};
  const button = /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      className: "ppp-operation-button",
      appearance,
      ...iconProps,
      disabled: busy || disabled === true || !allowed,
      onClick: handleClick,
      children: children ?? label
    }
  );
  return tooltip ? /* @__PURE__ */ jsx(Tooltip, { content: tooltip, relationship: "label", children: button }) : button;
}

// src/buttons/grid-button-behavior.ts
var GridButtonBehavior = {
  /** Always shown / enabled regardless of selection. */
  Always: "always",
  /** Only when zero rows are selected (e.g. New / Link). */
  NoneSelected: "none-selected",
  /** Only when exactly one row is selected (e.g. single-record Edit / Navigate). */
  OnlyOneSelected: "only-one-selected",
  /** Only when two or more rows are selected (e.g. multi-edit, bulk delete). */
  MoreThanOneSelected: "more-than-one-selected",
  /** Whenever at least one row is selected (Delete / Unlink). */
  OneOrMoreSelected: "one-or-more-selected"
};
function evaluateGridButtonBehavior(behavior, selectionCount) {
  switch (behavior) {
    case GridButtonBehavior.Always:
      return true;
    case GridButtonBehavior.NoneSelected:
      return selectionCount === 0;
    case GridButtonBehavior.OnlyOneSelected:
      return selectionCount === 1;
    case GridButtonBehavior.MoreThanOneSelected:
      return selectionCount > 1;
    case GridButtonBehavior.OneOrMoreSelected:
      return selectionCount >= 1;
    default:
      return false;
  }
}
var GridButtonRole = {
  /**
   * Creates a new record. Receives the grid's pending-create
   * re-open dispatch when a row in `pendingRowCreates` is clicked,
   * so the user's in-progress new record is edited via the same
   * form/wizard it was created in.
   */
  Create: "create",
  /**
   * Opens an existing (server-persisted) record for read or edit.
   * Receives the grid's row-click dispatch for any row that carries
   * a real Dataverse id (not the `__pending-create-` prefix).
   */
  Open: "open",
  /** Deletes a record. */
  Delete: "delete",
  /**
   * Anything that doesn't fit the create/open/delete taxonomy
   * refresh, link/unlink, custom export, etc. The grid doesn't
   * dispatch row-level interactions to `'other'` buttons; they're
   * triggered exclusively by their own click handlers.
   */
  Other: "other"
};
var GRID_BUTTON_ROLE_MARKER = /* @__PURE__ */ Symbol.for("@powerportalspro/grid-button-role");
function setGridButtonRole(Component, role) {
  Component[GRID_BUTTON_ROLE_MARKER] = role;
}
function getGridButtonRoleFromElement(node) {
  if (!isValidElement(node)) return null;
  const props = node.props;
  const propRole = props?.gridButtonRole;
  if (propRole === GridButtonRole.Create || propRole === GridButtonRole.Open || propRole === GridButtonRole.Delete || propRole === GridButtonRole.Other) {
    return propRole;
  }
  const type = node.type;
  return type?.[GRID_BUTTON_ROLE_MARKER] ?? null;
}
function findFirstButtonOfRole(children, role) {
  let found = null;
  function visit(node) {
    if (found) return;
    Children.forEach(node, (child) => {
      if (found) return;
      if (!isValidElement(child)) return;
      const childRole = getGridButtonRoleFromElement(child);
      if (childRole === role) {
        found = child;
        return;
      }
      const props = child.props;
      if (props?.children !== void 0 && childRole === null) {
        visit(props.children);
      }
    });
  }
  visit(children);
  return found;
}
function useGridButtonAction(onError) {
  const grid = useGridContext();
  const [working, setWorking] = useState(false);
  const [, setRenderError] = useState();
  const run = useCallback(
    async (handler) => {
      setWorking(true);
      try {
        await handler(grid);
      } catch (err) {
        if (onError) {
          await onError(err);
        } else {
          setRenderError(() => {
            throw err;
          });
        }
      } finally {
        setWorking(false);
      }
    },
    [grid, onError]
  );
  return { grid, working, run };
}
function GridButton({
  onClick,
  label,
  icon,
  visibilityBehavior = GridButtonBehavior.Always,
  enabledBehavior = GridButtonBehavior.Always,
  disabled,
  tooltip,
  appearance = "subtle",
  onError
}) {
  const { grid, working, run } = useGridButtonAction(onError);
  const selectionCount = grid.selectedRecords.length;
  const handleClick = useCallback(() => run(onClick), [run, onClick]);
  if (!evaluateGridButtonBehavior(visibilityBehavior, selectionCount)) {
    return null;
  }
  const enabledBySelection = evaluateGridButtonBehavior(enabledBehavior, selectionCount);
  const isDisabled = disabled === true || working || !enabledBySelection;
  const iconProps = icon !== void 0 ? { icon } : {};
  const button = /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      className: "ppp-grid-button",
      appearance,
      ...iconProps,
      disabled: isDisabled,
      onClick: handleClick,
      children: label
    }
  );
  if (tooltip) {
    return /* @__PURE__ */ jsx(Tooltip, { content: tooltip, relationship: "label", children: button });
  }
  return button;
}
function OperationGridButton(props) {
  const {
    operation,
    recordParameter,
    whenNotAllowed = OperationButtonBehavior.Hide,
    visibilityBehavior,
    label,
    icon,
    tooltip,
    appearance,
    disabled,
    onCompleted
  } = props;
  const grid = useGridContext();
  const overlayService = useOverlayService();
  const op = useOperationButton(props);
  const { busy, setBusy, gather, requestOf, report, busyText, access, ppp, t, allows } = op;
  const behavior = visibilityBehavior ?? (recordParameter ? GridButtonBehavior.OneOrMoreSelected : GridButtonBehavior.Always);
  const shown = evaluateGridButtonBehavior(behavior, grid.selectedRecords.length) && (whenNotAllowed === OperationButtonBehavior.Disable || (access.grants?.length ?? 0) > 0);
  const enabled = recordParameter ? grid.selectedRecords.length > 0 && grid.selectedRecords.every((row) => !!row.id && !row.id.startsWith("__pending-create-") && allows(row.permissions)) : allows(void 0);
  const handleClick = useCallback(
    async (context) => {
      if (busy) return;
      setBusy(true);
      const responses = [];
      try {
        const rows = recordParameter ? context.selectedRecords.slice() : [];
        const shared = await gather();
        if (!shared) return;
        const requests = recordParameter ? rows.map((row) => requestOf({ ...shared, [recordParameter]: recordParameterValue(row.tableName, row.id) })) : [requestOf(shared)];
        const progress = createProgressOverlay(overlayService, context.overlayTargetId);
        try {
          if (!access.runsAlone) {
            progress.show(busyText);
            responses.push(...await ppp.executeMultipleAsync(requests));
          } else {
            for (let i = 0; i < requests.length; i++) {
              progress.show(requests.length > 1 ? t("app.messages.operation-progress", [i + 1, requests.length]) : busyText);
              responses.push(...await ppp.executeMultipleAsync([requests[i]]));
            }
          }
        } finally {
          progress.close();
        }
        await context.refresh();
        await onCompleted?.(completedOf(operation, responses));
      } catch (err) {
        await report(err);
        if (responses.length > 0) await context.refresh();
      } finally {
        setBusy(false);
      }
    },
    [busy, setBusy, recordParameter, gather, requestOf, overlayService, access.runsAlone, busyText, ppp, t, onCompleted, operation, report]
  );
  if (!shown) return null;
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label,
      ...icon !== void 0 && { icon },
      ...tooltip !== void 0 && { tooltip },
      ...appearance !== void 0 && { appearance },
      onClick: handleClick,
      disabled: disabled === true || busy || !enabled,
      onError: report
    }
  );
}
function GridSplitButton({
  onClick,
  items,
  label,
  icon,
  visibilityBehavior = GridButtonBehavior.Always,
  enabledBehavior = GridButtonBehavior.Always,
  disabled,
  tooltip,
  menuLabel,
  appearance = "subtle",
  onError
}) {
  const t = useT();
  const { grid, working, run } = useGridButtonAction(onError);
  const selectionCount = grid.selectedRecords.length;
  if (!evaluateGridButtonBehavior(visibilityBehavior, selectionCount)) {
    return null;
  }
  const isDisabled = disabled === true || working || !evaluateGridButtonBehavior(enabledBehavior, selectionCount);
  const iconProps = icon !== void 0 ? { icon } : {};
  return /* @__PURE__ */ jsxs(Menu, { positioning: "below-end", children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: (triggerProps) => {
      const button = /* @__PURE__ */ jsx(
        SplitButton,
        {
          className: "ppp-grid-split-button",
          appearance,
          ...iconProps,
          disabled: isDisabled,
          menuButton: {
            ...triggerProps,
            "aria-label": menuLabel ?? t("app.buttons.more-options.label")
          },
          primaryActionButton: { type: "button", onClick: () => run(onClick) },
          children: label
        }
      );
      return tooltip ? /* @__PURE__ */ jsx(Tooltip, { content: tooltip, relationship: "description", children: button }) : button;
    } }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: items.map((item, index) => /* @__PURE__ */ jsx(
      MenuItem,
      {
        ...item.icon !== void 0 && { icon: item.icon },
        disabled: isDisabled || item.disabled === true,
        onClick: () => run(item.onClick),
        children: item.label
      },
      index
    )) }) })
  ] });
}
function NavigateRecordGridButton({
  url,
  title,
  icon,
  buttonEnabledBehavior = GridButtonBehavior.Always,
  buttonVisibleBehavior = GridButtonBehavior.Always,
  enabled,
  onClick,
  onNavigate,
  appearance
}) {
  const grid = useGridContext();
  const selectionCount = grid.selectedRecords.length;
  const visible = useMemo(
    () => evaluateGridButtonBehavior(buttonVisibleBehavior, selectionCount),
    [buttonVisibleBehavior, selectionCount]
  );
  const behaviorEnabled = useMemo(
    () => evaluateGridButtonBehavior(buttonEnabledBehavior, selectionCount),
    [buttonEnabledBehavior, selectionCount]
  );
  const resolvedEnabled = enabled ?? behaviorEnabled;
  const handleClick = useCallback(async () => {
    const ids = grid.selectedRecords.map((r) => (r.id ?? "").replace(/[{}]/g, "")).filter((id) => id.length > 0).join(",");
    const seedUrl = url.replace(/\{0\}/g, ids);
    const context = {
      gridContext: grid,
      url: seedUrl
    };
    if (onClick) await onClick(context);
    if (!context.url) return;
    if (onNavigate) {
      onNavigate(context.url);
    } else {
      window.location.assign(context.url);
    }
  }, [grid, url, onClick, onNavigate]);
  if (!visible) return null;
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: title,
      onClick: handleClick,
      disabled: !resolvedEnabled,
      ...icon !== void 0 && { icon },
      ...appearance !== void 0 && { appearance }
    }
  );
}
setGridButtonRole(NavigateRecordGridButton, GridButtonRole.Other);
function RefreshGridButton({
  disabled,
  onBeforeRefresh,
  onRefreshed,
  onError,
  label,
  appearance
}) {
  const t = useT();
  const warnAboutUnsavedChanges = useWarnAboutUnsavedChanges();
  const resolvedLabel = label ?? t("app.buttons.refresh.label");
  const handleClick = useCallback(
    async (grid) => {
      if (grid.isDirty) {
        const proceed = await warnAboutUnsavedChanges();
        if (!proceed) return;
        grid.clearPendingRowUpdates();
      }
      if (onBeforeRefresh) await onBeforeRefresh();
      await grid.refresh();
      if (onRefreshed) await onRefreshed();
    },
    [warnAboutUnsavedChanges, onBeforeRefresh, onRefreshed]
  );
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: resolvedLabel,
      icon: /* @__PURE__ */ jsx(ArrowClockwise24Regular, {}),
      onClick: handleClick,
      ...appearance !== void 0 && { appearance },
      ...disabled !== void 0 && { disabled },
      ...onError !== void 0 && { onError }
    }
  );
}
var allFormats = Object.values(GridExportFormat);
function labelKey(format) {
  switch (format) {
    case GridExportFormat.Excel:
      return "app.buttons.export-to-excel.label";
    case GridExportFormat.Csv:
      return "app.buttons.export-to-csv.label";
    default:
      return "app.buttons.export.label";
  }
}
function defaultIcon(format) {
  return format === GridExportFormat.Csv ? /* @__PURE__ */ jsx(DocumentCsv20Regular, {}) : /* @__PURE__ */ jsx(DocumentTable20Regular, {});
}
function ExportGridButton({
  formats,
  label,
  icon,
  tooltip,
  appearance,
  disabled,
  onError
}) {
  const t = useT();
  const grid = useGridContext();
  const formatsKey = formats?.join(",") ?? "";
  const offered = useMemo(
    () => formats !== void 0 && formats.length > 0 ? [...new Set(formats)] : allFormats,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [formatsKey]
  );
  const first = offered[0] ?? GridExportFormat.Excel;
  const menuItems = useMemo(
    () => offered.length > 1 ? offered.map((format) => ({
      label: t(labelKey(format)),
      icon: defaultIcon(format),
      onClick: (context) => context.exportAsync(format)
    })) : [],
    [offered, t]
  );
  const common = {
    label: label ?? t(labelKey(first)),
    icon: icon ?? defaultIcon(first),
    onClick: (context) => context.exportAsync(first),
    disabled: disabled === true || !grid.canExport,
    ...tooltip !== void 0 && { tooltip },
    ...appearance !== void 0 && { appearance },
    ...onError !== void 0 && { onError }
  };
  return offered.length > 1 ? /* @__PURE__ */ jsx(GridSplitButton, { ...common, items: menuItems }) : /* @__PURE__ */ jsx(GridButton, { ...common });
}
function NavigateNewRecordGridButton({
  url,
  onClick,
  onNavigate,
  disabled,
  label,
  appearance
}) {
  const grid = useGridContext();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.new.label");
  const page = useRecordPage(grid.tableName ?? grid.viewTableName, { enabled: url === void 0 });
  const resolvedUrl = url ?? recordPageNewUrl(page) ?? (onClick ? "" : void 0);
  const sampledPermissions = grid.tablePermissions;
  const createDeniedByPermissions = sampledPermissions !== void 0 && (sampledPermissions & TableSecurityPermission.Create) !== TableSecurityPermission.Create;
  const isDisabled = disabled === true || grid.selectedRecords.length > 0 || createDeniedByPermissions;
  const handleClick = useCallback(async () => {
    if (resolvedUrl === void 0) return;
    const resolved = typeof resolvedUrl === "function" ? resolvedUrl(grid) : resolvedUrl;
    const context = {
      gridContext: grid,
      url: resolved
    };
    if (onClick) await onClick(context);
    if (!context.url) return;
    if (onNavigate) {
      onNavigate(context.url);
    } else {
      window.location.assign(context.url);
    }
  }, [resolvedUrl, onClick, onNavigate, grid]);
  if (resolvedUrl === void 0) return null;
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: resolvedLabel,
      icon: /* @__PURE__ */ jsx(Add20Regular, {}),
      onClick: handleClick,
      disabled: isDisabled,
      ...appearance !== void 0 && { appearance }
    }
  );
}
setGridButtonRole(NavigateNewRecordGridButton, GridButtonRole.Create);
function NavigateOpenRecordGridButton({
  urlFor,
  onClick,
  onNavigate,
  disabled,
  label,
  appearance
}) {
  const grid = useGridContext();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.open.label");
  const page = useRecordPage(grid.tableName ?? grid.viewTableName, { enabled: urlFor === void 0 });
  const resolvedUrlFor = useMemo(() => {
    if (urlFor) return (record) => urlFor(record, grid);
    if (page) return (record) => recordPageUrl(page, record.id ?? "");
    return onClick ? () => "" : void 0;
  }, [urlFor, grid, page, onClick]);
  const isDisabled = disabled === true || grid.selectedRecords.length !== 1;
  const navigateForRecord = useCallback(
    async (record) => {
      if (!resolvedUrlFor) return;
      const resolved = resolvedUrlFor(record);
      const context = {
        gridContext: grid,
        record,
        url: resolved
      };
      if (onClick) await onClick(context);
      if (!context.url) return;
      if (onNavigate) {
        onNavigate(context.url);
      } else {
        window.location.assign(context.url);
      }
    },
    [resolvedUrlFor, onClick, onNavigate, grid]
  );
  const { registerOpenHandler } = grid;
  const hasUrl = resolvedUrlFor !== void 0;
  useEffect(() => {
    if (!hasUrl) return void 0;
    return registerOpenHandler(navigateForRecord);
  }, [registerOpenHandler, navigateForRecord, hasUrl]);
  const handleClick = useCallback(() => {
    const record = grid.selectedRecords[0];
    if (!record) return;
    navigateForRecord(record);
  }, [grid, navigateForRecord]);
  if (!hasUrl) return null;
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: resolvedLabel,
      icon: /* @__PURE__ */ jsx(Edit20Regular, {}),
      onClick: handleClick,
      disabled: isDisabled,
      ...appearance !== void 0 && { appearance }
    }
  );
}
setGridButtonRole(NavigateOpenRecordGridButton, GridButtonRole.Open);
var useDialogStyles = makeStyles({
  // Loading state replaces the form entirely while the record fetch is in
  // flight — NOT a scrim over the form, because the per-column edit
  // components mount and run their validators on first render. If they
  // mount against an undefined record they immediately report
  // "required field empty" errors that flicker visible for the duration
  // of the load. Gating on `status === Success` keeps the form out of
  // the tree until there's a real record to bind to.
  loadingArea: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "160px",
    rowGap: tokens.spacingVerticalM
  }
});
function OpenRecordGridButton({
  children,
  behavior = "withGridContext",
  location = "center",
  enablePanelResizing = true,
  disabled,
  label,
  appearance,
  dialogTitle,
  onSaved,
  onError,
  forceSuccessfulValidationBeforeSave
}) {
  const grid = useGridContext();
  const t = useT();
  const resolvedLabel = label ?? (grid.selectedRecords.length > 1 ? t("app.buttons.edit.label") : t("app.buttons.open.label"));
  const [recordToEdit, setRecordToEdit] = useState(null);
  const [multiEditRecords, setMultiEditRecords] = useState(null);
  const selected = grid.selectedRecords[0];
  const isSelectedPendingCreate = !!selected?.id && selected.id.startsWith("__pending-create-");
  const anySelectedPendingCreate = grid.selectedRecords.some(
    (r) => !!r.id && r.id.startsWith("__pending-create-")
  );
  const hasReadOnAllSelected = grid.selectedRecords.length > 0 && grid.selectedRecords.every(
    (r) => !!r.id && !!r.tableName && !!r.permissions && (r.permissions & 1) === 1
  );
  const canOpenSelected = grid.selectedRecords.length === 1 ? isSelectedPendingCreate || !!selected?.id && !!selected?.tableName && !!selected?.permissions && (selected.permissions & 1) === 1 : hasReadOnAllSelected && !anySelectedPendingCreate;
  const isDisabled = disabled === true || grid.selectedRecords.length === 0 || !canOpenSelected;
  const openForSelected = useCallback(() => {
    if (grid.selectedRecords.length === 1 && selected) {
      if (isSelectedPendingCreate) {
        grid.dispatchOpen(selected);
        return;
      }
      setRecordToEdit(selected);
    } else if (grid.selectedRecords.length > 1) {
      setMultiEditRecords(grid.selectedRecords);
    }
  }, [grid, selected, isSelectedPendingCreate]);
  const openForRecord = useCallback((record) => {
    if (!record.id || !record.tableName) return;
    if (record.id.startsWith("__pending-create-")) return;
    setRecordToEdit(record);
  }, []);
  const closeDialog = useCallback(() => {
    setRecordToEdit(null);
    setMultiEditRecords(null);
  }, []);
  const validationOverride = forceSuccessfulValidationBeforeSave !== void 0 ? { forceSuccessfulValidationBeforeSave } : {};
  const multiEditTableName = multiEditRecords?.[0]?.tableName;
  const multiEditInitialRecord = useMemo(
    () => multiEditTableName ? { tableName: multiEditTableName } : void 0,
    [multiEditTableName]
  );
  const { registerOpenHandler } = grid;
  useEffect(() => {
    return registerOpenHandler(openForRecord);
  }, [registerOpenHandler, openForRecord]);
  const handleOpenChange = useCallback((nextOpen) => {
    if (!nextOpen) {
      setRecordToEdit(null);
      setMultiEditRecords(null);
    }
  }, []);
  const open = recordToEdit !== null || multiEditRecords !== null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      GridButton,
      {
        label: resolvedLabel,
        icon: /* @__PURE__ */ jsx(Edit20Regular, {}),
        onClick: openForSelected,
        visibilityBehavior: GridButtonBehavior.OneOrMoreSelected,
        disabled: isDisabled,
        ...appearance !== void 0 && { appearance }
      }
    ),
    open && recordToEdit?.id && recordToEdit.tableName && // Standard edit branch — RecordContext fetches the record from
    // the server and DialogInner routes the save through the normal
    // update queue OR immediate save flow.
    // Any already-queued dirty cols from a prior dialog session land
    // on RecordContext as `initialPendingChanges`. RecordContext seeds
    // `pendingChanges` with them after the server load — so
    // `loadedRecord` stays as the unmodified server fetch and
    // `pendingChanges` carries the work-in-progress. The crucial
    // property: when the user reverts a column back to the server
    // value in the dialog, `setColumnValue`'s baseline-match check
    // sees `loadedRecord[col]` and `newValue` collide and drops the
    // column from `pendingChanges`. Dialog Save then ships an empty
    // dirty set and the queue entry gets deleted — net-zero edits
    // resolve cleanly.
    // `OpenRecordGridButton.razor.cs` flow: load fresh, copy
    // `GetChangedProperties` over, `ResetState()` to mark clean.
    /* @__PURE__ */ jsx(
      RecordDialogShell,
      {
        open,
        onOpenChange: handleOpenChange,
        location,
        tableName: recordToEdit.tableName,
        enablePanelResizing,
        children: /* @__PURE__ */ jsx(
          RecordContext,
          {
            table: recordToEdit.tableName,
            id: recordToEdit.id,
            ...(() => {
              const queued = grid.pendingRowUpdates.get(recordToEdit.id);
              return queued ? { initialPendingChanges: queued.dirty } : {};
            })(),
            children: /* @__PURE__ */ jsx(
              DialogInner,
              {
                location,
                behavior,
                gridTableName: recordToEdit.tableName,
                gridRecordId: recordToEdit.id,
                dialogTitle,
                onClose: closeDialog,
                onSaved,
                onError,
                queueRowUpdate: grid.queueRowUpdate,
                gridRefresh: grid.refresh,
                ...validationOverride,
                children: typeof children === "function" ? children() : children
              }
            )
          }
        )
      }
    ),
    open && multiEditRecords && multiEditRecords.length > 0 && multiEditRecords[0]?.tableName && // Multi-edit branch — bound to an empty record (`tableName` only,
    // no id). RecordContext sees the missing id and enters create
    // mode, but DialogInner's `multiEditTargets` short-circuits the
    // standard save path: it extracts the dirty columns from the
    // form and broadcasts them to every target record via an
    // ExecuteMultiple batch (immediate mode) or N queueRowUpdate
    // calls (withGridContext mode). The empty `initialRecord` is
    // important — without it, RecordContext would synthesize one
    // and the form would start from server-supplied defaults that
    // we'd then accidentally write to every row.
    // `OpenRecordGridButton.razor.cs::EditButtonClicked` which
    // builds a bare `new TableRecord { TableName = ... }` for the
    // multi-select branch.
    /* @__PURE__ */ jsx(
      RecordDialogShell,
      {
        open,
        onOpenChange: handleOpenChange,
        location,
        tableName: multiEditRecords[0].tableName,
        enablePanelResizing,
        children: /* @__PURE__ */ jsx(
          RecordContext,
          {
            table: multiEditRecords[0].tableName,
            ...multiEditInitialRecord && { initialRecord: multiEditInitialRecord },
            children: /* @__PURE__ */ jsx(
              DialogInner,
              {
                location,
                behavior,
                gridTableName: multiEditRecords[0].tableName,
                gridRecordId: "",
                dialogTitle,
                onClose: closeDialog,
                onSaved,
                onError,
                queueRowUpdate: grid.queueRowUpdate,
                gridRefresh: grid.refresh,
                ...validationOverride,
                multiEditTargets: multiEditRecords,
                children: typeof children === "function" ? children() : children
              }
            )
          }
        )
      }
    )
  ] });
}
setGridButtonRole(OpenRecordGridButton, GridButtonRole.Open);
function DialogInner({
  children,
  location,
  behavior,
  gridTableName,
  gridRecordId,
  dialogTitle,
  onClose,
  onSaved,
  onError,
  queueRowUpdate,
  gridRefresh,
  multiEditTargets,
  forceSuccessfulValidationBeforeSave
}) {
  const ctx = useRecordContext();
  const innerMainContext = useMainContext();
  const validation = useValidationContext();
  const dialogSvc = useDialogService();
  const runWithOverlay = useRunWithOverlay();
  const { ppp } = usePowerPortalsPro();
  const t = useT();
  const styles = useDialogStyles();
  const [saving, setSaving] = useState(false);
  const isMultiEdit = !!multiEditTargets && multiEditTargets.length > 0;
  const enforceValidation = isMultiEdit ? false : forceSuccessfulValidationBeforeSave ?? innerMainContext?.forceSuccessfulValidationBeforeSave ?? true;
  const isRecordReady = ctx.status === QueryStatus.Success && ctx.record !== void 0;
  const primaryNameColumn = ctx.tableMetadata?.primaryNameColumn;
  const primaryNameValue = primaryNameColumn !== void 0 && primaryNameColumn !== null ? ctx.record?.properties?.[primaryNameColumn]?.value : void 0;
  const resolvedTitle = dialogTitle ?? (isMultiEdit ? t("app.messages.edit-multiple") : void 0) ?? primaryNameValue ?? t("app.buttons.open.label");
  const handleSave = useCallback(async () => {
    setSaving(true);
    let batchSent = false;
    const refreshGrid = () => gridRefresh().catch(() => void 0);
    try {
      if (enforceValidation && validation && !await validation.validateAll()) {
        return;
      }
      if (multiEditTargets && multiEditTargets.length > 0) {
        const dirty = /* @__PURE__ */ new Map();
        if (ctx.record) {
          for (const columnName of ctx.dirtyColumns) {
            const value2 = ctx.record.properties?.[columnName];
            dirty.set(columnName, value2 ?? null);
          }
        }
        if (dirty.size === 0) {
          if (onSaved) await onSaved();
          onClose();
          return;
        }
        if (behavior === "immediately") {
          await runWithOverlay(
            {
              description: multiEditTargets.length === 1 ? t("app.messages.record-save") : t("app.messages.updating-records")
            },
            async () => {
              const properties = {};
              for (const [col, val] of dirty) {
                if (val !== null) properties[col] = val;
              }
              const requests = multiEditTargets.map(
                (target) => ({
                  $type: "UpdateRequest",
                  record: {
                    tableName: target.tableName,
                    ...target.id !== void 0 && { id: target.id },
                    properties
                  }
                })
              );
              batchSent = true;
              await ppp.executeMultipleAsync(requests, { returnResponses: false });
            }
          );
          await refreshGrid();
        } else {
          for (const target of multiEditTargets) {
            if (!target.id || !target.tableName) continue;
            queueRowUpdate({
              tableName: target.tableName,
              recordId: target.id,
              dirty
            });
          }
        }
      } else if (behavior === "immediately") {
        await runWithOverlay(
          { description: t("app.messages.record-save") },
          () => ctx.save()
        );
        await refreshGrid();
      } else {
        const dirty = /* @__PURE__ */ new Map();
        if (ctx.record) {
          for (const columnName of ctx.dirtyColumns) {
            const value2 = ctx.record.properties?.[columnName];
            dirty.set(columnName, value2 ?? null);
          }
        }
        queueRowUpdate({
          tableName: gridTableName,
          recordId: gridRecordId,
          dirty
        });
      }
      if (onSaved) await onSaved();
      onClose();
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialogSvc.showErrorAsync(
          err instanceof Error ? err.message : String(err),
          { title: t("app.errors.record-save") }
        );
      }
      if (batchSent) await refreshGrid();
    } finally {
      setSaving(false);
    }
  }, [
    ctx,
    validation,
    behavior,
    runWithOverlay,
    t,
    dialogSvc,
    queueRowUpdate,
    gridRefresh,
    gridTableName,
    gridRecordId,
    onClose,
    onSaved,
    onError,
    multiEditTargets,
    isMultiEdit,
    enforceValidation,
    ppp
  ]);
  return /* @__PURE__ */ jsx(
    RecordDialogFrame,
    {
      location,
      title: resolvedTitle,
      actions: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: onClose, disabled: saving, children: t("app.buttons.cancel.label") }),
        /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "primary",
            onClick: handleSave,
            disabled: saving || !isRecordReady || !ctx.isDirty,
            children: t("app.buttons.save.label")
          }
        )
      ] }),
      children: isRecordReady ? children : /* @__PURE__ */ jsx("div", { className: styles.loadingArea, role: "status", "aria-live": "polite", children: /* @__PURE__ */ jsx(Spinner, { size: "large", label: t("app.messages.record-loading") }) })
    }
  );
}
var PAGE_MARKER = /* @__PURE__ */ Symbol.for("@powerportalspro/wizard-record-page");
function WizardRecordPage({
  children,
  forceSuccessfulValidationBeforeSave = true
}) {
  const validation = useValidationContext();
  const { handleStep } = useWizard();
  handleStep(async () => {
    if (!forceSuccessfulValidationBeforeSave || !validation) return;
    const isValid = await validation.validateAll();
    if (!isValid) {
      throw new Error("validation-failed");
    }
  });
  return /* @__PURE__ */ jsx(Fragment, { children });
}
WizardRecordPage[PAGE_MARKER] = true;
function isWizardRecordPageElement(node) {
  if (!isValidElement(node)) return false;
  const type = node.type;
  return !!type && type[PAGE_MARKER] === true;
}
var useStyles42 = makeStyles({
  shell: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    minHeight: 0,
    rowGap: tokens.spacingVerticalM
  },
  stepper: {
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    paddingBottom: tokens.spacingVerticalM,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`
  },
  stepperItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalXS,
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200
  },
  stepperItemActive: {
    color: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightSemibold
  },
  stepperItemCompleted: {
    color: tokens.colorNeutralForeground2
  },
  stepperDot: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: tokens.colorNeutralBackground3,
    color: "inherit"
  },
  stepperDotActive: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand
  },
  stepperDotCompleted: {
    backgroundColor: tokens.colorPaletteGreenBackground2,
    color: tokens.colorPaletteGreenForeground2
  },
  stepperSeparator: {
    flex: "1 1 auto",
    height: "1px",
    backgroundColor: tokens.colorNeutralStroke2
  },
  body: {
    flex: "1 1 auto",
    minHeight: 0,
    display: "flex",
    flexDirection: "column"
  },
  // One group on the right, Cancel first: the same Cancel-then-primary order as every other
  // dialog, so Cancel sits beside Next rather than across the dialog from it. The Blazor
  // WizardRecordForm lays its buttons out the same way.
  footer: {
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalM,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`
  }
});
function WizardRecordForm({
  children,
  table,
  id,
  initialRecord,
  loadedRecord,
  onCompleted,
  skipSave,
  onError,
  finishLabel,
  onCancel,
  cancelLabel,
  stepperVisibility = "hidden"
}) {
  const pageProps = useMemo(() => {
    const props = [];
    Children.forEach(children, (child) => {
      if (isWizardRecordPageElement(child)) {
        props.push({
          ...child.props.label !== void 0 && { label: child.props.label }
        });
      }
    });
    return props;
  }, [children]);
  const recordContextProps = {
    table,
    ...id !== void 0 && { id },
    ...initialRecord !== void 0 && { initialRecord },
    ...loadedRecord !== void 0 && { loadedRecord },
    children: null
  };
  return /* @__PURE__ */ jsx(RecordContext, { ...recordContextProps, children: /* @__PURE__ */ jsx(
    WizardRecordFormInner,
    {
      pageProps,
      ...onCompleted !== void 0 && { onCompleted },
      ...skipSave !== void 0 && { skipSave },
      ...onError !== void 0 && { onError },
      ...finishLabel !== void 0 && { finishLabel },
      ...onCancel !== void 0 && { onCancel },
      ...cancelLabel !== void 0 && { cancelLabel },
      stepperVisibility,
      isCreate: id === void 0 || id === "" || id === "00000000-0000-0000-0000-000000000000",
      children
    }
  ) });
}
function WizardRecordFormInner({
  children,
  pageProps,
  onCompleted,
  skipSave,
  onError,
  finishLabel,
  onCancel,
  cancelLabel,
  stepperVisibility,
  isCreate
}) {
  const styles = useStyles42();
  return /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-wizard-record-form", styles.shell), children: /* @__PURE__ */ jsx(
    Wizard,
    {
      wrapper: /* @__PURE__ */ jsx("div", { className: styles.body }),
      footer: /* @__PURE__ */ jsx(
        WizardFooter,
        {
          pageProps,
          stepperVisibility,
          isCreate,
          ...onCompleted !== void 0 && { onCompleted },
          ...skipSave !== void 0 && { skipSave },
          ...onError !== void 0 && { onError },
          ...finishLabel !== void 0 && { finishLabel },
          ...onCancel !== void 0 && { onCancel },
          ...cancelLabel !== void 0 && { cancelLabel }
        }
      ),
      children
    }
  ) });
}
function WizardFooter({
  pageProps,
  stepperVisibility,
  isCreate,
  onCompleted,
  skipSave,
  onError,
  finishLabel,
  onCancel,
  cancelLabel
}) {
  const styles = useStyles42();
  const t = useT();
  const recordContext = useRecordContext();
  const wizard = useWizard();
  const handleFinish = useCallback(async () => {
    try {
      if (!skipSave) {
        await recordContext.save();
      }
      if (onCompleted && recordContext.record) {
        await onCompleted(recordContext.record);
      }
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        console.error("[WizardRecordForm] save failed", err);
        throw err;
      }
    }
  }, [recordContext, skipSave, onCompleted, onError]);
  const resolvedFinishLabel = finishLabel ?? (isCreate ? t("app.buttons.create.label") : t("app.buttons.save.label"));
  const resolvedCancelLabel = cancelLabel ?? t("app.buttons.cancel.label");
  const previousLabel = t("app.buttons.previous.label");
  const nextLabel = t("app.buttons.next.label");
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    stepperVisibility === "visible" && pageProps.length > 0 && /* @__PURE__ */ jsx("div", { className: styles.stepper, children: pageProps.map((p, i) => {
      const isActive = i === wizard.activeStep;
      const isCompleted = i < wizard.activeStep;
      const itemClass = mergeClasses(
        styles.stepperItem,
        isActive && styles.stepperItemActive,
        isCompleted && styles.stepperItemCompleted
      );
      const dotClass = mergeClasses(
        styles.stepperDot,
        isActive && styles.stepperDotActive,
        isCompleted && styles.stepperDotCompleted
      );
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        i > 0 && /* @__PURE__ */ jsx("span", { className: styles.stepperSeparator, "aria-hidden": "true" }, `sep-${i}`),
        /* @__PURE__ */ jsxs("span", { className: itemClass, children: [
          /* @__PURE__ */ jsx("span", { className: dotClass, children: i + 1 }),
          p.label && /* @__PURE__ */ jsx("span", { children: p.label })
        ] }, i)
      ] });
    }) }),
    /* @__PURE__ */ jsxs("div", { className: styles.footer, children: [
      onCancel && /* @__PURE__ */ jsx(Button, { onClick: onCancel, disabled: wizard.isLoading, children: resolvedCancelLabel }),
      !wizard.isFirstStep && /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => {
            void wizard.previousStep();
          },
          disabled: wizard.isLoading,
          children: previousLabel
        }
      ),
      wizard.isLastStep ? /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "primary",
          onClick: () => {
            void handleFinish();
          },
          disabled: wizard.isLoading,
          ...wizard.isLoading && { icon: /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) },
          children: resolvedFinishLabel
        }
      ) : /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "primary",
          onClick: () => {
            void wizard.nextStep();
          },
          disabled: wizard.isLoading,
          ...wizard.isLoading && { icon: /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) },
          children: nextLabel
        }
      )
    ] })
  ] });
}
var useDialogStyles2 = makeStyles({
  loadingArea: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "160px",
    rowGap: tokens.spacingVerticalM
  }
});
function NewRecordGridButton({
  children,
  behavior = "withGridContext",
  location = "center",
  enablePanelResizing = true,
  disabled,
  label,
  appearance,
  dialogTitle,
  initialValues,
  onSaved,
  onError,
  forceSuccessfulValidationBeforeSave
}) {
  const grid = useGridContext();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.new.label");
  const sampledPermissions = grid.tablePermissions;
  const createDeniedByPermissions = sampledPermissions !== void 0 && (sampledPermissions & TableSecurityPermission.Create) !== TableSecurityPermission.Create;
  const isDisabled = disabled === true || createDeniedByPermissions;
  const [open, setOpen] = useState(false);
  const [reopenState, setReopenState] = useState(null);
  const openDialog = useCallback(() => {
    setReopenState(null);
    setOpen(true);
  }, []);
  const closeDialog = useCallback(() => {
    setOpen(false);
    setReopenState(null);
  }, []);
  const handleOpenChange = useCallback((nextOpen) => {
    setOpen(nextOpen);
    if (!nextOpen) setReopenState(null);
  }, []);
  const { registerCreateReopenHandler } = grid;
  const pendingRowCreatesRef = useRef(grid.pendingRowCreates);
  pendingRowCreatesRef.current = grid.pendingRowCreates;
  const handleReopen = useCallback(
    (_synthetic, queueIndex) => {
      const queued = pendingRowCreatesRef.current[queueIndex];
      if (!queued) return;
      setReopenState({ index: queueIndex, record: queued.record });
      setOpen(true);
    },
    []
  );
  useEffect(() => {
    return registerCreateReopenHandler(handleReopen);
  }, [registerCreateReopenHandler, handleReopen]);
  const tableName = grid.tableName ?? "";
  const parentTableMetadataQuery = useTableMetadata(
    grid.parentRecord?.tableName ?? "",
    { enabled: !!grid.parentRecord?.tableName }
  );
  const parentTableMetadata = parentTableMetadataQuery.data;
  const initialRecord = useMemo(() => {
    const properties = {};
    const parent = grid.parentRecord;
    const relationshipName = grid.relationshipName;
    const parentRefId = parent ? getRecordReferenceId(parent) : void 0;
    if (parentRefId && parent?.tableName && relationshipName && parentTableMetadata) {
      const oneToMany = parentTableMetadata.oneToMany?.find(
        (rel) => rel.relationshipName === relationshipName
      );
      if (oneToMany?.referencingTableColumn) {
        const parentPrimaryName = parentTableMetadata.primaryNameColumn;
        const parentName = parentPrimaryName && parent.properties ? parent.properties[parentPrimaryName]?.value ?? null : null;
        const fkValue = {
          $type: 6,
          tableName: parent.tableName,
          value: parentRefId,
          ...parentName !== null && { name: parentName }
        };
        properties[oneToMany.referencingTableColumn] = fkValue;
      }
    }
    if (initialValues) {
      for (const [col, val] of initialValues) {
        properties[col] = val;
      }
    }
    return { tableName, properties };
  }, [tableName, grid.parentRecord, grid.relationshipName, parentTableMetadata, initialValues]);
  const parentLink = useMemo(() => {
    const parent = grid.parentRecord;
    const relationshipName = grid.relationshipName;
    const parentRefId = parent ? getRecordReferenceId(parent) : void 0;
    if (!parentRefId || !parent?.tableName || !relationshipName) return void 0;
    if (!parentTableMetadata?.manyToMany?.some((rel) => rel.relationshipName === relationshipName)) {
      return void 0;
    }
    return {
      parent: { tableName: parent.tableName, id: parentRefId },
      relationshipName,
      role: grid.selfReferencingRole
    };
  }, [grid.parentRecord, grid.relationshipName, grid.selfReferencingRole, parentTableMetadata]);
  const resolvedChildren = typeof children === "function" ? children() : children;
  const isWizardMode = useMemo(() => {
    let found = false;
    Children.forEach(resolvedChildren, (child) => {
      if (isWizardRecordPageElement(child)) found = true;
    });
    return found;
  }, [resolvedChildren]);
  const effectiveInitialRecord = reopenState ? reopenState.record : initialRecord;
  const parentUnsaved = grid.parentRecord !== void 0 && !hasSavedId(grid.parentRecord);
  const effectiveBehavior = reopenState !== null || parentUnsaved ? "withGridContext" : behavior;
  const handleWizardCompleted = useCallback(
    async (record) => {
      try {
        if (reopenState !== null) {
          grid.updatePendingRowCreate(reopenState.index, { record });
        } else if (behavior === "withGridContext") {
          grid.queueRowCreate({ record });
        } else {
          await grid.refresh();
        }
        closeDialog();
        if (onSaved) await onSaved();
      } catch (err) {
        if (onError) await onError(err);
        else throw err;
      }
    },
    [reopenState, behavior, grid, closeDialog, onSaved, onError]
  );
  const dialogQueueRowCreate = useMemo(() => {
    if (reopenState === null) return grid.queueRowCreate;
    const idx = reopenState.index;
    return (create) => grid.updatePendingRowCreate(idx, create);
  }, [reopenState, grid.queueRowCreate, grid.updatePendingRowCreate]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      GridButton,
      {
        label: resolvedLabel,
        icon: /* @__PURE__ */ jsx(Add20Regular, {}),
        onClick: openDialog,
        disabled: isDisabled,
        ...appearance !== void 0 && { appearance }
      }
    ),
    open && tableName && /* @__PURE__ */ jsx(
      RecordDialogShell,
      {
        open,
        onOpenChange: handleOpenChange,
        location,
        tableName,
        enablePanelResizing,
        children: isWizardMode ? (
          // The wizard draws its own steps and buttons: the frame only gives it the
          // panel's scrolling body when it is in one.
          /* @__PURE__ */ jsx(RecordDialogFrame, { location, children: /* @__PURE__ */ jsx(
            WizardRecordForm,
            {
              table: tableName,
              initialRecord: effectiveInitialRecord,
              onCancel: closeDialog,
              onCompleted: handleWizardCompleted,
              skipSave: effectiveBehavior === "withGridContext",
              children: resolvedChildren
            }
          ) })
        ) : /* @__PURE__ */ jsx(RecordContext, { table: tableName, initialRecord: effectiveInitialRecord, children: /* @__PURE__ */ jsx(
          DialogInner2,
          {
            location,
            behavior: effectiveBehavior,
            dialogTitle,
            onClose: closeDialog,
            onSaved,
            onError,
            queueRowCreate: dialogQueueRowCreate,
            gridRefresh: grid.refresh,
            parentLink,
            ...forceSuccessfulValidationBeforeSave !== void 0 && {
              forceSuccessfulValidationBeforeSave
            },
            children: resolvedChildren
          }
        ) })
      }
    )
  ] });
}
setGridButtonRole(NewRecordGridButton, GridButtonRole.Create);
function DialogInner2({
  children,
  location,
  behavior,
  dialogTitle,
  onClose,
  onSaved,
  onError,
  queueRowCreate,
  gridRefresh,
  parentLink,
  forceSuccessfulValidationBeforeSave
}) {
  const ctx = useRecordContext();
  const innerMainContext = useMainContext();
  const validation = useValidationContext();
  const dialogSvc = useDialogService();
  const runWithOverlay = useRunWithOverlay();
  const t = useT();
  const styles = useDialogStyles2();
  const [saving, setSaving] = useState(false);
  const enforceValidation = forceSuccessfulValidationBeforeSave ?? innerMainContext?.forceSuccessfulValidationBeforeSave ?? true;
  const recordRef = useRef(ctx.record);
  recordRef.current = ctx.record;
  const registerLink = innerMainContext?.registerDescendant;
  useEffect(() => {
    if (behavior !== "immediately" || !parentLink || !registerLink) return void 0;
    return registerLink({
      getRequests: () => {
        const record = recordRef.current;
        const id = getRecordReferenceId(record);
        if (!record?.tableName || !id) return [];
        const link = {
          $type: "AssociateRequest",
          record: parentLink.parent,
          relationshipName: parentLink.relationshipName,
          ...parentLink.role !== void 0 && { role: parentLink.role },
          relatedRecords: [{ tableName: record.tableName, id }]
        };
        return [link];
      },
      validate: () => true,
      refresh: async () => {
      },
      resetState: () => {
      },
      isDirty: () => false
    });
  }, [behavior, parentLink, registerLink]);
  const isRecordReady = ctx.status === QueryStatus.Success && ctx.record !== void 0;
  const resolvedTitle = dialogTitle ?? t("app.buttons.new.label");
  const handleSave = useCallback(async () => {
    setSaving(true);
    try {
      if (enforceValidation && validation && !await validation.validateAll()) return;
      if (behavior === "immediately") {
        await runWithOverlay(
          { description: t("app.messages.creating-record") },
          () => ctx.save()
        );
        await gridRefresh();
      } else {
        if (ctx.record) {
          queueRowCreate({ record: ctx.record });
        }
      }
      if (onSaved) await onSaved();
      onClose();
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialogSvc.showErrorAsync(
          err instanceof Error ? err.message : String(err),
          { title: t("app.errors.create-record") }
        );
      }
    } finally {
      setSaving(false);
    }
  }, [
    ctx,
    validation,
    behavior,
    runWithOverlay,
    t,
    dialogSvc,
    queueRowCreate,
    gridRefresh,
    onClose,
    onSaved,
    onError,
    enforceValidation
  ]);
  return /* @__PURE__ */ jsx(
    RecordDialogFrame,
    {
      location,
      title: resolvedTitle,
      actions: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: onClose, disabled: saving, children: t("app.buttons.cancel.label") }),
        /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "primary",
            onClick: handleSave,
            disabled: saving || !isRecordReady || !ctx.isDirty,
            children: t("app.buttons.save.label")
          }
        )
      ] }),
      children: isRecordReady ? children : /* @__PURE__ */ jsx("div", { className: styles.loadingArea, role: "status", "aria-live": "polite", children: /* @__PURE__ */ jsx(Spinner, { size: "large", label: t("app.messages.record-loading") }) })
    }
  );
}
function DeleteRecordGridButton({
  disabled,
  onBeforeDelete,
  onDeleted,
  onError,
  label,
  appearance,
  mode = "individually",
  behavior = "withGridContext"
}) {
  const { ppp } = usePowerPortalsPro();
  const dialog = useDialogService();
  const overlayService = useOverlayService();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.delete.label");
  const handleClick = useCallback(
    async (grid) => {
      const selectionCount = grid.selectedRecords.length;
      if (selectionCount === 0) return;
      if (onBeforeDelete) await onBeforeDelete();
      const message = t("app.messages.delete-records-confirmation", [
        selectionCount
      ]);
      const result = await dialog.showConfirmationAsync(message, {
        title: t("app.messages.delete-title"),
        primaryText: t("app.buttons.delete.label"),
        secondaryText: t("app.buttons.cancel.label")
      });
      if (result.canceled) return;
      const targets = grid.selectedRecords.slice();
      const targetRefs = targets.filter((r) => r.id && r.tableName).map((r) => ({ tableName: r.tableName, id: r.id }));
      if (behavior === "withGridContext") {
        grid.queueRowDeletes(targetRefs);
        await grid.clearSelection();
      } else {
        const progress = createProgressOverlay(overlayService, grid.overlayTargetId);
        try {
          if (mode === "bulk") {
            progress.show(t("app.messages.deleting-records", [targetRefs.length]));
            const requests = targetRefs.map((ref) => ({
              $type: "DeleteRequest",
              record: ref
            }));
            if (requests.length > 0) {
              await ppp.executeMultipleAsync(requests, { returnResponses: false });
            }
          } else {
            for (const [index, ref] of targetRefs.entries()) {
              progress.show(
                t("app.messages.delete-records-progress", [index + 1, targetRefs.length])
              );
              await ppp.deleteRecordAsync(ref.tableName, ref.id);
            }
          }
          await grid.refresh();
        } finally {
          progress.close();
        }
      }
      if (onDeleted) {
        await onDeleted(
          targets.map((r) => ({
            ...r.tableName !== void 0 && { tableName: r.tableName },
            ...r.id !== void 0 && { id: r.id }
          }))
        );
      }
    },
    [ppp, dialog, overlayService, t, onBeforeDelete, onDeleted, mode, behavior]
  );
  const additionallyDisabled = usePermissionGate();
  const effectiveOnError = useCallback(
    async (err) => {
      if (onError) {
        await onError(err);
        return;
      }
      await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
        title: t("app.errors.record-delete")
      });
    },
    [dialog, t, onError]
  );
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: resolvedLabel,
      icon: /* @__PURE__ */ jsx(Delete20Regular, {}),
      onClick: handleClick,
      visibilityBehavior: GridButtonBehavior.OneOrMoreSelected,
      enabledBehavior: GridButtonBehavior.OneOrMoreSelected,
      disabled: disabled === true || additionallyDisabled,
      onError: effectiveOnError,
      ...appearance !== void 0 && { appearance }
    }
  );
}
function usePermissionGate() {
  const grid = useGridContext();
  return !grid.selectedRecords.every((r) => {
    if (r.id?.startsWith("__pending-create-")) return true;
    return ((r.permissions ?? 0) & TableSecurityPermission.Delete) === TableSecurityPermission.Delete;
  });
}
setGridButtonRole(DeleteRecordGridButton, GridButtonRole.Delete);
var LINKING = TableSecurityPermission.Append | TableSecurityPermission.AppendTo;
function isLinkingDenied(tablePermissions2, parentPermissions) {
  return deniesLinking(tablePermissions2) || deniesLinking(parentPermissions);
}
function deniesLinking(permissions) {
  return permissions !== void 0 && (permissions & LINKING) !== LINKING;
}
function useLinkingDenied() {
  const grid = useGridContext();
  const tablePermissions2 = useTablePermissions(grid.tableName ?? "", {
    enabled: grid.tablePermissions === void 0
  });
  const parentTableName = grid.parentRecord?.tableName ?? "";
  const parentPermissions = useTablePermissions(parentTableName);
  return isLinkingDenied(
    grid.tablePermissions ?? (grid.tableName ? tablePermissions2.data : void 0),
    parentTableName ? parentPermissions.data : void 0
  );
}
function LinkExistingRecordGridButton({
  behavior = "withGridContext",
  mode = "individually",
  disabled,
  label,
  appearance,
  dialogTitle,
  onLinked,
  onError
}) {
  const { ppp } = usePowerPortalsPro();
  const grid = useGridContext();
  const dialog = useDialogService();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.link-existing.label");
  const [open, setOpen] = useState(false);
  const [working, setWorking] = useState(false);
  const isSubGrid = !!grid.parentRecord && !!grid.relationshipName;
  const linkingDenied = useLinkingDenied();
  const isDisabled = disabled === true || working || !isSubGrid || linkingDenied;
  const parentRecord = grid.parentRecord;
  const relationshipName = grid.relationshipName;
  const selfReferencingRole = grid.selfReferencingRole;
  const dialogFilters = useMemo(() => {
    if (!parentRecord || !relationshipName) return void 0;
    if (!getRecordReferenceId(parentRecord)) return void 0;
    return [
      buildFilter(
        parentRecord,
        relationshipName,
        RelationshipFilterMode.ExcludeExistingRecords,
        selfReferencingRole
      )
    ];
  }, [parentRecord, relationshipName, selfReferencingRole]);
  const openDialog = useCallback(() => setOpen(true), []);
  const closeDialog = useCallback(() => setOpen(false), []);
  const handleAction = useCallback(
    async (selectedRecords) => {
      if (selectedRecords.length === 0) {
        closeDialog();
        return;
      }
      const parent = grid.parentRecord;
      const rel = grid.relationshipName;
      const parentRefId = parent ? getRecordReferenceId(parent) : void 0;
      if (!parentRefId || !parent?.tableName || !rel) {
        closeDialog();
        return;
      }
      const parentRef = {
        tableName: parent.tableName,
        id: parentRefId
      };
      setWorking(true);
      try {
        const existingIds = /* @__PURE__ */ new Set();
        for (const r of grid.pendingRowAssociates) {
          if (r.id) existingIds.add(r.id);
        }
        const pendingDisassociateIds = /* @__PURE__ */ new Set();
        for (const r of grid.pendingRowDisassociates) {
          if (r.id) pendingDisassociateIds.add(r.id);
        }
        for (const r of grid.loadedRecords) {
          if (r.id && !pendingDisassociateIds.has(r.id)) existingIds.add(r.id);
        }
        const linkable = [];
        for (const r of selectedRecords) {
          if (!r.id || !r.tableName) continue;
          if (existingIds.has(r.id)) continue;
          linkable.push(r);
        }
        if (linkable.length === 0) {
          closeDialog();
          return;
        }
        if (behavior === "withGridContext") {
          grid.queueRowAssociates(linkable);
        } else {
          const refs = linkable.map((r) => ({
            tableName: r.tableName,
            id: r.id
          }));
          const requests = [];
          if (mode === "bulk") {
            const req = {
              $type: "AssociateRequest",
              record: parentRef,
              relationshipName: rel,
              ...grid.selfReferencingRole !== void 0 && { role: grid.selfReferencingRole },
              relatedRecords: refs
            };
            requests.push(req);
          } else {
            for (const ref of refs) {
              const req = {
                $type: "AssociateRequest",
                record: parentRef,
                relationshipName: rel,
                ...grid.selfReferencingRole !== void 0 && { role: grid.selfReferencingRole },
                relatedRecords: [ref]
              };
              requests.push(req);
            }
          }
          await ppp.executeMultipleAsync(requests, { returnResponses: false });
          await grid.refresh();
        }
        closeDialog();
        if (onLinked) await onLinked(linkable);
      } catch (err) {
        if (onError) {
          await onError(err);
        } else {
          await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
            title: t("app.errors.linking-records")
          });
        }
      } finally {
        setWorking(false);
      }
    },
    [behavior, mode, grid, ppp, dialog, t, onLinked, onError, closeDialog]
  );
  const tableNameLabel = grid.tableName ? t(`tables.${grid.tableName}.label`) : "";
  const resolvedDialogTitle = dialogTitle ?? t("app.components.lookup-form.title", [tableNameLabel]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      GridButton,
      {
        label: resolvedLabel,
        icon: /* @__PURE__ */ jsx(LinkAdd20Regular, {}),
        onClick: openDialog,
        disabled: isDisabled,
        ...appearance !== void 0 && { appearance }
      }
    ),
    grid.tableName && /* @__PURE__ */ jsx(
      LookupDialog,
      {
        hidden: !open,
        onHiddenChange: (hidden) => {
          if (hidden) closeDialog();
        },
        title: resolvedDialogTitle,
        tableNames: [grid.tableName],
        selectionMode: "multiple",
        actionLabel: t("app.buttons.link.label"),
        onActionClicked: handleAction,
        ...dialogFilters !== void 0 && { filters: dialogFilters }
      }
    )
  ] });
}
function UnlinkExistingRecordGridButton({
  behavior = "withGridContext",
  mode = "individually",
  disabled,
  label,
  appearance,
  onUnlinked,
  onError
}) {
  const { ppp } = usePowerPortalsPro();
  const dialog = useDialogService();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.unlink.label");
  const gridForGate = useGridContext();
  const isSubGrid = !!gridForGate.parentRecord && !!gridForGate.relationshipName;
  const linkingDenied = useLinkingDenied();
  const handleClick = useCallback(
    async (grid) => {
      const selectionCount = grid.selectedRecords.length;
      if (selectionCount === 0) return;
      const parent = grid.parentRecord;
      const rel = grid.relationshipName;
      const parentRefId = parent ? getRecordReferenceId(parent) : void 0;
      if (!parentRefId || !parent?.tableName || !rel) return;
      const parentRef = {
        tableName: parent.tableName,
        id: parentRefId
      };
      const message = selectionCount === 1 ? t("app.messages.unlink-record-confirmation") : t("app.messages.unlink-records-confirmation", [selectionCount]);
      const result = await dialog.showConfirmationAsync(message, {
        title: t("app.messages.unlink-title"),
        primaryText: t("app.buttons.unlink.label"),
        secondaryText: t("app.buttons.cancel.label")
      });
      if (result.canceled) return;
      const refs = [];
      for (const r of grid.selectedRecords) {
        if (!r.id || !r.tableName) continue;
        refs.push({ tableName: r.tableName, id: r.id });
      }
      if (behavior === "withGridContext") {
        grid.queueRowDisassociates(refs);
      } else {
        const requests = [];
        if (mode === "bulk") {
          const req = {
            $type: "DisassociateRequest",
            record: parentRef,
            relationshipName: rel,
            ...grid.selfReferencingRole !== void 0 && { role: grid.selfReferencingRole },
            relatedRecords: refs
          };
          requests.push(req);
        } else {
          for (const ref of refs) {
            const req = {
              $type: "DisassociateRequest",
              record: parentRef,
              relationshipName: rel,
              ...grid.selfReferencingRole !== void 0 && { role: grid.selfReferencingRole },
              relatedRecords: [ref]
            };
            requests.push(req);
          }
        }
        await ppp.executeMultipleAsync(requests, { returnResponses: false });
        await grid.refresh();
      }
      if (onUnlinked) await onUnlinked(refs);
    },
    [behavior, mode, ppp, dialog, t, onUnlinked]
  );
  const effectiveOnError = useCallback(
    async (err) => {
      if (onError) {
        await onError(err);
        return;
      }
      await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
        title: t("app.errors.unlinking-records")
      });
    },
    [dialog, t, onError]
  );
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: resolvedLabel,
      icon: /* @__PURE__ */ jsx(LinkDismiss20Regular, {}),
      onClick: handleClick,
      visibilityBehavior: GridButtonBehavior.OneOrMoreSelected,
      enabledBehavior: GridButtonBehavior.OneOrMoreSelected,
      disabled: disabled === true || !isSubGrid || linkingDenied,
      onError: effectiveOnError,
      ...appearance !== void 0 && { appearance }
    }
  );
}
function SubGrid({
  relationshipName,
  selfReferencingRole,
  record: explicitRecord,
  className,
  ...mainGridProps
}) {
  const ctx = useRecordContextOptional();
  const parentRecord = explicitRecord ?? ctx?.record;
  const hasDataSource = mainGridProps.dataSource !== void 0;
  const parentRefId = parentRecord ? getRecordReferenceId(parentRecord) : void 0;
  const filters = useMemo(() => {
    if (hasDataSource) return null;
    if (!parentRecord?.tableName || !parentRefId) return null;
    return [
      {
        $type: "RelationshipFilter",
        parentRecord: { tableName: parentRecord.tableName, id: parentRefId },
        relationshipName,
        ...selfReferencingRole !== void 0 && { selfReferencingRole }
        // `mode` left at the server's default (IncludeExistingRecords)
        // — the SubGrid case wants "records currently related to this
        // parent." `ExcludeExistingRecords` is for the
        // ManyToManyLookupEdit autocomplete pool, not this surface.
      }
    ];
  }, [hasDataSource, parentRecord?.tableName, parentRefId, relationshipName, selfReferencingRole]);
  if (!parentRecord?.tableName || !parentRefId) return null;
  return /* @__PURE__ */ jsx(
    MainGrid,
    {
      ...mainGridProps,
      ...filters && { filters },
      parentRecord,
      relationshipName,
      ...selfReferencingRole !== void 0 && { selfReferencingRole },
      className: mergeClasses("ppp-sub-grid", className)
    }
  );
}

// src/grids/file-grid-helpers.ts
function ensureFileColumnInView(view, fileColumn) {
  const alreadyInColumns = view.columns.some((c) => c.columnName === fileColumn);
  const alreadyInFetchXml = fetchXmlHasAttribute(view.fetchXml, fileColumn);
  if (alreadyInColumns && alreadyInFetchXml) return view;
  const columns = alreadyInColumns ? view.columns : [...view.columns, { columnName: fileColumn, width: 250 }];
  const fetchXml = alreadyInFetchXml ? view.fetchXml : addFetchXmlAttribute(view.fetchXml, fileColumn);
  return { ...view, columns, fetchXml };
}
function fetchXmlHasAttribute(fetchXml, attributeName) {
  const doc = parseFetchXml7(fetchXml);
  if (!doc) return false;
  const entity = doc.querySelector("entity");
  if (!entity) return false;
  return Array.from(entity.children).some(
    (child) => child.tagName === "attribute" && child.getAttribute("name") === attributeName
  );
}
function addFetchXmlAttribute(fetchXml, attributeName) {
  const doc = parseFetchXml7(fetchXml);
  if (!doc) return fetchXml;
  const entity = doc.querySelector("entity");
  if (!entity) return fetchXml;
  const attr = doc.createElement("attribute");
  attr.setAttribute("name", attributeName);
  entity.appendChild(attr);
  return new XMLSerializer().serializeToString(doc);
}
function parseFetchXml7(fetchXml) {
  try {
    const doc = new DOMParser().parseFromString(fetchXml, "application/xml");
    if (doc.getElementsByTagName("parsererror").length > 0) return null;
    return doc;
  } catch {
    return null;
  }
}
function isExtensionAllowed(fileName, allowedExtensions) {
  if (!allowedExtensions || allowedExtensions.length === 0) return true;
  const ext = getFileExtension(fileName);
  if (!ext) return false;
  return allowedExtensions.map((x) => x.replace(/^\./, "").toLowerCase()).includes(ext);
}
function isExtensionBlocked(fileName, blockedExtensions) {
  return blockedExtensions.has(getFileExtension(fileName));
}
var useFileGridStyles = makeStyles({
  // Outer wrapper that receives the drag events. `position: relative`
  // anchors the dropzone overlay; full width matches the inner grid's
  // natural sizing.
  wrapper: {
    position: "relative",
    width: "100%",
    minWidth: 0
  },
  // Soft accent outline drawn while a drag is in progress. `outline`
  // (not `border`) is used so no extra layout space is taken, avoiding
  // a 2px jitter when the user crosses the grid boundary mid-drag.
  wrapperDragActive: {
    outlineWidth: "2px",
    outlineStyle: "dashed",
    outlineColor: tokens.colorBrandStroke1,
    outlineOffset: "-2px"
  },
  // Full-bleed translucent overlay shown only while dragging. The
  // overlay itself is `pointer-events: none` so the underlying drop
  // handlers on the wrapper still receive the events — the overlay
  // is purely visual feedback.
  dropZone: {
    position: "absolute",
    inset: 0,
    zIndex: 10,
    pointerEvents: "none",
    backgroundColor: tokens.colorBrandBackground2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase400
  },
  // Centered card inside the overlay — icon stacked above the prompt
  // text. Sits on a solid panel so the prompt is readable regardless
  // of the rows underneath.
  dropZoneInner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: tokens.spacingVerticalS,
    paddingTop: tokens.spacingVerticalL,
    paddingBottom: tokens.spacingVerticalL,
    paddingLeft: tokens.spacingHorizontalXXL,
    paddingRight: tokens.spacingHorizontalXXL,
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusMedium,
    boxShadow: tokens.shadow8,
    pointerEvents: "none"
  },
  // Hidden file inputs — kept in the DOM so the Upload / Replace
  // buttons can `.click()` them, but never visible. `display: none`
  // works fine here; Safari/Chrome both fire the OS picker correctly
  // from a programmatic click on a hidden input.
  hiddenInput: {
    display: "none"
  },
  // Full-bleed busy scrim shown while uploads / downloads / replace
  // operations are in flight. `position: absolute` over the wrapper
  // (which is `position: relative`) so the spinner pins above the
  // grid without scrolling with it. Above the dropzone overlay
  // (zIndex 10) so a slow upload after a drop is visible.
  busyOverlay: {
    position: "absolute",
    inset: 0,
    zIndex: 11,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: tokens.colorNeutralBackgroundAlpha
  }
});
function GridToolbarItems({ children, className, style }) {
  const styles = useMainGridStyles();
  return /* @__PURE__ */ jsx("div", { className: mergeClasses(styles.buttonsBar, className), style, children });
}
var DEFAULT_MAX_FILE_SIZE_BYTES = 128 * 1024 * 1024;
var MAX_FILES_PER_UPLOAD = 1e3;
function GridContextBridge({
  contextRef
}) {
  const ctx = useGridContext();
  contextRef.current = ctx;
  return null;
}
function FileGrid(props) {
  const {
    tableName,
    fileColumn,
    autoAddFileColumnIfMissingFromView = true,
    allowDownloadAll = true,
    maxFileSizeBytes = DEFAULT_MAX_FILE_SIZE_BYTES,
    allowedExtensions,
    onUploadRecordAsync,
    transformViewAsync,
    children,
    className,
    style,
    // Forwarded MainGrid props with FileGrid-friendly defaults.
    selectionMode = "multiple",
    selectFromEntireRow = true,
    pageSize = 50,
    ...forwardedMainGridProps
  } = props;
  const styles = useFileGridStyles();
  const t = useT();
  const dialog = useDialogService();
  const { ppp } = usePowerPortalsPro();
  const mainContext = useMainContext();
  const tableMetadata = useTableMetadata(tableName);
  const organizationSettings = useOrganizationSettings();
  const effectiveMaxFileSizeBytes = useMemo(() => {
    let cap = maxFileSizeBytes;
    const columnMeta = tableMetadata.data?.columns?.find(
      (c) => c.columnName === fileColumn
    );
    const columnMaxKb = columnMeta?.maxSizeInKB;
    if (columnMaxKb !== void 0 && columnMaxKb !== null) {
      const kb = typeof columnMaxKb === "string" ? Number(columnMaxKb) : columnMaxKb;
      if (Number.isFinite(kb) && kb > 0) {
        cap = Math.min(cap, kb * 1024);
      }
    }
    const envMaxRaw = organizationSettings.data?.maxUploadFileSizeInBytes;
    const envMax = typeof envMaxRaw === "string" ? Number(envMaxRaw) : envMaxRaw;
    if (typeof envMax === "number" && Number.isFinite(envMax) && envMax > 0) {
      cap = Math.min(cap, envMax);
    }
    return cap;
  }, [
    maxFileSizeBytes,
    tableMetadata.data,
    fileColumn,
    organizationSettings.data
  ]);
  const blockedExtensions = useMemo(() => {
    return new Set(organizationSettings.data?.blockedFileExtensions ?? []);
  }, [organizationSettings.data]);
  const uploadInputRef = useRef(null);
  const replaceInputRef = useRef(null);
  const gridContextRef = useRef(null);
  const dragDepthRef = useRef(0);
  const [dragActive, setDragActive] = useState(false);
  const [busy, setBusy] = useState(false);
  const overlayService = useOverlayService();
  const [busyShownOnGrid, setBusyShownOnGrid] = useState(false);
  useLayoutEffect(() => {
    const targetId = gridContextRef.current?.overlayTargetId;
    if (!busy || !overlayService || !targetId) return void 0;
    const overlay = overlayService.show({ targetId });
    setBusyShownOnGrid(true);
    return () => {
      overlayService.hide(overlay);
      setBusyShownOnGrid(false);
    };
  }, [busy, overlayService]);
  const replaceTargetRef = useRef(null);
  const accept = useMemo(() => {
    if (!allowedExtensions || allowedExtensions.length === 0) return void 0;
    return allowedExtensions.map((e) => e.startsWith(".") ? e : `.${e}`).join(",");
  }, [allowedExtensions]);
  const composedTransformViewAsync = useMemo(() => {
    if (!autoAddFileColumnIfMissingFromView && !transformViewAsync) return void 0;
    return async (view) => {
      const withFile = autoAddFileColumnIfMissingFromView ? ensureFileColumnInView(view, fileColumn) : view;
      return transformViewAsync ? await transformViewAsync(withFile) : withFile;
    };
  }, [autoAddFileColumnIfMissingFromView, fileColumn, transformViewAsync]);
  const showError = useCallback(
    (message, title) => {
      void dialog.showErrorAsync(message, title ? { title } : void 0);
    },
    [dialog]
  );
  const filterAndReportExtensions = useCallback(
    (files) => {
      const ok = [];
      for (const file of files) {
        if (file.size > effectiveMaxFileSizeBytes) {
          showError(
            t("app.components.file-grid.file-too-large", [
              file.name,
              file.size,
              effectiveMaxFileSizeBytes
            ])
          );
          continue;
        }
        if (isExtensionBlocked(file.name, blockedExtensions)) {
          showError(
            t("app.components.file-grid.extension-blocked", [
              file.name,
              getFileExtension(file.name)
            ])
          );
          continue;
        }
        if (!isExtensionAllowed(file.name, allowedExtensions)) {
          showError(
            t("app.components.file-grid.extension-not-allowed", [
              file.name,
              (allowedExtensions ?? []).join(", ")
            ])
          );
          continue;
        }
        ok.push(file);
      }
      return ok;
    },
    [
      allowedExtensions,
      blockedExtensions,
      effectiveMaxFileSizeBytes,
      showError,
      t
    ]
  );
  const buildDefaultUploadRecord = useCallback(
    (fileName, base64) => {
      const fileValue = {
        $type: "FileValue",
        fileName,
        id: EMPTY_GUID,
        value: base64
      };
      return {
        tableName,
        properties: { [fileColumn]: fileValue }
      };
    },
    [fileColumn, tableName]
  );
  const uploadFiles = useCallback(
    async (files) => {
      const grid = gridContextRef.current;
      const accepted = filterAndReportExtensions(files);
      if (accepted.length === 0) return;
      setBusy(true);
      try {
        const records = [];
        for (const { name, bytes } of accepted) {
          const base64 = bytesToBase642(bytes);
          const record = onUploadRecordAsync ? await onUploadRecordAsync(name, bytes) : buildDefaultUploadRecord(name, base64);
          records.push(record);
        }
        if (records.length === 0) return;
        if (mainContext) {
          for (const record of records) {
            grid?.queueRowCreate({ record });
          }
          await grid?.refresh();
        } else {
          for (const record of records) {
            await ppp.createRecordAsync(record);
          }
          await grid?.refresh();
        }
      } catch (err) {
        showError(
          err instanceof Error ? err.message : String(err),
          t("app.components.file-grid.upload-failed-title")
        );
      } finally {
        setBusy(false);
      }
    },
    [
      buildDefaultUploadRecord,
      filterAndReportExtensions,
      mainContext,
      onUploadRecordAsync,
      ppp,
      showError,
      t
    ]
  );
  const onUploadInputChange = useCallback(
    async (ev) => {
      const fileList = ev.target.files;
      if (!fileList) return;
      const picked = Array.from(fileList).slice(0, MAX_FILES_PER_UPLOAD);
      ev.target.value = "";
      const payloads = [];
      for (const f of picked) {
        const buf = await f.arrayBuffer();
        payloads.push({ name: f.name, size: f.size, bytes: new Uint8Array(buf) });
      }
      await uploadFiles(payloads);
    },
    [uploadFiles]
  );
  const onReplaceInputChange = useCallback(
    async (ev) => {
      const target = replaceTargetRef.current;
      replaceTargetRef.current = null;
      const file = ev.target.files?.[0];
      ev.target.value = "";
      if (!target || !file) return;
      if (file.size > effectiveMaxFileSizeBytes) {
        showError(
          t("app.components.file-grid.file-too-large", [
            file.name,
            file.size,
            effectiveMaxFileSizeBytes
          ])
        );
        return;
      }
      if (isExtensionBlocked(file.name, blockedExtensions)) {
        showError(
          t("app.components.file-grid.extension-blocked", [
            file.name,
            getFileExtension(file.name)
          ])
        );
        return;
      }
      if (!isExtensionAllowed(file.name, allowedExtensions)) {
        showError(
          t("app.components.file-grid.extension-not-allowed", [
            file.name,
            (allowedExtensions ?? []).join(", ")
          ])
        );
        return;
      }
      const grid = gridContextRef.current;
      setBusy(true);
      try {
        const base64 = await readFileAsBase64(file);
        const fileValue = {
          $type: "FileValue",
          fileName: file.name,
          id: target.id ?? EMPTY_GUID,
          value: base64
        };
        if (mainContext && target.id) {
          grid?.queueRowUpdate({
            tableName,
            recordId: target.id,
            dirty: /* @__PURE__ */ new Map([[fileColumn, fileValue]])
          });
          await grid?.refresh();
        } else if (target.id) {
          const update = {
            tableName,
            id: target.id,
            properties: { [fileColumn]: fileValue }
          };
          await ppp.updateRecordAsync(update);
          await grid?.refresh();
        }
      } catch (err) {
        showError(
          err instanceof Error ? err.message : String(err),
          t("app.components.file-grid.replace-failed-title")
        );
      } finally {
        setBusy(false);
      }
    },
    [
      allowedExtensions,
      blockedExtensions,
      effectiveMaxFileSizeBytes,
      fileColumn,
      mainContext,
      ppp,
      showError,
      t,
      tableName
    ]
  );
  const downloadRecords = useCallback(
    async (records) => {
      const ids = records.map((r) => r.id).filter((id) => !!id);
      if (ids.length === 0) {
        showError(
          t("app.components.file-grid.no-records-selected"),
          t("app.components.file-grid.nothing-to-download-title")
        );
        return;
      }
      setBusy(true);
      try {
        if (ids.length === 1) {
          const onlyId = ids[0];
          const info = await ppp.getFileInfoAsync(tableName, onlyId, fileColumn, true);
          if (!info.fileName || !info.fileData) {
            showError(t("app.components.file-grid.no-file-attached"));
            return;
          }
          triggerBlobDownload(base64ToBytes(info.fileData), info.fileName);
          return;
        }
        const archive = await ppp.createFileArchiveAsync({
          tableName,
          columnName: fileColumn,
          recordIds: ids
          // Format/responseFormat default server-side (Zip / BinaryStream).
        });
        if (archive.data.length === 0) {
          showError(t("app.components.file-grid.no-files-attached"));
          return;
        }
        triggerBlobDownload(archive.data, archive.fileName);
      } catch (err) {
        showError(
          err instanceof Error ? err.message : String(err),
          t("app.components.file-grid.download-failed-title")
        );
      } finally {
        setBusy(false);
      }
    },
    [fileColumn, ppp, showError, t, tableName]
  );
  const onDragEnter = useCallback((e) => {
    e.preventDefault();
    dragDepthRef.current += 1;
    if (dragDepthRef.current === 1) setDragActive(true);
  }, []);
  const onDragOver = useCallback((e) => {
    e.preventDefault();
  }, []);
  const onDragLeave = useCallback((e) => {
    e.preventDefault();
    dragDepthRef.current = Math.max(0, dragDepthRef.current - 1);
    if (dragDepthRef.current === 0) setDragActive(false);
  }, []);
  const onDrop = useCallback(
    async (e) => {
      e.preventDefault();
      dragDepthRef.current = 0;
      setDragActive(false);
      const fileList = e.dataTransfer?.files;
      if (!fileList || fileList.length === 0) return;
      const grid = gridContextRef.current;
      const canCreate = hasPermission(grid?.tablePermissions, TableSecurityPermission.Create);
      if (grid?.tablePermissions !== void 0 && !canCreate) return;
      const picked = Array.from(fileList).slice(0, MAX_FILES_PER_UPLOAD);
      const payloads = [];
      for (const f of picked) {
        const buf = await f.arrayBuffer();
        payloads.push({ name: f.name, size: f.size, bytes: new Uint8Array(buf) });
      }
      await uploadFiles(payloads);
    },
    [uploadFiles]
  );
  useEffect(() => {
    const onDocDragEnd = () => {
      dragDepthRef.current = 0;
      setDragActive(false);
    };
    document.addEventListener("dragend", onDocDragEnd);
    return () => document.removeEventListener("dragend", onDocDragEnd);
  }, []);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses(
        "ppp-file-grid",
        styles.wrapper,
        dragActive && styles.wrapperDragActive,
        className
      ),
      style,
      onDragEnter,
      onDragOver,
      onDragLeave,
      onDrop,
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: uploadInputRef,
            type: "file",
            multiple: true,
            className: styles.hiddenInput,
            accept,
            onChange: onUploadInputChange
          }
        ),
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: replaceInputRef,
            type: "file",
            className: styles.hiddenInput,
            accept,
            onChange: onReplaceInputChange
          }
        ),
        /* @__PURE__ */ jsxs(
          MainGrid,
          {
            tableName,
            cardFileColumn: fileColumn,
            selectionMode,
            selectFromEntireRow,
            pageSize,
            ...composedTransformViewAsync !== void 0 && {
              transformViewAsync: composedTransformViewAsync
            },
            ...forwardedMainGridProps,
            children: [
              /* @__PURE__ */ jsx(GridContextBridge, { contextRef: gridContextRef }),
              /* @__PURE__ */ jsxs(GridToolbarItems, { children: [
                /* @__PURE__ */ jsx(
                  UploadGridButton,
                  {
                    onClick: () => uploadInputRef.current?.click()
                  }
                ),
                /* @__PURE__ */ jsx(
                  ReplaceGridButton,
                  {
                    onClick: (record) => {
                      replaceTargetRef.current = record;
                      replaceInputRef.current?.click();
                    }
                  }
                ),
                allowDownloadAll && /* @__PURE__ */ jsx(DownloadGridButton, { onDownload: downloadRecords }),
                /* @__PURE__ */ jsx(DeleteRecordGridButton, {}),
                children
              ] })
            ]
          }
        ),
        dragActive && /* @__PURE__ */ jsx("div", { className: styles.dropZone, children: /* @__PURE__ */ jsxs("div", { className: styles.dropZoneInner, children: [
          /* @__PURE__ */ jsx(ArrowUpload32Regular, {}),
          /* @__PURE__ */ jsx("span", { children: t("app.components.file-grid.drop-files-prompt") })
        ] }) }),
        busy && !busyShownOnGrid && /* @__PURE__ */ jsx("div", { className: styles.busyOverlay, children: /* @__PURE__ */ jsx(Spinner, { size: "medium" }) })
      ]
    }
  );
}
var useButtonStyles = makeStyles({
  // Inline-flex so the icon + text stay tight and the tooltip wraps
  // the entire button (Fluent's <Tooltip> wraps its child outright).
  button: { minWidth: "unset" }
});
function UploadGridButton({ onClick }) {
  const t = useT();
  const buttonStyles = useButtonStyles();
  const grid = useGridContext();
  const selectionCount = grid.selectedRecords.length;
  if (selectionCount > 0) return null;
  if (grid.tablePermissions !== void 0 && !hasPermission(grid.tablePermissions, TableSecurityPermission.Create)) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      relationship: "label",
      content: t("app.components.file-grid.upload-tooltip"),
      children: /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ArrowUpload24Regular, {}),
          onClick,
          className: buttonStyles.button,
          children: t("app.components.file-grid.upload-label")
        }
      )
    }
  );
}
function ReplaceGridButton({
  onClick
}) {
  const t = useT();
  const buttonStyles = useButtonStyles();
  const grid = useGridContext();
  if (grid.selectedRecords.length !== 1) return null;
  const target = grid.selectedRecords[0];
  if (!target || !target.id) return null;
  if (grid.tablePermissions !== void 0 && !hasPermission(grid.tablePermissions, TableSecurityPermission.Write)) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      relationship: "label",
      content: t("app.components.file-grid.replace-tooltip"),
      children: /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ArrowSync24Regular, {}),
          onClick: () => onClick(target),
          className: buttonStyles.button,
          children: t("app.components.file-grid.replace-label")
        }
      )
    }
  );
}
function DownloadGridButton({
  onDownload
}) {
  const t = useT();
  const buttonStyles = useButtonStyles();
  const grid = useGridContext();
  const selectionCount = grid.selectedRecords.length;
  const label = selectionCount > 0 ? t("app.components.file-grid.download-selected-label") : t("app.components.file-grid.download-all-label");
  const tooltip = selectionCount > 0 ? t("app.components.file-grid.download-selected-tooltip") : t("app.components.file-grid.download-all-tooltip");
  const onClick = useCallback(() => {
    const target = selectionCount > 0 ? grid.selectedRecords : grid.loadedRecords;
    void onDownload(target);
  }, [grid.loadedRecords, grid.selectedRecords, onDownload, selectionCount]);
  return /* @__PURE__ */ jsx(Tooltip, { relationship: "label", content: tooltip, children: /* @__PURE__ */ jsx(
    Button,
    {
      appearance: "subtle",
      icon: /* @__PURE__ */ jsx(DrawerArrowDownload24Regular, {}),
      onClick,
      className: buttonStyles.button,
      children: label
    }
  ) });
}
function bytesToBase642(bytes) {
  const CHUNK = 32768;
  let binary = "";
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}
function hasPermission(bitmask, required) {
  if (bitmask === void 0) return false;
  return (bitmask & required) === required;
}
function DataverseUnavailableBanner({ className }) {
  const unavailable = useDataverseUnavailable();
  const t = useT();
  if (!unavailable) {
    return null;
  }
  return (
    // The class is placement only — PageLayout targets it to assign the grid row.
    /* @__PURE__ */ jsx(
      MessageBar,
      {
        layout: "multiline",
        className: mergeClasses("ppp-dataverse-unavailable-banner", className),
        intent: "warning",
        children: /* @__PURE__ */ jsxs(MessageBarBody, { children: [
          /* @__PURE__ */ jsx(MessageBarTitle, { children: t("app.components.dataverse-unavailable-banner.title") }),
          t("app.components.dataverse-unavailable-banner.message")
        ] })
      }
    )
  );
}
var PageLayoutNestingContext = createContext({ isNested: false });
var usePageLayoutStyles = makeStyles({
  // Top-level layout — fills the viewport. The `:has()` carve-out in
  // `mainContent` below handles the "nested layout inside this body"
  // case by suppressing the outer body's padding when an inner layout
  // is detected (so nested layouts don't get doubled padding).
  root: {
    position: "relative",
    display: "grid",
    gridTemplateColumns: "auto minmax(0, 1fr)",
    // Five rows, not three: the first two carry the impersonation banner and the Dataverse-unavailable
    // banner. They're `auto` tracks and each banner renders nothing when there's nothing to say, so
    // the rows collapse to zero height and the layout is unchanged.
    gridTemplateRows: "auto auto auto 1fr auto",
    // Lets the PageLayout shrink when it's nested inside another
    // PageLayout's `<main>` (the outer main is a grid item; without
    // `min-width: 0` on this inner root the outer's `minmax(0, 1fr)`
    // track wouldn't be honored once content tries to grow wider).
    minWidth: 0,
    gridTemplateAreas: `
      'impersonation impersonation'
      'status status'
      'header header'
      'navigation main'
      'footer footer'
    `,
    height: "100vh",
    minHeight: "100vh",
    // Mobile uses dynamic viewport units so iOS Safari's collapsing URL
    // bar doesn't clip the footer behind it.
    [NARROW_VIEWPORT_MEDIA]: {
      height: "100dvh",
      minHeight: "100dvh"
    }
  },
  // Child layout — fills its parent's body area, not the viewport.
  childRoot: {
    height: "100%",
    minHeight: "100%"
  },
  // Resizable nav: the first track is driven by the `--ppp-nav-width` custom property
  // (set inline from the hook's clamped width) instead of `auto`. On mobile the nav
  // reflows and the handle hides, so revert to the content-sized `auto` track there
  // a stylesheet media query can override the inline custom-property-based track,
  // which an inline `gridTemplateColumns` couldn't.
  rootResizable: {
    gridTemplateColumns: "var(--ppp-nav-width) minmax(0, 1fr)",
    [NARROW_VIEWPORT_MEDIA]: {
      gridTemplateColumns: "auto minmax(0, 1fr)"
    }
  },
  // Applied to the root only while a drag is in progress: kills text selection and
  // forces the resize cursor everywhere so it doesn't flicker as the pointer leaves
  // the thin handle mid-drag.
  rootResizing: {
    userSelect: "none",
    cursor: "col-resize"
  },
  // When resizable, the unified `--ppp-nav-max-width` token still caps the element
  // the px track owns the width, but the cap (sourced from `maxNavigationWidth`)
  // lets a consumer rein in how wide the rail can be dragged from a single property.
  // Mobile reverts to 35vw via the media query since resizing is disabled there.
  navigationResizable: {
    maxWidth: "var(--ppp-nav-max-width, none)",
    [NARROW_VIEWPORT_MEDIA]: {
      maxWidth: "35vw"
    },
    // A NavMenu rail clamps itself to 250–320px (its standalone default). Inside a
    // resizable layout that cap fights the drag — the track keeps growing but the rail
    // stops widening at ~320px. Let it fill the user-sized track instead; PageLayout's
    // min/max nav width are the real bounds here. Descendant specificity (0,2,0) beats
    // NavMenu's atomic root class, so this wins without !important.
    "& .ppp-nav-menu": {
      minWidth: 0,
      maxWidth: "none",
      width: "100%"
    }
  },
  // Drag handle. Placed in the `main` area at its inline-start edge (the nav/main
  // boundary) rather than the nav's inline-end edge, so it never overlaps the nav's
  // scrollbar. Spans the middle grid row only (stretches within `main`), so it doesn't
  // cover the header/footer. Transparent until hover/active.
  resizeHandle: {
    gridArea: "main",
    justifySelf: "start",
    alignSelf: "stretch",
    width: "6px",
    zIndex: 2,
    cursor: "col-resize",
    backgroundColor: "transparent",
    // Stop touch drags from scrolling the page while resizing.
    touchAction: "none",
    transitionProperty: "background-color",
    transitionDuration: tokens.durationFaster,
    ":hover": {
      backgroundColor: tokens.colorNeutralStroke1Hover
    },
    // No handle on mobile — the nav track reverts to `auto` and isn't user-sized.
    [NARROW_VIEWPORT_MEDIA]: {
      display: "none"
    }
  },
  resizeHandleActive: {
    backgroundColor: tokens.colorBrandStroke1
  },
  // PageLayout-specific CONTEXT overrides on top of the canonical
  // `<Header>` styling (`layout/header.tsx`). These override the
  // background + border + corner radius + padding to produce the
  // page-level header look that
  // `.page-layout header { ... }` rules — taller (min-height 50),
  // accent-colored 2px bottom border (vs Section's neutral 1px),
  // wider horizontal padding. Grid-area placement is the structural
  // concern PageLayout owns regardless of which component renders
  // inside.
  header: {
    gridArea: "header",
    backgroundColor: tokens.colorNeutralBackground3,
    borderBottom: `2px solid ${tokens.colorBrandStroke1}`,
    // PageLayout's header sits at the top of the viewport — no rounding
    // because there's nothing above it to wrap around.
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    minHeight: "50px",
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL
  },
  // Child layouts get a thinner border so the visual weight doesn't
  // stack when one PageLayout's body contains another.
  childHeader: {
    borderBottomWidth: "1px"
  },
  impersonationBanner: {
    // Placement only. The banner is a Fluent MessageBar and Fluent owns everything about how it
    // looks; this grid assignment is the extent of PageLayout's involvement.
    gridArea: "impersonation"
  },
  dataverseUnavailableBanner: {
    // Placement only, as above.
    gridArea: "status"
  },
  navigation: {
    gridArea: "navigation",
    overflowY: "auto",
    // Unified element cap, sourced from `maxNavigationWidth` via the
    // `--ppp-nav-max-width` inline custom property. Defaults to 35vw when the
    // token isn't set (defensive — the component always seeds it).
    maxWidth: "var(--ppp-nav-max-width, 35vw)"
  },
  // Holds the hamburger that replaces the navigation rail on a phone. The auto margin pushes
  // it to the end of the header row however little the consumer's own content fills; the
  // padding keeps it clear of that content when it does fill the row.
  navigationButtonSlot: {
    display: "flex",
    flexShrink: 0,
    marginInlineStart: "auto",
    paddingInlineStart: tokens.spacingHorizontalS
  },
  // The drawer only exists on a phone, where SidePanel goes full width. Keep it rail-width
  // instead, so the page stays visible beside it. The media query is what lets this win over
  // SidePanel's own phone rule; an unconditional width would lose to it.
  navigationDrawer: {
    [NARROW_VIEWPORT_MEDIA]: {
      width: "min(320px, 100vw)"
    }
  },
  // NavMenu clamps itself to a 250–320px rail with a border on its inline-end edge; inside
  // the drawer it fills the panel instead, and the panel's own edge is the border. Full
  // height too, so the rail's surface runs to the bottom rather than stopping at the last item.
  navigationDrawerBody: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
    display: "flex",
    flexDirection: "column",
    "& > nav": {
      flexGrow: 1,
      display: "flex",
      flexDirection: "column"
    },
    "& .ppp-nav-menu": {
      flexGrow: 1,
      minWidth: 0,
      maxWidth: "none",
      width: "100%",
      borderRight: "none"
    }
  },
  main: {
    gridArea: "main",
    overflowY: "auto",
    // CSS Grid items default to `min-width: auto`, which makes them as
    // wide as their content's intrinsic min size — overriding the
    // outer grid's `minmax(0, 1fr)` track when content is wider than
    // the viewport. Without `min-width: 0` here, a wide descendant
    // (e.g., a MainGrid full of data columns whose summed widths
    // exceed the viewport) drags the whole main column past the right
    // edge and every sibling inside the body inherits that wider
    // width — multi-line MessageBars, headers, etc. then wrap (or
    // don't) at viewport-relative positions that look wrong. With
    // `min-width: 0`, the main column respects the track's 1fr cap,
    // and the descendant's own scroll container (the grid's
    // `tableContainer` has `overflow: auto`) handles its internal
    // horizontal overflow without involving the page.
    minWidth: 0,
    // Default padding for the body. Suppressed via the `:has()` rule
    // below when a nested PageLayout lives inside; that prevents the
    // outer body's padding from double-wrapping the inner layout's
    // header/nav/footer.
    padding: `1.3rem 1.25rem 1.25rem 1.25rem`,
    [NARROW_VIEWPORT_MEDIA]: {
      padding: "0.75rem"
    },
    // When a descendant is itself a PageLayout (detected by the root
    // class below), drop the outer body's padding so the inner
    // layout's bands sit flush against the outer layout's main edges.
    "&:has(.ppp-page-layout-root)": {
      padding: 0
    }
  },
  // PageLayout-specific CONTEXT overrides for the bottom-of-viewport
  // footer band. Same approach as `header` above — overrides the
  // canonical `<Footer>` styling (`layout/footer.tsx`) only where
  // PageLayout needs different visual treatment.
  // `.page-layout footer { ... }` rules: Background3 instead of
  // Background2, no top-border (the body/footer background contrast is
  // enough), no rounded corners (sitting flush at the viewport bottom).
  footer: {
    gridArea: "footer",
    flexDirection: "row",
    backgroundColor: tokens.colorNeutralBackground3,
    borderTop: "none",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS
  }
});
function PageLayout({
  header,
  navigation,
  body,
  footer,
  headerVisible = true,
  navigationVisible = true,
  footerVisible = true,
  className,
  style,
  headerClassName,
  headerStyle,
  navigationClassName,
  navigationStyle,
  bodyClassName,
  bodyStyle,
  footerClassName,
  footerStyle,
  scrollResetKey,
  enableNavigationResizing = true,
  defaultNavigationWidth = 280,
  minNavigationWidth = 200,
  maxNavigationWidth = 480,
  persistNavigationWidth = true,
  navigationResizeStorageKey = "ppp-page-layout-nav-width",
  navigationResizeHandleLabel = "Resize navigation",
  collapseNavigationOnMobile,
  editorLabelPosition
}) {
  const styles = usePageLayoutStyles();
  const t = useT();
  const { isNested } = useContext(PageLayoutNestingContext);
  const mainRef = useRef(null);
  const isNarrow = useIsNarrowViewport();
  const showHeader = header !== void 0 && headerVisible;
  const showNavigation = navigation !== void 0 && navigationVisible;
  const navigationCollapsed = (collapseNavigationOnMobile ?? !isNested) && isNarrow && showNavigation && showHeader;
  const [navigationOpen, setNavigationOpen] = useState(false);
  useEffect(() => {
    setNavigationOpen(false);
  }, [scrollResetKey, navigationCollapsed]);
  const drawerContext = useMemo(
    () => ({ close: () => setNavigationOpen(false) }),
    []
  );
  const resizable = enableNavigationResizing && showNavigation && !navigationCollapsed;
  const {
    width: navWidth,
    isResizing,
    handleProps
  } = useResizablePane({
    defaultWidth: defaultNavigationWidth,
    minWidth: minNavigationWidth,
    maxWidth: maxNavigationWidth,
    // Persistence opt-out: when `persistNavigationWidth` is false, drop the storage
    // key so the hook never reads from / writes to localStorage. Matches the
    // C# `PersistNavigationWidth` flag's contract.
    ...persistNavigationWidth ? { storageKey: navigationResizeStorageKey } : {}
  });
  useEffect(() => {
    if (scrollResetKey === void 0) return;
    mainRef.current?.scrollTo(0, 0);
  }, [scrollResetKey]);
  const rootClass = mergeClasses(
    "ppp-page-layout-root",
    styles.root,
    isNested && styles.childRoot,
    resizable && styles.rootResizable,
    resizable && isResizing && styles.rootResizing,
    className
  );
  const headerClass = mergeClasses(
    styles.header,
    isNested && styles.childHeader,
    headerClassName
  );
  const navMaxWidthVar = maxNavigationWidth > 0 ? `${maxNavigationWidth}px` : "auto";
  const rootStyle = {
    ...style,
    "--ppp-nav-max-width": navMaxWidthVar,
    ...resizable ? { "--ppp-nav-width": `${navWidth}px` } : {}
  };
  return /* @__PURE__ */ jsx(EditorLabelPositionProvider, { position: editorLabelPosition, children: /* @__PURE__ */ jsxs(PageLayoutNestingContext.Provider, { value: { isNested: true }, children: [
    /* @__PURE__ */ jsxs("div", { className: rootClass, style: rootStyle, children: [
      !isNested && /* @__PURE__ */ jsx(ImpersonationBanner, { className: styles.impersonationBanner }),
      !isNested && /* @__PURE__ */ jsx(DataverseUnavailableBanner, { className: styles.dataverseUnavailableBanner }),
      showHeader && /* @__PURE__ */ jsxs(Header, { className: headerClass, ...headerStyle && { style: headerStyle }, children: [
        header,
        navigationCollapsed && /* @__PURE__ */ jsx("span", { className: styles.navigationButtonSlot, children: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(NavigationRegular, {}),
            "aria-label": t("app.components.page-layout.open-navigation"),
            "aria-haspopup": "dialog",
            onClick: () => setNavigationOpen(true)
          }
        ) })
      ] }),
      showNavigation && !navigationCollapsed && /* @__PURE__ */ jsx(
        "nav",
        {
          className: mergeClasses(
            styles.navigation,
            resizable && styles.navigationResizable,
            navigationClassName
          ),
          style: navigationStyle,
          children: navigation
        }
      ),
      body !== void 0 && /* @__PURE__ */ jsx(
        "main",
        {
          ref: mainRef,
          className: mergeClasses(styles.main, bodyClassName),
          style: bodyStyle,
          children: body
        }
      ),
      resizable && /* @__PURE__ */ jsx(
        "div",
        {
          role: "separator",
          "aria-orientation": "vertical",
          "aria-label": navigationResizeHandleLabel,
          className: mergeClasses(styles.resizeHandle, isResizing && styles.resizeHandleActive),
          ...handleProps
        }
      ),
      footer !== void 0 && footerVisible && /* @__PURE__ */ jsx(
        Footer,
        {
          className: mergeClasses(styles.footer, footerClassName),
          ...footerStyle && { style: footerStyle },
          children: footer
        }
      )
    ] }),
    navigationCollapsed && /* @__PURE__ */ jsxs(
      SidePanel,
      {
        open: navigationOpen,
        onOpenChange: setNavigationOpen,
        enableResizing: false,
        defaultWidth: 320,
        className: styles.navigationDrawer,
        children: [
          /* @__PURE__ */ jsx(SidePanelHeader, { dismissLabel: t("app.buttons.close.label"), children: t("app.components.page-layout.navigation") }),
          /* @__PURE__ */ jsx(SidePanelBody, { className: styles.navigationDrawerBody, children: /* @__PURE__ */ jsx("nav", { children: /* @__PURE__ */ jsx(NavigationDrawerContext.Provider, { value: drawerContext, children: navigation }) }) })
        ]
      }
    )
  ] }) });
}
var PPP_BODY_CLASS = "ppp-body";
var useBodyStyles = makeStyles({
  // Single source of truth for the framework's body-area visual
  // treatment. `.ppp-body` defines
  // only `padding: calc(--design-unit * 3px)` (12px on all sides) and
  // nothing else. The component is intentionally lightweight: no
  // background, no border, no flex — just inset padding so content
  // doesn't butt against parent edges. Consumers and parent layouts
  // own the surrounding visual treatment (Section's border / radius,
  // PageLayout's grid placement, etc.).
  // Token mapping:
  // 3*--design-unit (12px) → tokens.spacingHorizontalM (12px)
  root: {
    padding: tokens.spacingHorizontalM
  }
});
function Body({ children, className, style, ...rest }) {
  const styles = useBodyStyles();
  return /* @__PURE__ */ jsx(
    "main",
    {
      ...rest,
      className: mergeClasses(styles.root, PPP_BODY_CLASS, className),
      style,
      children
    }
  );
}
var useTabsStyles = makeStaticStyles(`
.ppp-tab-panel { padding-block: var(--spacingVerticalL, 16px); }
`);
function TabPanel(_props) {
  return null;
}
function panelsOf(children) {
  return Children.toArray(children).flatMap((child) => {
    if (!isValidElement(child)) return [];
    if (child.type === TabPanel) return [child.props];
    if (child.type === Fragment$1) return panelsOf(child.props.children);
    return [];
  });
}
var idPart = (value2) => value2.replace(/[^A-Za-z0-9-]/g, (c) => `_${c.charCodeAt(0).toString(16)}_`);
function Tabs({
  children,
  selectedTab,
  onSelectedTabChange,
  defaultTab,
  selectedTabQueryParameter,
  lazyMount = true,
  id,
  className,
  style
}) {
  useTabsStyles();
  const generatedId = useId();
  const baseId = id ?? `ppp-tabs-${idPart(generatedId)}`;
  const panels = panelsOf(children);
  const isSelectable = (value2) => value2 !== void 0 && panels.some((p) => p.value === value2 && !p.disabled);
  const defaultValue = isSelectable(defaultTab) ? defaultTab : panels.find((p) => !p.disabled)?.value;
  const urlTab = useQueryParam(selectedTabQueryParameter ?? "") ?? void 0;
  const [selected, setSelected] = useState(() => urlTab ?? selectedTab);
  const writeToUrl = (value2) => {
    if (selectedTabQueryParameter)
      replaceQueryParam(selectedTabQueryParameter, value2 === defaultValue ? void 0 : value2);
  };
  const lastSelectedTab = useRef(selectedTab);
  useEffect(() => {
    if (selectedTab === lastSelectedTab.current) return;
    lastSelectedTab.current = selectedTab;
    if (selectedTab === void 0) return;
    setSelected(selectedTab);
    writeToUrl(isSelectable(selectedTab) ? selectedTab : defaultValue);
  }, [selectedTab]);
  const current = isSelectable(selected) ? selected : defaultValue;
  const reportedOpen = useRef(false);
  useEffect(() => {
    if (reportedOpen.current) return;
    reportedOpen.current = true;
    if (current !== void 0 && current !== selectedTab && (selectedTab !== void 0 || urlTab !== void 0))
      onSelectedTabChange?.(current);
  }, []);
  const mounted = useRef(/* @__PURE__ */ new Set());
  if (current !== void 0) mounted.current.add(current);
  const lastUrlTab = useRef(urlTab);
  useEffect(() => {
    if (!selectedTabQueryParameter || urlTab === lastUrlTab.current) return;
    lastUrlTab.current = urlTab;
    const next = isSelectable(urlTab) ? urlTab : defaultValue;
    if (next === void 0 || next === current) return;
    setSelected(next);
    onSelectedTabChange?.(next);
  });
  const select = (value2) => {
    if (value2 === current) return;
    setSelected(value2);
    onSelectedTabChange?.(value2);
    writeToUrl(value2);
  };
  const tabId = (value2) => `${baseId}-tab-${idPart(value2)}`;
  const panelId = (value2) => `${baseId}-panel-${idPart(value2)}`;
  return /* @__PURE__ */ jsxs("div", { id: baseId, className: mergeClasses("ppp-tabs", className), style, children: [
    /* @__PURE__ */ jsx(
      TabList,
      {
        ...current !== void 0 && { selectedValue: current },
        onTabSelect: (_, data) => select(String(data.value)),
        children: panels.map((p) => /* @__PURE__ */ jsx(
          Tab,
          {
            id: tabId(p.value),
            value: p.value,
            "aria-controls": panelId(p.value),
            ...p.disabled !== void 0 && { disabled: p.disabled },
            children: p.header
          },
          p.value
        ))
      }
    ),
    panels.filter((p) => !(p.lazyMount ?? lazyMount) || mounted.current.has(p.value)).map((p) => /* @__PURE__ */ jsx(
      "div",
      {
        id: panelId(p.value),
        className: "ppp-tab-panel",
        role: "tabpanel",
        "aria-labelledby": tabId(p.value),
        hidden: p.value !== current,
        children: p.children
      },
      p.value
    ))
  ] });
}
var useStyles43 = makeStyles({
  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(min(var(--ppp-summary-card-min-width, 220px), 100%), 1fr))",
    gap: tokens.spacingHorizontalL
  },
  card: {
    height: "100%",
    minWidth: 0,
    padding: `${tokens.spacingVerticalL} ${tokens.spacingHorizontalL}`
  },
  content: {
    display: "flex",
    alignItems: "flex-start",
    gap: tokens.spacingHorizontalM,
    minWidth: 0
  },
  icon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "none",
    width: "40px",
    height: "40px",
    // A Fluent icon is as large as its font.
    fontSize: "24px",
    borderRadius: tokens.borderRadiusCircular,
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground2
  },
  body: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    gap: tokens.spacingVerticalXXS,
    minWidth: 0
  },
  label: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200
  },
  value: {
    overflow: "hidden",
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase600,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  progress: {
    marginTop: tokens.spacingVerticalXS
  },
  // A card that is a link: the anchor around it takes no color or underline of its own, and the
  // card answers the pointer as Fluent UI's clickable card does.
  link: {
    display: "block",
    height: "100%",
    color: "inherit",
    textDecorationLine: "none",
    borderRadius: tokens.borderRadiusMedium,
    ":hover .ppp-summary-card": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
      boxShadow: tokens.shadow8
    },
    ":focus-visible": {
      outline: `${tokens.strokeWidthThick} solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: tokens.strokeWidthThin
    }
  }
});
var entityOf2 = (fetchXml) => fetchXml?.match(/<entity\s+name\s*=\s*["']([^"']+)["']/)?.[1];
function relatedTableOf(table, relationshipName) {
  if (!table || !relationshipName) return void 0;
  const oneToMany = table.oneToMany.find((x) => x.relationshipName === relationshipName);
  if (oneToMany) return oneToMany.referencingTable;
  const manyToMany = table.manyToMany.find((x) => x.relationshipName === relationshipName);
  if (manyToMany) return manyToMany.table1 === table.tableName ? manyToMany.table2 : manyToMany.table1;
  return void 0;
}
function numberOf3(figure) {
  if (!figure || figure.isAvailable === false) return null;
  const raw = figure.value?.value;
  if (raw == null) return figure.aggregate === QueryAggregate.Count ? 0 : null;
  const number = Number(raw);
  return Number.isFinite(number) ? number : null;
}
var isSingle = (figure) => figure !== QueryAggregate.None && (figure & figure - 1) === 0;
function throwIfMisconfigured(props) {
  const { label, value: value2, aggregate, columnName, viewId, fetchXml, relationshipName, captionAggregate, captionColumnName } = props;
  if (aggregate === void 0 || value2 != null) return;
  if (!isSingle(aggregate) || captionAggregate !== void 0 && !isSingle(captionAggregate))
    throw new Error(`The summary card '${label}' takes one QueryAggregate for each figure, not a combination.`);
  if (!viewId && !fetchXml && !relationshipName)
    throw new Error(`The summary card '${label}' needs a viewId, a fetchXml or a relationshipName to know its records.`);
  if (aggregate !== QueryAggregate.Count && !columnName)
    throw new Error(`The summary card '${label}' needs a columnName to work out its figure over.`);
  if (captionAggregate !== void 0 && captionAggregate !== QueryAggregate.Count && !captionColumnName && !columnName)
    throw new Error(`The summary card '${label}' needs a captionColumnName to work out its caption's figure over.`);
}
function useRecordsTable(viewId, fetchXml, relatedTable, wantId, enabled) {
  const fromQuery = entityOf2(fetchXml);
  const view = useViewMetadata(viewId ?? "", { enabled: enabled && wantId && !fromQuery && !!viewId });
  const table = fromQuery ?? (viewId ? view.data?.tableName : relatedTable);
  const metadata = useTableMetadata(table ?? "", { enabled: enabled && wantId && !!table });
  return { table, primaryIdColumn: wantId ? metadata.data?.primaryIdColumn : void 0 };
}
function SummaryCard(props) {
  throwIfMisconfigured(props);
  const {
    label,
    icon,
    value: value2,
    columnName,
    aggregate,
    format,
    viewId,
    fetchXml,
    relationshipName,
    selfReferencingRole,
    caption,
    captionAggregate,
    captionColumnName,
    ofViewId,
    ofFetchXml,
    showProgressBar = true,
    href,
    onNavigate,
    onClick,
    children,
    className,
    style
  } = props;
  const styles = useStyles43();
  const labelId = useId();
  const { locale } = useLocale();
  const record = useRecordContextOptional()?.record;
  const mainContext = useMainContext();
  const worked = aggregate !== void 0 && value2 == null;
  const isRatio = !!ofViewId || !!ofFetchXml;
  const canLoad = worked && (!relationshipName || hasSavedId(record) && !!record?.tableName);
  const parent = useTableMetadata(record?.tableName ?? "", {
    enabled: canLoad && !!relationshipName && !viewId && !fetchXml && !!record?.tableName
  });
  const relatedTable = relatedTableOf(parent.data, relationshipName);
  useEffect(() => {
    if (parent.data && relationshipName && !relatedTable)
      console.error(`The table '${parent.data.tableName}' has no relationship '${relationshipName}'.`);
  }, [parent.data, relationshipName, relatedTable]);
  const captionColumn = captionColumnName ?? (captionAggregate === QueryAggregate.Count ? void 0 : columnName);
  const countsRecords = aggregate === QueryAggregate.Count && !columnName;
  const main = useRecordsTable(viewId, fetchXml, relatedTable, countsRecords || captionAggregate === QueryAggregate.Count && !captionColumn, canLoad);
  const of = useRecordsTable(ofViewId, ofFetchXml, void 0, countsRecords, canLoad && isRatio);
  const recordTable = record?.tableName;
  const recordId = record?.id;
  const filters = useMemo(
    () => relationshipName && recordTable && recordId ? [
      {
        $type: "RelationshipFilter",
        parentRecord: { tableName: recordTable, id: recordId },
        relationshipName,
        ...selfReferencingRole !== void 0 && { selfReferencingRole }
      }
    ] : void 0,
    [relationshipName, recordTable, recordId, selfReferencingRole]
  );
  const request = (base, table, primaryIdColumn, withCaption) => {
    if (!canLoad || aggregate === void 0) return null;
    const figureColumn = (column, figure2) => column || (figure2 === QueryAggregate.Count ? primaryIdColumn : void 0);
    const first = figureColumn(columnName, aggregate);
    if (!first) return null;
    const figures = [{ columnName: first, aggregate, ...format && { format } }];
    if (withCaption && captionAggregate !== void 0) {
      const second = figureColumn(captionColumn, captionAggregate);
      if (!second) return null;
      figures.push({ columnName: second, aggregate: captionAggregate });
    }
    if (!base.viewId && !base.fetchXml && !table) return null;
    return {
      ...base.viewId && { viewId: base.viewId },
      fetchXml: base.viewId || base.fetchXml ? base.fetchXml : `<fetch><entity name="${table}" /></fetch>`,
      ...filters && { filters },
      // The figures must be of the query's columns.
      columns: [...new Set(figures.map((x) => x.columnName))],
      columnAggregates: figures,
      figuresOnly: true
    };
  };
  const ofRequest = isRatio ? request({ viewId: ofViewId, fetchXml: ofFetchXml }, of.table, of.primaryIdColumn, false) : null;
  const mainRequest = !isRatio || ofRequest ? request({ viewId, fetchXml }, main.table, main.primaryIdColumn, true) : null;
  const key3 = JSON.stringify([mainRequest, ofRequest]);
  const { ppp } = usePowerPortalsPro();
  const [loaded, setLoaded] = useState();
  const [inFlight, setInFlight] = useState();
  const [refreshes, setRefreshes] = useState(0);
  const waiting = useRef([]);
  const settleWaiting = () => {
    const resolve = waiting.current;
    waiting.current = [];
    resolve.forEach((settle) => settle());
  };
  useEffect(() => {
    if (!mainRequest) {
      setInFlight(void 0);
      settleWaiting();
      return;
    }
    const controller = new AbortController();
    setInFlight(key3);
    void Promise.all([
      ppp.loadQueryAsync(mainRequest, controller.signal),
      ofRequest ? ppp.loadQueryAsync(ofRequest, controller.signal) : void 0
    ]).then(
      ([main2, of2]) => ({ key: key3, main: main2, ...of2 && { of: of2 } }),
      // A failure shows a dash, as a figure that couldn't be worked out does.
      () => ({ key: key3 })
    ).then((result) => {
      if (controller.signal.aborted) return;
      setLoaded(result);
      setInFlight(void 0);
      settleWaiting();
    });
    return () => controller.abort();
  }, [ppp, key3, refreshes]);
  useEffect(() => settleWaiting, []);
  const current = loaded?.key === key3;
  const loading = !!mainRequest && (!current || inFlight === key3);
  useEffect(() => {
    if (!mainContext || !worked) return;
    return mainContext.registerDescendant({
      getRequests: () => [],
      validate: () => true,
      refresh: () => new Promise((resolve) => {
        waiting.current.push(resolve);
        setRefreshes((count) => count + 1);
      }),
      resetState: () => {
      },
      isDirty: () => false
    });
  }, [mainContext?.registerDescendant, worked]);
  const figure = current ? loaded.main?.columnAggregates?.[0] ?? void 0 : void 0;
  const captionFigure = current && captionAggregate !== void 0 ? loaded.main?.columnAggregates?.[1] ?? void 0 : void 0;
  const ratio = (() => {
    if (!isRatio || !current) return null;
    const part = numberOf3(figure);
    const whole = numberOf3(loaded?.of?.columnAggregates?.[0] ?? void 0);
    return part !== null && whole !== null && whole !== 0 ? part / whole : null;
  })();
  const shown = (() => {
    if (value2 != null) return value2;
    if (aggregate === void 0) return columnName && record ? resolveColumnDisplayValue(record, columnName) : null;
    if (isRatio) return ratio === null ? null : new Intl.NumberFormat(locale, { style: "percent", maximumFractionDigits: 0 }).format(ratio);
    return figure && figure.isAvailable !== false ? figure.formattedValue ?? null : null;
  })();
  const captionText = (() => {
    if (caption == null) return null;
    if (captionAggregate === void 0) return caption;
    return captionFigure && captionFigure.isAvailable !== false && captionFigure.formattedValue != null ? caption.replaceAll("{0}", captionFigure.formattedValue) : null;
  })();
  const isButton = !!onClick && !href;
  const onKeyDown = (event) => {
    if ((event.key === "Enter" || event.key === " ") && !event.repeat) {
      event.preventDefault();
      onClick?.(event);
    }
  };
  const card = /* @__PURE__ */ jsx(
    Card,
    {
      className: mergeClasses("ppp-summary-card", styles.card, !href && className),
      style: href ? void 0 : style,
      role: isButton ? "button" : "group",
      "aria-labelledby": labelId,
      "aria-busy": loading || void 0,
      onClick: isButton ? onClick : void 0,
      onKeyDown: isButton ? onKeyDown : void 0,
      children: /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-summary-card-content", styles.content), children: [
        icon && /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-summary-card-icon", styles.icon), "aria-hidden": "true", children: icon }),
        /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-summary-card-body", styles.body), children: [
          /* @__PURE__ */ jsx("span", { id: labelId, className: mergeClasses("ppp-summary-card-label", styles.label), children: label }),
          /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-summary-card-value", styles.value), children: shown || "\u2014" }),
          captionText && /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-summary-card-caption", styles.label), children: captionText }),
          isRatio && showProgressBar && /* @__PURE__ */ jsx(
            ProgressBar,
            {
              className: mergeClasses("ppp-summary-card-progress", styles.progress),
              value: ratio === null ? 0 : Math.min(Math.max(ratio, 0), 1),
              color: "success",
              thickness: "large"
            }
          ),
          children
        ] })
      ] })
    }
  );
  if (!href) return card;
  const onLinkClick = (event) => {
    onClick?.(event);
    if (!onNavigate || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    onNavigate(href);
  };
  return /* @__PURE__ */ jsx("a", { className: mergeClasses("ppp-summary-card-link", styles.link, className), style, href, onClick: onLinkClick, children: card });
}
function SummaryCards({ children, minCardWidth = "220px", className, style }) {
  const styles = useStyles43();
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: mergeClasses("ppp-summary-cards", styles.cards, className),
      style: { "--ppp-summary-card-min-width": minCardWidth, ...style },
      children
    }
  );
}
var providers = {
  [CaptchaProvider.Turnstile]: {
    global: "turnstile",
    src: (onload) => `https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=${onload}`,
    languageParameter: "language"
  },
  // reCAPTCHA and hCaptcha take their language only on the script, so the first widget's language
  // holds for the page.
  [CaptchaProvider.ReCaptchaV2]: {
    global: "grecaptcha",
    src: (onload, language) => `https://www.google.com/recaptcha/api.js?render=explicit&onload=${onload}` + (language ? `&hl=${encodeURIComponent(language)}` : ""),
    languageParameter: null
  },
  [CaptchaProvider.HCaptcha]: {
    global: "hcaptcha",
    src: (onload, language) => `https://js.hcaptcha.com/1/api.js?render=explicit&onload=${onload}` + (language ? `&hl=${encodeURIComponent(language)}` : ""),
    languageParameter: null
  },
  // v3 loads for its site key instead of rendering explicitly; Google shows its badge in the page's
  // corner, which its terms require unless the page credits reCAPTCHA in text instead.
  [CaptchaProvider.ReCaptchaV3]: {
    global: "grecaptcha",
    src: (onload, language, siteKey) => `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}&onload=${onload}` + (language ? `&hl=${encodeURIComponent(language)}` : ""),
    languageParameter: null
  }
};
var scriptLoads = /* @__PURE__ */ new Map();
var LOAD_TIMEOUT_MS = 2e4;
function isWidgetProvider(provider) {
  return provider in providers;
}
function loadProvider(provider, language, siteKey) {
  const script = providers[provider];
  const globals = window;
  const ready = globals[script.global];
  if (ready && typeof ready.render === "function") return Promise.resolve(ready);
  let load = scriptLoads.get(provider);
  if (!load) {
    load = new Promise((resolve, reject) => {
      const onload = `__pppCaptchaLoaded_${provider}`;
      const element = document.createElement("script");
      const fail = (reason) => {
        window.clearTimeout(timeout);
        delete globals[onload];
        element.remove();
        reject(new Error(reason));
      };
      const timeout = window.setTimeout(() => fail(`The ${script.global} script didn't load in time.`), LOAD_TIMEOUT_MS);
      globals[onload] = () => {
        window.clearTimeout(timeout);
        delete globals[onload];
        resolve(globals[script.global]);
      };
      element.src = script.src(onload, language, siteKey);
      element.async = true;
      element.onerror = () => fail(`The ${script.global} script failed to load.`);
      document.head.appendChild(element);
    });
    scriptLoads.set(provider, load);
    load.catch(() => scriptLoads.delete(provider));
  }
  return load;
}
function themeFor(container) {
  const value2 = getComputedStyle(container).getPropertyValue("--colorNeutralBackground1").trim();
  const rgb = parseColor(value2);
  if (!rgb) return null;
  const [r, g, b] = rgb.map((channel) => {
    const c = channel / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b < 0.5 ? "dark" : "light";
}
function parseColor(value2) {
  const hex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(value2);
  if (hex) {
    const digits = hex[1].length === 3 ? [...hex[1]].map((d) => d + d).join("") : hex[1];
    return [0, 2, 4].map((i) => parseInt(digits.slice(i, i + 2), 16));
  }
  const rgb = /^rgba?\(\s*(\d+(?:\.\d+)?)[\s,]+(\d+(?:\.\d+)?)[\s,]+(\d+(?:\.\d+)?)/i.exec(value2);
  if (rgb) return [Number(rgb[1]), Number(rgb[2]), Number(rgb[3])];
  return null;
}
async function renderCaptchaWidget(container, options, onToken) {
  if (!isWidgetProvider(options.provider)) throw new Error(`Not a CAPTCHA provider: ${options.provider}.`);
  const api = await loadProvider(options.provider, options.language, options.siteKey);
  if (options.provider === CaptchaProvider.ReCaptchaV3) return renderV3(api, options.siteKey);
  const parameters = {
    sitekey: options.siteKey,
    callback: (token) => onToken(token),
    "expired-callback": () => onToken(null),
    "error-callback": () => onToken(null)
  };
  const theme = themeFor(container);
  if (theme) parameters["theme"] = theme;
  const languageParameter = providers[options.provider].languageParameter;
  if (languageParameter && options.language) parameters[languageParameter] = options.language;
  const host = document.createElement("div");
  if (options.provider === CaptchaProvider.ReCaptchaV2) host.style.colorScheme = "light";
  container.appendChild(host);
  const widgetId = api.render(host, parameters);
  return {
    reset() {
      api.reset(widgetId);
      onToken(null);
    },
    dispose() {
      try {
        api.remove?.(widgetId);
      } finally {
        host.remove();
      }
    }
  };
}
async function renderV3(api, siteKey) {
  await new Promise((resolve) => api.ready(resolve));
  return {
    reset() {
    },
    dispose() {
    },
    execute(action) {
      return api.execute(siteKey, { action });
    }
  };
}
var useStyles44 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS
  }
});
var Captcha = forwardRef(function Captcha2({ form, onTokenChange, className }, ref) {
  const styles = useStyles44();
  const t = useT();
  const { locale } = useLocale();
  const { data: authOptions, refetch } = useAuthOptions();
  const settings = authOptions?.captcha;
  const required = isCaptchaRequired(settings, form);
  const provider = settings?.provider;
  const siteKey = settings?.siteKey;
  const scored = required && provider === CaptchaProvider.ReCaptchaV3;
  const containerRef = useRef(null);
  const widgetRef = useRef(null);
  const drawingRef = useRef(null);
  const [loadFailed, setLoadFailed] = useState(false);
  const [notSolved, setNotSolved] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const onTokenChangeRef = useRef(onTokenChange);
  useEffect(() => {
    onTokenChangeRef.current = onTokenChange;
  }, [onTokenChange]);
  const tokenRef = useRef(null);
  const report = useCallback((token) => {
    tokenRef.current = token;
    onTokenChangeRef.current?.(token);
  }, []);
  useEffect(() => {
    const container = containerRef.current;
    if (!required || !container || provider === void 0 || !siteKey) return void 0;
    let disposed = false;
    let widget = null;
    setLoadFailed(false);
    const drawing = renderCaptchaWidget(container, { provider, siteKey, language: locale || null }, (token) => {
      if (disposed) return;
      if (token) setNotSolved(false);
      report(token);
    }).then((drawn) => {
      if (disposed) {
        drawn.dispose();
        return;
      }
      widget = drawn;
      widgetRef.current = drawn;
    }).catch(() => {
      if (!disposed) setLoadFailed(true);
    });
    drawingRef.current = drawing;
    return () => {
      disposed = true;
      widgetRef.current = null;
      widget?.dispose();
    };
  }, [required, provider, siteKey, locale, attempt, report]);
  useImperativeHandle(
    ref,
    () => ({
      async takeToken() {
        if (scored) {
          setNotSolved(false);
          try {
            if (!widgetRef.current && drawingRef.current) await drawingRef.current;
            return await widgetRef.current?.execute?.(captchaAction(form)) ?? null;
          } catch {
            return null;
          }
        }
        const token = tokenRef.current;
        if (token !== null) {
          if (widgetRef.current) widgetRef.current.reset();
          else report(null);
        }
        return token;
      },
      reset() {
        setNotSolved(false);
        if (widgetRef.current) widgetRef.current.reset();
        else report(null);
      },
      reportNotSolved() {
        if (!settings) void refetch();
        if (loadFailed) setAttempt((n) => n + 1);
        if (widgetRef.current) widgetRef.current.reset();
        else report(null);
        setNotSolved(true);
      }
    }),
    [settings, refetch, loadFailed, report, scored, form]
  );
  if (!required) return null;
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-captcha", styles.root, className), children: [
    /* @__PURE__ */ jsx("div", { ref: containerRef, className: "ppp-captcha-widget" }),
    loadFailed ? /* @__PURE__ */ jsx(MessageBar, { intent: "warning", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.components.captcha.load-failed") }) }) : notSolved ? /* @__PURE__ */ jsx(MessageBar, { intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t(scored ? "app.components.captcha.not-verified" : "app.components.captcha.not-solved") }) }) : null
  ] });
});
var useStyles45 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: tokens.spacingVerticalS
  }
});
function PasskeySignInButton({ onResult, appearance = "secondary", disabled, className }) {
  const styles = useStyles45();
  const t = useT();
  const auth = useAuth();
  const [supported, setSupported] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => setSupported(isPasskeySupported()), []);
  if (!supported) return null;
  const signIn = async () => {
    setBusy(true);
    setError(null);
    try {
      const response = await auth.loginWithPasskey();
      const result = response.result ?? LoginResult.InvalidCredentials;
      if (result === LoginResult.InvalidCredentials) setError(t("app.components.passkeys.sign-in-failed"));
      onResult?.(result);
    } catch (e) {
      if (!isPasskeyCancellation(e)) setError(t("app.components.passkeys.error"));
    } finally {
      setBusy(false);
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-passkey-sign-in", styles.root, className), children: [
    /* @__PURE__ */ jsx(Button, { appearance, icon: /* @__PURE__ */ jsx(PersonPasskeyRegular, {}), disabled: disabled || busy, onClick: () => void signIn(), children: t("app.components.passkeys.sign-in") }),
    error && /* @__PURE__ */ jsx(MessageBar, { intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: error }) })
  ] });
}
var useStyles46 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalL,
    maxWidth: "640px"
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS,
    margin: 0,
    padding: 0,
    listStyleType: "none"
  },
  item: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`
  },
  details: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    minWidth: "200px"
  },
  actions: {
    display: "flex",
    gap: tokens.spacingHorizontalS
  },
  add: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    gap: tokens.spacingHorizontalS
  }
});
function PasskeyManager({ className }) {
  const styles = useStyles46();
  const t = useT();
  const { auth } = usePowerPortalsPro();
  const dialog = useDialogService();
  const { locale } = useLocale();
  const timeZone = useUserTimeZone();
  const [passkeys, setPasskeys] = useState(null);
  const [loadFailed, setLoadFailed] = useState(false);
  const [supported, setSupported] = useState(false);
  const [newName, setNewName] = useState("");
  const [renaming, setRenaming] = useState(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState(null);
  useEffect(() => setSupported(isPasskeySupported()), []);
  const load = useCallback(async (signal) => {
    try {
      setPasskeys((await auth.getPasskeysAsync(signal)).passkeys ?? []);
      setLoadFailed(false);
    } catch (e) {
      if (signal?.aborted) return;
      setMessage({ intent: "error", text: errorText(e) });
      setLoadFailed(true);
    }
  }, [auth]);
  useEffect(() => {
    const controller = new AbortController();
    void load(controller.signal);
    return () => controller.abort();
  }, [load]);
  function errorText(e) {
    return e instanceof PowerPortalsProError && e.detail ? e.detail : t("app.components.passkeys.error");
  }
  const run = async (action) => {
    setBusy(true);
    setMessage(null);
    try {
      await action();
    } catch (e) {
      if (!isPasskeyCancellation(e)) setMessage({ intent: "error", text: errorText(e) });
    } finally {
      setBusy(false);
    }
  };
  const add = () => run(async () => {
    const response = await auth.createPasskeyAsync(newName.trim() || null);
    switch (response.result) {
      case AddPasskeyResult.Added:
        setNewName("");
        setMessage({ intent: "success", text: t("app.components.passkeys.added") });
        await load();
        return;
      case AddPasskeyResult.LimitReached:
        setMessage({ intent: "error", text: t("app.components.passkeys.limit-reached") });
        return;
      default:
        setMessage({ intent: "error", text: t("app.components.passkeys.add-failed") });
    }
  });
  const rename = (id, name) => run(async () => {
    const response = await auth.renamePasskeyAsync({ id, name: name.trim() });
    setRenaming(null);
    if (!response.success) setMessage({ intent: "error", text: t("app.components.passkeys.error") });
    await load();
  });
  const remove = (passkey) => run(async () => {
    const confirmed = await dialog.showConfirmationAsync(
      t("app.components.passkeys.remove-confirm-message", [displayName(passkey)]),
      {
        title: t("app.components.passkeys.remove-confirm-title"),
        primaryText: t("app.components.passkeys.remove"),
        secondaryText: t("app.buttons.cancel.label")
      }
    );
    if (confirmed.canceled) return;
    const response = await auth.removePasskeyAsync({ id: passkey.id ?? "" });
    setMessage(response.success ? { intent: "success", text: t("app.components.passkeys.removed") } : { intent: "error", text: t("app.components.passkeys.error") });
    await load();
  });
  function displayName(passkey) {
    return passkey.name || t("app.components.passkeys.unnamed");
  }
  const formatDate3 = (value2) => value2 ? new Intl.DateTimeFormat(locale || void 0, { dateStyle: "medium", ...timeZone ? { timeZone } : {} }).format(new Date(value2)) : "";
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-passkey-manager", styles.root, className), children: [
    message && /* @__PURE__ */ jsx(MessageBar, { intent: message.intent, children: /* @__PURE__ */ jsx(MessageBarBody, { children: message.text }) }),
    passkeys === null ? !loadFailed && /* @__PURE__ */ jsx(Spinner, { size: "small", label: t("app.components.passkeys.loading") }) : passkeys.length === 0 ? /* @__PURE__ */ jsx(Text, { children: t("app.components.passkeys.empty") }) : /* @__PURE__ */ jsx("ul", { className: styles.list, children: passkeys.map((passkey) => /* @__PURE__ */ jsx("li", { className: mergeClasses("ppp-passkey-manager-item", styles.item), children: renaming && renaming.id === passkey.id ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Field, { label: t("app.components.passkeys.name-label"), className: styles.details, children: /* @__PURE__ */ jsx(
        Input,
        {
          value: renaming.name,
          maxLength: 200,
          onChange: (_, data) => setRenaming({ id: passkey.id ?? "", name: data.value })
        }
      ) }),
      /* @__PURE__ */ jsxs("div", { className: styles.actions, children: [
        /* @__PURE__ */ jsx(Button, { appearance: "primary", disabled: busy || !renaming.name.trim(), onClick: () => void rename(renaming.id, renaming.name), children: t("app.buttons.save.label") }),
        /* @__PURE__ */ jsx(Button, { disabled: busy, onClick: () => setRenaming(null), children: t("app.buttons.cancel.label") })
      ] })
    ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: styles.details, children: [
        /* @__PURE__ */ jsx(Text, { weight: "semibold", children: displayName(passkey) }),
        /* @__PURE__ */ jsx(Text, { size: 200, children: t("app.components.passkeys.created", [formatDate3(passkey.createdOn)]) })
      ] }),
      passkey.isBackedUp && /* @__PURE__ */ jsx(Badge, { appearance: "tint", children: t("app.components.passkeys.synced") }),
      /* @__PURE__ */ jsxs("div", { className: styles.actions, children: [
        /* @__PURE__ */ jsx(Button, { disabled: busy, onClick: () => setRenaming({ id: passkey.id ?? "", name: passkey.name ?? "" }), children: t("app.components.passkeys.rename") }),
        /* @__PURE__ */ jsx(Button, { disabled: busy, onClick: () => void remove(passkey), children: t("app.components.passkeys.remove") })
      ] })
    ] }) }, passkey.id)) }),
    passkeys === null ? null : supported ? /* @__PURE__ */ jsxs("div", { className: styles.add, children: [
      /* @__PURE__ */ jsx(Field, { label: t("app.components.passkeys.name-label"), hint: t("app.components.passkeys.name-hint"), children: /* @__PURE__ */ jsx(Input, { value: newName, maxLength: 200, onChange: (_, data) => setNewName(data.value) }) }),
      /* @__PURE__ */ jsx(Button, { appearance: "primary", icon: /* @__PURE__ */ jsx(PersonPasskeyRegular, {}), disabled: busy, onClick: () => void add(), children: t("app.components.passkeys.add") })
    ] }) : /* @__PURE__ */ jsx(MessageBar, { intent: "info", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.components.passkeys.unsupported") }) })
  ] });
}
function RouterUnsavedChangesGuard() {
  const guard = useUnsavedChangesGuard();
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => guard.isAnyDirty && currentLocation.pathname !== nextLocation.pathname
  );
  useEffect(() => {
    if (blocker.state !== "blocked") return;
    let canceled = false;
    (async () => {
      const proceed = await guard.warn();
      if (canceled) return;
      if (proceed) blocker.proceed();
      else blocker.reset();
    })();
    return () => {
      canceled = true;
    };
  }, [blocker, guard]);
  return null;
}

// src/charts/palette.ts
function readVariable(name, scope) {
  const fromScope = window.getComputedStyle(scope).getPropertyValue(name).trim();
  if (fromScope.length > 0) return fromScope;
  const fromHtml = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  if (fromHtml.length > 0) return fromHtml;
  return window.getComputedStyle(document.body).getPropertyValue(name).trim();
}
function pickFirst(scope, ...names2) {
  for (const name of names2) {
    const value2 = readVariable(name, scope);
    if (value2 && value2.length > 0) {
      return value2;
    }
  }
  return "";
}
function getChartPalette(scope) {
  const textColor = pickFirst(
    scope,
    "--colorNeutralForeground1",
    "--neutral-foreground-rest",
    "--neutral-foreground-1-rest"
  ) || "#666666";
  const gridColor = pickFirst(
    scope,
    "--colorNeutralStroke3",
    "--neutral-stroke-divider-rest",
    "--neutral-stroke-rest"
  ) || "rgba(128, 128, 128, 0.2)";
  const accentColor = pickFirst(
    scope,
    "--accent-fill-rest",
    "--colorBrandBackground",
    "--accent-foreground-rest"
  ) || "#0078d4";
  const seriesColors = [
    accentColor,
    "#d13438",
    // red
    "#107c10",
    // green
    "#ffb900",
    // yellow
    "#5c2d91",
    // purple
    "#008272",
    // teal
    "#d83b01",
    // orange
    "#e3008c",
    // pink / magenta
    "#4f6bed",
    // cornflower
    "#498205",
    // forest
    "#00cc6a",
    // seafoam
    "#7160e8",
    // lavender
    "#8e562e",
    // brown
    "#a4262c",
    // burgundy
    "#3a96dd",
    // lightBlue
    "#0099bc"
    // cyan
  ];
  return { textColor, gridColor, accentColor, seriesColors };
}
function toTranslucent(color, alpha) {
  if (!color || color.trim().length === 0) return color;
  const trimmed = color.trim();
  if (trimmed.startsWith("#") && trimmed.length === 7) {
    const r = parseInt(trimmed.slice(1, 3), 16);
    const g = parseInt(trimmed.slice(3, 5), 16);
    const b = parseInt(trimmed.slice(5, 7), 16);
    if (Number.isFinite(r) && Number.isFinite(g) && Number.isFinite(b)) {
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }
  const rgbMatch = trimmed.match(/^rgb\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)\s*\)$/i);
  if (rgbMatch) {
    return `rgba(${rgbMatch[1]}, ${rgbMatch[2]}, ${rgbMatch[3]}, ${alpha})`;
  }
  return trimmed;
}
function useFluentChartPalette(scopeRef) {
  const [palette, setPalette] = useState(null);
  useEffect(() => {
    let active = true;
    const readPalette = () => {
      if (!active) return;
      const scope = scopeRef.current;
      if (!scope) return;
      setPalette((prev) => {
        const next = getChartPalette(scope);
        if (prev && samePalette(prev, next)) return prev;
        return next;
      });
    };
    readPalette();
    const observer = new MutationObserver(readPalette);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class", "style"],
      subtree: true
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class", "style"]
    });
    return () => {
      active = false;
      observer.disconnect();
    };
  }, [scopeRef]);
  return palette;
}
function samePalette(a, b) {
  if (a.textColor !== b.textColor) return false;
  if (a.gridColor !== b.gridColor) return false;
  if (a.accentColor !== b.accentColor) return false;
  if (a.seriesColors.length !== b.seriesColors.length) return false;
  for (let i = 0; i < a.seriesColors.length; i++) {
    if (a.seriesColors[i] !== b.seriesColors[i]) return false;
  }
  return true;
}
var RADIAL_CHART_TYPES = /* @__PURE__ */ new Set([
  ChartType.Pie,
  ChartType.Doughnut,
  ChartType.PolarArea,
  ChartType.Radar,
  ChartType.Funnel
]);
var useStyles47 = makeStyles({
  // The wrapper uses Fluent design tokens directly so the rounded bordered
  // look picks up theme changes. `colorNeutralBackground1` (white in light,
  // grey[16] in dark) matches the Blazor FluentUIChart's
  // `--neutral-fill-layer-rest` surface, so the two stacks render an identical
  // white panel in light mode — the earlier `colorNeutralCardBackground` showed
  // a faint gray against the white page.
  border: {
    backgroundColor: tokens.colorNeutralBackground1,
    // `colorNeutralStroke1` (not the lighter Stroke2) so the outline carries the
    // same visible weight as the Blazor chart's `--neutral-stroke-rest` border —
    // Stroke2 reads a touch lighter than the Blazor outline side-by-side.
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusLarge,
    padding: tokens.spacingHorizontalM,
    boxSizing: "border-box",
    overflow: "hidden"
  }
});
function applyPaletteToDatasets(source, palette, chartType) {
  const seriesColors = palette.seriesColors.length > 0 ? palette.seriesColors : [palette.accentColor];
  const isRadial = RADIAL_CHART_TYPES.has(chartType);
  return source.map((original, i) => {
    const points = original.data ?? [];
    const label = original.label ?? "";
    if (isRadial) {
      const themedData = points.map((point, j) => {
        const color2 = seriesColors[j % seriesColors.length] ?? palette.accentColor;
        const p = point;
        return {
          ...point,
          backgroundColor: p.backgroundColor ?? toTranslucent(color2, 0.6),
          borderColor: p.borderColor ?? color2
        };
      });
      const dataset2 = {
        label,
        data: themedData,
        // Default to 1px border to match, whose
        // C# default is `BorderWidth = 1`. Chart.js treats undefined
        // as 0 — no border drawn — which made the React version look
        // borderless next to.
        borderWidth: original.borderWidth ?? 1
      };
      return dataset2;
    }
    const color = seriesColors[i % seriesColors.length] ?? palette.accentColor;
    const dataset = {
      label,
      data: points,
      backgroundColor: original.backgroundColor ?? toTranslucent(color, 0.5),
      borderColor: original.borderColor ?? color,
      // 1px default — see the radial
      // branch above for rationale.
      borderWidth: original.borderWidth ?? 1
    };
    return dataset;
  });
}
function FluentUIChartImpl(props, ref) {
  const {
    type = ChartType.Bar,
    labels,
    datasets,
    width,
    height = "400px",
    yAxisPrefix,
    yAxisSuffix,
    xAxisPrefix,
    xAxisSuffix,
    title,
    stacked,
    legendPosition,
    enableAnimation,
    orientation,
    valueFormat,
    valueCurrency,
    showBorder = true,
    onElementClick
  } = props;
  const styles = useStyles47();
  const containerRef = useRef(null);
  const palette = useFluentChartPalette(containerRef);
  const themedDatasets = useMemo(() => {
    if (!palette) return datasets;
    return applyPaletteToDatasets(datasets, palette, type);
  }, [datasets, palette, type]);
  const theme = useMemo(() => {
    if (!palette) {
      return assembleTheme(
        void 0,
        yAxisPrefix,
        yAxisSuffix,
        xAxisPrefix,
        xAxisSuffix,
        title,
        stacked,
        legendPosition,
        enableAnimation,
        orientation,
        valueFormat,
        valueCurrency
      );
    }
    return assembleTheme(
      palette,
      yAxisPrefix,
      yAxisSuffix,
      xAxisPrefix,
      xAxisSuffix,
      title,
      stacked,
      legendPosition,
      enableAnimation,
      orientation,
      valueFormat,
      valueCurrency
    );
  }, [
    palette,
    yAxisPrefix,
    yAxisSuffix,
    xAxisPrefix,
    xAxisSuffix,
    title,
    stacked,
    legendPosition,
    enableAnimation,
    orientation,
    valueFormat,
    valueCurrency
  ]);
  const innerRef = useRef(null);
  useImperativeHandle(
    ref,
    () => ({
      exportAsImage: () => innerRef.current?.exportAsImage() ?? null
    }),
    []
  );
  const chartProps = {
    type,
    labels,
    datasets: themedDatasets,
    height
  };
  if (width !== void 0) chartProps.width = width;
  if (theme !== void 0) chartProps.theme = theme;
  if (onElementClick !== void 0) chartProps.onElementClick = onElementClick;
  return /* @__PURE__ */ jsx("div", { ref: containerRef, className: mergeClasses("ppp-fluent-ui-chart", showBorder ? styles.border : void 0), children: /* @__PURE__ */ jsx(Chart, { ref: innerRef, ...chartProps }) });
}
var FluentUIChart = forwardRef(FluentUIChartImpl);
function assembleTheme(palette, yAxisPrefix, yAxisSuffix, xAxisPrefix, xAxisSuffix, title, stacked, legendPosition, enableAnimation, orientation, valueFormat, valueCurrency) {
  const theme = {};
  if (palette?.textColor) theme.textColor = palette.textColor;
  if (palette?.gridColor) theme.gridColor = palette.gridColor;
  if (yAxisPrefix !== void 0) theme.yAxisPrefix = yAxisPrefix;
  if (yAxisSuffix !== void 0) theme.yAxisSuffix = yAxisSuffix;
  if (xAxisPrefix !== void 0) theme.xAxisPrefix = xAxisPrefix;
  if (xAxisSuffix !== void 0) theme.xAxisSuffix = xAxisSuffix;
  if (title !== void 0) theme.title = title;
  if (stacked !== void 0) theme.stacked = stacked;
  if (legendPosition !== void 0) theme.legendPosition = legendPosition;
  if (enableAnimation !== void 0) theme.enableAnimation = enableAnimation;
  if (orientation !== void 0) theme.indexAxis = toIndexAxis(orientation);
  if (valueFormat !== void 0) theme.valueFormat = valueFormat;
  if (valueCurrency !== void 0) theme.valueCurrency = valueCurrency;
  return Object.keys(theme).length > 0 ? theme : void 0;
}
var useStyles48 = makeStyles({
  // Outer container — flex column so the view selector, message bar, and
  // chart fill share the caller's height budget.
  root: {
    position: "relative",
    display: "flex",
    flexDirection: "column"
  },
  toolbar: {
    position: "absolute",
    top: "4px",
    right: "4px",
    zIndex: 1,
    display: "flex",
    gap: "2px"
  },
  toolbarButton: {
    minWidth: "auto"
  },
  viewSelector: {
    marginBottom: tokens.spacingVerticalS,
    maxWidth: "300px",
    flex: "0 0 auto"
  },
  // `min-height: 0` + `grid-template-rows: 1fr` resolves the inner chart's
  // `height: 100%` against a definite size — required so the `ppp-chart-
  // fill` slot lays out correctly inside a flex column.
  chartFill: {
    flex: "1 1 auto",
    minHeight: 0,
    display: "grid",
    gridTemplateRows: "1fr"
  },
  empty: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: tokens.colorNeutralForeground3,
    fontStyle: "italic"
  },
  loadingOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.15)",
    zIndex: 2,
    pointerEvents: "all"
  }
});
var DataverseChart = forwardRef(
  function DataverseChart2(props, ref) {
    const {
      dataSource,
      aggregationIndex = 0,
      crossFilterMode = "highlight",
      type,
      width,
      height = "400px",
      yAxisPrefix,
      yAxisSuffix,
      xAxisPrefix,
      xAxisSuffix,
      title,
      stacked,
      legendPosition,
      enableAnimation,
      orientation,
      valueFormat,
      valueCurrency,
      onElementClick,
      showRefreshButton = true,
      showExportButton = true,
      showBorder = true,
      viewIds,
      defaultViewId
    } = props;
    const chartSource = dataSource instanceof DataverseChartDataSource ? dataSource : void 0;
    const viewDs = dataSource instanceof DataverseChartDataSource ? void 0 : dataSource;
    const styles = useStyles48();
    const t = useT();
    const { ppp, viewMetadataCache } = usePowerPortalsPro();
    const [data, setData] = useState({ labels: [], datasets: [] });
    const [error, setError] = useState(null);
    const [initialLoading, setInitialLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);
    const [selectedViewId, setSelectedViewId] = useState(
      defaultViewId ?? viewIds?.[0]
    );
    const [viewOptions, setViewOptions] = useState([]);
    const chartRef = useRef(null);
    const loadVersionRef = useRef(0);
    useEffect(() => {
      if (!chartSource) return;
      const viewToApply = defaultViewId ?? viewIds?.[0];
      if (viewToApply) {
        applyViewIdToSource(chartSource, viewToApply);
      }
    }, [chartSource]);
    const loadAsync = useCallback(
      async (signal) => {
        if (!chartSource) return;
        const version = ++loadVersionRef.current;
        try {
          const result = await chartSource.loadAsync(ppp, signal);
          if (version === loadVersionRef.current) {
            setData(result);
            setError(null);
          }
        } catch (e) {
          if (version === loadVersionRef.current) {
            setError(e instanceof Error ? e.message : String(e));
          }
        }
      },
      [chartSource, ppp]
    );
    useEffect(() => {
      const controller = new AbortController();
      let canceled = false;
      (async () => {
        await loadAsync(controller.signal);
        if (!canceled) {
          setInitialLoading(false);
        }
      })();
      return () => {
        canceled = true;
        controller.abort();
      };
    }, [loadAsync]);
    useEffect(() => {
      if (!viewIds || viewIds.length === 0) {
        setViewOptions([]);
        return;
      }
      let canceled = false;
      (async () => {
        const resolved = await Promise.all(
          viewIds.map(async (id) => {
            try {
              const view = await viewMetadataCache.getAsync(id);
              return { id, displayName: view?.displayName ?? view?.name ?? id };
            } catch {
              return { id, displayName: id };
            }
          })
        );
        if (!canceled) setViewOptions(resolved);
      })();
      return () => {
        canceled = true;
      };
    }, [viewIds, viewMetadataCache]);
    const handleRefresh = useCallback(async () => {
      if (viewDs) {
        await viewDs.refresh();
        return;
      }
      setRefreshing(true);
      try {
        await loadAsync();
      } finally {
        setRefreshing(false);
      }
    }, [viewDs, loadAsync]);
    const handleExport = useCallback(() => {
      const dataUri = chartRef.current?.exportAsImage();
      if (!dataUri) return;
      const link = document.createElement("a");
      link.href = dataUri;
      link.download = "chart.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, []);
    const handleViewChange = useCallback(
      async (viewId) => {
        if (!chartSource) return;
        setSelectedViewId(viewId);
        applyViewIdToSource(chartSource, viewId);
        setRefreshing(true);
        try {
          await loadAsync();
        } finally {
          setRefreshing(false);
        }
      },
      [chartSource, loadAsync]
    );
    useImperativeHandle(
      ref,
      () => ({
        exportAsImage: () => chartRef.current?.exportAsImage() ?? null
      }),
      []
    );
    const effectiveData = viewDs ? viewDs.aggregationResults[aggregationIndex] ?? { labels: [], datasets: [] } : data;
    const labels = effectiveData.labels ?? [];
    const rawDatasets = effectiveData.datasets ?? [];
    const datasets = useMemo(() => {
      const highlight = viewDs?.highlight;
      const groupByColumn = viewDs?.aggregations[aggregationIndex]?.groupBy?.column;
      if (!highlight || !groupByColumn) return rawDatasets;
      return rawDatasets.map((dataset) => ({
        ...dataset,
        data: (dataset.data ?? []).map((point) => {
          const dvpt = point;
          const pointValue = readColumnWireValue(dvpt.record?.properties?.[groupByColumn]);
          if (highlightMatches(highlight, pointValue)) return point;
          return { ...point, backgroundColor: "rgba(160, 160, 160, 0.3)" };
        })
      }));
    }, [rawDatasets, viewDs?.highlight, viewDs?.aggregations, aggregationIndex]);
    const hasData = datasets.length > 0 && datasets.some((d) => (d.data?.length ?? 0) > 0);
    const handleElementClick = useCallback(
      (args) => {
        if (viewDs && crossFilterMode === "highlight") {
          const aggregation = viewDs.aggregations[aggregationIndex];
          const column = aggregation?.groupBy?.column;
          if (column) {
            const point = args.dataPoint;
            const rawValue = readColumnWireValue(point?.record?.properties?.[column]);
            if (rawValue !== void 0) {
              const current = viewDs.highlight;
              if (current && current.column === column && current.value === rawValue) {
                viewDs.setHighlight(void 0);
              } else {
                const rangeSize = readRangeSize(effectiveData.rangeSize);
                viewDs.setHighlight(
                  rangeSize === void 0 ? { column, value: rawValue } : { column, value: rawValue, rangeSize }
                );
              }
            }
          }
        }
        onElementClick?.(args);
      },
      [viewDs, crossFilterMode, aggregationIndex, onElementClick, effectiveData]
    );
    const effectiveError = viewDs ? viewDs.error ? String(viewDs.error.message ?? viewDs.error) : effectiveData.error ?? null : error;
    const effectiveInitialLoading = viewDs ? viewDs.status === "loading" && viewDs.aggregationResults.length === 0 : initialLoading;
    const effectiveRefreshing = viewDs ? viewDs.isFetchingAggregations : refreshing;
    const showLoadError = !!effectiveError && !effectiveInitialLoading;
    const showExport = showExportButton && !(showLoadError && !hasData);
    const rootStyle = {};
    if (width !== void 0) rootStyle.width = width;
    if (height !== void 0) rootStyle.height = height;
    const innerChartProps = {
      labels,
      datasets,
      width: "100%",
      height: "100%",
      showBorder
    };
    if (type !== void 0) innerChartProps.type = type;
    if (yAxisPrefix !== void 0) innerChartProps.yAxisPrefix = yAxisPrefix;
    if (yAxisSuffix !== void 0) innerChartProps.yAxisSuffix = yAxisSuffix;
    if (xAxisPrefix !== void 0) innerChartProps.xAxisPrefix = xAxisPrefix;
    if (xAxisSuffix !== void 0) innerChartProps.xAxisSuffix = xAxisSuffix;
    if (title !== void 0) innerChartProps.title = title;
    if (stacked !== void 0) innerChartProps.stacked = stacked;
    if (legendPosition !== void 0) innerChartProps.legendPosition = legendPosition;
    if (enableAnimation !== void 0) innerChartProps.enableAnimation = enableAnimation;
    if (orientation !== void 0) innerChartProps.orientation = orientation;
    if (valueFormat !== void 0) innerChartProps.valueFormat = valueFormat;
    const currency = valueCurrency ?? effectiveData.valueCurrency ?? void 0;
    if (currency !== void 0) innerChartProps.valueCurrency = currency;
    innerChartProps.onElementClick = handleElementClick;
    return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-dataverse-chart", styles.root), style: rootStyle, children: [
      showLoadError && /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: effectiveError }) }),
      (showExport || showRefreshButton) && /* @__PURE__ */ jsxs("div", { className: styles.toolbar, children: [
        showExport && /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.chart.download-image-tooltip"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(ArrowDownload24Regular, {}),
            onClick: handleExport,
            className: styles.toolbarButton
          }
        ) }),
        showRefreshButton && /* @__PURE__ */ jsx(Tooltip, { content: t("app.components.chart.refresh-data-tooltip"), relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(ArrowClockwise24Regular, {}),
            disabled: effectiveRefreshing,
            onClick: () => void handleRefresh(),
            className: styles.toolbarButton
          }
        ) })
      ] }),
      viewOptions.length > 0 && /* @__PURE__ */ jsx("div", { className: styles.viewSelector, children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          value: viewOptions.find((v) => v.id === selectedViewId)?.displayName ?? "",
          selectedOptions: selectedViewId ? [selectedViewId] : [],
          onOptionSelect: (_e, option) => {
            if (option.optionValue) void handleViewChange(option.optionValue);
          },
          children: viewOptions.map((v) => /* @__PURE__ */ jsx(Option, { value: v.id, children: v.displayName }, v.id))
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: styles.chartFill, children: hasData ? /* @__PURE__ */ jsx(FluentUIChart, { ref: chartRef, ...innerChartProps }) : !effectiveInitialLoading && effectiveError === null ? /* @__PURE__ */ jsx("div", { className: styles.empty, children: t("app.components.chart.no-data") }) : null }),
      (effectiveInitialLoading || effectiveRefreshing) && /* @__PURE__ */ jsx("div", { className: styles.loadingOverlay, children: /* @__PURE__ */ jsx(Spinner, {}) })
    ] });
  }
);
function applyViewIdToSource(source, viewId) {
  if (source instanceof AggregateDataverseChartDataSource) {
    source.viewId = viewId;
  } else if (source instanceof ViewDataverseChartDataSource) {
    source.viewId = viewId;
  }
}
var CRITERIA_TABLE = "contact";
var CRITERIA_KEY_PREFIX = "criteria";
var CRITERIA_RESULTS_VIEW_ID = "9d3c7f21-6b48-4e05-a7d2-51cf8e2b36a4";
var useStyles49 = makeStyles({
  form: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
    minWidth: 0
  },
  heading: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXXS
  },
  description: {
    color: tokens.colorNeutralForeground2
  },
  builder: {
    minWidth: 0
  }
});
function criteriaProblemKey(criteria, table, keyPrefix) {
  const text2 = (criteria ?? "").trim();
  if (text2 === "") return `${keyPrefix}-problem-empty`;
  let parsed;
  try {
    parsed = parseFetchXml(text2);
  } catch {
    return `${keyPrefix}-problem-invalid`;
  }
  if (parsed.aggregate === true) return `${keyPrefix}-problem-aggregate`;
  if (parsed.entity.name.toLowerCase() !== table.toLowerCase()) return `${keyPrefix}-problem-table`;
  return void 0;
}
function RoleCriteriaEditor({
  stringsPrefix,
  criteriaColumn,
  table = CRITERIA_TABLE,
  keyPrefix = CRITERIA_KEY_PREFIX,
  resultsViewId = CRITERIA_RESULTS_VIEW_ID,
  readOnly
}) {
  const styles = useStyles49();
  const t = usePrefixedT(stringsPrefix);
  const metadata = usePowerPortalsProFetchXmlMetadata();
  const { value: criteria, setValue: setCriteria } = useStringColumn(criteriaColumn);
  const criteriaProblem = useMemo(
    () => criteriaProblemKey(criteria, table, keyPrefix),
    [criteria, table, keyPrefix]
  );
  return /* @__PURE__ */ jsxs("div", { className: styles.form, children: [
    /* @__PURE__ */ jsxs("div", { className: styles.heading, children: [
      /* @__PURE__ */ jsx(Text, { weight: "semibold", children: t(`${keyPrefix}-title`) }),
      /* @__PURE__ */ jsx(Text, { className: styles.description, children: t(`${keyPrefix}-description`) })
    ] }),
    criteriaProblem === void 0 ? null : /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "warning", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t(criteriaProblem) }) }),
    /* @__PURE__ */ jsx(
      FetchXmlBuilder,
      {
        className: styles.builder,
        metadata,
        table,
        sections: { table: false },
        allowAggregate: false,
        value: criteria ?? "",
        onChange: (nextFetchXml) => setCriteria(nextFetchXml),
        readOnly,
        renderResults: (runnable) => /* @__PURE__ */ jsx(
          MainGrid,
          {
            tableName: runnable.tableName,
            customViewDefinitions: [
              {
                id: resultsViewId,
                displayName: t(`${keyPrefix}-results-view-name`),
                tableName: runnable.tableName,
                fetchXml: runnable.fetchXml,
                columns: runnable.columns.map((columnName) => ({ columnName, width: 200 }))
              }
            ],
            viewId: resultsViewId,
            title: t(`${keyPrefix}-results-view-name`),
            pagingMode: PagingMode.Virtualize,
            selectionMode: "none",
            showRecordLinks: false,
            pageSize: 25,
            minHeight: "200px",
            maxHeight: "360px"
          },
          runnable.fetchXml
        )
      }
    )
  ] });
}
var STRINGS_PREFIX = "app.components.portal-role-admin";
var PORTAL_ROLE_TABLE = "ppp_portalrole";
var PORTAL_ROLE_NAME = "ppp_name";
var PORTAL_ROLE_DESCRIPTION = "ppp_description";
var CONFIGURATION_TABLE = "ppp_portalroleconfiguration";
var CONFIGURATION_ROLE = "ppp_portalrole";
var CONFIGURATION_MODE = "ppp_assignmentmode";
var CONFIGURATION_CRITERIA = "ppp_criteria";
var ASSIGN_FROM_CRITERIA = 894400002;
var ROLES_VIEW_ID = "f1c7a8d0-5b62-4e39-9a81-3d6f2c0b7e14";
var CONFIGURATIONS_VIEW_ID = "2a5e93b7-c14d-4f80-8b3a-6e97d2415cf8";
var useStyles50 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXXL,
    // A grid with many columns is wide content, and a flex item's floor is its
    // content unless told otherwise. Without this the grids push this component
    // past its container instead of scrolling inside themselves.
    minWidth: 0
  },
  section: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    minWidth: 0
  },
  heading: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXXS
  },
  description: {
    color: tokens.colorNeutralForeground2
  },
  form: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
    minWidth: 0
  }
});
function PortalRoleAdmin({
  className,
  configurationUrl,
  onNavigate
}) {
  const styles = useStyles50();
  const t = usePrefixedT(STRINGS_PREFIX);
  const roleViews = useMemo(
    () => [
      {
        id: ROLES_VIEW_ID,
        displayName: t("roles-view-name"),
        tableName: PORTAL_ROLE_TABLE,
        fetchXml: `<fetch><entity name="${PORTAL_ROLE_TABLE}"><attribute name="${PORTAL_ROLE_NAME}" /><attribute name="${PORTAL_ROLE_DESCRIPTION}" /><order attribute="${PORTAL_ROLE_NAME}" /></entity></fetch>`,
        columns: [
          { columnName: PORTAL_ROLE_NAME, width: 260 },
          { columnName: PORTAL_ROLE_DESCRIPTION, width: 520 }
        ]
      }
    ],
    [t]
  );
  const configurationViews = useMemo(
    () => [
      {
        id: CONFIGURATIONS_VIEW_ID,
        displayName: t("configurations-view-name"),
        tableName: CONFIGURATION_TABLE,
        fetchXml: `<fetch><entity name="${CONFIGURATION_TABLE}"><attribute name="${CONFIGURATION_ROLE}" /><attribute name="${CONFIGURATION_MODE}" /><order attribute="${CONFIGURATION_ROLE}" /></entity></fetch>`,
        columns: [
          { columnName: CONFIGURATION_ROLE, width: 300 },
          { columnName: CONFIGURATION_MODE, width: 320 }
        ]
      }
    ],
    [t]
  );
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-portal-role-admin", styles.root, className), children: [
    /* @__PURE__ */ jsxs("section", { className: styles.section, children: [
      /* @__PURE__ */ jsxs("div", { className: styles.heading, children: [
        /* @__PURE__ */ jsx(Title3, { children: t("roles-title") }),
        /* @__PURE__ */ jsx(Text, { className: styles.description, children: t("roles-description") })
      ] }),
      /* @__PURE__ */ jsx(
        MainGrid,
        {
          tableName: PORTAL_ROLE_TABLE,
          customViewDefinitions: roleViews,
          viewId: ROLES_VIEW_ID,
          title: t("roles-view-name"),
          pageSize: 25,
          minHeight: "240px",
          maxHeight: "420px",
          children: /* @__PURE__ */ jsxs(GridToolbarItems, { children: [
            /* @__PURE__ */ jsx(NewRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(PortalRoleForm, {}) }),
            /* @__PURE__ */ jsx(OpenRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(PortalRoleForm, {}) }),
            /* @__PURE__ */ jsx(DeleteRecordGridButton, { behavior: "immediately" })
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("section", { className: styles.section, children: [
      /* @__PURE__ */ jsxs("div", { className: styles.heading, children: [
        /* @__PURE__ */ jsx(Title3, { children: t("configurations-title") }),
        /* @__PURE__ */ jsx(Text, { className: styles.description, children: t("configurations-description") })
      ] }),
      /* @__PURE__ */ jsx(
        MainGrid,
        {
          tableName: CONFIGURATION_TABLE,
          customViewDefinitions: configurationViews,
          viewId: CONFIGURATIONS_VIEW_ID,
          title: t("configurations-view-name"),
          pageSize: 25,
          minHeight: "240px",
          maxHeight: "420px",
          children: /* @__PURE__ */ jsxs(GridToolbarItems, { children: [
            configurationUrl === void 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(NewRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(PortalRoleConfigurationForm, {}) }),
              /* @__PURE__ */ jsx(OpenRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(PortalRoleConfigurationForm, {}) })
            ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                NavigateNewRecordGridButton,
                {
                  url: configurationUrl(void 0),
                  ...onNavigate === void 0 ? {} : { onNavigate }
                }
              ),
              /* @__PURE__ */ jsx(
                NavigateOpenRecordGridButton,
                {
                  urlFor: (record) => configurationUrl(record.id),
                  ...onNavigate === void 0 ? {} : { onNavigate }
                }
              )
            ] }),
            /* @__PURE__ */ jsx(DeleteRecordGridButton, { behavior: "immediately" })
          ] })
        }
      )
    ] })
  ] });
}
function PortalRoleForm() {
  const styles = useStyles50();
  return /* @__PURE__ */ jsxs("div", { className: styles.form, children: [
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: PORTAL_ROLE_NAME }),
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: PORTAL_ROLE_DESCRIPTION })
  ] });
}
function PortalRoleConfigurationForm({
  className
} = {}) {
  const styles = useStyles50();
  const { value: mode } = useChoiceColumn(CONFIGURATION_MODE);
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-portal-role-configuration-form", styles.form, className), children: [
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: CONFIGURATION_ROLE }),
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: CONFIGURATION_MODE }),
    mode === ASSIGN_FROM_CRITERIA ? /* @__PURE__ */ jsx(RoleCriteriaEditor, { stringsPrefix: STRINGS_PREFIX, criteriaColumn: CONFIGURATION_CRITERIA }) : null
  ] });
}
var STRINGS_PREFIX2 = "app.components.web-role-admin";
var PERMISSION_TABLE = "mspp_entitypermission";
var NAME_COLUMN = "mspp_entityname";
var TABLE_COLUMN = "mspp_entitylogicalname";
var SCOPE_COLUMN = "mspp_scope";
var CONTACT_RELATIONSHIP_COLUMN = "mspp_contactrelationship";
var ACCOUNT_RELATIONSHIP_COLUMN = "mspp_accountrelationship";
var PARENT_PERMISSION_COLUMN = "mspp_parententitypermission";
var PARENT_RELATIONSHIP_COLUMN = "mspp_parentrelationship";
var CUSTOM_FILTER_COLUMN = "mspp_permissionfetchxml";
var PRIVILEGE_COLUMNS = [
  "mspp_read",
  "mspp_write",
  "mspp_create",
  "mspp_delete",
  "mspp_append",
  "mspp_appendto"
];
var Scope = {
  Contact: 756150001,
  Account: 756150002,
  Parent: 756150003,
  Self: 756150004,
  Custom: 756150005
};
var CUSTOM_FILTER_RESULTS_VIEW_ID = "8b017c9f-0143-48ee-9fb7-780b4a56d3e3";
var WEB_ROLE_TABLE = "mspp_webrole";
var WEB_ROLE_NAME = "mspp_name";
var WEB_ROLES_FETCH_XML = `<fetch><entity name="${WEB_ROLE_TABLE}"><attribute name="${WEB_ROLE_NAME}" /><order attribute="${WEB_ROLE_NAME}" /></entity></fetch>`;
var useStyles51 = makeStyles({
  form: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
    minWidth: 0
  },
  group: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXS,
    minWidth: 0
  },
  hint: {
    color: tokens.colorNeutralForeground2
  }
});
function TablePermissionForm({ className } = {}) {
  const styles = useStyles51();
  const t = usePrefixedT(STRINGS_PREFIX2);
  const { value: scope } = useChoiceColumn(SCOPE_COLUMN);
  const { value: tableName } = useStringColumn(TABLE_COLUMN);
  const { value: parentPermission } = useLookupColumn(PARENT_PERMISSION_COLUMN);
  const parentId = scope === Scope.Parent ? parentPermission?.id : void 0;
  const parent = useRecord(PERMISSION_TABLE, parentId ?? "", {
    columns: [TABLE_COLUMN],
    enabled: parentId !== void 0
  });
  const parentTable = parentId === void 0 ? void 0 : parent.data?.properties?.[TABLE_COLUMN]?.value ?? void 0;
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-table-permission-form", styles.form, className), children: [
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: NAME_COLUMN }),
    /* @__PURE__ */ jsx(TableField, { columnName: TABLE_COLUMN, label: t("table-label") }),
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: SCOPE_COLUMN }),
    scope === Scope.Contact ? /* @__PURE__ */ jsx(
      RelationshipField,
      {
        columnName: CONTACT_RELATIONSHIP_COLUMN,
        table: tableName,
        relatedTable: "contact",
        label: t("contact-relationship-label"),
        description: t("contact-relationship-description")
      }
    ) : null,
    scope === Scope.Account ? /* @__PURE__ */ jsx(
      RelationshipField,
      {
        columnName: ACCOUNT_RELATIONSHIP_COLUMN,
        table: tableName,
        relatedTable: "account",
        label: t("account-relationship-label"),
        description: t("account-relationship-description")
      }
    ) : null,
    scope === Scope.Parent ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(ColumnEdit, { columnName: PARENT_PERMISSION_COLUMN, required: true }),
      /* @__PURE__ */ jsx(
        RelationshipField,
        {
          columnName: PARENT_RELATIONSHIP_COLUMN,
          table: tableName,
          relatedTable: parentTable,
          label: t("parent-relationship-label"),
          description: t("parent-relationship-description"),
          missingText: tableName === void 0 ? void 0 : t("parent-needs-permission")
        }
      )
    ] }) : null,
    scope === Scope.Self && tableName !== void 0 && tableName.toLowerCase() !== "contact" ? /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "warning", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("self-not-contact") }) }) : null,
    scope === Scope.Custom ? tableName === void 0 ? /* @__PURE__ */ jsx(Text, { className: styles.hint, children: t("relationship-needs-table") }) : /* @__PURE__ */ jsx(
      RoleCriteriaEditor,
      {
        stringsPrefix: STRINGS_PREFIX2,
        criteriaColumn: CUSTOM_FILTER_COLUMN,
        table: tableName,
        keyPrefix: "custom-filter",
        resultsViewId: CUSTOM_FILTER_RESULTS_VIEW_ID
      }
    ) : null,
    /* @__PURE__ */ jsxs("div", { className: styles.group, children: [
      /* @__PURE__ */ jsx(Text, { weight: "semibold", children: t("privileges-title") }),
      PRIVILEGE_COLUMNS.map((column) => /* @__PURE__ */ jsx(ColumnEdit, { columnName: column }, column))
    ] }),
    /* @__PURE__ */ jsx(TablePermissionWebRolesField, {})
  ] });
}
function TableField({ columnName, label }) {
  const t = usePrefixedT(STRINGS_PREFIX2);
  const metadata = usePowerPortalsProFetchXmlMetadata();
  const tables = useFetchXmlTables(metadata);
  const { value: value2, setValue } = useStringColumn(columnName);
  const errors = useColumnValidation(columnName, {
    kind: "string",
    required: true,
    label,
    value: value2 ?? ""
  });
  const items = useMemo(
    () => (tables.data ?? []).filter((table) => table.isIntersect !== true),
    [tables.data]
  );
  return /* @__PURE__ */ jsx(Field, { label, required: true, ...buildFieldValidationProps(errors, true), children: /* @__PURE__ */ jsx(
    MetadataPicker,
    {
      value: value2 ?? "",
      onChange: (logicalName) => setValue(logicalName === "" ? null : logicalName),
      items,
      loading: tables.loading,
      placeholder: t("table-placeholder"),
      ariaLabel: label
    }
  ) });
}
function RelationshipField({
  columnName,
  table,
  relatedTable,
  label,
  description,
  missingText
}) {
  const styles = useStyles51();
  const t = usePrefixedT(STRINGS_PREFIX2);
  const metadata = usePowerPortalsProFetchXmlMetadata();
  const detail = useFetchXmlTableDetail(metadata, table);
  const { value: value2, setValue } = useStringColumn(columnName);
  const errors = useColumnValidation(columnName, {
    kind: "string",
    required: true,
    label,
    value: value2 ?? ""
  });
  const relationships = useMemo(() => {
    if (relatedTable === void 0) return [];
    const target = relatedTable.toLowerCase();
    return (detail.data?.relationships ?? []).filter(
      (relationship) => relationship.relatedTable.toLowerCase() === target
    );
  }, [detail.data, relatedTable]);
  const describe = (relationship) => {
    const kind = relationship.kind === "oneToMany" ? t("relationship-kind-one-to-many") : relationship.kind === "manyToOne" ? t("relationship-kind-many-to-one") : t("relationship-kind-many-to-many");
    return relationship.lookupLabel ? `${relationship.schemaName} (${kind}, ${relationship.lookupLabel})` : `${relationship.schemaName} (${kind})`;
  };
  const tablesKnown = table !== void 0 && relatedTable !== void 0;
  const selected = relationships.find((relationship) => relationship.schemaName === value2);
  const loaded = tablesKnown && !detail.loading && detail.data !== void 0;
  return /* @__PURE__ */ jsxs("div", { className: styles.group, children: [
    /* @__PURE__ */ jsx(
      Field,
      {
        label,
        hint: description,
        required: true,
        ...buildFieldValidationProps(errors, true),
        children: /* @__PURE__ */ jsxs(
          Dropdown,
          {
            "aria-label": label,
            disabled: !tablesKnown || detail.loading,
            placeholder: tablesKnown ? t("relationship-placeholder") : missingText ?? t("relationship-needs-table"),
            value: selected ? describe(selected) : value2 ?? "",
            selectedOptions: value2 === void 0 ? [] : [value2],
            onOptionSelect: (_, data) => setValue(data.optionValue === void 0 || data.optionValue === "" ? null : data.optionValue),
            children: [
              relationships.map((relationship) => /* @__PURE__ */ jsx(Option, { value: relationship.schemaName, children: describe(relationship) }, relationship.schemaName)),
              value2 !== void 0 && selected === void 0 ? /* @__PURE__ */ jsx(Option, { value: value2, children: value2 }, value2) : null
            ]
          }
        )
      }
    ),
    tablesKnown && detail.loading ? /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) : null,
    loaded && relationships.length === 0 ? /* @__PURE__ */ jsx(Text, { className: styles.hint, children: t("relationship-none", [table, relatedTable]) }) : null
  ] });
}
function sameIds(a, b) {
  if (a.length !== b.length) return false;
  const set = new Set(a.map((id) => id.toLowerCase()));
  return b.every((id) => set.has(id.toLowerCase()));
}
function TablePermissionWebRolesField() {
  const styles = useStyles51();
  const t = usePrefixedT(STRINGS_PREFIX2);
  const { ppp } = usePowerPortalsPro();
  const { record } = useRecordContext();
  const mainContext = useMainContext();
  const webRoles = useFetchRecords(WEB_ROLES_FETCH_XML);
  const permissionId = record?.id && record.id !== "00000000-0000-0000-0000-000000000000" ? record.id : void 0;
  const [saved, setSaved] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loadFailed, setLoadFailed] = useState(false);
  const [reloadTick, setReloadTick] = useState(0);
  const isDirty = !sameIds(saved, selected);
  const savedRef = useRef(saved);
  savedRef.current = saved;
  const selectedRef = useRef(selected);
  selectedRef.current = selected;
  const isDirtyRef = useRef(isDirty);
  isDirtyRef.current = isDirty;
  const tRef = useRef(t);
  tRef.current = t;
  useEffect(() => {
    if (permissionId === void 0) return;
    const controller = new AbortController();
    setLoadFailed(false);
    ppp.getTablePermissionWebRolesAsync(permissionId, controller.signal).then(
      (ids) => {
        if (controller.signal.aborted) return;
        const assigned = ids ?? [];
        savedRef.current = assigned;
        setSaved(assigned);
        setSelected(assigned);
      },
      () => {
        if (!controller.signal.aborted) setLoadFailed(true);
      }
    );
    return () => controller.abort();
  }, [ppp, permissionId, reloadTick]);
  useEffect(() => {
    if (!mainContext) return;
    return mainContext.registerDescendant({
      getRequests: () => [],
      validate: () => true,
      isDirty: () => isDirtyRef.current,
      afterSave: async (savedRecordId) => {
        if (!isDirtyRef.current || savedRecordId === void 0) return;
        const roles2 = selectedRef.current;
        let found;
        try {
          found = await ppp.setTablePermissionWebRolesAsync(savedRecordId, roles2);
        } catch (error) {
          const reason = error instanceof Error ? error.message : String(error);
          throw new Error(tRef.current("web-roles-save-failed", [reason]));
        }
        if (!found) {
          throw new Error(
            tRef.current("web-roles-save-failed", [tRef.current("web-roles-permission-missing")])
          );
        }
        savedRef.current = roles2;
        setSaved(roles2);
      },
      // Rereads what the permission applies to, dropping any unsaved choice.
      // Never writes: a save does that through afterSave, before it refreshes.
      refresh: async () => {
        setReloadTick((tick) => tick + 1);
      },
      resetState: () => setSelected(savedRef.current)
    });
  }, [mainContext?.registerDescendant, ppp]);
  const mainContextRef = useRef(mainContext);
  mainContextRef.current = mainContext;
  useEffect(() => {
    mainContextRef.current?.notifyDescendantDirtyChanged();
  }, [isDirty]);
  const toggle = (webRoleId, checked) => setSelected(
    (current) => checked ? [...current, webRoleId] : current.filter((id) => id.toLowerCase() !== webRoleId.toLowerCase())
  );
  const selectedSet = new Set(selected.map((id) => id.toLowerCase()));
  const roles = webRoles.data?.tableRecords ?? [];
  return /* @__PURE__ */ jsxs("div", { className: styles.group, children: [
    /* @__PURE__ */ jsx(Text, { weight: "semibold", children: t("web-roles-label") }),
    /* @__PURE__ */ jsx(Text, { className: styles.hint, children: t("web-roles-edit-description") }),
    loadFailed || webRoles.status === QueryStatus.Error ? /* @__PURE__ */ jsx(MessageBar, { layout: "multiline", intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("web-roles-load-failed") }) }) : webRoles.status === QueryStatus.Loading ? /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) : roles.length === 0 ? /* @__PURE__ */ jsx(Text, { children: t("web-roles-none") }) : roles.map((role) => {
      const id = role.id ?? "";
      const name = role.properties?.[WEB_ROLE_NAME]?.value ?? id;
      return /* @__PURE__ */ jsx(
        Checkbox,
        {
          label: name,
          checked: selectedSet.has(id.toLowerCase()),
          onChange: (_, data) => toggle(id, data.checked === true)
        },
        id
      );
    })
  ] });
}
var STRINGS_PREFIX3 = "app.components.web-role-admin";
var WEB_ROLE_TABLE2 = "mspp_webrole";
var WEB_ROLE_NAME2 = "mspp_name";
var WEB_ROLE_DESCRIPTION = "mspp_description";
var WEB_ROLE_AUTHENTICATED = "mspp_authenticatedusersrole";
var WEB_ROLE_ANONYMOUS = "mspp_anonymoususersrole";
var PERMISSION_TABLE2 = "mspp_entitypermission";
var PERMISSION_NAME = "mspp_entityname";
var PERMISSION_TABLE_NAME = "mspp_entitylogicalname";
var PERMISSION_SCOPE = "mspp_scope";
var PERMISSION_PRIVILEGES = [
  "mspp_read",
  "mspp_write",
  "mspp_create",
  "mspp_delete",
  "mspp_append",
  "mspp_appendto"
];
var CONFIGURATION_TABLE2 = "ppp_webroleconfiguration";
var CONFIGURATION_NAME = "ppp_name";
var CONFIGURATION_WEB_ROLE = "ppp_webrole";
var CONFIGURATION_MODE2 = "ppp_assignmentmode";
var CONFIGURATION_CRITERIA2 = "ppp_criteria";
var ASSIGN_FROM_CRITERIA2 = 894400002;
var WEB_ROLES_VIEW_ID = "2e594165-1caf-4c0f-9f49-5e7e7f2db7b3";
var PERMISSIONS_VIEW_ID = "2bcea006-db57-4fdc-a465-495ead4b2523";
var CONFIGURATIONS_VIEW_ID2 = "739263bf-f2e5-4777-8f06-cb6222ba5cc2";
var useStyles52 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXXL,
    // A grid with many columns is wide content, and a flex item's floor is its
    // content unless told otherwise. Without this the grid pushes this component
    // past its container instead of scrolling inside itself.
    minWidth: 0
  },
  section: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    minWidth: 0
  },
  heading: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXXS
  },
  description: {
    color: tokens.colorNeutralForeground2
  },
  form: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
    minWidth: 0
  }
});
function WebRoleAdmin({ className, configurationUrl, permissionUrl, onNavigate }) {
  const styles = useStyles52();
  const t = usePrefixedT(STRINGS_PREFIX3);
  const authOptions = useAuthOptions();
  const webRoleViews = useMemo(
    () => [
      {
        id: WEB_ROLES_VIEW_ID,
        displayName: t("web-roles-view-name"),
        tableName: WEB_ROLE_TABLE2,
        fetchXml: `<fetch><entity name="${WEB_ROLE_TABLE2}"><attribute name="${WEB_ROLE_NAME2}" /><attribute name="${WEB_ROLE_DESCRIPTION}" /><attribute name="${WEB_ROLE_AUTHENTICATED}" /><attribute name="${WEB_ROLE_ANONYMOUS}" /><order attribute="${WEB_ROLE_NAME2}" /></entity></fetch>`,
        columns: [
          { columnName: WEB_ROLE_NAME2, width: 240 },
          { columnName: WEB_ROLE_DESCRIPTION, width: 320 },
          { columnName: WEB_ROLE_AUTHENTICATED, width: 180 },
          { columnName: WEB_ROLE_ANONYMOUS, width: 180 }
        ]
      }
    ],
    [t]
  );
  const permissionViews = useMemo(
    () => [
      {
        id: PERMISSIONS_VIEW_ID,
        displayName: t("table-permissions-view-name"),
        tableName: PERMISSION_TABLE2,
        fetchXml: `<fetch><entity name="${PERMISSION_TABLE2}"><attribute name="${PERMISSION_NAME}" /><attribute name="${PERMISSION_TABLE_NAME}" /><attribute name="${PERMISSION_SCOPE}" />` + PERMISSION_PRIVILEGES.map((column) => `<attribute name="${column}" />`).join("") + `<order attribute="${PERMISSION_NAME}" /></entity></fetch>`,
        columns: [
          { columnName: PERMISSION_NAME, width: 240 },
          { columnName: PERMISSION_TABLE_NAME, width: 180 },
          { columnName: PERMISSION_SCOPE, width: 140 },
          ...PERMISSION_PRIVILEGES.map((column) => ({ columnName: column, width: 100 }))
        ]
      }
    ],
    [t]
  );
  const views = useMemo(
    () => [
      {
        id: CONFIGURATIONS_VIEW_ID2,
        displayName: t("configurations-view-name"),
        tableName: CONFIGURATION_TABLE2,
        fetchXml: `<fetch><entity name="${CONFIGURATION_TABLE2}"><attribute name="${CONFIGURATION_NAME}" /><attribute name="${CONFIGURATION_WEB_ROLE}" /><attribute name="${CONFIGURATION_MODE2}" /><order attribute="${CONFIGURATION_NAME}" /></entity></fetch>`,
        columns: [
          { columnName: CONFIGURATION_NAME, width: 260 },
          { columnName: CONFIGURATION_WEB_ROLE, width: 260 },
          { columnName: CONFIGURATION_MODE2, width: 320 }
        ]
      }
    ],
    [t]
  );
  if (authOptions.status === QueryStatus.Loading) return null;
  if (authOptions.data?.enhancedAuthorizationEnabled !== true) {
    return /* @__PURE__ */ jsx(
      MessageBar,
      {
        layout: "multiline",
        className: mergeClasses("ppp-web-role-admin", className),
        intent: authOptions.status === QueryStatus.Error ? "error" : "info",
        children: /* @__PURE__ */ jsx(MessageBarBody, { children: t(authOptions.status === QueryStatus.Error ? "options-unavailable" : "not-enabled") })
      }
    );
  }
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-web-role-admin", styles.root, className), children: [
    /* @__PURE__ */ jsxs("section", { className: styles.section, children: [
      /* @__PURE__ */ jsxs("div", { className: styles.heading, children: [
        /* @__PURE__ */ jsx(Title3, { children: t("web-roles-title") }),
        /* @__PURE__ */ jsx(Text, { className: styles.description, children: t("web-roles-description") })
      ] }),
      /* @__PURE__ */ jsx(
        MainGrid,
        {
          tableName: WEB_ROLE_TABLE2,
          customViewDefinitions: webRoleViews,
          viewId: WEB_ROLES_VIEW_ID,
          title: t("web-roles-view-name"),
          pageSize: 25,
          minHeight: "240px",
          maxHeight: "420px",
          children: /* @__PURE__ */ jsxs(GridToolbarItems, { children: [
            /* @__PURE__ */ jsx(NewRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(WebRoleForm, {}) }),
            /* @__PURE__ */ jsx(OpenRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(WebRoleForm, {}) }),
            /* @__PURE__ */ jsx(DeleteRecordGridButton, { behavior: "immediately" })
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("section", { className: styles.section, children: [
      /* @__PURE__ */ jsxs("div", { className: styles.heading, children: [
        /* @__PURE__ */ jsx(Title3, { children: t("table-permissions-title") }),
        /* @__PURE__ */ jsx(Text, { className: styles.description, children: t("table-permissions-description") })
      ] }),
      /* @__PURE__ */ jsx(
        MainGrid,
        {
          tableName: PERMISSION_TABLE2,
          customViewDefinitions: permissionViews,
          viewId: PERMISSIONS_VIEW_ID,
          title: t("table-permissions-view-name"),
          pageSize: 25,
          minHeight: "240px",
          maxHeight: "420px",
          selectionMode: "single",
          children: /* @__PURE__ */ jsxs(GridToolbarItems, { children: [
            permissionUrl === void 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(NewRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(TablePermissionForm, {}) }),
              /* @__PURE__ */ jsx(OpenRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(TablePermissionForm, {}) })
            ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                NavigateNewRecordGridButton,
                {
                  url: permissionUrl(void 0),
                  ...onNavigate === void 0 ? {} : { onNavigate }
                }
              ),
              /* @__PURE__ */ jsx(
                NavigateOpenRecordGridButton,
                {
                  urlFor: (record) => permissionUrl(record.id),
                  ...onNavigate === void 0 ? {} : { onNavigate }
                }
              )
            ] }),
            /* @__PURE__ */ jsx(DeleteRecordGridButton, { behavior: "immediately" })
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("section", { className: styles.section, children: [
      /* @__PURE__ */ jsxs("div", { className: styles.heading, children: [
        /* @__PURE__ */ jsx(Title3, { children: t("configurations-title") }),
        /* @__PURE__ */ jsx(Text, { className: styles.description, children: t("configurations-description") })
      ] }),
      /* @__PURE__ */ jsx(
        MainGrid,
        {
          tableName: CONFIGURATION_TABLE2,
          customViewDefinitions: views,
          viewId: CONFIGURATIONS_VIEW_ID2,
          title: t("configurations-view-name"),
          pageSize: 25,
          minHeight: "240px",
          maxHeight: "420px",
          children: /* @__PURE__ */ jsxs(GridToolbarItems, { children: [
            configurationUrl === void 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(NewRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(WebRoleConfigurationForm, {}) }),
              /* @__PURE__ */ jsx(OpenRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(WebRoleConfigurationForm, {}) })
            ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                NavigateNewRecordGridButton,
                {
                  url: configurationUrl(void 0),
                  ...onNavigate === void 0 ? {} : { onNavigate }
                }
              ),
              /* @__PURE__ */ jsx(
                NavigateOpenRecordGridButton,
                {
                  urlFor: (record) => configurationUrl(record.id),
                  ...onNavigate === void 0 ? {} : { onNavigate }
                }
              )
            ] }),
            /* @__PURE__ */ jsx(DeleteRecordGridButton, { behavior: "immediately" })
          ] })
        }
      )
    ] })
  ] });
}
function WebRoleForm({ className } = {}) {
  const styles = useStyles52();
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-web-role-form", styles.form, className), children: [
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: WEB_ROLE_NAME2 }),
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: WEB_ROLE_DESCRIPTION }),
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: WEB_ROLE_AUTHENTICATED }),
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: WEB_ROLE_ANONYMOUS })
  ] });
}
function WebRoleConfigurationForm({ className } = {}) {
  const styles = useStyles52();
  const { value: mode } = useChoiceColumn(CONFIGURATION_MODE2);
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-web-role-configuration-form", styles.form, className), children: [
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: CONFIGURATION_NAME }),
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: CONFIGURATION_WEB_ROLE }),
    /* @__PURE__ */ jsx(ColumnEdit, { columnName: CONFIGURATION_MODE2 }),
    mode === ASSIGN_FROM_CRITERIA2 ? /* @__PURE__ */ jsx(RoleCriteriaEditor, { stringsPrefix: STRINGS_PREFIX3, criteriaColumn: CONFIGURATION_CRITERIA2 }) : null
  ] });
}
var STRINGS_PREFIX4 = "app.components.invitation-admin";
var INVITATION = "ppp_invitation";
var RECIPIENT_TABLE = "ppp_invitationrecipient";
var RECIPIENTS_RELATIONSHIP = "ppp_invitation_ppp_invitationrecipient";
var PORTAL_ROLES_RELATIONSHIP = "ppp_invitation_ppp_portalrole";
var WEB_ROLES_RELATIONSHIP = "ppp_invitation_mspp_webrole";
var InvitationStatus = {
  Draft: 1,
  ReadyToSend: 8944e5,
  Sent: 894400002,
  Failed: 894400003,
  Expired: 2,
  Canceled: 894400004
};
var RecipientStatus = {
  Pending: 1,
  Processing: 8944e5,
  Sent: 894400001,
  Skipped: 894400002,
  Revoked: 894400003,
  Expired: 894400004,
  Failed: 894400005
};
var invitationStateOf = (status) => status === InvitationStatus.Expired || status === InvitationStatus.Canceled ? 1 : 0;
var recipientStateOf = (status) => status === RecipientStatus.Pending || status === RecipientStatus.Processing || status === RecipientStatus.Sent ? 0 : 1;
var INVITATIONS_VIEW_ID = "6d2b9e41-0f7c-4a58-b3e2-91c4a7d05e36";
var RECIPIENTS_VIEW_ID = "b7a41c2e-93d0-4f6b-8e15-2c9f60d3a874";
var EMAILS_VIEW_ID = "4d1f8e62-7a3b-4c90-b5e1-9f2c6a0d8b37";
var NO_TABLES = [];
var useStyles53 = makeStyles({
  root: { display: "flex", flexDirection: "column", rowGap: tokens.spacingVerticalS, minWidth: 0 },
  heading: { display: "flex", flexDirection: "column", rowGap: tokens.spacingVerticalXXS },
  description: { color: tokens.colorNeutralForeground2 },
  form: { display: "flex", flexDirection: "column", rowGap: tokens.spacingVerticalM, minWidth: 0 },
  // The form's own fields, kept to a readable width; the criteria builder and the recipients grid
  // use all of it.
  fields: { display: "flex", flexDirection: "column", rowGap: tokens.spacingVerticalM, minWidth: 0, maxWidth: "640px" },
  actions: { display: "flex", flexWrap: "wrap", alignItems: "center", columnGap: tokens.spacingHorizontalS, rowGap: tokens.spacingVerticalS }
});
var statusOf = (record) => {
  const value2 = record.properties?.statuscode?.value;
  return value2 === void 0 || value2 === null ? void 0 : Number(value2);
};
var choice = (value2) => ({ $type: 11, value: value2 });
function InvitationAdmin({ className, invitationUrl, onNavigate }) {
  const styles = useStyles53();
  const t = usePrefixedT(STRINGS_PREFIX4);
  const views = useMemo(
    () => [
      {
        id: INVITATIONS_VIEW_ID,
        displayName: t("invitations-view-name"),
        tableName: INVITATION,
        fetchXml: `<fetch><entity name="${INVITATION}"><attribute name="ppp_name" /><attribute name="statuscode" /><attribute name="ppp_recipient" /><attribute name="ppp_expireson" /><attribute name="ppp_sentby" /><attribute name="createdon" /><order attribute="createdon" descending="true" /></entity></fetch>`,
        columns: [
          { columnName: "ppp_name", width: 260 },
          { columnName: "statuscode", width: 140 },
          { columnName: "ppp_recipient", width: 220 },
          { columnName: "ppp_expireson", width: 180 },
          { columnName: "ppp_sentby", width: 180 }
        ]
      }
    ],
    [t]
  );
  return /* @__PURE__ */ jsxs("section", { className: mergeClasses("ppp-invitation-admin", styles.root, className), children: [
    /* @__PURE__ */ jsxs("div", { className: styles.heading, children: [
      /* @__PURE__ */ jsx(Title3, { children: t("invitations-title") }),
      /* @__PURE__ */ jsx(Text, { className: styles.description, children: t("invitations-description") })
    ] }),
    /* @__PURE__ */ jsx(
      MainGrid,
      {
        tableName: INVITATION,
        customViewDefinitions: views,
        viewId: INVITATIONS_VIEW_ID,
        title: t("invitations-view-name"),
        pageSize: 25,
        minHeight: "240px",
        maxHeight: "560px",
        children: /* @__PURE__ */ jsxs(GridToolbarItems, { children: [
          invitationUrl === void 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(NewRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(InvitationForm, {}) }),
            /* @__PURE__ */ jsx(OpenRecordGridButton, { location: "panel", behavior: "immediately", children: /* @__PURE__ */ jsx(InvitationForm, {}) })
          ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(NavigateNewRecordGridButton, { url: invitationUrl(void 0), ...onNavigate === void 0 ? {} : { onNavigate } }),
            /* @__PURE__ */ jsx(NavigateOpenRecordGridButton, { urlFor: (record) => invitationUrl(record.id), ...onNavigate === void 0 ? {} : { onNavigate } })
          ] }),
          /* @__PURE__ */ jsx(SendInvitationButton, {}),
          /* @__PURE__ */ jsx(CancelInvitationButton, {}),
          /* @__PURE__ */ jsx(DeleteRecordGridButton, { behavior: "immediately" })
        ] })
      }
    )
  ] });
}
async function setStatuses(ppp, dialog, context, records, tableName, status, state, failedTitle) {
  const refusals = [];
  for (const record of records) {
    try {
      await ppp.updateRecordAsync({
        id: record.id,
        tableName,
        properties: { statuscode: choice(status), statecode: choice(state) }
      });
    } catch (err) {
      refusals.push(err instanceof Error ? err.message : String(err));
    }
  }
  await context.refresh();
  if (refusals.length > 0) await dialog.showErrorAsync([...new Set(refusals)].join("\n"), { title: failedTitle });
}
function SendInvitationButton() {
  const t = usePrefixedT(STRINGS_PREFIX4);
  const { ppp } = usePowerPortalsPro();
  const dialog = useDialogService();
  const grid = useGridContext();
  const selected = grid.selectedRecords;
  const status = selected.length === 1 ? statusOf(selected[0]) : void 0;
  const sendable = status === InvitationStatus.Draft || status === InvitationStatus.Sent || status === InvitationStatus.Failed;
  const send = async (context) => {
    const record = context.selectedRecords[0];
    const name = record.properties?.ppp_name?.value ?? "";
    const key3 = statusOf(record) === InvitationStatus.Draft ? "send-confirmation" : "send-again-confirmation";
    const answer = await dialog.showConfirmationAsync(t(key3, [name]));
    if (answer.canceled) return;
    await setStatuses(
      ppp,
      dialog,
      context,
      [record],
      INVITATION,
      InvitationStatus.ReadyToSend,
      invitationStateOf(InvitationStatus.ReadyToSend),
      t("status-change-failed")
    );
  };
  return /* @__PURE__ */ jsx(GridButton, { label: t("send"), icon: /* @__PURE__ */ jsx(Send20Regular, {}), disabled: !sendable, onClick: send });
}
function CancelInvitationButton() {
  const t = usePrefixedT(STRINGS_PREFIX4);
  const { ppp } = usePowerPortalsPro();
  const dialog = useDialogService();
  const grid = useGridContext();
  const selected = grid.selectedRecords;
  const cancellable = selected.length > 0 && selected.every((r) => {
    const status = statusOf(r);
    return status !== void 0 && invitationStateOf(status) === 0;
  });
  const cancel = async (context) => {
    const records = context.selectedRecords;
    const name = records.length === 1 ? records[0].properties?.ppp_name?.value ?? "" : String(records.length);
    const answer = await dialog.showConfirmationAsync(t("cancel-confirmation", [name]));
    if (answer.canceled) return;
    await setStatuses(
      ppp,
      dialog,
      context,
      records,
      INVITATION,
      InvitationStatus.Canceled,
      invitationStateOf(InvitationStatus.Canceled),
      t("status-change-failed")
    );
  };
  return /* @__PURE__ */ jsx(GridButton, { label: t("cancel"), icon: /* @__PURE__ */ jsx(DismissCircle20Regular, {}), disabled: !cancellable, onClick: cancel });
}
function InvitationForm({ className } = {}) {
  const styles = useStyles53();
  const t = usePrefixedT(STRINGS_PREFIX4);
  const { ppp } = usePowerPortalsPro();
  const ctx = useRecordContext();
  const authOptions = useAuthOptions();
  const auth = useAuth();
  const staff = auth.status === AuthStatus.Authenticated && auth.user.portalUserType === PortalUserType.SystemUser;
  const { value: status } = useChoiceColumn("statuscode");
  const { value: statusDetail } = useStringColumn("ppp_statusdetail");
  const { value: templateId, setValue: setTemplateId } = useStringColumn("ppp_emailtemplateid");
  const { setValue: setTemplateName } = useStringColumn("ppp_emailtemplatename");
  const [templates, setTemplates] = useState([]);
  const { value: recipient, setValue: setRecipient } = useLookupColumn("ppp_recipient");
  const { value: criteria, setValue: setCriteria } = useStringColumn("ppp_recipientcriteria");
  const hasRecipient = Boolean(recipient);
  const hasCriteria = Boolean(criteria?.trim());
  const recordKey = getRecordReferenceId(ctx.record) ?? "";
  const [chosen, setChosen] = useState({ recordKey, byCriteria: false });
  const byCriteria = hasRecipient !== hasCriteria ? hasCriteria : chosen.recordKey === recordKey && chosen.byCriteria;
  const setAside = useRef({});
  useEffect(() => {
    setAside.current = {};
  }, [recordKey]);
  useEffect(() => {
    if (hasRecipient) setAside.current.recipient = void 0;
    if (hasCriteria) setAside.current.criteria = void 0;
  }, [hasRecipient, hasCriteria]);
  const setRecipientAside = () => {
    if (!hasRecipient) return;
    setAside.current.recipient = recipient;
    setRecipient(null);
  };
  const setCriteriaAside = () => {
    if (!hasCriteria) return;
    setAside.current.criteria = criteria;
    setCriteria(null);
  };
  const changeRecipientSource = (toCriteria) => {
    if (toCriteria === byCriteria) return;
    setChosen({ recordKey, byCriteria: toCriteria });
    const aside = setAside.current;
    if (toCriteria) {
      setRecipientAside();
      if (aside.criteria && !hasCriteria) setCriteria(aside.criteria);
      aside.criteria = void 0;
    } else {
      setCriteriaAside();
      if (aside.recipient && !hasRecipient) setRecipient(aside.recipient);
      aside.recipient = void 0;
    }
  };
  const locked = status !== void 0 && status !== InvitationStatus.Draft && status !== InvitationStatus.Failed;
  const rolesLocked = status !== void 0 && status !== InvitationStatus.Draft;
  const rolesRelationship = authOptions.data?.enhancedAuthorizationEnabled === true ? WEB_ROLES_RELATIONSHIP : PORTAL_ROLES_RELATIONSHIP;
  useEffect(() => {
    const controller = new AbortController();
    void ppp.retrieveRecordsAsync(
      '<fetch><entity name="template"><attribute name="title" /><attribute name="templateid" /><filter type="or"><condition attribute="templatetypecode" operator="eq" value="2" /><condition attribute="templatetypecode" operator="eq" value="8" /></filter><order attribute="title" /></entity></fetch>',
      controller.signal
    ).then(
      (response) => setTemplates((response.tableRecords ?? []).map((record) => ({
        id: record.id ?? "",
        title: record.properties?.title?.value ?? record.id ?? ""
      })))
    ).catch(() => setTemplates([]));
    return () => controller.abort();
  }, [ppp]);
  const recipientViews = useMemo(
    () => [
      {
        id: RECIPIENTS_VIEW_ID,
        displayName: t("recipients-view-name"),
        tableName: RECIPIENT_TABLE,
        fetchXml: `<fetch><entity name="${RECIPIENT_TABLE}"><attribute name="ppp_contact" /><attribute name="statuscode" /><attribute name="ppp_attempts" /><attribute name="ppp_senton" /><attribute name="ppp_acceptedon" /><attribute name="ppp_statusdetail" /><order attribute="ppp_name" /></entity></fetch>`,
        columns: [
          { columnName: "ppp_contact", width: 220 },
          { columnName: "statuscode", width: 120 },
          { columnName: "ppp_attempts", width: 100 },
          { columnName: "ppp_senton", width: 170 },
          { columnName: "ppp_acceptedon", width: 170 },
          { columnName: "ppp_statusdetail", width: 320 }
        ]
      }
    ],
    [t]
  );
  const emailViews = useMemo(
    () => [
      {
        id: EMAILS_VIEW_ID,
        displayName: t("emails-title"),
        tables: [
          {
            table: "email",
            fetchXml: `<fetch><entity name="email"><link-entity name="${RECIPIENT_TABLE}" from="ppp_invitationrecipientid" to="regardingobjectid" link-type="inner"><filter><condition attribute="ppp_invitation" operator="eq" value="${recordKey}" /></filter></link-entity></entity></fetch>`
          }
        ]
      }
    ],
    [t, recordKey]
  );
  const chosenTitle = templates.find((x) => x.id === templateId)?.title ?? t("template-placeholder");
  const saved = Boolean(ctx.record?.id);
  const dialog = useDialogService();
  const { value: name } = useStringColumn("ppp_name");
  const canSend = saved && (status === InvitationStatus.Draft || status === InvitationStatus.Sent || status === InvitationStatus.Failed);
  const canCancel = saved && status !== void 0 && invitationStateOf(status) === 0;
  const [changingStatus, setChangingStatus] = useState(false);
  const setStatus = async (next) => {
    setChangingStatus(true);
    try {
      await ppp.updateRecordAsync({
        id: ctx.record.id,
        tableName: INVITATION,
        properties: { statuscode: choice(next), statecode: choice(invitationStateOf(next)) }
      });
      await ctx.reload();
    } catch (err) {
      await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), { title: t("status-change-failed") });
    } finally {
      setChangingStatus(false);
    }
  };
  const send = async () => {
    const again = status !== InvitationStatus.Draft;
    const answer = await dialog.showConfirmationAsync(t(again ? "send-again-confirmation" : "send-confirmation", [name ?? ""]));
    if (!answer.canceled) await setStatus(InvitationStatus.ReadyToSend);
  };
  const cancel = async () => {
    const answer = await dialog.showConfirmationAsync(t("cancel-confirmation", [name ?? ""]));
    if (!answer.canceled) await setStatus(InvitationStatus.Canceled);
  };
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-invitation-form", styles.form, className), children: [
    /* @__PURE__ */ jsxs("div", { className: styles.fields, children: [
      (canSend || canCancel) && /* @__PURE__ */ jsxs("div", { className: styles.actions, children: [
        canSend && /* @__PURE__ */ jsx(Button, { appearance: "primary", icon: /* @__PURE__ */ jsx(Send20Regular, {}), disabled: ctx.isDirty || changingStatus, onClick: () => void send(), children: t("send") }),
        canCancel && /* @__PURE__ */ jsx(Button, { icon: /* @__PURE__ */ jsx(DismissCircle20Regular, {}), disabled: changingStatus, onClick: () => void cancel(), children: t("cancel") }),
        canSend && ctx.isDirty && /* @__PURE__ */ jsx(Text, { children: t("save-before-sending") })
      ] }),
      locked && /* @__PURE__ */ jsx(MessageBar, { intent: "info", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("locked-message") }) }),
      /* @__PURE__ */ jsx(ColumnEdit, { columnName: "ppp_name" }),
      /* @__PURE__ */ jsx(ColumnEdit, { columnName: "statuscode", readOnly: true }),
      statusDetail ? /* @__PURE__ */ jsx(ColumnEdit, { columnName: "ppp_statusdetail", readOnly: true }) : null,
      /* @__PURE__ */ jsx(ColumnEdit, { columnName: "ppp_website", readOnly: locked }),
      /* @__PURE__ */ jsx(Field, { label: t("recipient-source-label"), children: /* @__PURE__ */ jsxs(
        RadioGroup,
        {
          layout: "horizontal",
          value: byCriteria ? "criteria" : "recipient",
          disabled: locked,
          onChange: (_, data) => changeRecipientSource(data.value === "criteria"),
          children: [
            /* @__PURE__ */ jsx(Radio, { value: "recipient", label: t("recipient-source-recipient") }),
            /* @__PURE__ */ jsx(Radio, { value: "criteria", label: t("recipient-source-criteria") })
          ]
        }
      ) }),
      hasRecipient && hasCriteria && !locked && /* @__PURE__ */ jsxs(MessageBar, { intent: "warning", layout: "multiline", children: [
        /* @__PURE__ */ jsx(MessageBarBody, { children: t(byCriteria ? "both-sources-recipient-hidden" : "both-sources-criteria-hidden") }),
        /* @__PURE__ */ jsx(MessageBarActions, { children: /* @__PURE__ */ jsx(Button, { size: "small", onClick: byCriteria ? setRecipientAside : setCriteriaAside, children: t(byCriteria ? "remove-recipient" : "remove-criteria") }) })
      ] }),
      !byCriteria && /* @__PURE__ */ jsx(ColumnEdit, { columnName: "ppp_recipient", readOnly: locked, description: t("recipient-description") })
    ] }),
    byCriteria && /* @__PURE__ */ jsx(RoleCriteriaEditor, { stringsPrefix: STRINGS_PREFIX4, criteriaColumn: "ppp_recipientcriteria", readOnly: locked }),
    /* @__PURE__ */ jsxs("div", { className: styles.fields, children: [
      /* @__PURE__ */ jsx(ColumnEdit, { columnName: "ppp_expireson" }),
      /* @__PURE__ */ jsx(ColumnEdit, { columnName: "ppp_existingportalusers" }),
      /* @__PURE__ */ jsx(Field, { label: t("template-label"), hint: t("template-description"), children: /* @__PURE__ */ jsxs(
        Dropdown,
        {
          value: chosenTitle,
          selectedOptions: [templateId ?? ""],
          onOptionSelect: (_, data) => {
            const id = data.optionValue ?? "";
            setTemplateId(id || null);
            setTemplateName(id ? templates.find((x) => x.id === id)?.title ?? null : null);
          },
          children: [
            /* @__PURE__ */ jsx(Option, { value: "", children: t("template-placeholder") }),
            templates.map((template) => /* @__PURE__ */ jsx(Option, { value: template.id, children: template.title }, template.id))
          ]
        }
      ) }),
      /* @__PURE__ */ jsx(Field, { label: t("roles-title"), children: /* @__PURE__ */ jsx(ManyToManyLookupEdit, { relationshipName: rolesRelationship, readOnly: rolesLocked }) })
    ] }),
    saved && /* @__PURE__ */ jsxs("section", { className: styles.form, children: [
      /* @__PURE__ */ jsx(Subtitle2, { children: t("recipients-title") }),
      /* @__PURE__ */ jsx(
        SubGrid,
        {
          relationshipName: RECIPIENTS_RELATIONSHIP,
          customViewDefinitions: recipientViews,
          viewId: RECIPIENTS_VIEW_ID,
          maxHeight: "420px",
          children: /* @__PURE__ */ jsxs(GridToolbarItems, { children: [
            /* @__PURE__ */ jsx(RecipientStatusButton, { kind: "resend", invitationStatus: status }),
            /* @__PURE__ */ jsx(RecipientStatusButton, { kind: "revoke", invitationStatus: status })
          ] })
        }
      )
    ] }),
    saved && staff && /* @__PURE__ */ jsx(
      Timeline,
      {
        title: t("emails-title"),
        customViewDefinitions: emailViews,
        filterByRecord: false,
        creatableTables: NO_TABLES,
        pageSize: 5,
        maxHeight: "480px"
      }
    )
  ] });
}
function RecipientStatusButton({ kind, invitationStatus }) {
  const t = usePrefixedT(STRINGS_PREFIX4);
  const { ppp } = usePowerPortalsPro();
  const dialog = useDialogService();
  const grid = useGridContext();
  const target = kind === "resend" ? RecipientStatus.Pending : RecipientStatus.Revoked;
  const allowedFrom = kind === "resend" ? [RecipientStatus.Sent, RecipientStatus.Failed, RecipientStatus.Revoked, RecipientStatus.Skipped, RecipientStatus.Expired] : [RecipientStatus.Pending, RecipientStatus.Processing, RecipientStatus.Sent];
  const enabled = (kind === "revoke" || invitationStatus === InvitationStatus.Sent) && grid.selectedRecords.length > 0 && grid.selectedRecords.every((r) => allowedFrom.includes(statusOf(r) ?? -1));
  const run = async (context) => {
    const records = context.selectedRecords;
    const answer = await dialog.showConfirmationAsync(t(`${kind}-confirmation`, [records.length]));
    if (answer.canceled) return;
    await setStatuses(ppp, dialog, context, records, RECIPIENT_TABLE, target, recipientStateOf(target), t("recipient-change-failed"));
  };
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: t(kind),
      icon: kind === "resend" ? /* @__PURE__ */ jsx(ArrowRepeatAll20Regular, {}) : /* @__PURE__ */ jsx(Prohibited20Regular, {}),
      disabled: !enabled,
      onClick: run
    }
  );
}
var useStyles54 = makeStyles({
  surface: {
    width: "min(1200px, 94vw)",
    maxWidth: "min(1200px, 94vw)"
  },
  tabs: {
    marginBottom: "var(--spacingVerticalM)"
  },
  order: {
    maxWidth: "360px",
    marginBottom: "var(--spacingVerticalM)"
  },
  builder: {
    height: "auto"
  }
});
function orderTypeOf(column) {
  switch (column?.type) {
    case ColumnType.String:
      return "text";
    case ColumnType.Integer:
    case ColumnType.BigInt:
      return "whole";
    case ColumnType.Decimal:
      return "decimal";
    case ColumnType.Double:
      return "float";
    case ColumnType.Money:
      return "currency";
    case ColumnType.DateTime:
      return column.dateOnly ? "date" : "datetime";
    default:
      return void 0;
  }
}
function orderOf(fetchXml) {
  try {
    const order = parseFetchXml(fetchXml).entity.orders[0];
    return order && !order.entityName && !order.alias && order.attribute ? order.attribute : void 0;
  } catch {
    return void 0;
  }
}
function withOrder(fetchXml, column) {
  const query = parseFetchXml(fetchXml);
  return toFetchXml(updateEntity(query, query.entity.id, { orders: [createOrder(column)] }));
}
function MultiTableSearchViewDialog(props) {
  const { open, onCancel } = props;
  return open ? /* @__PURE__ */ jsx(Dialog, { open: true, onOpenChange: (_, data) => !data.open && onCancel(), children: /* @__PURE__ */ jsx(MultiTableSearchViewDialogSurface, { ...props }) }) : null;
}
function MultiTableSearchViewDialogSurface({ tabs, onApply, onCancel }) {
  const t = useT();
  const styles = useStyles54();
  const showsLogicalNames = useShowsLogicalNames();
  const metadata = useReadableFetchXmlMetadata();
  const [active, setActive] = useState(tabs[0]?.table);
  const [drafts, setDrafts] = useState({});
  const queryOf = (tab) => drafts[tab.table] ?? tab.fetchXml;
  const activeTab = tabs.find((tab) => tab.table === active) ?? tabs[0];
  const [columns, setColumns] = useState({});
  const toRead = tabs.map((tab) => tab.table).filter((x) => !(x in columns));
  const toReadKey = toRead.join(",");
  useEffect(() => {
    let canceled = false;
    for (const table of toReadKey.split(",").filter(Boolean)) {
      void metadata.getTable(table).then((detail) => {
        if (!canceled) setColumns((current) => ({ ...current, [table]: detail?.columns.filter(isSelectableColumn) ?? [] }));
      });
    }
    return () => {
      canceled = true;
    };
  }, [toReadKey, metadata]);
  const typeIn = (table, fetchXml) => {
    const order = orderOf(fetchXml);
    return order ? orderTypeOf(columns[table]?.find((x) => x.logicalName === order)) : void 0;
  };
  const first = tabs[0];
  const required = first ? typeIn(first.table, queryOf(first)) : void 0;
  const isFirst = (table) => first?.table === table;
  const orderedRightly = (tab) => {
    if (!(tab.table in columns)) return false;
    const type = typeIn(tab.table, queryOf(tab));
    return type !== void 0 && (isFirst(tab.table) || required === void 0 || type === required);
  };
  const orderColumns = (table) => (columns[table] ?? []).filter((x) => {
    const type = orderTypeOf(x);
    return type !== void 0 && (isFirst(table) || required === void 0 || type === required);
  }).slice().sort((a, b) => metadataLabel(a).localeCompare(metadataLabel(b)));
  const canApply = useMemo(
    () => tabs.every((tab) => {
      try {
        return !hasIncompleteCondition(parseFetchXml(queryOf(tab)).entity) && orderedRightly(tab);
      } catch {
        return false;
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tabs, drafts, columns]
  );
  const activeOrder = activeTab ? orderOf(queryOf(activeTab)) : void 0;
  const activeMisordered = !!activeTab && activeTab.table in columns && !orderedRightly(activeTab);
  const activeColumns = activeTab ? orderColumns(activeTab.table) : [];
  const activeOrderColumn = activeColumns.find((x) => x.logicalName === activeOrder);
  return /* @__PURE__ */ jsx(DialogSurface, { className: styles.surface, "aria-label": t("app.components.multi-table-search.view-title"), children: /* @__PURE__ */ jsxs(DialogBody, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: t("app.components.multi-table-search.view-title") }),
    /* @__PURE__ */ jsxs(DialogContent, { children: [
      tabs.length > 1 && /* @__PURE__ */ jsx(TabList, { className: styles.tabs, selectedValue: activeTab?.table, onTabSelect: (_, data) => setActive(String(data.value)), children: tabs.map((tab) => /* @__PURE__ */ jsx(Tab, { value: tab.table, children: tab.label }, tab.table)) }),
      activeTab && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Field,
          {
            className: mergeClasses("ppp-multi-table-search-view-order-field", styles.order),
            label: t("app.components.multi-table-search.view-order-column"),
            validationState: activeMisordered ? "error" : "none",
            ...activeMisordered && { validationMessage: t("app.components.multi-table-search.view-order-hint") },
            children: /* @__PURE__ */ jsx(
              Dropdown,
              {
                className: "ppp-multi-table-search-view-order",
                disabled: !(activeTab.table in columns),
                value: activeOrderColumn ? metadataLabel(activeOrderColumn) : activeOrder ?? "",
                selectedOptions: activeOrder ? [activeOrder] : [],
                onOptionSelect: (_, data) => {
                  if (!data.optionValue) return;
                  setDrafts((current) => ({ ...current, [activeTab.table]: withOrder(queryOf(activeTab), data.optionValue) }));
                },
                children: activeColumns.map((column) => /* @__PURE__ */ jsx(Option, { value: column.logicalName, children: metadataLabel(column) }, column.logicalName))
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(
          FetchXmlBuilder,
          {
            className: styles.builder,
            value: queryOf(activeTab),
            onChange: (value2) => setDrafts((current) => ({ ...current, [activeTab.table]: value2 })),
            metadata,
            table: activeTab.table,
            allowAggregate: false,
            showLogicalNames: showsLogicalNames,
            sections: { table: false, sorts: false, findColumns: true, options: false, preview: false }
          },
          activeTab.table
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(Button, { onClick: onCancel, children: t("app.components.multi-table-search.view-cancel") }),
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "primary",
          disabled: !canApply,
          onClick: () => onApply(Object.fromEntries(tabs.map((tab) => [tab.table, queryOf(tab)]))),
          children: t("app.components.multi-table-search.view-apply")
        }
      )
    ] })
  ] }) });
}
var MAXIMUM_RECENT_SEARCHES = 5;
var MAXIMUM_RECENT_RECORDS = 5;
var none = () => ({ version: 1, searches: [], records: [] });
var isGuid = (id) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id) && !/^[0-]+$/.test(id);
var recentKeyOf = (userId) => `ppp-multi-table-search-recent:${userId ? userId.toLowerCase() : "anonymous"}`;
function withSearch(recent, search) {
  const term = search?.trim();
  if (!term) return recent;
  const lower = term.toLocaleLowerCase();
  return { ...recent, searches: [term, ...recent.searches.filter((x) => x.toLocaleLowerCase() !== lower)].slice(0, MAXIMUM_RECENT_SEARCHES) };
}
function withRecord(recent, table, id, title) {
  const same2 = (x) => x.table.toLowerCase() === table.toLowerCase() && x.id.toLowerCase() === id.toLowerCase();
  const record = { table, id, ...title?.trim() && { title } };
  return { ...recent, records: [record, ...recent.records.filter((x) => !same2(x))].slice(0, MAXIMUM_RECENT_RECORDS) };
}
function recentToJson(recent) {
  return JSON.stringify({
    version: recent.version,
    searches: recent.searches,
    records: recent.records.map(({ table, id, title }) => ({ table, id, title }))
  });
}
function parseRecent(json2) {
  if (!json2?.trim()) return none();
  let value2;
  try {
    value2 = JSON.parse(json2);
  } catch {
    return none();
  }
  if (typeof value2 !== "object" || value2 === null || Array.isArray(value2)) return none();
  const { searches, records } = value2;
  if (searches !== void 0 && !Array.isArray(searches) || records !== void 0 && !Array.isArray(records)) return none();
  const isText = (x) => typeof x === "string" && x.trim().length > 0;
  return {
    version: 1,
    searches: (searches ?? []).filter(isText).slice(0, MAXIMUM_RECENT_SEARCHES),
    records: (records ?? []).filter((x) => {
      const record = x;
      return !!record && typeof record === "object" && isText(record.table) && isText(record.id) && isGuid(record.id);
    }).map(({ table, id, title }) => ({ table, id, ...typeof title === "string" && title && { title } })).slice(0, MAXIMUM_RECENT_RECORDS)
  };
}
function recentToItem(record) {
  return {
    table: record.table,
    id: record.id,
    title: { column: "", label: "", value: record.title ?? null, isMatch: false },
    details: [],
    otherMatches: [],
    record: { tableName: record.table, id: record.id, properties: {} }
  };
}
var RECENT_CHANGED = "ppp-multi-table-search-recent-changed";
function read(key3) {
  try {
    return parseRecent(window.localStorage.getItem(key3));
  } catch {
    return none();
  }
}
function write(key3, recent) {
  try {
    if (recent.searches.length === 0 && recent.records.length === 0) window.localStorage.removeItem(key3);
    else window.localStorage.setItem(key3, recentToJson(recent));
  } catch {
  }
}
function useMultiTableSearchRecents(enabled) {
  const { authState } = usePowerPortalsPro();
  const key3 = recentKeyOf(authState.status === AuthStatus.Authenticated ? authState.user.userId : null);
  const [recent, setRecent] = useState(none);
  useEffect(() => {
    setRecent(enabled ? read(key3) : none());
    if (!enabled) return;
    const changed = (event) => {
      if (event instanceof StorageEvent && event.key !== null && event.key !== key3) return;
      setRecent(read(key3));
    };
    window.addEventListener(RECENT_CHANGED, changed);
    window.addEventListener("storage", changed);
    return () => {
      window.removeEventListener(RECENT_CHANGED, changed);
      window.removeEventListener("storage", changed);
    };
  }, [enabled, key3]);
  const change = useCallback(
    (how) => {
      if (!enabled) return;
      const changed = how(read(key3));
      write(key3, changed);
      setRecent(changed);
      window.dispatchEvent(new Event(RECENT_CHANGED));
    },
    [enabled, key3]
  );
  return {
    recent,
    addSearch: (search) => change((x) => withSearch(x, search)),
    addRecord: (item, search) => change((x) => withRecord(withSearch(x, search), item.table, item.id, item.title.value)),
    addRecent: (record) => change((x) => withRecord(x, record.table, record.id, record.title)),
    clear: () => change(() => none())
  };
}

// src/multi-table-search/result-keys.ts
var ROW_NAMES = ".ppp-multi-table-search-results .ppp-multi-table-search-name";
function names(root) {
  return [...root.querySelectorAll(ROW_NAMES)].filter((x) => x.tagName !== "SPAN");
}
function searchBox(root) {
  const box = root.querySelector(".ppp-view-search");
  return box ? inputIn(box) ?? box : null;
}
function inputIn(element) {
  for (const scope of [element.shadowRoot, element]) {
    if (!scope) continue;
    const input = scope.querySelector("input");
    if (input) return input;
    for (const child of scope.querySelectorAll("*")) {
      const inner = child.shadowRoot ? inputIn(child) : null;
      if (inner) return inner;
    }
  }
  return null;
}
function moveThroughResults(root, target, key3) {
  const rows = names(root);
  if (rows.length === 0) return false;
  const go = (element) => {
    if (!element) return false;
    element.focus();
    return true;
  };
  if (target.closest(".ppp-view-search")) return key3 === "ArrowDown" && go(rows[0]);
  const name = target.closest(".ppp-multi-table-search-name");
  const at = name ? rows.indexOf(name) : -1;
  if (at < 0) return false;
  switch (key3) {
    case "ArrowDown":
      return go(rows[at + 1]);
    case "ArrowUp":
      return at === 0 ? go(searchBox(root)) : go(rows[at - 1]);
    case "Home":
      return go(rows[0]);
    case "End":
      return go(rows[rows.length - 1]);
    default:
      return false;
  }
}

// src/multi-table-search/search-navigated.ts
var SEARCH_NAVIGATED = "ppp-multi-table-search-navigated";
var MultiTableSearchLayout = {
  /** A card for each row: its table, its name, and each of its columns under its label. */
  Cards: "cards",
  /** Each row on two lines: its name and table, then its columns run together. */
  List: "list",
  /** A table of the rows: their table, their name, and their columns. */
  Grid: "grid"
};
var useStyles55 = makeStyles({
  root: { display: "flex", flexDirection: "column", gap: "var(--spacingVerticalM)", minWidth: 0 },
  // What a screen reader hears of a search, out of sight.
  visuallyHidden: {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    whiteSpace: "nowrap",
    border: 0
  },
  results: { display: "flex", flexDirection: "column", gap: "var(--spacingVerticalM)", minWidth: 0 },
  group: { display: "flex", flexDirection: "column", gap: "var(--spacingVerticalS)" },
  groupHeading: {
    borderBottom: "var(--strokeWidthThin) solid var(--colorNeutralStroke2, #e0e0e0)",
    paddingBottom: "var(--spacingVerticalXS)"
  },
  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 280px), 1fr))",
    gap: "var(--spacingHorizontalM)"
  },
  cardTitle: { display: "flex", flexDirection: "column", gap: "var(--spacingVerticalXXS)", minWidth: 0 },
  table: { color: "var(--colorNeutralForeground3, #616161)" },
  name: { overflowWrap: "anywhere" },
  list: { listStyleType: "none", margin: 0, padding: 0, display: "flex", flexDirection: "column" },
  listItem: {
    paddingTop: "var(--spacingVerticalS)",
    paddingBottom: "var(--spacingVerticalS)",
    borderBottom: "var(--strokeWidthThin) solid var(--colorNeutralStroke2, #e0e0e0)"
  },
  listHeading: { display: "flex", flexWrap: "wrap", alignItems: "baseline", gap: "var(--spacingHorizontalS)" },
  listFields: {
    display: "flex",
    flexWrap: "wrap",
    columnGap: "var(--spacingHorizontalL)",
    rowGap: "var(--spacingVerticalXXS)",
    color: "var(--colorNeutralForeground2, #424242)"
  },
  fieldLabel: { color: "var(--colorNeutralForeground3, #616161)", marginInlineEnd: "var(--spacingHorizontalXS)" },
  otherMatch: { fontStyle: "italic" },
  match: { fontWeight: "var(--fontWeightSemibold, 600)" },
  grid: { width: "100%", borderCollapse: "collapse" },
  cell: {
    textAlign: "start",
    verticalAlign: "top",
    padding: "var(--spacingVerticalS) var(--spacingHorizontalS)",
    borderBottom: "var(--strokeWidthThin) solid var(--colorNeutralStroke2, #e0e0e0)"
  },
  gridField: { display: "block" },
  status: { display: "flex", alignItems: "center", gap: "var(--spacingHorizontalS)" },
  recent: { display: "flex", flexDirection: "column", gap: "var(--spacingVerticalM)" },
  recentList: {
    listStyleType: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "baseline",
    columnGap: "var(--spacingHorizontalL)",
    rowGap: "var(--spacingVerticalXS)"
  },
  recentItem: { display: "flex", alignItems: "baseline", gap: "var(--spacingHorizontalXS)" },
  footer: { display: "flex", justifyContent: "center" }
});
var MAXIMUM_READS_PER_FILL = 100;
var sameId4 = (a, b) => !!a && !!b && a.toLowerCase() === b.toLowerCase();
var ORDER_OPTIONS = [
  { order: MultiTablePageOrder.View, key: "order-by-view", name: "view" },
  { order: MultiTablePageOrder.BestMatch, key: "order-by-best-match", name: "bestMatch" },
  { order: MultiTablePageOrder.Title, key: "order-by-title", name: "title" },
  { order: MultiTablePageOrder.ModifiedOn, key: "order-by-modified-on", name: "modifiedOn" },
  { order: MultiTablePageOrder.CreatedOn, key: "order-by-created-on", name: "createdOn" }
];
var orderNamed = (name) => ORDER_OPTIONS.find((x) => x.name.toLowerCase() === name?.toLowerCase())?.order;
var orderName = (order) => ORDER_OPTIONS.find((x) => x.order === order)?.name ?? "view";
var MODIFIED_WITHIN_OPTIONS = [0, 7, 30, 365];
var MAXIMUM_MODIFIED_WITHIN_DAYS = 3650;
var countsBack = (days) => Number.isInteger(days) && days >= 1 && days <= MAXIMUM_MODIFIED_WITHIN_DAYS;
var showsPageSize = (size) => Number.isInteger(size) && size >= 1 && size <= 100;
var DEFAULT_PAGE_SIZES2 = [10, 25, 50, 100];
var fieldsOf = (item) => [
  ...(item.details ?? []).filter((x) => x.value).map((field) => ({ field, other: false })),
  ...(item.otherMatches ?? []).filter((x) => x.value).map((field) => ({ field, other: true }))
];
function addressSearch(name) {
  if (!name || typeof window === "undefined") return "";
  return new URLSearchParams(window.location.search).get(name) ?? "";
}
function MultiTableSearch({
  search: controlledSearch,
  onSearchChange,
  searchParameterName = "q",
  tables,
  defaultTables,
  defaultViewId: defaultViewId$1,
  layout: layoutProp = MultiTableSearchLayout.Cards,
  onLayoutChange,
  allowLayoutChange = true,
  groupByTable: groupByTableProp = false,
  orderBy: orderByProp = MultiTablePageOrder.BestMatch,
  descending: descendingProp = false,
  mineOnly: mineOnlyProp = false,
  activeOnly: activeOnlyProp = false,
  modifiedWithinDays: modifiedWithinDaysProp,
  showTotals = false,
  pageSize: pageSizeProp = 25,
  pageSizes = DEFAULT_PAGE_SIZES2,
  regarding,
  recordUrl,
  onSelect,
  showRecordLinks = true,
  onNavigate,
  showRecent = true,
  renderItem,
  title,
  allowSavedViews = false,
  savedViewsKey,
  signInUrl = "Account/Login",
  className,
  style
}) {
  const t = useT();
  const T = usePrefixedT("app.components.multi-table-search");
  const styles = useStyles55();
  const { locale } = useLocale();
  const { ppp, authState } = usePowerPortalsPro();
  const recordPages = useRecordPages({ enabled: showRecordLinks && !recordUrl && !onSelect });
  if (!showsPageSize(pageSizeProp) || !pageSizes.every(showsPageSize)) throw new RangeError("A search shows 1 to 100 rows at a time.");
  if (modifiedWithinDaysProp !== void 0 && !countsBack(modifiedWithinDaysProp))
    throw new RangeError(`A search counts back 1 to ${MAXIMUM_MODIFIED_WITHIN_DAYS} days.`);
  const [ownSearch, setOwnSearch] = useState(() => controlledSearch ?? addressSearch(searchParameterName));
  const addressRef = useRef(addressSearch(searchParameterName).trim());
  const [, setAddressChanges] = useState(0);
  useEffect(() => {
    const changed = () => setAddressChanges((x) => x + 1);
    const navigation = window.navigation;
    window.addEventListener("popstate", changed);
    window.addEventListener(SEARCH_NAVIGATED, changed);
    navigation?.addEventListener("currententrychange", changed);
    return () => {
      window.removeEventListener("popstate", changed);
      window.removeEventListener(SEARCH_NAVIGATED, changed);
      navigation?.removeEventListener("currententrychange", changed);
    };
  }, []);
  if (controlledSearch === void 0 && searchParameterName) {
    const address = addressSearch(searchParameterName).trim();
    if (address !== addressRef.current) {
      addressRef.current = address;
      if (address !== ownSearch.trim()) setOwnSearch(address);
    }
  }
  const search = controlledSearch ?? ownSearch;
  const recents = useMultiTableSearchRecents(showRecent);
  const term = search.trim();
  const [layoutChoice, setLayoutChoice] = useState();
  const [orderChoice, setOrderChoice] = useState();
  const [descendingChoice, setDescendingChoice] = useState();
  const [groupedChoice, setGroupedChoice] = useState();
  const [pageSizeChoice, setPageSizeChoice] = useState();
  const [mineChoice, setMineChoice] = useState();
  const [activeChoice, setActiveChoice] = useState();
  const [modifiedChoice, setModifiedChoice] = useState();
  const layout = layoutChoice ?? layoutProp;
  const orderBy = orderChoice ?? orderByProp;
  const descending = descendingChoice ?? descendingProp;
  const grouped = groupedChoice ?? groupByTableProp;
  const pageSize = pageSizeChoice ?? pageSizeProp;
  const pageSizeOptions = pageSizes.length ? [.../* @__PURE__ */ new Set([...pageSizes, pageSizeProp, pageSize])].sort((a, b) => a - b) : [];
  const mineOnly = mineChoice ?? mineOnlyProp;
  const activeOnly = activeChoice ?? activeOnlyProp;
  const modifiedWithinDays = modifiedChoice !== void 0 ? modifiedChoice || void 0 : modifiedWithinDaysProp;
  const signedIn = authState.status === AuthStatus.Authenticated;
  const mineRead = signedIn && mineOnly;
  const control = useMemo(
    () => savedViewControl(SavedViewControlKind.Search, allowSavedViews ? savedViewsKey : void 0),
    [allowSavedViews, savedViewsKey]
  );
  const saved = useSavedViews({ enabled: allowSavedViews, tableName: MultiTableViewSchema.table, control });
  const multiSaved = useMultiTableViews({ enabled: allowSavedViews && saved.available, control });
  const offersSaved = allowSavedViews && saved.available;
  const [viewChoice, setViewChoice] = useState();
  const [edited, setEdited] = useState(null);
  const [editorTabs, setEditorTabs] = useState(null);
  const [labelsDialog, setLabelsDialog] = useState(null);
  const [opened, setOpened] = useState(null);
  const tableSetViewId = opened?.id ?? EVERY_TABLE_VIEW_ID;
  const tableSet = useMultiTableTableSet({ use: MultiTableUses.Search, viewId: tableSetViewId, tables, defaultTables: defaultTables ?? [] });
  const registered = tableSet.registered;
  useEffect(() => {
    void tableSet.registeredAsync().catch(() => void 0);
  }, [authState.status]);
  const everyTableName = T("every-table");
  const allViews = useMemo(
    () => [
      { id: EVERY_TABLE_VIEW_ID, name: everyTableName, tables: null, registered: false },
      ...(registered?.views ?? []).map((x) => ({ id: x.id, name: x.name, tables: x.tables, registered: true })),
      ...offersSaved ? multiSaved.views.map((x) => ({ id: x.id, name: x.name, tables: x.tables, registered: false, layout: parseSavedSearchLayout(x.searchLayout) })) : []
    ],
    [registered, offersSaved, multiSaved.views, everyTableName]
  );
  const userDefault = offersSaved ? defaultViewId(saved.settings, allViews.map((x) => x.id), control) : void 0;
  const views = useMemo(() => {
    const ordered = userDefault ? [...allViews.filter((x) => x.id === userDefault), ...allViews.filter((x) => x.id !== userDefault)] : allViews;
    const offered = ordered.filter((x) => sameId4(x.id, viewChoice) || !offersSaved || !isViewHidden(saved.settings, x.id, control));
    return offered.length > 0 ? offered : ordered;
  }, [allViews, userDefault, viewChoice, offersSaved, saved.settings, control]);
  const view = views.find((x) => sameId4(x.id, viewChoice)) ?? views.find((x) => sameId4(x.id, userDefault)) ?? views.find((x) => sameId4(x.id, defaultViewId$1)) ?? views[0];
  const findSavedView = (id) => multiSaved.views.find((x) => sameId4(x.id, id));
  const [columnLabels, setColumnLabels] = useState([]);
  const currentLayout = () => ({
    version: 1,
    layout,
    orderBy: orderName(orderBy),
    descending,
    groupByTable: grouped,
    pageSize,
    mineOnly,
    activeOnly,
    ...modifiedWithinDays !== void 0 && { modifiedWithinDays },
    columnLabels: [...columnLabels]
  });
  if (opened?.id !== view.id) {
    const own = view.layout;
    const ownLayout = own?.layout && Object.values(MultiTableSearchLayout).includes(own.layout) ? own.layout : void 0;
    setLayoutChoice(ownLayout);
    setOrderChoice(orderNamed(own?.orderBy));
    setDescendingChoice(own?.descending);
    setGroupedChoice(own?.groupByTable);
    const ownPageSize = own?.pageSize !== void 0 && showsPageSize(own.pageSize) ? own.pageSize : void 0;
    setPageSizeChoice(ownPageSize);
    setMineChoice(own?.mineOnly);
    setActiveChoice(own?.activeOnly);
    const ownDays = own?.modifiedWithinDays !== void 0 && countsBack(own.modifiedWithinDays) ? own.modifiedWithinDays : void 0;
    setModifiedChoice(own ? ownDays ?? 0 : void 0);
    setColumnLabels(own?.columnLabels ?? []);
    const openedDays = own ? ownDays : modifiedWithinDaysProp;
    setOpened({
      id: view.id,
      layout: {
        version: 1,
        layout: ownLayout ?? layoutProp,
        orderBy: orderName(orderNamed(own?.orderBy) ?? orderByProp),
        descending: own?.descending ?? descendingProp,
        groupByTable: own?.groupByTable ?? groupByTableProp,
        pageSize: ownPageSize ?? pageSizeProp,
        mineOnly: own?.mineOnly ?? mineOnlyProp,
        activeOnly: own?.activeOnly ?? activeOnlyProp,
        ...openedDays !== void 0 && { modifiedWithinDays: openedDays },
        columnLabels: own?.columnLabels ?? []
      }
    });
  }
  const registeredViewId = !edited && view.registered ? view.id : void 0;
  const shownViewTablesNow = edited ?? (!view.registered ? view.tables : null);
  const tablesNow = registered && sameId4(view.id, tableSetViewId) ? tableSet.tablesOf(shownViewTablesNow, registeredViewId ?? null) : null;
  if (tablesNow && tablesNow.join(",") !== tableSet.known.join(",")) tableSet.setKnown(tableSetViewId, tablesNow);
  const shown = tableSet.shown;
  const tableLabel4 = (table) => tableSet.tableLabel(table);
  const countedLabel = (table) => {
    const label = tableLabel4(table);
    const total = term ? totals[table.toLowerCase()] : void 0;
    if (total !== void 0) return T("table-count", [label, String(total)]);
    const count = term ? mergerRef.current.countOf(table) : void 0;
    return count ? T(count.more ? "table-count-more" : "table-count", [label, String(count.read)]) : label;
  };
  const mergerRef = useRef(new MultiTablePageMerger(descending, locale));
  const [items, setItems] = useState([]);
  const [groups, setGroups] = useState({});
  const [failures, setFailures] = useState([]);
  const [totals, setTotals] = useState({});
  const [unowned, setUnowned] = useState([]);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);
  const [refreshes, setRefreshes] = useState(0);
  const abortRef = useRef(null);
  const request = (reads) => ({
    ...registeredViewId && { viewId: registeredViewId },
    ...shownViewTablesNow && { tables: [...shownViewTablesNow] },
    includeTables: [...shown],
    search: term,
    ...regarding && { regarding },
    orderBy,
    descending,
    // Only for someone signed in, who is offered the choice: no one else owns a row.
    mineOnly: mineRead,
    activeOnly,
    ...modifiedWithinDays !== void 0 && { modifiedWithinDays },
    includeTotals: showTotals,
    pageSize,
    ...reads && { reads: [...reads] }
  });
  const requestRef = useRef(request);
  requestRef.current = request;
  const failuresRef = useRef([]);
  const totalsRef = useRef({});
  const unownedRef = useRef([]);
  const add = (response) => {
    mergerRef.current.add(response);
    const known = failuresRef.current;
    for (const failure of response.failures ?? []) if (!known.some((x) => x.table === failure.table)) known.push(failure);
    for (const total of response.totals ?? []) totalsRef.current[total.table.toLowerCase()] = Number(total.count);
    for (const table of response.unowned ?? []) if (!unownedRef.current.includes(table)) unownedRef.current.push(table);
  };
  const showKept = () => {
    setFailures([...failuresRef.current]);
    setTotals({ ...totalsRef.current });
    setUnowned([...unownedRef.current]);
  };
  const fill = async (shownRows, table, signal) => {
    const wanted = shownRows.length + pageSize;
    for (let reads = 0; shownRows.length < wanted && reads < MAXIMUM_READS_PER_FILL; reads++) {
      shownRows.push(...mergerRef.current.take(wanted - shownRows.length, table));
      const needed = mergerRef.current.readsNeeded(table);
      if (shownRows.length >= wanted || needed.length === 0) break;
      const response = await ppp.loadMultiTablePagesAsync(requestRef.current(needed), signal);
      add(response);
      if ((response.pages ?? []).length === 0 && (response.failures ?? []).length === 0) break;
    }
  };
  const shownKey = shown.join(",");
  const listingKey = JSON.stringify([
    term,
    view.id,
    edited,
    orderBy,
    descending,
    grouped,
    pageSize,
    regarding ?? null,
    shownKey,
    !!registered,
    refreshes,
    mineRead,
    activeOnly,
    modifiedWithinDays ?? null,
    showTotals
  ]);
  useEffect(() => {
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    mergerRef.current = new MultiTablePageMerger(descending, locale);
    failuresRef.current = [];
    totalsRef.current = {};
    unownedRef.current = [];
    setItems([]);
    setGroups({});
    setFailures([]);
    setTotals({});
    setUnowned([]);
    setFailed(false);
    if (!registered || !term || shown.length === 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    void (async () => {
      try {
        add(await ppp.loadMultiTablePagesAsync(requestRef.current(null), controller.signal));
        if (grouped) {
          const byTable = {};
          for (const table of shown) {
            byTable[table] = [];
            await fill(byTable[table], table, controller.signal);
          }
          if (!controller.signal.aborted) setGroups(byTable);
        } else {
          const rows2 = [];
          await fill(rows2, void 0, controller.signal);
          if (!controller.signal.aborted) setItems(rows2);
        }
        if (!controller.signal.aborted) showKept();
      } catch (error) {
        if (controller.signal.aborted) return;
        console.error("[MultiTableSearch] The search could not be run.", error);
        setFailed(true);
      }
      if (!controller.signal.aborted) setLoading(false);
    })();
    return () => controller.abort();
  }, [listingKey]);
  const loadMore = async (table) => {
    const signal = abortRef.current?.signal ?? new AbortController().signal;
    setLoading(true);
    try {
      if (table) {
        const rows2 = [...groups[table] ?? []];
        await fill(rows2, table, signal);
        if (!signal.aborted) setGroups((current) => ({ ...current, [table]: rows2 }));
      } else {
        const rows2 = [...items];
        await fill(rows2, void 0, signal);
        if (!signal.aborted) setItems(rows2);
      }
      if (!signal.aborted) showKept();
    } catch (error) {
      if (signal.aborted) return;
      console.error("[MultiTableSearch] The search could not read more.", error);
      setFailed(true);
    }
    if (!signal.aborted) setLoading(false);
  };
  const refresh = () => {
    tableSet.forget();
    void tableSet.registeredAsync().catch(() => void 0);
    setRefreshes((x) => x + 1);
  };
  const changeSearch = (text2) => {
    if (controlledSearch === void 0) setOwnSearch(text2);
    onSearchChange?.(text2);
    if (searchParameterName && typeof window !== "undefined") {
      const url = new URL(window.location.href);
      if (text2.trim()) url.searchParams.set(searchParameterName, text2.trim());
      else url.searchParams.delete(searchParameterName);
      window.history.replaceState(window.history.state, "", url);
      addressRef.current = text2.trim();
    }
  };
  const chooseView = (id) => {
    setViewChoice(id);
    setEdited(null);
    setLayoutChoice(void 0);
    setOrderChoice(void 0);
    setDescendingChoice(void 0);
    setGroupedChoice(void 0);
  };
  const chooseLayout = (next) => {
    setLayoutChoice(next);
    onLayoutChange?.(next);
  };
  const viewTables = () => [...edited ?? view.tables ?? tableSet.known.map((table) => ({ table }))];
  const editableTables = () => viewTables().filter((x) => shown.some((table) => table.toLowerCase() === x.table.toLowerCase()));
  const titleOf = (table) => table.overrides?.title || (tableSet.infoOf(table.table)?.definition.title ?? void 0);
  const editorQuery = async (table) => {
    const titleColumn = titleOf(table);
    const quickFind = (table.viewType ?? MultiTableViewType.FetchXml) === MultiTableViewType.FetchXml && !table.fetchXml?.trim();
    let fetchXml;
    if (quickFind) {
      const viewsOfTable = await ppp.retrieveViewsForTableAsync(table.table);
      fetchXml = viewsOfTable.find((x) => x.type === 4 && x.fetchXml)?.fetchXml ?? `<fetch><entity name="${table.table}" /></fetch>`;
    } else {
      fetchXml = (await tableSet.filterQueries([table]))[0]?.fetchXml ?? void 0;
    }
    if (!fetchXml) return void 0;
    const query = parseFetchXml(fetchXml);
    if ((quickFind || query.entity.orders.length === 0) && titleColumn)
      return toFetchXml(updateEntity(query, query.entity.id, { orders: [createOrder(titleColumn)] }));
    return toFetchXml(query);
  };
  const openEditor = async () => {
    const tabs = [];
    for (const table of editableTables()) {
      const fetchXml = await editorQuery(table);
      if (fetchXml) tabs.push({ table: table.table, label: table.label ?? tableLabel4(table.table), fetchXml });
    }
    setEditorTabs(tabs);
  };
  const applyEdit = (queries) => {
    setEdited(
      viewTables().map((x) => {
        const fetchXml = queries[x.table];
        return fetchXml ? { table: x.table, fetchXml, ...x.overrides && { overrides: x.overrides }, ...x.label && { label: x.label } } : x;
      })
    );
    setEditorTabs(null);
  };
  const openedLayout = opened?.id === view.id ? opened.layout : void 0;
  const layoutChanged = !!openedLayout && (openedLayout.layout !== layout || openedLayout.orderBy !== orderName(orderBy) || (openedLayout.descending ?? false) !== descending || (openedLayout.groupByTable ?? false) !== grouped || openedLayout.pageSize !== pageSize || (openedLayout.mineOnly ?? false) !== mineOnly || (openedLayout.activeOnly ?? false) !== activeOnly || openedLayout.modifiedWithinDays !== modifiedWithinDays);
  const viewChanged = !!edited || tableSet.tablesChanged || layoutChanged;
  const currentTables = () => shownViewTables(
    viewTables(),
    tableSet.known,
    shown,
    (table) => !!tableSet.infoOf(table)?.isActivity
  );
  const shownSaved = findSavedView(view.id);
  const savedOver = (id, layoutNow) => {
    setViewChoice(id);
    setEdited(null);
    setOpened({ id, layout: layoutNow });
  };
  const shownColumns = async (viewTable, fetchXml) => {
    const table = viewTable.table;
    const entity = parseFetchXml(fetchXml).entity;
    const titleColumn = titleOf(viewTable);
    const metadata = await ppp.retrieveTableMetadataAsync(table).catch(() => void 0);
    const own = (name2) => {
      const key3 = `tables.${table}.columns.${name2}.label`;
      const label = t(key3);
      return label !== key3 ? label : metadata?.columns.find((x) => x.columnName === name2)?.displayName || name2;
    };
    const joinedLabel = (of, name2) => {
      const key3 = `tables.${of}.columns.${name2}.label`;
      const label = t(key3);
      return label !== key3 ? label : name2;
    };
    const columns = [];
    const firstOrder = entity.orders[0];
    const order = orderBy === MultiTablePageOrder.ModifiedOn ? "modifiedon" : orderBy === MultiTablePageOrder.CreatedOn ? "createdon" : orderBy === MultiTablePageOrder.View && firstOrder && !firstOrder.entityName && !firstOrder.alias && firstOrder.attribute ? firstOrder.attribute : void 0;
    if (order && order !== titleColumn && !entity.attributes.some((x) => x.name === order)) columns.push({ key: order, label: own(order) });
    for (const attribute of entity.attributes) {
      if (!attribute.name || attribute.name === titleColumn || attribute.name === metadata?.primaryIdColumn) continue;
      columns.push({ key: attribute.alias ?? attribute.name, label: own(attribute.name) });
    }
    for (const link of entity.linkEntities.filter((x) => x.alias)) {
      for (const attribute of link.attributes.filter((x) => x.name))
        columns.push({ key: attribute.alias ?? `${link.alias}.${attribute.name}`, label: `${joinedLabel(link.name, attribute.name)} (${tableLabel4(link.name)})` });
    }
    return columns;
  };
  const session = useSavedViewSession({
    saved,
    signInUrl,
    deletingText: t("app.components.grid.saved-views-deleting"),
    operations: {
      shownViewId: view.id,
      savedViewName: (id) => findSavedView(id)?.name,
      managedViewName: (id) => allViews.find((x) => sameId4(x.id, id))?.name ?? findSavedView(id)?.name ?? T("title"),
      managedViews: () => allViews.map((x) => ({
        id: x.id,
        name: x.name,
        isSaved: !!findSavedView(x.id),
        isDefault: userDefault === x.id,
        isHidden: isViewHidden(saved.settings, x.id, control),
        isShown: x.id === view.id
      })),
      save: async () => {
        const tablesSaved = currentTables();
        if (!shownSaved || tablesSaved.length === 0) return;
        const layoutNow = currentLayout();
        await multiSaved.update(shownSaved.id, { tables: tablesSaved, searchLayout: savedSearchLayoutToJson(layoutNow) });
        savedOver(shownSaved.id, layoutNow);
      },
      saveAs: async (name2) => {
        const tablesSaved = currentTables();
        if (tablesSaved.length === 0) return;
        const layoutNow = currentLayout();
        const created = await multiSaved.create(name2, tablesSaved, { searchLayout: savedSearchLayoutToJson(layoutNow) });
        savedOver(created.id, layoutNow);
      },
      clone: async (id, name2) => {
        const source = allViews.find((x) => sameId4(x.id, id));
        if (!source) return;
        const tablesOfIt = source.tables ?? (registered?.tables ?? []).filter((x) => !tableSet.allowed || tableSet.allowed.has(x.table)).map((x) => ({ table: x.table }));
        if (tablesOfIt.length === 0) return;
        await multiSaved.create(name2, tablesOfIt, { searchLayout: findSavedView(id)?.searchLayout });
      },
      rename: async (id, name2) => void await multiSaved.update(id, { name: name2 }),
      remove: async (id) => {
        await multiSaved.remove(id);
        await saved.reloadSettings();
        if (sameId4(view.id, id)) chooseView(EVERY_TABLE_VIEW_ID);
      },
      openView: (id) => {
        if (!sameId4(id, view.id)) chooseView(id);
      },
      // Retitles a saved view's columns: the columns each table's query shows.
      editColumnLabels: (id) => {
        const target = allViews.find((x) => sameId4(x.id, id));
        if (!findSavedView(id) || !target?.tables) return;
        if (!sameId4(id, view.id)) chooseView(id);
        const targetTables = target.tables;
        const targetLabels = { version: 1, columnLabels: [...target.layout?.columnLabels ?? []] };
        void (async () => {
          const columns = [];
          for (const table of targetTables) {
            const fetchXml = await editorQuery(table);
            if (!fetchXml) continue;
            for (const column of await shownColumns(table, fetchXml)) {
              const label = searchColumnLabelOf(targetLabels, table.table, column.key);
              columns.push({ key: `${table.table}|${column.key}`, ownTitle: `${column.label} \u2014 ${tableLabel4(table.table)}`, ...label && { label } });
            }
          }
          setLabelsDialog({ viewId: id, columns });
        })();
      }
    }
  });
  const saveLabels = (labels) => {
    const dialog = labelsDialog;
    setLabelsDialog(null);
    const target = dialog ? findSavedView(dialog.viewId) : void 0;
    if (!dialog || !target) return;
    const titles = [];
    for (const [key3, label] of labels) {
      const [table, column] = [key3.slice(0, key3.indexOf("|")), key3.slice(key3.indexOf("|") + 1)];
      if (label.trim() && table && column) titles.push({ table, column, label: label.trim() });
    }
    const layoutNow = { ...parseSavedSearchLayout(target.searchLayout) ?? currentLayout(), columnLabels: titles };
    void session.run(async () => {
      await multiSaved.update(target.id, { searchLayout: savedSearchLayoutToJson(layoutNow) });
      if (sameId4(view.id, target.id)) {
        setColumnLabels(titles);
        setOpened((current) => current && sameId4(current.id, target.id) ? { id: current.id, layout: { ...current.layout, columnLabels: titles } } : current);
      }
    });
  };
  const fieldLabel = (item, field) => searchColumnLabelOf({ version: 1, columnLabels: [...columnLabels] }, item.table, field.column) ?? field.label;
  const highlighted = term.replace(/^\*+|\*+$/g, "");
  const value2 = (field, empty) => !field.value ? /* @__PURE__ */ jsx("span", { children: empty }) : field.isMatch ? /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-multi-table-search-value", "ppp-multi-table-search-match", styles.match), children: /* @__PURE__ */ jsx(Highlighter, { text: field.value, searchText: highlighted, delimiters: "*" }) }) : /* @__PURE__ */ jsx("span", { className: "ppp-multi-table-search-value", children: field.value });
  const linkOf = (item) => {
    if (recordUrl) return recordUrl(item);
    const page = showRecordLinks && !onSelect ? findRecordPage(recordPages, item.table) : void 0;
    return page ? recordPageUrl(page, item.id) : void 0;
  };
  const selectable = (item) => !linkOf(item) && !!onSelect;
  const keepOpened = (item) => recents.addRecord(item, term);
  const pick = (item) => {
    keepOpened(item);
    onSelect(item);
  };
  const name = (item) => {
    const text2 = value2(item.title, T("no-title"));
    const href = linkOf(item);
    if (href)
      return /* @__PURE__ */ jsx(
        "a",
        {
          className: mergeClasses("ppp-multi-table-search-name", styles.name),
          href,
          onClick: (event) => {
            keepOpened(item);
            followRecordLink(event, href, onNavigate);
          },
          children: text2
        }
      );
    if (selectable(item))
      return /* @__PURE__ */ jsx(Button, { appearance: "transparent", className: mergeClasses("ppp-multi-table-search-name", styles.name), onClick: () => pick(item), children: text2 });
    return /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-multi-table-search-name", styles.name), children: text2 });
  };
  const fieldSpan = (item, field, other, extra) => /* @__PURE__ */ jsxs(
    "span",
    {
      className: mergeClasses("ppp-multi-table-search-field", other && "ppp-multi-table-search-other-match", other && styles.otherMatch, extra),
      children: [
        /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-multi-table-search-field-label", styles.fieldLabel), children: fieldLabel(item, field) }),
        value2(field)
      ]
    },
    `${field.column}${other ? ":other" : ""}`
  );
  const rows = (list, showTable) => {
    if (layout === MultiTableSearchLayout.Grid)
      return /* @__PURE__ */ jsxs("table", { className: mergeClasses("ppp-multi-table-search-grid", styles.grid), children: [
        /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
          showTable && /* @__PURE__ */ jsx("th", { className: styles.cell, children: T("column-table") }),
          /* @__PURE__ */ jsx("th", { className: styles.cell, children: T("column-title") }),
          /* @__PURE__ */ jsx("th", { className: styles.cell, children: T("column-details") })
        ] }) }),
        /* @__PURE__ */ jsx("tbody", { children: list.map((item) => /* @__PURE__ */ jsxs("tr", { className: "ppp-multi-table-search-row", "data-table": item.table, children: [
          showTable && /* @__PURE__ */ jsx("td", { className: styles.cell, children: tableLabel4(item.table) }),
          /* @__PURE__ */ jsx("td", { className: styles.cell, children: name(item) }),
          /* @__PURE__ */ jsx("td", { className: styles.cell, children: fieldsOf(item).map(({ field, other }) => fieldSpan(item, field, other, styles.gridField)) })
        ] }, `${item.table}:${item.id}`)) })
      ] });
    if (layout === MultiTableSearchLayout.List)
      return /* @__PURE__ */ jsx("ol", { className: mergeClasses("ppp-multi-table-search-list", styles.list), children: list.map((item) => /* @__PURE__ */ jsx("li", { className: mergeClasses("ppp-multi-table-search-row", styles.listItem), "data-table": item.table, children: renderItem ? renderItem(item) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("div", { className: styles.listHeading, children: [
          name(item),
          showTable && /* @__PURE__ */ jsx(Caption1, { className: styles.table, children: tableLabel4(item.table) })
        ] }),
        /* @__PURE__ */ jsx("div", { className: styles.listFields, children: fieldsOf(item).map(({ field, other }) => fieldSpan(item, field, other)) })
      ] }) }, `${item.table}:${item.id}`)) });
    return /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-multi-table-search-cards", styles.cards), children: list.map((item) => /* @__PURE__ */ jsx(
      RecordCard,
      {
        className: "ppp-multi-table-search-row",
        "data-table": item.table,
        template: renderItem?.(item),
        title: /* @__PURE__ */ jsxs("div", { className: styles.cardTitle, children: [
          /* @__PURE__ */ jsx(Text, { weight: "semibold", children: name(item) }),
          showTable && /* @__PURE__ */ jsx(Caption1, { className: styles.table, children: tableLabel4(item.table) })
        ] }),
        fields: fieldsOf(item).map(({ field, other }) => ({
          key: `${field.column}${other ? ":other" : ""}`,
          label: other ? `${fieldLabel(item, field)} \xB7 ${T("also-matched")}` : fieldLabel(item, field),
          value: value2(field)
        })),
        clickable: selectable(item),
        onClick: selectable(item) ? () => pick(item) : void 0
      },
      `${item.table}:${item.id}`
    )) });
  };
  const recentRecords = recents.recent.records.filter((x) => !!linkOf(recentToItem(x)) || !!onSelect);
  const followRecent = (record, href) => (event) => {
    recents.addRecent(record);
    followRecordLink(event, href, onNavigate);
  };
  const pickRecent = (record) => {
    recents.addRecent(record);
    onSelect?.(recentToItem(record));
  };
  const recent = () => showRecent && (recents.recent.searches.length > 0 || recentRecords.length > 0) ? /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-multi-table-search-recent", styles.recent), children: [
    recents.recent.searches.length > 0 && /* @__PURE__ */ jsxs("section", { className: "ppp-multi-table-search-recent-searches", children: [
      /* @__PURE__ */ jsx(Subtitle2, { as: "h3", children: T("recent-searches") }),
      /* @__PURE__ */ jsx("ul", { className: styles.recentList, children: recents.recent.searches.map((x) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "transparent",
          className: "ppp-multi-table-search-recent-search",
          icon: /* @__PURE__ */ jsx(History16Regular, {}),
          onClick: () => {
            recents.addSearch(x);
            changeSearch(x);
          },
          children: x
        }
      ) }, x)) })
    ] }),
    recentRecords.length > 0 && /* @__PURE__ */ jsxs("section", { className: "ppp-multi-table-search-recent-records", children: [
      /* @__PURE__ */ jsx(Subtitle2, { as: "h3", children: T("recent-records") }),
      /* @__PURE__ */ jsx("ul", { className: styles.recentList, children: recentRecords.map((x) => {
        const href = linkOf(recentToItem(x));
        return /* @__PURE__ */ jsxs("li", { className: styles.recentItem, children: [
          href ? /* @__PURE__ */ jsx("a", { className: "ppp-multi-table-search-recent-record", href, onClick: followRecent(x, href), children: x.title ?? T("no-title") }) : /* @__PURE__ */ jsx(Button, { appearance: "transparent", className: "ppp-multi-table-search-recent-record", onClick: () => pickRecent(x), children: x.title ?? T("no-title") }),
          /* @__PURE__ */ jsx(Caption1, { className: styles.table, children: tableLabel4(x.table) })
        ] }, `${x.table}:${x.id}`);
      }) })
    ] }),
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Button, { appearance: "subtle", className: "ppp-multi-table-search-recent-clear", onClick: recents.clear, children: T("recent-clear") }) })
  ] }) : null;
  const canReload = !loading;
  const failedTables = failures.length > 0 ? failures.map((x) => tableLabel4(x.table)).join(", ") : null;
  const unownedTables = mineOnly && unowned.length > 0 ? unowned.map(tableLabel4).join(", ") : null;
  const announcement = (() => {
    if (loading || failed || !term || shown.length === 0) return "";
    const shownCount = grouped ? Object.values(groups).reduce((sum, rows2) => sum + rows2.length, 0) : items.length;
    if (shownCount === 0) return T("announce-none");
    const counted = shown.every((x) => totals[x.toLowerCase()] !== void 0);
    const count = counted ? shown.reduce((sum, x) => sum + (totals[x.toLowerCase()] ?? 0), 0) : shownCount;
    if (!counted && mergerRef.current.hasMore) return T("announce-more", [String(count)]);
    return count === 1 ? T("announce-one") : T("announce-count", [String(count)]);
  })();
  const unrelatedTables = (() => {
    if (!regarding) return null;
    const overridden = new Set(viewTables().filter((x) => x.overrides?.regarding).map((x) => x.table.toLowerCase()));
    const unrelated = shown.filter((table) => {
      const info = tableSet.infoOf(table);
      return !!info && !info.definition.regarding && !overridden.has(table.toLowerCase());
    });
    return unrelated.length > 0 ? unrelated.map(tableLabel4).join(", ") : null;
  })();
  const groupedTables = shown.filter((table) => (groups[table]?.length ?? 0) > 0 || mergerRef.current.hasMoreOf(table));
  const nothing = !failed && items.length === 0 && Object.values(groups).every((x) => x.length === 0);
  return /* @__PURE__ */ jsxs(
    "section",
    {
      className: mergeClasses("ppp-multi-table-search", styles.root, className),
      style,
      onKeyDown: (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.defaultPrevented) return;
        if (moveThroughResults(event.currentTarget, event.target, event.key)) event.preventDefault();
      },
      children: [
        /* @__PURE__ */ jsxs(
          ViewToolbar,
          {
            className: "ppp-multi-table-search-header",
            ariaLabel: T("toolbar"),
            start: views.length > 1 || session.showsMenu ? /* @__PURE__ */ jsx(
              ViewPicker,
              {
                className: "ppp-multi-table-search-view-picker",
                options: views.map((x) => ({ id: x.id, label: x.name })),
                value: view.id,
                onChange: chooseView,
                isUserView: (id) => !!findSavedView(id),
                disabled: !canReload
              }
            ) : /* @__PURE__ */ jsx(Subtitle2, { as: "h2", children: title ?? T("title") }),
            children: [
              allowLayoutChange && /* @__PURE__ */ jsx(
                Dropdown,
                {
                  className: "ppp-multi-table-search-layout-picker",
                  "aria-label": T("layout"),
                  value: T(`layout-${layout}`),
                  selectedOptions: [layout],
                  onOptionSelect: (_, data) => data.optionValue && chooseLayout(data.optionValue),
                  children: Object.values(MultiTableSearchLayout).map((x) => /* @__PURE__ */ jsx(Option, { value: x, children: T(`layout-${x}`) }, x))
                }
              ),
              /* @__PURE__ */ jsx(ViewSearchBox, { value: search, onChange: changeSearch, placeholder: T("search") }),
              /* @__PURE__ */ jsx(
                ViewFilterMenu,
                {
                  changed: viewChanged,
                  disabled: !canReload,
                  onEditFilters: allowSavedViews && shown.length > 0 ? () => void openEditor() : void 0,
                  refinements: {
                    items: /* @__PURE__ */ jsxs(Fragment, { children: [
                      /* @__PURE__ */ jsx(MenuGroupHeader, { children: T("refine-title") }),
                      signedIn && /* @__PURE__ */ jsx(MenuItemCheckbox, { name: "mine", value: "mine", className: "ppp-multi-table-search-mine-only", children: T("mine-only") }),
                      /* @__PURE__ */ jsx(MenuItemCheckbox, { name: "active", value: "active", className: "ppp-multi-table-search-active-only", children: T("active-only") }),
                      /* @__PURE__ */ jsx(MenuGroupHeader, { children: T("modified-title") }),
                      MODIFIED_WITHIN_OPTIONS.map((days) => /* @__PURE__ */ jsx(MenuItemRadio, { name: "modified", value: String(days), className: "ppp-multi-table-search-modified-within", "data-days": days, children: days === 0 ? T("modified-any") : days === 365 ? T("modified-year") : T("modified-days", [String(days)]) }, days))
                    ] }),
                    checkedValues: {
                      mine: mineOnly ? ["mine"] : [],
                      active: activeOnly ? ["active"] : [],
                      modified: [String(modifiedWithinDays ?? 0)]
                    },
                    onCheckedValueChange: (name2, checked) => {
                      if (name2 === "mine") setMineChoice(checked.includes("mine"));
                      if (name2 === "active") setActiveChoice(checked.includes("active"));
                      if (name2 === "modified") setModifiedChoice(Number(checked[0] ?? 0));
                    }
                  },
                  tables: tableSet.menuTables(countedLabel),
                  onTableShownChange: tableSet.showTable,
                  savedViews: session.menu({
                    canSave: !!shownSaved && viewChanged,
                    canSaveAs: currentTables().length > 0 && viewChanged,
                    canSetDefault: userDefault !== view.id
                  })
                }
              ),
              /* @__PURE__ */ jsx(ViewRefreshButton, { disabled: !canReload, onClick: refresh }),
              /* @__PURE__ */ jsxs(
                Menu,
                {
                  checkedValues: {
                    orderBy: [String(orderBy)],
                    order: [descending ? "descending" : "ascending"],
                    group: grouped ? ["table"] : []
                  },
                  onCheckedValueChange: (_, data) => {
                    if (data.name === "orderBy") setOrderChoice(Number(data.checkedItems[0]));
                    if (data.name === "order") setDescendingChoice(data.checkedItems[0] === "descending");
                    if (data.name === "group") setGroupedChoice(data.checkedItems.includes("table"));
                  },
                  children: [
                    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: t("app.buttons.settings.label"), relationship: "label", children: /* @__PURE__ */ jsx(Button, { appearance: "subtle", className: "ppp-multi-table-search-settings", icon: /* @__PURE__ */ jsx(Settings24Regular, {}) }) }) }),
                    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs(MenuList, { children: [
                      ORDER_OPTIONS.map((x) => /* @__PURE__ */ jsx(MenuItemRadio, { name: "orderBy", value: String(x.order), className: "ppp-multi-table-search-order-by", children: T(x.key) }, x.order)),
                      /* @__PURE__ */ jsx(MenuDivider, {}),
                      /* @__PURE__ */ jsx(MenuItemRadio, { name: "order", value: "ascending", className: "ppp-multi-table-search-ascending", children: T("order-ascending") }),
                      /* @__PURE__ */ jsx(MenuItemRadio, { name: "order", value: "descending", className: "ppp-multi-table-search-descending", children: T("order-descending") }),
                      /* @__PURE__ */ jsx(MenuDivider, {}),
                      /* @__PURE__ */ jsx(MenuItemCheckbox, { name: "group", value: "table", children: T("group-by-table") }),
                      pageSizeOptions.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
                        /* @__PURE__ */ jsx(MenuDivider, {}),
                        /* @__PURE__ */ jsxs(
                          Menu,
                          {
                            checkedValues: { pageSize: [String(pageSize)] },
                            onCheckedValueChange: (_, data) => {
                              if (data.name === "pageSize") setPageSizeChoice(Number(data.checkedItems[0]));
                            },
                            children: [
                              /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { className: "ppp-multi-table-search-page-size", children: T("page-size") }) }),
                              /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: pageSizeOptions.map((size) => /* @__PURE__ */ jsx(
                                MenuItemRadio,
                                {
                                  name: "pageSize",
                                  value: String(size),
                                  className: "ppp-multi-table-search-page-size-option",
                                  "data-page-size": size,
                                  children: size
                                },
                                size
                              )) }) })
                            ]
                          }
                        )
                      ] })
                    ] }) })
                  ]
                }
              )
            ]
          }
        ),
        unownedTables && /* @__PURE__ */ jsx(MessageBar, { className: "ppp-multi-table-search-unowned", intent: "info", children: /* @__PURE__ */ jsx(MessageBarBody, { children: T("unowned-tables", [unownedTables]) }) }),
        unrelatedTables && /* @__PURE__ */ jsx(MessageBar, { className: "ppp-multi-table-search-unrelated", intent: "info", children: /* @__PURE__ */ jsx(MessageBarBody, { children: T("unrelated-tables", [unrelatedTables]) }) }),
        /* @__PURE__ */ jsx(
          ViewLoadMessages,
          {
            failed,
            errorText: T("error"),
            failedTables: failedTables ? T("failed-tables", [failedTables]) : null,
            retryText: T("retry"),
            onRetry: refresh,
            retryDisabled: !canReload
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-multi-table-search-results", styles.results), "data-layout": layout, children: [
          grouped ? groupedTables.map((table) => /* @__PURE__ */ jsxs("section", { className: mergeClasses("ppp-multi-table-search-group", styles.group), "data-table": table, children: [
            /* @__PURE__ */ jsx("div", { className: styles.groupHeading, role: "heading", "aria-level": 3, children: /* @__PURE__ */ jsx(Text, { weight: "semibold", children: countedLabel(table) }) }),
            rows(groups[table] ?? [], false),
            !loading && mergerRef.current.hasMoreOf(table) && /* @__PURE__ */ jsx("div", { className: styles.footer, children: /* @__PURE__ */ jsx(Button, { appearance: "subtle", className: "ppp-multi-table-search-show-more", onClick: () => void loadMore(table), children: T("show-more") }) })
          ] }, table)) : items.length > 0 && rows(items, true),
          loading ? /* @__PURE__ */ jsxs("div", { className: styles.status, children: [
            /* @__PURE__ */ jsx(Spinner, { size: "tiny" }),
            /* @__PURE__ */ jsx("span", { children: T("loading") })
          ] }) : !failed && !term ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(Text, { className: "ppp-multi-table-search-prompt", children: T("prompt") }),
            recent()
          ] }) : !failed && registered && shown.length === 0 ? /* @__PURE__ */ jsx(Text, { className: "ppp-multi-table-search-empty", children: T("empty-tables") }) : nothing && registered ? /* @__PURE__ */ jsx(Text, { className: "ppp-multi-table-search-empty", children: T("empty") }) : null,
          !grouped && !loading && mergerRef.current.hasMore && /* @__PURE__ */ jsx("div", { className: styles.footer, children: /* @__PURE__ */ jsx(Button, { className: "ppp-multi-table-search-load-more", onClick: () => void loadMore(void 0), children: T("load-more") }) })
        ] }),
        /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-multi-table-search-visually-hidden", styles.visuallyHidden), role: "status", "aria-live": "polite", children: announcement }),
        /* @__PURE__ */ jsx(MultiTableSearchViewDialog, { open: !!editorTabs, tabs: editorTabs ?? [], onApply: applyEdit, onCancel: () => setEditorTabs(null) }),
        /* @__PURE__ */ jsx(GridColumnLabelsDialog, { open: !!labelsDialog, columns: labelsDialog?.columns ?? [], onSave: saveLabels, onCancel: () => setLabelsDialog(null) }),
        /* @__PURE__ */ jsx(SavedViewDialogs, { session })
      ]
    }
  );
}

// src/multi-table-search/box-keys.ts
function isEditable(target) {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
}
function isSearchShortcut(event) {
  if (event.defaultPrevented || event.altKey) return false;
  if ((event.ctrlKey || event.metaKey) && !event.shiftKey && event.key.toLowerCase() === "k") return true;
  return event.key === "/" && !event.ctrlKey && !event.metaKey && !isEditable(event.composedPath?.()[0] ?? event.target);
}
var NARROW = "@media (max-width: 640px)";
var useStyles56 = makeStyles({
  root: { display: "inline-flex", alignItems: "center", minWidth: 0, width: "100%" },
  box: { width: "100%", minWidth: 0 },
  // Folded on a narrow screen: the button alone, whatever width the page gave the box.
  folded: { [NARROW]: { width: "auto !important" } },
  foldedBox: { [NARROW]: { display: "none" } },
  toggle: { display: "none" },
  foldedToggle: { [NARROW]: { display: "inline-flex" } },
  option: { display: "flex", alignItems: "center", gap: "var(--spacingHorizontalS)", minWidth: 0, width: "100%" },
  text: { flex: "1 1 auto", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  table: { flex: "0 0 auto", color: "var(--colorNeutralForeground3, #616161)" }
});
function MultiTableSearchBox({
  searchPageUrl,
  searchParameterName = "q",
  tables,
  maximumResults = 6,
  recordUrl,
  onSelect,
  showRecordLinks = true,
  showRecent = true,
  onNavigate,
  placeholder,
  keyboardShortcut = true,
  collapsible = false,
  className,
  style
}) {
  const t = useT();
  const T = usePrefixedT("app.components.multi-table-search");
  const styles = useStyles56();
  const { locale } = useLocale();
  const { ppp } = usePowerPortalsPro();
  if (maximumResults < 1 || maximumResults > 25) throw new RangeError("A search box suggests 1 to 25 rows.");
  if (!searchPageUrl?.trim()) throw new Error("A search box needs the page its results show on.");
  const recordPages = useRecordPages({ enabled: showRecordLinks && !recordUrl && !onSelect });
  const recents = useMultiTableSearchRecents(showRecent);
  const [text2, setText] = useState("");
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const term = text2.trim();
  const rootRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [focusing, setFocusing] = useState(0);
  const bringUp = () => {
    setExpanded(true);
    setFocusing((x) => x + 1);
  };
  useEffect(() => {
    if (focusing > 0) rootRef.current?.querySelector("input")?.focus();
  }, [focusing]);
  useEffect(() => {
    if (!keyboardShortcut) return;
    const onKeyDown = (event) => {
      if (!isSearchShortcut(event) || !rootRef.current?.isConnected) return;
      event.preventDefault();
      bringUp();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [keyboardShortcut]);
  const folded = collapsible && !expanded;
  const tablesKey = tables?.join(",");
  useEffect(() => {
    if (!term) {
      setRows(null);
      setLoading(false);
      return;
    }
    const abort = new AbortController();
    setLoading(true);
    const timer = setTimeout(() => {
      ppp.loadMultiTablePagesAsync(
        { ...tables && { includeTables: [...tables] }, search: term, orderBy: MultiTablePageOrder.BestMatch, pageSize: maximumResults },
        abort.signal
      ).then((response) => {
        if (abort.signal.aborted) return;
        const merger = new MultiTablePageMerger(false, locale);
        merger.add(response);
        setRows({ search: term, items: merger.take(maximumResults) });
        setLoading(false);
      }).catch((error) => {
        if (abort.signal.aborted) return;
        console.error("[MultiTableSearchBox] The search box could not search.", error);
        setRows({ search: term, items: [] });
        setLoading(false);
      });
    }, 300);
    return () => {
      abort.abort();
      clearTimeout(timer);
    };
  }, [term, tablesKey, maximumResults, locale]);
  const shownTables = useMemo(
    () => [.../* @__PURE__ */ new Set([...(rows?.items ?? []).map((x) => x.table), ...recents.recent.records.map((x) => x.table)])],
    [rows, recents.recent]
  );
  useLocalization(shownTables.map((table) => `tables.${table}`));
  const tableLabel4 = (table) => {
    const key3 = `tables.${table}.label`;
    const label = t(key3);
    return label && label !== key3 ? label : table;
  };
  const linkOf = (item) => {
    if (recordUrl) return recordUrl(item);
    const page = showRecordLinks && !onSelect ? findRecordPage(recordPages, item.table) : void 0;
    return page ? recordPageUrl(page, item.id) : void 0;
  };
  const opens = (item) => !!linkOf(item) || !!onSelect;
  const suggestions = term ? [
    { kind: "see-all", key: "see-all", text: T("box-see-all", [term]), search: term },
    ...(rows?.search === term ? rows.items : []).map(
      (item) => ({ kind: "row", key: `${item.table}:${item.id}`, text: item.title.value ?? T("no-title"), search: term, item })
    )
  ] : showRecent ? [
    ...recents.recent.searches.map((search) => ({ kind: "recent-search", key: `search:${search}`, text: search, search })),
    // A record that can't be opened — its table has no page — isn't offered.
    ...recents.recent.records.map((recent) => ({ recent, item: recentToItem(recent) })).filter((x) => opens(x.item)).map(({ recent, item }) => ({ kind: "recent-record", key: `${recent.table}:${recent.id}`, text: recent.title ?? T("no-title"), item, recent }))
  ] : [];
  const go = (url) => {
    if (!onNavigate) return window.location.assign(url);
    onNavigate(url);
    setTimeout(() => window.dispatchEvent(new Event(SEARCH_NAVIGATED)), 0);
  };
  const searchUrl = (search) => rootRecordPageUrl(`${searchPageUrl}${searchPageUrl.includes("?") ? "&" : "?"}${encodeURIComponent(searchParameterName)}=${encodeURIComponent(search)}`);
  const pickRef = useRef(() => void 0);
  pickRef.current = (key3) => {
    const picked = suggestions.find((x) => x.key === key3);
    setText("");
    setOpen(false);
    if (!picked) return;
    if (picked.kind === "see-all" || picked.kind === "recent-search") {
      recents.addSearch(picked.search);
      go(searchUrl(picked.search));
      return;
    }
    const link = linkOf(picked.item);
    if (link || onSelect) {
      if (picked.kind === "recent-record") recents.addRecent(picked.recent);
      else recents.addRecord(picked.item, picked.search);
    }
    if (link) go(link);
    else onSelect?.(picked.item);
  };
  const hint = placeholder ?? T("search");
  const option = (suggestion) => {
    switch (suggestion.kind) {
      case "see-all":
        return /* @__PURE__ */ jsxs("span", { className: styles.option, children: [
          /* @__PURE__ */ jsx(Search16Regular, {}),
          /* @__PURE__ */ jsx(Text, { weight: "semibold", className: styles.text, children: suggestion.text })
        ] });
      case "recent-search":
        return /* @__PURE__ */ jsxs("span", { className: styles.option, children: [
          /* @__PURE__ */ jsx(History16Regular, {}),
          /* @__PURE__ */ jsx("span", { className: styles.text, children: suggestion.text }),
          /* @__PURE__ */ jsx(Caption1, { className: styles.table, children: T("recent-search") })
        ] });
      case "recent-record":
        return /* @__PURE__ */ jsxs("span", { className: styles.option, children: [
          /* @__PURE__ */ jsx(History16Regular, {}),
          /* @__PURE__ */ jsx("span", { className: styles.text, children: suggestion.text }),
          /* @__PURE__ */ jsx(Caption1, { className: styles.table, children: tableLabel4(suggestion.item.table) })
        ] });
      default:
        return /* @__PURE__ */ jsxs("span", { className: styles.option, children: [
          /* @__PURE__ */ jsx("span", { className: styles.text, children: suggestion.item.title.isMatch ? /* @__PURE__ */ jsx(Highlighter, { text: suggestion.text, searchText: term.replace(/^\*+|\*+$/g, ""), delimiters: "*" }) : suggestion.text }),
          /* @__PURE__ */ jsx(Caption1, { className: styles.table, children: tableLabel4(suggestion.item.table) })
        ] });
    }
  };
  return /* @__PURE__ */ jsxs(
    "span",
    {
      ref: rootRef,
      className: mergeClasses("ppp-multi-table-search-box", styles.root, folded && styles.folded, className),
      style,
      "data-collapsible": collapsible || void 0,
      "data-expanded": collapsible && expanded || void 0,
      onBlur: (event) => {
        if (collapsible && !text2 && !event.currentTarget.contains(event.relatedTarget)) setExpanded(false);
      },
      children: [
        collapsible && /* @__PURE__ */ jsx(Tooltip, { content: hint, relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            className: mergeClasses("ppp-multi-table-search-box-toggle", styles.toggle, folded && styles.foldedToggle),
            icon: /* @__PURE__ */ jsx(Search20Regular, {}),
            "aria-label": hint,
            onClick: bringUp
          }
        ) }),
        /* @__PURE__ */ jsxs(
          Combobox,
          {
            className: mergeClasses("ppp-multi-table-search-box-input", styles.box, folded && styles.foldedBox),
            freeform: true,
            "aria-label": hint,
            placeholder: hint,
            expandIcon: /* @__PURE__ */ jsx(Search20Regular, {}),
            value: text2,
            open: open && (suggestions.length > 0 || loading),
            selectedOptions: [],
            onChange: (event) => {
              setText(event.target.value);
              setOpen(true);
            },
            onOpenChange: (_, data) => setOpen(data.open),
            onOptionSelect: (_, data) => pickRef.current(data.optionValue),
            children: [
              suggestions.map((suggestion) => /* @__PURE__ */ jsx(Option, { value: suggestion.key, text: suggestion.text, className: "ppp-multi-table-search-box-option", "data-kind": suggestion.kind, children: option(suggestion) }, suggestion.key)),
              loading && term && /* @__PURE__ */ jsx(Option, { value: "", text: T("loading"), disabled: true, className: "ppp-multi-table-search-box-loading", children: /* @__PURE__ */ jsxs("span", { className: styles.option, children: [
                /* @__PURE__ */ jsx(Spinner, { size: "tiny" }),
                /* @__PURE__ */ jsx("span", { children: T("loading") })
              ] }) }, "loading")
            ]
          }
        )
      ]
    }
  );
}

// src/index.ts
var VERSION = "0.1.0";

export { ActivateQuoteButton, ActivateRecordButton, AddressDisplayValue, AddressMapServiceContext, Body, BoolEdit, BoolEditorType, CacheAdmin, CancelCaseButton, CancelOrderButton, Captcha, ChoiceEdit, ChoiceEditorType, ChoiceInvalidValueBehavior, ChoiceOrientation, ChoiceValueSort, CloseQuoteButton, ColumnDisplayValue, ColumnEdit, ColumnStatusBadge, DEFAULT_CONDENSED_TOOLBAR_BUTTONS, DataverseChart, DataverseUnavailableBanner, DateTimeEdit, DateTimeEditorType, DateValueEditor, DeactivateRecordButton, DeleteContextButton, DeleteRecordGridButton, DescriptionLocation, EVERY_TABLE_VIEW_ID, EditorLabelPosition, EditorLabelPositionContext, EditorLabelPositionProvider, ExportGridButton, FETCH_XML_BUILDER_STRINGS_PREFIX, FetchXmlBuilder, FetchXmlBuilderProvider, FetchXmlColumnsSection, FetchXmlFilterSection, FetchXmlFindColumnsSection, FetchXmlLoadingOverlay, FetchXmlOptionsSection, FetchXmlPreviewSection, FetchXmlResultsSection, FetchXmlSortSection, FetchXmlTableSection, FileEdit, FileGrid, FileViewer, FluentDialogProvider, FluentOverlayProvider, FluentOverlayTarget, FluentUIChart, Footer, FulfillOrderButton, GridButton, GridButtonBehavior, GridButtonRole, GridColumn, GridColumnMenuItem, GridColumns, GridColumnsDialog, GridFilterDialog, GridManageViewsPanel, GridMapPrintList, GridMapRendererContext, GridNearSearchContext, GridRelatedRecordsColumn, GridSaveViewDialog, GridSortPanel, GridSplitButton, GridTemplateColumn, GridToolbarItems, GridTotalsPanel, Header, HighlightFull, Highlighter, ImageEdit, ImageViewer, ImpersonationBanner, ImpersonationPickerDialog, InvitationAdmin, InvitationForm, JOIN_TYPE_GROUPS, KanbanBoard, KanbanBoardButton, KanbanDefaultForm, LanguageDropdown, LinkEntityEditor, LinkExistingRecordGridButton, LocalizationAdmin, LocalizationBoundary, LocalizationTranslator, LogoutButton, LookupDialog, LookupEdit, LookupEditorType, LookupForm, LookupValueEditor, LoseOpportunityButton, MainGrid, ManyToManyLookupEdit, ManyToManyLookupEditorType, MapPrintButton, MapPrintMenuItems, MaskedTextField, MemoEdit, MenuBar, MoneyEdit, MultiSelectChoiceEdit, MultiTableDefaultForm, MultiTableFilterDialog, MultiTableFormContext, MultiTableRecordPanel, MultiTableSearch, MultiTableSearchBox, MultiTableSearchLayout, NavGroup, NavItem, NavMenu, NavigateNewRecordGridButton, NavigateOpenRecordGridButton, NavigateRecordGridButton, NewRecordGridButton, NumberEdit, OFFERED_JOIN_TYPES, OFFICE_ACCENT_DEFINITIONS, OFFICE_ACCENT_HEX_TO_NAME, OFFICE_ACCENT_THEMES, OFFICE_COLOR_NAME_TO_ACCENT, OpenRecordGridButton, OperationButton, OperationButtonBehavior, OperationGridButton, PageLayout, PagingMode, PartyListEdit, PasskeyManager, PasskeySignInButton, PortalRoleAdmin, PortalRoleConfigurationForm, PowerPortalsProThemeProvider, ProfileMainMenu, RELATIONSHIP_KIND_KEYS, RELATIONSHIP_KIND_ORDER, ReactivateCaseButton, ReadOnlyValue, RecordCard, RecordCardAvatar, RecordDialogFrame, RecordDialogShell, RecordLink, RefreshContextButton, RefreshGridButton, RelationshipPickerDialog, ReopenOpportunityButton, ResolveCaseButton, RichEdit, RichEditToolbarButton, RichEditToolbarMode, RichTextView, RouterUnsavedChangesGuard, SaveContextButton, SavedViewDialogs, Section, SectionColumn, SectionColumnOrientation, SharedTooltip, SidePanel, SidePanelBody, SidePanelFooter, SidePanelHeader, SiteSettingsButton, SiteSettingsPanel, StatusEdit, StatusReasonEdit, SubGrid, SubmitOrderButton, SummaryCard, SummaryCards, TabPanel, TablePermissionForm, Tabs, TextDirection2 as TextDirection, TextEdit, ThemeColorSelector, ThemeMode, ThemeSelector, ThemeTextDirection, TimeZoneDropdown, TimeZoneEdit, Timeline, UnlinkExistingRecordGridButton, VERSION, ValidationSummary, ViewFilterMenu, ViewFilterMenuOverflowItem, ViewLoadMessages, ViewPicker, ViewPickerDialog, ViewRefreshButton, ViewSearchBox, ViewSort, ViewToolbar, WebRoleAdmin, WebRoleConfigurationForm, WebRoleForm, WinOpportunityButton, WinQuoteButton, WizardRecordForm, WizardRecordPage, applyMultiTableFilter, clampConditionDate, columnSourceKey, createFilterWithRow, defaultStatusBadgeTone, describeRelationship, editorLabelClassName, evaluateGridButtonBehavior, everyRow, findColumn, findColumnSource, findFirstButtonOfRole, findRelationshipForLink, followRecordLink, formatConditionDate, getCellRenderer, getChartPalette, getChoiceMetadata, getColumnSourceTables, getColumnSources, getDisplayDescription, getDisplayLabel, getEditComponentForMetadata, getEditComponentForType, getGridButtonRoleFromElement, getLookupMetadata, getNumberLimits, getRendererTypeForMetadata, getStringMaxLength, groupRelationships, hiddenByDefault, intersectColumnsFor, isColumnSortable, isColumnSource, isConditionIncomplete, isLinkAliasMissing, isMetadataReadOnly, isMetadataRequired, isNewRecord, isSelectableColumn, joinTypeKey, joinTypeOptions, linkEntityFromRelationship, matchesDateSearch, matchesNumericSearch, mergeConditionDate, metadataLabel, multiTableFilterQueries, multiTableFilterTabs, offersViewFilterMenu, officeColorValueToAccentName, parseColumnSourceKey, parseConditionDate, parseDateSearch, parseNumericSearch, relationshipFullLabel, relationshipLeadLabel, resolveAddressLines, resolveAddressPosition, resolveAddressQuery, resolveColumnDisplayText, resolveViewLabel, richTextToPlainText, searchHighlightFor, searchKindOf, searchMetadata, searchRelationships, setGridButtonRole, splitHighlightSegments, tablesOf, toRunnableQuery, toTranslucent, useAddressMapService, useBoolColumn, useChoiceColumn, useCloseRecordDialog, useDateColumn, useEditorLabelLayoutClass, useEditorLabelPosition, useEditorStateClass, useFetchXmlBuilderContext, useFetchXmlTableDetail, useFetchXmlTables, useFileColumn, useFluentChartPalette, useGridContext, useGridMapRenderer, useGridNearSearch, useKanbanBoardContext, useLookupColumn, useMoneyColumn, useMultiSelectChoiceColumn, useMultiTableForm, useMultiTableTableSet, useMultiTableViews, useNumberColumn, usePowerPortalsProFetchXmlMetadata, useSavedViewSession, useSavedViews, useSignInPrompt, useStringColumn, useTheme, viewLabelOf };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map